import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_unit_proto from './dcei_engine_unit_proto';
export class Actor {
  get descriptor() {
    return Actor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefix = false;
    this._prefix = null;
    this._hasTemplate = false;
    this._template = null;
    this._hasComment = false;
    this._comment = null;
    this._hasParent = false;
    this._parent = null;
    this._oneofActorTypeCase = 0;
    this._oneofActorTypeValue = null;
  }
  isEmpty() {
    if (this._hasPrefix) return false;
    if (this._hasTemplate) return false;
    if (this._hasComment) return false;
    if (this._hasParent) return false;
    if (this._oneofActorTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Actor) {
      return value;
    }
    return Actor.fromJson(value);
  }
  static fromJson(json) {
    const result = new Actor();
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.template != null) {
      result._hasTemplate = true;
      result._template = JsonToBoolean.fromJson(json.template);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    if (json.parent != null) {
      result._hasParent = true;
      result._parent = JsonToString.fromJson(json.parent);
    }
    if (json.unitActor != null) {
      result._oneofActorTypeCase = 2;
      result._oneofActorTypeValue = UnitActor.fromJson(json.unitActor);
    }
    if (json.modelActor != null) {
      result._oneofActorTypeCase = 3;
      result._oneofActorTypeValue = ModelActor.fromJson(json.modelActor);
    }
    if (json.actionActor != null) {
      result._oneofActorTypeCase = 4;
      result._oneofActorTypeValue = ActionActor.fromJson(json.actionActor);
    }
    if (json.siteOperation != null) {
      result._oneofActorTypeCase = 5;
      result._oneofActorTypeValue = SiteOperation.fromJson(json.siteOperation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasTemplate) {
      result.template = JsonToBoolean.toJson(this._template);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    if (this._hasParent) {
      result.parent = JsonToString.toJson(this._parent);
    }
    switch (this._oneofActorTypeCase) {
      case 2:
        result.unitActor = UnitActor.toJson(this._oneofActorTypeValue);
        break;
      case 3:
        result.modelActor = ModelActor.toJson(this._oneofActorTypeValue);
        break;
      case 4:
        result.actionActor = ActionActor.toJson(this._oneofActorTypeValue);
        break;
      case 5:
        result.siteOperation = SiteOperation.toJson(this._oneofActorTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {boolean}
   */
  get template() {
    return this._hasTemplate ? this._template : JsonToBoolean.default;
  }
  get hasTemplate() {
    return this._hasTemplate;
  }
  setTemplate(path, value) {
    return {type: 'SET', path: path.concat(['template']), value};
  }
  deleteTemplate(path) {
    return {type: 'DELETE', path: path.concat(['template'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  /**
   * @returns {string}
   */
  get parent() {
    return this._hasParent ? this._parent : JsonToString.default;
  }
  get hasParent() {
    return this._hasParent;
  }
  setParent(path, value) {
    return {type: 'SET', path: path.concat(['parent']), value};
  }
  deleteParent(path) {
    return {type: 'DELETE', path: path.concat(['parent'])};
  }
  get oneofActorTypeCase() {
    return this._oneofActorTypeCase;
  }
  deleteOneofActorType(path) {
    switch (this._oneofActorTypeCase) {
      default:
      case 2: {
        return {type: 'DELETE', path: path.concat(['unitActor'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['modelActor'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['actionActor'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['siteOperation'])};
      }
    }
  }
  /**
   * @returns {UnitActor}
   */
  get unitActor() {
    return this._oneofActorTypeCase === 2 ? this._oneofActorTypeValue : UnitActor.default;
  }
  setUnitActor(path, value) {
    return {type: 'SET', path: path.concat(['unitActor']), value: value.toJson()};
  }
  deleteUnitActor(path) {
    return {type: 'DELETE', path: path.concat(['unitActor'])};
  }
  /**
   * @returns {ModelActor}
   */
  get modelActor() {
    return this._oneofActorTypeCase === 3 ? this._oneofActorTypeValue : ModelActor.default;
  }
  setModelActor(path, value) {
    return {type: 'SET', path: path.concat(['modelActor']), value: value.toJson()};
  }
  deleteModelActor(path) {
    return {type: 'DELETE', path: path.concat(['modelActor'])};
  }
  /**
   * @returns {ActionActor}
   */
  get actionActor() {
    return this._oneofActorTypeCase === 4 ? this._oneofActorTypeValue : ActionActor.default;
  }
  setActionActor(path, value) {
    return {type: 'SET', path: path.concat(['actionActor']), value: value.toJson()};
  }
  deleteActionActor(path) {
    return {type: 'DELETE', path: path.concat(['actionActor'])};
  }
  /**
   * @returns {SiteOperation}
   */
  get siteOperation() {
    return this._oneofActorTypeCase === 5 ? this._oneofActorTypeValue : SiteOperation.default;
  }
  setSiteOperation(path, value) {
    return {type: 'SET', path: path.concat(['siteOperation']), value: value.toJson()};
  }
  deleteSiteOperation(path) {
    return {type: 'DELETE', path: path.concat(['siteOperation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new Actor(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "template": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._hasTemplate = true;
              copy._template = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTemplate) {
                return this;
              }
              const copy = new Actor(this);
              copy._hasTemplate = false;
              copy._template = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Actor(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._hasParent = true;
              copy._parent = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParent) {
                return this;
              }
              const copy = new Actor(this);
              copy._hasParent = false;
              copy._parent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitActor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 2;
              copy._oneofActorTypeValue = UnitActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorTypeCase !== 2) {
                return this;
              }
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 0;
              copy._oneofActorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorTypeCase !== 2) {
            const copy = new Actor(this);
            copy._oneofActorTypeCase = 2;
            copy._oneofActorTypeValue = UnitActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitActor.apply(type, path.slice(1), value);
          if (newValue === this.unitActor) {
            return this;
          }
          const copy = new Actor(this);
          copy._oneofActorTypeCase = 2;
          copy._oneofActorTypeValue = newValue;
          return copy;
        }
      }
      case "modelActor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 3;
              copy._oneofActorTypeValue = ModelActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorTypeCase !== 3) {
                return this;
              }
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 0;
              copy._oneofActorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorTypeCase !== 3) {
            const copy = new Actor(this);
            copy._oneofActorTypeCase = 3;
            copy._oneofActorTypeValue = ModelActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modelActor.apply(type, path.slice(1), value);
          if (newValue === this.modelActor) {
            return this;
          }
          const copy = new Actor(this);
          copy._oneofActorTypeCase = 3;
          copy._oneofActorTypeValue = newValue;
          return copy;
        }
      }
      case "actionActor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 4;
              copy._oneofActorTypeValue = ActionActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorTypeCase !== 4) {
                return this;
              }
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 0;
              copy._oneofActorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorTypeCase !== 4) {
            const copy = new Actor(this);
            copy._oneofActorTypeCase = 4;
            copy._oneofActorTypeValue = ActionActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.actionActor.apply(type, path.slice(1), value);
          if (newValue === this.actionActor) {
            return this;
          }
          const copy = new Actor(this);
          copy._oneofActorTypeCase = 4;
          copy._oneofActorTypeValue = newValue;
          return copy;
        }
      }
      case "siteOperation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 5;
              copy._oneofActorTypeValue = SiteOperation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorTypeCase !== 5) {
                return this;
              }
              const copy = new Actor(this);
              copy._oneofActorTypeCase = 0;
              copy._oneofActorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorTypeCase !== 5) {
            const copy = new Actor(this);
            copy._oneofActorTypeCase = 5;
            copy._oneofActorTypeValue = SiteOperation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.siteOperation.apply(type, path.slice(1), value);
          if (newValue === this.siteOperation) {
            return this;
          }
          const copy = new Actor(this);
          copy._oneofActorTypeCase = 5;
          copy._oneofActorTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Actor} other
   * @returns {Actor}
   */
  merge(other) {
    const copy = new Actor(this);
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasTemplate) {
      copy._hasTemplate = true;
      copy._template = other._template;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    if (other._hasParent) {
      copy._hasParent = true;
      copy._parent = other._parent;
    }
    if (other._oneofActorTypeCase === 2) {
      if (this._oneofActorTypeCase === 2) {
        copy._oneofActorTypeValue = copy._oneofActorTypeValue.merge(other._oneofActorTypeValue);
      } else {
        copy._oneofActorTypeValue = other._oneofActorTypeValue;
      }
      copy._oneofActorTypeCase = 2;
    }
    if (other._oneofActorTypeCase === 2) {
      if (this._oneofActorTypeCase === 2) {
        copy._oneofActorTypeValue = copy._oneofActorTypeValue.merge(other._oneofActorTypeValue);
      } else {
        copy._oneofActorTypeValue = other._oneofActorTypeValue;
      }
      copy._oneofActorTypeCase = 2;
    }
    if (other._oneofActorTypeCase === 2) {
      if (this._oneofActorTypeCase === 2) {
        copy._oneofActorTypeValue = copy._oneofActorTypeValue.merge(other._oneofActorTypeValue);
      } else {
        copy._oneofActorTypeValue = other._oneofActorTypeValue;
      }
      copy._oneofActorTypeCase = 2;
    }
    if (other._oneofActorTypeCase === 2) {
      if (this._oneofActorTypeCase === 2) {
        copy._oneofActorTypeValue = copy._oneofActorTypeValue.merge(other._oneofActorTypeValue);
      } else {
        copy._oneofActorTypeValue = other._oneofActorTypeValue;
      }
      copy._oneofActorTypeCase = 2;
    }
    return copy;
  }
}
Actor.default = new Actor();
class Actor_Builder {
  constructor(value) {
    this._value = new Actor(value);
  }
  build() {
    return new Actor(this._value);
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setTemplate(value) {
    this._value._hasTemplate = true;
    this._value._template = value;
    return this;
  }
  deleteTemplate() {
    this._value._hasTemplate = false;
    this._value._template = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
  setParent(value) {
    this._value._hasParent = true;
    this._value._parent = value;
    return this;
  }
  deleteParent() {
    this._value._hasParent = false;
    this._value._parent = null;
    return this;
  }
  clearoneofActorType() {
    this._value._oneofActorTypeCase = 0;
    this._value._oneofActorTypeValue = null;
    return this;
  }
  setUnitActor(value) {
    this._value._oneofActorTypeCase = 2;
    this._value._oneofActorTypeValue = value;
    return this;
  }
  setModelActor(value) {
    this._value._oneofActorTypeCase = 3;
    this._value._oneofActorTypeValue = value;
    return this;
  }
  setActionActor(value) {
    this._value._oneofActorTypeCase = 4;
    this._value._oneofActorTypeValue = value;
    return this;
  }
  setSiteOperation(value) {
    this._value._oneofActorTypeCase = 5;
    this._value._oneofActorTypeValue = value;
    return this;
  }
}
Actor.Builder = Actor_Builder;
class Actor_WithParent {
  /**
   * @param {Actor} value
   * @param {Actor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Actor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasTemplate() {
    if (this._cachedHasTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedHasTemplate = true;
      } else {
        this._cachedHasTemplate = this._parent ? this._parent.hasTemplate : false;
      }
    }
    return this._cachedHasTemplate;
  }
  get template() {
    if (this._cachedTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedTemplate = this._value.template;
      } else {
        this._cachedTemplate = this._parent ? this._parent.template : this._value.template;
      }
    }
    return this._cachedTemplate;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  get hasParent() {
    if (this._cachedHasParent === undefined) {
      if (this._value.hasParent) {
        this._cachedHasParent = true;
      } else {
        this._cachedHasParent = this._parent ? this._parent.hasParent : false;
      }
    }
    return this._cachedHasParent;
  }
  get parent() {
    if (this._cachedParent === undefined) {
      if (this._value.hasParent) {
        this._cachedParent = this._value.parent;
      } else {
        this._cachedParent = this._parent ? this._parent.parent : this._value.parent;
      }
    }
    return this._cachedParent;
  }
  get oneofActorTypeCase() {
    if (this._cachedoneofActorTypeCase === undefined) {
      if (this._value._oneofActorTypeCase === 0) {
        this._cachedoneofActorTypeCase = this._parent ? this._parent.oneofActorTypeCase : 0;
      } else {
        this._cachedoneofActorTypeCase = this._value._oneofActorTypeCase;
      }
    }
    return this._cachedoneofActorTypeCase;
  }
  get unitActor() {
    if (!this._cachedUnitActor) {
      if (this._value._oneofActorTypeCase === 0) {
        this._cachedUnitActor = this._parent ? new UnitActor.WithParent(UnitActor.default, this._parent.unitActor) : this._value.unitActor;
      } else if (this._value._oneofActorTypeCase === 2) {
        this._cachedUnitActor = new UnitActor.WithParent(this._value.unitActor, this._parent && this._parent.oneofActorTypeCase === 2 ? this._parent.unitActor : null);
      } else {
        this._cachedUnitActor = UnitActor.WithParent.default;
      }
    }
    return this._cachedUnitActor;
  }
  get modelActor() {
    if (!this._cachedModelActor) {
      if (this._value._oneofActorTypeCase === 0) {
        this._cachedModelActor = this._parent ? new ModelActor.WithParent(ModelActor.default, this._parent.modelActor) : this._value.modelActor;
      } else if (this._value._oneofActorTypeCase === 3) {
        this._cachedModelActor = new ModelActor.WithParent(this._value.modelActor, this._parent && this._parent.oneofActorTypeCase === 3 ? this._parent.modelActor : null);
      } else {
        this._cachedModelActor = ModelActor.WithParent.default;
      }
    }
    return this._cachedModelActor;
  }
  get actionActor() {
    if (!this._cachedActionActor) {
      if (this._value._oneofActorTypeCase === 0) {
        this._cachedActionActor = this._parent ? new ActionActor.WithParent(ActionActor.default, this._parent.actionActor) : this._value.actionActor;
      } else if (this._value._oneofActorTypeCase === 4) {
        this._cachedActionActor = new ActionActor.WithParent(this._value.actionActor, this._parent && this._parent.oneofActorTypeCase === 4 ? this._parent.actionActor : null);
      } else {
        this._cachedActionActor = ActionActor.WithParent.default;
      }
    }
    return this._cachedActionActor;
  }
  get siteOperation() {
    if (!this._cachedSiteOperation) {
      if (this._value._oneofActorTypeCase === 0) {
        this._cachedSiteOperation = this._parent ? new SiteOperation.WithParent(SiteOperation.default, this._parent.siteOperation) : this._value.siteOperation;
      } else if (this._value._oneofActorTypeCase === 5) {
        this._cachedSiteOperation = new SiteOperation.WithParent(this._value.siteOperation, this._parent && this._parent.oneofActorTypeCase === 5 ? this._parent.siteOperation : null);
      } else {
        this._cachedSiteOperation = SiteOperation.WithParent.default;
      }
    }
    return this._cachedSiteOperation;
  }
  update(current, parent) {
    const result = new Actor_WithParent(current, parent);
    if (this._cachedUnitActor && this._value._oneofActorTypeCase === 2 && current._oneofActorTypeCase === 2) {
      if (this._value.unitActor === current.unitActor && this._parent === parent) {
        result._cachedUnitActor = this._cachedUnitActor;
      } else {
        result._cachedUnitActor = this._cachedUnitActor.update(current.unitActor, parent && parent.oneofActorTypeCase === 2 ? parent.unitActor : null);
      }
    }
    if (this._cachedModelActor && this._value._oneofActorTypeCase === 3 && current._oneofActorTypeCase === 3) {
      if (this._value.modelActor === current.modelActor && this._parent === parent) {
        result._cachedModelActor = this._cachedModelActor;
      } else {
        result._cachedModelActor = this._cachedModelActor.update(current.modelActor, parent && parent.oneofActorTypeCase === 3 ? parent.modelActor : null);
      }
    }
    if (this._cachedActionActor && this._value._oneofActorTypeCase === 4 && current._oneofActorTypeCase === 4) {
      if (this._value.actionActor === current.actionActor && this._parent === parent) {
        result._cachedActionActor = this._cachedActionActor;
      } else {
        result._cachedActionActor = this._cachedActionActor.update(current.actionActor, parent && parent.oneofActorTypeCase === 4 ? parent.actionActor : null);
      }
    }
    if (this._cachedSiteOperation && this._value._oneofActorTypeCase === 5 && current._oneofActorTypeCase === 5) {
      if (this._value.siteOperation === current.siteOperation && this._parent === parent) {
        result._cachedSiteOperation = this._cachedSiteOperation;
      } else {
        result._cachedSiteOperation = this._cachedSiteOperation.update(current.siteOperation, parent && parent.oneofActorTypeCase === 5 ? parent.siteOperation : null);
      }
    }
    return result;
  }
}
Actor_WithParent.default = new Actor_WithParent(Actor.default, null);
Actor.WithParent = Actor_WithParent;
class Actor_Descriptor {
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 1000,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get template() {
    if (!this._template) {
      this._template = {
        name: "template",
        Name: "Template",
        number: 2000,
        protoType: 8,
        protoName: "template",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._template;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get parent() {
    if (!this._parent) {
      this._parent = {
        name: "parent",
        Name: "Parent",
        number: 1,
        protoType: 9,
        protoName: "parent",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedActorListNamesWithNullWithTemplate",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parent;
  }
  get unitActor() {
    if (!this._unitActor) {
      this._unitActor = {
        name: "unitActor",
        Name: "UnitActor",
        number: 2,
        protoType: 11,
        protoName: "unit_actor",
        oneofIndex: 4,
        type: UnitActor,
        options: {
          comments: "Unit actors determine how units look, sound, and animate. Units are linked to actors with the same name, and unit actors are automatically created without needing additional actor events.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitActor;
  }
  get modelActor() {
    if (!this._modelActor) {
      this._modelActor = {
        name: "modelActor",
        Name: "ModelActor",
        number: 3,
        protoType: 11,
        protoName: "model_actor",
        oneofIndex: 4,
        type: ModelActor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modelActor;
  }
  get actionActor() {
    if (!this._actionActor) {
      this._actionActor = {
        name: "actionActor",
        Name: "ActionActor",
        number: 4,
        protoType: 11,
        protoName: "action_actor",
        oneofIndex: 4,
        type: ActionActor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actionActor;
  }
  get siteOperation() {
    if (!this._siteOperation) {
      this._siteOperation = {
        name: "siteOperation",
        Name: "SiteOperation",
        number: 5,
        protoType: 11,
        protoName: "site_operation",
        oneofIndex: 4,
        type: SiteOperation,
        options: {
          comments: "Site operations are special actors that modify the position or rotation of other actors.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._siteOperation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefix,
        this.template,
        this.comment,
        this.parent,
        this.unitActor,
        this.modelActor,
        this.actionActor,
        this.siteOperation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTemplate",
        Name: "DummyOneofForTemplate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParent",
        Name: "DummyOneofForParent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "oneofActorType",
        Name: "OneofActorType",
        fields: [
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
Actor.descriptor = new Actor_Descriptor();
export class ActorResource {
  get descriptor() {
    return ActorResource.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasName = false;
    this._name = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorResource) {
      return value;
    }
    return ActorResource.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorResource();
    if (json.type != null) {
      result._hasType = true;
      result._type = JsonToString.fromJson(json.type);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = JsonToString.toJson(this._type);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get type() {
    return this._hasType ? this._type : JsonToString.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorResource(this);
              copy._hasType = true;
              copy._type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new ActorResource(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorResource(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ActorResource(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorResource} other
   * @returns {ActorResource}
   */
  merge(other) {
    const copy = new ActorResource(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    return copy;
  }
}
ActorResource.default = new ActorResource();
class ActorResource_Builder {
  constructor(value) {
    this._value = new ActorResource(value);
  }
  build() {
    return new ActorResource(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
}
ActorResource.Builder = ActorResource_Builder;
class ActorResource_WithParent {
  /**
   * @param {ActorResource} value
   * @param {ActorResource_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorResource.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  update(current, parent) {
    const result = new ActorResource_WithParent(current, parent);
    return result;
  }
}
ActorResource_WithParent.default = new ActorResource_WithParent(ActorResource.default, null);
ActorResource.WithParent = ActorResource_WithParent;
class ActorResource_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 9,
        protoName: "type",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedResourceTypeNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 2,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedModelNameList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.name,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorResource.descriptor = new ActorResource_Descriptor();
class ActorExpressions_VariableValue {
  get descriptor() {
    return ActorExpressions_VariableValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_VariableValue) {
      return value;
    }
    return ActorExpressions_VariableValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_VariableValue();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_VariableValue(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ActorExpressions_VariableValue(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_VariableValue} other
   * @returns {ActorExpressions_VariableValue}
   */
  merge(other) {
    const copy = new ActorExpressions_VariableValue(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    return copy;
  }
}
ActorExpressions_VariableValue.default = new ActorExpressions_VariableValue();
class ActorExpressions_VariableValue_Builder {
  constructor(value) {
    this._value = new ActorExpressions_VariableValue(value);
  }
  build() {
    return new ActorExpressions_VariableValue(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
}
ActorExpressions_VariableValue.Builder = ActorExpressions_VariableValue_Builder;
class ActorExpressions_VariableValue_WithParent {
  /**
   * @param {ActorExpressions_VariableValue} value
   * @param {ActorExpressions_VariableValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_VariableValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  update(current, parent) {
    const result = new ActorExpressions_VariableValue_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_VariableValue_WithParent.default = new ActorExpressions_VariableValue_WithParent(ActorExpressions_VariableValue.default, null);
ActorExpressions_VariableValue.WithParent = ActorExpressions_VariableValue_WithParent;
class ActorExpressions_VariableValue_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "The name of the variable.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_VariableValue.descriptor = new ActorExpressions_VariableValue_Descriptor();
class ActorExpressions_ConstantValue {
  get descriptor() {
    return ActorExpressions_ConstantValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_ConstantValue) {
      return value;
    }
    return ActorExpressions_ConstantValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_ConstantValue();
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToDouble.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValue) {
      result.value = JsonToDouble.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToDouble.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_ConstantValue(this);
              copy._hasValue = true;
              copy._value = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new ActorExpressions_ConstantValue(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_ConstantValue} other
   * @returns {ActorExpressions_ConstantValue}
   */
  merge(other) {
    const copy = new ActorExpressions_ConstantValue(this);
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    return copy;
  }
}
ActorExpressions_ConstantValue.default = new ActorExpressions_ConstantValue();
class ActorExpressions_ConstantValue_Builder {
  constructor(value) {
    this._value = new ActorExpressions_ConstantValue(value);
  }
  build() {
    return new ActorExpressions_ConstantValue(this._value);
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
ActorExpressions_ConstantValue.Builder = ActorExpressions_ConstantValue_Builder;
class ActorExpressions_ConstantValue_WithParent {
  /**
   * @param {ActorExpressions_ConstantValue} value
   * @param {ActorExpressions_ConstantValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_ConstantValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new ActorExpressions_ConstantValue_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_ConstantValue_WithParent.default = new ActorExpressions_ConstantValue_WithParent(ActorExpressions_ConstantValue.default, null);
ActorExpressions_ConstantValue.WithParent = ActorExpressions_ConstantValue_WithParent;
class ActorExpressions_ConstantValue_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 1,
        protoName: "value",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_ConstantValue.descriptor = new ActorExpressions_ConstantValue_Descriptor();
class ActorExpressions_RandomIntValue {
  get descriptor() {
    return ActorExpressions_RandomIntValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMinValue = false;
    this._minValue = null;
    this._hasMaxValue = false;
    this._maxValue = null;
  }
  isEmpty() {
    if (this._hasMinValue) return false;
    if (this._hasMaxValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_RandomIntValue) {
      return value;
    }
    return ActorExpressions_RandomIntValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_RandomIntValue();
    if (json.minValue != null) {
      result._hasMinValue = true;
      result._minValue = JsonToInt32.fromJson(json.minValue);
    }
    if (json.maxValue != null) {
      result._hasMaxValue = true;
      result._maxValue = JsonToInt32.fromJson(json.maxValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMinValue) {
      result.minValue = JsonToInt32.toJson(this._minValue);
    }
    if (this._hasMaxValue) {
      result.maxValue = JsonToInt32.toJson(this._maxValue);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get minValue() {
    return this._hasMinValue ? this._minValue : JsonToInt32.default;
  }
  get hasMinValue() {
    return this._hasMinValue;
  }
  setMinValue(path, value) {
    return {type: 'SET', path: path.concat(['minValue']), value};
  }
  deleteMinValue(path) {
    return {type: 'DELETE', path: path.concat(['minValue'])};
  }
  /**
   * @returns {number}
   */
  get maxValue() {
    return this._hasMaxValue ? this._maxValue : JsonToInt32.default;
  }
  get hasMaxValue() {
    return this._hasMaxValue;
  }
  setMaxValue(path, value) {
    return {type: 'SET', path: path.concat(['maxValue']), value};
  }
  deleteMaxValue(path) {
    return {type: 'DELETE', path: path.concat(['maxValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "minValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_RandomIntValue(this);
              copy._hasMinValue = true;
              copy._minValue = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMinValue) {
                return this;
              }
              const copy = new ActorExpressions_RandomIntValue(this);
              copy._hasMinValue = false;
              copy._minValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_RandomIntValue(this);
              copy._hasMaxValue = true;
              copy._maxValue = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxValue) {
                return this;
              }
              const copy = new ActorExpressions_RandomIntValue(this);
              copy._hasMaxValue = false;
              copy._maxValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_RandomIntValue} other
   * @returns {ActorExpressions_RandomIntValue}
   */
  merge(other) {
    const copy = new ActorExpressions_RandomIntValue(this);
    if (other._hasMinValue) {
      copy._hasMinValue = true;
      copy._minValue = other._minValue;
    }
    if (other._hasMaxValue) {
      copy._hasMaxValue = true;
      copy._maxValue = other._maxValue;
    }
    return copy;
  }
}
ActorExpressions_RandomIntValue.default = new ActorExpressions_RandomIntValue();
class ActorExpressions_RandomIntValue_Builder {
  constructor(value) {
    this._value = new ActorExpressions_RandomIntValue(value);
  }
  build() {
    return new ActorExpressions_RandomIntValue(this._value);
  }
  setMinValue(value) {
    this._value._hasMinValue = true;
    this._value._minValue = value;
    return this;
  }
  deleteMinValue() {
    this._value._hasMinValue = false;
    this._value._minValue = null;
    return this;
  }
  setMaxValue(value) {
    this._value._hasMaxValue = true;
    this._value._maxValue = value;
    return this;
  }
  deleteMaxValue() {
    this._value._hasMaxValue = false;
    this._value._maxValue = null;
    return this;
  }
}
ActorExpressions_RandomIntValue.Builder = ActorExpressions_RandomIntValue_Builder;
class ActorExpressions_RandomIntValue_WithParent {
  /**
   * @param {ActorExpressions_RandomIntValue} value
   * @param {ActorExpressions_RandomIntValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_RandomIntValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMinValue() {
    if (this._cachedHasMinValue === undefined) {
      if (this._value.hasMinValue) {
        this._cachedHasMinValue = true;
      } else {
        this._cachedHasMinValue = this._parent ? this._parent.hasMinValue : false;
      }
    }
    return this._cachedHasMinValue;
  }
  get minValue() {
    if (this._cachedMinValue === undefined) {
      if (this._value.hasMinValue) {
        this._cachedMinValue = this._value.minValue;
      } else {
        this._cachedMinValue = this._parent ? this._parent.minValue : this._value.minValue;
      }
    }
    return this._cachedMinValue;
  }
  get hasMaxValue() {
    if (this._cachedHasMaxValue === undefined) {
      if (this._value.hasMaxValue) {
        this._cachedHasMaxValue = true;
      } else {
        this._cachedHasMaxValue = this._parent ? this._parent.hasMaxValue : false;
      }
    }
    return this._cachedHasMaxValue;
  }
  get maxValue() {
    if (this._cachedMaxValue === undefined) {
      if (this._value.hasMaxValue) {
        this._cachedMaxValue = this._value.maxValue;
      } else {
        this._cachedMaxValue = this._parent ? this._parent.maxValue : this._value.maxValue;
      }
    }
    return this._cachedMaxValue;
  }
  update(current, parent) {
    const result = new ActorExpressions_RandomIntValue_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_RandomIntValue_WithParent.default = new ActorExpressions_RandomIntValue_WithParent(ActorExpressions_RandomIntValue.default, null);
ActorExpressions_RandomIntValue.WithParent = ActorExpressions_RandomIntValue_WithParent;
class ActorExpressions_RandomIntValue_Descriptor {
  get minValue() {
    if (!this._minValue) {
      this._minValue = {
        name: "minValue",
        Name: "MinValue",
        number: 1,
        protoType: 5,
        protoName: "min_value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._minValue;
  }
  get maxValue() {
    if (!this._maxValue) {
      this._maxValue = {
        name: "maxValue",
        Name: "MaxValue",
        number: 2,
        protoType: 5,
        protoName: "max_value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.minValue,
        this.maxValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMinValue",
        Name: "DummyOneofForMinValue",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxValue",
        Name: "DummyOneofForMaxValue",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_RandomIntValue.descriptor = new ActorExpressions_RandomIntValue_Descriptor();
class ActorExpressions_UnitWeaponRange {
  get descriptor() {
    return ActorExpressions_UnitWeaponRange.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWeapon = false;
    this._weapon = null;
  }
  isEmpty() {
    if (this._hasWeapon) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_UnitWeaponRange) {
      return value;
    }
    return ActorExpressions_UnitWeaponRange.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_UnitWeaponRange();
    if (json.weapon != null) {
      result._hasWeapon = true;
      result._weapon = JsonToString.fromJson(json.weapon);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWeapon) {
      result.weapon = JsonToString.toJson(this._weapon);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get weapon() {
    return this._hasWeapon ? this._weapon : JsonToString.default;
  }
  get hasWeapon() {
    return this._hasWeapon;
  }
  setWeapon(path, value) {
    return {type: 'SET', path: path.concat(['weapon']), value};
  }
  deleteWeapon(path) {
    return {type: 'DELETE', path: path.concat(['weapon'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "weapon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_UnitWeaponRange(this);
              copy._hasWeapon = true;
              copy._weapon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeapon) {
                return this;
              }
              const copy = new ActorExpressions_UnitWeaponRange(this);
              copy._hasWeapon = false;
              copy._weapon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_UnitWeaponRange} other
   * @returns {ActorExpressions_UnitWeaponRange}
   */
  merge(other) {
    const copy = new ActorExpressions_UnitWeaponRange(this);
    if (other._hasWeapon) {
      copy._hasWeapon = true;
      copy._weapon = other._weapon;
    }
    return copy;
  }
}
ActorExpressions_UnitWeaponRange.default = new ActorExpressions_UnitWeaponRange();
class ActorExpressions_UnitWeaponRange_Builder {
  constructor(value) {
    this._value = new ActorExpressions_UnitWeaponRange(value);
  }
  build() {
    return new ActorExpressions_UnitWeaponRange(this._value);
  }
  setWeapon(value) {
    this._value._hasWeapon = true;
    this._value._weapon = value;
    return this;
  }
  deleteWeapon() {
    this._value._hasWeapon = false;
    this._value._weapon = null;
    return this;
  }
}
ActorExpressions_UnitWeaponRange.Builder = ActorExpressions_UnitWeaponRange_Builder;
class ActorExpressions_UnitWeaponRange_WithParent {
  /**
   * @param {ActorExpressions_UnitWeaponRange} value
   * @param {ActorExpressions_UnitWeaponRange_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_UnitWeaponRange.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWeapon() {
    if (this._cachedHasWeapon === undefined) {
      if (this._value.hasWeapon) {
        this._cachedHasWeapon = true;
      } else {
        this._cachedHasWeapon = this._parent ? this._parent.hasWeapon : false;
      }
    }
    return this._cachedHasWeapon;
  }
  get weapon() {
    if (this._cachedWeapon === undefined) {
      if (this._value.hasWeapon) {
        this._cachedWeapon = this._value.weapon;
      } else {
        this._cachedWeapon = this._parent ? this._parent.weapon : this._value.weapon;
      }
    }
    return this._cachedWeapon;
  }
  update(current, parent) {
    const result = new ActorExpressions_UnitWeaponRange_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_UnitWeaponRange_WithParent.default = new ActorExpressions_UnitWeaponRange_WithParent(ActorExpressions_UnitWeaponRange.default, null);
ActorExpressions_UnitWeaponRange.WithParent = ActorExpressions_UnitWeaponRange_WithParent;
class ActorExpressions_UnitWeaponRange_Descriptor {
  get weapon() {
    if (!this._weapon) {
      this._weapon = {
        name: "weapon",
        Name: "Weapon",
        number: 1,
        protoType: 9,
        protoName: "weapon",
        type: JsonToString,
        options: {
          comments: "The weapon to use the range of.",
          valueDropdown: "SupportedWeaponNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weapon;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.weapon,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWeapon",
        Name: "DummyOneofForWeapon",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_UnitWeaponRange.descriptor = new ActorExpressions_UnitWeaponRange_Descriptor();
class ActorExpressions_UnitAbilityRange {
  get descriptor() {
    return ActorExpressions_UnitAbilityRange.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAbility = false;
    this._ability = null;
  }
  isEmpty() {
    if (this._hasAbility) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_UnitAbilityRange) {
      return value;
    }
    return ActorExpressions_UnitAbilityRange.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_UnitAbilityRange();
    if (json.ability != null) {
      result._hasAbility = true;
      result._ability = JsonToString.fromJson(json.ability);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAbility) {
      result.ability = JsonToString.toJson(this._ability);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get ability() {
    return this._hasAbility ? this._ability : JsonToString.default;
  }
  get hasAbility() {
    return this._hasAbility;
  }
  setAbility(path, value) {
    return {type: 'SET', path: path.concat(['ability']), value};
  }
  deleteAbility(path) {
    return {type: 'DELETE', path: path.concat(['ability'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "ability": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_UnitAbilityRange(this);
              copy._hasAbility = true;
              copy._ability = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbility) {
                return this;
              }
              const copy = new ActorExpressions_UnitAbilityRange(this);
              copy._hasAbility = false;
              copy._ability = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_UnitAbilityRange} other
   * @returns {ActorExpressions_UnitAbilityRange}
   */
  merge(other) {
    const copy = new ActorExpressions_UnitAbilityRange(this);
    if (other._hasAbility) {
      copy._hasAbility = true;
      copy._ability = other._ability;
    }
    return copy;
  }
}
ActorExpressions_UnitAbilityRange.default = new ActorExpressions_UnitAbilityRange();
class ActorExpressions_UnitAbilityRange_Builder {
  constructor(value) {
    this._value = new ActorExpressions_UnitAbilityRange(value);
  }
  build() {
    return new ActorExpressions_UnitAbilityRange(this._value);
  }
  setAbility(value) {
    this._value._hasAbility = true;
    this._value._ability = value;
    return this;
  }
  deleteAbility() {
    this._value._hasAbility = false;
    this._value._ability = null;
    return this;
  }
}
ActorExpressions_UnitAbilityRange.Builder = ActorExpressions_UnitAbilityRange_Builder;
class ActorExpressions_UnitAbilityRange_WithParent {
  /**
   * @param {ActorExpressions_UnitAbilityRange} value
   * @param {ActorExpressions_UnitAbilityRange_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_UnitAbilityRange.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAbility() {
    if (this._cachedHasAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedHasAbility = true;
      } else {
        this._cachedHasAbility = this._parent ? this._parent.hasAbility : false;
      }
    }
    return this._cachedHasAbility;
  }
  get ability() {
    if (this._cachedAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedAbility = this._value.ability;
      } else {
        this._cachedAbility = this._parent ? this._parent.ability : this._value.ability;
      }
    }
    return this._cachedAbility;
  }
  update(current, parent) {
    const result = new ActorExpressions_UnitAbilityRange_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_UnitAbilityRange_WithParent.default = new ActorExpressions_UnitAbilityRange_WithParent(ActorExpressions_UnitAbilityRange.default, null);
ActorExpressions_UnitAbilityRange.WithParent = ActorExpressions_UnitAbilityRange_WithParent;
class ActorExpressions_UnitAbilityRange_Descriptor {
  get ability() {
    if (!this._ability) {
      this._ability = {
        name: "ability",
        Name: "Ability",
        number: 1,
        protoType: 9,
        protoName: "ability",
        type: JsonToString,
        options: {
          comments: "The ability to use the range of.",
          valueDropdown: "SupportedAbilityNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ability;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.ability,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAbility",
        Name: "DummyOneofForAbility",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_UnitAbilityRange.descriptor = new ActorExpressions_UnitAbilityRange_Descriptor();
class ActorExpressions_Value {
  get descriptor() {
    return ActorExpressions_Value.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._valueTypeCase = 0;
    this._valueTypeValue = null;
  }
  isEmpty() {
    if (this._valueTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_Value) {
      return value;
    }
    return ActorExpressions_Value.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_Value();
    if (json.constant != null) {
      result._valueTypeCase = 1;
      result._valueTypeValue = ActorExpressions_ConstantValue.fromJson(json.constant);
    }
    if (json.variable != null) {
      result._valueTypeCase = 2;
      result._valueTypeValue = ActorExpressions_VariableValue.fromJson(json.variable);
    }
    if (json.randomInt != null) {
      result._valueTypeCase = 3;
      result._valueTypeValue = ActorExpressions_RandomIntValue.fromJson(json.randomInt);
    }
    if (json.unitWeaponRange != null) {
      result._valueTypeCase = 4;
      result._valueTypeValue = ActorExpressions_UnitWeaponRange.fromJson(json.unitWeaponRange);
    }
    if (json.unitAbilityRange != null) {
      result._valueTypeCase = 5;
      result._valueTypeValue = ActorExpressions_UnitAbilityRange.fromJson(json.unitAbilityRange);
    }
    if (json.addExpressions != null) {
      result._valueTypeCase = 101;
      result._valueTypeValue = ActorExpressions_AddExpression.fromJson(json.addExpressions);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._valueTypeCase) {
      case 1:
        result.constant = ActorExpressions_ConstantValue.toJson(this._valueTypeValue);
        break;
      case 2:
        result.variable = ActorExpressions_VariableValue.toJson(this._valueTypeValue);
        break;
      case 3:
        result.randomInt = ActorExpressions_RandomIntValue.toJson(this._valueTypeValue);
        break;
      case 4:
        result.unitWeaponRange = ActorExpressions_UnitWeaponRange.toJson(this._valueTypeValue);
        break;
      case 5:
        result.unitAbilityRange = ActorExpressions_UnitAbilityRange.toJson(this._valueTypeValue);
        break;
      case 101:
        result.addExpressions = ActorExpressions_AddExpression.toJson(this._valueTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get valueTypeCase() {
    return this._valueTypeCase;
  }
  deleteValueType(path) {
    switch (this._valueTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['constant'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['variable'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['randomInt'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['unitWeaponRange'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['unitAbilityRange'])};
      }
      case 101: {
        return {type: 'DELETE', path: path.concat(['addExpressions'])};
      }
    }
  }
  /**
   * @returns {ActorExpressions_ConstantValue}
   */
  get constant() {
    return this._valueTypeCase === 1 ? this._valueTypeValue : ActorExpressions_ConstantValue.default;
  }
  setConstant(path, value) {
    return {type: 'SET', path: path.concat(['constant']), value: value.toJson()};
  }
  deleteConstant(path) {
    return {type: 'DELETE', path: path.concat(['constant'])};
  }
  /**
   * @returns {ActorExpressions_VariableValue}
   */
  get variable() {
    return this._valueTypeCase === 2 ? this._valueTypeValue : ActorExpressions_VariableValue.default;
  }
  setVariable(path, value) {
    return {type: 'SET', path: path.concat(['variable']), value: value.toJson()};
  }
  deleteVariable(path) {
    return {type: 'DELETE', path: path.concat(['variable'])};
  }
  /**
   * @returns {ActorExpressions_RandomIntValue}
   */
  get randomInt() {
    return this._valueTypeCase === 3 ? this._valueTypeValue : ActorExpressions_RandomIntValue.default;
  }
  setRandomInt(path, value) {
    return {type: 'SET', path: path.concat(['randomInt']), value: value.toJson()};
  }
  deleteRandomInt(path) {
    return {type: 'DELETE', path: path.concat(['randomInt'])};
  }
  /**
   * @returns {ActorExpressions_UnitWeaponRange}
   */
  get unitWeaponRange() {
    return this._valueTypeCase === 4 ? this._valueTypeValue : ActorExpressions_UnitWeaponRange.default;
  }
  setUnitWeaponRange(path, value) {
    return {type: 'SET', path: path.concat(['unitWeaponRange']), value: value.toJson()};
  }
  deleteUnitWeaponRange(path) {
    return {type: 'DELETE', path: path.concat(['unitWeaponRange'])};
  }
  /**
   * @returns {ActorExpressions_UnitAbilityRange}
   */
  get unitAbilityRange() {
    return this._valueTypeCase === 5 ? this._valueTypeValue : ActorExpressions_UnitAbilityRange.default;
  }
  setUnitAbilityRange(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityRange']), value: value.toJson()};
  }
  deleteUnitAbilityRange(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityRange'])};
  }
  /**
   * @returns {ActorExpressions_AddExpression}
   */
  get addExpressions() {
    return this._valueTypeCase === 101 ? this._valueTypeValue : ActorExpressions_AddExpression.default;
  }
  setAddExpressions(path, value) {
    return {type: 'SET', path: path.concat(['addExpressions']), value: value.toJson()};
  }
  deleteAddExpressions(path) {
    return {type: 'DELETE', path: path.concat(['addExpressions'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "constant": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 1;
              copy._valueTypeValue = ActorExpressions_ConstantValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 1) {
                return this;
              }
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 1) {
            const copy = new ActorExpressions_Value(this);
            copy._valueTypeCase = 1;
            copy._valueTypeValue = ActorExpressions_ConstantValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.constant.apply(type, path.slice(1), value);
          if (newValue === this.constant) {
            return this;
          }
          const copy = new ActorExpressions_Value(this);
          copy._valueTypeCase = 1;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "variable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 2;
              copy._valueTypeValue = ActorExpressions_VariableValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 2) {
                return this;
              }
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 2) {
            const copy = new ActorExpressions_Value(this);
            copy._valueTypeCase = 2;
            copy._valueTypeValue = ActorExpressions_VariableValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.variable.apply(type, path.slice(1), value);
          if (newValue === this.variable) {
            return this;
          }
          const copy = new ActorExpressions_Value(this);
          copy._valueTypeCase = 2;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "randomInt": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 3;
              copy._valueTypeValue = ActorExpressions_RandomIntValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 3) {
                return this;
              }
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 3) {
            const copy = new ActorExpressions_Value(this);
            copy._valueTypeCase = 3;
            copy._valueTypeValue = ActorExpressions_RandomIntValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.randomInt.apply(type, path.slice(1), value);
          if (newValue === this.randomInt) {
            return this;
          }
          const copy = new ActorExpressions_Value(this);
          copy._valueTypeCase = 3;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "unitWeaponRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 4;
              copy._valueTypeValue = ActorExpressions_UnitWeaponRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 4) {
                return this;
              }
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 4) {
            const copy = new ActorExpressions_Value(this);
            copy._valueTypeCase = 4;
            copy._valueTypeValue = ActorExpressions_UnitWeaponRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWeaponRange.apply(type, path.slice(1), value);
          if (newValue === this.unitWeaponRange) {
            return this;
          }
          const copy = new ActorExpressions_Value(this);
          copy._valueTypeCase = 4;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 5;
              copy._valueTypeValue = ActorExpressions_UnitAbilityRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 5) {
                return this;
              }
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 5) {
            const copy = new ActorExpressions_Value(this);
            copy._valueTypeCase = 5;
            copy._valueTypeValue = ActorExpressions_UnitAbilityRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityRange.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityRange) {
            return this;
          }
          const copy = new ActorExpressions_Value(this);
          copy._valueTypeCase = 5;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "addExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 101;
              copy._valueTypeValue = ActorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 101) {
                return this;
              }
              const copy = new ActorExpressions_Value(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 101) {
            const copy = new ActorExpressions_Value(this);
            copy._valueTypeCase = 101;
            copy._valueTypeValue = ActorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.addExpressions.apply(type, path.slice(1), value);
          if (newValue === this.addExpressions) {
            return this;
          }
          const copy = new ActorExpressions_Value(this);
          copy._valueTypeCase = 101;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_Value} other
   * @returns {ActorExpressions_Value}
   */
  merge(other) {
    const copy = new ActorExpressions_Value(this);
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    return copy;
  }
}
ActorExpressions_Value.default = new ActorExpressions_Value();
class ActorExpressions_Value_Builder {
  constructor(value) {
    this._value = new ActorExpressions_Value(value);
  }
  build() {
    return new ActorExpressions_Value(this._value);
  }
  clearvalueType() {
    this._value._valueTypeCase = 0;
    this._value._valueTypeValue = null;
    return this;
  }
  setConstant(value) {
    this._value._valueTypeCase = 1;
    this._value._valueTypeValue = value;
    return this;
  }
  setVariable(value) {
    this._value._valueTypeCase = 2;
    this._value._valueTypeValue = value;
    return this;
  }
  setRandomInt(value) {
    this._value._valueTypeCase = 3;
    this._value._valueTypeValue = value;
    return this;
  }
  setUnitWeaponRange(value) {
    this._value._valueTypeCase = 4;
    this._value._valueTypeValue = value;
    return this;
  }
  setUnitAbilityRange(value) {
    this._value._valueTypeCase = 5;
    this._value._valueTypeValue = value;
    return this;
  }
  setAddExpressions(value) {
    this._value._valueTypeCase = 101;
    this._value._valueTypeValue = value;
    return this;
  }
}
ActorExpressions_Value.Builder = ActorExpressions_Value_Builder;
class ActorExpressions_Value_WithParent {
  /**
   * @param {ActorExpressions_Value} value
   * @param {ActorExpressions_Value_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_Value.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get valueTypeCase() {
    if (this._cachedvalueTypeCase === undefined) {
      if (this._value._valueTypeCase === 0) {
        this._cachedvalueTypeCase = this._parent ? this._parent.valueTypeCase : 0;
      } else {
        this._cachedvalueTypeCase = this._value._valueTypeCase;
      }
    }
    return this._cachedvalueTypeCase;
  }
  get constant() {
    if (!this._cachedConstant) {
      if (this._value._valueTypeCase === 0) {
        this._cachedConstant = this._parent ? new ActorExpressions_ConstantValue.WithParent(ActorExpressions_ConstantValue.default, this._parent.constant) : this._value.constant;
      } else if (this._value._valueTypeCase === 1) {
        this._cachedConstant = new ActorExpressions_ConstantValue.WithParent(this._value.constant, this._parent && this._parent.valueTypeCase === 1 ? this._parent.constant : null);
      } else {
        this._cachedConstant = ActorExpressions_ConstantValue.WithParent.default;
      }
    }
    return this._cachedConstant;
  }
  get variable() {
    if (!this._cachedVariable) {
      if (this._value._valueTypeCase === 0) {
        this._cachedVariable = this._parent ? new ActorExpressions_VariableValue.WithParent(ActorExpressions_VariableValue.default, this._parent.variable) : this._value.variable;
      } else if (this._value._valueTypeCase === 2) {
        this._cachedVariable = new ActorExpressions_VariableValue.WithParent(this._value.variable, this._parent && this._parent.valueTypeCase === 2 ? this._parent.variable : null);
      } else {
        this._cachedVariable = ActorExpressions_VariableValue.WithParent.default;
      }
    }
    return this._cachedVariable;
  }
  get randomInt() {
    if (!this._cachedRandomInt) {
      if (this._value._valueTypeCase === 0) {
        this._cachedRandomInt = this._parent ? new ActorExpressions_RandomIntValue.WithParent(ActorExpressions_RandomIntValue.default, this._parent.randomInt) : this._value.randomInt;
      } else if (this._value._valueTypeCase === 3) {
        this._cachedRandomInt = new ActorExpressions_RandomIntValue.WithParent(this._value.randomInt, this._parent && this._parent.valueTypeCase === 3 ? this._parent.randomInt : null);
      } else {
        this._cachedRandomInt = ActorExpressions_RandomIntValue.WithParent.default;
      }
    }
    return this._cachedRandomInt;
  }
  get unitWeaponRange() {
    if (!this._cachedUnitWeaponRange) {
      if (this._value._valueTypeCase === 0) {
        this._cachedUnitWeaponRange = this._parent ? new ActorExpressions_UnitWeaponRange.WithParent(ActorExpressions_UnitWeaponRange.default, this._parent.unitWeaponRange) : this._value.unitWeaponRange;
      } else if (this._value._valueTypeCase === 4) {
        this._cachedUnitWeaponRange = new ActorExpressions_UnitWeaponRange.WithParent(this._value.unitWeaponRange, this._parent && this._parent.valueTypeCase === 4 ? this._parent.unitWeaponRange : null);
      } else {
        this._cachedUnitWeaponRange = ActorExpressions_UnitWeaponRange.WithParent.default;
      }
    }
    return this._cachedUnitWeaponRange;
  }
  get unitAbilityRange() {
    if (!this._cachedUnitAbilityRange) {
      if (this._value._valueTypeCase === 0) {
        this._cachedUnitAbilityRange = this._parent ? new ActorExpressions_UnitAbilityRange.WithParent(ActorExpressions_UnitAbilityRange.default, this._parent.unitAbilityRange) : this._value.unitAbilityRange;
      } else if (this._value._valueTypeCase === 5) {
        this._cachedUnitAbilityRange = new ActorExpressions_UnitAbilityRange.WithParent(this._value.unitAbilityRange, this._parent && this._parent.valueTypeCase === 5 ? this._parent.unitAbilityRange : null);
      } else {
        this._cachedUnitAbilityRange = ActorExpressions_UnitAbilityRange.WithParent.default;
      }
    }
    return this._cachedUnitAbilityRange;
  }
  get addExpressions() {
    if (!this._cachedAddExpressions) {
      if (this._value._valueTypeCase === 0) {
        this._cachedAddExpressions = this._parent ? new ActorExpressions_AddExpression.WithParent(ActorExpressions_AddExpression.default, this._parent.addExpressions) : this._value.addExpressions;
      } else if (this._value._valueTypeCase === 101) {
        this._cachedAddExpressions = new ActorExpressions_AddExpression.WithParent(this._value.addExpressions, this._parent && this._parent.valueTypeCase === 101 ? this._parent.addExpressions : null);
      } else {
        this._cachedAddExpressions = ActorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAddExpressions;
  }
  update(current, parent) {
    const result = new ActorExpressions_Value_WithParent(current, parent);
    if (this._cachedConstant && this._value._valueTypeCase === 1 && current._valueTypeCase === 1) {
      if (this._value.constant === current.constant && this._parent === parent) {
        result._cachedConstant = this._cachedConstant;
      } else {
        result._cachedConstant = this._cachedConstant.update(current.constant, parent && parent.valueTypeCase === 1 ? parent.constant : null);
      }
    }
    if (this._cachedVariable && this._value._valueTypeCase === 2 && current._valueTypeCase === 2) {
      if (this._value.variable === current.variable && this._parent === parent) {
        result._cachedVariable = this._cachedVariable;
      } else {
        result._cachedVariable = this._cachedVariable.update(current.variable, parent && parent.valueTypeCase === 2 ? parent.variable : null);
      }
    }
    if (this._cachedRandomInt && this._value._valueTypeCase === 3 && current._valueTypeCase === 3) {
      if (this._value.randomInt === current.randomInt && this._parent === parent) {
        result._cachedRandomInt = this._cachedRandomInt;
      } else {
        result._cachedRandomInt = this._cachedRandomInt.update(current.randomInt, parent && parent.valueTypeCase === 3 ? parent.randomInt : null);
      }
    }
    if (this._cachedUnitWeaponRange && this._value._valueTypeCase === 4 && current._valueTypeCase === 4) {
      if (this._value.unitWeaponRange === current.unitWeaponRange && this._parent === parent) {
        result._cachedUnitWeaponRange = this._cachedUnitWeaponRange;
      } else {
        result._cachedUnitWeaponRange = this._cachedUnitWeaponRange.update(current.unitWeaponRange, parent && parent.valueTypeCase === 4 ? parent.unitWeaponRange : null);
      }
    }
    if (this._cachedUnitAbilityRange && this._value._valueTypeCase === 5 && current._valueTypeCase === 5) {
      if (this._value.unitAbilityRange === current.unitAbilityRange && this._parent === parent) {
        result._cachedUnitAbilityRange = this._cachedUnitAbilityRange;
      } else {
        result._cachedUnitAbilityRange = this._cachedUnitAbilityRange.update(current.unitAbilityRange, parent && parent.valueTypeCase === 5 ? parent.unitAbilityRange : null);
      }
    }
    if (this._cachedAddExpressions && this._value._valueTypeCase === 101 && current._valueTypeCase === 101) {
      if (this._value.addExpressions === current.addExpressions && this._parent === parent) {
        result._cachedAddExpressions = this._cachedAddExpressions;
      } else {
        result._cachedAddExpressions = this._cachedAddExpressions.update(current.addExpressions, parent && parent.valueTypeCase === 101 ? parent.addExpressions : null);
      }
    }
    return result;
  }
}
ActorExpressions_Value_WithParent.default = new ActorExpressions_Value_WithParent(ActorExpressions_Value.default, null);
ActorExpressions_Value.WithParent = ActorExpressions_Value_WithParent;
class ActorExpressions_Value_Descriptor {
  get constant() {
    if (!this._constant) {
      this._constant = {
        name: "constant",
        Name: "Constant",
        number: 1,
        protoType: 11,
        protoName: "constant",
        oneofIndex: 0,
        type: ActorExpressions_ConstantValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._constant;
  }
  get variable() {
    if (!this._variable) {
      this._variable = {
        name: "variable",
        Name: "Variable",
        number: 2,
        protoType: 11,
        protoName: "variable",
        oneofIndex: 0,
        type: ActorExpressions_VariableValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variable;
  }
  get randomInt() {
    if (!this._randomInt) {
      this._randomInt = {
        name: "randomInt",
        Name: "RandomInt",
        number: 3,
        protoType: 11,
        protoName: "random_int",
        oneofIndex: 0,
        type: ActorExpressions_RandomIntValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomInt;
  }
  get unitWeaponRange() {
    if (!this._unitWeaponRange) {
      this._unitWeaponRange = {
        name: "unitWeaponRange",
        Name: "UnitWeaponRange",
        number: 4,
        protoType: 11,
        protoName: "unit_weapon_range",
        oneofIndex: 0,
        type: ActorExpressions_UnitWeaponRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWeaponRange;
  }
  get unitAbilityRange() {
    if (!this._unitAbilityRange) {
      this._unitAbilityRange = {
        name: "unitAbilityRange",
        Name: "UnitAbilityRange",
        number: 5,
        protoType: 11,
        protoName: "unit_ability_range",
        oneofIndex: 0,
        type: ActorExpressions_UnitAbilityRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityRange;
  }
  get addExpressions() {
    if (!this._addExpressions) {
      this._addExpressions = {
        name: "addExpressions",
        Name: "AddExpressions",
        number: 101,
        protoType: 11,
        protoName: "add_expressions",
        oneofIndex: 0,
        type: ActorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._addExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.constant,
        this.variable,
        this.randomInt,
        this.unitWeaponRange,
        this.unitAbilityRange,
        this.addExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "valueType",
        Name: "ValueType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_Value.descriptor = new ActorExpressions_Value_Descriptor();
class ActorExpressions_DivideExpression {
  get descriptor() {
    return ActorExpressions_DivideExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_DivideExpression) {
      return value;
    }
    return ActorExpressions_DivideExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_DivideExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ActorExpressions_Value.fromJson(json.left);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ActorExpressions_Value.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ActorExpressions_Value.toJson(this._left);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ActorExpressions_Value.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_Value}
   */
  get left() {
    return this._hasLeft ? this._left : ActorExpressions_Value.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {ActorExpressions_Value}
   */
  get right() {
    return this._hasRight ? this._right : ActorExpressions_Value.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_DivideExpression(this);
              copy._hasLeft = true;
              copy._left = ActorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ActorExpressions_DivideExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ActorExpressions_DivideExpression(this);
            copy._hasLeft = true;
            copy._left = ActorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ActorExpressions_DivideExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_DivideExpression(this);
              copy._hasRight = true;
              copy._right = ActorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ActorExpressions_DivideExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ActorExpressions_DivideExpression(this);
            copy._hasRight = true;
            copy._right = ActorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ActorExpressions_DivideExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_DivideExpression} other
   * @returns {ActorExpressions_DivideExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_DivideExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ActorExpressions_DivideExpression.default = new ActorExpressions_DivideExpression();
class ActorExpressions_DivideExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_DivideExpression(value);
  }
  build() {
    return new ActorExpressions_DivideExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ActorExpressions_DivideExpression.Builder = ActorExpressions_DivideExpression_Builder;
class ActorExpressions_DivideExpression_WithParent {
  /**
   * @param {ActorExpressions_DivideExpression} value
   * @param {ActorExpressions_DivideExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_DivideExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ActorExpressions_Value.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ActorExpressions_Value.WithParent(ActorExpressions_Value.default, this._parent.left) : ActorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ActorExpressions_Value.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ActorExpressions_Value.WithParent(ActorExpressions_Value.default, this._parent.right) : ActorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ActorExpressions_DivideExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ActorExpressions_DivideExpression_WithParent.default = new ActorExpressions_DivideExpression_WithParent(ActorExpressions_DivideExpression.default, null);
ActorExpressions_DivideExpression.WithParent = ActorExpressions_DivideExpression_WithParent;
class ActorExpressions_DivideExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ActorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 11,
        protoName: "right",
        type: ActorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_DivideExpression.descriptor = new ActorExpressions_DivideExpression_Descriptor();
class ActorExpressions_MultiplyExpression {
  get descriptor() {
    return ActorExpressions_MultiplyExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_MultiplyExpression) {
      return value;
    }
    return ActorExpressions_MultiplyExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_MultiplyExpression();
    result._expressions = JsonToList(json.expressions, ActorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ActorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ActorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_MultiplyExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ActorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorExpressions_MultiplyExpression(this);
              copy._expressions = copy._expressions.concat([ActorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ActorExpressions_MultiplyExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_MultiplyExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorExpressions_MultiplyExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorExpressions_MultiplyExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_MultiplyExpression} other
   * @returns {ActorExpressions_MultiplyExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_MultiplyExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ActorExpressions_MultiplyExpression.default = new ActorExpressions_MultiplyExpression();
class ActorExpressions_MultiplyExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_MultiplyExpression(value);
  }
  build() {
    return new ActorExpressions_MultiplyExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ActorExpressions_MultiplyExpression.Builder = ActorExpressions_MultiplyExpression_Builder;
class ActorExpressions_MultiplyExpression_WithParent {
  /**
   * @param {ActorExpressions_MultiplyExpression} value
   * @param {ActorExpressions_MultiplyExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_MultiplyExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ActorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ActorExpressions_MultiplyExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ActorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorExpressions_MultiplyExpression_WithParent.default = new ActorExpressions_MultiplyExpression_WithParent(ActorExpressions_MultiplyExpression.default, null);
ActorExpressions_MultiplyExpression.WithParent = ActorExpressions_MultiplyExpression_WithParent;
class ActorExpressions_MultiplyExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ActorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_MultiplyExpression.descriptor = new ActorExpressions_MultiplyExpression_Descriptor();
class ActorExpressions_SubtractExpression_ChildExpression {
  get descriptor() {
    return ActorExpressions_SubtractExpression_ChildExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_SubtractExpression_ChildExpression) {
      return value;
    }
    return ActorExpressions_SubtractExpression_ChildExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_SubtractExpression_ChildExpression();
    if (json.value != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ActorExpressions_Value.fromJson(json.value);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ActorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ActorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.value = ActorExpressions_Value.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.divide = ActorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.multiply = ActorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
    }
  }
  /**
   * @returns {ActorExpressions_Value}
   */
  get value() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ActorExpressions_Value.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ActorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ActorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ActorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ActorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ActorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ActorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ActorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ActorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ActorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ActorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_SubtractExpression_ChildExpression} other
   * @returns {ActorExpressions_SubtractExpression_ChildExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_SubtractExpression_ChildExpression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    return copy;
  }
}
ActorExpressions_SubtractExpression_ChildExpression.default = new ActorExpressions_SubtractExpression_ChildExpression();
class ActorExpressions_SubtractExpression_ChildExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_SubtractExpression_ChildExpression(value);
  }
  build() {
    return new ActorExpressions_SubtractExpression_ChildExpression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
}
ActorExpressions_SubtractExpression_ChildExpression.Builder = ActorExpressions_SubtractExpression_ChildExpression_Builder;
class ActorExpressions_SubtractExpression_ChildExpression_WithParent {
  /**
   * @param {ActorExpressions_SubtractExpression_ChildExpression} value
   * @param {ActorExpressions_SubtractExpression_ChildExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_SubtractExpression_ChildExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedValue = this._parent ? new ActorExpressions_Value.WithParent(ActorExpressions_Value.default, this._parent.value) : this._value.value;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedValue = new ActorExpressions_Value.WithParent(this._value.value, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = ActorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ActorExpressions_DivideExpression.WithParent(ActorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedDivide = new ActorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ActorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ActorExpressions_MultiplyExpression.WithParent(ActorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedMultiply = new ActorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ActorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  update(current, parent) {
    const result = new ActorExpressions_SubtractExpression_ChildExpression_WithParent(current, parent);
    if (this._cachedValue && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.oneofTypeCase === 1 ? parent.value : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 2 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 3 ? parent.multiply : null);
      }
    }
    return result;
  }
}
ActorExpressions_SubtractExpression_ChildExpression_WithParent.default = new ActorExpressions_SubtractExpression_ChildExpression_WithParent(ActorExpressions_SubtractExpression_ChildExpression.default, null);
ActorExpressions_SubtractExpression_ChildExpression.WithParent = ActorExpressions_SubtractExpression_ChildExpression_WithParent;
class ActorExpressions_SubtractExpression_ChildExpression_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: ActorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 2,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ActorExpressions_DivideExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 3,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ActorExpressions_MultiplyExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.divide,
        this.multiply,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_SubtractExpression_ChildExpression.descriptor = new ActorExpressions_SubtractExpression_ChildExpression_Descriptor();
class ActorExpressions_SubtractExpression {
  get descriptor() {
    return ActorExpressions_SubtractExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_SubtractExpression) {
      return value;
    }
    return ActorExpressions_SubtractExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_SubtractExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ActorExpressions_SubtractExpression_ChildExpression.fromJson(json.left);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ActorExpressions_SubtractExpression_ChildExpression.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ActorExpressions_SubtractExpression_ChildExpression.toJson(this._left);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ActorExpressions_SubtractExpression_ChildExpression.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_SubtractExpression_ChildExpression}
   */
  get left() {
    return this._hasLeft ? this._left : ActorExpressions_SubtractExpression_ChildExpression.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {ActorExpressions_SubtractExpression_ChildExpression}
   */
  get right() {
    return this._hasRight ? this._right : ActorExpressions_SubtractExpression_ChildExpression.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_SubtractExpression(this);
              copy._hasLeft = true;
              copy._left = ActorExpressions_SubtractExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ActorExpressions_SubtractExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ActorExpressions_SubtractExpression(this);
            copy._hasLeft = true;
            copy._left = ActorExpressions_SubtractExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ActorExpressions_SubtractExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_SubtractExpression(this);
              copy._hasRight = true;
              copy._right = ActorExpressions_SubtractExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ActorExpressions_SubtractExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ActorExpressions_SubtractExpression(this);
            copy._hasRight = true;
            copy._right = ActorExpressions_SubtractExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ActorExpressions_SubtractExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_SubtractExpression} other
   * @returns {ActorExpressions_SubtractExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_SubtractExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ActorExpressions_SubtractExpression.default = new ActorExpressions_SubtractExpression();
ActorExpressions_SubtractExpression.ChildExpression = ActorExpressions_SubtractExpression_ChildExpression;
class ActorExpressions_SubtractExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_SubtractExpression(value);
  }
  build() {
    return new ActorExpressions_SubtractExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ActorExpressions_SubtractExpression.Builder = ActorExpressions_SubtractExpression_Builder;
class ActorExpressions_SubtractExpression_WithParent {
  /**
   * @param {ActorExpressions_SubtractExpression} value
   * @param {ActorExpressions_SubtractExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_SubtractExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ActorExpressions_SubtractExpression_ChildExpression.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ActorExpressions_SubtractExpression_ChildExpression.WithParent(ActorExpressions_SubtractExpression_ChildExpression.default, this._parent.left) : ActorExpressions_SubtractExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ActorExpressions_SubtractExpression_ChildExpression.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ActorExpressions_SubtractExpression_ChildExpression.WithParent(ActorExpressions_SubtractExpression_ChildExpression.default, this._parent.right) : ActorExpressions_SubtractExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ActorExpressions_SubtractExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ActorExpressions_SubtractExpression_WithParent.default = new ActorExpressions_SubtractExpression_WithParent(ActorExpressions_SubtractExpression.default, null);
ActorExpressions_SubtractExpression.WithParent = ActorExpressions_SubtractExpression_WithParent;
class ActorExpressions_SubtractExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ActorExpressions_SubtractExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 11,
        protoName: "right",
        type: ActorExpressions_SubtractExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_SubtractExpression.descriptor = new ActorExpressions_SubtractExpression_Descriptor();
class ActorExpressions_AddExpression {
  get descriptor() {
    return ActorExpressions_AddExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_AddExpression) {
      return value;
    }
    return ActorExpressions_AddExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_AddExpression();
    result._expressions = JsonToList(json.expressions, ActorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ActorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ActorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_AddExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ActorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorExpressions_AddExpression(this);
              copy._expressions = copy._expressions.concat([ActorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ActorExpressions_AddExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_AddExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorExpressions_AddExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorExpressions_AddExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_AddExpression} other
   * @returns {ActorExpressions_AddExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_AddExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ActorExpressions_AddExpression.default = new ActorExpressions_AddExpression();
class ActorExpressions_AddExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_AddExpression(value);
  }
  build() {
    return new ActorExpressions_AddExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ActorExpressions_AddExpression.Builder = ActorExpressions_AddExpression_Builder;
class ActorExpressions_AddExpression_WithParent {
  /**
   * @param {ActorExpressions_AddExpression} value
   * @param {ActorExpressions_AddExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_AddExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ActorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ActorExpressions_AddExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ActorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorExpressions_AddExpression_WithParent.default = new ActorExpressions_AddExpression_WithParent(ActorExpressions_AddExpression.default, null);
ActorExpressions_AddExpression.WithParent = ActorExpressions_AddExpression_WithParent;
class ActorExpressions_AddExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ActorExpressions_Expression,
        isRepeated: true,
        options: {
          comments: "The expressions to add.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_AddExpression.descriptor = new ActorExpressions_AddExpression_Descriptor();
class ActorExpressions_CompareExpression_Operator {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "EQUAL": return 0;
        case "NOT_EQUAL": return 1;
        case "GREATER_THAN": return 2;
        case "LESS_THAN": return 3;
        case "GREATER_OR_EQUAL": return 4;
        case "LESS_OR_EQUAL": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ActorExpressions_CompareExpression_Operator.fromJson(value);
  }
  static fromReact(e) {
    return ActorExpressions_CompareExpression_Operator.fromJson(e);
  }
}
ActorExpressions_CompareExpression_Operator.EQUAL = 0;
ActorExpressions_CompareExpression_Operator.NOT_EQUAL = 1;
ActorExpressions_CompareExpression_Operator.GREATER_THAN = 2;
ActorExpressions_CompareExpression_Operator.LESS_THAN = 3;
ActorExpressions_CompareExpression_Operator.GREATER_OR_EQUAL = 4;
ActorExpressions_CompareExpression_Operator.LESS_OR_EQUAL = 5;
ActorExpressions_CompareExpression_Operator.default = 0;
ActorExpressions_CompareExpression_Operator.values = {
  EQUAL: 0,
  NOT_EQUAL: 1,
  GREATER_THAN: 2,
  LESS_THAN: 3,
  GREATER_OR_EQUAL: 4,
  LESS_OR_EQUAL: 5,
};
ActorExpressions_CompareExpression_Operator.names = {
  0: "EQUAL",
  1: "NOT_EQUAL",
  2: "GREATER_THAN",
  3: "LESS_THAN",
  4: "GREATER_OR_EQUAL",
  5: "LESS_OR_EQUAL",
};
class ActorExpressions_CompareExpression {
  get descriptor() {
    return ActorExpressions_CompareExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasOp = false;
    this._op = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasOp) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_CompareExpression) {
      return value;
    }
    return ActorExpressions_CompareExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_CompareExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ActorExpressions_Value.fromJson(json.left);
    }
    if (json.op != null) {
      result._hasOp = true;
      result._op = ActorExpressions_CompareExpression_Operator.fromJson(json.op);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ActorExpressions_Value.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ActorExpressions_Value.toJson(this._left);
    }
    if (this._hasOp) {
      result.op = ActorExpressions_CompareExpression_Operator.toJson(this._op);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ActorExpressions_Value.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_Value}
   */
  get left() {
    return this._hasLeft ? this._left : ActorExpressions_Value.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {number}
   */
  get op() {
    return this._hasOp ? this._op : ActorExpressions_CompareExpression_Operator.default;
  }
  get hasOp() {
    return this._hasOp;
  }
  setOp(path, value) {
    return {type: 'SET', path: path.concat(['op']), value};
  }
  deleteOp(path) {
    return {type: 'DELETE', path: path.concat(['op'])};
  }
  /**
   * @returns {ActorExpressions_Value}
   */
  get right() {
    return this._hasRight ? this._right : ActorExpressions_Value.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_CompareExpression(this);
              copy._hasLeft = true;
              copy._left = ActorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ActorExpressions_CompareExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ActorExpressions_CompareExpression(this);
            copy._hasLeft = true;
            copy._left = ActorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ActorExpressions_CompareExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "op": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_CompareExpression(this);
              copy._hasOp = true;
              copy._op = ActorExpressions_CompareExpression_Operator.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOp) {
                return this;
              }
              const copy = new ActorExpressions_CompareExpression(this);
              copy._hasOp = false;
              copy._op = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_CompareExpression(this);
              copy._hasRight = true;
              copy._right = ActorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ActorExpressions_CompareExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ActorExpressions_CompareExpression(this);
            copy._hasRight = true;
            copy._right = ActorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ActorExpressions_CompareExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_CompareExpression} other
   * @returns {ActorExpressions_CompareExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_CompareExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasOp) {
      copy._hasOp = true;
      copy._op = other._op;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ActorExpressions_CompareExpression.default = new ActorExpressions_CompareExpression();
ActorExpressions_CompareExpression.Operator = ActorExpressions_CompareExpression_Operator;
class ActorExpressions_CompareExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_CompareExpression(value);
  }
  build() {
    return new ActorExpressions_CompareExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setOp(value) {
    this._value._hasOp = true;
    this._value._op = value;
    return this;
  }
  deleteOp() {
    this._value._hasOp = false;
    this._value._op = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ActorExpressions_CompareExpression.Builder = ActorExpressions_CompareExpression_Builder;
class ActorExpressions_CompareExpression_WithParent {
  /**
   * @param {ActorExpressions_CompareExpression} value
   * @param {ActorExpressions_CompareExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_CompareExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ActorExpressions_Value.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ActorExpressions_Value.WithParent(ActorExpressions_Value.default, this._parent.left) : ActorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasOp() {
    if (this._cachedHasOp === undefined) {
      if (this._value.hasOp) {
        this._cachedHasOp = true;
      } else {
        this._cachedHasOp = this._parent ? this._parent.hasOp : false;
      }
    }
    return this._cachedHasOp;
  }
  get op() {
    if (this._cachedOp === undefined) {
      if (this._value.hasOp) {
        this._cachedOp = this._value.op;
      } else {
        this._cachedOp = this._parent ? this._parent.op : this._value.op;
      }
    }
    return this._cachedOp;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ActorExpressions_Value.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ActorExpressions_Value.WithParent(ActorExpressions_Value.default, this._parent.right) : ActorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ActorExpressions_CompareExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ActorExpressions_CompareExpression_WithParent.default = new ActorExpressions_CompareExpression_WithParent(ActorExpressions_CompareExpression.default, null);
ActorExpressions_CompareExpression.WithParent = ActorExpressions_CompareExpression_WithParent;
class ActorExpressions_CompareExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ActorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get op() {
    if (!this._op) {
      this._op = {
        name: "op",
        Name: "Op",
        number: 2,
        protoType: 14,
        protoName: "op",
        type: ActorExpressions_CompareExpression_Operator,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._op;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 3,
        protoType: 11,
        protoName: "right",
        type: ActorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.op,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOp",
        Name: "DummyOneofForOp",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_CompareExpression.descriptor = new ActorExpressions_CompareExpression_Descriptor();
class ActorExpressions_LogicNotExpression_ChildExpression {
  get descriptor() {
    return ActorExpressions_LogicNotExpression_ChildExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_LogicNotExpression_ChildExpression) {
      return value;
    }
    return ActorExpressions_LogicNotExpression_ChildExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_LogicNotExpression_ChildExpression();
    if (json.value != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ActorExpressions_Value.fromJson(json.value);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ActorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ActorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    if (json.subtract != null) {
      result._oneofTypeCase = 4;
      result._oneofTypeValue = ActorExpressions_SubtractExpression.fromJson(json.subtract);
    }
    if (json.add != null) {
      result._oneofTypeCase = 5;
      result._oneofTypeValue = ActorExpressions_AddExpression.fromJson(json.add);
    }
    if (json.compare != null) {
      result._oneofTypeCase = 6;
      result._oneofTypeValue = ActorExpressions_CompareExpression.fromJson(json.compare);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.value = ActorExpressions_Value.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.divide = ActorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.multiply = ActorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      case 4:
        result.subtract = ActorExpressions_SubtractExpression.toJson(this._oneofTypeValue);
        break;
      case 5:
        result.add = ActorExpressions_AddExpression.toJson(this._oneofTypeValue);
        break;
      case 6:
        result.compare = ActorExpressions_CompareExpression.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['subtract'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['compare'])};
      }
    }
  }
  /**
   * @returns {ActorExpressions_Value}
   */
  get value() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ActorExpressions_Value.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ActorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ActorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ActorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ActorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  /**
   * @returns {ActorExpressions_SubtractExpression}
   */
  get subtract() {
    return this._oneofTypeCase === 4 ? this._oneofTypeValue : ActorExpressions_SubtractExpression.default;
  }
  setSubtract(path, value) {
    return {type: 'SET', path: path.concat(['subtract']), value: value.toJson()};
  }
  deleteSubtract(path) {
    return {type: 'DELETE', path: path.concat(['subtract'])};
  }
  /**
   * @returns {ActorExpressions_AddExpression}
   */
  get add() {
    return this._oneofTypeCase === 5 ? this._oneofTypeValue : ActorExpressions_AddExpression.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  /**
   * @returns {ActorExpressions_CompareExpression}
   */
  get compare() {
    return this._oneofTypeCase === 6 ? this._oneofTypeValue : ActorExpressions_CompareExpression.default;
  }
  setCompare(path, value) {
    return {type: 'SET', path: path.concat(['compare']), value: value.toJson()};
  }
  deleteCompare(path) {
    return {type: 'DELETE', path: path.concat(['compare'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ActorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ActorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ActorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ActorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ActorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ActorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "subtract": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 4;
              copy._oneofTypeValue = ActorExpressions_SubtractExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 4) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 4) {
            const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 4;
            copy._oneofTypeValue = ActorExpressions_SubtractExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.subtract.apply(type, path.slice(1), value);
          if (newValue === this.subtract) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 4;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 5;
              copy._oneofTypeValue = ActorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 5) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 5) {
            const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 5;
            copy._oneofTypeValue = ActorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 5;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "compare": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 6;
              copy._oneofTypeValue = ActorExpressions_CompareExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 6) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 6) {
            const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 6;
            copy._oneofTypeValue = ActorExpressions_CompareExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.compare.apply(type, path.slice(1), value);
          if (newValue === this.compare) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 6;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_LogicNotExpression_ChildExpression} other
   * @returns {ActorExpressions_LogicNotExpression_ChildExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_LogicNotExpression_ChildExpression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    return copy;
  }
}
ActorExpressions_LogicNotExpression_ChildExpression.default = new ActorExpressions_LogicNotExpression_ChildExpression();
class ActorExpressions_LogicNotExpression_ChildExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_LogicNotExpression_ChildExpression(value);
  }
  build() {
    return new ActorExpressions_LogicNotExpression_ChildExpression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
  setSubtract(value) {
    this._value._oneofTypeCase = 4;
    this._value._oneofTypeValue = value;
    return this;
  }
  setAdd(value) {
    this._value._oneofTypeCase = 5;
    this._value._oneofTypeValue = value;
    return this;
  }
  setCompare(value) {
    this._value._oneofTypeCase = 6;
    this._value._oneofTypeValue = value;
    return this;
  }
}
ActorExpressions_LogicNotExpression_ChildExpression.Builder = ActorExpressions_LogicNotExpression_ChildExpression_Builder;
class ActorExpressions_LogicNotExpression_ChildExpression_WithParent {
  /**
   * @param {ActorExpressions_LogicNotExpression_ChildExpression} value
   * @param {ActorExpressions_LogicNotExpression_ChildExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_LogicNotExpression_ChildExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedValue = this._parent ? new ActorExpressions_Value.WithParent(ActorExpressions_Value.default, this._parent.value) : this._value.value;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedValue = new ActorExpressions_Value.WithParent(this._value.value, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = ActorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ActorExpressions_DivideExpression.WithParent(ActorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedDivide = new ActorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ActorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ActorExpressions_MultiplyExpression.WithParent(ActorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedMultiply = new ActorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ActorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  get subtract() {
    if (!this._cachedSubtract) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedSubtract = this._parent ? new ActorExpressions_SubtractExpression.WithParent(ActorExpressions_SubtractExpression.default, this._parent.subtract) : this._value.subtract;
      } else if (this._value._oneofTypeCase === 4) {
        this._cachedSubtract = new ActorExpressions_SubtractExpression.WithParent(this._value.subtract, this._parent && this._parent.oneofTypeCase === 4 ? this._parent.subtract : null);
      } else {
        this._cachedSubtract = ActorExpressions_SubtractExpression.WithParent.default;
      }
    }
    return this._cachedSubtract;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedAdd = this._parent ? new ActorExpressions_AddExpression.WithParent(ActorExpressions_AddExpression.default, this._parent.add) : this._value.add;
      } else if (this._value._oneofTypeCase === 5) {
        this._cachedAdd = new ActorExpressions_AddExpression.WithParent(this._value.add, this._parent && this._parent.oneofTypeCase === 5 ? this._parent.add : null);
      } else {
        this._cachedAdd = ActorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  get compare() {
    if (!this._cachedCompare) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedCompare = this._parent ? new ActorExpressions_CompareExpression.WithParent(ActorExpressions_CompareExpression.default, this._parent.compare) : this._value.compare;
      } else if (this._value._oneofTypeCase === 6) {
        this._cachedCompare = new ActorExpressions_CompareExpression.WithParent(this._value.compare, this._parent && this._parent.oneofTypeCase === 6 ? this._parent.compare : null);
      } else {
        this._cachedCompare = ActorExpressions_CompareExpression.WithParent.default;
      }
    }
    return this._cachedCompare;
  }
  update(current, parent) {
    const result = new ActorExpressions_LogicNotExpression_ChildExpression_WithParent(current, parent);
    if (this._cachedValue && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.oneofTypeCase === 1 ? parent.value : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 2 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 3 ? parent.multiply : null);
      }
    }
    if (this._cachedSubtract && this._value._oneofTypeCase === 4 && current._oneofTypeCase === 4) {
      if (this._value.subtract === current.subtract && this._parent === parent) {
        result._cachedSubtract = this._cachedSubtract;
      } else {
        result._cachedSubtract = this._cachedSubtract.update(current.subtract, parent && parent.oneofTypeCase === 4 ? parent.subtract : null);
      }
    }
    if (this._cachedAdd && this._value._oneofTypeCase === 5 && current._oneofTypeCase === 5) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.oneofTypeCase === 5 ? parent.add : null);
      }
    }
    if (this._cachedCompare && this._value._oneofTypeCase === 6 && current._oneofTypeCase === 6) {
      if (this._value.compare === current.compare && this._parent === parent) {
        result._cachedCompare = this._cachedCompare;
      } else {
        result._cachedCompare = this._cachedCompare.update(current.compare, parent && parent.oneofTypeCase === 6 ? parent.compare : null);
      }
    }
    return result;
  }
}
ActorExpressions_LogicNotExpression_ChildExpression_WithParent.default = new ActorExpressions_LogicNotExpression_ChildExpression_WithParent(ActorExpressions_LogicNotExpression_ChildExpression.default, null);
ActorExpressions_LogicNotExpression_ChildExpression.WithParent = ActorExpressions_LogicNotExpression_ChildExpression_WithParent;
class ActorExpressions_LogicNotExpression_ChildExpression_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: ActorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 2,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ActorExpressions_DivideExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 3,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ActorExpressions_MultiplyExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get subtract() {
    if (!this._subtract) {
      this._subtract = {
        name: "subtract",
        Name: "Subtract",
        number: 4,
        protoType: 11,
        protoName: "subtract",
        oneofIndex: 0,
        type: ActorExpressions_SubtractExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subtract;
  }
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 5,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ActorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get compare() {
    if (!this._compare) {
      this._compare = {
        name: "compare",
        Name: "Compare",
        number: 6,
        protoType: 11,
        protoName: "compare",
        oneofIndex: 0,
        type: ActorExpressions_CompareExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._compare;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.divide,
        this.multiply,
        this.subtract,
        this.add,
        this.compare,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_LogicNotExpression_ChildExpression.descriptor = new ActorExpressions_LogicNotExpression_ChildExpression_Descriptor();
class ActorExpressions_LogicNotExpression {
  get descriptor() {
    return ActorExpressions_LogicNotExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasExpression = false;
    this._expression = null;
  }
  isEmpty() {
    if (this._hasExpression && !this._expression.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_LogicNotExpression) {
      return value;
    }
    return ActorExpressions_LogicNotExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_LogicNotExpression();
    if (json.expression != null) {
      result._hasExpression = true;
      result._expression = ActorExpressions_LogicNotExpression_ChildExpression.fromJson(json.expression);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasExpression && !this._expression.isEmpty()) {
      result.expression = ActorExpressions_LogicNotExpression_ChildExpression.toJson(this._expression);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_LogicNotExpression_ChildExpression}
   */
  get expression() {
    return this._hasExpression ? this._expression : ActorExpressions_LogicNotExpression_ChildExpression.default;
  }
  get hasExpression() {
    return this._hasExpression;
  }
  setExpression(path, value) {
    return {type: 'SET', path: path.concat(['expression']), value: value.toJson()};
  }
  deleteExpression(path) {
    return {type: 'DELETE', path: path.concat(['expression'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicNotExpression(this);
              copy._hasExpression = true;
              copy._expression = ActorExpressions_LogicNotExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpression) {
                return this;
              }
              const copy = new ActorExpressions_LogicNotExpression(this);
              copy._hasExpression = false;
              copy._expression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasExpression) {
            const copy = new ActorExpressions_LogicNotExpression(this);
            copy._hasExpression = true;
            copy._expression = ActorExpressions_LogicNotExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._expression.apply(type, path.slice(1), value);
          if (newValue === this._expression) {
            return this;
          }
          const copy = new ActorExpressions_LogicNotExpression(this);
          copy._expression = copy._expression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_LogicNotExpression} other
   * @returns {ActorExpressions_LogicNotExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_LogicNotExpression(this);
    if (other._hasExpression) {
      if (copy._hasExpression) {
        copy._expression = copy.expression.merge(other.expression);
      } else {
        copy._expression = other._expression;
      }
      copy._hasExpression = true;
    }
    return copy;
  }
}
ActorExpressions_LogicNotExpression.default = new ActorExpressions_LogicNotExpression();
ActorExpressions_LogicNotExpression.ChildExpression = ActorExpressions_LogicNotExpression_ChildExpression;
class ActorExpressions_LogicNotExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_LogicNotExpression(value);
  }
  build() {
    return new ActorExpressions_LogicNotExpression(this._value);
  }
  setExpression(value) {
    this._value._hasExpression = true;
    this._value._expression = value;
    return this;
  }
  deleteExpression() {
    this._value._hasExpression = false;
    this._value._expression = null;
    return this;
  }
}
ActorExpressions_LogicNotExpression.Builder = ActorExpressions_LogicNotExpression_Builder;
class ActorExpressions_LogicNotExpression_WithParent {
  /**
   * @param {ActorExpressions_LogicNotExpression} value
   * @param {ActorExpressions_LogicNotExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_LogicNotExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasExpression() {
    if (this._cachedHasExpression === undefined) {
      if (this._value.hasExpression) {
        this._cachedHasExpression = true;
      } else {
        this._cachedHasExpression = this._parent ? this._parent.hasExpression : false;
      }
    }
    return this._cachedHasExpression;
  }
  get expression() {
    if (!this._cachedExpression) {
      if (this._value.hasExpression) {
        this._cachedExpression = new ActorExpressions_LogicNotExpression_ChildExpression.WithParent(this._value.expression, this._parent && this._parent.hasExpression ? this._parent.expression : null);
      } else {
        this._cachedExpression = this._parent ? new ActorExpressions_LogicNotExpression_ChildExpression.WithParent(ActorExpressions_LogicNotExpression_ChildExpression.default, this._parent.expression) : ActorExpressions_LogicNotExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedExpression;
  }
  update(current, parent) {
    const result = new ActorExpressions_LogicNotExpression_WithParent(current, parent);
    if (this._cachedExpression && this._value.hasExpression && current.hasExpression) {
      if (this._value.expression === current.expression && this._parent === parent) {
        result._cachedExpression = this._cachedExpression;
      } else {
        result._cachedExpression = this._cachedExpression.update(current.expression, parent && parent.hasExpression ? parent.expression : null);
      }
    }
    return result;
  }
}
ActorExpressions_LogicNotExpression_WithParent.default = new ActorExpressions_LogicNotExpression_WithParent(ActorExpressions_LogicNotExpression.default, null);
ActorExpressions_LogicNotExpression.WithParent = ActorExpressions_LogicNotExpression_WithParent;
class ActorExpressions_LogicNotExpression_Descriptor {
  get expression() {
    if (!this._expression) {
      this._expression = {
        name: "expression",
        Name: "Expression",
        number: 1,
        protoType: 11,
        protoName: "expression",
        type: ActorExpressions_LogicNotExpression_ChildExpression,
        options: {
          comments: "The expression to flip.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForExpression",
        Name: "DummyOneofForExpression",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_LogicNotExpression.descriptor = new ActorExpressions_LogicNotExpression_Descriptor();
class ActorExpressions_LogicAndExpression {
  get descriptor() {
    return ActorExpressions_LogicAndExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_LogicAndExpression) {
      return value;
    }
    return ActorExpressions_LogicAndExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_LogicAndExpression();
    result._expressions = JsonToList(json.expressions, ActorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ActorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ActorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicAndExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ActorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorExpressions_LogicAndExpression(this);
              copy._expressions = copy._expressions.concat([ActorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ActorExpressions_LogicAndExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicAndExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorExpressions_LogicAndExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorExpressions_LogicAndExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_LogicAndExpression} other
   * @returns {ActorExpressions_LogicAndExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_LogicAndExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ActorExpressions_LogicAndExpression.default = new ActorExpressions_LogicAndExpression();
class ActorExpressions_LogicAndExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_LogicAndExpression(value);
  }
  build() {
    return new ActorExpressions_LogicAndExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ActorExpressions_LogicAndExpression.Builder = ActorExpressions_LogicAndExpression_Builder;
class ActorExpressions_LogicAndExpression_WithParent {
  /**
   * @param {ActorExpressions_LogicAndExpression} value
   * @param {ActorExpressions_LogicAndExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_LogicAndExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ActorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ActorExpressions_LogicAndExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ActorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorExpressions_LogicAndExpression_WithParent.default = new ActorExpressions_LogicAndExpression_WithParent(ActorExpressions_LogicAndExpression.default, null);
ActorExpressions_LogicAndExpression.WithParent = ActorExpressions_LogicAndExpression_WithParent;
class ActorExpressions_LogicAndExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ActorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_LogicAndExpression.descriptor = new ActorExpressions_LogicAndExpression_Descriptor();
class ActorExpressions_LogicOrExpression {
  get descriptor() {
    return ActorExpressions_LogicOrExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_LogicOrExpression) {
      return value;
    }
    return ActorExpressions_LogicOrExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_LogicOrExpression();
    result._expressions = JsonToList(json.expressions, ActorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ActorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ActorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicOrExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ActorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorExpressions_LogicOrExpression(this);
              copy._expressions = copy._expressions.concat([ActorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ActorExpressions_LogicOrExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_LogicOrExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorExpressions_LogicOrExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorExpressions_LogicOrExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_LogicOrExpression} other
   * @returns {ActorExpressions_LogicOrExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_LogicOrExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ActorExpressions_LogicOrExpression.default = new ActorExpressions_LogicOrExpression();
class ActorExpressions_LogicOrExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_LogicOrExpression(value);
  }
  build() {
    return new ActorExpressions_LogicOrExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ActorExpressions_LogicOrExpression.Builder = ActorExpressions_LogicOrExpression_Builder;
class ActorExpressions_LogicOrExpression_WithParent {
  /**
   * @param {ActorExpressions_LogicOrExpression} value
   * @param {ActorExpressions_LogicOrExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_LogicOrExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ActorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ActorExpressions_LogicOrExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ActorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorExpressions_LogicOrExpression_WithParent.default = new ActorExpressions_LogicOrExpression_WithParent(ActorExpressions_LogicOrExpression.default, null);
ActorExpressions_LogicOrExpression.WithParent = ActorExpressions_LogicOrExpression_WithParent;
class ActorExpressions_LogicOrExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ActorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_LogicOrExpression.descriptor = new ActorExpressions_LogicOrExpression_Descriptor();
class ActorExpressions_IfExpression_Condition {
  get descriptor() {
    return ActorExpressions_IfExpression_Condition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofConditionCase = 0;
    this._oneofConditionValue = null;
  }
  isEmpty() {
    if (this._oneofConditionCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_IfExpression_Condition) {
      return value;
    }
    return ActorExpressions_IfExpression_Condition.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_IfExpression_Condition();
    if (json.compare != null) {
      result._oneofConditionCase = 1;
      result._oneofConditionValue = ActorExpressions_CompareExpression.fromJson(json.compare);
    }
    if (json.constant != null) {
      result._oneofConditionCase = 2;
      result._oneofConditionValue = ActorExpressions_ConstantValue.fromJson(json.constant);
    }
    if (json.variable != null) {
      result._oneofConditionCase = 3;
      result._oneofConditionValue = ActorExpressions_VariableValue.fromJson(json.variable);
    }
    if (json.add != null) {
      result._oneofConditionCase = 4;
      result._oneofConditionValue = ActorExpressions_AddExpression.fromJson(json.add);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofConditionCase) {
      case 1:
        result.compare = ActorExpressions_CompareExpression.toJson(this._oneofConditionValue);
        break;
      case 2:
        result.constant = ActorExpressions_ConstantValue.toJson(this._oneofConditionValue);
        break;
      case 3:
        result.variable = ActorExpressions_VariableValue.toJson(this._oneofConditionValue);
        break;
      case 4:
        result.add = ActorExpressions_AddExpression.toJson(this._oneofConditionValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofConditionCase() {
    return this._oneofConditionCase;
  }
  deleteOneofCondition(path) {
    switch (this._oneofConditionCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['compare'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['constant'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['variable'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
    }
  }
  /**
   * @returns {ActorExpressions_CompareExpression}
   */
  get compare() {
    return this._oneofConditionCase === 1 ? this._oneofConditionValue : ActorExpressions_CompareExpression.default;
  }
  setCompare(path, value) {
    return {type: 'SET', path: path.concat(['compare']), value: value.toJson()};
  }
  deleteCompare(path) {
    return {type: 'DELETE', path: path.concat(['compare'])};
  }
  /**
   * @returns {ActorExpressions_ConstantValue}
   */
  get constant() {
    return this._oneofConditionCase === 2 ? this._oneofConditionValue : ActorExpressions_ConstantValue.default;
  }
  setConstant(path, value) {
    return {type: 'SET', path: path.concat(['constant']), value: value.toJson()};
  }
  deleteConstant(path) {
    return {type: 'DELETE', path: path.concat(['constant'])};
  }
  /**
   * @returns {ActorExpressions_VariableValue}
   */
  get variable() {
    return this._oneofConditionCase === 3 ? this._oneofConditionValue : ActorExpressions_VariableValue.default;
  }
  setVariable(path, value) {
    return {type: 'SET', path: path.concat(['variable']), value: value.toJson()};
  }
  deleteVariable(path) {
    return {type: 'DELETE', path: path.concat(['variable'])};
  }
  /**
   * @returns {ActorExpressions_AddExpression}
   */
  get add() {
    return this._oneofConditionCase === 4 ? this._oneofConditionValue : ActorExpressions_AddExpression.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "compare": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 1;
              copy._oneofConditionValue = ActorExpressions_CompareExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofConditionCase !== 1) {
                return this;
              }
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 0;
              copy._oneofConditionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofConditionCase !== 1) {
            const copy = new ActorExpressions_IfExpression_Condition(this);
            copy._oneofConditionCase = 1;
            copy._oneofConditionValue = ActorExpressions_CompareExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.compare.apply(type, path.slice(1), value);
          if (newValue === this.compare) {
            return this;
          }
          const copy = new ActorExpressions_IfExpression_Condition(this);
          copy._oneofConditionCase = 1;
          copy._oneofConditionValue = newValue;
          return copy;
        }
      }
      case "constant": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 2;
              copy._oneofConditionValue = ActorExpressions_ConstantValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofConditionCase !== 2) {
                return this;
              }
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 0;
              copy._oneofConditionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofConditionCase !== 2) {
            const copy = new ActorExpressions_IfExpression_Condition(this);
            copy._oneofConditionCase = 2;
            copy._oneofConditionValue = ActorExpressions_ConstantValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.constant.apply(type, path.slice(1), value);
          if (newValue === this.constant) {
            return this;
          }
          const copy = new ActorExpressions_IfExpression_Condition(this);
          copy._oneofConditionCase = 2;
          copy._oneofConditionValue = newValue;
          return copy;
        }
      }
      case "variable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 3;
              copy._oneofConditionValue = ActorExpressions_VariableValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofConditionCase !== 3) {
                return this;
              }
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 0;
              copy._oneofConditionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofConditionCase !== 3) {
            const copy = new ActorExpressions_IfExpression_Condition(this);
            copy._oneofConditionCase = 3;
            copy._oneofConditionValue = ActorExpressions_VariableValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.variable.apply(type, path.slice(1), value);
          if (newValue === this.variable) {
            return this;
          }
          const copy = new ActorExpressions_IfExpression_Condition(this);
          copy._oneofConditionCase = 3;
          copy._oneofConditionValue = newValue;
          return copy;
        }
      }
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 4;
              copy._oneofConditionValue = ActorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofConditionCase !== 4) {
                return this;
              }
              const copy = new ActorExpressions_IfExpression_Condition(this);
              copy._oneofConditionCase = 0;
              copy._oneofConditionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofConditionCase !== 4) {
            const copy = new ActorExpressions_IfExpression_Condition(this);
            copy._oneofConditionCase = 4;
            copy._oneofConditionValue = ActorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ActorExpressions_IfExpression_Condition(this);
          copy._oneofConditionCase = 4;
          copy._oneofConditionValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_IfExpression_Condition} other
   * @returns {ActorExpressions_IfExpression_Condition}
   */
  merge(other) {
    const copy = new ActorExpressions_IfExpression_Condition(this);
    if (other._oneofConditionCase === 1) {
      if (this._oneofConditionCase === 1) {
        copy._oneofConditionValue = copy._oneofConditionValue.merge(other._oneofConditionValue);
      } else {
        copy._oneofConditionValue = other._oneofConditionValue;
      }
      copy._oneofConditionCase = 1;
    }
    if (other._oneofConditionCase === 1) {
      if (this._oneofConditionCase === 1) {
        copy._oneofConditionValue = copy._oneofConditionValue.merge(other._oneofConditionValue);
      } else {
        copy._oneofConditionValue = other._oneofConditionValue;
      }
      copy._oneofConditionCase = 1;
    }
    if (other._oneofConditionCase === 1) {
      if (this._oneofConditionCase === 1) {
        copy._oneofConditionValue = copy._oneofConditionValue.merge(other._oneofConditionValue);
      } else {
        copy._oneofConditionValue = other._oneofConditionValue;
      }
      copy._oneofConditionCase = 1;
    }
    if (other._oneofConditionCase === 1) {
      if (this._oneofConditionCase === 1) {
        copy._oneofConditionValue = copy._oneofConditionValue.merge(other._oneofConditionValue);
      } else {
        copy._oneofConditionValue = other._oneofConditionValue;
      }
      copy._oneofConditionCase = 1;
    }
    return copy;
  }
}
ActorExpressions_IfExpression_Condition.default = new ActorExpressions_IfExpression_Condition();
class ActorExpressions_IfExpression_Condition_Builder {
  constructor(value) {
    this._value = new ActorExpressions_IfExpression_Condition(value);
  }
  build() {
    return new ActorExpressions_IfExpression_Condition(this._value);
  }
  clearoneofCondition() {
    this._value._oneofConditionCase = 0;
    this._value._oneofConditionValue = null;
    return this;
  }
  setCompare(value) {
    this._value._oneofConditionCase = 1;
    this._value._oneofConditionValue = value;
    return this;
  }
  setConstant(value) {
    this._value._oneofConditionCase = 2;
    this._value._oneofConditionValue = value;
    return this;
  }
  setVariable(value) {
    this._value._oneofConditionCase = 3;
    this._value._oneofConditionValue = value;
    return this;
  }
  setAdd(value) {
    this._value._oneofConditionCase = 4;
    this._value._oneofConditionValue = value;
    return this;
  }
}
ActorExpressions_IfExpression_Condition.Builder = ActorExpressions_IfExpression_Condition_Builder;
class ActorExpressions_IfExpression_Condition_WithParent {
  /**
   * @param {ActorExpressions_IfExpression_Condition} value
   * @param {ActorExpressions_IfExpression_Condition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_IfExpression_Condition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofConditionCase() {
    if (this._cachedoneofConditionCase === undefined) {
      if (this._value._oneofConditionCase === 0) {
        this._cachedoneofConditionCase = this._parent ? this._parent.oneofConditionCase : 0;
      } else {
        this._cachedoneofConditionCase = this._value._oneofConditionCase;
      }
    }
    return this._cachedoneofConditionCase;
  }
  get compare() {
    if (!this._cachedCompare) {
      if (this._value._oneofConditionCase === 0) {
        this._cachedCompare = this._parent ? new ActorExpressions_CompareExpression.WithParent(ActorExpressions_CompareExpression.default, this._parent.compare) : this._value.compare;
      } else if (this._value._oneofConditionCase === 1) {
        this._cachedCompare = new ActorExpressions_CompareExpression.WithParent(this._value.compare, this._parent && this._parent.oneofConditionCase === 1 ? this._parent.compare : null);
      } else {
        this._cachedCompare = ActorExpressions_CompareExpression.WithParent.default;
      }
    }
    return this._cachedCompare;
  }
  get constant() {
    if (!this._cachedConstant) {
      if (this._value._oneofConditionCase === 0) {
        this._cachedConstant = this._parent ? new ActorExpressions_ConstantValue.WithParent(ActorExpressions_ConstantValue.default, this._parent.constant) : this._value.constant;
      } else if (this._value._oneofConditionCase === 2) {
        this._cachedConstant = new ActorExpressions_ConstantValue.WithParent(this._value.constant, this._parent && this._parent.oneofConditionCase === 2 ? this._parent.constant : null);
      } else {
        this._cachedConstant = ActorExpressions_ConstantValue.WithParent.default;
      }
    }
    return this._cachedConstant;
  }
  get variable() {
    if (!this._cachedVariable) {
      if (this._value._oneofConditionCase === 0) {
        this._cachedVariable = this._parent ? new ActorExpressions_VariableValue.WithParent(ActorExpressions_VariableValue.default, this._parent.variable) : this._value.variable;
      } else if (this._value._oneofConditionCase === 3) {
        this._cachedVariable = new ActorExpressions_VariableValue.WithParent(this._value.variable, this._parent && this._parent.oneofConditionCase === 3 ? this._parent.variable : null);
      } else {
        this._cachedVariable = ActorExpressions_VariableValue.WithParent.default;
      }
    }
    return this._cachedVariable;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._oneofConditionCase === 0) {
        this._cachedAdd = this._parent ? new ActorExpressions_AddExpression.WithParent(ActorExpressions_AddExpression.default, this._parent.add) : this._value.add;
      } else if (this._value._oneofConditionCase === 4) {
        this._cachedAdd = new ActorExpressions_AddExpression.WithParent(this._value.add, this._parent && this._parent.oneofConditionCase === 4 ? this._parent.add : null);
      } else {
        this._cachedAdd = ActorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  update(current, parent) {
    const result = new ActorExpressions_IfExpression_Condition_WithParent(current, parent);
    if (this._cachedCompare && this._value._oneofConditionCase === 1 && current._oneofConditionCase === 1) {
      if (this._value.compare === current.compare && this._parent === parent) {
        result._cachedCompare = this._cachedCompare;
      } else {
        result._cachedCompare = this._cachedCompare.update(current.compare, parent && parent.oneofConditionCase === 1 ? parent.compare : null);
      }
    }
    if (this._cachedConstant && this._value._oneofConditionCase === 2 && current._oneofConditionCase === 2) {
      if (this._value.constant === current.constant && this._parent === parent) {
        result._cachedConstant = this._cachedConstant;
      } else {
        result._cachedConstant = this._cachedConstant.update(current.constant, parent && parent.oneofConditionCase === 2 ? parent.constant : null);
      }
    }
    if (this._cachedVariable && this._value._oneofConditionCase === 3 && current._oneofConditionCase === 3) {
      if (this._value.variable === current.variable && this._parent === parent) {
        result._cachedVariable = this._cachedVariable;
      } else {
        result._cachedVariable = this._cachedVariable.update(current.variable, parent && parent.oneofConditionCase === 3 ? parent.variable : null);
      }
    }
    if (this._cachedAdd && this._value._oneofConditionCase === 4 && current._oneofConditionCase === 4) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.oneofConditionCase === 4 ? parent.add : null);
      }
    }
    return result;
  }
}
ActorExpressions_IfExpression_Condition_WithParent.default = new ActorExpressions_IfExpression_Condition_WithParent(ActorExpressions_IfExpression_Condition.default, null);
ActorExpressions_IfExpression_Condition.WithParent = ActorExpressions_IfExpression_Condition_WithParent;
class ActorExpressions_IfExpression_Condition_Descriptor {
  get compare() {
    if (!this._compare) {
      this._compare = {
        name: "compare",
        Name: "Compare",
        number: 1,
        protoType: 11,
        protoName: "compare",
        oneofIndex: 0,
        type: ActorExpressions_CompareExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._compare;
  }
  get constant() {
    if (!this._constant) {
      this._constant = {
        name: "constant",
        Name: "Constant",
        number: 2,
        protoType: 11,
        protoName: "constant",
        oneofIndex: 0,
        type: ActorExpressions_ConstantValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._constant;
  }
  get variable() {
    if (!this._variable) {
      this._variable = {
        name: "variable",
        Name: "Variable",
        number: 3,
        protoType: 11,
        protoName: "variable",
        oneofIndex: 0,
        type: ActorExpressions_VariableValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variable;
  }
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 4,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ActorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.compare,
        this.constant,
        this.variable,
        this.add,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofCondition",
        Name: "OneofCondition",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_IfExpression_Condition.descriptor = new ActorExpressions_IfExpression_Condition_Descriptor();
class ActorExpressions_IfExpression {
  get descriptor() {
    return ActorExpressions_IfExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCondition = false;
    this._condition = null;
    this._hasValues = false;
    this._values = null;
  }
  isEmpty() {
    if (this._hasCondition && !this._condition.isEmpty()) return false;
    if (this._hasValues && !this._values.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_IfExpression) {
      return value;
    }
    return ActorExpressions_IfExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_IfExpression();
    if (json.condition != null) {
      result._hasCondition = true;
      result._condition = ActorExpressions_IfExpression_Condition.fromJson(json.condition);
    }
    if (json.values != null) {
      result._hasValues = true;
      result._values = ActorExpressions_AddExpression.fromJson(json.values);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCondition && !this._condition.isEmpty()) {
      result.condition = ActorExpressions_IfExpression_Condition.toJson(this._condition);
    }
    if (this._hasValues && !this._values.isEmpty()) {
      result.values = ActorExpressions_AddExpression.toJson(this._values);
    }
    return result;
  }
  /**
   * @returns {ActorExpressions_IfExpression_Condition}
   */
  get condition() {
    return this._hasCondition ? this._condition : ActorExpressions_IfExpression_Condition.default;
  }
  get hasCondition() {
    return this._hasCondition;
  }
  setCondition(path, value) {
    return {type: 'SET', path: path.concat(['condition']), value: value.toJson()};
  }
  deleteCondition(path) {
    return {type: 'DELETE', path: path.concat(['condition'])};
  }
  /**
   * @returns {ActorExpressions_AddExpression}
   */
  get values() {
    return this._hasValues ? this._values : ActorExpressions_AddExpression.default;
  }
  get hasValues() {
    return this._hasValues;
  }
  setValues(path, value) {
    return {type: 'SET', path: path.concat(['values']), value: value.toJson()};
  }
  deleteValues(path) {
    return {type: 'DELETE', path: path.concat(['values'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "condition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IfExpression(this);
              copy._hasCondition = true;
              copy._condition = ActorExpressions_IfExpression_Condition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCondition) {
                return this;
              }
              const copy = new ActorExpressions_IfExpression(this);
              copy._hasCondition = false;
              copy._condition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCondition) {
            const copy = new ActorExpressions_IfExpression(this);
            copy._hasCondition = true;
            copy._condition = ActorExpressions_IfExpression_Condition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._condition.apply(type, path.slice(1), value);
          if (newValue === this._condition) {
            return this;
          }
          const copy = new ActorExpressions_IfExpression(this);
          copy._condition = copy._condition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "values": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IfExpression(this);
              copy._hasValues = true;
              copy._values = ActorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValues) {
                return this;
              }
              const copy = new ActorExpressions_IfExpression(this);
              copy._hasValues = false;
              copy._values = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValues) {
            const copy = new ActorExpressions_IfExpression(this);
            copy._hasValues = true;
            copy._values = ActorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._values.apply(type, path.slice(1), value);
          if (newValue === this._values) {
            return this;
          }
          const copy = new ActorExpressions_IfExpression(this);
          copy._values = copy._values.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_IfExpression} other
   * @returns {ActorExpressions_IfExpression}
   */
  merge(other) {
    const copy = new ActorExpressions_IfExpression(this);
    if (other._hasCondition) {
      if (copy._hasCondition) {
        copy._condition = copy.condition.merge(other.condition);
      } else {
        copy._condition = other._condition;
      }
      copy._hasCondition = true;
    }
    if (other._hasValues) {
      if (copy._hasValues) {
        copy._values = copy.values.merge(other.values);
      } else {
        copy._values = other._values;
      }
      copy._hasValues = true;
    }
    return copy;
  }
}
ActorExpressions_IfExpression.default = new ActorExpressions_IfExpression();
ActorExpressions_IfExpression.Condition = ActorExpressions_IfExpression_Condition;
class ActorExpressions_IfExpression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_IfExpression(value);
  }
  build() {
    return new ActorExpressions_IfExpression(this._value);
  }
  setCondition(value) {
    this._value._hasCondition = true;
    this._value._condition = value;
    return this;
  }
  deleteCondition() {
    this._value._hasCondition = false;
    this._value._condition = null;
    return this;
  }
  setValues(value) {
    this._value._hasValues = true;
    this._value._values = value;
    return this;
  }
  deleteValues() {
    this._value._hasValues = false;
    this._value._values = null;
    return this;
  }
}
ActorExpressions_IfExpression.Builder = ActorExpressions_IfExpression_Builder;
class ActorExpressions_IfExpression_WithParent {
  /**
   * @param {ActorExpressions_IfExpression} value
   * @param {ActorExpressions_IfExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_IfExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCondition() {
    if (this._cachedHasCondition === undefined) {
      if (this._value.hasCondition) {
        this._cachedHasCondition = true;
      } else {
        this._cachedHasCondition = this._parent ? this._parent.hasCondition : false;
      }
    }
    return this._cachedHasCondition;
  }
  get condition() {
    if (!this._cachedCondition) {
      if (this._value.hasCondition) {
        this._cachedCondition = new ActorExpressions_IfExpression_Condition.WithParent(this._value.condition, this._parent && this._parent.hasCondition ? this._parent.condition : null);
      } else {
        this._cachedCondition = this._parent ? new ActorExpressions_IfExpression_Condition.WithParent(ActorExpressions_IfExpression_Condition.default, this._parent.condition) : ActorExpressions_IfExpression_Condition.WithParent.default;
      }
    }
    return this._cachedCondition;
  }
  get hasValues() {
    if (this._cachedHasValues === undefined) {
      if (this._value.hasValues) {
        this._cachedHasValues = true;
      } else {
        this._cachedHasValues = this._parent ? this._parent.hasValues : false;
      }
    }
    return this._cachedHasValues;
  }
  get values() {
    if (!this._cachedValues) {
      if (this._value.hasValues) {
        this._cachedValues = new ActorExpressions_AddExpression.WithParent(this._value.values, this._parent && this._parent.hasValues ? this._parent.values : null);
      } else {
        this._cachedValues = this._parent ? new ActorExpressions_AddExpression.WithParent(ActorExpressions_AddExpression.default, this._parent.values) : ActorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedValues;
  }
  update(current, parent) {
    const result = new ActorExpressions_IfExpression_WithParent(current, parent);
    if (this._cachedCondition && this._value.hasCondition && current.hasCondition) {
      if (this._value.condition === current.condition && this._parent === parent) {
        result._cachedCondition = this._cachedCondition;
      } else {
        result._cachedCondition = this._cachedCondition.update(current.condition, parent && parent.hasCondition ? parent.condition : null);
      }
    }
    if (this._cachedValues && this._value.hasValues && current.hasValues) {
      if (this._value.values === current.values && this._parent === parent) {
        result._cachedValues = this._cachedValues;
      } else {
        result._cachedValues = this._cachedValues.update(current.values, parent && parent.hasValues ? parent.values : null);
      }
    }
    return result;
  }
}
ActorExpressions_IfExpression_WithParent.default = new ActorExpressions_IfExpression_WithParent(ActorExpressions_IfExpression.default, null);
ActorExpressions_IfExpression.WithParent = ActorExpressions_IfExpression_WithParent;
class ActorExpressions_IfExpression_Descriptor {
  get condition() {
    if (!this._condition) {
      this._condition = {
        name: "condition",
        Name: "Condition",
        number: 1,
        protoType: 11,
        protoName: "condition",
        type: ActorExpressions_IfExpression_Condition,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._condition;
  }
  get values() {
    if (!this._values) {
      this._values = {
        name: "values",
        Name: "Values",
        number: 2,
        protoType: 11,
        protoName: "values",
        type: ActorExpressions_AddExpression,
        options: {
          comments: "If the condition is true, return the sum of these expressions.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._values;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.condition,
        this.values,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCondition",
        Name: "DummyOneofForCondition",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValues",
        Name: "DummyOneofForValues",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_IfExpression.descriptor = new ActorExpressions_IfExpression_Descriptor();
class ActorExpressions_AreaSearchRadius {
  get descriptor() {
    return ActorExpressions_AreaSearchRadius.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_AreaSearchRadius) {
      return value;
    }
    return ActorExpressions_AreaSearchRadius.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_AreaSearchRadius();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_AreaSearchRadius} other
   * @returns {ActorExpressions_AreaSearchRadius}
   */
  merge(other) {
    const copy = new ActorExpressions_AreaSearchRadius(this);
    return copy;
  }
}
ActorExpressions_AreaSearchRadius.default = new ActorExpressions_AreaSearchRadius();
class ActorExpressions_AreaSearchRadius_Builder {
  constructor(value) {
    this._value = new ActorExpressions_AreaSearchRadius(value);
  }
  build() {
    return new ActorExpressions_AreaSearchRadius(this._value);
  }
}
ActorExpressions_AreaSearchRadius.Builder = ActorExpressions_AreaSearchRadius_Builder;
class ActorExpressions_AreaSearchRadius_WithParent {
  /**
   * @param {ActorExpressions_AreaSearchRadius} value
   * @param {ActorExpressions_AreaSearchRadius_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_AreaSearchRadius.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ActorExpressions_AreaSearchRadius_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_AreaSearchRadius_WithParent.default = new ActorExpressions_AreaSearchRadius_WithParent(ActorExpressions_AreaSearchRadius.default, null);
ActorExpressions_AreaSearchRadius.WithParent = ActorExpressions_AreaSearchRadius_WithParent;
class ActorExpressions_AreaSearchRadius_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_AreaSearchRadius.descriptor = new ActorExpressions_AreaSearchRadius_Descriptor();
class ActorExpressions_UnitTeamId {
  get descriptor() {
    return ActorExpressions_UnitTeamId.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_UnitTeamId) {
      return value;
    }
    return ActorExpressions_UnitTeamId.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_UnitTeamId();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_UnitTeamId} other
   * @returns {ActorExpressions_UnitTeamId}
   */
  merge(other) {
    const copy = new ActorExpressions_UnitTeamId(this);
    return copy;
  }
}
ActorExpressions_UnitTeamId.default = new ActorExpressions_UnitTeamId();
class ActorExpressions_UnitTeamId_Builder {
  constructor(value) {
    this._value = new ActorExpressions_UnitTeamId(value);
  }
  build() {
    return new ActorExpressions_UnitTeamId(this._value);
  }
}
ActorExpressions_UnitTeamId.Builder = ActorExpressions_UnitTeamId_Builder;
class ActorExpressions_UnitTeamId_WithParent {
  /**
   * @param {ActorExpressions_UnitTeamId} value
   * @param {ActorExpressions_UnitTeamId_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_UnitTeamId.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ActorExpressions_UnitTeamId_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_UnitTeamId_WithParent.default = new ActorExpressions_UnitTeamId_WithParent(ActorExpressions_UnitTeamId.default, null);
ActorExpressions_UnitTeamId.WithParent = ActorExpressions_UnitTeamId_WithParent;
class ActorExpressions_UnitTeamId_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_UnitTeamId.descriptor = new ActorExpressions_UnitTeamId_Descriptor();
class ActorExpressions_BehaviorStackCountValue {
  get descriptor() {
    return ActorExpressions_BehaviorStackCountValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehavior = false;
    this._behavior = null;
  }
  isEmpty() {
    if (this._hasBehavior) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_BehaviorStackCountValue) {
      return value;
    }
    return ActorExpressions_BehaviorStackCountValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_BehaviorStackCountValue();
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_BehaviorStackCountValue(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new ActorExpressions_BehaviorStackCountValue(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_BehaviorStackCountValue} other
   * @returns {ActorExpressions_BehaviorStackCountValue}
   */
  merge(other) {
    const copy = new ActorExpressions_BehaviorStackCountValue(this);
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    return copy;
  }
}
ActorExpressions_BehaviorStackCountValue.default = new ActorExpressions_BehaviorStackCountValue();
class ActorExpressions_BehaviorStackCountValue_Builder {
  constructor(value) {
    this._value = new ActorExpressions_BehaviorStackCountValue(value);
  }
  build() {
    return new ActorExpressions_BehaviorStackCountValue(this._value);
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
}
ActorExpressions_BehaviorStackCountValue.Builder = ActorExpressions_BehaviorStackCountValue_Builder;
class ActorExpressions_BehaviorStackCountValue_WithParent {
  /**
   * @param {ActorExpressions_BehaviorStackCountValue} value
   * @param {ActorExpressions_BehaviorStackCountValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_BehaviorStackCountValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  update(current, parent) {
    const result = new ActorExpressions_BehaviorStackCountValue_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_BehaviorStackCountValue_WithParent.default = new ActorExpressions_BehaviorStackCountValue_WithParent(ActorExpressions_BehaviorStackCountValue.default, null);
ActorExpressions_BehaviorStackCountValue.WithParent = ActorExpressions_BehaviorStackCountValue_WithParent;
class ActorExpressions_BehaviorStackCountValue_Descriptor {
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 1,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "Which behavior is evaluated.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behavior,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_BehaviorStackCountValue.descriptor = new ActorExpressions_BehaviorStackCountValue_Descriptor();
class ActorExpressions_UnitRadius {
  get descriptor() {
    return ActorExpressions_UnitRadius.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_UnitRadius) {
      return value;
    }
    return ActorExpressions_UnitRadius.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_UnitRadius();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_UnitRadius} other
   * @returns {ActorExpressions_UnitRadius}
   */
  merge(other) {
    const copy = new ActorExpressions_UnitRadius(this);
    return copy;
  }
}
ActorExpressions_UnitRadius.default = new ActorExpressions_UnitRadius();
class ActorExpressions_UnitRadius_Builder {
  constructor(value) {
    this._value = new ActorExpressions_UnitRadius(value);
  }
  build() {
    return new ActorExpressions_UnitRadius(this._value);
  }
}
ActorExpressions_UnitRadius.Builder = ActorExpressions_UnitRadius_Builder;
class ActorExpressions_UnitRadius_WithParent {
  /**
   * @param {ActorExpressions_UnitRadius} value
   * @param {ActorExpressions_UnitRadius_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_UnitRadius.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ActorExpressions_UnitRadius_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_UnitRadius_WithParent.default = new ActorExpressions_UnitRadius_WithParent(ActorExpressions_UnitRadius.default, null);
ActorExpressions_UnitRadius.WithParent = ActorExpressions_UnitRadius_WithParent;
class ActorExpressions_UnitRadius_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions_UnitRadius.descriptor = new ActorExpressions_UnitRadius_Descriptor();
class ActorExpressions_IscriticalHit {
  get descriptor() {
    return ActorExpressions_IscriticalHit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasNegate = false;
    this._negate = null;
  }
  isEmpty() {
    if (this._hasNegate) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_IscriticalHit) {
      return value;
    }
    return ActorExpressions_IscriticalHit.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_IscriticalHit();
    if (json.negate != null) {
      result._hasNegate = true;
      result._negate = JsonToBoolean.fromJson(json.negate);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasNegate) {
      result.negate = JsonToBoolean.toJson(this._negate);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get negate() {
    return this._hasNegate ? this._negate : JsonToBoolean.default;
  }
  get hasNegate() {
    return this._hasNegate;
  }
  setNegate(path, value) {
    return {type: 'SET', path: path.concat(['negate']), value};
  }
  deleteNegate(path) {
    return {type: 'DELETE', path: path.concat(['negate'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "negate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_IscriticalHit(this);
              copy._hasNegate = true;
              copy._negate = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNegate) {
                return this;
              }
              const copy = new ActorExpressions_IscriticalHit(this);
              copy._hasNegate = false;
              copy._negate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_IscriticalHit} other
   * @returns {ActorExpressions_IscriticalHit}
   */
  merge(other) {
    const copy = new ActorExpressions_IscriticalHit(this);
    if (other._hasNegate) {
      copy._hasNegate = true;
      copy._negate = other._negate;
    }
    return copy;
  }
}
ActorExpressions_IscriticalHit.default = new ActorExpressions_IscriticalHit();
class ActorExpressions_IscriticalHit_Builder {
  constructor(value) {
    this._value = new ActorExpressions_IscriticalHit(value);
  }
  build() {
    return new ActorExpressions_IscriticalHit(this._value);
  }
  setNegate(value) {
    this._value._hasNegate = true;
    this._value._negate = value;
    return this;
  }
  deleteNegate() {
    this._value._hasNegate = false;
    this._value._negate = null;
    return this;
  }
}
ActorExpressions_IscriticalHit.Builder = ActorExpressions_IscriticalHit_Builder;
class ActorExpressions_IscriticalHit_WithParent {
  /**
   * @param {ActorExpressions_IscriticalHit} value
   * @param {ActorExpressions_IscriticalHit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_IscriticalHit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasNegate() {
    if (this._cachedHasNegate === undefined) {
      if (this._value.hasNegate) {
        this._cachedHasNegate = true;
      } else {
        this._cachedHasNegate = this._parent ? this._parent.hasNegate : false;
      }
    }
    return this._cachedHasNegate;
  }
  get negate() {
    if (this._cachedNegate === undefined) {
      if (this._value.hasNegate) {
        this._cachedNegate = this._value.negate;
      } else {
        this._cachedNegate = this._parent ? this._parent.negate : this._value.negate;
      }
    }
    return this._cachedNegate;
  }
  update(current, parent) {
    const result = new ActorExpressions_IscriticalHit_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_IscriticalHit_WithParent.default = new ActorExpressions_IscriticalHit_WithParent(ActorExpressions_IscriticalHit.default, null);
ActorExpressions_IscriticalHit.WithParent = ActorExpressions_IscriticalHit_WithParent;
class ActorExpressions_IscriticalHit_Descriptor {
  get negate() {
    if (!this._negate) {
      this._negate = {
        name: "negate",
        Name: "Negate",
        number: 1,
        protoType: 8,
        protoName: "negate",
        type: JsonToBoolean,
        options: {
          comments: "If set to true, return true when it\'s NOT a critical hit",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._negate;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.negate,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForNegate",
        Name: "DummyOneofForNegate",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_IscriticalHit.descriptor = new ActorExpressions_IscriticalHit_Descriptor();
class ActorExpressions_ViewerHasAllianceType_AllianceType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PLAYER": return 0;
        case "ALLY": return 1;
        case "ENEMY": return 2;
        case "NEUTRAL": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ActorExpressions_ViewerHasAllianceType_AllianceType.fromJson(value);
  }
  static fromReact(e) {
    return ActorExpressions_ViewerHasAllianceType_AllianceType.fromJson(e);
  }
}
ActorExpressions_ViewerHasAllianceType_AllianceType.PLAYER = 0;
ActorExpressions_ViewerHasAllianceType_AllianceType.ALLY = 1;
ActorExpressions_ViewerHasAllianceType_AllianceType.ENEMY = 2;
ActorExpressions_ViewerHasAllianceType_AllianceType.NEUTRAL = 3;
ActorExpressions_ViewerHasAllianceType_AllianceType.default = 0;
ActorExpressions_ViewerHasAllianceType_AllianceType.values = {
  PLAYER: 0,
  ALLY: 1,
  ENEMY: 2,
  NEUTRAL: 3,
};
ActorExpressions_ViewerHasAllianceType_AllianceType.names = {
  0: "PLAYER",
  1: "ALLY",
  2: "ENEMY",
  3: "NEUTRAL",
};
class ActorExpressions_ViewerHasAllianceType {
  get descriptor() {
    return ActorExpressions_ViewerHasAllianceType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAllianceType = false;
    this._allianceType = null;
  }
  isEmpty() {
    if (this._hasAllianceType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_ViewerHasAllianceType) {
      return value;
    }
    return ActorExpressions_ViewerHasAllianceType.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_ViewerHasAllianceType();
    if (json.allianceType != null) {
      result._hasAllianceType = true;
      result._allianceType = ActorExpressions_ViewerHasAllianceType_AllianceType.fromJson(json.allianceType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAllianceType) {
      result.allianceType = ActorExpressions_ViewerHasAllianceType_AllianceType.toJson(this._allianceType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get allianceType() {
    return this._hasAllianceType ? this._allianceType : ActorExpressions_ViewerHasAllianceType_AllianceType.default;
  }
  get hasAllianceType() {
    return this._hasAllianceType;
  }
  setAllianceType(path, value) {
    return {type: 'SET', path: path.concat(['allianceType']), value};
  }
  deleteAllianceType(path) {
    return {type: 'DELETE', path: path.concat(['allianceType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "allianceType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_ViewerHasAllianceType(this);
              copy._hasAllianceType = true;
              copy._allianceType = ActorExpressions_ViewerHasAllianceType_AllianceType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAllianceType) {
                return this;
              }
              const copy = new ActorExpressions_ViewerHasAllianceType(this);
              copy._hasAllianceType = false;
              copy._allianceType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_ViewerHasAllianceType} other
   * @returns {ActorExpressions_ViewerHasAllianceType}
   */
  merge(other) {
    const copy = new ActorExpressions_ViewerHasAllianceType(this);
    if (other._hasAllianceType) {
      copy._hasAllianceType = true;
      copy._allianceType = other._allianceType;
    }
    return copy;
  }
}
ActorExpressions_ViewerHasAllianceType.default = new ActorExpressions_ViewerHasAllianceType();
ActorExpressions_ViewerHasAllianceType.AllianceType = ActorExpressions_ViewerHasAllianceType_AllianceType;
class ActorExpressions_ViewerHasAllianceType_Builder {
  constructor(value) {
    this._value = new ActorExpressions_ViewerHasAllianceType(value);
  }
  build() {
    return new ActorExpressions_ViewerHasAllianceType(this._value);
  }
  setAllianceType(value) {
    this._value._hasAllianceType = true;
    this._value._allianceType = value;
    return this;
  }
  deleteAllianceType() {
    this._value._hasAllianceType = false;
    this._value._allianceType = null;
    return this;
  }
}
ActorExpressions_ViewerHasAllianceType.Builder = ActorExpressions_ViewerHasAllianceType_Builder;
class ActorExpressions_ViewerHasAllianceType_WithParent {
  /**
   * @param {ActorExpressions_ViewerHasAllianceType} value
   * @param {ActorExpressions_ViewerHasAllianceType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_ViewerHasAllianceType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAllianceType() {
    if (this._cachedHasAllianceType === undefined) {
      if (this._value.hasAllianceType) {
        this._cachedHasAllianceType = true;
      } else {
        this._cachedHasAllianceType = this._parent ? this._parent.hasAllianceType : false;
      }
    }
    return this._cachedHasAllianceType;
  }
  get allianceType() {
    if (this._cachedAllianceType === undefined) {
      if (this._value.hasAllianceType) {
        this._cachedAllianceType = this._value.allianceType;
      } else {
        this._cachedAllianceType = this._parent ? this._parent.allianceType : this._value.allianceType;
      }
    }
    return this._cachedAllianceType;
  }
  update(current, parent) {
    const result = new ActorExpressions_ViewerHasAllianceType_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_ViewerHasAllianceType_WithParent.default = new ActorExpressions_ViewerHasAllianceType_WithParent(ActorExpressions_ViewerHasAllianceType.default, null);
ActorExpressions_ViewerHasAllianceType.WithParent = ActorExpressions_ViewerHasAllianceType_WithParent;
class ActorExpressions_ViewerHasAllianceType_Descriptor {
  get allianceType() {
    if (!this._allianceType) {
      this._allianceType = {
        name: "allianceType",
        Name: "AllianceType",
        number: 1,
        protoType: 14,
        protoName: "alliance_type",
        type: ActorExpressions_ViewerHasAllianceType_AllianceType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._allianceType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.allianceType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAllianceType",
        Name: "DummyOneofForAllianceType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_ViewerHasAllianceType.descriptor = new ActorExpressions_ViewerHasAllianceType_Descriptor();
class ActorExpressions_ViewerHasPlayerId {
  get descriptor() {
    return ActorExpressions_ViewerHasPlayerId.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerId = false;
    this._playerId = null;
  }
  isEmpty() {
    if (this._hasPlayerId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_ViewerHasPlayerId) {
      return value;
    }
    return ActorExpressions_ViewerHasPlayerId.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_ViewerHasPlayerId();
    if (json.playerId != null) {
      result._hasPlayerId = true;
      result._playerId = JsonToInt32.fromJson(json.playerId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerId) {
      result.playerId = JsonToInt32.toJson(this._playerId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get playerId() {
    return this._hasPlayerId ? this._playerId : JsonToInt32.default;
  }
  get hasPlayerId() {
    return this._hasPlayerId;
  }
  setPlayerId(path, value) {
    return {type: 'SET', path: path.concat(['playerId']), value};
  }
  deletePlayerId(path) {
    return {type: 'DELETE', path: path.concat(['playerId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_ViewerHasPlayerId(this);
              copy._hasPlayerId = true;
              copy._playerId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerId) {
                return this;
              }
              const copy = new ActorExpressions_ViewerHasPlayerId(this);
              copy._hasPlayerId = false;
              copy._playerId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_ViewerHasPlayerId} other
   * @returns {ActorExpressions_ViewerHasPlayerId}
   */
  merge(other) {
    const copy = new ActorExpressions_ViewerHasPlayerId(this);
    if (other._hasPlayerId) {
      copy._hasPlayerId = true;
      copy._playerId = other._playerId;
    }
    return copy;
  }
}
ActorExpressions_ViewerHasPlayerId.default = new ActorExpressions_ViewerHasPlayerId();
class ActorExpressions_ViewerHasPlayerId_Builder {
  constructor(value) {
    this._value = new ActorExpressions_ViewerHasPlayerId(value);
  }
  build() {
    return new ActorExpressions_ViewerHasPlayerId(this._value);
  }
  setPlayerId(value) {
    this._value._hasPlayerId = true;
    this._value._playerId = value;
    return this;
  }
  deletePlayerId() {
    this._value._hasPlayerId = false;
    this._value._playerId = null;
    return this;
  }
}
ActorExpressions_ViewerHasPlayerId.Builder = ActorExpressions_ViewerHasPlayerId_Builder;
class ActorExpressions_ViewerHasPlayerId_WithParent {
  /**
   * @param {ActorExpressions_ViewerHasPlayerId} value
   * @param {ActorExpressions_ViewerHasPlayerId_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_ViewerHasPlayerId.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerId() {
    if (this._cachedHasPlayerId === undefined) {
      if (this._value.hasPlayerId) {
        this._cachedHasPlayerId = true;
      } else {
        this._cachedHasPlayerId = this._parent ? this._parent.hasPlayerId : false;
      }
    }
    return this._cachedHasPlayerId;
  }
  get playerId() {
    if (this._cachedPlayerId === undefined) {
      if (this._value.hasPlayerId) {
        this._cachedPlayerId = this._value.playerId;
      } else {
        this._cachedPlayerId = this._parent ? this._parent.playerId : this._value.playerId;
      }
    }
    return this._cachedPlayerId;
  }
  update(current, parent) {
    const result = new ActorExpressions_ViewerHasPlayerId_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_ViewerHasPlayerId_WithParent.default = new ActorExpressions_ViewerHasPlayerId_WithParent(ActorExpressions_ViewerHasPlayerId.default, null);
ActorExpressions_ViewerHasPlayerId.WithParent = ActorExpressions_ViewerHasPlayerId_WithParent;
class ActorExpressions_ViewerHasPlayerId_Descriptor {
  get playerId() {
    if (!this._playerId) {
      this._playerId = {
        name: "playerId",
        Name: "PlayerId",
        number: 1,
        protoType: 5,
        protoName: "player_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerId",
        Name: "DummyOneofForPlayerId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_ViewerHasPlayerId.descriptor = new ActorExpressions_ViewerHasPlayerId_Descriptor();
class ActorExpressions_Expression {
  get descriptor() {
    return ActorExpressions_Expression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions_Expression) {
      return value;
    }
    return ActorExpressions_Expression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions_Expression();
    if (json.compare != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ActorExpressions_CompareExpression.fromJson(json.compare);
    }
    if (json.constant != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ActorExpressions_ConstantValue.fromJson(json.constant);
    }
    if (json.variable != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ActorExpressions_VariableValue.fromJson(json.variable);
    }
    if (json.add != null) {
      result._oneofTypeCase = 4;
      result._oneofTypeValue = ActorExpressions_AddExpression.fromJson(json.add);
    }
    if (json.if != null) {
      result._oneofTypeCase = 5;
      result._oneofTypeValue = ActorExpressions_IfExpression.fromJson(json.if);
    }
    if (json.randomInt != null) {
      result._oneofTypeCase = 6;
      result._oneofTypeValue = ActorExpressions_RandomIntValue.fromJson(json.randomInt);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 7;
      result._oneofTypeValue = ActorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 8;
      result._oneofTypeValue = ActorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    if (json.subtract != null) {
      result._oneofTypeCase = 9;
      result._oneofTypeValue = ActorExpressions_SubtractExpression.fromJson(json.subtract);
    }
    if (json.logicNot != null) {
      result._oneofTypeCase = 10;
      result._oneofTypeValue = ActorExpressions_LogicNotExpression.fromJson(json.logicNot);
    }
    if (json.logicAnd != null) {
      result._oneofTypeCase = 11;
      result._oneofTypeValue = ActorExpressions_LogicAndExpression.fromJson(json.logicAnd);
    }
    if (json.logicOr != null) {
      result._oneofTypeCase = 12;
      result._oneofTypeValue = ActorExpressions_LogicOrExpression.fromJson(json.logicOr);
    }
    if (json.areaSearchRadius != null) {
      result._oneofTypeCase = 21;
      result._oneofTypeValue = ActorExpressions_AreaSearchRadius.fromJson(json.areaSearchRadius);
    }
    if (json.unitWeaponRange != null) {
      result._oneofTypeCase = 22;
      result._oneofTypeValue = ActorExpressions_UnitWeaponRange.fromJson(json.unitWeaponRange);
    }
    if (json.unitAbilityRange != null) {
      result._oneofTypeCase = 23;
      result._oneofTypeValue = ActorExpressions_UnitAbilityRange.fromJson(json.unitAbilityRange);
    }
    if (json.unitTeamId != null) {
      result._oneofTypeCase = 24;
      result._oneofTypeValue = ActorExpressions_UnitTeamId.fromJson(json.unitTeamId);
    }
    if (json.behaviorStackCount != null) {
      result._oneofTypeCase = 25;
      result._oneofTypeValue = ActorExpressions_BehaviorStackCountValue.fromJson(json.behaviorStackCount);
    }
    if (json.unitRadius != null) {
      result._oneofTypeCase = 26;
      result._oneofTypeValue = ActorExpressions_UnitRadius.fromJson(json.unitRadius);
    }
    if (json.isCriticalHit != null) {
      result._oneofTypeCase = 27;
      result._oneofTypeValue = ActorExpressions_IscriticalHit.fromJson(json.isCriticalHit);
    }
    if (json.viewerHasAllianceType != null) {
      result._oneofTypeCase = 28;
      result._oneofTypeValue = ActorExpressions_ViewerHasAllianceType.fromJson(json.viewerHasAllianceType);
    }
    if (json.viewerHasPlayerId != null) {
      result._oneofTypeCase = 29;
      result._oneofTypeValue = ActorExpressions_ViewerHasPlayerId.fromJson(json.viewerHasPlayerId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.compare = ActorExpressions_CompareExpression.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.constant = ActorExpressions_ConstantValue.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.variable = ActorExpressions_VariableValue.toJson(this._oneofTypeValue);
        break;
      case 4:
        result.add = ActorExpressions_AddExpression.toJson(this._oneofTypeValue);
        break;
      case 5:
        result.if = ActorExpressions_IfExpression.toJson(this._oneofTypeValue);
        break;
      case 6:
        result.randomInt = ActorExpressions_RandomIntValue.toJson(this._oneofTypeValue);
        break;
      case 7:
        result.divide = ActorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 8:
        result.multiply = ActorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      case 9:
        result.subtract = ActorExpressions_SubtractExpression.toJson(this._oneofTypeValue);
        break;
      case 10:
        result.logicNot = ActorExpressions_LogicNotExpression.toJson(this._oneofTypeValue);
        break;
      case 11:
        result.logicAnd = ActorExpressions_LogicAndExpression.toJson(this._oneofTypeValue);
        break;
      case 12:
        result.logicOr = ActorExpressions_LogicOrExpression.toJson(this._oneofTypeValue);
        break;
      case 21:
        result.areaSearchRadius = ActorExpressions_AreaSearchRadius.toJson(this._oneofTypeValue);
        break;
      case 22:
        result.unitWeaponRange = ActorExpressions_UnitWeaponRange.toJson(this._oneofTypeValue);
        break;
      case 23:
        result.unitAbilityRange = ActorExpressions_UnitAbilityRange.toJson(this._oneofTypeValue);
        break;
      case 24:
        result.unitTeamId = ActorExpressions_UnitTeamId.toJson(this._oneofTypeValue);
        break;
      case 25:
        result.behaviorStackCount = ActorExpressions_BehaviorStackCountValue.toJson(this._oneofTypeValue);
        break;
      case 26:
        result.unitRadius = ActorExpressions_UnitRadius.toJson(this._oneofTypeValue);
        break;
      case 27:
        result.isCriticalHit = ActorExpressions_IscriticalHit.toJson(this._oneofTypeValue);
        break;
      case 28:
        result.viewerHasAllianceType = ActorExpressions_ViewerHasAllianceType.toJson(this._oneofTypeValue);
        break;
      case 29:
        result.viewerHasPlayerId = ActorExpressions_ViewerHasPlayerId.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['compare'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['constant'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['variable'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['if'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['randomInt'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['subtract'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['logicNot'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['logicAnd'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['logicOr'])};
      }
      case 21: {
        return {type: 'DELETE', path: path.concat(['areaSearchRadius'])};
      }
      case 22: {
        return {type: 'DELETE', path: path.concat(['unitWeaponRange'])};
      }
      case 23: {
        return {type: 'DELETE', path: path.concat(['unitAbilityRange'])};
      }
      case 24: {
        return {type: 'DELETE', path: path.concat(['unitTeamId'])};
      }
      case 25: {
        return {type: 'DELETE', path: path.concat(['behaviorStackCount'])};
      }
      case 26: {
        return {type: 'DELETE', path: path.concat(['unitRadius'])};
      }
      case 27: {
        return {type: 'DELETE', path: path.concat(['isCriticalHit'])};
      }
      case 28: {
        return {type: 'DELETE', path: path.concat(['viewerHasAllianceType'])};
      }
      case 29: {
        return {type: 'DELETE', path: path.concat(['viewerHasPlayerId'])};
      }
    }
  }
  /**
   * @returns {ActorExpressions_CompareExpression}
   */
  get compare() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ActorExpressions_CompareExpression.default;
  }
  setCompare(path, value) {
    return {type: 'SET', path: path.concat(['compare']), value: value.toJson()};
  }
  deleteCompare(path) {
    return {type: 'DELETE', path: path.concat(['compare'])};
  }
  /**
   * @returns {ActorExpressions_ConstantValue}
   */
  get constant() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ActorExpressions_ConstantValue.default;
  }
  setConstant(path, value) {
    return {type: 'SET', path: path.concat(['constant']), value: value.toJson()};
  }
  deleteConstant(path) {
    return {type: 'DELETE', path: path.concat(['constant'])};
  }
  /**
   * @returns {ActorExpressions_VariableValue}
   */
  get variable() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ActorExpressions_VariableValue.default;
  }
  setVariable(path, value) {
    return {type: 'SET', path: path.concat(['variable']), value: value.toJson()};
  }
  deleteVariable(path) {
    return {type: 'DELETE', path: path.concat(['variable'])};
  }
  /**
   * @returns {ActorExpressions_AddExpression}
   */
  get add() {
    return this._oneofTypeCase === 4 ? this._oneofTypeValue : ActorExpressions_AddExpression.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  /**
   * @returns {ActorExpressions_IfExpression}
   */
  get if() {
    return this._oneofTypeCase === 5 ? this._oneofTypeValue : ActorExpressions_IfExpression.default;
  }
  setIf(path, value) {
    return {type: 'SET', path: path.concat(['if']), value: value.toJson()};
  }
  deleteIf(path) {
    return {type: 'DELETE', path: path.concat(['if'])};
  }
  /**
   * @returns {ActorExpressions_RandomIntValue}
   */
  get randomInt() {
    return this._oneofTypeCase === 6 ? this._oneofTypeValue : ActorExpressions_RandomIntValue.default;
  }
  setRandomInt(path, value) {
    return {type: 'SET', path: path.concat(['randomInt']), value: value.toJson()};
  }
  deleteRandomInt(path) {
    return {type: 'DELETE', path: path.concat(['randomInt'])};
  }
  /**
   * @returns {ActorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 7 ? this._oneofTypeValue : ActorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ActorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 8 ? this._oneofTypeValue : ActorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  /**
   * @returns {ActorExpressions_SubtractExpression}
   */
  get subtract() {
    return this._oneofTypeCase === 9 ? this._oneofTypeValue : ActorExpressions_SubtractExpression.default;
  }
  setSubtract(path, value) {
    return {type: 'SET', path: path.concat(['subtract']), value: value.toJson()};
  }
  deleteSubtract(path) {
    return {type: 'DELETE', path: path.concat(['subtract'])};
  }
  /**
   * @returns {ActorExpressions_LogicNotExpression}
   */
  get logicNot() {
    return this._oneofTypeCase === 10 ? this._oneofTypeValue : ActorExpressions_LogicNotExpression.default;
  }
  setLogicNot(path, value) {
    return {type: 'SET', path: path.concat(['logicNot']), value: value.toJson()};
  }
  deleteLogicNot(path) {
    return {type: 'DELETE', path: path.concat(['logicNot'])};
  }
  /**
   * @returns {ActorExpressions_LogicAndExpression}
   */
  get logicAnd() {
    return this._oneofTypeCase === 11 ? this._oneofTypeValue : ActorExpressions_LogicAndExpression.default;
  }
  setLogicAnd(path, value) {
    return {type: 'SET', path: path.concat(['logicAnd']), value: value.toJson()};
  }
  deleteLogicAnd(path) {
    return {type: 'DELETE', path: path.concat(['logicAnd'])};
  }
  /**
   * @returns {ActorExpressions_LogicOrExpression}
   */
  get logicOr() {
    return this._oneofTypeCase === 12 ? this._oneofTypeValue : ActorExpressions_LogicOrExpression.default;
  }
  setLogicOr(path, value) {
    return {type: 'SET', path: path.concat(['logicOr']), value: value.toJson()};
  }
  deleteLogicOr(path) {
    return {type: 'DELETE', path: path.concat(['logicOr'])};
  }
  /**
   * @returns {ActorExpressions_AreaSearchRadius}
   */
  get areaSearchRadius() {
    return this._oneofTypeCase === 21 ? this._oneofTypeValue : ActorExpressions_AreaSearchRadius.default;
  }
  setAreaSearchRadius(path, value) {
    return {type: 'SET', path: path.concat(['areaSearchRadius']), value: value.toJson()};
  }
  deleteAreaSearchRadius(path) {
    return {type: 'DELETE', path: path.concat(['areaSearchRadius'])};
  }
  /**
   * @returns {ActorExpressions_UnitWeaponRange}
   */
  get unitWeaponRange() {
    return this._oneofTypeCase === 22 ? this._oneofTypeValue : ActorExpressions_UnitWeaponRange.default;
  }
  setUnitWeaponRange(path, value) {
    return {type: 'SET', path: path.concat(['unitWeaponRange']), value: value.toJson()};
  }
  deleteUnitWeaponRange(path) {
    return {type: 'DELETE', path: path.concat(['unitWeaponRange'])};
  }
  /**
   * @returns {ActorExpressions_UnitAbilityRange}
   */
  get unitAbilityRange() {
    return this._oneofTypeCase === 23 ? this._oneofTypeValue : ActorExpressions_UnitAbilityRange.default;
  }
  setUnitAbilityRange(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityRange']), value: value.toJson()};
  }
  deleteUnitAbilityRange(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityRange'])};
  }
  /**
   * @returns {ActorExpressions_UnitTeamId}
   */
  get unitTeamId() {
    return this._oneofTypeCase === 24 ? this._oneofTypeValue : ActorExpressions_UnitTeamId.default;
  }
  setUnitTeamId(path, value) {
    return {type: 'SET', path: path.concat(['unitTeamId']), value: value.toJson()};
  }
  deleteUnitTeamId(path) {
    return {type: 'DELETE', path: path.concat(['unitTeamId'])};
  }
  /**
   * @returns {ActorExpressions_BehaviorStackCountValue}
   */
  get behaviorStackCount() {
    return this._oneofTypeCase === 25 ? this._oneofTypeValue : ActorExpressions_BehaviorStackCountValue.default;
  }
  setBehaviorStackCount(path, value) {
    return {type: 'SET', path: path.concat(['behaviorStackCount']), value: value.toJson()};
  }
  deleteBehaviorStackCount(path) {
    return {type: 'DELETE', path: path.concat(['behaviorStackCount'])};
  }
  /**
   * @returns {ActorExpressions_UnitRadius}
   */
  get unitRadius() {
    return this._oneofTypeCase === 26 ? this._oneofTypeValue : ActorExpressions_UnitRadius.default;
  }
  setUnitRadius(path, value) {
    return {type: 'SET', path: path.concat(['unitRadius']), value: value.toJson()};
  }
  deleteUnitRadius(path) {
    return {type: 'DELETE', path: path.concat(['unitRadius'])};
  }
  /**
   * @returns {ActorExpressions_IscriticalHit}
   */
  get isCriticalHit() {
    return this._oneofTypeCase === 27 ? this._oneofTypeValue : ActorExpressions_IscriticalHit.default;
  }
  setIsCriticalHit(path, value) {
    return {type: 'SET', path: path.concat(['isCriticalHit']), value: value.toJson()};
  }
  deleteIsCriticalHit(path) {
    return {type: 'DELETE', path: path.concat(['isCriticalHit'])};
  }
  /**
   * @returns {ActorExpressions_ViewerHasAllianceType}
   */
  get viewerHasAllianceType() {
    return this._oneofTypeCase === 28 ? this._oneofTypeValue : ActorExpressions_ViewerHasAllianceType.default;
  }
  setViewerHasAllianceType(path, value) {
    return {type: 'SET', path: path.concat(['viewerHasAllianceType']), value: value.toJson()};
  }
  deleteViewerHasAllianceType(path) {
    return {type: 'DELETE', path: path.concat(['viewerHasAllianceType'])};
  }
  /**
   * @returns {ActorExpressions_ViewerHasPlayerId}
   */
  get viewerHasPlayerId() {
    return this._oneofTypeCase === 29 ? this._oneofTypeValue : ActorExpressions_ViewerHasPlayerId.default;
  }
  setViewerHasPlayerId(path, value) {
    return {type: 'SET', path: path.concat(['viewerHasPlayerId']), value: value.toJson()};
  }
  deleteViewerHasPlayerId(path) {
    return {type: 'DELETE', path: path.concat(['viewerHasPlayerId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "compare": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ActorExpressions_CompareExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ActorExpressions_CompareExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.compare.apply(type, path.slice(1), value);
          if (newValue === this.compare) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "constant": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ActorExpressions_ConstantValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ActorExpressions_ConstantValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.constant.apply(type, path.slice(1), value);
          if (newValue === this.constant) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "variable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ActorExpressions_VariableValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ActorExpressions_VariableValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.variable.apply(type, path.slice(1), value);
          if (newValue === this.variable) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 4;
              copy._oneofTypeValue = ActorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 4) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 4) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 4;
            copy._oneofTypeValue = ActorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 4;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "if": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 5;
              copy._oneofTypeValue = ActorExpressions_IfExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 5) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 5) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 5;
            copy._oneofTypeValue = ActorExpressions_IfExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.if.apply(type, path.slice(1), value);
          if (newValue === this.if) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 5;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "randomInt": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 6;
              copy._oneofTypeValue = ActorExpressions_RandomIntValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 6) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 6) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 6;
            copy._oneofTypeValue = ActorExpressions_RandomIntValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.randomInt.apply(type, path.slice(1), value);
          if (newValue === this.randomInt) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 6;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 7;
              copy._oneofTypeValue = ActorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 7) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 7) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 7;
            copy._oneofTypeValue = ActorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 7;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 8;
              copy._oneofTypeValue = ActorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 8) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 8) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 8;
            copy._oneofTypeValue = ActorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 8;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "subtract": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 9;
              copy._oneofTypeValue = ActorExpressions_SubtractExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 9) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 9) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 9;
            copy._oneofTypeValue = ActorExpressions_SubtractExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.subtract.apply(type, path.slice(1), value);
          if (newValue === this.subtract) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 9;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "logicNot": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 10;
              copy._oneofTypeValue = ActorExpressions_LogicNotExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 10) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 10) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 10;
            copy._oneofTypeValue = ActorExpressions_LogicNotExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicNot.apply(type, path.slice(1), value);
          if (newValue === this.logicNot) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 10;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "logicAnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 11;
              copy._oneofTypeValue = ActorExpressions_LogicAndExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 11) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 11) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 11;
            copy._oneofTypeValue = ActorExpressions_LogicAndExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicAnd.apply(type, path.slice(1), value);
          if (newValue === this.logicAnd) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 11;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "logicOr": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 12;
              copy._oneofTypeValue = ActorExpressions_LogicOrExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 12) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 12) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 12;
            copy._oneofTypeValue = ActorExpressions_LogicOrExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicOr.apply(type, path.slice(1), value);
          if (newValue === this.logicOr) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 12;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "areaSearchRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 21;
              copy._oneofTypeValue = ActorExpressions_AreaSearchRadius.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 21) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 21) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 21;
            copy._oneofTypeValue = ActorExpressions_AreaSearchRadius.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.areaSearchRadius.apply(type, path.slice(1), value);
          if (newValue === this.areaSearchRadius) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 21;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "unitWeaponRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 22;
              copy._oneofTypeValue = ActorExpressions_UnitWeaponRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 22) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 22) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 22;
            copy._oneofTypeValue = ActorExpressions_UnitWeaponRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWeaponRange.apply(type, path.slice(1), value);
          if (newValue === this.unitWeaponRange) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 22;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 23;
              copy._oneofTypeValue = ActorExpressions_UnitAbilityRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 23) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 23) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 23;
            copy._oneofTypeValue = ActorExpressions_UnitAbilityRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityRange.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityRange) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 23;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "unitTeamId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 24;
              copy._oneofTypeValue = ActorExpressions_UnitTeamId.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 24) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 24) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 24;
            copy._oneofTypeValue = ActorExpressions_UnitTeamId.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitTeamId.apply(type, path.slice(1), value);
          if (newValue === this.unitTeamId) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 24;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "behaviorStackCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 25;
              copy._oneofTypeValue = ActorExpressions_BehaviorStackCountValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 25) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 25) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 25;
            copy._oneofTypeValue = ActorExpressions_BehaviorStackCountValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.behaviorStackCount.apply(type, path.slice(1), value);
          if (newValue === this.behaviorStackCount) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 25;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "unitRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 26;
              copy._oneofTypeValue = ActorExpressions_UnitRadius.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 26) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 26) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 26;
            copy._oneofTypeValue = ActorExpressions_UnitRadius.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitRadius.apply(type, path.slice(1), value);
          if (newValue === this.unitRadius) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 26;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "isCriticalHit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 27;
              copy._oneofTypeValue = ActorExpressions_IscriticalHit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 27) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 27) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 27;
            copy._oneofTypeValue = ActorExpressions_IscriticalHit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.isCriticalHit.apply(type, path.slice(1), value);
          if (newValue === this.isCriticalHit) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 27;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "viewerHasAllianceType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 28;
              copy._oneofTypeValue = ActorExpressions_ViewerHasAllianceType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 28) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 28) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 28;
            copy._oneofTypeValue = ActorExpressions_ViewerHasAllianceType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.viewerHasAllianceType.apply(type, path.slice(1), value);
          if (newValue === this.viewerHasAllianceType) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 28;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "viewerHasPlayerId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 29;
              copy._oneofTypeValue = ActorExpressions_ViewerHasPlayerId.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 29) {
                return this;
              }
              const copy = new ActorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 29) {
            const copy = new ActorExpressions_Expression(this);
            copy._oneofTypeCase = 29;
            copy._oneofTypeValue = ActorExpressions_ViewerHasPlayerId.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.viewerHasPlayerId.apply(type, path.slice(1), value);
          if (newValue === this.viewerHasPlayerId) {
            return this;
          }
          const copy = new ActorExpressions_Expression(this);
          copy._oneofTypeCase = 29;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions_Expression} other
   * @returns {ActorExpressions_Expression}
   */
  merge(other) {
    const copy = new ActorExpressions_Expression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    return copy;
  }
}
ActorExpressions_Expression.default = new ActorExpressions_Expression();
class ActorExpressions_Expression_Builder {
  constructor(value) {
    this._value = new ActorExpressions_Expression(value);
  }
  build() {
    return new ActorExpressions_Expression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setCompare(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setConstant(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setVariable(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
  setAdd(value) {
    this._value._oneofTypeCase = 4;
    this._value._oneofTypeValue = value;
    return this;
  }
  setIf(value) {
    this._value._oneofTypeCase = 5;
    this._value._oneofTypeValue = value;
    return this;
  }
  setRandomInt(value) {
    this._value._oneofTypeCase = 6;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 7;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 8;
    this._value._oneofTypeValue = value;
    return this;
  }
  setSubtract(value) {
    this._value._oneofTypeCase = 9;
    this._value._oneofTypeValue = value;
    return this;
  }
  setLogicNot(value) {
    this._value._oneofTypeCase = 10;
    this._value._oneofTypeValue = value;
    return this;
  }
  setLogicAnd(value) {
    this._value._oneofTypeCase = 11;
    this._value._oneofTypeValue = value;
    return this;
  }
  setLogicOr(value) {
    this._value._oneofTypeCase = 12;
    this._value._oneofTypeValue = value;
    return this;
  }
  setAreaSearchRadius(value) {
    this._value._oneofTypeCase = 21;
    this._value._oneofTypeValue = value;
    return this;
  }
  setUnitWeaponRange(value) {
    this._value._oneofTypeCase = 22;
    this._value._oneofTypeValue = value;
    return this;
  }
  setUnitAbilityRange(value) {
    this._value._oneofTypeCase = 23;
    this._value._oneofTypeValue = value;
    return this;
  }
  setUnitTeamId(value) {
    this._value._oneofTypeCase = 24;
    this._value._oneofTypeValue = value;
    return this;
  }
  setBehaviorStackCount(value) {
    this._value._oneofTypeCase = 25;
    this._value._oneofTypeValue = value;
    return this;
  }
  setUnitRadius(value) {
    this._value._oneofTypeCase = 26;
    this._value._oneofTypeValue = value;
    return this;
  }
  setIsCriticalHit(value) {
    this._value._oneofTypeCase = 27;
    this._value._oneofTypeValue = value;
    return this;
  }
  setViewerHasAllianceType(value) {
    this._value._oneofTypeCase = 28;
    this._value._oneofTypeValue = value;
    return this;
  }
  setViewerHasPlayerId(value) {
    this._value._oneofTypeCase = 29;
    this._value._oneofTypeValue = value;
    return this;
  }
}
ActorExpressions_Expression.Builder = ActorExpressions_Expression_Builder;
class ActorExpressions_Expression_WithParent {
  /**
   * @param {ActorExpressions_Expression} value
   * @param {ActorExpressions_Expression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions_Expression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get compare() {
    if (!this._cachedCompare) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedCompare = this._parent ? new ActorExpressions_CompareExpression.WithParent(ActorExpressions_CompareExpression.default, this._parent.compare) : this._value.compare;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedCompare = new ActorExpressions_CompareExpression.WithParent(this._value.compare, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.compare : null);
      } else {
        this._cachedCompare = ActorExpressions_CompareExpression.WithParent.default;
      }
    }
    return this._cachedCompare;
  }
  get constant() {
    if (!this._cachedConstant) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedConstant = this._parent ? new ActorExpressions_ConstantValue.WithParent(ActorExpressions_ConstantValue.default, this._parent.constant) : this._value.constant;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedConstant = new ActorExpressions_ConstantValue.WithParent(this._value.constant, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.constant : null);
      } else {
        this._cachedConstant = ActorExpressions_ConstantValue.WithParent.default;
      }
    }
    return this._cachedConstant;
  }
  get variable() {
    if (!this._cachedVariable) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedVariable = this._parent ? new ActorExpressions_VariableValue.WithParent(ActorExpressions_VariableValue.default, this._parent.variable) : this._value.variable;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedVariable = new ActorExpressions_VariableValue.WithParent(this._value.variable, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.variable : null);
      } else {
        this._cachedVariable = ActorExpressions_VariableValue.WithParent.default;
      }
    }
    return this._cachedVariable;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedAdd = this._parent ? new ActorExpressions_AddExpression.WithParent(ActorExpressions_AddExpression.default, this._parent.add) : this._value.add;
      } else if (this._value._oneofTypeCase === 4) {
        this._cachedAdd = new ActorExpressions_AddExpression.WithParent(this._value.add, this._parent && this._parent.oneofTypeCase === 4 ? this._parent.add : null);
      } else {
        this._cachedAdd = ActorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  get if() {
    if (!this._cachedIf) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedIf = this._parent ? new ActorExpressions_IfExpression.WithParent(ActorExpressions_IfExpression.default, this._parent.if) : this._value.if;
      } else if (this._value._oneofTypeCase === 5) {
        this._cachedIf = new ActorExpressions_IfExpression.WithParent(this._value.if, this._parent && this._parent.oneofTypeCase === 5 ? this._parent.if : null);
      } else {
        this._cachedIf = ActorExpressions_IfExpression.WithParent.default;
      }
    }
    return this._cachedIf;
  }
  get randomInt() {
    if (!this._cachedRandomInt) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedRandomInt = this._parent ? new ActorExpressions_RandomIntValue.WithParent(ActorExpressions_RandomIntValue.default, this._parent.randomInt) : this._value.randomInt;
      } else if (this._value._oneofTypeCase === 6) {
        this._cachedRandomInt = new ActorExpressions_RandomIntValue.WithParent(this._value.randomInt, this._parent && this._parent.oneofTypeCase === 6 ? this._parent.randomInt : null);
      } else {
        this._cachedRandomInt = ActorExpressions_RandomIntValue.WithParent.default;
      }
    }
    return this._cachedRandomInt;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ActorExpressions_DivideExpression.WithParent(ActorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 7) {
        this._cachedDivide = new ActorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 7 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ActorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ActorExpressions_MultiplyExpression.WithParent(ActorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 8) {
        this._cachedMultiply = new ActorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 8 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ActorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  get subtract() {
    if (!this._cachedSubtract) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedSubtract = this._parent ? new ActorExpressions_SubtractExpression.WithParent(ActorExpressions_SubtractExpression.default, this._parent.subtract) : this._value.subtract;
      } else if (this._value._oneofTypeCase === 9) {
        this._cachedSubtract = new ActorExpressions_SubtractExpression.WithParent(this._value.subtract, this._parent && this._parent.oneofTypeCase === 9 ? this._parent.subtract : null);
      } else {
        this._cachedSubtract = ActorExpressions_SubtractExpression.WithParent.default;
      }
    }
    return this._cachedSubtract;
  }
  get logicNot() {
    if (!this._cachedLogicNot) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedLogicNot = this._parent ? new ActorExpressions_LogicNotExpression.WithParent(ActorExpressions_LogicNotExpression.default, this._parent.logicNot) : this._value.logicNot;
      } else if (this._value._oneofTypeCase === 10) {
        this._cachedLogicNot = new ActorExpressions_LogicNotExpression.WithParent(this._value.logicNot, this._parent && this._parent.oneofTypeCase === 10 ? this._parent.logicNot : null);
      } else {
        this._cachedLogicNot = ActorExpressions_LogicNotExpression.WithParent.default;
      }
    }
    return this._cachedLogicNot;
  }
  get logicAnd() {
    if (!this._cachedLogicAnd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedLogicAnd = this._parent ? new ActorExpressions_LogicAndExpression.WithParent(ActorExpressions_LogicAndExpression.default, this._parent.logicAnd) : this._value.logicAnd;
      } else if (this._value._oneofTypeCase === 11) {
        this._cachedLogicAnd = new ActorExpressions_LogicAndExpression.WithParent(this._value.logicAnd, this._parent && this._parent.oneofTypeCase === 11 ? this._parent.logicAnd : null);
      } else {
        this._cachedLogicAnd = ActorExpressions_LogicAndExpression.WithParent.default;
      }
    }
    return this._cachedLogicAnd;
  }
  get logicOr() {
    if (!this._cachedLogicOr) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedLogicOr = this._parent ? new ActorExpressions_LogicOrExpression.WithParent(ActorExpressions_LogicOrExpression.default, this._parent.logicOr) : this._value.logicOr;
      } else if (this._value._oneofTypeCase === 12) {
        this._cachedLogicOr = new ActorExpressions_LogicOrExpression.WithParent(this._value.logicOr, this._parent && this._parent.oneofTypeCase === 12 ? this._parent.logicOr : null);
      } else {
        this._cachedLogicOr = ActorExpressions_LogicOrExpression.WithParent.default;
      }
    }
    return this._cachedLogicOr;
  }
  get areaSearchRadius() {
    if (!this._cachedAreaSearchRadius) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedAreaSearchRadius = this._parent ? new ActorExpressions_AreaSearchRadius.WithParent(ActorExpressions_AreaSearchRadius.default, this._parent.areaSearchRadius) : this._value.areaSearchRadius;
      } else if (this._value._oneofTypeCase === 21) {
        this._cachedAreaSearchRadius = new ActorExpressions_AreaSearchRadius.WithParent(this._value.areaSearchRadius, this._parent && this._parent.oneofTypeCase === 21 ? this._parent.areaSearchRadius : null);
      } else {
        this._cachedAreaSearchRadius = ActorExpressions_AreaSearchRadius.WithParent.default;
      }
    }
    return this._cachedAreaSearchRadius;
  }
  get unitWeaponRange() {
    if (!this._cachedUnitWeaponRange) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedUnitWeaponRange = this._parent ? new ActorExpressions_UnitWeaponRange.WithParent(ActorExpressions_UnitWeaponRange.default, this._parent.unitWeaponRange) : this._value.unitWeaponRange;
      } else if (this._value._oneofTypeCase === 22) {
        this._cachedUnitWeaponRange = new ActorExpressions_UnitWeaponRange.WithParent(this._value.unitWeaponRange, this._parent && this._parent.oneofTypeCase === 22 ? this._parent.unitWeaponRange : null);
      } else {
        this._cachedUnitWeaponRange = ActorExpressions_UnitWeaponRange.WithParent.default;
      }
    }
    return this._cachedUnitWeaponRange;
  }
  get unitAbilityRange() {
    if (!this._cachedUnitAbilityRange) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedUnitAbilityRange = this._parent ? new ActorExpressions_UnitAbilityRange.WithParent(ActorExpressions_UnitAbilityRange.default, this._parent.unitAbilityRange) : this._value.unitAbilityRange;
      } else if (this._value._oneofTypeCase === 23) {
        this._cachedUnitAbilityRange = new ActorExpressions_UnitAbilityRange.WithParent(this._value.unitAbilityRange, this._parent && this._parent.oneofTypeCase === 23 ? this._parent.unitAbilityRange : null);
      } else {
        this._cachedUnitAbilityRange = ActorExpressions_UnitAbilityRange.WithParent.default;
      }
    }
    return this._cachedUnitAbilityRange;
  }
  get unitTeamId() {
    if (!this._cachedUnitTeamId) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedUnitTeamId = this._parent ? new ActorExpressions_UnitTeamId.WithParent(ActorExpressions_UnitTeamId.default, this._parent.unitTeamId) : this._value.unitTeamId;
      } else if (this._value._oneofTypeCase === 24) {
        this._cachedUnitTeamId = new ActorExpressions_UnitTeamId.WithParent(this._value.unitTeamId, this._parent && this._parent.oneofTypeCase === 24 ? this._parent.unitTeamId : null);
      } else {
        this._cachedUnitTeamId = ActorExpressions_UnitTeamId.WithParent.default;
      }
    }
    return this._cachedUnitTeamId;
  }
  get behaviorStackCount() {
    if (!this._cachedBehaviorStackCount) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedBehaviorStackCount = this._parent ? new ActorExpressions_BehaviorStackCountValue.WithParent(ActorExpressions_BehaviorStackCountValue.default, this._parent.behaviorStackCount) : this._value.behaviorStackCount;
      } else if (this._value._oneofTypeCase === 25) {
        this._cachedBehaviorStackCount = new ActorExpressions_BehaviorStackCountValue.WithParent(this._value.behaviorStackCount, this._parent && this._parent.oneofTypeCase === 25 ? this._parent.behaviorStackCount : null);
      } else {
        this._cachedBehaviorStackCount = ActorExpressions_BehaviorStackCountValue.WithParent.default;
      }
    }
    return this._cachedBehaviorStackCount;
  }
  get unitRadius() {
    if (!this._cachedUnitRadius) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedUnitRadius = this._parent ? new ActorExpressions_UnitRadius.WithParent(ActorExpressions_UnitRadius.default, this._parent.unitRadius) : this._value.unitRadius;
      } else if (this._value._oneofTypeCase === 26) {
        this._cachedUnitRadius = new ActorExpressions_UnitRadius.WithParent(this._value.unitRadius, this._parent && this._parent.oneofTypeCase === 26 ? this._parent.unitRadius : null);
      } else {
        this._cachedUnitRadius = ActorExpressions_UnitRadius.WithParent.default;
      }
    }
    return this._cachedUnitRadius;
  }
  get isCriticalHit() {
    if (!this._cachedIsCriticalHit) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedIsCriticalHit = this._parent ? new ActorExpressions_IscriticalHit.WithParent(ActorExpressions_IscriticalHit.default, this._parent.isCriticalHit) : this._value.isCriticalHit;
      } else if (this._value._oneofTypeCase === 27) {
        this._cachedIsCriticalHit = new ActorExpressions_IscriticalHit.WithParent(this._value.isCriticalHit, this._parent && this._parent.oneofTypeCase === 27 ? this._parent.isCriticalHit : null);
      } else {
        this._cachedIsCriticalHit = ActorExpressions_IscriticalHit.WithParent.default;
      }
    }
    return this._cachedIsCriticalHit;
  }
  get viewerHasAllianceType() {
    if (!this._cachedViewerHasAllianceType) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedViewerHasAllianceType = this._parent ? new ActorExpressions_ViewerHasAllianceType.WithParent(ActorExpressions_ViewerHasAllianceType.default, this._parent.viewerHasAllianceType) : this._value.viewerHasAllianceType;
      } else if (this._value._oneofTypeCase === 28) {
        this._cachedViewerHasAllianceType = new ActorExpressions_ViewerHasAllianceType.WithParent(this._value.viewerHasAllianceType, this._parent && this._parent.oneofTypeCase === 28 ? this._parent.viewerHasAllianceType : null);
      } else {
        this._cachedViewerHasAllianceType = ActorExpressions_ViewerHasAllianceType.WithParent.default;
      }
    }
    return this._cachedViewerHasAllianceType;
  }
  get viewerHasPlayerId() {
    if (!this._cachedViewerHasPlayerId) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedViewerHasPlayerId = this._parent ? new ActorExpressions_ViewerHasPlayerId.WithParent(ActorExpressions_ViewerHasPlayerId.default, this._parent.viewerHasPlayerId) : this._value.viewerHasPlayerId;
      } else if (this._value._oneofTypeCase === 29) {
        this._cachedViewerHasPlayerId = new ActorExpressions_ViewerHasPlayerId.WithParent(this._value.viewerHasPlayerId, this._parent && this._parent.oneofTypeCase === 29 ? this._parent.viewerHasPlayerId : null);
      } else {
        this._cachedViewerHasPlayerId = ActorExpressions_ViewerHasPlayerId.WithParent.default;
      }
    }
    return this._cachedViewerHasPlayerId;
  }
  update(current, parent) {
    const result = new ActorExpressions_Expression_WithParent(current, parent);
    if (this._cachedCompare && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.compare === current.compare && this._parent === parent) {
        result._cachedCompare = this._cachedCompare;
      } else {
        result._cachedCompare = this._cachedCompare.update(current.compare, parent && parent.oneofTypeCase === 1 ? parent.compare : null);
      }
    }
    if (this._cachedConstant && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.constant === current.constant && this._parent === parent) {
        result._cachedConstant = this._cachedConstant;
      } else {
        result._cachedConstant = this._cachedConstant.update(current.constant, parent && parent.oneofTypeCase === 2 ? parent.constant : null);
      }
    }
    if (this._cachedVariable && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.variable === current.variable && this._parent === parent) {
        result._cachedVariable = this._cachedVariable;
      } else {
        result._cachedVariable = this._cachedVariable.update(current.variable, parent && parent.oneofTypeCase === 3 ? parent.variable : null);
      }
    }
    if (this._cachedAdd && this._value._oneofTypeCase === 4 && current._oneofTypeCase === 4) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.oneofTypeCase === 4 ? parent.add : null);
      }
    }
    if (this._cachedIf && this._value._oneofTypeCase === 5 && current._oneofTypeCase === 5) {
      if (this._value.if === current.if && this._parent === parent) {
        result._cachedIf = this._cachedIf;
      } else {
        result._cachedIf = this._cachedIf.update(current.if, parent && parent.oneofTypeCase === 5 ? parent.if : null);
      }
    }
    if (this._cachedRandomInt && this._value._oneofTypeCase === 6 && current._oneofTypeCase === 6) {
      if (this._value.randomInt === current.randomInt && this._parent === parent) {
        result._cachedRandomInt = this._cachedRandomInt;
      } else {
        result._cachedRandomInt = this._cachedRandomInt.update(current.randomInt, parent && parent.oneofTypeCase === 6 ? parent.randomInt : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 7 && current._oneofTypeCase === 7) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 7 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 8 && current._oneofTypeCase === 8) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 8 ? parent.multiply : null);
      }
    }
    if (this._cachedSubtract && this._value._oneofTypeCase === 9 && current._oneofTypeCase === 9) {
      if (this._value.subtract === current.subtract && this._parent === parent) {
        result._cachedSubtract = this._cachedSubtract;
      } else {
        result._cachedSubtract = this._cachedSubtract.update(current.subtract, parent && parent.oneofTypeCase === 9 ? parent.subtract : null);
      }
    }
    if (this._cachedLogicNot && this._value._oneofTypeCase === 10 && current._oneofTypeCase === 10) {
      if (this._value.logicNot === current.logicNot && this._parent === parent) {
        result._cachedLogicNot = this._cachedLogicNot;
      } else {
        result._cachedLogicNot = this._cachedLogicNot.update(current.logicNot, parent && parent.oneofTypeCase === 10 ? parent.logicNot : null);
      }
    }
    if (this._cachedLogicAnd && this._value._oneofTypeCase === 11 && current._oneofTypeCase === 11) {
      if (this._value.logicAnd === current.logicAnd && this._parent === parent) {
        result._cachedLogicAnd = this._cachedLogicAnd;
      } else {
        result._cachedLogicAnd = this._cachedLogicAnd.update(current.logicAnd, parent && parent.oneofTypeCase === 11 ? parent.logicAnd : null);
      }
    }
    if (this._cachedLogicOr && this._value._oneofTypeCase === 12 && current._oneofTypeCase === 12) {
      if (this._value.logicOr === current.logicOr && this._parent === parent) {
        result._cachedLogicOr = this._cachedLogicOr;
      } else {
        result._cachedLogicOr = this._cachedLogicOr.update(current.logicOr, parent && parent.oneofTypeCase === 12 ? parent.logicOr : null);
      }
    }
    if (this._cachedAreaSearchRadius && this._value._oneofTypeCase === 21 && current._oneofTypeCase === 21) {
      if (this._value.areaSearchRadius === current.areaSearchRadius && this._parent === parent) {
        result._cachedAreaSearchRadius = this._cachedAreaSearchRadius;
      } else {
        result._cachedAreaSearchRadius = this._cachedAreaSearchRadius.update(current.areaSearchRadius, parent && parent.oneofTypeCase === 21 ? parent.areaSearchRadius : null);
      }
    }
    if (this._cachedUnitWeaponRange && this._value._oneofTypeCase === 22 && current._oneofTypeCase === 22) {
      if (this._value.unitWeaponRange === current.unitWeaponRange && this._parent === parent) {
        result._cachedUnitWeaponRange = this._cachedUnitWeaponRange;
      } else {
        result._cachedUnitWeaponRange = this._cachedUnitWeaponRange.update(current.unitWeaponRange, parent && parent.oneofTypeCase === 22 ? parent.unitWeaponRange : null);
      }
    }
    if (this._cachedUnitAbilityRange && this._value._oneofTypeCase === 23 && current._oneofTypeCase === 23) {
      if (this._value.unitAbilityRange === current.unitAbilityRange && this._parent === parent) {
        result._cachedUnitAbilityRange = this._cachedUnitAbilityRange;
      } else {
        result._cachedUnitAbilityRange = this._cachedUnitAbilityRange.update(current.unitAbilityRange, parent && parent.oneofTypeCase === 23 ? parent.unitAbilityRange : null);
      }
    }
    if (this._cachedUnitTeamId && this._value._oneofTypeCase === 24 && current._oneofTypeCase === 24) {
      if (this._value.unitTeamId === current.unitTeamId && this._parent === parent) {
        result._cachedUnitTeamId = this._cachedUnitTeamId;
      } else {
        result._cachedUnitTeamId = this._cachedUnitTeamId.update(current.unitTeamId, parent && parent.oneofTypeCase === 24 ? parent.unitTeamId : null);
      }
    }
    if (this._cachedBehaviorStackCount && this._value._oneofTypeCase === 25 && current._oneofTypeCase === 25) {
      if (this._value.behaviorStackCount === current.behaviorStackCount && this._parent === parent) {
        result._cachedBehaviorStackCount = this._cachedBehaviorStackCount;
      } else {
        result._cachedBehaviorStackCount = this._cachedBehaviorStackCount.update(current.behaviorStackCount, parent && parent.oneofTypeCase === 25 ? parent.behaviorStackCount : null);
      }
    }
    if (this._cachedUnitRadius && this._value._oneofTypeCase === 26 && current._oneofTypeCase === 26) {
      if (this._value.unitRadius === current.unitRadius && this._parent === parent) {
        result._cachedUnitRadius = this._cachedUnitRadius;
      } else {
        result._cachedUnitRadius = this._cachedUnitRadius.update(current.unitRadius, parent && parent.oneofTypeCase === 26 ? parent.unitRadius : null);
      }
    }
    if (this._cachedIsCriticalHit && this._value._oneofTypeCase === 27 && current._oneofTypeCase === 27) {
      if (this._value.isCriticalHit === current.isCriticalHit && this._parent === parent) {
        result._cachedIsCriticalHit = this._cachedIsCriticalHit;
      } else {
        result._cachedIsCriticalHit = this._cachedIsCriticalHit.update(current.isCriticalHit, parent && parent.oneofTypeCase === 27 ? parent.isCriticalHit : null);
      }
    }
    if (this._cachedViewerHasAllianceType && this._value._oneofTypeCase === 28 && current._oneofTypeCase === 28) {
      if (this._value.viewerHasAllianceType === current.viewerHasAllianceType && this._parent === parent) {
        result._cachedViewerHasAllianceType = this._cachedViewerHasAllianceType;
      } else {
        result._cachedViewerHasAllianceType = this._cachedViewerHasAllianceType.update(current.viewerHasAllianceType, parent && parent.oneofTypeCase === 28 ? parent.viewerHasAllianceType : null);
      }
    }
    if (this._cachedViewerHasPlayerId && this._value._oneofTypeCase === 29 && current._oneofTypeCase === 29) {
      if (this._value.viewerHasPlayerId === current.viewerHasPlayerId && this._parent === parent) {
        result._cachedViewerHasPlayerId = this._cachedViewerHasPlayerId;
      } else {
        result._cachedViewerHasPlayerId = this._cachedViewerHasPlayerId.update(current.viewerHasPlayerId, parent && parent.oneofTypeCase === 29 ? parent.viewerHasPlayerId : null);
      }
    }
    return result;
  }
}
ActorExpressions_Expression_WithParent.default = new ActorExpressions_Expression_WithParent(ActorExpressions_Expression.default, null);
ActorExpressions_Expression.WithParent = ActorExpressions_Expression_WithParent;
class ActorExpressions_Expression_Descriptor {
  get compare() {
    if (!this._compare) {
      this._compare = {
        name: "compare",
        Name: "Compare",
        number: 1,
        protoType: 11,
        protoName: "compare",
        oneofIndex: 0,
        type: ActorExpressions_CompareExpression,
        options: {
          comments: "Compares two values/expressions and returns true or false based on the result.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._compare;
  }
  get constant() {
    if (!this._constant) {
      this._constant = {
        name: "constant",
        Name: "Constant",
        number: 2,
        protoType: 11,
        protoName: "constant",
        oneofIndex: 0,
        type: ActorExpressions_ConstantValue,
        options: {
          comments: "Returns the given integer. Useful for comparing to other values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._constant;
  }
  get variable() {
    if (!this._variable) {
      this._variable = {
        name: "variable",
        Name: "Variable",
        number: 3,
        protoType: 11,
        protoName: "variable",
        oneofIndex: 0,
        type: ActorExpressions_VariableValue,
        options: {
          comments: "Returns the given variable. Variables are set with the **Set Variable** actor action.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._variable;
  }
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 4,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ActorExpressions_AddExpression,
        options: {
          comments: "Returns the sum of the listed expressions.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get if() {
    if (!this._if) {
      this._if = {
        name: "if",
        Name: "If",
        number: 5,
        protoType: 11,
        protoName: "if",
        oneofIndex: 0,
        type: ActorExpressions_IfExpression,
        options: {
          comments: "Returns the result of the evaluated expression if the condition is true. Otherwise returns false.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._if;
  }
  get randomInt() {
    if (!this._randomInt) {
      this._randomInt = {
        name: "randomInt",
        Name: "RandomInt",
        number: 6,
        protoType: 11,
        protoName: "random_int",
        oneofIndex: 0,
        type: ActorExpressions_RandomIntValue,
        options: {
          comments: "Returns a random integer between the min and max value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomInt;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 7,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ActorExpressions_DivideExpression,
        options: {
          comments: "Returns the result of the **left** value divided by the **right** value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 8,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ActorExpressions_MultiplyExpression,
        options: {
          comments: "Returns the result of the listed expressions multiplied together.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get subtract() {
    if (!this._subtract) {
      this._subtract = {
        name: "subtract",
        Name: "Subtract",
        number: 9,
        protoType: 11,
        protoName: "subtract",
        oneofIndex: 0,
        type: ActorExpressions_SubtractExpression,
        options: {
          comments: "Returns the result of the **right** value subtracted from the **left** value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subtract;
  }
  get logicNot() {
    if (!this._logicNot) {
      this._logicNot = {
        name: "logicNot",
        Name: "LogicNot",
        number: 10,
        protoType: 11,
        protoName: "logic_not",
        oneofIndex: 0,
        type: ActorExpressions_LogicNotExpression,
        options: {
          comments: "Returns the flipped value or expression (true becomes false, false becomes true).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicNot;
  }
  get logicAnd() {
    if (!this._logicAnd) {
      this._logicAnd = {
        name: "logicAnd",
        Name: "LogicAnd",
        number: 11,
        protoType: 11,
        protoName: "logic_and",
        oneofIndex: 0,
        type: ActorExpressions_LogicAndExpression,
        options: {
          comments: "Returns true if all listed values/expressions are true.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicAnd;
  }
  get logicOr() {
    if (!this._logicOr) {
      this._logicOr = {
        name: "logicOr",
        Name: "LogicOr",
        number: 12,
        protoType: 11,
        protoName: "logic_or",
        oneofIndex: 0,
        type: ActorExpressions_LogicOrExpression,
        options: {
          comments: "Returns true if any listed values/expressions are true.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicOr;
  }
  get areaSearchRadius() {
    if (!this._areaSearchRadius) {
      this._areaSearchRadius = {
        name: "areaSearchRadius",
        Name: "AreaSearchRadius",
        number: 21,
        protoType: 11,
        protoName: "area_search_radius",
        oneofIndex: 0,
        type: ActorExpressions_AreaSearchRadius,
        options: {
          comments: "If the actor is created by an **area search** effect from an **action actor**, returns the radius of the search effect.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._areaSearchRadius;
  }
  get unitWeaponRange() {
    if (!this._unitWeaponRange) {
      this._unitWeaponRange = {
        name: "unitWeaponRange",
        Name: "UnitWeaponRange",
        number: 22,
        protoType: 11,
        protoName: "unit_weapon_range",
        oneofIndex: 0,
        type: ActorExpressions_UnitWeaponRange,
        options: {
          comments: "If the actor scope contains a unit, returns the maximum range of a weapon on the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWeaponRange;
  }
  get unitAbilityRange() {
    if (!this._unitAbilityRange) {
      this._unitAbilityRange = {
        name: "unitAbilityRange",
        Name: "UnitAbilityRange",
        number: 23,
        protoType: 11,
        protoName: "unit_ability_range",
        oneofIndex: 0,
        type: ActorExpressions_UnitAbilityRange,
        options: {
          comments: "If the actor scope contains a unit, returns the range of an ability on the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityRange;
  }
  get unitTeamId() {
    if (!this._unitTeamId) {
      this._unitTeamId = {
        name: "unitTeamId",
        Name: "UnitTeamId",
        number: 24,
        protoType: 11,
        protoName: "unit_team_id",
        oneofIndex: 0,
        type: ActorExpressions_UnitTeamId,
        options: {
          comments: "If the actor scope contains a unit, returns the team id of the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitTeamId;
  }
  get behaviorStackCount() {
    if (!this._behaviorStackCount) {
      this._behaviorStackCount = {
        name: "behaviorStackCount",
        Name: "BehaviorStackCount",
        number: 25,
        protoType: 11,
        protoName: "behavior_stack_count",
        oneofIndex: 0,
        type: ActorExpressions_BehaviorStackCountValue,
        options: {
          comments: "If the actor scope contains a unit, returns the current stack count of a behavior of the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorStackCount;
  }
  get unitRadius() {
    if (!this._unitRadius) {
      this._unitRadius = {
        name: "unitRadius",
        Name: "UnitRadius",
        number: 26,
        protoType: 11,
        protoName: "unit_radius",
        oneofIndex: 0,
        type: ActorExpressions_UnitRadius,
        options: {
          comments: "If the actor scope contains a unit, returns the radius of the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitRadius;
  }
  get isCriticalHit() {
    if (!this._isCriticalHit) {
      this._isCriticalHit = {
        name: "isCriticalHit",
        Name: "IsCriticalHit",
        number: 27,
        protoType: 11,
        protoName: "is_critical_hit",
        oneofIndex: 0,
        type: ActorExpressions_IscriticalHit,
        options: {
          comments: "Returns true if the actor event triggered by a critical hit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isCriticalHit;
  }
  get viewerHasAllianceType() {
    if (!this._viewerHasAllianceType) {
      this._viewerHasAllianceType = {
        name: "viewerHasAllianceType",
        Name: "ViewerHasAllianceType",
        number: 28,
        protoType: 11,
        protoName: "viewer_has_alliance_type",
        oneofIndex: 0,
        type: ActorExpressions_ViewerHasAllianceType,
        options: {
          comments: "Returns true if the current viewer has a certain alliance type with the unit in the actor scope.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._viewerHasAllianceType;
  }
  get viewerHasPlayerId() {
    if (!this._viewerHasPlayerId) {
      this._viewerHasPlayerId = {
        name: "viewerHasPlayerId",
        Name: "ViewerHasPlayerId",
        number: 29,
        protoType: 11,
        protoName: "viewer_has_player_id",
        oneofIndex: 0,
        type: ActorExpressions_ViewerHasPlayerId,
        options: {
          comments: "Returns true if the current viewer has a certain player id.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._viewerHasPlayerId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.compare,
        this.constant,
        this.variable,
        this.add,
        this.if,
        this.randomInt,
        this.divide,
        this.multiply,
        this.subtract,
        this.logicNot,
        this.logicAnd,
        this.logicOr,
        this.areaSearchRadius,
        this.unitWeaponRange,
        this.unitAbilityRange,
        this.unitTeamId,
        this.behaviorStackCount,
        this.unitRadius,
        this.isCriticalHit,
        this.viewerHasAllianceType,
        this.viewerHasPlayerId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
          this.fields[13],
          this.fields[14],
          this.fields[15],
          this.fields[16],
          this.fields[17],
          this.fields[18],
          this.fields[19],
          this.fields[20],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorExpressions_Expression.descriptor = new ActorExpressions_Expression_Descriptor();
export class ActorExpressions {
  get descriptor() {
    return ActorExpressions.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorExpressions) {
      return value;
    }
    return ActorExpressions.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorExpressions();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ActorExpressions} other
   * @returns {ActorExpressions}
   */
  merge(other) {
    const copy = new ActorExpressions(this);
    return copy;
  }
}
ActorExpressions.default = new ActorExpressions();
ActorExpressions.VariableValue = ActorExpressions_VariableValue;
ActorExpressions.ConstantValue = ActorExpressions_ConstantValue;
ActorExpressions.RandomIntValue = ActorExpressions_RandomIntValue;
ActorExpressions.UnitWeaponRange = ActorExpressions_UnitWeaponRange;
ActorExpressions.UnitAbilityRange = ActorExpressions_UnitAbilityRange;
ActorExpressions.Value = ActorExpressions_Value;
ActorExpressions.DivideExpression = ActorExpressions_DivideExpression;
ActorExpressions.MultiplyExpression = ActorExpressions_MultiplyExpression;
ActorExpressions.SubtractExpression = ActorExpressions_SubtractExpression;
ActorExpressions.AddExpression = ActorExpressions_AddExpression;
ActorExpressions.CompareExpression = ActorExpressions_CompareExpression;
ActorExpressions.LogicNotExpression = ActorExpressions_LogicNotExpression;
ActorExpressions.LogicAndExpression = ActorExpressions_LogicAndExpression;
ActorExpressions.LogicOrExpression = ActorExpressions_LogicOrExpression;
ActorExpressions.IfExpression = ActorExpressions_IfExpression;
ActorExpressions.AreaSearchRadius = ActorExpressions_AreaSearchRadius;
ActorExpressions.UnitTeamId = ActorExpressions_UnitTeamId;
ActorExpressions.BehaviorStackCountValue = ActorExpressions_BehaviorStackCountValue;
ActorExpressions.UnitRadius = ActorExpressions_UnitRadius;
ActorExpressions.IscriticalHit = ActorExpressions_IscriticalHit;
ActorExpressions.ViewerHasAllianceType = ActorExpressions_ViewerHasAllianceType;
ActorExpressions.ViewerHasPlayerId = ActorExpressions_ViewerHasPlayerId;
ActorExpressions.Expression = ActorExpressions_Expression;
class ActorExpressions_Builder {
  constructor(value) {
    this._value = new ActorExpressions(value);
  }
  build() {
    return new ActorExpressions(this._value);
  }
}
ActorExpressions.Builder = ActorExpressions_Builder;
class ActorExpressions_WithParent {
  /**
   * @param {ActorExpressions} value
   * @param {ActorExpressions_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorExpressions.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ActorExpressions_WithParent(current, parent);
    return result;
  }
}
ActorExpressions_WithParent.default = new ActorExpressions_WithParent(ActorExpressions.default, null);
ActorExpressions.WithParent = ActorExpressions_WithParent;
class ActorExpressions_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorExpressions.descriptor = new ActorExpressions_Descriptor();
export class PriorityLabel {
  get descriptor() {
    return PriorityLabel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLabel = false;
    this._label = null;
    this._hasPriority = false;
    this._priority = null;
  }
  isEmpty() {
    if (this._hasLabel) return false;
    if (this._hasPriority) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PriorityLabel) {
      return value;
    }
    return PriorityLabel.fromJson(value);
  }
  static fromJson(json) {
    const result = new PriorityLabel();
    if (json.label != null) {
      result._hasLabel = true;
      result._label = JsonToString.fromJson(json.label);
    }
    if (json.priority != null) {
      result._hasPriority = true;
      result._priority = JsonToInt32.fromJson(json.priority);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLabel) {
      result.label = JsonToString.toJson(this._label);
    }
    if (this._hasPriority) {
      result.priority = JsonToInt32.toJson(this._priority);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get label() {
    return this._hasLabel ? this._label : JsonToString.default;
  }
  get hasLabel() {
    return this._hasLabel;
  }
  setLabel(path, value) {
    return {type: 'SET', path: path.concat(['label']), value};
  }
  deleteLabel(path) {
    return {type: 'DELETE', path: path.concat(['label'])};
  }
  /**
   * @returns {number}
   */
  get priority() {
    return this._hasPriority ? this._priority : JsonToInt32.default;
  }
  get hasPriority() {
    return this._hasPriority;
  }
  setPriority(path, value) {
    return {type: 'SET', path: path.concat(['priority']), value};
  }
  deletePriority(path) {
    return {type: 'DELETE', path: path.concat(['priority'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "label": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PriorityLabel(this);
              copy._hasLabel = true;
              copy._label = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLabel) {
                return this;
              }
              const copy = new PriorityLabel(this);
              copy._hasLabel = false;
              copy._label = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "priority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PriorityLabel(this);
              copy._hasPriority = true;
              copy._priority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPriority) {
                return this;
              }
              const copy = new PriorityLabel(this);
              copy._hasPriority = false;
              copy._priority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PriorityLabel} other
   * @returns {PriorityLabel}
   */
  merge(other) {
    const copy = new PriorityLabel(this);
    if (other._hasLabel) {
      copy._hasLabel = true;
      copy._label = other._label;
    }
    if (other._hasPriority) {
      copy._hasPriority = true;
      copy._priority = other._priority;
    }
    return copy;
  }
}
PriorityLabel.default = new PriorityLabel();
class PriorityLabel_Builder {
  constructor(value) {
    this._value = new PriorityLabel(value);
  }
  build() {
    return new PriorityLabel(this._value);
  }
  setLabel(value) {
    this._value._hasLabel = true;
    this._value._label = value;
    return this;
  }
  deleteLabel() {
    this._value._hasLabel = false;
    this._value._label = null;
    return this;
  }
  setPriority(value) {
    this._value._hasPriority = true;
    this._value._priority = value;
    return this;
  }
  deletePriority() {
    this._value._hasPriority = false;
    this._value._priority = null;
    return this;
  }
}
PriorityLabel.Builder = PriorityLabel_Builder;
class PriorityLabel_WithParent {
  /**
   * @param {PriorityLabel} value
   * @param {PriorityLabel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PriorityLabel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLabel() {
    if (this._cachedHasLabel === undefined) {
      if (this._value.hasLabel) {
        this._cachedHasLabel = true;
      } else {
        this._cachedHasLabel = this._parent ? this._parent.hasLabel : false;
      }
    }
    return this._cachedHasLabel;
  }
  get label() {
    if (this._cachedLabel === undefined) {
      if (this._value.hasLabel) {
        this._cachedLabel = this._value.label;
      } else {
        this._cachedLabel = this._parent ? this._parent.label : this._value.label;
      }
    }
    return this._cachedLabel;
  }
  get hasPriority() {
    if (this._cachedHasPriority === undefined) {
      if (this._value.hasPriority) {
        this._cachedHasPriority = true;
      } else {
        this._cachedHasPriority = this._parent ? this._parent.hasPriority : false;
      }
    }
    return this._cachedHasPriority;
  }
  get priority() {
    if (this._cachedPriority === undefined) {
      if (this._value.hasPriority) {
        this._cachedPriority = this._value.priority;
      } else {
        this._cachedPriority = this._parent ? this._parent.priority : this._value.priority;
      }
    }
    return this._cachedPriority;
  }
  update(current, parent) {
    const result = new PriorityLabel_WithParent(current, parent);
    return result;
  }
}
PriorityLabel_WithParent.default = new PriorityLabel_WithParent(PriorityLabel.default, null);
PriorityLabel.WithParent = PriorityLabel_WithParent;
class PriorityLabel_Descriptor {
  get label() {
    if (!this._label) {
      this._label = {
        name: "label",
        Name: "Label",
        number: 1,
        protoType: 9,
        protoName: "label",
        type: JsonToString,
        options: {
          comments: "Use labels to apply multiple tint colors. Only the current tint color with the highest priority will be used. Use ClearTintColor to remove tint color by label.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._label;
  }
  get priority() {
    if (!this._priority) {
      this._priority = {
        name: "priority",
        Name: "Priority",
        number: 2,
        protoType: 5,
        protoName: "priority",
        type: JsonToInt32,
        options: {
          comments: "Setting tint color with higher priority will overwrite any tint colors with lower priority. The default priority is 50.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._priority;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.label,
        this.priority,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLabel",
        Name: "DummyOneofForLabel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPriority",
        Name: "DummyOneofForPriority",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PriorityLabel.descriptor = new PriorityLabel_Descriptor();
export class TeamColor {
  get descriptor() {
    return TeamColor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasR = false;
    this._r = null;
    this._hasG = false;
    this._g = null;
    this._hasB = false;
    this._b = null;
    this._hasA = false;
    this._a = null;
  }
  isEmpty() {
    if (this._hasR) return false;
    if (this._hasG) return false;
    if (this._hasB) return false;
    if (this._hasA) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TeamColor) {
      return value;
    }
    return TeamColor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TeamColor();
    if (json.r != null) {
      result._hasR = true;
      result._r = JsonToInt32.fromJson(json.r);
    }
    if (json.g != null) {
      result._hasG = true;
      result._g = JsonToInt32.fromJson(json.g);
    }
    if (json.b != null) {
      result._hasB = true;
      result._b = JsonToInt32.fromJson(json.b);
    }
    if (json.a != null) {
      result._hasA = true;
      result._a = JsonToInt32.fromJson(json.a);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasR) {
      result.r = JsonToInt32.toJson(this._r);
    }
    if (this._hasG) {
      result.g = JsonToInt32.toJson(this._g);
    }
    if (this._hasB) {
      result.b = JsonToInt32.toJson(this._b);
    }
    if (this._hasA) {
      result.a = JsonToInt32.toJson(this._a);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get r() {
    return this._hasR ? this._r : JsonToInt32.default;
  }
  get hasR() {
    return this._hasR;
  }
  setR(path, value) {
    return {type: 'SET', path: path.concat(['r']), value};
  }
  deleteR(path) {
    return {type: 'DELETE', path: path.concat(['r'])};
  }
  /**
   * @returns {number}
   */
  get g() {
    return this._hasG ? this._g : JsonToInt32.default;
  }
  get hasG() {
    return this._hasG;
  }
  setG(path, value) {
    return {type: 'SET', path: path.concat(['g']), value};
  }
  deleteG(path) {
    return {type: 'DELETE', path: path.concat(['g'])};
  }
  /**
   * @returns {number}
   */
  get b() {
    return this._hasB ? this._b : JsonToInt32.default;
  }
  get hasB() {
    return this._hasB;
  }
  setB(path, value) {
    return {type: 'SET', path: path.concat(['b']), value};
  }
  deleteB(path) {
    return {type: 'DELETE', path: path.concat(['b'])};
  }
  /**
   * @returns {number}
   */
  get a() {
    return this._hasA ? this._a : JsonToInt32.default;
  }
  get hasA() {
    return this._hasA;
  }
  setA(path, value) {
    return {type: 'SET', path: path.concat(['a']), value};
  }
  deleteA(path) {
    return {type: 'DELETE', path: path.concat(['a'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "r": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TeamColor(this);
              copy._hasR = true;
              copy._r = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasR) {
                return this;
              }
              const copy = new TeamColor(this);
              copy._hasR = false;
              copy._r = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "g": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TeamColor(this);
              copy._hasG = true;
              copy._g = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasG) {
                return this;
              }
              const copy = new TeamColor(this);
              copy._hasG = false;
              copy._g = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "b": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TeamColor(this);
              copy._hasB = true;
              copy._b = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasB) {
                return this;
              }
              const copy = new TeamColor(this);
              copy._hasB = false;
              copy._b = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "a": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TeamColor(this);
              copy._hasA = true;
              copy._a = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasA) {
                return this;
              }
              const copy = new TeamColor(this);
              copy._hasA = false;
              copy._a = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TeamColor} other
   * @returns {TeamColor}
   */
  merge(other) {
    const copy = new TeamColor(this);
    if (other._hasR) {
      copy._hasR = true;
      copy._r = other._r;
    }
    if (other._hasG) {
      copy._hasG = true;
      copy._g = other._g;
    }
    if (other._hasB) {
      copy._hasB = true;
      copy._b = other._b;
    }
    if (other._hasA) {
      copy._hasA = true;
      copy._a = other._a;
    }
    return copy;
  }
}
TeamColor.default = new TeamColor();
class TeamColor_Builder {
  constructor(value) {
    this._value = new TeamColor(value);
  }
  build() {
    return new TeamColor(this._value);
  }
  setR(value) {
    this._value._hasR = true;
    this._value._r = value;
    return this;
  }
  deleteR() {
    this._value._hasR = false;
    this._value._r = null;
    return this;
  }
  setG(value) {
    this._value._hasG = true;
    this._value._g = value;
    return this;
  }
  deleteG() {
    this._value._hasG = false;
    this._value._g = null;
    return this;
  }
  setB(value) {
    this._value._hasB = true;
    this._value._b = value;
    return this;
  }
  deleteB() {
    this._value._hasB = false;
    this._value._b = null;
    return this;
  }
  setA(value) {
    this._value._hasA = true;
    this._value._a = value;
    return this;
  }
  deleteA() {
    this._value._hasA = false;
    this._value._a = null;
    return this;
  }
}
TeamColor.Builder = TeamColor_Builder;
class TeamColor_WithParent {
  /**
   * @param {TeamColor} value
   * @param {TeamColor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TeamColor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasR() {
    if (this._cachedHasR === undefined) {
      if (this._value.hasR) {
        this._cachedHasR = true;
      } else {
        this._cachedHasR = this._parent ? this._parent.hasR : false;
      }
    }
    return this._cachedHasR;
  }
  get r() {
    if (this._cachedR === undefined) {
      if (this._value.hasR) {
        this._cachedR = this._value.r;
      } else {
        this._cachedR = this._parent ? this._parent.r : this._value.r;
      }
    }
    return this._cachedR;
  }
  get hasG() {
    if (this._cachedHasG === undefined) {
      if (this._value.hasG) {
        this._cachedHasG = true;
      } else {
        this._cachedHasG = this._parent ? this._parent.hasG : false;
      }
    }
    return this._cachedHasG;
  }
  get g() {
    if (this._cachedG === undefined) {
      if (this._value.hasG) {
        this._cachedG = this._value.g;
      } else {
        this._cachedG = this._parent ? this._parent.g : this._value.g;
      }
    }
    return this._cachedG;
  }
  get hasB() {
    if (this._cachedHasB === undefined) {
      if (this._value.hasB) {
        this._cachedHasB = true;
      } else {
        this._cachedHasB = this._parent ? this._parent.hasB : false;
      }
    }
    return this._cachedHasB;
  }
  get b() {
    if (this._cachedB === undefined) {
      if (this._value.hasB) {
        this._cachedB = this._value.b;
      } else {
        this._cachedB = this._parent ? this._parent.b : this._value.b;
      }
    }
    return this._cachedB;
  }
  get hasA() {
    if (this._cachedHasA === undefined) {
      if (this._value.hasA) {
        this._cachedHasA = true;
      } else {
        this._cachedHasA = this._parent ? this._parent.hasA : false;
      }
    }
    return this._cachedHasA;
  }
  get a() {
    if (this._cachedA === undefined) {
      if (this._value.hasA) {
        this._cachedA = this._value.a;
      } else {
        this._cachedA = this._parent ? this._parent.a : this._value.a;
      }
    }
    return this._cachedA;
  }
  update(current, parent) {
    const result = new TeamColor_WithParent(current, parent);
    return result;
  }
}
TeamColor_WithParent.default = new TeamColor_WithParent(TeamColor.default, null);
TeamColor.WithParent = TeamColor_WithParent;
class TeamColor_Descriptor {
  get r() {
    if (!this._r) {
      this._r = {
        name: "r",
        Name: "R",
        number: 1,
        protoType: 5,
        protoName: "r",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._r;
  }
  get g() {
    if (!this._g) {
      this._g = {
        name: "g",
        Name: "G",
        number: 2,
        protoType: 5,
        protoName: "g",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._g;
  }
  get b() {
    if (!this._b) {
      this._b = {
        name: "b",
        Name: "B",
        number: 3,
        protoType: 5,
        protoName: "b",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._b;
  }
  get a() {
    if (!this._a) {
      this._a = {
        name: "a",
        Name: "A",
        number: 4,
        protoType: 5,
        protoName: "a",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._a;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.r,
        this.g,
        this.b,
        this.a,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForR",
        Name: "DummyOneofForR",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForG",
        Name: "DummyOneofForG",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForB",
        Name: "DummyOneofForB",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForA",
        Name: "DummyOneofForA",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
TeamColor.descriptor = new TeamColor_Descriptor();
export class InitialScale {
  get descriptor() {
    return InitialScale.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InitialScale) {
      return value;
    }
    return InitialScale.fromJson(value);
  }
  static fromJson(json) {
    const result = new InitialScale();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InitialScale(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new InitialScale(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InitialScale(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new InitialScale(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InitialScale(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new InitialScale(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InitialScale} other
   * @returns {InitialScale}
   */
  merge(other) {
    const copy = new InitialScale(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    return copy;
  }
}
InitialScale.default = new InitialScale();
class InitialScale_Builder {
  constructor(value) {
    this._value = new InitialScale(value);
  }
  build() {
    return new InitialScale(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
}
InitialScale.Builder = InitialScale_Builder;
class InitialScale_WithParent {
  /**
   * @param {InitialScale} value
   * @param {InitialScale_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InitialScale.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  update(current, parent) {
    const result = new InitialScale_WithParent(current, parent);
    return result;
  }
}
InitialScale_WithParent.default = new InitialScale_WithParent(InitialScale.default, null);
InitialScale.WithParent = InitialScale_WithParent;
class InitialScale_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
InitialScale.descriptor = new InitialScale_Descriptor();
class ActorAction_PlayAnimation {
  get descriptor() {
    return ActorAction_PlayAnimation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
    this._hasSpeedAdditiveFactor = false;
    this._speedAdditiveFactor = null;
    this._hasUseRealTimer = false;
    this._useRealTimer = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    if (this._hasSpeedAdditiveFactor) return false;
    if (this._hasUseRealTimer) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_PlayAnimation) {
      return value;
    }
    return ActorAction_PlayAnimation.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_PlayAnimation();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    if (json.speedAdditiveFactor != null) {
      result._hasSpeedAdditiveFactor = true;
      result._speedAdditiveFactor = JsonToDouble.fromJson(json.speedAdditiveFactor);
    }
    if (json.useRealTimer != null) {
      result._hasUseRealTimer = true;
      result._useRealTimer = JsonToBoolean.fromJson(json.useRealTimer);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    if (this._hasSpeedAdditiveFactor) {
      result.speedAdditiveFactor = JsonToDouble.toJson(this._speedAdditiveFactor);
    }
    if (this._hasUseRealTimer) {
      result.useRealTimer = JsonToBoolean.toJson(this._useRealTimer);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  /**
   * @returns {number}
   */
  get speedAdditiveFactor() {
    return this._hasSpeedAdditiveFactor ? this._speedAdditiveFactor : JsonToDouble.default;
  }
  get hasSpeedAdditiveFactor() {
    return this._hasSpeedAdditiveFactor;
  }
  setSpeedAdditiveFactor(path, value) {
    return {type: 'SET', path: path.concat(['speedAdditiveFactor']), value};
  }
  deleteSpeedAdditiveFactor(path) {
    return {type: 'DELETE', path: path.concat(['speedAdditiveFactor'])};
  }
  /**
   * @returns {boolean}
   */
  get useRealTimer() {
    return this._hasUseRealTimer ? this._useRealTimer : JsonToBoolean.default;
  }
  get hasUseRealTimer() {
    return this._hasUseRealTimer;
  }
  setUseRealTimer(path, value) {
    return {type: 'SET', path: path.concat(['useRealTimer']), value};
  }
  deleteUseRealTimer(path) {
    return {type: 'DELETE', path: path.concat(['useRealTimer'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimation(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_PlayAnimation(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speedAdditiveFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimation(this);
              copy._hasSpeedAdditiveFactor = true;
              copy._speedAdditiveFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeedAdditiveFactor) {
                return this;
              }
              const copy = new ActorAction_PlayAnimation(this);
              copy._hasSpeedAdditiveFactor = false;
              copy._speedAdditiveFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useRealTimer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimation(this);
              copy._hasUseRealTimer = true;
              copy._useRealTimer = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseRealTimer) {
                return this;
              }
              const copy = new ActorAction_PlayAnimation(this);
              copy._hasUseRealTimer = false;
              copy._useRealTimer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_PlayAnimation} other
   * @returns {ActorAction_PlayAnimation}
   */
  merge(other) {
    const copy = new ActorAction_PlayAnimation(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    if (other._hasSpeedAdditiveFactor) {
      copy._hasSpeedAdditiveFactor = true;
      copy._speedAdditiveFactor = other._speedAdditiveFactor;
    }
    if (other._hasUseRealTimer) {
      copy._hasUseRealTimer = true;
      copy._useRealTimer = other._useRealTimer;
    }
    return copy;
  }
}
ActorAction_PlayAnimation.default = new ActorAction_PlayAnimation();
class ActorAction_PlayAnimation_Builder {
  constructor(value) {
    this._value = new ActorAction_PlayAnimation(value);
  }
  build() {
    return new ActorAction_PlayAnimation(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
  setSpeedAdditiveFactor(value) {
    this._value._hasSpeedAdditiveFactor = true;
    this._value._speedAdditiveFactor = value;
    return this;
  }
  deleteSpeedAdditiveFactor() {
    this._value._hasSpeedAdditiveFactor = false;
    this._value._speedAdditiveFactor = null;
    return this;
  }
  setUseRealTimer(value) {
    this._value._hasUseRealTimer = true;
    this._value._useRealTimer = value;
    return this;
  }
  deleteUseRealTimer() {
    this._value._hasUseRealTimer = false;
    this._value._useRealTimer = null;
    return this;
  }
}
ActorAction_PlayAnimation.Builder = ActorAction_PlayAnimation_Builder;
class ActorAction_PlayAnimation_WithParent {
  /**
   * @param {ActorAction_PlayAnimation} value
   * @param {ActorAction_PlayAnimation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_PlayAnimation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  get hasSpeedAdditiveFactor() {
    if (this._cachedHasSpeedAdditiveFactor === undefined) {
      if (this._value.hasSpeedAdditiveFactor) {
        this._cachedHasSpeedAdditiveFactor = true;
      } else {
        this._cachedHasSpeedAdditiveFactor = this._parent ? this._parent.hasSpeedAdditiveFactor : false;
      }
    }
    return this._cachedHasSpeedAdditiveFactor;
  }
  get speedAdditiveFactor() {
    if (this._cachedSpeedAdditiveFactor === undefined) {
      if (this._value.hasSpeedAdditiveFactor) {
        this._cachedSpeedAdditiveFactor = this._value.speedAdditiveFactor;
      } else {
        this._cachedSpeedAdditiveFactor = this._parent ? this._parent.speedAdditiveFactor : this._value.speedAdditiveFactor;
      }
    }
    return this._cachedSpeedAdditiveFactor;
  }
  get hasUseRealTimer() {
    if (this._cachedHasUseRealTimer === undefined) {
      if (this._value.hasUseRealTimer) {
        this._cachedHasUseRealTimer = true;
      } else {
        this._cachedHasUseRealTimer = this._parent ? this._parent.hasUseRealTimer : false;
      }
    }
    return this._cachedHasUseRealTimer;
  }
  get useRealTimer() {
    if (this._cachedUseRealTimer === undefined) {
      if (this._value.hasUseRealTimer) {
        this._cachedUseRealTimer = this._value.useRealTimer;
      } else {
        this._cachedUseRealTimer = this._parent ? this._parent.useRealTimer : this._value.useRealTimer;
      }
    }
    return this._cachedUseRealTimer;
  }
  update(current, parent) {
    const result = new ActorAction_PlayAnimation_WithParent(current, parent);
    return result;
  }
}
ActorAction_PlayAnimation_WithParent.default = new ActorAction_PlayAnimation_WithParent(ActorAction_PlayAnimation.default, null);
ActorAction_PlayAnimation.WithParent = ActorAction_PlayAnimation_WithParent;
class ActorAction_PlayAnimation_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to play. The default animation is \"Attack\".",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get speedAdditiveFactor() {
    if (!this._speedAdditiveFactor) {
      this._speedAdditiveFactor = {
        name: "speedAdditiveFactor",
        Name: "SpeedAdditiveFactor",
        number: 2,
        protoType: 1,
        protoName: "speed_additive_factor",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedAdditiveFactor;
  }
  get useRealTimer() {
    if (!this._useRealTimer) {
      this._useRealTimer = {
        name: "useRealTimer",
        Name: "UseRealTimer",
        number: 3,
        protoType: 8,
        protoName: "use_real_timer",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useRealTimer;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
        this.speedAdditiveFactor,
        this.useRealTimer,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeedAdditiveFactor",
        Name: "DummyOneofForSpeedAdditiveFactor",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseRealTimer",
        Name: "DummyOneofForUseRealTimer",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_PlayAnimation.descriptor = new ActorAction_PlayAnimation_Descriptor();
class ActorAction_PlayAnimationWithDuration {
  get descriptor() {
    return ActorAction_PlayAnimationWithDuration.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
    this._hasSpeedAdditiveFactor = false;
    this._speedAdditiveFactor = null;
    this._hasClipDuration = false;
    this._clipDuration = null;
    this._hasUseRealTimer = false;
    this._useRealTimer = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    if (this._hasSpeedAdditiveFactor) return false;
    if (this._hasClipDuration) return false;
    if (this._hasUseRealTimer) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_PlayAnimationWithDuration) {
      return value;
    }
    return ActorAction_PlayAnimationWithDuration.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_PlayAnimationWithDuration();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    if (json.speedAdditiveFactor != null) {
      result._hasSpeedAdditiveFactor = true;
      result._speedAdditiveFactor = JsonToDouble.fromJson(json.speedAdditiveFactor);
    }
    if (json.clipDuration != null) {
      result._hasClipDuration = true;
      result._clipDuration = JsonToDouble.fromJson(json.clipDuration);
    }
    if (json.useRealTimer != null) {
      result._hasUseRealTimer = true;
      result._useRealTimer = JsonToBoolean.fromJson(json.useRealTimer);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    if (this._hasSpeedAdditiveFactor) {
      result.speedAdditiveFactor = JsonToDouble.toJson(this._speedAdditiveFactor);
    }
    if (this._hasClipDuration) {
      result.clipDuration = JsonToDouble.toJson(this._clipDuration);
    }
    if (this._hasUseRealTimer) {
      result.useRealTimer = JsonToBoolean.toJson(this._useRealTimer);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  /**
   * @returns {number}
   */
  get speedAdditiveFactor() {
    return this._hasSpeedAdditiveFactor ? this._speedAdditiveFactor : JsonToDouble.default;
  }
  get hasSpeedAdditiveFactor() {
    return this._hasSpeedAdditiveFactor;
  }
  setSpeedAdditiveFactor(path, value) {
    return {type: 'SET', path: path.concat(['speedAdditiveFactor']), value};
  }
  deleteSpeedAdditiveFactor(path) {
    return {type: 'DELETE', path: path.concat(['speedAdditiveFactor'])};
  }
  /**
   * @returns {number}
   */
  get clipDuration() {
    return this._hasClipDuration ? this._clipDuration : JsonToDouble.default;
  }
  get hasClipDuration() {
    return this._hasClipDuration;
  }
  setClipDuration(path, value) {
    return {type: 'SET', path: path.concat(['clipDuration']), value};
  }
  deleteClipDuration(path) {
    return {type: 'DELETE', path: path.concat(['clipDuration'])};
  }
  /**
   * @returns {boolean}
   */
  get useRealTimer() {
    return this._hasUseRealTimer ? this._useRealTimer : JsonToBoolean.default;
  }
  get hasUseRealTimer() {
    return this._hasUseRealTimer;
  }
  setUseRealTimer(path, value) {
    return {type: 'SET', path: path.concat(['useRealTimer']), value};
  }
  deleteUseRealTimer(path) {
    return {type: 'DELETE', path: path.concat(['useRealTimer'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speedAdditiveFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasSpeedAdditiveFactor = true;
              copy._speedAdditiveFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeedAdditiveFactor) {
                return this;
              }
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasSpeedAdditiveFactor = false;
              copy._speedAdditiveFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "clipDuration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasClipDuration = true;
              copy._clipDuration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipDuration) {
                return this;
              }
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasClipDuration = false;
              copy._clipDuration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useRealTimer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasUseRealTimer = true;
              copy._useRealTimer = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseRealTimer) {
                return this;
              }
              const copy = new ActorAction_PlayAnimationWithDuration(this);
              copy._hasUseRealTimer = false;
              copy._useRealTimer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_PlayAnimationWithDuration} other
   * @returns {ActorAction_PlayAnimationWithDuration}
   */
  merge(other) {
    const copy = new ActorAction_PlayAnimationWithDuration(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    if (other._hasSpeedAdditiveFactor) {
      copy._hasSpeedAdditiveFactor = true;
      copy._speedAdditiveFactor = other._speedAdditiveFactor;
    }
    if (other._hasClipDuration) {
      copy._hasClipDuration = true;
      copy._clipDuration = other._clipDuration;
    }
    if (other._hasUseRealTimer) {
      copy._hasUseRealTimer = true;
      copy._useRealTimer = other._useRealTimer;
    }
    return copy;
  }
}
ActorAction_PlayAnimationWithDuration.default = new ActorAction_PlayAnimationWithDuration();
class ActorAction_PlayAnimationWithDuration_Builder {
  constructor(value) {
    this._value = new ActorAction_PlayAnimationWithDuration(value);
  }
  build() {
    return new ActorAction_PlayAnimationWithDuration(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
  setSpeedAdditiveFactor(value) {
    this._value._hasSpeedAdditiveFactor = true;
    this._value._speedAdditiveFactor = value;
    return this;
  }
  deleteSpeedAdditiveFactor() {
    this._value._hasSpeedAdditiveFactor = false;
    this._value._speedAdditiveFactor = null;
    return this;
  }
  setClipDuration(value) {
    this._value._hasClipDuration = true;
    this._value._clipDuration = value;
    return this;
  }
  deleteClipDuration() {
    this._value._hasClipDuration = false;
    this._value._clipDuration = null;
    return this;
  }
  setUseRealTimer(value) {
    this._value._hasUseRealTimer = true;
    this._value._useRealTimer = value;
    return this;
  }
  deleteUseRealTimer() {
    this._value._hasUseRealTimer = false;
    this._value._useRealTimer = null;
    return this;
  }
}
ActorAction_PlayAnimationWithDuration.Builder = ActorAction_PlayAnimationWithDuration_Builder;
class ActorAction_PlayAnimationWithDuration_WithParent {
  /**
   * @param {ActorAction_PlayAnimationWithDuration} value
   * @param {ActorAction_PlayAnimationWithDuration_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_PlayAnimationWithDuration.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  get hasSpeedAdditiveFactor() {
    if (this._cachedHasSpeedAdditiveFactor === undefined) {
      if (this._value.hasSpeedAdditiveFactor) {
        this._cachedHasSpeedAdditiveFactor = true;
      } else {
        this._cachedHasSpeedAdditiveFactor = this._parent ? this._parent.hasSpeedAdditiveFactor : false;
      }
    }
    return this._cachedHasSpeedAdditiveFactor;
  }
  get speedAdditiveFactor() {
    if (this._cachedSpeedAdditiveFactor === undefined) {
      if (this._value.hasSpeedAdditiveFactor) {
        this._cachedSpeedAdditiveFactor = this._value.speedAdditiveFactor;
      } else {
        this._cachedSpeedAdditiveFactor = this._parent ? this._parent.speedAdditiveFactor : this._value.speedAdditiveFactor;
      }
    }
    return this._cachedSpeedAdditiveFactor;
  }
  get hasClipDuration() {
    if (this._cachedHasClipDuration === undefined) {
      if (this._value.hasClipDuration) {
        this._cachedHasClipDuration = true;
      } else {
        this._cachedHasClipDuration = this._parent ? this._parent.hasClipDuration : false;
      }
    }
    return this._cachedHasClipDuration;
  }
  get clipDuration() {
    if (this._cachedClipDuration === undefined) {
      if (this._value.hasClipDuration) {
        this._cachedClipDuration = this._value.clipDuration;
      } else {
        this._cachedClipDuration = this._parent ? this._parent.clipDuration : this._value.clipDuration;
      }
    }
    return this._cachedClipDuration;
  }
  get hasUseRealTimer() {
    if (this._cachedHasUseRealTimer === undefined) {
      if (this._value.hasUseRealTimer) {
        this._cachedHasUseRealTimer = true;
      } else {
        this._cachedHasUseRealTimer = this._parent ? this._parent.hasUseRealTimer : false;
      }
    }
    return this._cachedHasUseRealTimer;
  }
  get useRealTimer() {
    if (this._cachedUseRealTimer === undefined) {
      if (this._value.hasUseRealTimer) {
        this._cachedUseRealTimer = this._value.useRealTimer;
      } else {
        this._cachedUseRealTimer = this._parent ? this._parent.useRealTimer : this._value.useRealTimer;
      }
    }
    return this._cachedUseRealTimer;
  }
  update(current, parent) {
    const result = new ActorAction_PlayAnimationWithDuration_WithParent(current, parent);
    return result;
  }
}
ActorAction_PlayAnimationWithDuration_WithParent.default = new ActorAction_PlayAnimationWithDuration_WithParent(ActorAction_PlayAnimationWithDuration.default, null);
ActorAction_PlayAnimationWithDuration.WithParent = ActorAction_PlayAnimationWithDuration_WithParent;
class ActorAction_PlayAnimationWithDuration_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to play. The default animation is \"Attack\".",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get speedAdditiveFactor() {
    if (!this._speedAdditiveFactor) {
      this._speedAdditiveFactor = {
        name: "speedAdditiveFactor",
        Name: "SpeedAdditiveFactor",
        number: 2,
        protoType: 1,
        protoName: "speed_additive_factor",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedAdditiveFactor;
  }
  get clipDuration() {
    if (!this._clipDuration) {
      this._clipDuration = {
        name: "clipDuration",
        Name: "ClipDuration",
        number: 3,
        protoType: 1,
        protoName: "clip_duration",
        type: JsonToDouble,
        options: {
          comments: "The duration of the animation.",
          min: 0.02,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipDuration;
  }
  get useRealTimer() {
    if (!this._useRealTimer) {
      this._useRealTimer = {
        name: "useRealTimer",
        Name: "UseRealTimer",
        number: 4,
        protoType: 8,
        protoName: "use_real_timer",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useRealTimer;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
        this.speedAdditiveFactor,
        this.clipDuration,
        this.useRealTimer,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeedAdditiveFactor",
        Name: "DummyOneofForSpeedAdditiveFactor",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClipDuration",
        Name: "DummyOneofForClipDuration",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseRealTimer",
        Name: "DummyOneofForUseRealTimer",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_PlayAnimationWithDuration.descriptor = new ActorAction_PlayAnimationWithDuration_Descriptor();
class ActorAction_StopAnimation {
  get descriptor() {
    return ActorAction_StopAnimation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_StopAnimation) {
      return value;
    }
    return ActorAction_StopAnimation.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_StopAnimation();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_StopAnimation(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_StopAnimation(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_StopAnimation} other
   * @returns {ActorAction_StopAnimation}
   */
  merge(other) {
    const copy = new ActorAction_StopAnimation(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    return copy;
  }
}
ActorAction_StopAnimation.default = new ActorAction_StopAnimation();
class ActorAction_StopAnimation_Builder {
  constructor(value) {
    this._value = new ActorAction_StopAnimation(value);
  }
  build() {
    return new ActorAction_StopAnimation(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
}
ActorAction_StopAnimation.Builder = ActorAction_StopAnimation_Builder;
class ActorAction_StopAnimation_WithParent {
  /**
   * @param {ActorAction_StopAnimation} value
   * @param {ActorAction_StopAnimation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_StopAnimation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  update(current, parent) {
    const result = new ActorAction_StopAnimation_WithParent(current, parent);
    return result;
  }
}
ActorAction_StopAnimation_WithParent.default = new ActorAction_StopAnimation_WithParent(ActorAction_StopAnimation.default, null);
ActorAction_StopAnimation.WithParent = ActorAction_StopAnimation_WithParent;
class ActorAction_StopAnimation_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to stop playing. The default animation is \"Attack\".",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_StopAnimation.descriptor = new ActorAction_StopAnimation_Descriptor();
class ActorAction_PauseAnimation {
  get descriptor() {
    return ActorAction_PauseAnimation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_PauseAnimation) {
      return value;
    }
    return ActorAction_PauseAnimation.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_PauseAnimation();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PauseAnimation(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_PauseAnimation(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_PauseAnimation} other
   * @returns {ActorAction_PauseAnimation}
   */
  merge(other) {
    const copy = new ActorAction_PauseAnimation(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    return copy;
  }
}
ActorAction_PauseAnimation.default = new ActorAction_PauseAnimation();
class ActorAction_PauseAnimation_Builder {
  constructor(value) {
    this._value = new ActorAction_PauseAnimation(value);
  }
  build() {
    return new ActorAction_PauseAnimation(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
}
ActorAction_PauseAnimation.Builder = ActorAction_PauseAnimation_Builder;
class ActorAction_PauseAnimation_WithParent {
  /**
   * @param {ActorAction_PauseAnimation} value
   * @param {ActorAction_PauseAnimation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_PauseAnimation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  update(current, parent) {
    const result = new ActorAction_PauseAnimation_WithParent(current, parent);
    return result;
  }
}
ActorAction_PauseAnimation_WithParent.default = new ActorAction_PauseAnimation_WithParent(ActorAction_PauseAnimation.default, null);
ActorAction_PauseAnimation.WithParent = ActorAction_PauseAnimation_WithParent;
class ActorAction_PauseAnimation_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to pause. The default animation is \"Attack\".",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_PauseAnimation.descriptor = new ActorAction_PauseAnimation_Descriptor();
class ActorAction_ResumeAnimation {
  get descriptor() {
    return ActorAction_ResumeAnimation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_ResumeAnimation) {
      return value;
    }
    return ActorAction_ResumeAnimation.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_ResumeAnimation();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ResumeAnimation(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_ResumeAnimation(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_ResumeAnimation} other
   * @returns {ActorAction_ResumeAnimation}
   */
  merge(other) {
    const copy = new ActorAction_ResumeAnimation(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    return copy;
  }
}
ActorAction_ResumeAnimation.default = new ActorAction_ResumeAnimation();
class ActorAction_ResumeAnimation_Builder {
  constructor(value) {
    this._value = new ActorAction_ResumeAnimation(value);
  }
  build() {
    return new ActorAction_ResumeAnimation(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
}
ActorAction_ResumeAnimation.Builder = ActorAction_ResumeAnimation_Builder;
class ActorAction_ResumeAnimation_WithParent {
  /**
   * @param {ActorAction_ResumeAnimation} value
   * @param {ActorAction_ResumeAnimation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_ResumeAnimation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  update(current, parent) {
    const result = new ActorAction_ResumeAnimation_WithParent(current, parent);
    return result;
  }
}
ActorAction_ResumeAnimation_WithParent.default = new ActorAction_ResumeAnimation_WithParent(ActorAction_ResumeAnimation.default, null);
ActorAction_ResumeAnimation.WithParent = ActorAction_ResumeAnimation_WithParent;
class ActorAction_ResumeAnimation_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to resume. The default animation is \"Attack\".",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_ResumeAnimation.descriptor = new ActorAction_ResumeAnimation_Descriptor();
class ActorAction_CreateActor {
  get descriptor() {
    return ActorAction_CreateActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasHostSite = false;
    this._hostSite = null;
    this._hostSiteOperations = [];
    this._aliases = [];
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasHostSite) return false;
    if (this._hostSiteOperations.length > 0) return false;
    if (this._aliases.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_CreateActor) {
      return value;
    }
    return ActorAction_CreateActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_CreateActor();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.hostSite != null) {
      result._hasHostSite = true;
      result._hostSite = JsonToString.fromJson(json.hostSite);
    }
    result._hostSiteOperations = JsonToList(json.hostSiteOperations, JsonToString);
    result._aliases = JsonToList(json.aliases, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasHostSite) {
      result.hostSite = JsonToString.toJson(this._hostSite);
    }
    if (this._hostSiteOperations.length > 0) {
      result.hostSiteOperations = ArrayToJson(this._hostSiteOperations, JsonToString);
    }
    if (this._aliases.length > 0) {
      result.aliases = ArrayToJson(this._aliases, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get hostSite() {
    return this._hasHostSite ? this._hostSite : JsonToString.default;
  }
  get hasHostSite() {
    return this._hasHostSite;
  }
  setHostSite(path, value) {
    return {type: 'SET', path: path.concat(['hostSite']), value};
  }
  deleteHostSite(path) {
    return {type: 'DELETE', path: path.concat(['hostSite'])};
  }
  /**
   * @returns {string[]}
   */
  get hostSiteOperations() {
    return this._hostSiteOperations;
  }
  addHostSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['hostSiteOperations']), value};
  }
  setHostSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setHostSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations', key]), value};
  }
  deleteHostSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations'])};
  }
  deleteHostSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations', key])};
  }
  /**
   * @returns {string[]}
   */
  get aliases() {
    return this._aliases;
  }
  addAliases(path, value) {
    return {type: 'ADD', path: path.concat(['aliases']), value};
  }
  setAliases(path, value) {
    return {type: 'SET', path: path.concat(['aliases']), value: ArrayToJson(value, JsonToString)};
  }
  setAliasesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['aliases', key]), value};
  }
  deleteAliases(path) {
    return {type: 'DELETE', path: path.concat(['aliases'])};
  }
  deleteAliasesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['aliases', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateActor(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_CreateActor(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateActor(this);
              copy._hasHostSite = true;
              copy._hostSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHostSite) {
                return this;
              }
              const copy = new ActorAction_CreateActor(this);
              copy._hasHostSite = false;
              copy._hostSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateActor(this);
              copy._hostSiteOperations = [];        for (let i of value) {
                copy._hostSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorAction_CreateActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._hostSiteOperations.length === 0) {
                return this;
              }
              const copy = new ActorAction_CreateActor(this);
              copy._hostSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice();
              copy._hostSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorAction_CreateActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice(0, path[1]).concat(copy._hostSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          const oldValue = this._hostSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorAction_CreateActor(this);
          copy._hostSiteOperations = copy._hostSiteOperations.slice();
          copy._hostSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "aliases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateActor(this);
              copy._aliases = [];        for (let i of value) {
                copy._aliases.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorAction_CreateActor(this);
              copy._aliases = copy._aliases.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._aliases.length === 0) {
                return this;
              }
              const copy = new ActorAction_CreateActor(this);
              copy._aliases = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateActor(this);
              copy._aliases = copy._aliases.slice();
              copy._aliases[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorAction_CreateActor(this);
              copy._aliases = copy._aliases.slice(0, path[1]).concat(copy._aliases.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          const oldValue = this._aliases[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorAction_CreateActor(this);
          copy._aliases = copy._aliases.slice();
          copy._aliases[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_CreateActor} other
   * @returns {ActorAction_CreateActor}
   */
  merge(other) {
    const copy = new ActorAction_CreateActor(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasHostSite) {
      copy._hasHostSite = true;
      copy._hostSite = other._hostSite;
    }
    copy._hostSiteOperations = this._hostSiteOperations.concat(other._hostSiteOperations);
    copy._aliases = this._aliases.concat(other._aliases);
    return copy;
  }
}
ActorAction_CreateActor.default = new ActorAction_CreateActor();
class ActorAction_CreateActor_Builder {
  constructor(value) {
    this._value = new ActorAction_CreateActor(value);
  }
  build() {
    return new ActorAction_CreateActor(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setHostSite(value) {
    this._value._hasHostSite = true;
    this._value._hostSite = value;
    return this;
  }
  deleteHostSite() {
    this._value._hasHostSite = false;
    this._value._hostSite = null;
    return this;
  }
  addAllHostSiteOperations(values) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat(values);
    return this;
  }
  addHostSiteOperations(value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat([value]);
    return this;
  }
  setHostSiteOperations(index, value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat();
    this._value._hostSiteOperations[index] = value;
    return this;
  }
  clearHostSiteOperations() {
    this._value._hostSiteOperations = [];
    return this;
  }
  addAllAliases(values) {
    this._value._aliases = this._value._aliases.concat(values);
    return this;
  }
  addAliases(value) {
    this._value._aliases = this._value._aliases.concat([value]);
    return this;
  }
  setAliases(index, value) {
    this._value._aliases = this._value._aliases.concat();
    this._value._aliases[index] = value;
    return this;
  }
  clearAliases() {
    this._value._aliases = [];
    return this;
  }
}
ActorAction_CreateActor.Builder = ActorAction_CreateActor_Builder;
class ActorAction_CreateActor_WithParent {
  /**
   * @param {ActorAction_CreateActor} value
   * @param {ActorAction_CreateActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_CreateActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasHostSite() {
    if (this._cachedHasHostSite === undefined) {
      if (this._value.hasHostSite) {
        this._cachedHasHostSite = true;
      } else {
        this._cachedHasHostSite = this._parent ? this._parent.hasHostSite : false;
      }
    }
    return this._cachedHasHostSite;
  }
  get hostSite() {
    if (this._cachedHostSite === undefined) {
      if (this._value.hasHostSite) {
        this._cachedHostSite = this._value.hostSite;
      } else {
        this._cachedHostSite = this._parent ? this._parent.hostSite : this._value.hostSite;
      }
    }
    return this._cachedHostSite;
  }
  get selfHostSiteOperations() {
    return this._value.hostSiteOperations;
  }
  get inherentHostSiteOperations() {
    if (!this._inherentHostSiteOperations) {
      this._inherentHostSiteOperations = this._parent ? this._parent.hostSiteOperations : [];
    }
    return this._inherentHostSiteOperations;
  }
  get hostSiteOperations() {
    if (!this._allHostSiteOperations) {
      this._allHostSiteOperations = this._parent ? this._parent.hostSiteOperations.concat(this.selfHostSiteOperations) : this.selfHostSiteOperations;
    }
    return this._allHostSiteOperations;
  }
  get selfAliases() {
    return this._value.aliases;
  }
  get inherentAliases() {
    if (!this._inherentAliases) {
      this._inherentAliases = this._parent ? this._parent.aliases : [];
    }
    return this._inherentAliases;
  }
  get aliases() {
    if (!this._allAliases) {
      this._allAliases = this._parent ? this._parent.aliases.concat(this.selfAliases) : this.selfAliases;
    }
    return this._allAliases;
  }
  update(current, parent) {
    const result = new ActorAction_CreateActor_WithParent(current, parent);
    return result;
  }
}
ActorAction_CreateActor_WithParent.default = new ActorAction_CreateActor_WithParent(ActorAction_CreateActor.default, null);
ActorAction_CreateActor.WithParent = ActorAction_CreateActor_WithParent;
class ActorAction_CreateActor_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The type of new actor to create.",
          default: "Self",
          valueDropdown: "SupportedActorListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get hostSite() {
    if (!this._hostSite) {
      this._hostSite = {
        name: "hostSite",
        Name: "HostSite",
        number: 2,
        protoType: 9,
        protoName: "host_site",
        type: JsonToString,
        options: {
          comments: "If set, this value will overwrite the **Host Site** field of the created actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSite;
  }
  get hostSiteOperations() {
    if (!this._hostSiteOperations) {
      this._hostSiteOperations = {
        name: "hostSiteOperations",
        Name: "HostSiteOperations",
        number: 3,
        protoType: 9,
        protoName: "host_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "If set, this value will overwrite the **Host Site Operations** field of the created actor.",
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSiteOperations;
  }
  get aliases() {
    if (!this._aliases) {
      this._aliases = {
        name: "aliases",
        Name: "Aliases",
        number: 4,
        protoType: 9,
        protoName: "aliases",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Used to assign an **Alias** to the new actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._aliases;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.hostSite,
        this.hostSiteOperations,
        this.aliases,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHostSite",
        Name: "DummyOneofForHostSite",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_CreateActor.descriptor = new ActorAction_CreateActor_Descriptor();
class ActorAction_DestroyActor {
  get descriptor() {
    return ActorAction_DestroyActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_DestroyActor) {
      return value;
    }
    return ActorAction_DestroyActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_DestroyActor();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_DestroyActor(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_DestroyActor(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_DestroyActor} other
   * @returns {ActorAction_DestroyActor}
   */
  merge(other) {
    const copy = new ActorAction_DestroyActor(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    return copy;
  }
}
ActorAction_DestroyActor.default = new ActorAction_DestroyActor();
class ActorAction_DestroyActor_Builder {
  constructor(value) {
    this._value = new ActorAction_DestroyActor(value);
  }
  build() {
    return new ActorAction_DestroyActor(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
}
ActorAction_DestroyActor.Builder = ActorAction_DestroyActor_Builder;
class ActorAction_DestroyActor_WithParent {
  /**
   * @param {ActorAction_DestroyActor} value
   * @param {ActorAction_DestroyActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_DestroyActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  update(current, parent) {
    const result = new ActorAction_DestroyActor_WithParent(current, parent);
    return result;
  }
}
ActorAction_DestroyActor_WithParent.default = new ActorAction_DestroyActor_WithParent(ActorAction_DestroyActor.default, null);
ActorAction_DestroyActor.WithParent = ActorAction_DestroyActor_WithParent;
class ActorAction_DestroyActor_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "Look for an actor with this name within the scope to destroy.",
          default: "Self",
          valueDropdown: "SupportedActorListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_DestroyActor.descriptor = new ActorAction_DestroyActor_Descriptor();
class ActorAction_SendMessage {
  get descriptor() {
    return ActorAction_SendMessage.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasMessage = false;
    this._message = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasMessage) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SendMessage) {
      return value;
    }
    return ActorAction_SendMessage.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SendMessage();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.message != null) {
      result._hasMessage = true;
      result._message = JsonToString.fromJson(json.message);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasMessage) {
      result.message = JsonToString.toJson(this._message);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get message() {
    return this._hasMessage ? this._message : JsonToString.default;
  }
  get hasMessage() {
    return this._hasMessage;
  }
  setMessage(path, value) {
    return {type: 'SET', path: path.concat(['message']), value};
  }
  deleteMessage(path) {
    return {type: 'DELETE', path: path.concat(['message'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SendMessage(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SendMessage(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "message": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SendMessage(this);
              copy._hasMessage = true;
              copy._message = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMessage) {
                return this;
              }
              const copy = new ActorAction_SendMessage(this);
              copy._hasMessage = false;
              copy._message = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SendMessage} other
   * @returns {ActorAction_SendMessage}
   */
  merge(other) {
    const copy = new ActorAction_SendMessage(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasMessage) {
      copy._hasMessage = true;
      copy._message = other._message;
    }
    return copy;
  }
}
ActorAction_SendMessage.default = new ActorAction_SendMessage();
class ActorAction_SendMessage_Builder {
  constructor(value) {
    this._value = new ActorAction_SendMessage(value);
  }
  build() {
    return new ActorAction_SendMessage(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setMessage(value) {
    this._value._hasMessage = true;
    this._value._message = value;
    return this;
  }
  deleteMessage() {
    this._value._hasMessage = false;
    this._value._message = null;
    return this;
  }
}
ActorAction_SendMessage.Builder = ActorAction_SendMessage_Builder;
class ActorAction_SendMessage_WithParent {
  /**
   * @param {ActorAction_SendMessage} value
   * @param {ActorAction_SendMessage_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SendMessage.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasMessage() {
    if (this._cachedHasMessage === undefined) {
      if (this._value.hasMessage) {
        this._cachedHasMessage = true;
      } else {
        this._cachedHasMessage = this._parent ? this._parent.hasMessage : false;
      }
    }
    return this._cachedHasMessage;
  }
  get message() {
    if (this._cachedMessage === undefined) {
      if (this._value.hasMessage) {
        this._cachedMessage = this._value.message;
      } else {
        this._cachedMessage = this._parent ? this._parent.message : this._value.message;
      }
    }
    return this._cachedMessage;
  }
  update(current, parent) {
    const result = new ActorAction_SendMessage_WithParent(current, parent);
    return result;
  }
}
ActorAction_SendMessage_WithParent.default = new ActorAction_SendMessage_WithParent(ActorAction_SendMessage.default, null);
ActorAction_SendMessage.WithParent = ActorAction_SendMessage_WithParent;
class ActorAction_SendMessage_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedActorListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get message() {
    if (!this._message) {
      this._message = {
        name: "message",
        Name: "Message",
        number: 2,
        protoType: 9,
        protoName: "message",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._message;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.message,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMessage",
        Name: "DummyOneofForMessage",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SendMessage.descriptor = new ActorAction_SendMessage_Descriptor();
class ActorAction_DebugLog_LogType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "DEBUG": return 0;
        case "WARNING": return 1;
        case "ERROR": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ActorAction_DebugLog_LogType.fromJson(value);
  }
  static fromReact(e) {
    return ActorAction_DebugLog_LogType.fromJson(e);
  }
}
ActorAction_DebugLog_LogType.DEBUG = 0;
ActorAction_DebugLog_LogType.WARNING = 1;
ActorAction_DebugLog_LogType.ERROR = 2;
ActorAction_DebugLog_LogType.default = 0;
ActorAction_DebugLog_LogType.values = {
  DEBUG: 0,
  WARNING: 1,
  ERROR: 2,
};
ActorAction_DebugLog_LogType.names = {
  0: "DEBUG",
  1: "WARNING",
  2: "ERROR",
};
class ActorAction_DebugLog {
  get descriptor() {
    return ActorAction_DebugLog.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasMessage = false;
    this._message = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasMessage) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_DebugLog) {
      return value;
    }
    return ActorAction_DebugLog.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_DebugLog();
    if (json.type != null) {
      result._hasType = true;
      result._type = ActorAction_DebugLog_LogType.fromJson(json.type);
    }
    if (json.message != null) {
      result._hasMessage = true;
      result._message = JsonToString.fromJson(json.message);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = ActorAction_DebugLog_LogType.toJson(this._type);
    }
    if (this._hasMessage) {
      result.message = JsonToString.toJson(this._message);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : ActorAction_DebugLog_LogType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {string}
   */
  get message() {
    return this._hasMessage ? this._message : JsonToString.default;
  }
  get hasMessage() {
    return this._hasMessage;
  }
  setMessage(path, value) {
    return {type: 'SET', path: path.concat(['message']), value};
  }
  deleteMessage(path) {
    return {type: 'DELETE', path: path.concat(['message'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_DebugLog(this);
              copy._hasType = true;
              copy._type = ActorAction_DebugLog_LogType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new ActorAction_DebugLog(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "message": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_DebugLog(this);
              copy._hasMessage = true;
              copy._message = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMessage) {
                return this;
              }
              const copy = new ActorAction_DebugLog(this);
              copy._hasMessage = false;
              copy._message = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_DebugLog} other
   * @returns {ActorAction_DebugLog}
   */
  merge(other) {
    const copy = new ActorAction_DebugLog(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasMessage) {
      copy._hasMessage = true;
      copy._message = other._message;
    }
    return copy;
  }
}
ActorAction_DebugLog.default = new ActorAction_DebugLog();
ActorAction_DebugLog.LogType = ActorAction_DebugLog_LogType;
class ActorAction_DebugLog_Builder {
  constructor(value) {
    this._value = new ActorAction_DebugLog(value);
  }
  build() {
    return new ActorAction_DebugLog(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setMessage(value) {
    this._value._hasMessage = true;
    this._value._message = value;
    return this;
  }
  deleteMessage() {
    this._value._hasMessage = false;
    this._value._message = null;
    return this;
  }
}
ActorAction_DebugLog.Builder = ActorAction_DebugLog_Builder;
class ActorAction_DebugLog_WithParent {
  /**
   * @param {ActorAction_DebugLog} value
   * @param {ActorAction_DebugLog_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_DebugLog.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasMessage() {
    if (this._cachedHasMessage === undefined) {
      if (this._value.hasMessage) {
        this._cachedHasMessage = true;
      } else {
        this._cachedHasMessage = this._parent ? this._parent.hasMessage : false;
      }
    }
    return this._cachedHasMessage;
  }
  get message() {
    if (this._cachedMessage === undefined) {
      if (this._value.hasMessage) {
        this._cachedMessage = this._value.message;
      } else {
        this._cachedMessage = this._parent ? this._parent.message : this._value.message;
      }
    }
    return this._cachedMessage;
  }
  update(current, parent) {
    const result = new ActorAction_DebugLog_WithParent(current, parent);
    return result;
  }
}
ActorAction_DebugLog_WithParent.default = new ActorAction_DebugLog_WithParent(ActorAction_DebugLog.default, null);
ActorAction_DebugLog.WithParent = ActorAction_DebugLog_WithParent;
class ActorAction_DebugLog_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: ActorAction_DebugLog_LogType,
        options: {
          comments: "Determines if the message is displayed as a debug, warning, or error message.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get message() {
    if (!this._message) {
      this._message = {
        name: "message",
        Name: "Message",
        number: 2,
        protoType: 9,
        protoName: "message",
        type: JsonToString,
        options: {
          comments: "The message to be printed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._message;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.message,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMessage",
        Name: "DummyOneofForMessage",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_DebugLog.descriptor = new ActorAction_DebugLog_Descriptor();
class ActorAction_CreateTimer {
  get descriptor() {
    return ActorAction_CreateTimer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasDuration = false;
    this._duration = null;
    this._hasRepeat = false;
    this._repeat = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasDuration) return false;
    if (this._hasRepeat) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_CreateTimer) {
      return value;
    }
    return ActorAction_CreateTimer.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_CreateTimer();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.repeat != null) {
      result._hasRepeat = true;
      result._repeat = JsonToBoolean.fromJson(json.repeat);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasRepeat) {
      result.repeat = JsonToBoolean.toJson(this._repeat);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {boolean}
   */
  get repeat() {
    return this._hasRepeat ? this._repeat : JsonToBoolean.default;
  }
  get hasRepeat() {
    return this._hasRepeat;
  }
  setRepeat(path, value) {
    return {type: 'SET', path: path.concat(['repeat']), value};
  }
  deleteRepeat(path) {
    return {type: 'DELETE', path: path.concat(['repeat'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateTimer(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ActorAction_CreateTimer(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateTimer(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new ActorAction_CreateTimer(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "repeat": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateTimer(this);
              copy._hasRepeat = true;
              copy._repeat = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRepeat) {
                return this;
              }
              const copy = new ActorAction_CreateTimer(this);
              copy._hasRepeat = false;
              copy._repeat = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_CreateTimer} other
   * @returns {ActorAction_CreateTimer}
   */
  merge(other) {
    const copy = new ActorAction_CreateTimer(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasRepeat) {
      copy._hasRepeat = true;
      copy._repeat = other._repeat;
    }
    return copy;
  }
}
ActorAction_CreateTimer.default = new ActorAction_CreateTimer();
class ActorAction_CreateTimer_Builder {
  constructor(value) {
    this._value = new ActorAction_CreateTimer(value);
  }
  build() {
    return new ActorAction_CreateTimer(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setRepeat(value) {
    this._value._hasRepeat = true;
    this._value._repeat = value;
    return this;
  }
  deleteRepeat() {
    this._value._hasRepeat = false;
    this._value._repeat = null;
    return this;
  }
}
ActorAction_CreateTimer.Builder = ActorAction_CreateTimer_Builder;
class ActorAction_CreateTimer_WithParent {
  /**
   * @param {ActorAction_CreateTimer} value
   * @param {ActorAction_CreateTimer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_CreateTimer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasRepeat() {
    if (this._cachedHasRepeat === undefined) {
      if (this._value.hasRepeat) {
        this._cachedHasRepeat = true;
      } else {
        this._cachedHasRepeat = this._parent ? this._parent.hasRepeat : false;
      }
    }
    return this._cachedHasRepeat;
  }
  get repeat() {
    if (this._cachedRepeat === undefined) {
      if (this._value.hasRepeat) {
        this._cachedRepeat = this._value.repeat;
      } else {
        this._cachedRepeat = this._parent ? this._parent.repeat : this._value.repeat;
      }
    }
    return this._cachedRepeat;
  }
  update(current, parent) {
    const result = new ActorAction_CreateTimer_WithParent(current, parent);
    return result;
  }
}
ActorAction_CreateTimer_WithParent.default = new ActorAction_CreateTimer_WithParent(ActorAction_CreateTimer.default, null);
ActorAction_CreateTimer.WithParent = ActorAction_CreateTimer_WithParent;
class ActorAction_CreateTimer_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "Name of the timer. This name is only defined in the scope of the current actor. You can use the same timer name in different actors and they won\'t interfere.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 2,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "How soon the timer should expire (in seconds). After the timer is expired, an OnTimer event will be sent to the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get repeat() {
    if (!this._repeat) {
      this._repeat = {
        name: "repeat",
        Name: "Repeat",
        number: 3,
        protoType: 8,
        protoName: "repeat",
        type: JsonToBoolean,
        options: {
          comments: "By default a timer will be removed after it\'s expired. Set this flag to true will keep the timer and an OnTimer event will be fired every time when the time specified in \"duration\" has passed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._repeat;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.duration,
        this.repeat,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRepeat",
        Name: "DummyOneofForRepeat",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_CreateTimer.descriptor = new ActorAction_CreateTimer_Descriptor();
class ActorAction_RemoveTimer {
  get descriptor() {
    return ActorAction_RemoveTimer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_RemoveTimer) {
      return value;
    }
    return ActorAction_RemoveTimer.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_RemoveTimer();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_RemoveTimer(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ActorAction_RemoveTimer(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_RemoveTimer} other
   * @returns {ActorAction_RemoveTimer}
   */
  merge(other) {
    const copy = new ActorAction_RemoveTimer(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    return copy;
  }
}
ActorAction_RemoveTimer.default = new ActorAction_RemoveTimer();
class ActorAction_RemoveTimer_Builder {
  constructor(value) {
    this._value = new ActorAction_RemoveTimer(value);
  }
  build() {
    return new ActorAction_RemoveTimer(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
}
ActorAction_RemoveTimer.Builder = ActorAction_RemoveTimer_Builder;
class ActorAction_RemoveTimer_WithParent {
  /**
   * @param {ActorAction_RemoveTimer} value
   * @param {ActorAction_RemoveTimer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_RemoveTimer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  update(current, parent) {
    const result = new ActorAction_RemoveTimer_WithParent(current, parent);
    return result;
  }
}
ActorAction_RemoveTimer_WithParent.default = new ActorAction_RemoveTimer_WithParent(ActorAction_RemoveTimer.default, null);
ActorAction_RemoveTimer.WithParent = ActorAction_RemoveTimer_WithParent;
class ActorAction_RemoveTimer_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "Name of the timer to remove. Note that a timer event may still be fired after removing the timer.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_RemoveTimer.descriptor = new ActorAction_RemoveTimer_Descriptor();
class ActorAction_SetSiteOperations {
  get descriptor() {
    return ActorAction_SetSiteOperations.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._siteOperations = [];
    this._hasDuration = false;
    this._duration = null;
    this._hasAppend = false;
    this._append = null;
  }
  isEmpty() {
    if (this._siteOperations.length > 0) return false;
    if (this._hasDuration) return false;
    if (this._hasAppend) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetSiteOperations) {
      return value;
    }
    return ActorAction_SetSiteOperations.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetSiteOperations();
    result._siteOperations = JsonToList(json.siteOperations, JsonToString);
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.append != null) {
      result._hasAppend = true;
      result._append = JsonToBoolean.fromJson(json.append);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._siteOperations.length > 0) {
      result.siteOperations = ArrayToJson(this._siteOperations, JsonToString);
    }
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasAppend) {
      result.append = JsonToBoolean.toJson(this._append);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get siteOperations() {
    return this._siteOperations;
  }
  addSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['siteOperations']), value};
  }
  setSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['siteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['siteOperations', key]), value};
  }
  deleteSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['siteOperations'])};
  }
  deleteSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['siteOperations', key])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {boolean}
   */
  get append() {
    return this._hasAppend ? this._append : JsonToBoolean.default;
  }
  get hasAppend() {
    return this._hasAppend;
  }
  setAppend(path, value) {
    return {type: 'SET', path: path.concat(['append']), value};
  }
  deleteAppend(path) {
    return {type: 'DELETE', path: path.concat(['append'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "siteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSiteOperations(this);
              copy._siteOperations = [];        for (let i of value) {
                copy._siteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorAction_SetSiteOperations(this);
              copy._siteOperations = copy._siteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._siteOperations.length === 0) {
                return this;
              }
              const copy = new ActorAction_SetSiteOperations(this);
              copy._siteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._siteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSiteOperations(this);
              copy._siteOperations = copy._siteOperations.slice();
              copy._siteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorAction_SetSiteOperations(this);
              copy._siteOperations = copy._siteOperations.slice(0, path[1]).concat(copy._siteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._siteOperations.length) {
            return this;
          }
          const oldValue = this._siteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorAction_SetSiteOperations(this);
          copy._siteOperations = copy._siteOperations.slice();
          copy._siteOperations[key] = newValue;
          return copy;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSiteOperations(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new ActorAction_SetSiteOperations(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "append": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSiteOperations(this);
              copy._hasAppend = true;
              copy._append = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAppend) {
                return this;
              }
              const copy = new ActorAction_SetSiteOperations(this);
              copy._hasAppend = false;
              copy._append = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetSiteOperations} other
   * @returns {ActorAction_SetSiteOperations}
   */
  merge(other) {
    const copy = new ActorAction_SetSiteOperations(this);
    copy._siteOperations = this._siteOperations.concat(other._siteOperations);
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasAppend) {
      copy._hasAppend = true;
      copy._append = other._append;
    }
    return copy;
  }
}
ActorAction_SetSiteOperations.default = new ActorAction_SetSiteOperations();
class ActorAction_SetSiteOperations_Builder {
  constructor(value) {
    this._value = new ActorAction_SetSiteOperations(value);
  }
  build() {
    return new ActorAction_SetSiteOperations(this._value);
  }
  addAllSiteOperations(values) {
    this._value._siteOperations = this._value._siteOperations.concat(values);
    return this;
  }
  addSiteOperations(value) {
    this._value._siteOperations = this._value._siteOperations.concat([value]);
    return this;
  }
  setSiteOperations(index, value) {
    this._value._siteOperations = this._value._siteOperations.concat();
    this._value._siteOperations[index] = value;
    return this;
  }
  clearSiteOperations() {
    this._value._siteOperations = [];
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setAppend(value) {
    this._value._hasAppend = true;
    this._value._append = value;
    return this;
  }
  deleteAppend() {
    this._value._hasAppend = false;
    this._value._append = null;
    return this;
  }
}
ActorAction_SetSiteOperations.Builder = ActorAction_SetSiteOperations_Builder;
class ActorAction_SetSiteOperations_WithParent {
  /**
   * @param {ActorAction_SetSiteOperations} value
   * @param {ActorAction_SetSiteOperations_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetSiteOperations.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSiteOperations() {
    return this._value.siteOperations;
  }
  get inherentSiteOperations() {
    if (!this._inherentSiteOperations) {
      this._inherentSiteOperations = this._parent ? this._parent.siteOperations : [];
    }
    return this._inherentSiteOperations;
  }
  get siteOperations() {
    if (!this._allSiteOperations) {
      this._allSiteOperations = this._parent ? this._parent.siteOperations.concat(this.selfSiteOperations) : this.selfSiteOperations;
    }
    return this._allSiteOperations;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasAppend() {
    if (this._cachedHasAppend === undefined) {
      if (this._value.hasAppend) {
        this._cachedHasAppend = true;
      } else {
        this._cachedHasAppend = this._parent ? this._parent.hasAppend : false;
      }
    }
    return this._cachedHasAppend;
  }
  get append() {
    if (this._cachedAppend === undefined) {
      if (this._value.hasAppend) {
        this._cachedAppend = this._value.append;
      } else {
        this._cachedAppend = this._parent ? this._parent.append : this._value.append;
      }
    }
    return this._cachedAppend;
  }
  update(current, parent) {
    const result = new ActorAction_SetSiteOperations_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetSiteOperations_WithParent.default = new ActorAction_SetSiteOperations_WithParent(ActorAction_SetSiteOperations.default, null);
ActorAction_SetSiteOperations.WithParent = ActorAction_SetSiteOperations_WithParent;
class ActorAction_SetSiteOperations_Descriptor {
  get siteOperations() {
    if (!this._siteOperations) {
      this._siteOperations = {
        name: "siteOperations",
        Name: "SiteOperations",
        number: 1,
        protoType: 9,
        protoName: "site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The site operations to apply to the actor.",
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._siteOperations;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 2,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "If set, the site operations will be applied over this duration. Does not work for all types of site operations.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get append() {
    if (!this._append) {
      this._append = {
        name: "append",
        Name: "Append",
        number: 3,
        protoType: 8,
        protoName: "append",
        type: JsonToBoolean,
        options: {
          comments: "If set, the new site operations will be added to the existing site operations on the actor instead of overwriting them. Does not work for all type sof site operations.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._append;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.siteOperations,
        this.duration,
        this.append,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAppend",
        Name: "DummyOneofForAppend",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetSiteOperations.descriptor = new ActorAction_SetSiteOperations_Descriptor();
class ActorAction_CreateAliases {
  get descriptor() {
    return ActorAction_CreateAliases.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._aliases = [];
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._aliases.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_CreateAliases) {
      return value;
    }
    return ActorAction_CreateAliases.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_CreateAliases();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    result._aliases = JsonToList(json.aliases, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._aliases.length > 0) {
      result.aliases = ArrayToJson(this._aliases, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string[]}
   */
  get aliases() {
    return this._aliases;
  }
  addAliases(path, value) {
    return {type: 'ADD', path: path.concat(['aliases']), value};
  }
  setAliases(path, value) {
    return {type: 'SET', path: path.concat(['aliases']), value: ArrayToJson(value, JsonToString)};
  }
  setAliasesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['aliases', key]), value};
  }
  deleteAliases(path) {
    return {type: 'DELETE', path: path.concat(['aliases'])};
  }
  deleteAliasesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['aliases', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateAliases(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_CreateAliases(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "aliases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateAliases(this);
              copy._aliases = [];        for (let i of value) {
                copy._aliases.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorAction_CreateAliases(this);
              copy._aliases = copy._aliases.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._aliases.length === 0) {
                return this;
              }
              const copy = new ActorAction_CreateAliases(this);
              copy._aliases = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_CreateAliases(this);
              copy._aliases = copy._aliases.slice();
              copy._aliases[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorAction_CreateAliases(this);
              copy._aliases = copy._aliases.slice(0, path[1]).concat(copy._aliases.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          const oldValue = this._aliases[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorAction_CreateAliases(this);
          copy._aliases = copy._aliases.slice();
          copy._aliases[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_CreateAliases} other
   * @returns {ActorAction_CreateAliases}
   */
  merge(other) {
    const copy = new ActorAction_CreateAliases(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    copy._aliases = this._aliases.concat(other._aliases);
    return copy;
  }
}
ActorAction_CreateAliases.default = new ActorAction_CreateAliases();
class ActorAction_CreateAliases_Builder {
  constructor(value) {
    this._value = new ActorAction_CreateAliases(value);
  }
  build() {
    return new ActorAction_CreateAliases(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  addAllAliases(values) {
    this._value._aliases = this._value._aliases.concat(values);
    return this;
  }
  addAliases(value) {
    this._value._aliases = this._value._aliases.concat([value]);
    return this;
  }
  setAliases(index, value) {
    this._value._aliases = this._value._aliases.concat();
    this._value._aliases[index] = value;
    return this;
  }
  clearAliases() {
    this._value._aliases = [];
    return this;
  }
}
ActorAction_CreateAliases.Builder = ActorAction_CreateAliases_Builder;
class ActorAction_CreateAliases_WithParent {
  /**
   * @param {ActorAction_CreateAliases} value
   * @param {ActorAction_CreateAliases_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_CreateAliases.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get selfAliases() {
    return this._value.aliases;
  }
  get inherentAliases() {
    if (!this._inherentAliases) {
      this._inherentAliases = this._parent ? this._parent.aliases : [];
    }
    return this._inherentAliases;
  }
  get aliases() {
    if (!this._allAliases) {
      this._allAliases = this._parent ? this._parent.aliases.concat(this.selfAliases) : this.selfAliases;
    }
    return this._allAliases;
  }
  update(current, parent) {
    const result = new ActorAction_CreateAliases_WithParent(current, parent);
    return result;
  }
}
ActorAction_CreateAliases_WithParent.default = new ActorAction_CreateAliases_WithParent(ActorAction_CreateAliases.default, null);
ActorAction_CreateAliases.WithParent = ActorAction_CreateAliases_WithParent;
class ActorAction_CreateAliases_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor to apply the aliases to. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get aliases() {
    if (!this._aliases) {
      this._aliases = {
        name: "aliases",
        Name: "Aliases",
        number: 2,
        protoType: 9,
        protoName: "aliases",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The aliases to apply.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._aliases;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.aliases,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_CreateAliases.descriptor = new ActorAction_CreateAliases_Descriptor();
class ActorAction_SetVariable {
  get descriptor() {
    return ActorAction_SetVariable.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasValueExpression = false;
    this._valueExpression = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasValueExpression && !this._valueExpression.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetVariable) {
      return value;
    }
    return ActorAction_SetVariable.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetVariable();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.valueExpression != null) {
      result._hasValueExpression = true;
      result._valueExpression = ActorExpressions_Expression.fromJson(json.valueExpression);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasValueExpression && !this._valueExpression.isEmpty()) {
      result.valueExpression = ActorExpressions_Expression.toJson(this._valueExpression);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {ActorExpressions_Expression}
   */
  get valueExpression() {
    return this._hasValueExpression ? this._valueExpression : ActorExpressions_Expression.default;
  }
  get hasValueExpression() {
    return this._hasValueExpression;
  }
  setValueExpression(path, value) {
    return {type: 'SET', path: path.concat(['valueExpression']), value: value.toJson()};
  }
  deleteValueExpression(path) {
    return {type: 'DELETE', path: path.concat(['valueExpression'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetVariable(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ActorAction_SetVariable(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "valueExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetVariable(this);
              copy._hasValueExpression = true;
              copy._valueExpression = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueExpression) {
                return this;
              }
              const copy = new ActorAction_SetVariable(this);
              copy._hasValueExpression = false;
              copy._valueExpression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValueExpression) {
            const copy = new ActorAction_SetVariable(this);
            copy._hasValueExpression = true;
            copy._valueExpression = ActorExpressions_Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._valueExpression.apply(type, path.slice(1), value);
          if (newValue === this._valueExpression) {
            return this;
          }
          const copy = new ActorAction_SetVariable(this);
          copy._valueExpression = copy._valueExpression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetVariable} other
   * @returns {ActorAction_SetVariable}
   */
  merge(other) {
    const copy = new ActorAction_SetVariable(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasValueExpression) {
      if (copy._hasValueExpression) {
        copy._valueExpression = copy.valueExpression.merge(other.valueExpression);
      } else {
        copy._valueExpression = other._valueExpression;
      }
      copy._hasValueExpression = true;
    }
    return copy;
  }
}
ActorAction_SetVariable.default = new ActorAction_SetVariable();
class ActorAction_SetVariable_Builder {
  constructor(value) {
    this._value = new ActorAction_SetVariable(value);
  }
  build() {
    return new ActorAction_SetVariable(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setValueExpression(value) {
    this._value._hasValueExpression = true;
    this._value._valueExpression = value;
    return this;
  }
  deleteValueExpression() {
    this._value._hasValueExpression = false;
    this._value._valueExpression = null;
    return this;
  }
}
ActorAction_SetVariable.Builder = ActorAction_SetVariable_Builder;
class ActorAction_SetVariable_WithParent {
  /**
   * @param {ActorAction_SetVariable} value
   * @param {ActorAction_SetVariable_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetVariable.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasValueExpression() {
    if (this._cachedHasValueExpression === undefined) {
      if (this._value.hasValueExpression) {
        this._cachedHasValueExpression = true;
      } else {
        this._cachedHasValueExpression = this._parent ? this._parent.hasValueExpression : false;
      }
    }
    return this._cachedHasValueExpression;
  }
  get valueExpression() {
    if (!this._cachedValueExpression) {
      if (this._value.hasValueExpression) {
        this._cachedValueExpression = new ActorExpressions_Expression.WithParent(this._value.valueExpression, this._parent && this._parent.hasValueExpression ? this._parent.valueExpression : null);
      } else {
        this._cachedValueExpression = this._parent ? new ActorExpressions_Expression.WithParent(ActorExpressions_Expression.default, this._parent.valueExpression) : ActorExpressions_Expression.WithParent.default;
      }
    }
    return this._cachedValueExpression;
  }
  update(current, parent) {
    const result = new ActorAction_SetVariable_WithParent(current, parent);
    if (this._cachedValueExpression && this._value.hasValueExpression && current.hasValueExpression) {
      if (this._value.valueExpression === current.valueExpression && this._parent === parent) {
        result._cachedValueExpression = this._cachedValueExpression;
      } else {
        result._cachedValueExpression = this._cachedValueExpression.update(current.valueExpression, parent && parent.hasValueExpression ? parent.valueExpression : null);
      }
    }
    return result;
  }
}
ActorAction_SetVariable_WithParent.default = new ActorAction_SetVariable_WithParent(ActorAction_SetVariable.default, null);
ActorAction_SetVariable.WithParent = ActorAction_SetVariable_WithParent;
class ActorAction_SetVariable_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "The name of the variable.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get valueExpression() {
    if (!this._valueExpression) {
      this._valueExpression = {
        name: "valueExpression",
        Name: "ValueExpression",
        number: 2,
        protoType: 11,
        protoName: "value_expression",
        type: ActorExpressions_Expression,
        options: {
          comments: "The value of the variable. Most commonly set to a constant, random integer, or using add to increment the variable by a constant.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueExpression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.valueExpression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueExpression",
        Name: "DummyOneofForValueExpression",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetVariable.descriptor = new ActorAction_SetVariable_Descriptor();
class ActorAction_SendCustomEvent {
  get descriptor() {
    return ActorAction_SendCustomEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasDeprecatedEventId = false;
    this._eventId = null;
    this._hasIdentifier = false;
    this._identifier = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasDeprecatedEventId) return false;
    if (this._hasIdentifier) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SendCustomEvent) {
      return value;
    }
    return ActorAction_SendCustomEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SendCustomEvent();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.eventId != null) {
      result._hasDeprecatedEventId = true;
      result._eventId = JsonToInt32.fromJson(json.eventId);
    }
    if (json.identifier != null) {
      result._hasIdentifier = true;
      result._identifier = JsonToString.fromJson(json.identifier);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasDeprecatedEventId) {
      result.eventId = JsonToInt32.toJson(this._eventId);
    }
    if (this._hasIdentifier) {
      result.identifier = JsonToString.toJson(this._identifier);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {number}
   */
  get eventId() {
    return this._hasDeprecatedEventId ? this._eventId : JsonToInt32.default;
  }
  get hasDeprecatedEventId() {
    return this._hasDeprecatedEventId;
  }
  setDeprecatedEventId(path, value) {
    return {type: 'SET', path: path.concat(['eventId']), value};
  }
  deleteDeprecatedEventId(path) {
    return {type: 'DELETE', path: path.concat(['eventId'])};
  }
  /**
   * @returns {string}
   */
  get identifier() {
    return this._hasIdentifier ? this._identifier : JsonToString.default;
  }
  get hasIdentifier() {
    return this._hasIdentifier;
  }
  setIdentifier(path, value) {
    return {type: 'SET', path: path.concat(['identifier']), value};
  }
  deleteIdentifier(path) {
    return {type: 'DELETE', path: path.concat(['identifier'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SendCustomEvent(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SendCustomEvent(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SendCustomEvent(this);
              copy._hasDeprecatedEventId = true;
              copy._eventId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedEventId) {
                return this;
              }
              const copy = new ActorAction_SendCustomEvent(this);
              copy._hasDeprecatedEventId = false;
              copy._eventId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "identifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SendCustomEvent(this);
              copy._hasIdentifier = true;
              copy._identifier = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIdentifier) {
                return this;
              }
              const copy = new ActorAction_SendCustomEvent(this);
              copy._hasIdentifier = false;
              copy._identifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SendCustomEvent} other
   * @returns {ActorAction_SendCustomEvent}
   */
  merge(other) {
    const copy = new ActorAction_SendCustomEvent(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasDeprecatedEventId) {
      copy._hasDeprecatedEventId = true;
      copy._eventId = other._eventId;
    }
    if (other._hasIdentifier) {
      copy._hasIdentifier = true;
      copy._identifier = other._identifier;
    }
    return copy;
  }
}
ActorAction_SendCustomEvent.default = new ActorAction_SendCustomEvent();
class ActorAction_SendCustomEvent_Builder {
  constructor(value) {
    this._value = new ActorAction_SendCustomEvent(value);
  }
  build() {
    return new ActorAction_SendCustomEvent(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setDeprecatedEventId(value) {
    this._value._hasDeprecatedEventId = true;
    this._value._eventId = value;
    return this;
  }
  deleteDeprecatedEventId() {
    this._value._hasDeprecatedEventId = false;
    this._value._eventId = null;
    return this;
  }
  setIdentifier(value) {
    this._value._hasIdentifier = true;
    this._value._identifier = value;
    return this;
  }
  deleteIdentifier() {
    this._value._hasIdentifier = false;
    this._value._identifier = null;
    return this;
  }
}
ActorAction_SendCustomEvent.Builder = ActorAction_SendCustomEvent_Builder;
class ActorAction_SendCustomEvent_WithParent {
  /**
   * @param {ActorAction_SendCustomEvent} value
   * @param {ActorAction_SendCustomEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SendCustomEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasDeprecatedEventId() {
    if (this._cachedHasDeprecatedEventId === undefined) {
      if (this._value.hasDeprecatedEventId) {
        this._cachedHasDeprecatedEventId = true;
      } else {
        this._cachedHasDeprecatedEventId = this._parent ? this._parent.hasDeprecatedEventId : false;
      }
    }
    return this._cachedHasDeprecatedEventId;
  }
  get eventId() {
    if (this._cachedDeprecatedEventId === undefined) {
      if (this._value.hasDeprecatedEventId) {
        this._cachedDeprecatedEventId = this._value.eventId;
      } else {
        this._cachedDeprecatedEventId = this._parent ? this._parent.eventId : this._value.eventId;
      }
    }
    return this._cachedDeprecatedEventId;
  }
  get hasIdentifier() {
    if (this._cachedHasIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedHasIdentifier = true;
      } else {
        this._cachedHasIdentifier = this._parent ? this._parent.hasIdentifier : false;
      }
    }
    return this._cachedHasIdentifier;
  }
  get identifier() {
    if (this._cachedIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedIdentifier = this._value.identifier;
      } else {
        this._cachedIdentifier = this._parent ? this._parent.identifier : this._value.identifier;
      }
    }
    return this._cachedIdentifier;
  }
  update(current, parent) {
    const result = new ActorAction_SendCustomEvent_WithParent(current, parent);
    return result;
  }
}
ActorAction_SendCustomEvent_WithParent.default = new ActorAction_SendCustomEvent_WithParent(ActorAction_SendCustomEvent.default, null);
ActorAction_SendCustomEvent.WithParent = ActorAction_SendCustomEvent_WithParent;
class ActorAction_SendCustomEvent_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get eventId() {
    if (!this._eventId) {
      this._eventId = {
        name: "eventId",
        Name: "DeprecatedEventId",
        number: 1002,
        protoType: 5,
        protoName: "deprecated_event_id",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventId;
  }
  get identifier() {
    if (!this._identifier) {
      this._identifier = {
        name: "identifier",
        Name: "Identifier",
        number: 2,
        protoType: 9,
        protoName: "identifier",
        type: JsonToString,
        options: {
          comments: "The name of the custom event.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._identifier;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.eventId,
        this.identifier,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedEventId",
        Name: "DummyOneofForDeprecatedEventId",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIdentifier",
        Name: "DummyOneofForIdentifier",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SendCustomEvent.descriptor = new ActorAction_SendCustomEvent_Descriptor();
class ActorAction_BroadcastCustomEvent {
  get descriptor() {
    return ActorAction_BroadcastCustomEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasIdentifier = false;
    this._identifier = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasIdentifier) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_BroadcastCustomEvent) {
      return value;
    }
    return ActorAction_BroadcastCustomEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_BroadcastCustomEvent();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.identifier != null) {
      result._hasIdentifier = true;
      result._identifier = JsonToString.fromJson(json.identifier);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasIdentifier) {
      result.identifier = JsonToString.toJson(this._identifier);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get identifier() {
    return this._hasIdentifier ? this._identifier : JsonToString.default;
  }
  get hasIdentifier() {
    return this._hasIdentifier;
  }
  setIdentifier(path, value) {
    return {type: 'SET', path: path.concat(['identifier']), value};
  }
  deleteIdentifier(path) {
    return {type: 'DELETE', path: path.concat(['identifier'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_BroadcastCustomEvent(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_BroadcastCustomEvent(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "identifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_BroadcastCustomEvent(this);
              copy._hasIdentifier = true;
              copy._identifier = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIdentifier) {
                return this;
              }
              const copy = new ActorAction_BroadcastCustomEvent(this);
              copy._hasIdentifier = false;
              copy._identifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_BroadcastCustomEvent} other
   * @returns {ActorAction_BroadcastCustomEvent}
   */
  merge(other) {
    const copy = new ActorAction_BroadcastCustomEvent(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasIdentifier) {
      copy._hasIdentifier = true;
      copy._identifier = other._identifier;
    }
    return copy;
  }
}
ActorAction_BroadcastCustomEvent.default = new ActorAction_BroadcastCustomEvent();
class ActorAction_BroadcastCustomEvent_Builder {
  constructor(value) {
    this._value = new ActorAction_BroadcastCustomEvent(value);
  }
  build() {
    return new ActorAction_BroadcastCustomEvent(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setIdentifier(value) {
    this._value._hasIdentifier = true;
    this._value._identifier = value;
    return this;
  }
  deleteIdentifier() {
    this._value._hasIdentifier = false;
    this._value._identifier = null;
    return this;
  }
}
ActorAction_BroadcastCustomEvent.Builder = ActorAction_BroadcastCustomEvent_Builder;
class ActorAction_BroadcastCustomEvent_WithParent {
  /**
   * @param {ActorAction_BroadcastCustomEvent} value
   * @param {ActorAction_BroadcastCustomEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_BroadcastCustomEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasIdentifier() {
    if (this._cachedHasIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedHasIdentifier = true;
      } else {
        this._cachedHasIdentifier = this._parent ? this._parent.hasIdentifier : false;
      }
    }
    return this._cachedHasIdentifier;
  }
  get identifier() {
    if (this._cachedIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedIdentifier = this._value.identifier;
      } else {
        this._cachedIdentifier = this._parent ? this._parent.identifier : this._value.identifier;
      }
    }
    return this._cachedIdentifier;
  }
  update(current, parent) {
    const result = new ActorAction_BroadcastCustomEvent_WithParent(current, parent);
    return result;
  }
}
ActorAction_BroadcastCustomEvent_WithParent.default = new ActorAction_BroadcastCustomEvent_WithParent(ActorAction_BroadcastCustomEvent.default, null);
ActorAction_BroadcastCustomEvent.WithParent = ActorAction_BroadcastCustomEvent_WithParent;
class ActorAction_BroadcastCustomEvent_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get identifier() {
    if (!this._identifier) {
      this._identifier = {
        name: "identifier",
        Name: "Identifier",
        number: 2,
        protoType: 9,
        protoName: "identifier",
        type: JsonToString,
        options: {
          comments: "The name of the custom event.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._identifier;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.identifier,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIdentifier",
        Name: "DummyOneofForIdentifier",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_BroadcastCustomEvent.descriptor = new ActorAction_BroadcastCustomEvent_Descriptor();
class ActorAction_SetTintColor {
  get descriptor() {
    return ActorAction_SetTintColor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasColor = false;
    this._color = null;
    this._hasPriorityLabel = false;
    this._priorityLabel = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasColor && !this._color.isEmpty()) return false;
    if (this._hasPriorityLabel && !this._priorityLabel.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetTintColor) {
      return value;
    }
    return ActorAction_SetTintColor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetTintColor();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.color != null) {
      result._hasColor = true;
      result._color = dcei_engine_unit_proto.TintColor.fromJson(json.color);
    }
    if (json.priorityLabel != null) {
      result._hasPriorityLabel = true;
      result._priorityLabel = PriorityLabel.fromJson(json.priorityLabel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasColor && !this._color.isEmpty()) {
      result.color = dcei_engine_unit_proto.TintColor.toJson(this._color);
    }
    if (this._hasPriorityLabel && !this._priorityLabel.isEmpty()) {
      result.priorityLabel = PriorityLabel.toJson(this._priorityLabel);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {dcei_engine_unit_proto.TintColor}
   */
  get color() {
    return this._hasColor ? this._color : dcei_engine_unit_proto.TintColor.default;
  }
  get hasColor() {
    return this._hasColor;
  }
  setColor(path, value) {
    return {type: 'SET', path: path.concat(['color']), value: value.toJson()};
  }
  deleteColor(path) {
    return {type: 'DELETE', path: path.concat(['color'])};
  }
  /**
   * @returns {PriorityLabel}
   */
  get priorityLabel() {
    return this._hasPriorityLabel ? this._priorityLabel : PriorityLabel.default;
  }
  get hasPriorityLabel() {
    return this._hasPriorityLabel;
  }
  setPriorityLabel(path, value) {
    return {type: 'SET', path: path.concat(['priorityLabel']), value: value.toJson()};
  }
  deletePriorityLabel(path) {
    return {type: 'DELETE', path: path.concat(['priorityLabel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetTintColor(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetTintColor(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "color": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetTintColor(this);
              copy._hasColor = true;
              copy._color = dcei_engine_unit_proto.TintColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasColor) {
                return this;
              }
              const copy = new ActorAction_SetTintColor(this);
              copy._hasColor = false;
              copy._color = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasColor) {
            const copy = new ActorAction_SetTintColor(this);
            copy._hasColor = true;
            copy._color = dcei_engine_unit_proto.TintColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._color.apply(type, path.slice(1), value);
          if (newValue === this._color) {
            return this;
          }
          const copy = new ActorAction_SetTintColor(this);
          copy._color = copy._color.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "priorityLabel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetTintColor(this);
              copy._hasPriorityLabel = true;
              copy._priorityLabel = PriorityLabel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPriorityLabel) {
                return this;
              }
              const copy = new ActorAction_SetTintColor(this);
              copy._hasPriorityLabel = false;
              copy._priorityLabel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPriorityLabel) {
            const copy = new ActorAction_SetTintColor(this);
            copy._hasPriorityLabel = true;
            copy._priorityLabel = PriorityLabel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._priorityLabel.apply(type, path.slice(1), value);
          if (newValue === this._priorityLabel) {
            return this;
          }
          const copy = new ActorAction_SetTintColor(this);
          copy._priorityLabel = copy._priorityLabel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetTintColor} other
   * @returns {ActorAction_SetTintColor}
   */
  merge(other) {
    const copy = new ActorAction_SetTintColor(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasColor) {
      if (copy._hasColor) {
        copy._color = copy.color.merge(other.color);
      } else {
        copy._color = other._color;
      }
      copy._hasColor = true;
    }
    if (other._hasPriorityLabel) {
      if (copy._hasPriorityLabel) {
        copy._priorityLabel = copy.priorityLabel.merge(other.priorityLabel);
      } else {
        copy._priorityLabel = other._priorityLabel;
      }
      copy._hasPriorityLabel = true;
    }
    return copy;
  }
}
ActorAction_SetTintColor.default = new ActorAction_SetTintColor();
class ActorAction_SetTintColor_Builder {
  constructor(value) {
    this._value = new ActorAction_SetTintColor(value);
  }
  build() {
    return new ActorAction_SetTintColor(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setColor(value) {
    this._value._hasColor = true;
    this._value._color = value;
    return this;
  }
  deleteColor() {
    this._value._hasColor = false;
    this._value._color = null;
    return this;
  }
  setPriorityLabel(value) {
    this._value._hasPriorityLabel = true;
    this._value._priorityLabel = value;
    return this;
  }
  deletePriorityLabel() {
    this._value._hasPriorityLabel = false;
    this._value._priorityLabel = null;
    return this;
  }
}
ActorAction_SetTintColor.Builder = ActorAction_SetTintColor_Builder;
class ActorAction_SetTintColor_WithParent {
  /**
   * @param {ActorAction_SetTintColor} value
   * @param {ActorAction_SetTintColor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetTintColor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasColor() {
    if (this._cachedHasColor === undefined) {
      if (this._value.hasColor) {
        this._cachedHasColor = true;
      } else {
        this._cachedHasColor = this._parent ? this._parent.hasColor : false;
      }
    }
    return this._cachedHasColor;
  }
  get color() {
    if (!this._cachedColor) {
      if (this._value.hasColor) {
        this._cachedColor = new dcei_engine_unit_proto.TintColor.WithParent(this._value.color, this._parent && this._parent.hasColor ? this._parent.color : null);
      } else {
        this._cachedColor = this._parent ? new dcei_engine_unit_proto.TintColor.WithParent(dcei_engine_unit_proto.TintColor.default, this._parent.color) : dcei_engine_unit_proto.TintColor.WithParent.default;
      }
    }
    return this._cachedColor;
  }
  get hasPriorityLabel() {
    if (this._cachedHasPriorityLabel === undefined) {
      if (this._value.hasPriorityLabel) {
        this._cachedHasPriorityLabel = true;
      } else {
        this._cachedHasPriorityLabel = this._parent ? this._parent.hasPriorityLabel : false;
      }
    }
    return this._cachedHasPriorityLabel;
  }
  get priorityLabel() {
    if (!this._cachedPriorityLabel) {
      if (this._value.hasPriorityLabel) {
        this._cachedPriorityLabel = new PriorityLabel.WithParent(this._value.priorityLabel, this._parent && this._parent.hasPriorityLabel ? this._parent.priorityLabel : null);
      } else {
        this._cachedPriorityLabel = this._parent ? new PriorityLabel.WithParent(PriorityLabel.default, this._parent.priorityLabel) : PriorityLabel.WithParent.default;
      }
    }
    return this._cachedPriorityLabel;
  }
  update(current, parent) {
    const result = new ActorAction_SetTintColor_WithParent(current, parent);
    if (this._cachedColor && this._value.hasColor && current.hasColor) {
      if (this._value.color === current.color && this._parent === parent) {
        result._cachedColor = this._cachedColor;
      } else {
        result._cachedColor = this._cachedColor.update(current.color, parent && parent.hasColor ? parent.color : null);
      }
    }
    if (this._cachedPriorityLabel && this._value.hasPriorityLabel && current.hasPriorityLabel) {
      if (this._value.priorityLabel === current.priorityLabel && this._parent === parent) {
        result._cachedPriorityLabel = this._cachedPriorityLabel;
      } else {
        result._cachedPriorityLabel = this._cachedPriorityLabel.update(current.priorityLabel, parent && parent.hasPriorityLabel ? parent.priorityLabel : null);
      }
    }
    return result;
  }
}
ActorAction_SetTintColor_WithParent.default = new ActorAction_SetTintColor_WithParent(ActorAction_SetTintColor.default, null);
ActorAction_SetTintColor.WithParent = ActorAction_SetTintColor_WithParent;
class ActorAction_SetTintColor_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get color() {
    if (!this._color) {
      this._color = {
        name: "color",
        Name: "Color",
        number: 2,
        protoType: 11,
        protoName: "color",
        type: dcei_engine_unit_proto.TintColor,
        options: {
          comments: "These color values will be used to tint the model multiplicatively.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._color;
  }
  get priorityLabel() {
    if (!this._priorityLabel) {
      this._priorityLabel = {
        name: "priorityLabel",
        Name: "PriorityLabel",
        number: 3,
        protoType: 11,
        protoName: "priority_label",
        type: PriorityLabel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._priorityLabel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.color,
        this.priorityLabel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForColor",
        Name: "DummyOneofForColor",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPriorityLabel",
        Name: "DummyOneofForPriorityLabel",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetTintColor.descriptor = new ActorAction_SetTintColor_Descriptor();
class ActorAction_ClearTintColor {
  get descriptor() {
    return ActorAction_ClearTintColor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasLabel = false;
    this._label = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasLabel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_ClearTintColor) {
      return value;
    }
    return ActorAction_ClearTintColor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_ClearTintColor();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.label != null) {
      result._hasLabel = true;
      result._label = JsonToString.fromJson(json.label);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasLabel) {
      result.label = JsonToString.toJson(this._label);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get label() {
    return this._hasLabel ? this._label : JsonToString.default;
  }
  get hasLabel() {
    return this._hasLabel;
  }
  setLabel(path, value) {
    return {type: 'SET', path: path.concat(['label']), value};
  }
  deleteLabel(path) {
    return {type: 'DELETE', path: path.concat(['label'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ClearTintColor(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_ClearTintColor(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "label": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ClearTintColor(this);
              copy._hasLabel = true;
              copy._label = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLabel) {
                return this;
              }
              const copy = new ActorAction_ClearTintColor(this);
              copy._hasLabel = false;
              copy._label = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_ClearTintColor} other
   * @returns {ActorAction_ClearTintColor}
   */
  merge(other) {
    const copy = new ActorAction_ClearTintColor(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasLabel) {
      copy._hasLabel = true;
      copy._label = other._label;
    }
    return copy;
  }
}
ActorAction_ClearTintColor.default = new ActorAction_ClearTintColor();
class ActorAction_ClearTintColor_Builder {
  constructor(value) {
    this._value = new ActorAction_ClearTintColor(value);
  }
  build() {
    return new ActorAction_ClearTintColor(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setLabel(value) {
    this._value._hasLabel = true;
    this._value._label = value;
    return this;
  }
  deleteLabel() {
    this._value._hasLabel = false;
    this._value._label = null;
    return this;
  }
}
ActorAction_ClearTintColor.Builder = ActorAction_ClearTintColor_Builder;
class ActorAction_ClearTintColor_WithParent {
  /**
   * @param {ActorAction_ClearTintColor} value
   * @param {ActorAction_ClearTintColor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_ClearTintColor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasLabel() {
    if (this._cachedHasLabel === undefined) {
      if (this._value.hasLabel) {
        this._cachedHasLabel = true;
      } else {
        this._cachedHasLabel = this._parent ? this._parent.hasLabel : false;
      }
    }
    return this._cachedHasLabel;
  }
  get label() {
    if (this._cachedLabel === undefined) {
      if (this._value.hasLabel) {
        this._cachedLabel = this._value.label;
      } else {
        this._cachedLabel = this._parent ? this._parent.label : this._value.label;
      }
    }
    return this._cachedLabel;
  }
  update(current, parent) {
    const result = new ActorAction_ClearTintColor_WithParent(current, parent);
    return result;
  }
}
ActorAction_ClearTintColor_WithParent.default = new ActorAction_ClearTintColor_WithParent(ActorAction_ClearTintColor.default, null);
ActorAction_ClearTintColor.WithParent = ActorAction_ClearTintColor_WithParent;
class ActorAction_ClearTintColor_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get label() {
    if (!this._label) {
      this._label = {
        name: "label",
        Name: "Label",
        number: 2,
        protoType: 9,
        protoName: "label",
        type: JsonToString,
        options: {
          comments: "If set, only the tint with the matching label will be removed. Otherwise all tint color will be removed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._label;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.label,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLabel",
        Name: "DummyOneofForLabel",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_ClearTintColor.descriptor = new ActorAction_ClearTintColor_Descriptor();
class ActorAction_SetTeamColor {
  get descriptor() {
    return ActorAction_SetTeamColor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasColor = false;
    this._color = null;
    this._hasSecondColor = false;
    this._secondColor = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasColor && !this._color.isEmpty()) return false;
    if (this._hasSecondColor && !this._secondColor.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetTeamColor) {
      return value;
    }
    return ActorAction_SetTeamColor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetTeamColor();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.color != null) {
      result._hasColor = true;
      result._color = TeamColor.fromJson(json.color);
    }
    if (json.secondColor != null) {
      result._hasSecondColor = true;
      result._secondColor = TeamColor.fromJson(json.secondColor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasColor && !this._color.isEmpty()) {
      result.color = TeamColor.toJson(this._color);
    }
    if (this._hasSecondColor && !this._secondColor.isEmpty()) {
      result.secondColor = TeamColor.toJson(this._secondColor);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {TeamColor}
   */
  get color() {
    return this._hasColor ? this._color : TeamColor.default;
  }
  get hasColor() {
    return this._hasColor;
  }
  setColor(path, value) {
    return {type: 'SET', path: path.concat(['color']), value: value.toJson()};
  }
  deleteColor(path) {
    return {type: 'DELETE', path: path.concat(['color'])};
  }
  /**
   * @returns {TeamColor}
   */
  get secondColor() {
    return this._hasSecondColor ? this._secondColor : TeamColor.default;
  }
  get hasSecondColor() {
    return this._hasSecondColor;
  }
  setSecondColor(path, value) {
    return {type: 'SET', path: path.concat(['secondColor']), value: value.toJson()};
  }
  deleteSecondColor(path) {
    return {type: 'DELETE', path: path.concat(['secondColor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetTeamColor(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetTeamColor(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "color": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetTeamColor(this);
              copy._hasColor = true;
              copy._color = TeamColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasColor) {
                return this;
              }
              const copy = new ActorAction_SetTeamColor(this);
              copy._hasColor = false;
              copy._color = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasColor) {
            const copy = new ActorAction_SetTeamColor(this);
            copy._hasColor = true;
            copy._color = TeamColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._color.apply(type, path.slice(1), value);
          if (newValue === this._color) {
            return this;
          }
          const copy = new ActorAction_SetTeamColor(this);
          copy._color = copy._color.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "secondColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetTeamColor(this);
              copy._hasSecondColor = true;
              copy._secondColor = TeamColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondColor) {
                return this;
              }
              const copy = new ActorAction_SetTeamColor(this);
              copy._hasSecondColor = false;
              copy._secondColor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSecondColor) {
            const copy = new ActorAction_SetTeamColor(this);
            copy._hasSecondColor = true;
            copy._secondColor = TeamColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._secondColor.apply(type, path.slice(1), value);
          if (newValue === this._secondColor) {
            return this;
          }
          const copy = new ActorAction_SetTeamColor(this);
          copy._secondColor = copy._secondColor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetTeamColor} other
   * @returns {ActorAction_SetTeamColor}
   */
  merge(other) {
    const copy = new ActorAction_SetTeamColor(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasColor) {
      if (copy._hasColor) {
        copy._color = copy.color.merge(other.color);
      } else {
        copy._color = other._color;
      }
      copy._hasColor = true;
    }
    if (other._hasSecondColor) {
      if (copy._hasSecondColor) {
        copy._secondColor = copy.secondColor.merge(other.secondColor);
      } else {
        copy._secondColor = other._secondColor;
      }
      copy._hasSecondColor = true;
    }
    return copy;
  }
}
ActorAction_SetTeamColor.default = new ActorAction_SetTeamColor();
class ActorAction_SetTeamColor_Builder {
  constructor(value) {
    this._value = new ActorAction_SetTeamColor(value);
  }
  build() {
    return new ActorAction_SetTeamColor(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setColor(value) {
    this._value._hasColor = true;
    this._value._color = value;
    return this;
  }
  deleteColor() {
    this._value._hasColor = false;
    this._value._color = null;
    return this;
  }
  setSecondColor(value) {
    this._value._hasSecondColor = true;
    this._value._secondColor = value;
    return this;
  }
  deleteSecondColor() {
    this._value._hasSecondColor = false;
    this._value._secondColor = null;
    return this;
  }
}
ActorAction_SetTeamColor.Builder = ActorAction_SetTeamColor_Builder;
class ActorAction_SetTeamColor_WithParent {
  /**
   * @param {ActorAction_SetTeamColor} value
   * @param {ActorAction_SetTeamColor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetTeamColor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasColor() {
    if (this._cachedHasColor === undefined) {
      if (this._value.hasColor) {
        this._cachedHasColor = true;
      } else {
        this._cachedHasColor = this._parent ? this._parent.hasColor : false;
      }
    }
    return this._cachedHasColor;
  }
  get color() {
    if (!this._cachedColor) {
      if (this._value.hasColor) {
        this._cachedColor = new TeamColor.WithParent(this._value.color, this._parent && this._parent.hasColor ? this._parent.color : null);
      } else {
        this._cachedColor = this._parent ? new TeamColor.WithParent(TeamColor.default, this._parent.color) : TeamColor.WithParent.default;
      }
    }
    return this._cachedColor;
  }
  get hasSecondColor() {
    if (this._cachedHasSecondColor === undefined) {
      if (this._value.hasSecondColor) {
        this._cachedHasSecondColor = true;
      } else {
        this._cachedHasSecondColor = this._parent ? this._parent.hasSecondColor : false;
      }
    }
    return this._cachedHasSecondColor;
  }
  get secondColor() {
    if (!this._cachedSecondColor) {
      if (this._value.hasSecondColor) {
        this._cachedSecondColor = new TeamColor.WithParent(this._value.secondColor, this._parent && this._parent.hasSecondColor ? this._parent.secondColor : null);
      } else {
        this._cachedSecondColor = this._parent ? new TeamColor.WithParent(TeamColor.default, this._parent.secondColor) : TeamColor.WithParent.default;
      }
    }
    return this._cachedSecondColor;
  }
  update(current, parent) {
    const result = new ActorAction_SetTeamColor_WithParent(current, parent);
    if (this._cachedColor && this._value.hasColor && current.hasColor) {
      if (this._value.color === current.color && this._parent === parent) {
        result._cachedColor = this._cachedColor;
      } else {
        result._cachedColor = this._cachedColor.update(current.color, parent && parent.hasColor ? parent.color : null);
      }
    }
    if (this._cachedSecondColor && this._value.hasSecondColor && current.hasSecondColor) {
      if (this._value.secondColor === current.secondColor && this._parent === parent) {
        result._cachedSecondColor = this._cachedSecondColor;
      } else {
        result._cachedSecondColor = this._cachedSecondColor.update(current.secondColor, parent && parent.hasSecondColor ? parent.secondColor : null);
      }
    }
    return result;
  }
}
ActorAction_SetTeamColor_WithParent.default = new ActorAction_SetTeamColor_WithParent(ActorAction_SetTeamColor.default, null);
ActorAction_SetTeamColor.WithParent = ActorAction_SetTeamColor_WithParent;
class ActorAction_SetTeamColor_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get color() {
    if (!this._color) {
      this._color = {
        name: "color",
        Name: "Color",
        number: 2,
        protoType: 11,
        protoName: "color",
        type: TeamColor,
        options: {
          comments: "These color values will be used to colorize the team color sections of the model, using the A value as the blending value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._color;
  }
  get secondColor() {
    if (!this._secondColor) {
      this._secondColor = {
        name: "secondColor",
        Name: "SecondColor",
        number: 3,
        protoType: 11,
        protoName: "second_color",
        type: TeamColor,
        options: {
          comments: "These color values will be used to colorize the secondary team color sections of the model.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._secondColor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.color,
        this.secondColor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForColor",
        Name: "DummyOneofForColor",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondColor",
        Name: "DummyOneofForSecondColor",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetTeamColor.descriptor = new ActorAction_SetTeamColor_Descriptor();
class ActorAction_SetShadow {
  get descriptor() {
    return ActorAction_SetShadow.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasShadowDisplay = false;
    this._shadowDisplay = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasShadowDisplay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetShadow) {
      return value;
    }
    return ActorAction_SetShadow.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetShadow();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.shadowDisplay != null) {
      result._hasShadowDisplay = true;
      result._shadowDisplay = JsonToBoolean.fromJson(json.shadowDisplay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasShadowDisplay) {
      result.shadowDisplay = JsonToBoolean.toJson(this._shadowDisplay);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {boolean}
   */
  get shadowDisplay() {
    return this._hasShadowDisplay ? this._shadowDisplay : JsonToBoolean.default;
  }
  get hasShadowDisplay() {
    return this._hasShadowDisplay;
  }
  setShadowDisplay(path, value) {
    return {type: 'SET', path: path.concat(['shadowDisplay']), value};
  }
  deleteShadowDisplay(path) {
    return {type: 'DELETE', path: path.concat(['shadowDisplay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetShadow(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetShadow(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "shadowDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetShadow(this);
              copy._hasShadowDisplay = true;
              copy._shadowDisplay = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShadowDisplay) {
                return this;
              }
              const copy = new ActorAction_SetShadow(this);
              copy._hasShadowDisplay = false;
              copy._shadowDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetShadow} other
   * @returns {ActorAction_SetShadow}
   */
  merge(other) {
    const copy = new ActorAction_SetShadow(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasShadowDisplay) {
      copy._hasShadowDisplay = true;
      copy._shadowDisplay = other._shadowDisplay;
    }
    return copy;
  }
}
ActorAction_SetShadow.default = new ActorAction_SetShadow();
class ActorAction_SetShadow_Builder {
  constructor(value) {
    this._value = new ActorAction_SetShadow(value);
  }
  build() {
    return new ActorAction_SetShadow(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setShadowDisplay(value) {
    this._value._hasShadowDisplay = true;
    this._value._shadowDisplay = value;
    return this;
  }
  deleteShadowDisplay() {
    this._value._hasShadowDisplay = false;
    this._value._shadowDisplay = null;
    return this;
  }
}
ActorAction_SetShadow.Builder = ActorAction_SetShadow_Builder;
class ActorAction_SetShadow_WithParent {
  /**
   * @param {ActorAction_SetShadow} value
   * @param {ActorAction_SetShadow_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetShadow.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasShadowDisplay() {
    if (this._cachedHasShadowDisplay === undefined) {
      if (this._value.hasShadowDisplay) {
        this._cachedHasShadowDisplay = true;
      } else {
        this._cachedHasShadowDisplay = this._parent ? this._parent.hasShadowDisplay : false;
      }
    }
    return this._cachedHasShadowDisplay;
  }
  get shadowDisplay() {
    if (this._cachedShadowDisplay === undefined) {
      if (this._value.hasShadowDisplay) {
        this._cachedShadowDisplay = this._value.shadowDisplay;
      } else {
        this._cachedShadowDisplay = this._parent ? this._parent.shadowDisplay : this._value.shadowDisplay;
      }
    }
    return this._cachedShadowDisplay;
  }
  update(current, parent) {
    const result = new ActorAction_SetShadow_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetShadow_WithParent.default = new ActorAction_SetShadow_WithParent(ActorAction_SetShadow.default, null);
ActorAction_SetShadow.WithParent = ActorAction_SetShadow_WithParent;
class ActorAction_SetShadow_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The name of the actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get shadowDisplay() {
    if (!this._shadowDisplay) {
      this._shadowDisplay = {
        name: "shadowDisplay",
        Name: "ShadowDisplay",
        number: 2,
        protoType: 8,
        protoName: "shadow_display",
        type: JsonToBoolean,
        options: {
          comments: "When unchecked, hides the actor\'s shadow.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shadowDisplay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.shadowDisplay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShadowDisplay",
        Name: "DummyOneofForShadowDisplay",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetShadow.descriptor = new ActorAction_SetShadow_Descriptor();
class ActorAction_SetOutline {
  get descriptor() {
    return ActorAction_SetOutline.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasOutlineDisplay = false;
    this._outlineDisplay = null;
    this._hasOutlineColor = false;
    this._outlineColor = null;
    this._hasOutlineWidth = false;
    this._outlineWidth = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasOutlineDisplay) return false;
    if (this._hasOutlineColor && !this._outlineColor.isEmpty()) return false;
    if (this._hasOutlineWidth) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetOutline) {
      return value;
    }
    return ActorAction_SetOutline.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetOutline();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.outlineDisplay != null) {
      result._hasOutlineDisplay = true;
      result._outlineDisplay = JsonToBoolean.fromJson(json.outlineDisplay);
    }
    if (json.outlineColor != null) {
      result._hasOutlineColor = true;
      result._outlineColor = dcei_engine_unit_proto.TintColor.fromJson(json.outlineColor);
    }
    if (json.outlineWidth != null) {
      result._hasOutlineWidth = true;
      result._outlineWidth = JsonToDouble.fromJson(json.outlineWidth);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasOutlineDisplay) {
      result.outlineDisplay = JsonToBoolean.toJson(this._outlineDisplay);
    }
    if (this._hasOutlineColor && !this._outlineColor.isEmpty()) {
      result.outlineColor = dcei_engine_unit_proto.TintColor.toJson(this._outlineColor);
    }
    if (this._hasOutlineWidth) {
      result.outlineWidth = JsonToDouble.toJson(this._outlineWidth);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {boolean}
   */
  get outlineDisplay() {
    return this._hasOutlineDisplay ? this._outlineDisplay : JsonToBoolean.default;
  }
  get hasOutlineDisplay() {
    return this._hasOutlineDisplay;
  }
  setOutlineDisplay(path, value) {
    return {type: 'SET', path: path.concat(['outlineDisplay']), value};
  }
  deleteOutlineDisplay(path) {
    return {type: 'DELETE', path: path.concat(['outlineDisplay'])};
  }
  /**
   * @returns {dcei_engine_unit_proto.TintColor}
   */
  get outlineColor() {
    return this._hasOutlineColor ? this._outlineColor : dcei_engine_unit_proto.TintColor.default;
  }
  get hasOutlineColor() {
    return this._hasOutlineColor;
  }
  setOutlineColor(path, value) {
    return {type: 'SET', path: path.concat(['outlineColor']), value: value.toJson()};
  }
  deleteOutlineColor(path) {
    return {type: 'DELETE', path: path.concat(['outlineColor'])};
  }
  /**
   * @returns {number}
   */
  get outlineWidth() {
    return this._hasOutlineWidth ? this._outlineWidth : JsonToDouble.default;
  }
  get hasOutlineWidth() {
    return this._hasOutlineWidth;
  }
  setOutlineWidth(path, value) {
    return {type: 'SET', path: path.concat(['outlineWidth']), value};
  }
  deleteOutlineWidth(path) {
    return {type: 'DELETE', path: path.concat(['outlineWidth'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetOutline(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetOutline(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "outlineDisplay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetOutline(this);
              copy._hasOutlineDisplay = true;
              copy._outlineDisplay = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOutlineDisplay) {
                return this;
              }
              const copy = new ActorAction_SetOutline(this);
              copy._hasOutlineDisplay = false;
              copy._outlineDisplay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "outlineColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetOutline(this);
              copy._hasOutlineColor = true;
              copy._outlineColor = dcei_engine_unit_proto.TintColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOutlineColor) {
                return this;
              }
              const copy = new ActorAction_SetOutline(this);
              copy._hasOutlineColor = false;
              copy._outlineColor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOutlineColor) {
            const copy = new ActorAction_SetOutline(this);
            copy._hasOutlineColor = true;
            copy._outlineColor = dcei_engine_unit_proto.TintColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._outlineColor.apply(type, path.slice(1), value);
          if (newValue === this._outlineColor) {
            return this;
          }
          const copy = new ActorAction_SetOutline(this);
          copy._outlineColor = copy._outlineColor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "outlineWidth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetOutline(this);
              copy._hasOutlineWidth = true;
              copy._outlineWidth = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOutlineWidth) {
                return this;
              }
              const copy = new ActorAction_SetOutline(this);
              copy._hasOutlineWidth = false;
              copy._outlineWidth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetOutline} other
   * @returns {ActorAction_SetOutline}
   */
  merge(other) {
    const copy = new ActorAction_SetOutline(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasOutlineDisplay) {
      copy._hasOutlineDisplay = true;
      copy._outlineDisplay = other._outlineDisplay;
    }
    if (other._hasOutlineColor) {
      if (copy._hasOutlineColor) {
        copy._outlineColor = copy.outlineColor.merge(other.outlineColor);
      } else {
        copy._outlineColor = other._outlineColor;
      }
      copy._hasOutlineColor = true;
    }
    if (other._hasOutlineWidth) {
      copy._hasOutlineWidth = true;
      copy._outlineWidth = other._outlineWidth;
    }
    return copy;
  }
}
ActorAction_SetOutline.default = new ActorAction_SetOutline();
class ActorAction_SetOutline_Builder {
  constructor(value) {
    this._value = new ActorAction_SetOutline(value);
  }
  build() {
    return new ActorAction_SetOutline(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setOutlineDisplay(value) {
    this._value._hasOutlineDisplay = true;
    this._value._outlineDisplay = value;
    return this;
  }
  deleteOutlineDisplay() {
    this._value._hasOutlineDisplay = false;
    this._value._outlineDisplay = null;
    return this;
  }
  setOutlineColor(value) {
    this._value._hasOutlineColor = true;
    this._value._outlineColor = value;
    return this;
  }
  deleteOutlineColor() {
    this._value._hasOutlineColor = false;
    this._value._outlineColor = null;
    return this;
  }
  setOutlineWidth(value) {
    this._value._hasOutlineWidth = true;
    this._value._outlineWidth = value;
    return this;
  }
  deleteOutlineWidth() {
    this._value._hasOutlineWidth = false;
    this._value._outlineWidth = null;
    return this;
  }
}
ActorAction_SetOutline.Builder = ActorAction_SetOutline_Builder;
class ActorAction_SetOutline_WithParent {
  /**
   * @param {ActorAction_SetOutline} value
   * @param {ActorAction_SetOutline_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetOutline.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasOutlineDisplay() {
    if (this._cachedHasOutlineDisplay === undefined) {
      if (this._value.hasOutlineDisplay) {
        this._cachedHasOutlineDisplay = true;
      } else {
        this._cachedHasOutlineDisplay = this._parent ? this._parent.hasOutlineDisplay : false;
      }
    }
    return this._cachedHasOutlineDisplay;
  }
  get outlineDisplay() {
    if (this._cachedOutlineDisplay === undefined) {
      if (this._value.hasOutlineDisplay) {
        this._cachedOutlineDisplay = this._value.outlineDisplay;
      } else {
        this._cachedOutlineDisplay = this._parent ? this._parent.outlineDisplay : this._value.outlineDisplay;
      }
    }
    return this._cachedOutlineDisplay;
  }
  get hasOutlineColor() {
    if (this._cachedHasOutlineColor === undefined) {
      if (this._value.hasOutlineColor) {
        this._cachedHasOutlineColor = true;
      } else {
        this._cachedHasOutlineColor = this._parent ? this._parent.hasOutlineColor : false;
      }
    }
    return this._cachedHasOutlineColor;
  }
  get outlineColor() {
    if (!this._cachedOutlineColor) {
      if (this._value.hasOutlineColor) {
        this._cachedOutlineColor = new dcei_engine_unit_proto.TintColor.WithParent(this._value.outlineColor, this._parent && this._parent.hasOutlineColor ? this._parent.outlineColor : null);
      } else {
        this._cachedOutlineColor = this._parent ? new dcei_engine_unit_proto.TintColor.WithParent(dcei_engine_unit_proto.TintColor.default, this._parent.outlineColor) : dcei_engine_unit_proto.TintColor.WithParent.default;
      }
    }
    return this._cachedOutlineColor;
  }
  get hasOutlineWidth() {
    if (this._cachedHasOutlineWidth === undefined) {
      if (this._value.hasOutlineWidth) {
        this._cachedHasOutlineWidth = true;
      } else {
        this._cachedHasOutlineWidth = this._parent ? this._parent.hasOutlineWidth : false;
      }
    }
    return this._cachedHasOutlineWidth;
  }
  get outlineWidth() {
    if (this._cachedOutlineWidth === undefined) {
      if (this._value.hasOutlineWidth) {
        this._cachedOutlineWidth = this._value.outlineWidth;
      } else {
        this._cachedOutlineWidth = this._parent ? this._parent.outlineWidth : this._value.outlineWidth;
      }
    }
    return this._cachedOutlineWidth;
  }
  update(current, parent) {
    const result = new ActorAction_SetOutline_WithParent(current, parent);
    if (this._cachedOutlineColor && this._value.hasOutlineColor && current.hasOutlineColor) {
      if (this._value.outlineColor === current.outlineColor && this._parent === parent) {
        result._cachedOutlineColor = this._cachedOutlineColor;
      } else {
        result._cachedOutlineColor = this._cachedOutlineColor.update(current.outlineColor, parent && parent.hasOutlineColor ? parent.outlineColor : null);
      }
    }
    return result;
  }
}
ActorAction_SetOutline_WithParent.default = new ActorAction_SetOutline_WithParent(ActorAction_SetOutline.default, null);
ActorAction_SetOutline.WithParent = ActorAction_SetOutline_WithParent;
class ActorAction_SetOutline_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The name of the actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get outlineDisplay() {
    if (!this._outlineDisplay) {
      this._outlineDisplay = {
        name: "outlineDisplay",
        Name: "OutlineDisplay",
        number: 2,
        protoType: 8,
        protoName: "outline_display",
        type: JsonToBoolean,
        options: {
          comments: "When checked, render a outline of the actor.",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._outlineDisplay;
  }
  get outlineColor() {
    if (!this._outlineColor) {
      this._outlineColor = {
        name: "outlineColor",
        Name: "OutlineColor",
        number: 3,
        protoType: 11,
        protoName: "outline_color",
        type: dcei_engine_unit_proto.TintColor,
        options: {
          comments: "Sets the outline color. The default is black.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._outlineColor;
  }
  get outlineWidth() {
    if (!this._outlineWidth) {
      this._outlineWidth = {
        name: "outlineWidth",
        Name: "OutlineWidth",
        number: 4,
        protoType: 1,
        protoName: "outline_width",
        type: JsonToDouble,
        options: {
          comments: "The outline width to use.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._outlineWidth;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.outlineDisplay,
        this.outlineColor,
        this.outlineWidth,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOutlineDisplay",
        Name: "DummyOneofForOutlineDisplay",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOutlineColor",
        Name: "DummyOneofForOutlineColor",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOutlineWidth",
        Name: "DummyOneofForOutlineWidth",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetOutline.descriptor = new ActorAction_SetOutline_Descriptor();
class ActorAction_ClearOutline {
  get descriptor() {
    return ActorAction_ClearOutline.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_ClearOutline) {
      return value;
    }
    return ActorAction_ClearOutline.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_ClearOutline();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ClearOutline(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_ClearOutline(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_ClearOutline} other
   * @returns {ActorAction_ClearOutline}
   */
  merge(other) {
    const copy = new ActorAction_ClearOutline(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    return copy;
  }
}
ActorAction_ClearOutline.default = new ActorAction_ClearOutline();
class ActorAction_ClearOutline_Builder {
  constructor(value) {
    this._value = new ActorAction_ClearOutline(value);
  }
  build() {
    return new ActorAction_ClearOutline(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
}
ActorAction_ClearOutline.Builder = ActorAction_ClearOutline_Builder;
class ActorAction_ClearOutline_WithParent {
  /**
   * @param {ActorAction_ClearOutline} value
   * @param {ActorAction_ClearOutline_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_ClearOutline.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  update(current, parent) {
    const result = new ActorAction_ClearOutline_WithParent(current, parent);
    return result;
  }
}
ActorAction_ClearOutline_WithParent.default = new ActorAction_ClearOutline_WithParent(ActorAction_ClearOutline.default, null);
ActorAction_ClearOutline.WithParent = ActorAction_ClearOutline_WithParent;
class ActorAction_ClearOutline_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The name of the actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_ClearOutline.descriptor = new ActorAction_ClearOutline_Descriptor();
class ActorAction_SetScaleMultiplier {
  get descriptor() {
    return ActorAction_SetScaleMultiplier.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasScale = false;
    this._scale = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasScale && !this._scale.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetScaleMultiplier) {
      return value;
    }
    return ActorAction_SetScaleMultiplier.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetScaleMultiplier();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.scale != null) {
      result._hasScale = true;
      result._scale = InitialScale.fromJson(json.scale);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasScale && !this._scale.isEmpty()) {
      result.scale = InitialScale.toJson(this._scale);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {InitialScale}
   */
  get scale() {
    return this._hasScale ? this._scale : InitialScale.default;
  }
  get hasScale() {
    return this._hasScale;
  }
  setScale(path, value) {
    return {type: 'SET', path: path.concat(['scale']), value: value.toJson()};
  }
  deleteScale(path) {
    return {type: 'DELETE', path: path.concat(['scale'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetScaleMultiplier(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetScaleMultiplier(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetScaleMultiplier(this);
              copy._hasScale = true;
              copy._scale = InitialScale.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScale) {
                return this;
              }
              const copy = new ActorAction_SetScaleMultiplier(this);
              copy._hasScale = false;
              copy._scale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasScale) {
            const copy = new ActorAction_SetScaleMultiplier(this);
            copy._hasScale = true;
            copy._scale = InitialScale.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._scale.apply(type, path.slice(1), value);
          if (newValue === this._scale) {
            return this;
          }
          const copy = new ActorAction_SetScaleMultiplier(this);
          copy._scale = copy._scale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetScaleMultiplier} other
   * @returns {ActorAction_SetScaleMultiplier}
   */
  merge(other) {
    const copy = new ActorAction_SetScaleMultiplier(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasScale) {
      if (copy._hasScale) {
        copy._scale = copy.scale.merge(other.scale);
      } else {
        copy._scale = other._scale;
      }
      copy._hasScale = true;
    }
    return copy;
  }
}
ActorAction_SetScaleMultiplier.default = new ActorAction_SetScaleMultiplier();
class ActorAction_SetScaleMultiplier_Builder {
  constructor(value) {
    this._value = new ActorAction_SetScaleMultiplier(value);
  }
  build() {
    return new ActorAction_SetScaleMultiplier(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setScale(value) {
    this._value._hasScale = true;
    this._value._scale = value;
    return this;
  }
  deleteScale() {
    this._value._hasScale = false;
    this._value._scale = null;
    return this;
  }
}
ActorAction_SetScaleMultiplier.Builder = ActorAction_SetScaleMultiplier_Builder;
class ActorAction_SetScaleMultiplier_WithParent {
  /**
   * @param {ActorAction_SetScaleMultiplier} value
   * @param {ActorAction_SetScaleMultiplier_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetScaleMultiplier.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasScale() {
    if (this._cachedHasScale === undefined) {
      if (this._value.hasScale) {
        this._cachedHasScale = true;
      } else {
        this._cachedHasScale = this._parent ? this._parent.hasScale : false;
      }
    }
    return this._cachedHasScale;
  }
  get scale() {
    if (!this._cachedScale) {
      if (this._value.hasScale) {
        this._cachedScale = new InitialScale.WithParent(this._value.scale, this._parent && this._parent.hasScale ? this._parent.scale : null);
      } else {
        this._cachedScale = this._parent ? new InitialScale.WithParent(InitialScale.default, this._parent.scale) : InitialScale.WithParent.default;
      }
    }
    return this._cachedScale;
  }
  update(current, parent) {
    const result = new ActorAction_SetScaleMultiplier_WithParent(current, parent);
    if (this._cachedScale && this._value.hasScale && current.hasScale) {
      if (this._value.scale === current.scale && this._parent === parent) {
        result._cachedScale = this._cachedScale;
      } else {
        result._cachedScale = this._cachedScale.update(current.scale, parent && parent.hasScale ? parent.scale : null);
      }
    }
    return result;
  }
}
ActorAction_SetScaleMultiplier_WithParent.default = new ActorAction_SetScaleMultiplier_WithParent(ActorAction_SetScaleMultiplier.default, null);
ActorAction_SetScaleMultiplier.WithParent = ActorAction_SetScaleMultiplier_WithParent;
class ActorAction_SetScaleMultiplier_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The name of the actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get scale() {
    if (!this._scale) {
      this._scale = {
        name: "scale",
        Name: "Scale",
        number: 2,
        protoType: 11,
        protoName: "scale",
        type: InitialScale,
        options: {
          comments: "Specified the initial scale of the model and it can be non-uniform, this is display only, the finial display will multiply this by actual model scale",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scale;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.scale,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScale",
        Name: "DummyOneofForScale",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetScaleMultiplier.descriptor = new ActorAction_SetScaleMultiplier_Descriptor();
class ActorAction_SetShadowHeight {
  get descriptor() {
    return ActorAction_SetShadowHeight.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasShadowHeight = false;
    this._shadowHeight = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasShadowHeight) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetShadowHeight) {
      return value;
    }
    return ActorAction_SetShadowHeight.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetShadowHeight();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.shadowHeight != null) {
      result._hasShadowHeight = true;
      result._shadowHeight = JsonToDouble.fromJson(json.shadowHeight);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasShadowHeight) {
      result.shadowHeight = JsonToDouble.toJson(this._shadowHeight);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {number}
   */
  get shadowHeight() {
    return this._hasShadowHeight ? this._shadowHeight : JsonToDouble.default;
  }
  get hasShadowHeight() {
    return this._hasShadowHeight;
  }
  setShadowHeight(path, value) {
    return {type: 'SET', path: path.concat(['shadowHeight']), value};
  }
  deleteShadowHeight(path) {
    return {type: 'DELETE', path: path.concat(['shadowHeight'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetShadowHeight(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetShadowHeight(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "shadowHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetShadowHeight(this);
              copy._hasShadowHeight = true;
              copy._shadowHeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShadowHeight) {
                return this;
              }
              const copy = new ActorAction_SetShadowHeight(this);
              copy._hasShadowHeight = false;
              copy._shadowHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetShadowHeight} other
   * @returns {ActorAction_SetShadowHeight}
   */
  merge(other) {
    const copy = new ActorAction_SetShadowHeight(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasShadowHeight) {
      copy._hasShadowHeight = true;
      copy._shadowHeight = other._shadowHeight;
    }
    return copy;
  }
}
ActorAction_SetShadowHeight.default = new ActorAction_SetShadowHeight();
class ActorAction_SetShadowHeight_Builder {
  constructor(value) {
    this._value = new ActorAction_SetShadowHeight(value);
  }
  build() {
    return new ActorAction_SetShadowHeight(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setShadowHeight(value) {
    this._value._hasShadowHeight = true;
    this._value._shadowHeight = value;
    return this;
  }
  deleteShadowHeight() {
    this._value._hasShadowHeight = false;
    this._value._shadowHeight = null;
    return this;
  }
}
ActorAction_SetShadowHeight.Builder = ActorAction_SetShadowHeight_Builder;
class ActorAction_SetShadowHeight_WithParent {
  /**
   * @param {ActorAction_SetShadowHeight} value
   * @param {ActorAction_SetShadowHeight_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetShadowHeight.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasShadowHeight() {
    if (this._cachedHasShadowHeight === undefined) {
      if (this._value.hasShadowHeight) {
        this._cachedHasShadowHeight = true;
      } else {
        this._cachedHasShadowHeight = this._parent ? this._parent.hasShadowHeight : false;
      }
    }
    return this._cachedHasShadowHeight;
  }
  get shadowHeight() {
    if (this._cachedShadowHeight === undefined) {
      if (this._value.hasShadowHeight) {
        this._cachedShadowHeight = this._value.shadowHeight;
      } else {
        this._cachedShadowHeight = this._parent ? this._parent.shadowHeight : this._value.shadowHeight;
      }
    }
    return this._cachedShadowHeight;
  }
  update(current, parent) {
    const result = new ActorAction_SetShadowHeight_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetShadowHeight_WithParent.default = new ActorAction_SetShadowHeight_WithParent(ActorAction_SetShadowHeight.default, null);
ActorAction_SetShadowHeight.WithParent = ActorAction_SetShadowHeight_WithParent;
class ActorAction_SetShadowHeight_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor to set the shadow height for. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get shadowHeight() {
    if (!this._shadowHeight) {
      this._shadowHeight = {
        name: "shadowHeight",
        Name: "ShadowHeight",
        number: 2,
        protoType: 1,
        protoName: "shadow_height",
        type: JsonToDouble,
        options: {
          comments: "The value to set shadow height.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shadowHeight;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.shadowHeight,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShadowHeight",
        Name: "DummyOneofForShadowHeight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetShadowHeight.descriptor = new ActorAction_SetShadowHeight_Descriptor();
class ActorAction_SetMeshEffect {
  get descriptor() {
    return ActorAction_SetMeshEffect.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasEffect = false;
    this._effect = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasEffect) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetMeshEffect) {
      return value;
    }
    return ActorAction_SetMeshEffect.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetMeshEffect();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetMeshEffect(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetMeshEffect(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetMeshEffect(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new ActorAction_SetMeshEffect(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetMeshEffect} other
   * @returns {ActorAction_SetMeshEffect}
   */
  merge(other) {
    const copy = new ActorAction_SetMeshEffect(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    return copy;
  }
}
ActorAction_SetMeshEffect.default = new ActorAction_SetMeshEffect();
class ActorAction_SetMeshEffect_Builder {
  constructor(value) {
    this._value = new ActorAction_SetMeshEffect(value);
  }
  build() {
    return new ActorAction_SetMeshEffect(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
}
ActorAction_SetMeshEffect.Builder = ActorAction_SetMeshEffect_Builder;
class ActorAction_SetMeshEffect_WithParent {
  /**
   * @param {ActorAction_SetMeshEffect} value
   * @param {ActorAction_SetMeshEffect_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetMeshEffect.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  update(current, parent) {
    const result = new ActorAction_SetMeshEffect_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetMeshEffect_WithParent.default = new ActorAction_SetMeshEffect_WithParent(ActorAction_SetMeshEffect.default, null);
ActorAction_SetMeshEffect.WithParent = ActorAction_SetMeshEffect_WithParent;
class ActorAction_SetMeshEffect_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 2,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "dcei.engine.proto.ActorAction.SetMeshEffect.effect,,The mesh effect to apply.",
          valueDropdown: "SupportedMeshEffectNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.effect,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetMeshEffect.descriptor = new ActorAction_SetMeshEffect_Descriptor();
class ActorAction_ApplyMeshEffect {
  get descriptor() {
    return ActorAction_ApplyMeshEffect.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasEffect = false;
    this._effect = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasEffect) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_ApplyMeshEffect) {
      return value;
    }
    return ActorAction_ApplyMeshEffect.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_ApplyMeshEffect();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ApplyMeshEffect(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_ApplyMeshEffect(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ApplyMeshEffect(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new ActorAction_ApplyMeshEffect(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_ApplyMeshEffect} other
   * @returns {ActorAction_ApplyMeshEffect}
   */
  merge(other) {
    const copy = new ActorAction_ApplyMeshEffect(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    return copy;
  }
}
ActorAction_ApplyMeshEffect.default = new ActorAction_ApplyMeshEffect();
class ActorAction_ApplyMeshEffect_Builder {
  constructor(value) {
    this._value = new ActorAction_ApplyMeshEffect(value);
  }
  build() {
    return new ActorAction_ApplyMeshEffect(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
}
ActorAction_ApplyMeshEffect.Builder = ActorAction_ApplyMeshEffect_Builder;
class ActorAction_ApplyMeshEffect_WithParent {
  /**
   * @param {ActorAction_ApplyMeshEffect} value
   * @param {ActorAction_ApplyMeshEffect_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_ApplyMeshEffect.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  update(current, parent) {
    const result = new ActorAction_ApplyMeshEffect_WithParent(current, parent);
    return result;
  }
}
ActorAction_ApplyMeshEffect_WithParent.default = new ActorAction_ApplyMeshEffect_WithParent(ActorAction_ApplyMeshEffect.default, null);
ActorAction_ApplyMeshEffect.WithParent = ActorAction_ApplyMeshEffect_WithParent;
class ActorAction_ApplyMeshEffect_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 2,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The mesh effect to apply.",
          valueDropdown: "SupportedMeshEffectNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.effect,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_ApplyMeshEffect.descriptor = new ActorAction_ApplyMeshEffect_Descriptor();
class ActorAction_RemoveMeshEffect {
  get descriptor() {
    return ActorAction_RemoveMeshEffect.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasEffect = false;
    this._effect = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasEffect) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_RemoveMeshEffect) {
      return value;
    }
    return ActorAction_RemoveMeshEffect.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_RemoveMeshEffect();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_RemoveMeshEffect(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_RemoveMeshEffect(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_RemoveMeshEffect(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new ActorAction_RemoveMeshEffect(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_RemoveMeshEffect} other
   * @returns {ActorAction_RemoveMeshEffect}
   */
  merge(other) {
    const copy = new ActorAction_RemoveMeshEffect(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    return copy;
  }
}
ActorAction_RemoveMeshEffect.default = new ActorAction_RemoveMeshEffect();
class ActorAction_RemoveMeshEffect_Builder {
  constructor(value) {
    this._value = new ActorAction_RemoveMeshEffect(value);
  }
  build() {
    return new ActorAction_RemoveMeshEffect(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
}
ActorAction_RemoveMeshEffect.Builder = ActorAction_RemoveMeshEffect_Builder;
class ActorAction_RemoveMeshEffect_WithParent {
  /**
   * @param {ActorAction_RemoveMeshEffect} value
   * @param {ActorAction_RemoveMeshEffect_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_RemoveMeshEffect.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  update(current, parent) {
    const result = new ActorAction_RemoveMeshEffect_WithParent(current, parent);
    return result;
  }
}
ActorAction_RemoveMeshEffect_WithParent.default = new ActorAction_RemoveMeshEffect_WithParent(ActorAction_RemoveMeshEffect.default, null);
ActorAction_RemoveMeshEffect.WithParent = ActorAction_RemoveMeshEffect_WithParent;
class ActorAction_RemoveMeshEffect_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 2,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The mesh effect to remove.",
          valueDropdown: "SupportedMeshEffectNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.effect,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_RemoveMeshEffect.descriptor = new ActorAction_RemoveMeshEffect_Descriptor();
class ActorAction_PlayMusic {
  get descriptor() {
    return ActorAction_PlayMusic.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMusicName = false;
    this._musicName = null;
    this._hasPush = false;
    this._push = null;
  }
  isEmpty() {
    if (this._hasMusicName) return false;
    if (this._hasPush) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_PlayMusic) {
      return value;
    }
    return ActorAction_PlayMusic.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_PlayMusic();
    if (json.musicName != null) {
      result._hasMusicName = true;
      result._musicName = JsonToString.fromJson(json.musicName);
    }
    if (json.push != null) {
      result._hasPush = true;
      result._push = JsonToBoolean.fromJson(json.push);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMusicName) {
      result.musicName = JsonToString.toJson(this._musicName);
    }
    if (this._hasPush) {
      result.push = JsonToBoolean.toJson(this._push);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get musicName() {
    return this._hasMusicName ? this._musicName : JsonToString.default;
  }
  get hasMusicName() {
    return this._hasMusicName;
  }
  setMusicName(path, value) {
    return {type: 'SET', path: path.concat(['musicName']), value};
  }
  deleteMusicName(path) {
    return {type: 'DELETE', path: path.concat(['musicName'])};
  }
  /**
   * @returns {boolean}
   */
  get push() {
    return this._hasPush ? this._push : JsonToBoolean.default;
  }
  get hasPush() {
    return this._hasPush;
  }
  setPush(path, value) {
    return {type: 'SET', path: path.concat(['push']), value};
  }
  deletePush(path) {
    return {type: 'DELETE', path: path.concat(['push'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "musicName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayMusic(this);
              copy._hasMusicName = true;
              copy._musicName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMusicName) {
                return this;
              }
              const copy = new ActorAction_PlayMusic(this);
              copy._hasMusicName = false;
              copy._musicName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "push": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlayMusic(this);
              copy._hasPush = true;
              copy._push = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPush) {
                return this;
              }
              const copy = new ActorAction_PlayMusic(this);
              copy._hasPush = false;
              copy._push = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_PlayMusic} other
   * @returns {ActorAction_PlayMusic}
   */
  merge(other) {
    const copy = new ActorAction_PlayMusic(this);
    if (other._hasMusicName) {
      copy._hasMusicName = true;
      copy._musicName = other._musicName;
    }
    if (other._hasPush) {
      copy._hasPush = true;
      copy._push = other._push;
    }
    return copy;
  }
}
ActorAction_PlayMusic.default = new ActorAction_PlayMusic();
class ActorAction_PlayMusic_Builder {
  constructor(value) {
    this._value = new ActorAction_PlayMusic(value);
  }
  build() {
    return new ActorAction_PlayMusic(this._value);
  }
  setMusicName(value) {
    this._value._hasMusicName = true;
    this._value._musicName = value;
    return this;
  }
  deleteMusicName() {
    this._value._hasMusicName = false;
    this._value._musicName = null;
    return this;
  }
  setPush(value) {
    this._value._hasPush = true;
    this._value._push = value;
    return this;
  }
  deletePush() {
    this._value._hasPush = false;
    this._value._push = null;
    return this;
  }
}
ActorAction_PlayMusic.Builder = ActorAction_PlayMusic_Builder;
class ActorAction_PlayMusic_WithParent {
  /**
   * @param {ActorAction_PlayMusic} value
   * @param {ActorAction_PlayMusic_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_PlayMusic.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMusicName() {
    if (this._cachedHasMusicName === undefined) {
      if (this._value.hasMusicName) {
        this._cachedHasMusicName = true;
      } else {
        this._cachedHasMusicName = this._parent ? this._parent.hasMusicName : false;
      }
    }
    return this._cachedHasMusicName;
  }
  get musicName() {
    if (this._cachedMusicName === undefined) {
      if (this._value.hasMusicName) {
        this._cachedMusicName = this._value.musicName;
      } else {
        this._cachedMusicName = this._parent ? this._parent.musicName : this._value.musicName;
      }
    }
    return this._cachedMusicName;
  }
  get hasPush() {
    if (this._cachedHasPush === undefined) {
      if (this._value.hasPush) {
        this._cachedHasPush = true;
      } else {
        this._cachedHasPush = this._parent ? this._parent.hasPush : false;
      }
    }
    return this._cachedHasPush;
  }
  get push() {
    if (this._cachedPush === undefined) {
      if (this._value.hasPush) {
        this._cachedPush = this._value.push;
      } else {
        this._cachedPush = this._parent ? this._parent.push : this._value.push;
      }
    }
    return this._cachedPush;
  }
  update(current, parent) {
    const result = new ActorAction_PlayMusic_WithParent(current, parent);
    return result;
  }
}
ActorAction_PlayMusic_WithParent.default = new ActorAction_PlayMusic_WithParent(ActorAction_PlayMusic.default, null);
ActorAction_PlayMusic.WithParent = ActorAction_PlayMusic_WithParent;
class ActorAction_PlayMusic_Descriptor {
  get musicName() {
    if (!this._musicName) {
      this._musicName = {
        name: "musicName",
        Name: "MusicName",
        number: 1,
        protoType: 9,
        protoName: "music_name",
        type: JsonToString,
        options: {
          comments: "The music asset to play.",
          valueDropdown: "SupportedMusicNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._musicName;
  }
  get push() {
    if (!this._push) {
      this._push = {
        name: "push",
        Name: "Push",
        number: 2,
        protoType: 8,
        protoName: "push",
        type: JsonToBoolean,
        options: {
          comments: "Whether to save the previously playing music to a stack. This is useful if you want to resume that music later (using **Stop Music** with the pop flag set to true).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._push;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.musicName,
        this.push,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMusicName",
        Name: "DummyOneofForMusicName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPush",
        Name: "DummyOneofForPush",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_PlayMusic.descriptor = new ActorAction_PlayMusic_Descriptor();
class ActorAction_PlaySound {
  get descriptor() {
    return ActorAction_PlaySound.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSoundName = false;
    this._soundName = null;
    this._hasVolume = false;
    this._volume = null;
  }
  isEmpty() {
    if (this._hasSoundName) return false;
    if (this._hasVolume) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_PlaySound) {
      return value;
    }
    return ActorAction_PlaySound.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_PlaySound();
    if (json.soundName != null) {
      result._hasSoundName = true;
      result._soundName = JsonToString.fromJson(json.soundName);
    }
    if (json.volume != null) {
      result._hasVolume = true;
      result._volume = JsonToDouble.fromJson(json.volume);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSoundName) {
      result.soundName = JsonToString.toJson(this._soundName);
    }
    if (this._hasVolume) {
      result.volume = JsonToDouble.toJson(this._volume);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get soundName() {
    return this._hasSoundName ? this._soundName : JsonToString.default;
  }
  get hasSoundName() {
    return this._hasSoundName;
  }
  setSoundName(path, value) {
    return {type: 'SET', path: path.concat(['soundName']), value};
  }
  deleteSoundName(path) {
    return {type: 'DELETE', path: path.concat(['soundName'])};
  }
  /**
   * @returns {number}
   */
  get volume() {
    return this._hasVolume ? this._volume : JsonToDouble.default;
  }
  get hasVolume() {
    return this._hasVolume;
  }
  setVolume(path, value) {
    return {type: 'SET', path: path.concat(['volume']), value};
  }
  deleteVolume(path) {
    return {type: 'DELETE', path: path.concat(['volume'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "soundName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlaySound(this);
              copy._hasSoundName = true;
              copy._soundName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSoundName) {
                return this;
              }
              const copy = new ActorAction_PlaySound(this);
              copy._hasSoundName = false;
              copy._soundName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "volume": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_PlaySound(this);
              copy._hasVolume = true;
              copy._volume = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVolume) {
                return this;
              }
              const copy = new ActorAction_PlaySound(this);
              copy._hasVolume = false;
              copy._volume = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_PlaySound} other
   * @returns {ActorAction_PlaySound}
   */
  merge(other) {
    const copy = new ActorAction_PlaySound(this);
    if (other._hasSoundName) {
      copy._hasSoundName = true;
      copy._soundName = other._soundName;
    }
    if (other._hasVolume) {
      copy._hasVolume = true;
      copy._volume = other._volume;
    }
    return copy;
  }
}
ActorAction_PlaySound.default = new ActorAction_PlaySound();
class ActorAction_PlaySound_Builder {
  constructor(value) {
    this._value = new ActorAction_PlaySound(value);
  }
  build() {
    return new ActorAction_PlaySound(this._value);
  }
  setSoundName(value) {
    this._value._hasSoundName = true;
    this._value._soundName = value;
    return this;
  }
  deleteSoundName() {
    this._value._hasSoundName = false;
    this._value._soundName = null;
    return this;
  }
  setVolume(value) {
    this._value._hasVolume = true;
    this._value._volume = value;
    return this;
  }
  deleteVolume() {
    this._value._hasVolume = false;
    this._value._volume = null;
    return this;
  }
}
ActorAction_PlaySound.Builder = ActorAction_PlaySound_Builder;
class ActorAction_PlaySound_WithParent {
  /**
   * @param {ActorAction_PlaySound} value
   * @param {ActorAction_PlaySound_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_PlaySound.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSoundName() {
    if (this._cachedHasSoundName === undefined) {
      if (this._value.hasSoundName) {
        this._cachedHasSoundName = true;
      } else {
        this._cachedHasSoundName = this._parent ? this._parent.hasSoundName : false;
      }
    }
    return this._cachedHasSoundName;
  }
  get soundName() {
    if (this._cachedSoundName === undefined) {
      if (this._value.hasSoundName) {
        this._cachedSoundName = this._value.soundName;
      } else {
        this._cachedSoundName = this._parent ? this._parent.soundName : this._value.soundName;
      }
    }
    return this._cachedSoundName;
  }
  get hasVolume() {
    if (this._cachedHasVolume === undefined) {
      if (this._value.hasVolume) {
        this._cachedHasVolume = true;
      } else {
        this._cachedHasVolume = this._parent ? this._parent.hasVolume : false;
      }
    }
    return this._cachedHasVolume;
  }
  get volume() {
    if (this._cachedVolume === undefined) {
      if (this._value.hasVolume) {
        this._cachedVolume = this._value.volume;
      } else {
        this._cachedVolume = this._parent ? this._parent.volume : this._value.volume;
      }
    }
    return this._cachedVolume;
  }
  update(current, parent) {
    const result = new ActorAction_PlaySound_WithParent(current, parent);
    return result;
  }
}
ActorAction_PlaySound_WithParent.default = new ActorAction_PlaySound_WithParent(ActorAction_PlaySound.default, null);
ActorAction_PlaySound.WithParent = ActorAction_PlaySound_WithParent;
class ActorAction_PlaySound_Descriptor {
  get soundName() {
    if (!this._soundName) {
      this._soundName = {
        name: "soundName",
        Name: "SoundName",
        number: 1,
        protoType: 9,
        protoName: "sound_name",
        type: JsonToString,
        options: {
          comments: "The name of the sound asset to play.",
          valueDropdown: "SupportedSoundNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._soundName;
  }
  get volume() {
    if (!this._volume) {
      this._volume = {
        name: "volume",
        Name: "Volume",
        number: 2,
        protoType: 1,
        protoName: "volume",
        type: JsonToDouble,
        options: {
          comments: "The volume multiplier for the sound. Using 0 defaults to 1.",
          default: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._volume;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.soundName,
        this.volume,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSoundName",
        Name: "DummyOneofForSoundName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVolume",
        Name: "DummyOneofForVolume",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_PlaySound.descriptor = new ActorAction_PlaySound_Descriptor();
class ActorAction_StopMusic {
  get descriptor() {
    return ActorAction_StopMusic.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPop = false;
    this._pop = null;
  }
  isEmpty() {
    if (this._hasPop) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_StopMusic) {
      return value;
    }
    return ActorAction_StopMusic.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_StopMusic();
    if (json.pop != null) {
      result._hasPop = true;
      result._pop = JsonToBoolean.fromJson(json.pop);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPop) {
      result.pop = JsonToBoolean.toJson(this._pop);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get pop() {
    return this._hasPop ? this._pop : JsonToBoolean.default;
  }
  get hasPop() {
    return this._hasPop;
  }
  setPop(path, value) {
    return {type: 'SET', path: path.concat(['pop']), value};
  }
  deletePop(path) {
    return {type: 'DELETE', path: path.concat(['pop'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "pop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_StopMusic(this);
              copy._hasPop = true;
              copy._pop = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPop) {
                return this;
              }
              const copy = new ActorAction_StopMusic(this);
              copy._hasPop = false;
              copy._pop = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_StopMusic} other
   * @returns {ActorAction_StopMusic}
   */
  merge(other) {
    const copy = new ActorAction_StopMusic(this);
    if (other._hasPop) {
      copy._hasPop = true;
      copy._pop = other._pop;
    }
    return copy;
  }
}
ActorAction_StopMusic.default = new ActorAction_StopMusic();
class ActorAction_StopMusic_Builder {
  constructor(value) {
    this._value = new ActorAction_StopMusic(value);
  }
  build() {
    return new ActorAction_StopMusic(this._value);
  }
  setPop(value) {
    this._value._hasPop = true;
    this._value._pop = value;
    return this;
  }
  deletePop() {
    this._value._hasPop = false;
    this._value._pop = null;
    return this;
  }
}
ActorAction_StopMusic.Builder = ActorAction_StopMusic_Builder;
class ActorAction_StopMusic_WithParent {
  /**
   * @param {ActorAction_StopMusic} value
   * @param {ActorAction_StopMusic_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_StopMusic.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPop() {
    if (this._cachedHasPop === undefined) {
      if (this._value.hasPop) {
        this._cachedHasPop = true;
      } else {
        this._cachedHasPop = this._parent ? this._parent.hasPop : false;
      }
    }
    return this._cachedHasPop;
  }
  get pop() {
    if (this._cachedPop === undefined) {
      if (this._value.hasPop) {
        this._cachedPop = this._value.pop;
      } else {
        this._cachedPop = this._parent ? this._parent.pop : this._value.pop;
      }
    }
    return this._cachedPop;
  }
  update(current, parent) {
    const result = new ActorAction_StopMusic_WithParent(current, parent);
    return result;
  }
}
ActorAction_StopMusic_WithParent.default = new ActorAction_StopMusic_WithParent(ActorAction_StopMusic.default, null);
ActorAction_StopMusic.WithParent = ActorAction_StopMusic_WithParent;
class ActorAction_StopMusic_Descriptor {
  get pop() {
    if (!this._pop) {
      this._pop = {
        name: "pop",
        Name: "Pop",
        number: 1,
        protoType: 8,
        protoName: "pop",
        type: JsonToBoolean,
        options: {
          comments: "If set to true, will play the previously saved music. If not set, the music will simply stop.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pop;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.pop,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPop",
        Name: "DummyOneofForPop",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_StopMusic.descriptor = new ActorAction_StopMusic_Descriptor();
class ActorAction_ShakeCamera_CameraShakeParameters {
  get descriptor() {
    return ActorAction_ShakeCamera_CameraShakeParameters.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDuration = false;
    this._duration = null;
    this._hasStrength = false;
    this._strength = null;
    this._hasVibrato = false;
    this._vibrato = null;
  }
  isEmpty() {
    if (this._hasDuration) return false;
    if (this._hasStrength) return false;
    if (this._hasVibrato) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_ShakeCamera_CameraShakeParameters) {
      return value;
    }
    return ActorAction_ShakeCamera_CameraShakeParameters.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_ShakeCamera_CameraShakeParameters();
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    if (json.strength != null) {
      result._hasStrength = true;
      result._strength = JsonToDouble.fromJson(json.strength);
    }
    if (json.vibrato != null) {
      result._hasVibrato = true;
      result._vibrato = JsonToInt32.fromJson(json.vibrato);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    if (this._hasStrength) {
      result.strength = JsonToDouble.toJson(this._strength);
    }
    if (this._hasVibrato) {
      result.vibrato = JsonToInt32.toJson(this._vibrato);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {number}
   */
  get strength() {
    return this._hasStrength ? this._strength : JsonToDouble.default;
  }
  get hasStrength() {
    return this._hasStrength;
  }
  setStrength(path, value) {
    return {type: 'SET', path: path.concat(['strength']), value};
  }
  deleteStrength(path) {
    return {type: 'DELETE', path: path.concat(['strength'])};
  }
  /**
   * @returns {number}
   */
  get vibrato() {
    return this._hasVibrato ? this._vibrato : JsonToInt32.default;
  }
  get hasVibrato() {
    return this._hasVibrato;
  }
  setVibrato(path, value) {
    return {type: 'SET', path: path.concat(['vibrato']), value};
  }
  deleteVibrato(path) {
    return {type: 'DELETE', path: path.concat(['vibrato'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "strength": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
              copy._hasStrength = true;
              copy._strength = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStrength) {
                return this;
              }
              const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
              copy._hasStrength = false;
              copy._strength = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "vibrato": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
              copy._hasVibrato = true;
              copy._vibrato = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVibrato) {
                return this;
              }
              const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
              copy._hasVibrato = false;
              copy._vibrato = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_ShakeCamera_CameraShakeParameters} other
   * @returns {ActorAction_ShakeCamera_CameraShakeParameters}
   */
  merge(other) {
    const copy = new ActorAction_ShakeCamera_CameraShakeParameters(this);
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasStrength) {
      copy._hasStrength = true;
      copy._strength = other._strength;
    }
    if (other._hasVibrato) {
      copy._hasVibrato = true;
      copy._vibrato = other._vibrato;
    }
    return copy;
  }
}
ActorAction_ShakeCamera_CameraShakeParameters.default = new ActorAction_ShakeCamera_CameraShakeParameters();
class ActorAction_ShakeCamera_CameraShakeParameters_Builder {
  constructor(value) {
    this._value = new ActorAction_ShakeCamera_CameraShakeParameters(value);
  }
  build() {
    return new ActorAction_ShakeCamera_CameraShakeParameters(this._value);
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setStrength(value) {
    this._value._hasStrength = true;
    this._value._strength = value;
    return this;
  }
  deleteStrength() {
    this._value._hasStrength = false;
    this._value._strength = null;
    return this;
  }
  setVibrato(value) {
    this._value._hasVibrato = true;
    this._value._vibrato = value;
    return this;
  }
  deleteVibrato() {
    this._value._hasVibrato = false;
    this._value._vibrato = null;
    return this;
  }
}
ActorAction_ShakeCamera_CameraShakeParameters.Builder = ActorAction_ShakeCamera_CameraShakeParameters_Builder;
class ActorAction_ShakeCamera_CameraShakeParameters_WithParent {
  /**
   * @param {ActorAction_ShakeCamera_CameraShakeParameters} value
   * @param {ActorAction_ShakeCamera_CameraShakeParameters_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_ShakeCamera_CameraShakeParameters.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasStrength() {
    if (this._cachedHasStrength === undefined) {
      if (this._value.hasStrength) {
        this._cachedHasStrength = true;
      } else {
        this._cachedHasStrength = this._parent ? this._parent.hasStrength : false;
      }
    }
    return this._cachedHasStrength;
  }
  get strength() {
    if (this._cachedStrength === undefined) {
      if (this._value.hasStrength) {
        this._cachedStrength = this._value.strength;
      } else {
        this._cachedStrength = this._parent ? this._parent.strength : this._value.strength;
      }
    }
    return this._cachedStrength;
  }
  get hasVibrato() {
    if (this._cachedHasVibrato === undefined) {
      if (this._value.hasVibrato) {
        this._cachedHasVibrato = true;
      } else {
        this._cachedHasVibrato = this._parent ? this._parent.hasVibrato : false;
      }
    }
    return this._cachedHasVibrato;
  }
  get vibrato() {
    if (this._cachedVibrato === undefined) {
      if (this._value.hasVibrato) {
        this._cachedVibrato = this._value.vibrato;
      } else {
        this._cachedVibrato = this._parent ? this._parent.vibrato : this._value.vibrato;
      }
    }
    return this._cachedVibrato;
  }
  update(current, parent) {
    const result = new ActorAction_ShakeCamera_CameraShakeParameters_WithParent(current, parent);
    return result;
  }
}
ActorAction_ShakeCamera_CameraShakeParameters_WithParent.default = new ActorAction_ShakeCamera_CameraShakeParameters_WithParent(ActorAction_ShakeCamera_CameraShakeParameters.default, null);
ActorAction_ShakeCamera_CameraShakeParameters.WithParent = ActorAction_ShakeCamera_CameraShakeParameters_WithParent;
class ActorAction_ShakeCamera_CameraShakeParameters_Descriptor {
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 1,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "The duration of the camera shake.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get strength() {
    if (!this._strength) {
      this._strength = {
        name: "strength",
        Name: "Strength",
        number: 2,
        protoType: 1,
        protoName: "strength",
        type: JsonToDouble,
        options: {
          comments: "The magnitude of the camera shake.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._strength;
  }
  get vibrato() {
    if (!this._vibrato) {
      this._vibrato = {
        name: "vibrato",
        Name: "Vibrato",
        number: 3,
        protoType: 5,
        protoName: "vibrato",
        type: JsonToInt32,
        options: {
          comments: "The vibration intensity of the camera shake.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._vibrato;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.duration,
        this.strength,
        this.vibrato,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStrength",
        Name: "DummyOneofForStrength",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVibrato",
        Name: "DummyOneofForVibrato",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_ShakeCamera_CameraShakeParameters.descriptor = new ActorAction_ShakeCamera_CameraShakeParameters_Descriptor();
class ActorAction_ShakeCamera {
  get descriptor() {
    return ActorAction_ShakeCamera.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValue = false;
    this._value = null;
    this._hasParameters = false;
    this._parameters = null;
  }
  isEmpty() {
    if (this._hasValue) return false;
    if (this._hasParameters && !this._parameters.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_ShakeCamera) {
      return value;
    }
    return ActorAction_ShakeCamera.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_ShakeCamera();
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToInt32.fromJson(json.value);
    }
    if (json.parameters != null) {
      result._hasParameters = true;
      result._parameters = ActorAction_ShakeCamera_CameraShakeParameters.fromJson(json.parameters);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValue) {
      result.value = JsonToInt32.toJson(this._value);
    }
    if (this._hasParameters && !this._parameters.isEmpty()) {
      result.parameters = ActorAction_ShakeCamera_CameraShakeParameters.toJson(this._parameters);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToInt32.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ActorAction_ShakeCamera_CameraShakeParameters}
   */
  get parameters() {
    return this._hasParameters ? this._parameters : ActorAction_ShakeCamera_CameraShakeParameters.default;
  }
  get hasParameters() {
    return this._hasParameters;
  }
  setParameters(path, value) {
    return {type: 'SET', path: path.concat(['parameters']), value: value.toJson()};
  }
  deleteParameters(path) {
    return {type: 'DELETE', path: path.concat(['parameters'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ShakeCamera(this);
              copy._hasValue = true;
              copy._value = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new ActorAction_ShakeCamera(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_ShakeCamera(this);
              copy._hasParameters = true;
              copy._parameters = ActorAction_ShakeCamera_CameraShakeParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParameters) {
                return this;
              }
              const copy = new ActorAction_ShakeCamera(this);
              copy._hasParameters = false;
              copy._parameters = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasParameters) {
            const copy = new ActorAction_ShakeCamera(this);
            copy._hasParameters = true;
            copy._parameters = ActorAction_ShakeCamera_CameraShakeParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._parameters.apply(type, path.slice(1), value);
          if (newValue === this._parameters) {
            return this;
          }
          const copy = new ActorAction_ShakeCamera(this);
          copy._parameters = copy._parameters.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_ShakeCamera} other
   * @returns {ActorAction_ShakeCamera}
   */
  merge(other) {
    const copy = new ActorAction_ShakeCamera(this);
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    if (other._hasParameters) {
      if (copy._hasParameters) {
        copy._parameters = copy.parameters.merge(other.parameters);
      } else {
        copy._parameters = other._parameters;
      }
      copy._hasParameters = true;
    }
    return copy;
  }
}
ActorAction_ShakeCamera.default = new ActorAction_ShakeCamera();
ActorAction_ShakeCamera.CameraShakeParameters = ActorAction_ShakeCamera_CameraShakeParameters;
class ActorAction_ShakeCamera_Builder {
  constructor(value) {
    this._value = new ActorAction_ShakeCamera(value);
  }
  build() {
    return new ActorAction_ShakeCamera(this._value);
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
  setParameters(value) {
    this._value._hasParameters = true;
    this._value._parameters = value;
    return this;
  }
  deleteParameters() {
    this._value._hasParameters = false;
    this._value._parameters = null;
    return this;
  }
}
ActorAction_ShakeCamera.Builder = ActorAction_ShakeCamera_Builder;
class ActorAction_ShakeCamera_WithParent {
  /**
   * @param {ActorAction_ShakeCamera} value
   * @param {ActorAction_ShakeCamera_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_ShakeCamera.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  get hasParameters() {
    if (this._cachedHasParameters === undefined) {
      if (this._value.hasParameters) {
        this._cachedHasParameters = true;
      } else {
        this._cachedHasParameters = this._parent ? this._parent.hasParameters : false;
      }
    }
    return this._cachedHasParameters;
  }
  get parameters() {
    if (!this._cachedParameters) {
      if (this._value.hasParameters) {
        this._cachedParameters = new ActorAction_ShakeCamera_CameraShakeParameters.WithParent(this._value.parameters, this._parent && this._parent.hasParameters ? this._parent.parameters : null);
      } else {
        this._cachedParameters = this._parent ? new ActorAction_ShakeCamera_CameraShakeParameters.WithParent(ActorAction_ShakeCamera_CameraShakeParameters.default, this._parent.parameters) : ActorAction_ShakeCamera_CameraShakeParameters.WithParent.default;
      }
    }
    return this._cachedParameters;
  }
  update(current, parent) {
    const result = new ActorAction_ShakeCamera_WithParent(current, parent);
    if (this._cachedParameters && this._value.hasParameters && current.hasParameters) {
      if (this._value.parameters === current.parameters && this._parent === parent) {
        result._cachedParameters = this._cachedParameters;
      } else {
        result._cachedParameters = this._cachedParameters.update(current.parameters, parent && parent.hasParameters ? parent.parameters : null);
      }
    }
    return result;
  }
}
ActorAction_ShakeCamera_WithParent.default = new ActorAction_ShakeCamera_WithParent(ActorAction_ShakeCamera.default, null);
ActorAction_ShakeCamera.WithParent = ActorAction_ShakeCamera_WithParent;
class ActorAction_ShakeCamera_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 5,
        protoName: "value",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get parameters() {
    if (!this._parameters) {
      this._parameters = {
        name: "parameters",
        Name: "Parameters",
        number: 2,
        protoType: 11,
        protoName: "parameters",
        type: ActorAction_ShakeCamera_CameraShakeParameters,
        options: {
          comments: "If no parameters are set, the default camera shake will be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parameters;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.parameters,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParameters",
        Name: "DummyOneofForParameters",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_ShakeCamera.descriptor = new ActorAction_ShakeCamera_Descriptor();
class ActorAction_SetVisibility {
  get descriptor() {
    return ActorAction_SetVisibility.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasVisibility = false;
    this._visibility = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasVisibility) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetVisibility) {
      return value;
    }
    return ActorAction_SetVisibility.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetVisibility();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.visibility != null) {
      result._hasVisibility = true;
      result._visibility = JsonToBoolean.fromJson(json.visibility);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasVisibility) {
      result.visibility = JsonToBoolean.toJson(this._visibility);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {boolean}
   */
  get visibility() {
    return this._hasVisibility ? this._visibility : JsonToBoolean.default;
  }
  get hasVisibility() {
    return this._hasVisibility;
  }
  setVisibility(path, value) {
    return {type: 'SET', path: path.concat(['visibility']), value};
  }
  deleteVisibility(path) {
    return {type: 'DELETE', path: path.concat(['visibility'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetVisibility(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetVisibility(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "visibility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetVisibility(this);
              copy._hasVisibility = true;
              copy._visibility = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVisibility) {
                return this;
              }
              const copy = new ActorAction_SetVisibility(this);
              copy._hasVisibility = false;
              copy._visibility = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetVisibility} other
   * @returns {ActorAction_SetVisibility}
   */
  merge(other) {
    const copy = new ActorAction_SetVisibility(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasVisibility) {
      copy._hasVisibility = true;
      copy._visibility = other._visibility;
    }
    return copy;
  }
}
ActorAction_SetVisibility.default = new ActorAction_SetVisibility();
class ActorAction_SetVisibility_Builder {
  constructor(value) {
    this._value = new ActorAction_SetVisibility(value);
  }
  build() {
    return new ActorAction_SetVisibility(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setVisibility(value) {
    this._value._hasVisibility = true;
    this._value._visibility = value;
    return this;
  }
  deleteVisibility() {
    this._value._hasVisibility = false;
    this._value._visibility = null;
    return this;
  }
}
ActorAction_SetVisibility.Builder = ActorAction_SetVisibility_Builder;
class ActorAction_SetVisibility_WithParent {
  /**
   * @param {ActorAction_SetVisibility} value
   * @param {ActorAction_SetVisibility_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetVisibility.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasVisibility() {
    if (this._cachedHasVisibility === undefined) {
      if (this._value.hasVisibility) {
        this._cachedHasVisibility = true;
      } else {
        this._cachedHasVisibility = this._parent ? this._parent.hasVisibility : false;
      }
    }
    return this._cachedHasVisibility;
  }
  get visibility() {
    if (this._cachedVisibility === undefined) {
      if (this._value.hasVisibility) {
        this._cachedVisibility = this._value.visibility;
      } else {
        this._cachedVisibility = this._parent ? this._parent.visibility : this._value.visibility;
      }
    }
    return this._cachedVisibility;
  }
  update(current, parent) {
    const result = new ActorAction_SetVisibility_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetVisibility_WithParent.default = new ActorAction_SetVisibility_WithParent(ActorAction_SetVisibility.default, null);
ActorAction_SetVisibility.WithParent = ActorAction_SetVisibility_WithParent;
class ActorAction_SetVisibility_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get visibility() {
    if (!this._visibility) {
      this._visibility = {
        name: "visibility",
        Name: "Visibility",
        number: 2,
        protoType: 8,
        protoName: "visibility",
        type: JsonToBoolean,
        options: {
          comments: "If disabled, hide the actor. If enabled, show the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._visibility;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.visibility,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVisibility",
        Name: "DummyOneofForVisibility",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetVisibility.descriptor = new ActorAction_SetVisibility_Descriptor();
class ActorAction_SetModelScale {
  get descriptor() {
    return ActorAction_SetModelScale.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasModelScale = false;
    this._modelScale = null;
    this._modelScaleExpression = [];
    this._hasDuration = false;
    this._duration = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasModelScale) return false;
    if (this._modelScaleExpression.length > 0) return false;
    if (this._hasDuration) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetModelScale) {
      return value;
    }
    return ActorAction_SetModelScale.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetModelScale();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.modelScale != null) {
      result._hasModelScale = true;
      result._modelScale = JsonToDouble.fromJson(json.modelScale);
    }
    result._modelScaleExpression = JsonToList(json.modelScaleExpression, ActorExpressions_Expression);
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToDouble.fromJson(json.duration);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasModelScale) {
      result.modelScale = JsonToDouble.toJson(this._modelScale);
    }
    if (this._modelScaleExpression.length > 0) {
      result.modelScaleExpression = ArrayToJson(this._modelScaleExpression, ActorExpressions_Expression);
    }
    if (this._hasDuration) {
      result.duration = JsonToDouble.toJson(this._duration);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {number}
   */
  get modelScale() {
    return this._hasModelScale ? this._modelScale : JsonToDouble.default;
  }
  get hasModelScale() {
    return this._hasModelScale;
  }
  setModelScale(path, value) {
    return {type: 'SET', path: path.concat(['modelScale']), value};
  }
  deleteModelScale(path) {
    return {type: 'DELETE', path: path.concat(['modelScale'])};
  }
  /**
   * @returns {ActorExpressions_Expression[]}
   */
  get modelScaleExpression() {
    return this._modelScaleExpression;
  }
  addModelScaleExpression(path, value) {
    return {type: 'ADD', path: path.concat(['modelScaleExpression']), value: value.toJson()};
  }
  setModelScaleExpression(path, value) {
    return {type: 'SET', path: path.concat(['modelScaleExpression']), value: ArrayToJson(value, ActorExpressions_Expression)};
  }
  setModelScaleExpressionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['modelScaleExpression', key]), value: value.toJson()};
  }
  deleteModelScaleExpression(path) {
    return {type: 'DELETE', path: path.concat(['modelScaleExpression'])};
  }
  deleteModelScaleExpressionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['modelScaleExpression', key])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToDouble.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetModelScale(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetModelScale(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modelScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetModelScale(this);
              copy._hasModelScale = true;
              copy._modelScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModelScale) {
                return this;
              }
              const copy = new ActorAction_SetModelScale(this);
              copy._hasModelScale = false;
              copy._modelScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modelScaleExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetModelScale(this);
              copy._modelScaleExpression = [];        for (let i of value) {
                copy._modelScaleExpression.push(ActorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorAction_SetModelScale(this);
              copy._modelScaleExpression = copy._modelScaleExpression.concat([ActorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._modelScaleExpression.length === 0) {
                return this;
              }
              const copy = new ActorAction_SetModelScale(this);
              copy._modelScaleExpression = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._modelScaleExpression.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetModelScale(this);
              copy._modelScaleExpression = copy._modelScaleExpression.slice();
              copy._modelScaleExpression[path[1]] = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorAction_SetModelScale(this);
              copy._modelScaleExpression = copy._modelScaleExpression.slice(0, path[1]).concat(copy._modelScaleExpression.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._modelScaleExpression.length) {
            return this;
          }
          const oldValue = this._modelScaleExpression[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorAction_SetModelScale(this);
          copy._modelScaleExpression = copy._modelScaleExpression.slice();
          copy._modelScaleExpression[key] = newValue;
          return copy;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetModelScale(this);
              copy._hasDuration = true;
              copy._duration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new ActorAction_SetModelScale(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetModelScale} other
   * @returns {ActorAction_SetModelScale}
   */
  merge(other) {
    const copy = new ActorAction_SetModelScale(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasModelScale) {
      copy._hasModelScale = true;
      copy._modelScale = other._modelScale;
    }
    copy._modelScaleExpression = this._modelScaleExpression.concat(other._modelScaleExpression);
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    return copy;
  }
}
ActorAction_SetModelScale.default = new ActorAction_SetModelScale();
class ActorAction_SetModelScale_Builder {
  constructor(value) {
    this._value = new ActorAction_SetModelScale(value);
  }
  build() {
    return new ActorAction_SetModelScale(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setModelScale(value) {
    this._value._hasModelScale = true;
    this._value._modelScale = value;
    return this;
  }
  deleteModelScale() {
    this._value._hasModelScale = false;
    this._value._modelScale = null;
    return this;
  }
  addAllModelScaleExpression(values) {
    this._value._modelScaleExpression = this._value._modelScaleExpression.concat(values);
    return this;
  }
  addModelScaleExpression(value) {
    this._value._modelScaleExpression = this._value._modelScaleExpression.concat([value]);
    return this;
  }
  setModelScaleExpression(index, value) {
    this._value._modelScaleExpression = this._value._modelScaleExpression.concat();
    this._value._modelScaleExpression[index] = value;
    return this;
  }
  clearModelScaleExpression() {
    this._value._modelScaleExpression = [];
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
}
ActorAction_SetModelScale.Builder = ActorAction_SetModelScale_Builder;
class ActorAction_SetModelScale_WithParent {
  /**
   * @param {ActorAction_SetModelScale} value
   * @param {ActorAction_SetModelScale_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetModelScale.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasModelScale() {
    if (this._cachedHasModelScale === undefined) {
      if (this._value.hasModelScale) {
        this._cachedHasModelScale = true;
      } else {
        this._cachedHasModelScale = this._parent ? this._parent.hasModelScale : false;
      }
    }
    return this._cachedHasModelScale;
  }
  get modelScale() {
    if (this._cachedModelScale === undefined) {
      if (this._value.hasModelScale) {
        this._cachedModelScale = this._value.modelScale;
      } else {
        this._cachedModelScale = this._parent ? this._parent.modelScale : this._value.modelScale;
      }
    }
    return this._cachedModelScale;
  }
  get selfModelScaleExpression() {
    if (!this._selfModelScaleExpression) {
      this._selfModelScaleExpression = [];
      for (let i of this._value.modelScaleExpression) {
        this._selfModelScaleExpression.push(new ActorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfModelScaleExpression;
  }
  get inherentModelScaleExpression() {
    if (!this._inherentModelScaleExpression) {
      this._inherentModelScaleExpression = this._parent ? this._parent.modelScaleExpression : [];
    }
    return this._inherentModelScaleExpression;
  }
  get modelScaleExpression() {
    if (!this._allModelScaleExpression) {
      this._allModelScaleExpression = this._parent ? this._parent.modelScaleExpression.concat(this.selfModelScaleExpression) : this.selfModelScaleExpression;
    }
    return this._allModelScaleExpression;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  update(current, parent) {
    const result = new ActorAction_SetModelScale_WithParent(current, parent);
    if (this._selfModelScaleExpression) {
      if (this._value.modelScaleExpression === current.modelScaleExpression) {
        result._selfModelScaleExpression = this._selfModelScaleExpression;
      } else {
        result._selfModelScaleExpression = [];
        for (let i = 0; i < current.modelScaleExpression.length; i++) {
          const oldValue = this._value.modelScaleExpression[i];
          if (oldValue) {
            const oldCache = this._selfModelScaleExpression[i];
            if (oldValue === current.modelScaleExpression[i]) {
              result._selfModelScaleExpression[i] = oldCache;
            } else {
              result._selfModelScaleExpression[i] = oldCache.update(current.modelScaleExpression[i], null);
            }
          } else {
            result._selfModelScaleExpression[i] = new ActorExpressions_Expression.WithParent(current.modelScaleExpression[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorAction_SetModelScale_WithParent.default = new ActorAction_SetModelScale_WithParent(ActorAction_SetModelScale.default, null);
ActorAction_SetModelScale.WithParent = ActorAction_SetModelScale_WithParent;
class ActorAction_SetModelScale_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The name of the actor that should receive the event. Can be aliases.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get modelScale() {
    if (!this._modelScale) {
      this._modelScale = {
        name: "modelScale",
        Name: "ModelScale",
        number: 2,
        protoType: 1,
        protoName: "model_scale",
        type: JsonToDouble,
        options: {
          comments: "Adjusts the size of the model over a duration. Using model scale 0 defaults to 1.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modelScale;
  }
  get modelScaleExpression() {
    if (!this._modelScaleExpression) {
      this._modelScaleExpression = {
        name: "modelScaleExpression",
        Name: "ModelScaleExpression",
        number: 4,
        protoType: 11,
        protoName: "model_scale_expression",
        type: ActorExpressions_Expression,
        isRepeated: true,
        options: {
          comments: "The evaluated expression is added to the **Model Scale**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modelScaleExpression;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 3,
        protoType: 1,
        protoName: "duration",
        type: JsonToDouble,
        options: {
          comments: "If set, the scale will be applied over this duration. This can be used to make simple grow/shrink animations.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.modelScale,
        this.modelScaleExpression,
        this.duration,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModelScale",
        Name: "DummyOneofForModelScale",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetModelScale.descriptor = new ActorAction_SetModelScale_Descriptor();
class ActorAction_SetSpriteFlip {
  get descriptor() {
    return ActorAction_SetSpriteFlip.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActor = false;
    this._actor = null;
    this._hasFlipX = false;
    this._flipX = null;
    this._hasFlipY = false;
    this._flipY = null;
  }
  isEmpty() {
    if (this._hasActor) return false;
    if (this._hasFlipX) return false;
    if (this._hasFlipY) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetSpriteFlip) {
      return value;
    }
    return ActorAction_SetSpriteFlip.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetSpriteFlip();
    if (json.actor != null) {
      result._hasActor = true;
      result._actor = JsonToString.fromJson(json.actor);
    }
    if (json.flipX != null) {
      result._hasFlipX = true;
      result._flipX = JsonToBoolean.fromJson(json.flipX);
    }
    if (json.flipY != null) {
      result._hasFlipY = true;
      result._flipY = JsonToBoolean.fromJson(json.flipY);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActor) {
      result.actor = JsonToString.toJson(this._actor);
    }
    if (this._hasFlipX) {
      result.flipX = JsonToBoolean.toJson(this._flipX);
    }
    if (this._hasFlipY) {
      result.flipY = JsonToBoolean.toJson(this._flipY);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get actor() {
    return this._hasActor ? this._actor : JsonToString.default;
  }
  get hasActor() {
    return this._hasActor;
  }
  setActor(path, value) {
    return {type: 'SET', path: path.concat(['actor']), value};
  }
  deleteActor(path) {
    return {type: 'DELETE', path: path.concat(['actor'])};
  }
  /**
   * @returns {boolean}
   */
  get flipX() {
    return this._hasFlipX ? this._flipX : JsonToBoolean.default;
  }
  get hasFlipX() {
    return this._hasFlipX;
  }
  setFlipX(path, value) {
    return {type: 'SET', path: path.concat(['flipX']), value};
  }
  deleteFlipX(path) {
    return {type: 'DELETE', path: path.concat(['flipX'])};
  }
  /**
   * @returns {boolean}
   */
  get flipY() {
    return this._hasFlipY ? this._flipY : JsonToBoolean.default;
  }
  get hasFlipY() {
    return this._hasFlipY;
  }
  setFlipY(path, value) {
    return {type: 'SET', path: path.concat(['flipY']), value};
  }
  deleteFlipY(path) {
    return {type: 'DELETE', path: path.concat(['flipY'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "actor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSpriteFlip(this);
              copy._hasActor = true;
              copy._actor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActor) {
                return this;
              }
              const copy = new ActorAction_SetSpriteFlip(this);
              copy._hasActor = false;
              copy._actor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "flipX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSpriteFlip(this);
              copy._hasFlipX = true;
              copy._flipX = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlipX) {
                return this;
              }
              const copy = new ActorAction_SetSpriteFlip(this);
              copy._hasFlipX = false;
              copy._flipX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "flipY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetSpriteFlip(this);
              copy._hasFlipY = true;
              copy._flipY = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlipY) {
                return this;
              }
              const copy = new ActorAction_SetSpriteFlip(this);
              copy._hasFlipY = false;
              copy._flipY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetSpriteFlip} other
   * @returns {ActorAction_SetSpriteFlip}
   */
  merge(other) {
    const copy = new ActorAction_SetSpriteFlip(this);
    if (other._hasActor) {
      copy._hasActor = true;
      copy._actor = other._actor;
    }
    if (other._hasFlipX) {
      copy._hasFlipX = true;
      copy._flipX = other._flipX;
    }
    if (other._hasFlipY) {
      copy._hasFlipY = true;
      copy._flipY = other._flipY;
    }
    return copy;
  }
}
ActorAction_SetSpriteFlip.default = new ActorAction_SetSpriteFlip();
class ActorAction_SetSpriteFlip_Builder {
  constructor(value) {
    this._value = new ActorAction_SetSpriteFlip(value);
  }
  build() {
    return new ActorAction_SetSpriteFlip(this._value);
  }
  setActor(value) {
    this._value._hasActor = true;
    this._value._actor = value;
    return this;
  }
  deleteActor() {
    this._value._hasActor = false;
    this._value._actor = null;
    return this;
  }
  setFlipX(value) {
    this._value._hasFlipX = true;
    this._value._flipX = value;
    return this;
  }
  deleteFlipX() {
    this._value._hasFlipX = false;
    this._value._flipX = null;
    return this;
  }
  setFlipY(value) {
    this._value._hasFlipY = true;
    this._value._flipY = value;
    return this;
  }
  deleteFlipY() {
    this._value._hasFlipY = false;
    this._value._flipY = null;
    return this;
  }
}
ActorAction_SetSpriteFlip.Builder = ActorAction_SetSpriteFlip_Builder;
class ActorAction_SetSpriteFlip_WithParent {
  /**
   * @param {ActorAction_SetSpriteFlip} value
   * @param {ActorAction_SetSpriteFlip_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetSpriteFlip.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActor() {
    if (this._cachedHasActor === undefined) {
      if (this._value.hasActor) {
        this._cachedHasActor = true;
      } else {
        this._cachedHasActor = this._parent ? this._parent.hasActor : false;
      }
    }
    return this._cachedHasActor;
  }
  get actor() {
    if (this._cachedActor === undefined) {
      if (this._value.hasActor) {
        this._cachedActor = this._value.actor;
      } else {
        this._cachedActor = this._parent ? this._parent.actor : this._value.actor;
      }
    }
    return this._cachedActor;
  }
  get hasFlipX() {
    if (this._cachedHasFlipX === undefined) {
      if (this._value.hasFlipX) {
        this._cachedHasFlipX = true;
      } else {
        this._cachedHasFlipX = this._parent ? this._parent.hasFlipX : false;
      }
    }
    return this._cachedHasFlipX;
  }
  get flipX() {
    if (this._cachedFlipX === undefined) {
      if (this._value.hasFlipX) {
        this._cachedFlipX = this._value.flipX;
      } else {
        this._cachedFlipX = this._parent ? this._parent.flipX : this._value.flipX;
      }
    }
    return this._cachedFlipX;
  }
  get hasFlipY() {
    if (this._cachedHasFlipY === undefined) {
      if (this._value.hasFlipY) {
        this._cachedHasFlipY = true;
      } else {
        this._cachedHasFlipY = this._parent ? this._parent.hasFlipY : false;
      }
    }
    return this._cachedHasFlipY;
  }
  get flipY() {
    if (this._cachedFlipY === undefined) {
      if (this._value.hasFlipY) {
        this._cachedFlipY = this._value.flipY;
      } else {
        this._cachedFlipY = this._parent ? this._parent.flipY : this._value.flipY;
      }
    }
    return this._cachedFlipY;
  }
  update(current, parent) {
    const result = new ActorAction_SetSpriteFlip_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetSpriteFlip_WithParent.default = new ActorAction_SetSpriteFlip_WithParent(ActorAction_SetSpriteFlip.default, null);
ActorAction_SetSpriteFlip.WithParent = ActorAction_SetSpriteFlip_WithParent;
class ActorAction_SetSpriteFlip_Descriptor {
  get actor() {
    if (!this._actor) {
      this._actor = {
        name: "actor",
        Name: "Actor",
        number: 1,
        protoType: 9,
        protoName: "actor",
        type: JsonToString,
        options: {
          comments: "The name of the actor that should receive the event. Accepts an actor name or alias.",
          default: "Self",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actor;
  }
  get flipX() {
    if (!this._flipX) {
      this._flipX = {
        name: "flipX",
        Name: "FlipX",
        number: 2,
        protoType: 8,
        protoName: "flip_x",
        type: JsonToBoolean,
        options: {
          comments: "If checked, flips the sprite horizontally.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flipX;
  }
  get flipY() {
    if (!this._flipY) {
      this._flipY = {
        name: "flipY",
        Name: "FlipY",
        number: 3,
        protoType: 8,
        protoName: "flip_y",
        type: JsonToBoolean,
        options: {
          comments: "If checked, flips the sprite vertically.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flipY;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.actor,
        this.flipX,
        this.flipY,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActor",
        Name: "DummyOneofForActor",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFlipX",
        Name: "DummyOneofForFlipX",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFlipY",
        Name: "DummyOneofForFlipY",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetSpriteFlip.descriptor = new ActorAction_SetSpriteFlip_Descriptor();
class ActorAction_SetWalkAnimation {
  get descriptor() {
    return ActorAction_SetWalkAnimation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetWalkAnimation) {
      return value;
    }
    return ActorAction_SetWalkAnimation.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetWalkAnimation();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetWalkAnimation(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_SetWalkAnimation(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetWalkAnimation} other
   * @returns {ActorAction_SetWalkAnimation}
   */
  merge(other) {
    const copy = new ActorAction_SetWalkAnimation(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    return copy;
  }
}
ActorAction_SetWalkAnimation.default = new ActorAction_SetWalkAnimation();
class ActorAction_SetWalkAnimation_Builder {
  constructor(value) {
    this._value = new ActorAction_SetWalkAnimation(value);
  }
  build() {
    return new ActorAction_SetWalkAnimation(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
}
ActorAction_SetWalkAnimation.Builder = ActorAction_SetWalkAnimation_Builder;
class ActorAction_SetWalkAnimation_WithParent {
  /**
   * @param {ActorAction_SetWalkAnimation} value
   * @param {ActorAction_SetWalkAnimation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetWalkAnimation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  update(current, parent) {
    const result = new ActorAction_SetWalkAnimation_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetWalkAnimation_WithParent.default = new ActorAction_SetWalkAnimation_WithParent(ActorAction_SetWalkAnimation.default, null);
ActorAction_SetWalkAnimation.WithParent = ActorAction_SetWalkAnimation_WithParent;
class ActorAction_SetWalkAnimation_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to play when unit is moving.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetWalkAnimation.descriptor = new ActorAction_SetWalkAnimation_Descriptor();
class ActorAction_SetIdleAnimation {
  get descriptor() {
    return ActorAction_SetIdleAnimation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClipId = false;
    this._clipId = null;
  }
  isEmpty() {
    if (this._hasClipId) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction_SetIdleAnimation) {
      return value;
    }
    return ActorAction_SetIdleAnimation.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction_SetIdleAnimation();
    if (json.clipId != null) {
      result._hasClipId = true;
      result._clipId = JsonToInt32.fromJson(json.clipId);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClipId) {
      result.clipId = JsonToInt32.toJson(this._clipId);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clipId() {
    return this._hasClipId ? this._clipId : JsonToInt32.default;
  }
  get hasClipId() {
    return this._hasClipId;
  }
  setClipId(path, value) {
    return {type: 'SET', path: path.concat(['clipId']), value};
  }
  deleteClipId(path) {
    return {type: 'DELETE', path: path.concat(['clipId'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clipId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction_SetIdleAnimation(this);
              copy._hasClipId = true;
              copy._clipId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClipId) {
                return this;
              }
              const copy = new ActorAction_SetIdleAnimation(this);
              copy._hasClipId = false;
              copy._clipId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction_SetIdleAnimation} other
   * @returns {ActorAction_SetIdleAnimation}
   */
  merge(other) {
    const copy = new ActorAction_SetIdleAnimation(this);
    if (other._hasClipId) {
      copy._hasClipId = true;
      copy._clipId = other._clipId;
    }
    return copy;
  }
}
ActorAction_SetIdleAnimation.default = new ActorAction_SetIdleAnimation();
class ActorAction_SetIdleAnimation_Builder {
  constructor(value) {
    this._value = new ActorAction_SetIdleAnimation(value);
  }
  build() {
    return new ActorAction_SetIdleAnimation(this._value);
  }
  setClipId(value) {
    this._value._hasClipId = true;
    this._value._clipId = value;
    return this;
  }
  deleteClipId() {
    this._value._hasClipId = false;
    this._value._clipId = null;
    return this;
  }
}
ActorAction_SetIdleAnimation.Builder = ActorAction_SetIdleAnimation_Builder;
class ActorAction_SetIdleAnimation_WithParent {
  /**
   * @param {ActorAction_SetIdleAnimation} value
   * @param {ActorAction_SetIdleAnimation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction_SetIdleAnimation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClipId() {
    if (this._cachedHasClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedHasClipId = true;
      } else {
        this._cachedHasClipId = this._parent ? this._parent.hasClipId : false;
      }
    }
    return this._cachedHasClipId;
  }
  get clipId() {
    if (this._cachedClipId === undefined) {
      if (this._value.hasClipId) {
        this._cachedClipId = this._value.clipId;
      } else {
        this._cachedClipId = this._parent ? this._parent.clipId : this._value.clipId;
      }
    }
    return this._cachedClipId;
  }
  update(current, parent) {
    const result = new ActorAction_SetIdleAnimation_WithParent(current, parent);
    return result;
  }
}
ActorAction_SetIdleAnimation_WithParent.default = new ActorAction_SetIdleAnimation_WithParent(ActorAction_SetIdleAnimation.default, null);
ActorAction_SetIdleAnimation.WithParent = ActorAction_SetIdleAnimation_WithParent;
class ActorAction_SetIdleAnimation_Descriptor {
  get clipId() {
    if (!this._clipId) {
      this._clipId = {
        name: "clipId",
        Name: "ClipId",
        number: 1,
        protoType: 5,
        protoName: "clip_id",
        type: JsonToInt32,
        options: {
          comments: "Which animation to play when unit is idle.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clipId;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clipId,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClipId",
        Name: "DummyOneofForClipId",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction_SetIdleAnimation.descriptor = new ActorAction_SetIdleAnimation_Descriptor();
export class ActorAction {
  get descriptor() {
    return ActorAction.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofActorActionCase = 0;
    this._oneofActorActionValue = null;
  }
  isEmpty() {
    if (this._oneofActorActionCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorAction) {
      return value;
    }
    return ActorAction.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorAction();
    if (json.playAnimation != null) {
      result._oneofActorActionCase = 1;
      result._oneofActorActionValue = ActorAction_PlayAnimation.fromJson(json.playAnimation);
    }
    if (json.stopAnimation != null) {
      result._oneofActorActionCase = 2;
      result._oneofActorActionValue = ActorAction_StopAnimation.fromJson(json.stopAnimation);
    }
    if (json.create != null) {
      result._oneofActorActionCase = 3;
      result._oneofActorActionValue = ActorAction_CreateActor.fromJson(json.create);
    }
    if (json.destroy != null) {
      result._oneofActorActionCase = 4;
      result._oneofActorActionValue = ActorAction_DestroyActor.fromJson(json.destroy);
    }
    if (json.log != null) {
      result._oneofActorActionCase = 6;
      result._oneofActorActionValue = ActorAction_DebugLog.fromJson(json.log);
    }
    if (json.createTimer != null) {
      result._oneofActorActionCase = 7;
      result._oneofActorActionValue = ActorAction_CreateTimer.fromJson(json.createTimer);
    }
    if (json.removeTimer != null) {
      result._oneofActorActionCase = 8;
      result._oneofActorActionValue = ActorAction_RemoveTimer.fromJson(json.removeTimer);
    }
    if (json.setSiteOperations != null) {
      result._oneofActorActionCase = 9;
      result._oneofActorActionValue = ActorAction_SetSiteOperations.fromJson(json.setSiteOperations);
    }
    if (json.createAliases != null) {
      result._oneofActorActionCase = 10;
      result._oneofActorActionValue = ActorAction_CreateAliases.fromJson(json.createAliases);
    }
    if (json.setVariable != null) {
      result._oneofActorActionCase = 11;
      result._oneofActorActionValue = ActorAction_SetVariable.fromJson(json.setVariable);
    }
    if (json.sendCustomEvent != null) {
      result._oneofActorActionCase = 12;
      result._oneofActorActionValue = ActorAction_SendCustomEvent.fromJson(json.sendCustomEvent);
    }
    if (json.setTintColor != null) {
      result._oneofActorActionCase = 13;
      result._oneofActorActionValue = ActorAction_SetTintColor.fromJson(json.setTintColor);
    }
    if (json.setMeshEffect != null) {
      result._oneofActorActionCase = 14;
      result._oneofActorActionValue = ActorAction_SetMeshEffect.fromJson(json.setMeshEffect);
    }
    if (json.playMusic != null) {
      result._oneofActorActionCase = 15;
      result._oneofActorActionValue = ActorAction_PlayMusic.fromJson(json.playMusic);
    }
    if (json.stopMusic != null) {
      result._oneofActorActionCase = 16;
      result._oneofActorActionValue = ActorAction_StopMusic.fromJson(json.stopMusic);
    }
    if (json.shakeCamera != null) {
      result._oneofActorActionCase = 17;
      result._oneofActorActionValue = ActorAction_ShakeCamera.fromJson(json.shakeCamera);
    }
    if (json.setVisibility != null) {
      result._oneofActorActionCase = 18;
      result._oneofActorActionValue = ActorAction_SetVisibility.fromJson(json.setVisibility);
    }
    if (json.setModelScale != null) {
      result._oneofActorActionCase = 19;
      result._oneofActorActionValue = ActorAction_SetModelScale.fromJson(json.setModelScale);
    }
    if (json.broadcastCustomEvent != null) {
      result._oneofActorActionCase = 20;
      result._oneofActorActionValue = ActorAction_BroadcastCustomEvent.fromJson(json.broadcastCustomEvent);
    }
    if (json.applyMeshEffect != null) {
      result._oneofActorActionCase = 21;
      result._oneofActorActionValue = ActorAction_ApplyMeshEffect.fromJson(json.applyMeshEffect);
    }
    if (json.removeMeshEffect != null) {
      result._oneofActorActionCase = 22;
      result._oneofActorActionValue = ActorAction_RemoveMeshEffect.fromJson(json.removeMeshEffect);
    }
    if (json.setTeamColor != null) {
      result._oneofActorActionCase = 25;
      result._oneofActorActionValue = ActorAction_SetTeamColor.fromJson(json.setTeamColor);
    }
    if (json.setShadowHeight != null) {
      result._oneofActorActionCase = 26;
      result._oneofActorActionValue = ActorAction_SetShadowHeight.fromJson(json.setShadowHeight);
    }
    if (json.playAnimationWithDuration != null) {
      result._oneofActorActionCase = 27;
      result._oneofActorActionValue = ActorAction_PlayAnimationWithDuration.fromJson(json.playAnimationWithDuration);
    }
    if (json.pauseAnimation != null) {
      result._oneofActorActionCase = 28;
      result._oneofActorActionValue = ActorAction_PauseAnimation.fromJson(json.pauseAnimation);
    }
    if (json.resumeAnimation != null) {
      result._oneofActorActionCase = 29;
      result._oneofActorActionValue = ActorAction_ResumeAnimation.fromJson(json.resumeAnimation);
    }
    if (json.playSound != null) {
      result._oneofActorActionCase = 30;
      result._oneofActorActionValue = ActorAction_PlaySound.fromJson(json.playSound);
    }
    if (json.setScaleMultiplier != null) {
      result._oneofActorActionCase = 31;
      result._oneofActorActionValue = ActorAction_SetScaleMultiplier.fromJson(json.setScaleMultiplier);
    }
    if (json.setShadow != null) {
      result._oneofActorActionCase = 32;
      result._oneofActorActionValue = ActorAction_SetShadow.fromJson(json.setShadow);
    }
    if (json.clearTintColor != null) {
      result._oneofActorActionCase = 33;
      result._oneofActorActionValue = ActorAction_ClearTintColor.fromJson(json.clearTintColor);
    }
    if (json.setOutline != null) {
      result._oneofActorActionCase = 34;
      result._oneofActorActionValue = ActorAction_SetOutline.fromJson(json.setOutline);
    }
    if (json.setSpriteFlip != null) {
      result._oneofActorActionCase = 35;
      result._oneofActorActionValue = ActorAction_SetSpriteFlip.fromJson(json.setSpriteFlip);
    }
    if (json.clearOutline != null) {
      result._oneofActorActionCase = 36;
      result._oneofActorActionValue = ActorAction_ClearOutline.fromJson(json.clearOutline);
    }
    if (json.setWalkAnimation != null) {
      result._oneofActorActionCase = 37;
      result._oneofActorActionValue = ActorAction_SetWalkAnimation.fromJson(json.setWalkAnimation);
    }
    if (json.setIdleAnimation != null) {
      result._oneofActorActionCase = 38;
      result._oneofActorActionValue = ActorAction_SetIdleAnimation.fromJson(json.setIdleAnimation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofActorActionCase) {
      case 1:
        result.playAnimation = ActorAction_PlayAnimation.toJson(this._oneofActorActionValue);
        break;
      case 2:
        result.stopAnimation = ActorAction_StopAnimation.toJson(this._oneofActorActionValue);
        break;
      case 3:
        result.create = ActorAction_CreateActor.toJson(this._oneofActorActionValue);
        break;
      case 4:
        result.destroy = ActorAction_DestroyActor.toJson(this._oneofActorActionValue);
        break;
      case 6:
        result.log = ActorAction_DebugLog.toJson(this._oneofActorActionValue);
        break;
      case 7:
        result.createTimer = ActorAction_CreateTimer.toJson(this._oneofActorActionValue);
        break;
      case 8:
        result.removeTimer = ActorAction_RemoveTimer.toJson(this._oneofActorActionValue);
        break;
      case 9:
        result.setSiteOperations = ActorAction_SetSiteOperations.toJson(this._oneofActorActionValue);
        break;
      case 10:
        result.createAliases = ActorAction_CreateAliases.toJson(this._oneofActorActionValue);
        break;
      case 11:
        result.setVariable = ActorAction_SetVariable.toJson(this._oneofActorActionValue);
        break;
      case 12:
        result.sendCustomEvent = ActorAction_SendCustomEvent.toJson(this._oneofActorActionValue);
        break;
      case 13:
        result.setTintColor = ActorAction_SetTintColor.toJson(this._oneofActorActionValue);
        break;
      case 14:
        result.setMeshEffect = ActorAction_SetMeshEffect.toJson(this._oneofActorActionValue);
        break;
      case 15:
        result.playMusic = ActorAction_PlayMusic.toJson(this._oneofActorActionValue);
        break;
      case 16:
        result.stopMusic = ActorAction_StopMusic.toJson(this._oneofActorActionValue);
        break;
      case 17:
        result.shakeCamera = ActorAction_ShakeCamera.toJson(this._oneofActorActionValue);
        break;
      case 18:
        result.setVisibility = ActorAction_SetVisibility.toJson(this._oneofActorActionValue);
        break;
      case 19:
        result.setModelScale = ActorAction_SetModelScale.toJson(this._oneofActorActionValue);
        break;
      case 20:
        result.broadcastCustomEvent = ActorAction_BroadcastCustomEvent.toJson(this._oneofActorActionValue);
        break;
      case 21:
        result.applyMeshEffect = ActorAction_ApplyMeshEffect.toJson(this._oneofActorActionValue);
        break;
      case 22:
        result.removeMeshEffect = ActorAction_RemoveMeshEffect.toJson(this._oneofActorActionValue);
        break;
      case 25:
        result.setTeamColor = ActorAction_SetTeamColor.toJson(this._oneofActorActionValue);
        break;
      case 26:
        result.setShadowHeight = ActorAction_SetShadowHeight.toJson(this._oneofActorActionValue);
        break;
      case 27:
        result.playAnimationWithDuration = ActorAction_PlayAnimationWithDuration.toJson(this._oneofActorActionValue);
        break;
      case 28:
        result.pauseAnimation = ActorAction_PauseAnimation.toJson(this._oneofActorActionValue);
        break;
      case 29:
        result.resumeAnimation = ActorAction_ResumeAnimation.toJson(this._oneofActorActionValue);
        break;
      case 30:
        result.playSound = ActorAction_PlaySound.toJson(this._oneofActorActionValue);
        break;
      case 31:
        result.setScaleMultiplier = ActorAction_SetScaleMultiplier.toJson(this._oneofActorActionValue);
        break;
      case 32:
        result.setShadow = ActorAction_SetShadow.toJson(this._oneofActorActionValue);
        break;
      case 33:
        result.clearTintColor = ActorAction_ClearTintColor.toJson(this._oneofActorActionValue);
        break;
      case 34:
        result.setOutline = ActorAction_SetOutline.toJson(this._oneofActorActionValue);
        break;
      case 35:
        result.setSpriteFlip = ActorAction_SetSpriteFlip.toJson(this._oneofActorActionValue);
        break;
      case 36:
        result.clearOutline = ActorAction_ClearOutline.toJson(this._oneofActorActionValue);
        break;
      case 37:
        result.setWalkAnimation = ActorAction_SetWalkAnimation.toJson(this._oneofActorActionValue);
        break;
      case 38:
        result.setIdleAnimation = ActorAction_SetIdleAnimation.toJson(this._oneofActorActionValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofActorActionCase() {
    return this._oneofActorActionCase;
  }
  deleteOneofActorAction(path) {
    switch (this._oneofActorActionCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['playAnimation'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['stopAnimation'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['create'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['destroy'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['log'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['createTimer'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['removeTimer'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['setSiteOperations'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['createAliases'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['setVariable'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['sendCustomEvent'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['setTintColor'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['setMeshEffect'])};
      }
      case 15: {
        return {type: 'DELETE', path: path.concat(['playMusic'])};
      }
      case 16: {
        return {type: 'DELETE', path: path.concat(['stopMusic'])};
      }
      case 17: {
        return {type: 'DELETE', path: path.concat(['shakeCamera'])};
      }
      case 18: {
        return {type: 'DELETE', path: path.concat(['setVisibility'])};
      }
      case 19: {
        return {type: 'DELETE', path: path.concat(['setModelScale'])};
      }
      case 20: {
        return {type: 'DELETE', path: path.concat(['broadcastCustomEvent'])};
      }
      case 21: {
        return {type: 'DELETE', path: path.concat(['applyMeshEffect'])};
      }
      case 22: {
        return {type: 'DELETE', path: path.concat(['removeMeshEffect'])};
      }
      case 25: {
        return {type: 'DELETE', path: path.concat(['setTeamColor'])};
      }
      case 26: {
        return {type: 'DELETE', path: path.concat(['setShadowHeight'])};
      }
      case 27: {
        return {type: 'DELETE', path: path.concat(['playAnimationWithDuration'])};
      }
      case 28: {
        return {type: 'DELETE', path: path.concat(['pauseAnimation'])};
      }
      case 29: {
        return {type: 'DELETE', path: path.concat(['resumeAnimation'])};
      }
      case 30: {
        return {type: 'DELETE', path: path.concat(['playSound'])};
      }
      case 31: {
        return {type: 'DELETE', path: path.concat(['setScaleMultiplier'])};
      }
      case 32: {
        return {type: 'DELETE', path: path.concat(['setShadow'])};
      }
      case 33: {
        return {type: 'DELETE', path: path.concat(['clearTintColor'])};
      }
      case 34: {
        return {type: 'DELETE', path: path.concat(['setOutline'])};
      }
      case 35: {
        return {type: 'DELETE', path: path.concat(['setSpriteFlip'])};
      }
      case 36: {
        return {type: 'DELETE', path: path.concat(['clearOutline'])};
      }
      case 37: {
        return {type: 'DELETE', path: path.concat(['setWalkAnimation'])};
      }
      case 38: {
        return {type: 'DELETE', path: path.concat(['setIdleAnimation'])};
      }
    }
  }
  /**
   * @returns {ActorAction_PlayAnimation}
   */
  get playAnimation() {
    return this._oneofActorActionCase === 1 ? this._oneofActorActionValue : ActorAction_PlayAnimation.default;
  }
  setPlayAnimation(path, value) {
    return {type: 'SET', path: path.concat(['playAnimation']), value: value.toJson()};
  }
  deletePlayAnimation(path) {
    return {type: 'DELETE', path: path.concat(['playAnimation'])};
  }
  /**
   * @returns {ActorAction_StopAnimation}
   */
  get stopAnimation() {
    return this._oneofActorActionCase === 2 ? this._oneofActorActionValue : ActorAction_StopAnimation.default;
  }
  setStopAnimation(path, value) {
    return {type: 'SET', path: path.concat(['stopAnimation']), value: value.toJson()};
  }
  deleteStopAnimation(path) {
    return {type: 'DELETE', path: path.concat(['stopAnimation'])};
  }
  /**
   * @returns {ActorAction_CreateActor}
   */
  get create() {
    return this._oneofActorActionCase === 3 ? this._oneofActorActionValue : ActorAction_CreateActor.default;
  }
  setCreate(path, value) {
    return {type: 'SET', path: path.concat(['create']), value: value.toJson()};
  }
  deleteCreate(path) {
    return {type: 'DELETE', path: path.concat(['create'])};
  }
  /**
   * @returns {ActorAction_DestroyActor}
   */
  get destroy() {
    return this._oneofActorActionCase === 4 ? this._oneofActorActionValue : ActorAction_DestroyActor.default;
  }
  setDestroy(path, value) {
    return {type: 'SET', path: path.concat(['destroy']), value: value.toJson()};
  }
  deleteDestroy(path) {
    return {type: 'DELETE', path: path.concat(['destroy'])};
  }
  /**
   * @returns {ActorAction_DebugLog}
   */
  get log() {
    return this._oneofActorActionCase === 6 ? this._oneofActorActionValue : ActorAction_DebugLog.default;
  }
  setLog(path, value) {
    return {type: 'SET', path: path.concat(['log']), value: value.toJson()};
  }
  deleteLog(path) {
    return {type: 'DELETE', path: path.concat(['log'])};
  }
  /**
   * @returns {ActorAction_CreateTimer}
   */
  get createTimer() {
    return this._oneofActorActionCase === 7 ? this._oneofActorActionValue : ActorAction_CreateTimer.default;
  }
  setCreateTimer(path, value) {
    return {type: 'SET', path: path.concat(['createTimer']), value: value.toJson()};
  }
  deleteCreateTimer(path) {
    return {type: 'DELETE', path: path.concat(['createTimer'])};
  }
  /**
   * @returns {ActorAction_RemoveTimer}
   */
  get removeTimer() {
    return this._oneofActorActionCase === 8 ? this._oneofActorActionValue : ActorAction_RemoveTimer.default;
  }
  setRemoveTimer(path, value) {
    return {type: 'SET', path: path.concat(['removeTimer']), value: value.toJson()};
  }
  deleteRemoveTimer(path) {
    return {type: 'DELETE', path: path.concat(['removeTimer'])};
  }
  /**
   * @returns {ActorAction_SetSiteOperations}
   */
  get setSiteOperations() {
    return this._oneofActorActionCase === 9 ? this._oneofActorActionValue : ActorAction_SetSiteOperations.default;
  }
  setSetSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['setSiteOperations']), value: value.toJson()};
  }
  deleteSetSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['setSiteOperations'])};
  }
  /**
   * @returns {ActorAction_CreateAliases}
   */
  get createAliases() {
    return this._oneofActorActionCase === 10 ? this._oneofActorActionValue : ActorAction_CreateAliases.default;
  }
  setCreateAliases(path, value) {
    return {type: 'SET', path: path.concat(['createAliases']), value: value.toJson()};
  }
  deleteCreateAliases(path) {
    return {type: 'DELETE', path: path.concat(['createAliases'])};
  }
  /**
   * @returns {ActorAction_SetVariable}
   */
  get setVariable() {
    return this._oneofActorActionCase === 11 ? this._oneofActorActionValue : ActorAction_SetVariable.default;
  }
  setSetVariable(path, value) {
    return {type: 'SET', path: path.concat(['setVariable']), value: value.toJson()};
  }
  deleteSetVariable(path) {
    return {type: 'DELETE', path: path.concat(['setVariable'])};
  }
  /**
   * @returns {ActorAction_SendCustomEvent}
   */
  get sendCustomEvent() {
    return this._oneofActorActionCase === 12 ? this._oneofActorActionValue : ActorAction_SendCustomEvent.default;
  }
  setSendCustomEvent(path, value) {
    return {type: 'SET', path: path.concat(['sendCustomEvent']), value: value.toJson()};
  }
  deleteSendCustomEvent(path) {
    return {type: 'DELETE', path: path.concat(['sendCustomEvent'])};
  }
  /**
   * @returns {ActorAction_SetTintColor}
   */
  get setTintColor() {
    return this._oneofActorActionCase === 13 ? this._oneofActorActionValue : ActorAction_SetTintColor.default;
  }
  setSetTintColor(path, value) {
    return {type: 'SET', path: path.concat(['setTintColor']), value: value.toJson()};
  }
  deleteSetTintColor(path) {
    return {type: 'DELETE', path: path.concat(['setTintColor'])};
  }
  /**
   * @returns {ActorAction_SetMeshEffect}
   */
  get setMeshEffect() {
    return this._oneofActorActionCase === 14 ? this._oneofActorActionValue : ActorAction_SetMeshEffect.default;
  }
  setSetMeshEffect(path, value) {
    return {type: 'SET', path: path.concat(['setMeshEffect']), value: value.toJson()};
  }
  deleteSetMeshEffect(path) {
    return {type: 'DELETE', path: path.concat(['setMeshEffect'])};
  }
  /**
   * @returns {ActorAction_PlayMusic}
   */
  get playMusic() {
    return this._oneofActorActionCase === 15 ? this._oneofActorActionValue : ActorAction_PlayMusic.default;
  }
  setPlayMusic(path, value) {
    return {type: 'SET', path: path.concat(['playMusic']), value: value.toJson()};
  }
  deletePlayMusic(path) {
    return {type: 'DELETE', path: path.concat(['playMusic'])};
  }
  /**
   * @returns {ActorAction_StopMusic}
   */
  get stopMusic() {
    return this._oneofActorActionCase === 16 ? this._oneofActorActionValue : ActorAction_StopMusic.default;
  }
  setStopMusic(path, value) {
    return {type: 'SET', path: path.concat(['stopMusic']), value: value.toJson()};
  }
  deleteStopMusic(path) {
    return {type: 'DELETE', path: path.concat(['stopMusic'])};
  }
  /**
   * @returns {ActorAction_ShakeCamera}
   */
  get shakeCamera() {
    return this._oneofActorActionCase === 17 ? this._oneofActorActionValue : ActorAction_ShakeCamera.default;
  }
  setShakeCamera(path, value) {
    return {type: 'SET', path: path.concat(['shakeCamera']), value: value.toJson()};
  }
  deleteShakeCamera(path) {
    return {type: 'DELETE', path: path.concat(['shakeCamera'])};
  }
  /**
   * @returns {ActorAction_SetVisibility}
   */
  get setVisibility() {
    return this._oneofActorActionCase === 18 ? this._oneofActorActionValue : ActorAction_SetVisibility.default;
  }
  setSetVisibility(path, value) {
    return {type: 'SET', path: path.concat(['setVisibility']), value: value.toJson()};
  }
  deleteSetVisibility(path) {
    return {type: 'DELETE', path: path.concat(['setVisibility'])};
  }
  /**
   * @returns {ActorAction_SetModelScale}
   */
  get setModelScale() {
    return this._oneofActorActionCase === 19 ? this._oneofActorActionValue : ActorAction_SetModelScale.default;
  }
  setSetModelScale(path, value) {
    return {type: 'SET', path: path.concat(['setModelScale']), value: value.toJson()};
  }
  deleteSetModelScale(path) {
    return {type: 'DELETE', path: path.concat(['setModelScale'])};
  }
  /**
   * @returns {ActorAction_BroadcastCustomEvent}
   */
  get broadcastCustomEvent() {
    return this._oneofActorActionCase === 20 ? this._oneofActorActionValue : ActorAction_BroadcastCustomEvent.default;
  }
  setBroadcastCustomEvent(path, value) {
    return {type: 'SET', path: path.concat(['broadcastCustomEvent']), value: value.toJson()};
  }
  deleteBroadcastCustomEvent(path) {
    return {type: 'DELETE', path: path.concat(['broadcastCustomEvent'])};
  }
  /**
   * @returns {ActorAction_ApplyMeshEffect}
   */
  get applyMeshEffect() {
    return this._oneofActorActionCase === 21 ? this._oneofActorActionValue : ActorAction_ApplyMeshEffect.default;
  }
  setApplyMeshEffect(path, value) {
    return {type: 'SET', path: path.concat(['applyMeshEffect']), value: value.toJson()};
  }
  deleteApplyMeshEffect(path) {
    return {type: 'DELETE', path: path.concat(['applyMeshEffect'])};
  }
  /**
   * @returns {ActorAction_RemoveMeshEffect}
   */
  get removeMeshEffect() {
    return this._oneofActorActionCase === 22 ? this._oneofActorActionValue : ActorAction_RemoveMeshEffect.default;
  }
  setRemoveMeshEffect(path, value) {
    return {type: 'SET', path: path.concat(['removeMeshEffect']), value: value.toJson()};
  }
  deleteRemoveMeshEffect(path) {
    return {type: 'DELETE', path: path.concat(['removeMeshEffect'])};
  }
  /**
   * @returns {ActorAction_SetTeamColor}
   */
  get setTeamColor() {
    return this._oneofActorActionCase === 25 ? this._oneofActorActionValue : ActorAction_SetTeamColor.default;
  }
  setSetTeamColor(path, value) {
    return {type: 'SET', path: path.concat(['setTeamColor']), value: value.toJson()};
  }
  deleteSetTeamColor(path) {
    return {type: 'DELETE', path: path.concat(['setTeamColor'])};
  }
  /**
   * @returns {ActorAction_SetShadowHeight}
   */
  get setShadowHeight() {
    return this._oneofActorActionCase === 26 ? this._oneofActorActionValue : ActorAction_SetShadowHeight.default;
  }
  setSetShadowHeight(path, value) {
    return {type: 'SET', path: path.concat(['setShadowHeight']), value: value.toJson()};
  }
  deleteSetShadowHeight(path) {
    return {type: 'DELETE', path: path.concat(['setShadowHeight'])};
  }
  /**
   * @returns {ActorAction_PlayAnimationWithDuration}
   */
  get playAnimationWithDuration() {
    return this._oneofActorActionCase === 27 ? this._oneofActorActionValue : ActorAction_PlayAnimationWithDuration.default;
  }
  setPlayAnimationWithDuration(path, value) {
    return {type: 'SET', path: path.concat(['playAnimationWithDuration']), value: value.toJson()};
  }
  deletePlayAnimationWithDuration(path) {
    return {type: 'DELETE', path: path.concat(['playAnimationWithDuration'])};
  }
  /**
   * @returns {ActorAction_PauseAnimation}
   */
  get pauseAnimation() {
    return this._oneofActorActionCase === 28 ? this._oneofActorActionValue : ActorAction_PauseAnimation.default;
  }
  setPauseAnimation(path, value) {
    return {type: 'SET', path: path.concat(['pauseAnimation']), value: value.toJson()};
  }
  deletePauseAnimation(path) {
    return {type: 'DELETE', path: path.concat(['pauseAnimation'])};
  }
  /**
   * @returns {ActorAction_ResumeAnimation}
   */
  get resumeAnimation() {
    return this._oneofActorActionCase === 29 ? this._oneofActorActionValue : ActorAction_ResumeAnimation.default;
  }
  setResumeAnimation(path, value) {
    return {type: 'SET', path: path.concat(['resumeAnimation']), value: value.toJson()};
  }
  deleteResumeAnimation(path) {
    return {type: 'DELETE', path: path.concat(['resumeAnimation'])};
  }
  /**
   * @returns {ActorAction_PlaySound}
   */
  get playSound() {
    return this._oneofActorActionCase === 30 ? this._oneofActorActionValue : ActorAction_PlaySound.default;
  }
  setPlaySound(path, value) {
    return {type: 'SET', path: path.concat(['playSound']), value: value.toJson()};
  }
  deletePlaySound(path) {
    return {type: 'DELETE', path: path.concat(['playSound'])};
  }
  /**
   * @returns {ActorAction_SetScaleMultiplier}
   */
  get setScaleMultiplier() {
    return this._oneofActorActionCase === 31 ? this._oneofActorActionValue : ActorAction_SetScaleMultiplier.default;
  }
  setSetScaleMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['setScaleMultiplier']), value: value.toJson()};
  }
  deleteSetScaleMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['setScaleMultiplier'])};
  }
  /**
   * @returns {ActorAction_SetShadow}
   */
  get setShadow() {
    return this._oneofActorActionCase === 32 ? this._oneofActorActionValue : ActorAction_SetShadow.default;
  }
  setSetShadow(path, value) {
    return {type: 'SET', path: path.concat(['setShadow']), value: value.toJson()};
  }
  deleteSetShadow(path) {
    return {type: 'DELETE', path: path.concat(['setShadow'])};
  }
  /**
   * @returns {ActorAction_ClearTintColor}
   */
  get clearTintColor() {
    return this._oneofActorActionCase === 33 ? this._oneofActorActionValue : ActorAction_ClearTintColor.default;
  }
  setClearTintColor(path, value) {
    return {type: 'SET', path: path.concat(['clearTintColor']), value: value.toJson()};
  }
  deleteClearTintColor(path) {
    return {type: 'DELETE', path: path.concat(['clearTintColor'])};
  }
  /**
   * @returns {ActorAction_SetOutline}
   */
  get setOutline() {
    return this._oneofActorActionCase === 34 ? this._oneofActorActionValue : ActorAction_SetOutline.default;
  }
  setSetOutline(path, value) {
    return {type: 'SET', path: path.concat(['setOutline']), value: value.toJson()};
  }
  deleteSetOutline(path) {
    return {type: 'DELETE', path: path.concat(['setOutline'])};
  }
  /**
   * @returns {ActorAction_SetSpriteFlip}
   */
  get setSpriteFlip() {
    return this._oneofActorActionCase === 35 ? this._oneofActorActionValue : ActorAction_SetSpriteFlip.default;
  }
  setSetSpriteFlip(path, value) {
    return {type: 'SET', path: path.concat(['setSpriteFlip']), value: value.toJson()};
  }
  deleteSetSpriteFlip(path) {
    return {type: 'DELETE', path: path.concat(['setSpriteFlip'])};
  }
  /**
   * @returns {ActorAction_ClearOutline}
   */
  get clearOutline() {
    return this._oneofActorActionCase === 36 ? this._oneofActorActionValue : ActorAction_ClearOutline.default;
  }
  setClearOutline(path, value) {
    return {type: 'SET', path: path.concat(['clearOutline']), value: value.toJson()};
  }
  deleteClearOutline(path) {
    return {type: 'DELETE', path: path.concat(['clearOutline'])};
  }
  /**
   * @returns {ActorAction_SetWalkAnimation}
   */
  get setWalkAnimation() {
    return this._oneofActorActionCase === 37 ? this._oneofActorActionValue : ActorAction_SetWalkAnimation.default;
  }
  setSetWalkAnimation(path, value) {
    return {type: 'SET', path: path.concat(['setWalkAnimation']), value: value.toJson()};
  }
  deleteSetWalkAnimation(path) {
    return {type: 'DELETE', path: path.concat(['setWalkAnimation'])};
  }
  /**
   * @returns {ActorAction_SetIdleAnimation}
   */
  get setIdleAnimation() {
    return this._oneofActorActionCase === 38 ? this._oneofActorActionValue : ActorAction_SetIdleAnimation.default;
  }
  setSetIdleAnimation(path, value) {
    return {type: 'SET', path: path.concat(['setIdleAnimation']), value: value.toJson()};
  }
  deleteSetIdleAnimation(path) {
    return {type: 'DELETE', path: path.concat(['setIdleAnimation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playAnimation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 1;
              copy._oneofActorActionValue = ActorAction_PlayAnimation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 1) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 1) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 1;
            copy._oneofActorActionValue = ActorAction_PlayAnimation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playAnimation.apply(type, path.slice(1), value);
          if (newValue === this.playAnimation) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 1;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "stopAnimation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 2;
              copy._oneofActorActionValue = ActorAction_StopAnimation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 2) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 2) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 2;
            copy._oneofActorActionValue = ActorAction_StopAnimation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.stopAnimation.apply(type, path.slice(1), value);
          if (newValue === this.stopAnimation) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 2;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "create": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 3;
              copy._oneofActorActionValue = ActorAction_CreateActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 3) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 3) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 3;
            copy._oneofActorActionValue = ActorAction_CreateActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.create.apply(type, path.slice(1), value);
          if (newValue === this.create) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 3;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "destroy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 4;
              copy._oneofActorActionValue = ActorAction_DestroyActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 4) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 4) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 4;
            copy._oneofActorActionValue = ActorAction_DestroyActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.destroy.apply(type, path.slice(1), value);
          if (newValue === this.destroy) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 4;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "log": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 6;
              copy._oneofActorActionValue = ActorAction_DebugLog.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 6) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 6) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 6;
            copy._oneofActorActionValue = ActorAction_DebugLog.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.log.apply(type, path.slice(1), value);
          if (newValue === this.log) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 6;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "createTimer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 7;
              copy._oneofActorActionValue = ActorAction_CreateTimer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 7) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 7) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 7;
            copy._oneofActorActionValue = ActorAction_CreateTimer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.createTimer.apply(type, path.slice(1), value);
          if (newValue === this.createTimer) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 7;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "removeTimer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 8;
              copy._oneofActorActionValue = ActorAction_RemoveTimer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 8) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 8) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 8;
            copy._oneofActorActionValue = ActorAction_RemoveTimer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.removeTimer.apply(type, path.slice(1), value);
          if (newValue === this.removeTimer) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 8;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 9;
              copy._oneofActorActionValue = ActorAction_SetSiteOperations.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 9) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 9) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 9;
            copy._oneofActorActionValue = ActorAction_SetSiteOperations.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setSiteOperations.apply(type, path.slice(1), value);
          if (newValue === this.setSiteOperations) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 9;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "createAliases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 10;
              copy._oneofActorActionValue = ActorAction_CreateAliases.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 10) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 10) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 10;
            copy._oneofActorActionValue = ActorAction_CreateAliases.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.createAliases.apply(type, path.slice(1), value);
          if (newValue === this.createAliases) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 10;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setVariable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 11;
              copy._oneofActorActionValue = ActorAction_SetVariable.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 11) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 11) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 11;
            copy._oneofActorActionValue = ActorAction_SetVariable.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setVariable.apply(type, path.slice(1), value);
          if (newValue === this.setVariable) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 11;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "sendCustomEvent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 12;
              copy._oneofActorActionValue = ActorAction_SendCustomEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 12) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 12) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 12;
            copy._oneofActorActionValue = ActorAction_SendCustomEvent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.sendCustomEvent.apply(type, path.slice(1), value);
          if (newValue === this.sendCustomEvent) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 12;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setTintColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 13;
              copy._oneofActorActionValue = ActorAction_SetTintColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 13) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 13) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 13;
            copy._oneofActorActionValue = ActorAction_SetTintColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setTintColor.apply(type, path.slice(1), value);
          if (newValue === this.setTintColor) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 13;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setMeshEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 14;
              copy._oneofActorActionValue = ActorAction_SetMeshEffect.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 14) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 14) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 14;
            copy._oneofActorActionValue = ActorAction_SetMeshEffect.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setMeshEffect.apply(type, path.slice(1), value);
          if (newValue === this.setMeshEffect) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 14;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "playMusic": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 15;
              copy._oneofActorActionValue = ActorAction_PlayMusic.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 15) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 15) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 15;
            copy._oneofActorActionValue = ActorAction_PlayMusic.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playMusic.apply(type, path.slice(1), value);
          if (newValue === this.playMusic) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 15;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "stopMusic": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 16;
              copy._oneofActorActionValue = ActorAction_StopMusic.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 16) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 16) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 16;
            copy._oneofActorActionValue = ActorAction_StopMusic.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.stopMusic.apply(type, path.slice(1), value);
          if (newValue === this.stopMusic) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 16;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "shakeCamera": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 17;
              copy._oneofActorActionValue = ActorAction_ShakeCamera.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 17) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 17) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 17;
            copy._oneofActorActionValue = ActorAction_ShakeCamera.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.shakeCamera.apply(type, path.slice(1), value);
          if (newValue === this.shakeCamera) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 17;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setVisibility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 18;
              copy._oneofActorActionValue = ActorAction_SetVisibility.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 18) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 18) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 18;
            copy._oneofActorActionValue = ActorAction_SetVisibility.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setVisibility.apply(type, path.slice(1), value);
          if (newValue === this.setVisibility) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 18;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setModelScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 19;
              copy._oneofActorActionValue = ActorAction_SetModelScale.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 19) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 19) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 19;
            copy._oneofActorActionValue = ActorAction_SetModelScale.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setModelScale.apply(type, path.slice(1), value);
          if (newValue === this.setModelScale) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 19;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "broadcastCustomEvent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 20;
              copy._oneofActorActionValue = ActorAction_BroadcastCustomEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 20) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 20) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 20;
            copy._oneofActorActionValue = ActorAction_BroadcastCustomEvent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.broadcastCustomEvent.apply(type, path.slice(1), value);
          if (newValue === this.broadcastCustomEvent) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 20;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "applyMeshEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 21;
              copy._oneofActorActionValue = ActorAction_ApplyMeshEffect.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 21) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 21) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 21;
            copy._oneofActorActionValue = ActorAction_ApplyMeshEffect.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.applyMeshEffect.apply(type, path.slice(1), value);
          if (newValue === this.applyMeshEffect) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 21;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "removeMeshEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 22;
              copy._oneofActorActionValue = ActorAction_RemoveMeshEffect.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 22) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 22) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 22;
            copy._oneofActorActionValue = ActorAction_RemoveMeshEffect.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.removeMeshEffect.apply(type, path.slice(1), value);
          if (newValue === this.removeMeshEffect) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 22;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setTeamColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 25;
              copy._oneofActorActionValue = ActorAction_SetTeamColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 25) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 25) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 25;
            copy._oneofActorActionValue = ActorAction_SetTeamColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setTeamColor.apply(type, path.slice(1), value);
          if (newValue === this.setTeamColor) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 25;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setShadowHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 26;
              copy._oneofActorActionValue = ActorAction_SetShadowHeight.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 26) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 26) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 26;
            copy._oneofActorActionValue = ActorAction_SetShadowHeight.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setShadowHeight.apply(type, path.slice(1), value);
          if (newValue === this.setShadowHeight) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 26;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "playAnimationWithDuration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 27;
              copy._oneofActorActionValue = ActorAction_PlayAnimationWithDuration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 27) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 27) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 27;
            copy._oneofActorActionValue = ActorAction_PlayAnimationWithDuration.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playAnimationWithDuration.apply(type, path.slice(1), value);
          if (newValue === this.playAnimationWithDuration) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 27;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "pauseAnimation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 28;
              copy._oneofActorActionValue = ActorAction_PauseAnimation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 28) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 28) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 28;
            copy._oneofActorActionValue = ActorAction_PauseAnimation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.pauseAnimation.apply(type, path.slice(1), value);
          if (newValue === this.pauseAnimation) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 28;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "resumeAnimation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 29;
              copy._oneofActorActionValue = ActorAction_ResumeAnimation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 29) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 29) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 29;
            copy._oneofActorActionValue = ActorAction_ResumeAnimation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.resumeAnimation.apply(type, path.slice(1), value);
          if (newValue === this.resumeAnimation) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 29;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "playSound": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 30;
              copy._oneofActorActionValue = ActorAction_PlaySound.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 30) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 30) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 30;
            copy._oneofActorActionValue = ActorAction_PlaySound.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playSound.apply(type, path.slice(1), value);
          if (newValue === this.playSound) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 30;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setScaleMultiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 31;
              copy._oneofActorActionValue = ActorAction_SetScaleMultiplier.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 31) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 31) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 31;
            copy._oneofActorActionValue = ActorAction_SetScaleMultiplier.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setScaleMultiplier.apply(type, path.slice(1), value);
          if (newValue === this.setScaleMultiplier) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 31;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setShadow": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 32;
              copy._oneofActorActionValue = ActorAction_SetShadow.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 32) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 32) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 32;
            copy._oneofActorActionValue = ActorAction_SetShadow.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setShadow.apply(type, path.slice(1), value);
          if (newValue === this.setShadow) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 32;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "clearTintColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 33;
              copy._oneofActorActionValue = ActorAction_ClearTintColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 33) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 33) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 33;
            copy._oneofActorActionValue = ActorAction_ClearTintColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.clearTintColor.apply(type, path.slice(1), value);
          if (newValue === this.clearTintColor) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 33;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setOutline": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 34;
              copy._oneofActorActionValue = ActorAction_SetOutline.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 34) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 34) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 34;
            copy._oneofActorActionValue = ActorAction_SetOutline.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setOutline.apply(type, path.slice(1), value);
          if (newValue === this.setOutline) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 34;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setSpriteFlip": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 35;
              copy._oneofActorActionValue = ActorAction_SetSpriteFlip.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 35) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 35) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 35;
            copy._oneofActorActionValue = ActorAction_SetSpriteFlip.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setSpriteFlip.apply(type, path.slice(1), value);
          if (newValue === this.setSpriteFlip) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 35;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "clearOutline": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 36;
              copy._oneofActorActionValue = ActorAction_ClearOutline.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 36) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 36) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 36;
            copy._oneofActorActionValue = ActorAction_ClearOutline.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.clearOutline.apply(type, path.slice(1), value);
          if (newValue === this.clearOutline) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 36;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setWalkAnimation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 37;
              copy._oneofActorActionValue = ActorAction_SetWalkAnimation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 37) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 37) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 37;
            copy._oneofActorActionValue = ActorAction_SetWalkAnimation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setWalkAnimation.apply(type, path.slice(1), value);
          if (newValue === this.setWalkAnimation) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 37;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      case "setIdleAnimation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 38;
              copy._oneofActorActionValue = ActorAction_SetIdleAnimation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofActorActionCase !== 38) {
                return this;
              }
              const copy = new ActorAction(this);
              copy._oneofActorActionCase = 0;
              copy._oneofActorActionValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofActorActionCase !== 38) {
            const copy = new ActorAction(this);
            copy._oneofActorActionCase = 38;
            copy._oneofActorActionValue = ActorAction_SetIdleAnimation.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.setIdleAnimation.apply(type, path.slice(1), value);
          if (newValue === this.setIdleAnimation) {
            return this;
          }
          const copy = new ActorAction(this);
          copy._oneofActorActionCase = 38;
          copy._oneofActorActionValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorAction} other
   * @returns {ActorAction}
   */
  merge(other) {
    const copy = new ActorAction(this);
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    if (other._oneofActorActionCase === 1) {
      if (this._oneofActorActionCase === 1) {
        copy._oneofActorActionValue = copy._oneofActorActionValue.merge(other._oneofActorActionValue);
      } else {
        copy._oneofActorActionValue = other._oneofActorActionValue;
      }
      copy._oneofActorActionCase = 1;
    }
    return copy;
  }
}
ActorAction.default = new ActorAction();
ActorAction.PlayAnimation = ActorAction_PlayAnimation;
ActorAction.PlayAnimationWithDuration = ActorAction_PlayAnimationWithDuration;
ActorAction.StopAnimation = ActorAction_StopAnimation;
ActorAction.PauseAnimation = ActorAction_PauseAnimation;
ActorAction.ResumeAnimation = ActorAction_ResumeAnimation;
ActorAction.CreateActor = ActorAction_CreateActor;
ActorAction.DestroyActor = ActorAction_DestroyActor;
ActorAction.SendMessage = ActorAction_SendMessage;
ActorAction.DebugLog = ActorAction_DebugLog;
ActorAction.CreateTimer = ActorAction_CreateTimer;
ActorAction.RemoveTimer = ActorAction_RemoveTimer;
ActorAction.SetSiteOperations = ActorAction_SetSiteOperations;
ActorAction.CreateAliases = ActorAction_CreateAliases;
ActorAction.SetVariable = ActorAction_SetVariable;
ActorAction.SendCustomEvent = ActorAction_SendCustomEvent;
ActorAction.BroadcastCustomEvent = ActorAction_BroadcastCustomEvent;
ActorAction.SetTintColor = ActorAction_SetTintColor;
ActorAction.ClearTintColor = ActorAction_ClearTintColor;
ActorAction.SetTeamColor = ActorAction_SetTeamColor;
ActorAction.SetShadow = ActorAction_SetShadow;
ActorAction.SetOutline = ActorAction_SetOutline;
ActorAction.ClearOutline = ActorAction_ClearOutline;
ActorAction.SetScaleMultiplier = ActorAction_SetScaleMultiplier;
ActorAction.SetShadowHeight = ActorAction_SetShadowHeight;
ActorAction.SetMeshEffect = ActorAction_SetMeshEffect;
ActorAction.ApplyMeshEffect = ActorAction_ApplyMeshEffect;
ActorAction.RemoveMeshEffect = ActorAction_RemoveMeshEffect;
ActorAction.PlayMusic = ActorAction_PlayMusic;
ActorAction.PlaySound = ActorAction_PlaySound;
ActorAction.StopMusic = ActorAction_StopMusic;
ActorAction.ShakeCamera = ActorAction_ShakeCamera;
ActorAction.SetVisibility = ActorAction_SetVisibility;
ActorAction.SetModelScale = ActorAction_SetModelScale;
ActorAction.SetSpriteFlip = ActorAction_SetSpriteFlip;
ActorAction.SetWalkAnimation = ActorAction_SetWalkAnimation;
ActorAction.SetIdleAnimation = ActorAction_SetIdleAnimation;
class ActorAction_Builder {
  constructor(value) {
    this._value = new ActorAction(value);
  }
  build() {
    return new ActorAction(this._value);
  }
  clearoneofActorAction() {
    this._value._oneofActorActionCase = 0;
    this._value._oneofActorActionValue = null;
    return this;
  }
  setPlayAnimation(value) {
    this._value._oneofActorActionCase = 1;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setStopAnimation(value) {
    this._value._oneofActorActionCase = 2;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setCreate(value) {
    this._value._oneofActorActionCase = 3;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setDestroy(value) {
    this._value._oneofActorActionCase = 4;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setLog(value) {
    this._value._oneofActorActionCase = 6;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setCreateTimer(value) {
    this._value._oneofActorActionCase = 7;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setRemoveTimer(value) {
    this._value._oneofActorActionCase = 8;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetSiteOperations(value) {
    this._value._oneofActorActionCase = 9;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setCreateAliases(value) {
    this._value._oneofActorActionCase = 10;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetVariable(value) {
    this._value._oneofActorActionCase = 11;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSendCustomEvent(value) {
    this._value._oneofActorActionCase = 12;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetTintColor(value) {
    this._value._oneofActorActionCase = 13;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetMeshEffect(value) {
    this._value._oneofActorActionCase = 14;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setPlayMusic(value) {
    this._value._oneofActorActionCase = 15;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setStopMusic(value) {
    this._value._oneofActorActionCase = 16;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setShakeCamera(value) {
    this._value._oneofActorActionCase = 17;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetVisibility(value) {
    this._value._oneofActorActionCase = 18;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetModelScale(value) {
    this._value._oneofActorActionCase = 19;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setBroadcastCustomEvent(value) {
    this._value._oneofActorActionCase = 20;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setApplyMeshEffect(value) {
    this._value._oneofActorActionCase = 21;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setRemoveMeshEffect(value) {
    this._value._oneofActorActionCase = 22;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetTeamColor(value) {
    this._value._oneofActorActionCase = 25;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetShadowHeight(value) {
    this._value._oneofActorActionCase = 26;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setPlayAnimationWithDuration(value) {
    this._value._oneofActorActionCase = 27;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setPauseAnimation(value) {
    this._value._oneofActorActionCase = 28;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setResumeAnimation(value) {
    this._value._oneofActorActionCase = 29;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setPlaySound(value) {
    this._value._oneofActorActionCase = 30;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetScaleMultiplier(value) {
    this._value._oneofActorActionCase = 31;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetShadow(value) {
    this._value._oneofActorActionCase = 32;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setClearTintColor(value) {
    this._value._oneofActorActionCase = 33;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetOutline(value) {
    this._value._oneofActorActionCase = 34;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetSpriteFlip(value) {
    this._value._oneofActorActionCase = 35;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setClearOutline(value) {
    this._value._oneofActorActionCase = 36;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetWalkAnimation(value) {
    this._value._oneofActorActionCase = 37;
    this._value._oneofActorActionValue = value;
    return this;
  }
  setSetIdleAnimation(value) {
    this._value._oneofActorActionCase = 38;
    this._value._oneofActorActionValue = value;
    return this;
  }
}
ActorAction.Builder = ActorAction_Builder;
class ActorAction_WithParent {
  /**
   * @param {ActorAction} value
   * @param {ActorAction_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorAction.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofActorActionCase() {
    if (this._cachedoneofActorActionCase === undefined) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedoneofActorActionCase = this._parent ? this._parent.oneofActorActionCase : 0;
      } else {
        this._cachedoneofActorActionCase = this._value._oneofActorActionCase;
      }
    }
    return this._cachedoneofActorActionCase;
  }
  get playAnimation() {
    if (!this._cachedPlayAnimation) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedPlayAnimation = this._parent ? new ActorAction_PlayAnimation.WithParent(ActorAction_PlayAnimation.default, this._parent.playAnimation) : this._value.playAnimation;
      } else if (this._value._oneofActorActionCase === 1) {
        this._cachedPlayAnimation = new ActorAction_PlayAnimation.WithParent(this._value.playAnimation, this._parent && this._parent.oneofActorActionCase === 1 ? this._parent.playAnimation : null);
      } else {
        this._cachedPlayAnimation = ActorAction_PlayAnimation.WithParent.default;
      }
    }
    return this._cachedPlayAnimation;
  }
  get stopAnimation() {
    if (!this._cachedStopAnimation) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedStopAnimation = this._parent ? new ActorAction_StopAnimation.WithParent(ActorAction_StopAnimation.default, this._parent.stopAnimation) : this._value.stopAnimation;
      } else if (this._value._oneofActorActionCase === 2) {
        this._cachedStopAnimation = new ActorAction_StopAnimation.WithParent(this._value.stopAnimation, this._parent && this._parent.oneofActorActionCase === 2 ? this._parent.stopAnimation : null);
      } else {
        this._cachedStopAnimation = ActorAction_StopAnimation.WithParent.default;
      }
    }
    return this._cachedStopAnimation;
  }
  get create() {
    if (!this._cachedCreate) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedCreate = this._parent ? new ActorAction_CreateActor.WithParent(ActorAction_CreateActor.default, this._parent.create) : this._value.create;
      } else if (this._value._oneofActorActionCase === 3) {
        this._cachedCreate = new ActorAction_CreateActor.WithParent(this._value.create, this._parent && this._parent.oneofActorActionCase === 3 ? this._parent.create : null);
      } else {
        this._cachedCreate = ActorAction_CreateActor.WithParent.default;
      }
    }
    return this._cachedCreate;
  }
  get destroy() {
    if (!this._cachedDestroy) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedDestroy = this._parent ? new ActorAction_DestroyActor.WithParent(ActorAction_DestroyActor.default, this._parent.destroy) : this._value.destroy;
      } else if (this._value._oneofActorActionCase === 4) {
        this._cachedDestroy = new ActorAction_DestroyActor.WithParent(this._value.destroy, this._parent && this._parent.oneofActorActionCase === 4 ? this._parent.destroy : null);
      } else {
        this._cachedDestroy = ActorAction_DestroyActor.WithParent.default;
      }
    }
    return this._cachedDestroy;
  }
  get log() {
    if (!this._cachedLog) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedLog = this._parent ? new ActorAction_DebugLog.WithParent(ActorAction_DebugLog.default, this._parent.log) : this._value.log;
      } else if (this._value._oneofActorActionCase === 6) {
        this._cachedLog = new ActorAction_DebugLog.WithParent(this._value.log, this._parent && this._parent.oneofActorActionCase === 6 ? this._parent.log : null);
      } else {
        this._cachedLog = ActorAction_DebugLog.WithParent.default;
      }
    }
    return this._cachedLog;
  }
  get createTimer() {
    if (!this._cachedCreateTimer) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedCreateTimer = this._parent ? new ActorAction_CreateTimer.WithParent(ActorAction_CreateTimer.default, this._parent.createTimer) : this._value.createTimer;
      } else if (this._value._oneofActorActionCase === 7) {
        this._cachedCreateTimer = new ActorAction_CreateTimer.WithParent(this._value.createTimer, this._parent && this._parent.oneofActorActionCase === 7 ? this._parent.createTimer : null);
      } else {
        this._cachedCreateTimer = ActorAction_CreateTimer.WithParent.default;
      }
    }
    return this._cachedCreateTimer;
  }
  get removeTimer() {
    if (!this._cachedRemoveTimer) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedRemoveTimer = this._parent ? new ActorAction_RemoveTimer.WithParent(ActorAction_RemoveTimer.default, this._parent.removeTimer) : this._value.removeTimer;
      } else if (this._value._oneofActorActionCase === 8) {
        this._cachedRemoveTimer = new ActorAction_RemoveTimer.WithParent(this._value.removeTimer, this._parent && this._parent.oneofActorActionCase === 8 ? this._parent.removeTimer : null);
      } else {
        this._cachedRemoveTimer = ActorAction_RemoveTimer.WithParent.default;
      }
    }
    return this._cachedRemoveTimer;
  }
  get setSiteOperations() {
    if (!this._cachedSetSiteOperations) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetSiteOperations = this._parent ? new ActorAction_SetSiteOperations.WithParent(ActorAction_SetSiteOperations.default, this._parent.setSiteOperations) : this._value.setSiteOperations;
      } else if (this._value._oneofActorActionCase === 9) {
        this._cachedSetSiteOperations = new ActorAction_SetSiteOperations.WithParent(this._value.setSiteOperations, this._parent && this._parent.oneofActorActionCase === 9 ? this._parent.setSiteOperations : null);
      } else {
        this._cachedSetSiteOperations = ActorAction_SetSiteOperations.WithParent.default;
      }
    }
    return this._cachedSetSiteOperations;
  }
  get createAliases() {
    if (!this._cachedCreateAliases) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedCreateAliases = this._parent ? new ActorAction_CreateAliases.WithParent(ActorAction_CreateAliases.default, this._parent.createAliases) : this._value.createAliases;
      } else if (this._value._oneofActorActionCase === 10) {
        this._cachedCreateAliases = new ActorAction_CreateAliases.WithParent(this._value.createAliases, this._parent && this._parent.oneofActorActionCase === 10 ? this._parent.createAliases : null);
      } else {
        this._cachedCreateAliases = ActorAction_CreateAliases.WithParent.default;
      }
    }
    return this._cachedCreateAliases;
  }
  get setVariable() {
    if (!this._cachedSetVariable) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetVariable = this._parent ? new ActorAction_SetVariable.WithParent(ActorAction_SetVariable.default, this._parent.setVariable) : this._value.setVariable;
      } else if (this._value._oneofActorActionCase === 11) {
        this._cachedSetVariable = new ActorAction_SetVariable.WithParent(this._value.setVariable, this._parent && this._parent.oneofActorActionCase === 11 ? this._parent.setVariable : null);
      } else {
        this._cachedSetVariable = ActorAction_SetVariable.WithParent.default;
      }
    }
    return this._cachedSetVariable;
  }
  get sendCustomEvent() {
    if (!this._cachedSendCustomEvent) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSendCustomEvent = this._parent ? new ActorAction_SendCustomEvent.WithParent(ActorAction_SendCustomEvent.default, this._parent.sendCustomEvent) : this._value.sendCustomEvent;
      } else if (this._value._oneofActorActionCase === 12) {
        this._cachedSendCustomEvent = new ActorAction_SendCustomEvent.WithParent(this._value.sendCustomEvent, this._parent && this._parent.oneofActorActionCase === 12 ? this._parent.sendCustomEvent : null);
      } else {
        this._cachedSendCustomEvent = ActorAction_SendCustomEvent.WithParent.default;
      }
    }
    return this._cachedSendCustomEvent;
  }
  get setTintColor() {
    if (!this._cachedSetTintColor) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetTintColor = this._parent ? new ActorAction_SetTintColor.WithParent(ActorAction_SetTintColor.default, this._parent.setTintColor) : this._value.setTintColor;
      } else if (this._value._oneofActorActionCase === 13) {
        this._cachedSetTintColor = new ActorAction_SetTintColor.WithParent(this._value.setTintColor, this._parent && this._parent.oneofActorActionCase === 13 ? this._parent.setTintColor : null);
      } else {
        this._cachedSetTintColor = ActorAction_SetTintColor.WithParent.default;
      }
    }
    return this._cachedSetTintColor;
  }
  get setMeshEffect() {
    if (!this._cachedSetMeshEffect) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetMeshEffect = this._parent ? new ActorAction_SetMeshEffect.WithParent(ActorAction_SetMeshEffect.default, this._parent.setMeshEffect) : this._value.setMeshEffect;
      } else if (this._value._oneofActorActionCase === 14) {
        this._cachedSetMeshEffect = new ActorAction_SetMeshEffect.WithParent(this._value.setMeshEffect, this._parent && this._parent.oneofActorActionCase === 14 ? this._parent.setMeshEffect : null);
      } else {
        this._cachedSetMeshEffect = ActorAction_SetMeshEffect.WithParent.default;
      }
    }
    return this._cachedSetMeshEffect;
  }
  get playMusic() {
    if (!this._cachedPlayMusic) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedPlayMusic = this._parent ? new ActorAction_PlayMusic.WithParent(ActorAction_PlayMusic.default, this._parent.playMusic) : this._value.playMusic;
      } else if (this._value._oneofActorActionCase === 15) {
        this._cachedPlayMusic = new ActorAction_PlayMusic.WithParent(this._value.playMusic, this._parent && this._parent.oneofActorActionCase === 15 ? this._parent.playMusic : null);
      } else {
        this._cachedPlayMusic = ActorAction_PlayMusic.WithParent.default;
      }
    }
    return this._cachedPlayMusic;
  }
  get stopMusic() {
    if (!this._cachedStopMusic) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedStopMusic = this._parent ? new ActorAction_StopMusic.WithParent(ActorAction_StopMusic.default, this._parent.stopMusic) : this._value.stopMusic;
      } else if (this._value._oneofActorActionCase === 16) {
        this._cachedStopMusic = new ActorAction_StopMusic.WithParent(this._value.stopMusic, this._parent && this._parent.oneofActorActionCase === 16 ? this._parent.stopMusic : null);
      } else {
        this._cachedStopMusic = ActorAction_StopMusic.WithParent.default;
      }
    }
    return this._cachedStopMusic;
  }
  get shakeCamera() {
    if (!this._cachedShakeCamera) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedShakeCamera = this._parent ? new ActorAction_ShakeCamera.WithParent(ActorAction_ShakeCamera.default, this._parent.shakeCamera) : this._value.shakeCamera;
      } else if (this._value._oneofActorActionCase === 17) {
        this._cachedShakeCamera = new ActorAction_ShakeCamera.WithParent(this._value.shakeCamera, this._parent && this._parent.oneofActorActionCase === 17 ? this._parent.shakeCamera : null);
      } else {
        this._cachedShakeCamera = ActorAction_ShakeCamera.WithParent.default;
      }
    }
    return this._cachedShakeCamera;
  }
  get setVisibility() {
    if (!this._cachedSetVisibility) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetVisibility = this._parent ? new ActorAction_SetVisibility.WithParent(ActorAction_SetVisibility.default, this._parent.setVisibility) : this._value.setVisibility;
      } else if (this._value._oneofActorActionCase === 18) {
        this._cachedSetVisibility = new ActorAction_SetVisibility.WithParent(this._value.setVisibility, this._parent && this._parent.oneofActorActionCase === 18 ? this._parent.setVisibility : null);
      } else {
        this._cachedSetVisibility = ActorAction_SetVisibility.WithParent.default;
      }
    }
    return this._cachedSetVisibility;
  }
  get setModelScale() {
    if (!this._cachedSetModelScale) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetModelScale = this._parent ? new ActorAction_SetModelScale.WithParent(ActorAction_SetModelScale.default, this._parent.setModelScale) : this._value.setModelScale;
      } else if (this._value._oneofActorActionCase === 19) {
        this._cachedSetModelScale = new ActorAction_SetModelScale.WithParent(this._value.setModelScale, this._parent && this._parent.oneofActorActionCase === 19 ? this._parent.setModelScale : null);
      } else {
        this._cachedSetModelScale = ActorAction_SetModelScale.WithParent.default;
      }
    }
    return this._cachedSetModelScale;
  }
  get broadcastCustomEvent() {
    if (!this._cachedBroadcastCustomEvent) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedBroadcastCustomEvent = this._parent ? new ActorAction_BroadcastCustomEvent.WithParent(ActorAction_BroadcastCustomEvent.default, this._parent.broadcastCustomEvent) : this._value.broadcastCustomEvent;
      } else if (this._value._oneofActorActionCase === 20) {
        this._cachedBroadcastCustomEvent = new ActorAction_BroadcastCustomEvent.WithParent(this._value.broadcastCustomEvent, this._parent && this._parent.oneofActorActionCase === 20 ? this._parent.broadcastCustomEvent : null);
      } else {
        this._cachedBroadcastCustomEvent = ActorAction_BroadcastCustomEvent.WithParent.default;
      }
    }
    return this._cachedBroadcastCustomEvent;
  }
  get applyMeshEffect() {
    if (!this._cachedApplyMeshEffect) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedApplyMeshEffect = this._parent ? new ActorAction_ApplyMeshEffect.WithParent(ActorAction_ApplyMeshEffect.default, this._parent.applyMeshEffect) : this._value.applyMeshEffect;
      } else if (this._value._oneofActorActionCase === 21) {
        this._cachedApplyMeshEffect = new ActorAction_ApplyMeshEffect.WithParent(this._value.applyMeshEffect, this._parent && this._parent.oneofActorActionCase === 21 ? this._parent.applyMeshEffect : null);
      } else {
        this._cachedApplyMeshEffect = ActorAction_ApplyMeshEffect.WithParent.default;
      }
    }
    return this._cachedApplyMeshEffect;
  }
  get removeMeshEffect() {
    if (!this._cachedRemoveMeshEffect) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedRemoveMeshEffect = this._parent ? new ActorAction_RemoveMeshEffect.WithParent(ActorAction_RemoveMeshEffect.default, this._parent.removeMeshEffect) : this._value.removeMeshEffect;
      } else if (this._value._oneofActorActionCase === 22) {
        this._cachedRemoveMeshEffect = new ActorAction_RemoveMeshEffect.WithParent(this._value.removeMeshEffect, this._parent && this._parent.oneofActorActionCase === 22 ? this._parent.removeMeshEffect : null);
      } else {
        this._cachedRemoveMeshEffect = ActorAction_RemoveMeshEffect.WithParent.default;
      }
    }
    return this._cachedRemoveMeshEffect;
  }
  get setTeamColor() {
    if (!this._cachedSetTeamColor) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetTeamColor = this._parent ? new ActorAction_SetTeamColor.WithParent(ActorAction_SetTeamColor.default, this._parent.setTeamColor) : this._value.setTeamColor;
      } else if (this._value._oneofActorActionCase === 25) {
        this._cachedSetTeamColor = new ActorAction_SetTeamColor.WithParent(this._value.setTeamColor, this._parent && this._parent.oneofActorActionCase === 25 ? this._parent.setTeamColor : null);
      } else {
        this._cachedSetTeamColor = ActorAction_SetTeamColor.WithParent.default;
      }
    }
    return this._cachedSetTeamColor;
  }
  get setShadowHeight() {
    if (!this._cachedSetShadowHeight) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetShadowHeight = this._parent ? new ActorAction_SetShadowHeight.WithParent(ActorAction_SetShadowHeight.default, this._parent.setShadowHeight) : this._value.setShadowHeight;
      } else if (this._value._oneofActorActionCase === 26) {
        this._cachedSetShadowHeight = new ActorAction_SetShadowHeight.WithParent(this._value.setShadowHeight, this._parent && this._parent.oneofActorActionCase === 26 ? this._parent.setShadowHeight : null);
      } else {
        this._cachedSetShadowHeight = ActorAction_SetShadowHeight.WithParent.default;
      }
    }
    return this._cachedSetShadowHeight;
  }
  get playAnimationWithDuration() {
    if (!this._cachedPlayAnimationWithDuration) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedPlayAnimationWithDuration = this._parent ? new ActorAction_PlayAnimationWithDuration.WithParent(ActorAction_PlayAnimationWithDuration.default, this._parent.playAnimationWithDuration) : this._value.playAnimationWithDuration;
      } else if (this._value._oneofActorActionCase === 27) {
        this._cachedPlayAnimationWithDuration = new ActorAction_PlayAnimationWithDuration.WithParent(this._value.playAnimationWithDuration, this._parent && this._parent.oneofActorActionCase === 27 ? this._parent.playAnimationWithDuration : null);
      } else {
        this._cachedPlayAnimationWithDuration = ActorAction_PlayAnimationWithDuration.WithParent.default;
      }
    }
    return this._cachedPlayAnimationWithDuration;
  }
  get pauseAnimation() {
    if (!this._cachedPauseAnimation) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedPauseAnimation = this._parent ? new ActorAction_PauseAnimation.WithParent(ActorAction_PauseAnimation.default, this._parent.pauseAnimation) : this._value.pauseAnimation;
      } else if (this._value._oneofActorActionCase === 28) {
        this._cachedPauseAnimation = new ActorAction_PauseAnimation.WithParent(this._value.pauseAnimation, this._parent && this._parent.oneofActorActionCase === 28 ? this._parent.pauseAnimation : null);
      } else {
        this._cachedPauseAnimation = ActorAction_PauseAnimation.WithParent.default;
      }
    }
    return this._cachedPauseAnimation;
  }
  get resumeAnimation() {
    if (!this._cachedResumeAnimation) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedResumeAnimation = this._parent ? new ActorAction_ResumeAnimation.WithParent(ActorAction_ResumeAnimation.default, this._parent.resumeAnimation) : this._value.resumeAnimation;
      } else if (this._value._oneofActorActionCase === 29) {
        this._cachedResumeAnimation = new ActorAction_ResumeAnimation.WithParent(this._value.resumeAnimation, this._parent && this._parent.oneofActorActionCase === 29 ? this._parent.resumeAnimation : null);
      } else {
        this._cachedResumeAnimation = ActorAction_ResumeAnimation.WithParent.default;
      }
    }
    return this._cachedResumeAnimation;
  }
  get playSound() {
    if (!this._cachedPlaySound) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedPlaySound = this._parent ? new ActorAction_PlaySound.WithParent(ActorAction_PlaySound.default, this._parent.playSound) : this._value.playSound;
      } else if (this._value._oneofActorActionCase === 30) {
        this._cachedPlaySound = new ActorAction_PlaySound.WithParent(this._value.playSound, this._parent && this._parent.oneofActorActionCase === 30 ? this._parent.playSound : null);
      } else {
        this._cachedPlaySound = ActorAction_PlaySound.WithParent.default;
      }
    }
    return this._cachedPlaySound;
  }
  get setScaleMultiplier() {
    if (!this._cachedSetScaleMultiplier) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetScaleMultiplier = this._parent ? new ActorAction_SetScaleMultiplier.WithParent(ActorAction_SetScaleMultiplier.default, this._parent.setScaleMultiplier) : this._value.setScaleMultiplier;
      } else if (this._value._oneofActorActionCase === 31) {
        this._cachedSetScaleMultiplier = new ActorAction_SetScaleMultiplier.WithParent(this._value.setScaleMultiplier, this._parent && this._parent.oneofActorActionCase === 31 ? this._parent.setScaleMultiplier : null);
      } else {
        this._cachedSetScaleMultiplier = ActorAction_SetScaleMultiplier.WithParent.default;
      }
    }
    return this._cachedSetScaleMultiplier;
  }
  get setShadow() {
    if (!this._cachedSetShadow) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetShadow = this._parent ? new ActorAction_SetShadow.WithParent(ActorAction_SetShadow.default, this._parent.setShadow) : this._value.setShadow;
      } else if (this._value._oneofActorActionCase === 32) {
        this._cachedSetShadow = new ActorAction_SetShadow.WithParent(this._value.setShadow, this._parent && this._parent.oneofActorActionCase === 32 ? this._parent.setShadow : null);
      } else {
        this._cachedSetShadow = ActorAction_SetShadow.WithParent.default;
      }
    }
    return this._cachedSetShadow;
  }
  get clearTintColor() {
    if (!this._cachedClearTintColor) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedClearTintColor = this._parent ? new ActorAction_ClearTintColor.WithParent(ActorAction_ClearTintColor.default, this._parent.clearTintColor) : this._value.clearTintColor;
      } else if (this._value._oneofActorActionCase === 33) {
        this._cachedClearTintColor = new ActorAction_ClearTintColor.WithParent(this._value.clearTintColor, this._parent && this._parent.oneofActorActionCase === 33 ? this._parent.clearTintColor : null);
      } else {
        this._cachedClearTintColor = ActorAction_ClearTintColor.WithParent.default;
      }
    }
    return this._cachedClearTintColor;
  }
  get setOutline() {
    if (!this._cachedSetOutline) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetOutline = this._parent ? new ActorAction_SetOutline.WithParent(ActorAction_SetOutline.default, this._parent.setOutline) : this._value.setOutline;
      } else if (this._value._oneofActorActionCase === 34) {
        this._cachedSetOutline = new ActorAction_SetOutline.WithParent(this._value.setOutline, this._parent && this._parent.oneofActorActionCase === 34 ? this._parent.setOutline : null);
      } else {
        this._cachedSetOutline = ActorAction_SetOutline.WithParent.default;
      }
    }
    return this._cachedSetOutline;
  }
  get setSpriteFlip() {
    if (!this._cachedSetSpriteFlip) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetSpriteFlip = this._parent ? new ActorAction_SetSpriteFlip.WithParent(ActorAction_SetSpriteFlip.default, this._parent.setSpriteFlip) : this._value.setSpriteFlip;
      } else if (this._value._oneofActorActionCase === 35) {
        this._cachedSetSpriteFlip = new ActorAction_SetSpriteFlip.WithParent(this._value.setSpriteFlip, this._parent && this._parent.oneofActorActionCase === 35 ? this._parent.setSpriteFlip : null);
      } else {
        this._cachedSetSpriteFlip = ActorAction_SetSpriteFlip.WithParent.default;
      }
    }
    return this._cachedSetSpriteFlip;
  }
  get clearOutline() {
    if (!this._cachedClearOutline) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedClearOutline = this._parent ? new ActorAction_ClearOutline.WithParent(ActorAction_ClearOutline.default, this._parent.clearOutline) : this._value.clearOutline;
      } else if (this._value._oneofActorActionCase === 36) {
        this._cachedClearOutline = new ActorAction_ClearOutline.WithParent(this._value.clearOutline, this._parent && this._parent.oneofActorActionCase === 36 ? this._parent.clearOutline : null);
      } else {
        this._cachedClearOutline = ActorAction_ClearOutline.WithParent.default;
      }
    }
    return this._cachedClearOutline;
  }
  get setWalkAnimation() {
    if (!this._cachedSetWalkAnimation) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetWalkAnimation = this._parent ? new ActorAction_SetWalkAnimation.WithParent(ActorAction_SetWalkAnimation.default, this._parent.setWalkAnimation) : this._value.setWalkAnimation;
      } else if (this._value._oneofActorActionCase === 37) {
        this._cachedSetWalkAnimation = new ActorAction_SetWalkAnimation.WithParent(this._value.setWalkAnimation, this._parent && this._parent.oneofActorActionCase === 37 ? this._parent.setWalkAnimation : null);
      } else {
        this._cachedSetWalkAnimation = ActorAction_SetWalkAnimation.WithParent.default;
      }
    }
    return this._cachedSetWalkAnimation;
  }
  get setIdleAnimation() {
    if (!this._cachedSetIdleAnimation) {
      if (this._value._oneofActorActionCase === 0) {
        this._cachedSetIdleAnimation = this._parent ? new ActorAction_SetIdleAnimation.WithParent(ActorAction_SetIdleAnimation.default, this._parent.setIdleAnimation) : this._value.setIdleAnimation;
      } else if (this._value._oneofActorActionCase === 38) {
        this._cachedSetIdleAnimation = new ActorAction_SetIdleAnimation.WithParent(this._value.setIdleAnimation, this._parent && this._parent.oneofActorActionCase === 38 ? this._parent.setIdleAnimation : null);
      } else {
        this._cachedSetIdleAnimation = ActorAction_SetIdleAnimation.WithParent.default;
      }
    }
    return this._cachedSetIdleAnimation;
  }
  update(current, parent) {
    const result = new ActorAction_WithParent(current, parent);
    if (this._cachedPlayAnimation && this._value._oneofActorActionCase === 1 && current._oneofActorActionCase === 1) {
      if (this._value.playAnimation === current.playAnimation && this._parent === parent) {
        result._cachedPlayAnimation = this._cachedPlayAnimation;
      } else {
        result._cachedPlayAnimation = this._cachedPlayAnimation.update(current.playAnimation, parent && parent.oneofActorActionCase === 1 ? parent.playAnimation : null);
      }
    }
    if (this._cachedStopAnimation && this._value._oneofActorActionCase === 2 && current._oneofActorActionCase === 2) {
      if (this._value.stopAnimation === current.stopAnimation && this._parent === parent) {
        result._cachedStopAnimation = this._cachedStopAnimation;
      } else {
        result._cachedStopAnimation = this._cachedStopAnimation.update(current.stopAnimation, parent && parent.oneofActorActionCase === 2 ? parent.stopAnimation : null);
      }
    }
    if (this._cachedCreate && this._value._oneofActorActionCase === 3 && current._oneofActorActionCase === 3) {
      if (this._value.create === current.create && this._parent === parent) {
        result._cachedCreate = this._cachedCreate;
      } else {
        result._cachedCreate = this._cachedCreate.update(current.create, parent && parent.oneofActorActionCase === 3 ? parent.create : null);
      }
    }
    if (this._cachedDestroy && this._value._oneofActorActionCase === 4 && current._oneofActorActionCase === 4) {
      if (this._value.destroy === current.destroy && this._parent === parent) {
        result._cachedDestroy = this._cachedDestroy;
      } else {
        result._cachedDestroy = this._cachedDestroy.update(current.destroy, parent && parent.oneofActorActionCase === 4 ? parent.destroy : null);
      }
    }
    if (this._cachedLog && this._value._oneofActorActionCase === 6 && current._oneofActorActionCase === 6) {
      if (this._value.log === current.log && this._parent === parent) {
        result._cachedLog = this._cachedLog;
      } else {
        result._cachedLog = this._cachedLog.update(current.log, parent && parent.oneofActorActionCase === 6 ? parent.log : null);
      }
    }
    if (this._cachedCreateTimer && this._value._oneofActorActionCase === 7 && current._oneofActorActionCase === 7) {
      if (this._value.createTimer === current.createTimer && this._parent === parent) {
        result._cachedCreateTimer = this._cachedCreateTimer;
      } else {
        result._cachedCreateTimer = this._cachedCreateTimer.update(current.createTimer, parent && parent.oneofActorActionCase === 7 ? parent.createTimer : null);
      }
    }
    if (this._cachedRemoveTimer && this._value._oneofActorActionCase === 8 && current._oneofActorActionCase === 8) {
      if (this._value.removeTimer === current.removeTimer && this._parent === parent) {
        result._cachedRemoveTimer = this._cachedRemoveTimer;
      } else {
        result._cachedRemoveTimer = this._cachedRemoveTimer.update(current.removeTimer, parent && parent.oneofActorActionCase === 8 ? parent.removeTimer : null);
      }
    }
    if (this._cachedSetSiteOperations && this._value._oneofActorActionCase === 9 && current._oneofActorActionCase === 9) {
      if (this._value.setSiteOperations === current.setSiteOperations && this._parent === parent) {
        result._cachedSetSiteOperations = this._cachedSetSiteOperations;
      } else {
        result._cachedSetSiteOperations = this._cachedSetSiteOperations.update(current.setSiteOperations, parent && parent.oneofActorActionCase === 9 ? parent.setSiteOperations : null);
      }
    }
    if (this._cachedCreateAliases && this._value._oneofActorActionCase === 10 && current._oneofActorActionCase === 10) {
      if (this._value.createAliases === current.createAliases && this._parent === parent) {
        result._cachedCreateAliases = this._cachedCreateAliases;
      } else {
        result._cachedCreateAliases = this._cachedCreateAliases.update(current.createAliases, parent && parent.oneofActorActionCase === 10 ? parent.createAliases : null);
      }
    }
    if (this._cachedSetVariable && this._value._oneofActorActionCase === 11 && current._oneofActorActionCase === 11) {
      if (this._value.setVariable === current.setVariable && this._parent === parent) {
        result._cachedSetVariable = this._cachedSetVariable;
      } else {
        result._cachedSetVariable = this._cachedSetVariable.update(current.setVariable, parent && parent.oneofActorActionCase === 11 ? parent.setVariable : null);
      }
    }
    if (this._cachedSendCustomEvent && this._value._oneofActorActionCase === 12 && current._oneofActorActionCase === 12) {
      if (this._value.sendCustomEvent === current.sendCustomEvent && this._parent === parent) {
        result._cachedSendCustomEvent = this._cachedSendCustomEvent;
      } else {
        result._cachedSendCustomEvent = this._cachedSendCustomEvent.update(current.sendCustomEvent, parent && parent.oneofActorActionCase === 12 ? parent.sendCustomEvent : null);
      }
    }
    if (this._cachedSetTintColor && this._value._oneofActorActionCase === 13 && current._oneofActorActionCase === 13) {
      if (this._value.setTintColor === current.setTintColor && this._parent === parent) {
        result._cachedSetTintColor = this._cachedSetTintColor;
      } else {
        result._cachedSetTintColor = this._cachedSetTintColor.update(current.setTintColor, parent && parent.oneofActorActionCase === 13 ? parent.setTintColor : null);
      }
    }
    if (this._cachedSetMeshEffect && this._value._oneofActorActionCase === 14 && current._oneofActorActionCase === 14) {
      if (this._value.setMeshEffect === current.setMeshEffect && this._parent === parent) {
        result._cachedSetMeshEffect = this._cachedSetMeshEffect;
      } else {
        result._cachedSetMeshEffect = this._cachedSetMeshEffect.update(current.setMeshEffect, parent && parent.oneofActorActionCase === 14 ? parent.setMeshEffect : null);
      }
    }
    if (this._cachedPlayMusic && this._value._oneofActorActionCase === 15 && current._oneofActorActionCase === 15) {
      if (this._value.playMusic === current.playMusic && this._parent === parent) {
        result._cachedPlayMusic = this._cachedPlayMusic;
      } else {
        result._cachedPlayMusic = this._cachedPlayMusic.update(current.playMusic, parent && parent.oneofActorActionCase === 15 ? parent.playMusic : null);
      }
    }
    if (this._cachedStopMusic && this._value._oneofActorActionCase === 16 && current._oneofActorActionCase === 16) {
      if (this._value.stopMusic === current.stopMusic && this._parent === parent) {
        result._cachedStopMusic = this._cachedStopMusic;
      } else {
        result._cachedStopMusic = this._cachedStopMusic.update(current.stopMusic, parent && parent.oneofActorActionCase === 16 ? parent.stopMusic : null);
      }
    }
    if (this._cachedShakeCamera && this._value._oneofActorActionCase === 17 && current._oneofActorActionCase === 17) {
      if (this._value.shakeCamera === current.shakeCamera && this._parent === parent) {
        result._cachedShakeCamera = this._cachedShakeCamera;
      } else {
        result._cachedShakeCamera = this._cachedShakeCamera.update(current.shakeCamera, parent && parent.oneofActorActionCase === 17 ? parent.shakeCamera : null);
      }
    }
    if (this._cachedSetVisibility && this._value._oneofActorActionCase === 18 && current._oneofActorActionCase === 18) {
      if (this._value.setVisibility === current.setVisibility && this._parent === parent) {
        result._cachedSetVisibility = this._cachedSetVisibility;
      } else {
        result._cachedSetVisibility = this._cachedSetVisibility.update(current.setVisibility, parent && parent.oneofActorActionCase === 18 ? parent.setVisibility : null);
      }
    }
    if (this._cachedSetModelScale && this._value._oneofActorActionCase === 19 && current._oneofActorActionCase === 19) {
      if (this._value.setModelScale === current.setModelScale && this._parent === parent) {
        result._cachedSetModelScale = this._cachedSetModelScale;
      } else {
        result._cachedSetModelScale = this._cachedSetModelScale.update(current.setModelScale, parent && parent.oneofActorActionCase === 19 ? parent.setModelScale : null);
      }
    }
    if (this._cachedBroadcastCustomEvent && this._value._oneofActorActionCase === 20 && current._oneofActorActionCase === 20) {
      if (this._value.broadcastCustomEvent === current.broadcastCustomEvent && this._parent === parent) {
        result._cachedBroadcastCustomEvent = this._cachedBroadcastCustomEvent;
      } else {
        result._cachedBroadcastCustomEvent = this._cachedBroadcastCustomEvent.update(current.broadcastCustomEvent, parent && parent.oneofActorActionCase === 20 ? parent.broadcastCustomEvent : null);
      }
    }
    if (this._cachedApplyMeshEffect && this._value._oneofActorActionCase === 21 && current._oneofActorActionCase === 21) {
      if (this._value.applyMeshEffect === current.applyMeshEffect && this._parent === parent) {
        result._cachedApplyMeshEffect = this._cachedApplyMeshEffect;
      } else {
        result._cachedApplyMeshEffect = this._cachedApplyMeshEffect.update(current.applyMeshEffect, parent && parent.oneofActorActionCase === 21 ? parent.applyMeshEffect : null);
      }
    }
    if (this._cachedRemoveMeshEffect && this._value._oneofActorActionCase === 22 && current._oneofActorActionCase === 22) {
      if (this._value.removeMeshEffect === current.removeMeshEffect && this._parent === parent) {
        result._cachedRemoveMeshEffect = this._cachedRemoveMeshEffect;
      } else {
        result._cachedRemoveMeshEffect = this._cachedRemoveMeshEffect.update(current.removeMeshEffect, parent && parent.oneofActorActionCase === 22 ? parent.removeMeshEffect : null);
      }
    }
    if (this._cachedSetTeamColor && this._value._oneofActorActionCase === 25 && current._oneofActorActionCase === 25) {
      if (this._value.setTeamColor === current.setTeamColor && this._parent === parent) {
        result._cachedSetTeamColor = this._cachedSetTeamColor;
      } else {
        result._cachedSetTeamColor = this._cachedSetTeamColor.update(current.setTeamColor, parent && parent.oneofActorActionCase === 25 ? parent.setTeamColor : null);
      }
    }
    if (this._cachedSetShadowHeight && this._value._oneofActorActionCase === 26 && current._oneofActorActionCase === 26) {
      if (this._value.setShadowHeight === current.setShadowHeight && this._parent === parent) {
        result._cachedSetShadowHeight = this._cachedSetShadowHeight;
      } else {
        result._cachedSetShadowHeight = this._cachedSetShadowHeight.update(current.setShadowHeight, parent && parent.oneofActorActionCase === 26 ? parent.setShadowHeight : null);
      }
    }
    if (this._cachedPlayAnimationWithDuration && this._value._oneofActorActionCase === 27 && current._oneofActorActionCase === 27) {
      if (this._value.playAnimationWithDuration === current.playAnimationWithDuration && this._parent === parent) {
        result._cachedPlayAnimationWithDuration = this._cachedPlayAnimationWithDuration;
      } else {
        result._cachedPlayAnimationWithDuration = this._cachedPlayAnimationWithDuration.update(current.playAnimationWithDuration, parent && parent.oneofActorActionCase === 27 ? parent.playAnimationWithDuration : null);
      }
    }
    if (this._cachedPauseAnimation && this._value._oneofActorActionCase === 28 && current._oneofActorActionCase === 28) {
      if (this._value.pauseAnimation === current.pauseAnimation && this._parent === parent) {
        result._cachedPauseAnimation = this._cachedPauseAnimation;
      } else {
        result._cachedPauseAnimation = this._cachedPauseAnimation.update(current.pauseAnimation, parent && parent.oneofActorActionCase === 28 ? parent.pauseAnimation : null);
      }
    }
    if (this._cachedResumeAnimation && this._value._oneofActorActionCase === 29 && current._oneofActorActionCase === 29) {
      if (this._value.resumeAnimation === current.resumeAnimation && this._parent === parent) {
        result._cachedResumeAnimation = this._cachedResumeAnimation;
      } else {
        result._cachedResumeAnimation = this._cachedResumeAnimation.update(current.resumeAnimation, parent && parent.oneofActorActionCase === 29 ? parent.resumeAnimation : null);
      }
    }
    if (this._cachedPlaySound && this._value._oneofActorActionCase === 30 && current._oneofActorActionCase === 30) {
      if (this._value.playSound === current.playSound && this._parent === parent) {
        result._cachedPlaySound = this._cachedPlaySound;
      } else {
        result._cachedPlaySound = this._cachedPlaySound.update(current.playSound, parent && parent.oneofActorActionCase === 30 ? parent.playSound : null);
      }
    }
    if (this._cachedSetScaleMultiplier && this._value._oneofActorActionCase === 31 && current._oneofActorActionCase === 31) {
      if (this._value.setScaleMultiplier === current.setScaleMultiplier && this._parent === parent) {
        result._cachedSetScaleMultiplier = this._cachedSetScaleMultiplier;
      } else {
        result._cachedSetScaleMultiplier = this._cachedSetScaleMultiplier.update(current.setScaleMultiplier, parent && parent.oneofActorActionCase === 31 ? parent.setScaleMultiplier : null);
      }
    }
    if (this._cachedSetShadow && this._value._oneofActorActionCase === 32 && current._oneofActorActionCase === 32) {
      if (this._value.setShadow === current.setShadow && this._parent === parent) {
        result._cachedSetShadow = this._cachedSetShadow;
      } else {
        result._cachedSetShadow = this._cachedSetShadow.update(current.setShadow, parent && parent.oneofActorActionCase === 32 ? parent.setShadow : null);
      }
    }
    if (this._cachedClearTintColor && this._value._oneofActorActionCase === 33 && current._oneofActorActionCase === 33) {
      if (this._value.clearTintColor === current.clearTintColor && this._parent === parent) {
        result._cachedClearTintColor = this._cachedClearTintColor;
      } else {
        result._cachedClearTintColor = this._cachedClearTintColor.update(current.clearTintColor, parent && parent.oneofActorActionCase === 33 ? parent.clearTintColor : null);
      }
    }
    if (this._cachedSetOutline && this._value._oneofActorActionCase === 34 && current._oneofActorActionCase === 34) {
      if (this._value.setOutline === current.setOutline && this._parent === parent) {
        result._cachedSetOutline = this._cachedSetOutline;
      } else {
        result._cachedSetOutline = this._cachedSetOutline.update(current.setOutline, parent && parent.oneofActorActionCase === 34 ? parent.setOutline : null);
      }
    }
    if (this._cachedSetSpriteFlip && this._value._oneofActorActionCase === 35 && current._oneofActorActionCase === 35) {
      if (this._value.setSpriteFlip === current.setSpriteFlip && this._parent === parent) {
        result._cachedSetSpriteFlip = this._cachedSetSpriteFlip;
      } else {
        result._cachedSetSpriteFlip = this._cachedSetSpriteFlip.update(current.setSpriteFlip, parent && parent.oneofActorActionCase === 35 ? parent.setSpriteFlip : null);
      }
    }
    if (this._cachedClearOutline && this._value._oneofActorActionCase === 36 && current._oneofActorActionCase === 36) {
      if (this._value.clearOutline === current.clearOutline && this._parent === parent) {
        result._cachedClearOutline = this._cachedClearOutline;
      } else {
        result._cachedClearOutline = this._cachedClearOutline.update(current.clearOutline, parent && parent.oneofActorActionCase === 36 ? parent.clearOutline : null);
      }
    }
    if (this._cachedSetWalkAnimation && this._value._oneofActorActionCase === 37 && current._oneofActorActionCase === 37) {
      if (this._value.setWalkAnimation === current.setWalkAnimation && this._parent === parent) {
        result._cachedSetWalkAnimation = this._cachedSetWalkAnimation;
      } else {
        result._cachedSetWalkAnimation = this._cachedSetWalkAnimation.update(current.setWalkAnimation, parent && parent.oneofActorActionCase === 37 ? parent.setWalkAnimation : null);
      }
    }
    if (this._cachedSetIdleAnimation && this._value._oneofActorActionCase === 38 && current._oneofActorActionCase === 38) {
      if (this._value.setIdleAnimation === current.setIdleAnimation && this._parent === parent) {
        result._cachedSetIdleAnimation = this._cachedSetIdleAnimation;
      } else {
        result._cachedSetIdleAnimation = this._cachedSetIdleAnimation.update(current.setIdleAnimation, parent && parent.oneofActorActionCase === 38 ? parent.setIdleAnimation : null);
      }
    }
    return result;
  }
}
ActorAction_WithParent.default = new ActorAction_WithParent(ActorAction.default, null);
ActorAction.WithParent = ActorAction_WithParent;
class ActorAction_Descriptor {
  get playAnimation() {
    if (!this._playAnimation) {
      this._playAnimation = {
        name: "playAnimation",
        Name: "PlayAnimation",
        number: 1,
        protoType: 11,
        protoName: "play_animation",
        oneofIndex: 0,
        type: ActorAction_PlayAnimation,
        options: {
          comments: "Plays an animation on the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playAnimation;
  }
  get stopAnimation() {
    if (!this._stopAnimation) {
      this._stopAnimation = {
        name: "stopAnimation",
        Name: "StopAnimation",
        number: 2,
        protoType: 11,
        protoName: "stop_animation",
        oneofIndex: 0,
        type: ActorAction_StopAnimation,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stopAnimation;
  }
  get create() {
    if (!this._create) {
      this._create = {
        name: "create",
        Name: "Create",
        number: 3,
        protoType: 11,
        protoName: "create",
        oneofIndex: 0,
        type: ActorAction_CreateActor,
        options: {
          comments: "Create a new actor in the scope of this actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._create;
  }
  get destroy() {
    if (!this._destroy) {
      this._destroy = {
        name: "destroy",
        Name: "Destroy",
        number: 4,
        protoType: 11,
        protoName: "destroy",
        oneofIndex: 0,
        type: ActorAction_DestroyActor,
        options: {
          comments: "Destroys an actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._destroy;
  }
  get log() {
    if (!this._log) {
      this._log = {
        name: "log",
        Name: "Log",
        number: 6,
        protoType: 11,
        protoName: "log",
        oneofIndex: 0,
        type: ActorAction_DebugLog,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._log;
  }
  get createTimer() {
    if (!this._createTimer) {
      this._createTimer = {
        name: "createTimer",
        Name: "CreateTimer",
        number: 7,
        protoType: 11,
        protoName: "create_timer",
        oneofIndex: 0,
        type: ActorAction_CreateTimer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._createTimer;
  }
  get removeTimer() {
    if (!this._removeTimer) {
      this._removeTimer = {
        name: "removeTimer",
        Name: "RemoveTimer",
        number: 8,
        protoType: 11,
        protoName: "remove_timer",
        oneofIndex: 0,
        type: ActorAction_RemoveTimer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._removeTimer;
  }
  get setSiteOperations() {
    if (!this._setSiteOperations) {
      this._setSiteOperations = {
        name: "setSiteOperations",
        Name: "SetSiteOperations",
        number: 9,
        protoType: 11,
        protoName: "set_site_operations",
        oneofIndex: 0,
        type: ActorAction_SetSiteOperations,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setSiteOperations;
  }
  get createAliases() {
    if (!this._createAliases) {
      this._createAliases = {
        name: "createAliases",
        Name: "CreateAliases",
        number: 10,
        protoType: 11,
        protoName: "create_aliases",
        oneofIndex: 0,
        type: ActorAction_CreateAliases,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._createAliases;
  }
  get setVariable() {
    if (!this._setVariable) {
      this._setVariable = {
        name: "setVariable",
        Name: "SetVariable",
        number: 11,
        protoType: 11,
        protoName: "set_variable",
        oneofIndex: 0,
        type: ActorAction_SetVariable,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setVariable;
  }
  get sendCustomEvent() {
    if (!this._sendCustomEvent) {
      this._sendCustomEvent = {
        name: "sendCustomEvent",
        Name: "SendCustomEvent",
        number: 12,
        protoType: 11,
        protoName: "send_custom_event",
        oneofIndex: 0,
        type: ActorAction_SendCustomEvent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sendCustomEvent;
  }
  get setTintColor() {
    if (!this._setTintColor) {
      this._setTintColor = {
        name: "setTintColor",
        Name: "SetTintColor",
        number: 13,
        protoType: 11,
        protoName: "set_tint_color",
        oneofIndex: 0,
        type: ActorAction_SetTintColor,
        options: {
          comments: "Sets the tint color of the actor. To clear tint color use ClearTintColor or set RGB to 255, 255, 255.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setTintColor;
  }
  get setMeshEffect() {
    if (!this._setMeshEffect) {
      this._setMeshEffect = {
        name: "setMeshEffect",
        Name: "SetMeshEffect",
        number: 14,
        protoType: 11,
        protoName: "set_mesh_effect",
        oneofIndex: 0,
        type: ActorAction_SetMeshEffect,
        options: {
          comments: "Applies a mesh effect to to the model, overriding any existing mesh effects.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setMeshEffect;
  }
  get playMusic() {
    if (!this._playMusic) {
      this._playMusic = {
        name: "playMusic",
        Name: "PlayMusic",
        number: 15,
        protoType: 11,
        protoName: "play_music",
        oneofIndex: 0,
        type: ActorAction_PlayMusic,
        options: {
          comments: "Used to set the game\'s music track.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playMusic;
  }
  get stopMusic() {
    if (!this._stopMusic) {
      this._stopMusic = {
        name: "stopMusic",
        Name: "StopMusic",
        number: 16,
        protoType: 11,
        protoName: "stop_music",
        oneofIndex: 0,
        type: ActorAction_StopMusic,
        options: {
          comments: "Used to stop the game\'s music track.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stopMusic;
  }
  get shakeCamera() {
    if (!this._shakeCamera) {
      this._shakeCamera = {
        name: "shakeCamera",
        Name: "ShakeCamera",
        number: 17,
        protoType: 11,
        protoName: "shake_camera",
        oneofIndex: 0,
        type: ActorAction_ShakeCamera,
        options: {
          comments: "Shakes the camera.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shakeCamera;
  }
  get setVisibility() {
    if (!this._setVisibility) {
      this._setVisibility = {
        name: "setVisibility",
        Name: "SetVisibility",
        number: 18,
        protoType: 11,
        protoName: "set_visibility",
        oneofIndex: 0,
        type: ActorAction_SetVisibility,
        options: {
          comments: "Modifies the visibility of the actor. Hidden actors can\'t be selected or otherwise interact with the cursor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setVisibility;
  }
  get setModelScale() {
    if (!this._setModelScale) {
      this._setModelScale = {
        name: "setModelScale",
        Name: "SetModelScale",
        number: 19,
        protoType: 11,
        protoName: "set_model_scale",
        oneofIndex: 0,
        type: ActorAction_SetModelScale,
        options: {
          comments: "The actor that should receive the event. Accepts an actor name or alias.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setModelScale;
  }
  get broadcastCustomEvent() {
    if (!this._broadcastCustomEvent) {
      this._broadcastCustomEvent = {
        name: "broadcastCustomEvent",
        Name: "BroadcastCustomEvent",
        number: 20,
        protoType: 11,
        protoName: "broadcast_custom_event",
        oneofIndex: 0,
        type: ActorAction_BroadcastCustomEvent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._broadcastCustomEvent;
  }
  get applyMeshEffect() {
    if (!this._applyMeshEffect) {
      this._applyMeshEffect = {
        name: "applyMeshEffect",
        Name: "ApplyMeshEffect",
        number: 21,
        protoType: 11,
        protoName: "apply_mesh_effect",
        oneofIndex: 0,
        type: ActorAction_ApplyMeshEffect,
        options: {
          comments: "Applies a mesh effect to the actor. Mesh effects are similar to shaders effects.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._applyMeshEffect;
  }
  get removeMeshEffect() {
    if (!this._removeMeshEffect) {
      this._removeMeshEffect = {
        name: "removeMeshEffect",
        Name: "RemoveMeshEffect",
        number: 22,
        protoType: 11,
        protoName: "remove_mesh_effect",
        oneofIndex: 0,
        type: ActorAction_RemoveMeshEffect,
        options: {
          comments: "Removes a mesh effect from the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._removeMeshEffect;
  }
  get setTeamColor() {
    if (!this._setTeamColor) {
      this._setTeamColor = {
        name: "setTeamColor",
        Name: "SetTeamColor",
        number: 25,
        protoType: 11,
        protoName: "set_team_color",
        oneofIndex: 0,
        type: ActorAction_SetTeamColor,
        options: {
          comments: "Applies colorization to specific sections of model\'s texture.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setTeamColor;
  }
  get setShadowHeight() {
    if (!this._setShadowHeight) {
      this._setShadowHeight = {
        name: "setShadowHeight",
        Name: "SetShadowHeight",
        number: 26,
        protoType: 11,
        protoName: "set_shadow_height",
        oneofIndex: 0,
        type: ActorAction_SetShadowHeight,
        options: {
          comments: "Sets the shadow height of the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setShadowHeight;
  }
  get playAnimationWithDuration() {
    if (!this._playAnimationWithDuration) {
      this._playAnimationWithDuration = {
        name: "playAnimationWithDuration",
        Name: "PlayAnimationWithDuration",
        number: 27,
        protoType: 11,
        protoName: "play_animation_with_duration",
        oneofIndex: 0,
        type: ActorAction_PlayAnimationWithDuration,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playAnimationWithDuration;
  }
  get pauseAnimation() {
    if (!this._pauseAnimation) {
      this._pauseAnimation = {
        name: "pauseAnimation",
        Name: "PauseAnimation",
        number: 28,
        protoType: 11,
        protoName: "pause_animation",
        oneofIndex: 0,
        type: ActorAction_PauseAnimation,
        options: {
          comments: "Used to pause a currently playing animation on the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pauseAnimation;
  }
  get resumeAnimation() {
    if (!this._resumeAnimation) {
      this._resumeAnimation = {
        name: "resumeAnimation",
        Name: "ResumeAnimation",
        number: 29,
        protoType: 11,
        protoName: "resume_animation",
        oneofIndex: 0,
        type: ActorAction_ResumeAnimation,
        options: {
          comments: "Resumes a paused animation on the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resumeAnimation;
  }
  get playSound() {
    if (!this._playSound) {
      this._playSound = {
        name: "playSound",
        Name: "PlaySound",
        number: 30,
        protoType: 11,
        protoName: "play_sound",
        oneofIndex: 0,
        type: ActorAction_PlaySound,
        options: {
          comments: "Used to play a sound from an actor directly.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playSound;
  }
  get setScaleMultiplier() {
    if (!this._setScaleMultiplier) {
      this._setScaleMultiplier = {
        name: "setScaleMultiplier",
        Name: "SetScaleMultiplier",
        number: 31,
        protoType: 11,
        protoName: "set_scale_multiplier",
        oneofIndex: 0,
        type: ActorAction_SetScaleMultiplier,
        options: {
          comments: "Sets the scale of the actor across individual axes. The final scale will be these values multiplied by the **Model Scale**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setScaleMultiplier;
  }
  get setShadow() {
    if (!this._setShadow) {
      this._setShadow = {
        name: "setShadow",
        Name: "SetShadow",
        number: 32,
        protoType: 11,
        protoName: "set_shadow",
        oneofIndex: 0,
        type: ActorAction_SetShadow,
        options: {
          comments: "Used to hide or show the shadow of an actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setShadow;
  }
  get clearTintColor() {
    if (!this._clearTintColor) {
      this._clearTintColor = {
        name: "clearTintColor",
        Name: "ClearTintColor",
        number: 33,
        protoType: 11,
        protoName: "clear_tint_color",
        oneofIndex: 0,
        type: ActorAction_ClearTintColor,
        options: {
          comments: "Removes tint color from the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clearTintColor;
  }
  get setOutline() {
    if (!this._setOutline) {
      this._setOutline = {
        name: "setOutline",
        Name: "SetOutline",
        number: 34,
        protoType: 11,
        protoName: "set_outline",
        oneofIndex: 0,
        type: ActorAction_SetOutline,
        options: {
          comments: "Sets the outline render for the actor",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setOutline;
  }
  get setSpriteFlip() {
    if (!this._setSpriteFlip) {
      this._setSpriteFlip = {
        name: "setSpriteFlip",
        Name: "SetSpriteFlip",
        number: 35,
        protoType: 11,
        protoName: "set_sprite_flip",
        oneofIndex: 0,
        type: ActorAction_SetSpriteFlip,
        options: {
          comments: "Flips the sprite vertically and/or horizontally.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setSpriteFlip;
  }
  get clearOutline() {
    if (!this._clearOutline) {
      this._clearOutline = {
        name: "clearOutline",
        Name: "ClearOutline",
        number: 36,
        protoType: 11,
        protoName: "clear_outline",
        oneofIndex: 0,
        type: ActorAction_ClearOutline,
        options: {
          comments: "Clear the outline render for the actor",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clearOutline;
  }
  get setWalkAnimation() {
    if (!this._setWalkAnimation) {
      this._setWalkAnimation = {
        name: "setWalkAnimation",
        Name: "SetWalkAnimation",
        number: 37,
        protoType: 11,
        protoName: "set_walk_animation",
        oneofIndex: 0,
        type: ActorAction_SetWalkAnimation,
        options: {
          comments: "Sets the walk animation for the actor",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setWalkAnimation;
  }
  get setIdleAnimation() {
    if (!this._setIdleAnimation) {
      this._setIdleAnimation = {
        name: "setIdleAnimation",
        Name: "SetIdleAnimation",
        number: 38,
        protoType: 11,
        protoName: "set_idle_animation",
        oneofIndex: 0,
        type: ActorAction_SetIdleAnimation,
        options: {
          comments: "Sets the idle animation for the actor",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._setIdleAnimation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playAnimation,
        this.stopAnimation,
        this.create,
        this.destroy,
        this.log,
        this.createTimer,
        this.removeTimer,
        this.setSiteOperations,
        this.createAliases,
        this.setVariable,
        this.sendCustomEvent,
        this.setTintColor,
        this.setMeshEffect,
        this.playMusic,
        this.stopMusic,
        this.shakeCamera,
        this.setVisibility,
        this.setModelScale,
        this.broadcastCustomEvent,
        this.applyMeshEffect,
        this.removeMeshEffect,
        this.setTeamColor,
        this.setShadowHeight,
        this.playAnimationWithDuration,
        this.pauseAnimation,
        this.resumeAnimation,
        this.playSound,
        this.setScaleMultiplier,
        this.setShadow,
        this.clearTintColor,
        this.setOutline,
        this.setSpriteFlip,
        this.clearOutline,
        this.setWalkAnimation,
        this.setIdleAnimation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofActorAction",
        Name: "OneofActorAction",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
          this.fields[13],
          this.fields[14],
          this.fields[15],
          this.fields[16],
          this.fields[17],
          this.fields[18],
          this.fields[19],
          this.fields[20],
          this.fields[21],
          this.fields[22],
          this.fields[23],
          this.fields[24],
          this.fields[25],
          this.fields[26],
          this.fields[27],
          this.fields[28],
          this.fields[29],
          this.fields[30],
          this.fields[31],
          this.fields[32],
          this.fields[33],
          this.fields[34],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorAction.descriptor = new ActorAction_Descriptor();
class ActorTerm_EmptyTerm {
  get descriptor() {
    return ActorTerm_EmptyTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_EmptyTerm) {
      return value;
    }
    return ActorTerm_EmptyTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_EmptyTerm();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_EmptyTerm} other
   * @returns {ActorTerm_EmptyTerm}
   */
  merge(other) {
    const copy = new ActorTerm_EmptyTerm(this);
    return copy;
  }
}
ActorTerm_EmptyTerm.default = new ActorTerm_EmptyTerm();
class ActorTerm_EmptyTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_EmptyTerm(value);
  }
  build() {
    return new ActorTerm_EmptyTerm(this._value);
  }
}
ActorTerm_EmptyTerm.Builder = ActorTerm_EmptyTerm_Builder;
class ActorTerm_EmptyTerm_WithParent {
  /**
   * @param {ActorTerm_EmptyTerm} value
   * @param {ActorTerm_EmptyTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_EmptyTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ActorTerm_EmptyTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_EmptyTerm_WithParent.default = new ActorTerm_EmptyTerm_WithParent(ActorTerm_EmptyTerm.default, null);
ActorTerm_EmptyTerm.WithParent = ActorTerm_EmptyTerm_WithParent;
class ActorTerm_EmptyTerm_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ActorTerm_EmptyTerm.descriptor = new ActorTerm_EmptyTerm_Descriptor();
class ActorTerm_UnitTerm {
  get descriptor() {
    return ActorTerm_UnitTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitType = false;
    this._unitType = null;
  }
  isEmpty() {
    if (this._hasUnitType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_UnitTerm) {
      return value;
    }
    return ActorTerm_UnitTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_UnitTerm();
    if (json.unitType != null) {
      result._hasUnitType = true;
      result._unitType = JsonToString.fromJson(json.unitType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitType) {
      result.unitType = JsonToString.toJson(this._unitType);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unitType() {
    return this._hasUnitType ? this._unitType : JsonToString.default;
  }
  get hasUnitType() {
    return this._hasUnitType;
  }
  setUnitType(path, value) {
    return {type: 'SET', path: path.concat(['unitType']), value};
  }
  deleteUnitType(path) {
    return {type: 'DELETE', path: path.concat(['unitType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_UnitTerm(this);
              copy._hasUnitType = true;
              copy._unitType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitType) {
                return this;
              }
              const copy = new ActorTerm_UnitTerm(this);
              copy._hasUnitType = false;
              copy._unitType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_UnitTerm} other
   * @returns {ActorTerm_UnitTerm}
   */
  merge(other) {
    const copy = new ActorTerm_UnitTerm(this);
    if (other._hasUnitType) {
      copy._hasUnitType = true;
      copy._unitType = other._unitType;
    }
    return copy;
  }
}
ActorTerm_UnitTerm.default = new ActorTerm_UnitTerm();
class ActorTerm_UnitTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_UnitTerm(value);
  }
  build() {
    return new ActorTerm_UnitTerm(this._value);
  }
  setUnitType(value) {
    this._value._hasUnitType = true;
    this._value._unitType = value;
    return this;
  }
  deleteUnitType() {
    this._value._hasUnitType = false;
    this._value._unitType = null;
    return this;
  }
}
ActorTerm_UnitTerm.Builder = ActorTerm_UnitTerm_Builder;
class ActorTerm_UnitTerm_WithParent {
  /**
   * @param {ActorTerm_UnitTerm} value
   * @param {ActorTerm_UnitTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_UnitTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitType() {
    if (this._cachedHasUnitType === undefined) {
      if (this._value.hasUnitType) {
        this._cachedHasUnitType = true;
      } else {
        this._cachedHasUnitType = this._parent ? this._parent.hasUnitType : false;
      }
    }
    return this._cachedHasUnitType;
  }
  get unitType() {
    if (this._cachedUnitType === undefined) {
      if (this._value.hasUnitType) {
        this._cachedUnitType = this._value.unitType;
      } else {
        this._cachedUnitType = this._parent ? this._parent.unitType : this._value.unitType;
      }
    }
    return this._cachedUnitType;
  }
  update(current, parent) {
    const result = new ActorTerm_UnitTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_UnitTerm_WithParent.default = new ActorTerm_UnitTerm_WithParent(ActorTerm_UnitTerm.default, null);
ActorTerm_UnitTerm.WithParent = ActorTerm_UnitTerm_WithParent;
class ActorTerm_UnitTerm_Descriptor {
  get unitType() {
    if (!this._unitType) {
      this._unitType = {
        name: "unitType",
        Name: "UnitType",
        number: 1,
        protoType: 9,
        protoName: "unit_type",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitType",
        Name: "DummyOneofForUnitType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_UnitTerm.descriptor = new ActorTerm_UnitTerm_Descriptor();
class ActorTerm_UnitWeaponTerm {
  get descriptor() {
    return ActorTerm_UnitWeaponTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWeapon = false;
    this._weapon = null;
  }
  isEmpty() {
    if (this._hasWeapon) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_UnitWeaponTerm) {
      return value;
    }
    return ActorTerm_UnitWeaponTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_UnitWeaponTerm();
    if (json.weapon != null) {
      result._hasWeapon = true;
      result._weapon = JsonToString.fromJson(json.weapon);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWeapon) {
      result.weapon = JsonToString.toJson(this._weapon);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get weapon() {
    return this._hasWeapon ? this._weapon : JsonToString.default;
  }
  get hasWeapon() {
    return this._hasWeapon;
  }
  setWeapon(path, value) {
    return {type: 'SET', path: path.concat(['weapon']), value};
  }
  deleteWeapon(path) {
    return {type: 'DELETE', path: path.concat(['weapon'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "weapon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_UnitWeaponTerm(this);
              copy._hasWeapon = true;
              copy._weapon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeapon) {
                return this;
              }
              const copy = new ActorTerm_UnitWeaponTerm(this);
              copy._hasWeapon = false;
              copy._weapon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_UnitWeaponTerm} other
   * @returns {ActorTerm_UnitWeaponTerm}
   */
  merge(other) {
    const copy = new ActorTerm_UnitWeaponTerm(this);
    if (other._hasWeapon) {
      copy._hasWeapon = true;
      copy._weapon = other._weapon;
    }
    return copy;
  }
}
ActorTerm_UnitWeaponTerm.default = new ActorTerm_UnitWeaponTerm();
class ActorTerm_UnitWeaponTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_UnitWeaponTerm(value);
  }
  build() {
    return new ActorTerm_UnitWeaponTerm(this._value);
  }
  setWeapon(value) {
    this._value._hasWeapon = true;
    this._value._weapon = value;
    return this;
  }
  deleteWeapon() {
    this._value._hasWeapon = false;
    this._value._weapon = null;
    return this;
  }
}
ActorTerm_UnitWeaponTerm.Builder = ActorTerm_UnitWeaponTerm_Builder;
class ActorTerm_UnitWeaponTerm_WithParent {
  /**
   * @param {ActorTerm_UnitWeaponTerm} value
   * @param {ActorTerm_UnitWeaponTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_UnitWeaponTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWeapon() {
    if (this._cachedHasWeapon === undefined) {
      if (this._value.hasWeapon) {
        this._cachedHasWeapon = true;
      } else {
        this._cachedHasWeapon = this._parent ? this._parent.hasWeapon : false;
      }
    }
    return this._cachedHasWeapon;
  }
  get weapon() {
    if (this._cachedWeapon === undefined) {
      if (this._value.hasWeapon) {
        this._cachedWeapon = this._value.weapon;
      } else {
        this._cachedWeapon = this._parent ? this._parent.weapon : this._value.weapon;
      }
    }
    return this._cachedWeapon;
  }
  update(current, parent) {
    const result = new ActorTerm_UnitWeaponTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_UnitWeaponTerm_WithParent.default = new ActorTerm_UnitWeaponTerm_WithParent(ActorTerm_UnitWeaponTerm.default, null);
ActorTerm_UnitWeaponTerm.WithParent = ActorTerm_UnitWeaponTerm_WithParent;
class ActorTerm_UnitWeaponTerm_Descriptor {
  get weapon() {
    if (!this._weapon) {
      this._weapon = {
        name: "weapon",
        Name: "Weapon",
        number: 1,
        protoType: 9,
        protoName: "weapon",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedWeaponListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weapon;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.weapon,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWeapon",
        Name: "DummyOneofForWeapon",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_UnitWeaponTerm.descriptor = new ActorTerm_UnitWeaponTerm_Descriptor();
class ActorTerm_UnitAbilityTerm {
  get descriptor() {
    return ActorTerm_UnitAbilityTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAbility = false;
    this._ability = null;
  }
  isEmpty() {
    if (this._hasAbility) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_UnitAbilityTerm) {
      return value;
    }
    return ActorTerm_UnitAbilityTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_UnitAbilityTerm();
    if (json.ability != null) {
      result._hasAbility = true;
      result._ability = JsonToString.fromJson(json.ability);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAbility) {
      result.ability = JsonToString.toJson(this._ability);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get ability() {
    return this._hasAbility ? this._ability : JsonToString.default;
  }
  get hasAbility() {
    return this._hasAbility;
  }
  setAbility(path, value) {
    return {type: 'SET', path: path.concat(['ability']), value};
  }
  deleteAbility(path) {
    return {type: 'DELETE', path: path.concat(['ability'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "ability": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_UnitAbilityTerm(this);
              copy._hasAbility = true;
              copy._ability = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbility) {
                return this;
              }
              const copy = new ActorTerm_UnitAbilityTerm(this);
              copy._hasAbility = false;
              copy._ability = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_UnitAbilityTerm} other
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  merge(other) {
    const copy = new ActorTerm_UnitAbilityTerm(this);
    if (other._hasAbility) {
      copy._hasAbility = true;
      copy._ability = other._ability;
    }
    return copy;
  }
}
ActorTerm_UnitAbilityTerm.default = new ActorTerm_UnitAbilityTerm();
class ActorTerm_UnitAbilityTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_UnitAbilityTerm(value);
  }
  build() {
    return new ActorTerm_UnitAbilityTerm(this._value);
  }
  setAbility(value) {
    this._value._hasAbility = true;
    this._value._ability = value;
    return this;
  }
  deleteAbility() {
    this._value._hasAbility = false;
    this._value._ability = null;
    return this;
  }
}
ActorTerm_UnitAbilityTerm.Builder = ActorTerm_UnitAbilityTerm_Builder;
class ActorTerm_UnitAbilityTerm_WithParent {
  /**
   * @param {ActorTerm_UnitAbilityTerm} value
   * @param {ActorTerm_UnitAbilityTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_UnitAbilityTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAbility() {
    if (this._cachedHasAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedHasAbility = true;
      } else {
        this._cachedHasAbility = this._parent ? this._parent.hasAbility : false;
      }
    }
    return this._cachedHasAbility;
  }
  get ability() {
    if (this._cachedAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedAbility = this._value.ability;
      } else {
        this._cachedAbility = this._parent ? this._parent.ability : this._value.ability;
      }
    }
    return this._cachedAbility;
  }
  update(current, parent) {
    const result = new ActorTerm_UnitAbilityTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_UnitAbilityTerm_WithParent.default = new ActorTerm_UnitAbilityTerm_WithParent(ActorTerm_UnitAbilityTerm.default, null);
ActorTerm_UnitAbilityTerm.WithParent = ActorTerm_UnitAbilityTerm_WithParent;
class ActorTerm_UnitAbilityTerm_Descriptor {
  get ability() {
    if (!this._ability) {
      this._ability = {
        name: "ability",
        Name: "Ability",
        number: 1,
        protoType: 9,
        protoName: "ability",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ability;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.ability,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAbility",
        Name: "DummyOneofForAbility",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_UnitAbilityTerm.descriptor = new ActorTerm_UnitAbilityTerm_Descriptor();
class ActorTerm_SelectionTerm_SelectionType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "SELECTION": return 0;
        case "PRE_SELECTION": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ActorTerm_SelectionTerm_SelectionType.fromJson(value);
  }
  static fromReact(e) {
    return ActorTerm_SelectionTerm_SelectionType.fromJson(e);
  }
}
ActorTerm_SelectionTerm_SelectionType.SELECTION = 0;
ActorTerm_SelectionTerm_SelectionType.PRE_SELECTION = 1;
ActorTerm_SelectionTerm_SelectionType.default = 0;
ActorTerm_SelectionTerm_SelectionType.values = {
  SELECTION: 0,
  PRE_SELECTION: 1,
};
ActorTerm_SelectionTerm_SelectionType.names = {
  0: "SELECTION",
  1: "PRE_SELECTION",
};
class ActorTerm_SelectionTerm {
  get descriptor() {
    return ActorTerm_SelectionTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSelectionType = false;
    this._selectionType = null;
  }
  isEmpty() {
    if (this._hasSelectionType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_SelectionTerm) {
      return value;
    }
    return ActorTerm_SelectionTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_SelectionTerm();
    if (json.selectionType != null) {
      result._hasSelectionType = true;
      result._selectionType = ActorTerm_SelectionTerm_SelectionType.fromJson(json.selectionType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSelectionType) {
      result.selectionType = ActorTerm_SelectionTerm_SelectionType.toJson(this._selectionType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get selectionType() {
    return this._hasSelectionType ? this._selectionType : ActorTerm_SelectionTerm_SelectionType.default;
  }
  get hasSelectionType() {
    return this._hasSelectionType;
  }
  setSelectionType(path, value) {
    return {type: 'SET', path: path.concat(['selectionType']), value};
  }
  deleteSelectionType(path) {
    return {type: 'DELETE', path: path.concat(['selectionType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "selectionType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_SelectionTerm(this);
              copy._hasSelectionType = true;
              copy._selectionType = ActorTerm_SelectionTerm_SelectionType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionType) {
                return this;
              }
              const copy = new ActorTerm_SelectionTerm(this);
              copy._hasSelectionType = false;
              copy._selectionType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_SelectionTerm} other
   * @returns {ActorTerm_SelectionTerm}
   */
  merge(other) {
    const copy = new ActorTerm_SelectionTerm(this);
    if (other._hasSelectionType) {
      copy._hasSelectionType = true;
      copy._selectionType = other._selectionType;
    }
    return copy;
  }
}
ActorTerm_SelectionTerm.default = new ActorTerm_SelectionTerm();
ActorTerm_SelectionTerm.SelectionType = ActorTerm_SelectionTerm_SelectionType;
class ActorTerm_SelectionTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_SelectionTerm(value);
  }
  build() {
    return new ActorTerm_SelectionTerm(this._value);
  }
  setSelectionType(value) {
    this._value._hasSelectionType = true;
    this._value._selectionType = value;
    return this;
  }
  deleteSelectionType() {
    this._value._hasSelectionType = false;
    this._value._selectionType = null;
    return this;
  }
}
ActorTerm_SelectionTerm.Builder = ActorTerm_SelectionTerm_Builder;
class ActorTerm_SelectionTerm_WithParent {
  /**
   * @param {ActorTerm_SelectionTerm} value
   * @param {ActorTerm_SelectionTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_SelectionTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSelectionType() {
    if (this._cachedHasSelectionType === undefined) {
      if (this._value.hasSelectionType) {
        this._cachedHasSelectionType = true;
      } else {
        this._cachedHasSelectionType = this._parent ? this._parent.hasSelectionType : false;
      }
    }
    return this._cachedHasSelectionType;
  }
  get selectionType() {
    if (this._cachedSelectionType === undefined) {
      if (this._value.hasSelectionType) {
        this._cachedSelectionType = this._value.selectionType;
      } else {
        this._cachedSelectionType = this._parent ? this._parent.selectionType : this._value.selectionType;
      }
    }
    return this._cachedSelectionType;
  }
  update(current, parent) {
    const result = new ActorTerm_SelectionTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_SelectionTerm_WithParent.default = new ActorTerm_SelectionTerm_WithParent(ActorTerm_SelectionTerm.default, null);
ActorTerm_SelectionTerm.WithParent = ActorTerm_SelectionTerm_WithParent;
class ActorTerm_SelectionTerm_Descriptor {
  get selectionType() {
    if (!this._selectionType) {
      this._selectionType = {
        name: "selectionType",
        Name: "SelectionType",
        number: 1,
        protoType: 14,
        protoName: "selection_type",
        type: ActorTerm_SelectionTerm_SelectionType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.selectionType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSelectionType",
        Name: "DummyOneofForSelectionType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_SelectionTerm.descriptor = new ActorTerm_SelectionTerm_Descriptor();
class ActorTerm_BehaviorTerm {
  get descriptor() {
    return ActorTerm_BehaviorTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehavior = false;
    this._behavior = null;
  }
  isEmpty() {
    if (this._hasBehavior) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_BehaviorTerm) {
      return value;
    }
    return ActorTerm_BehaviorTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_BehaviorTerm();
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_BehaviorTerm(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new ActorTerm_BehaviorTerm(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_BehaviorTerm} other
   * @returns {ActorTerm_BehaviorTerm}
   */
  merge(other) {
    const copy = new ActorTerm_BehaviorTerm(this);
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    return copy;
  }
}
ActorTerm_BehaviorTerm.default = new ActorTerm_BehaviorTerm();
class ActorTerm_BehaviorTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_BehaviorTerm(value);
  }
  build() {
    return new ActorTerm_BehaviorTerm(this._value);
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
}
ActorTerm_BehaviorTerm.Builder = ActorTerm_BehaviorTerm_Builder;
class ActorTerm_BehaviorTerm_WithParent {
  /**
   * @param {ActorTerm_BehaviorTerm} value
   * @param {ActorTerm_BehaviorTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_BehaviorTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  update(current, parent) {
    const result = new ActorTerm_BehaviorTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_BehaviorTerm_WithParent.default = new ActorTerm_BehaviorTerm_WithParent(ActorTerm_BehaviorTerm.default, null);
ActorTerm_BehaviorTerm.WithParent = ActorTerm_BehaviorTerm_WithParent;
class ActorTerm_BehaviorTerm_Descriptor {
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 1,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "The behavior that triggers this event.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behavior,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_BehaviorTerm.descriptor = new ActorTerm_BehaviorTerm_Descriptor();
class ActorTerm_EffectTerm {
  get descriptor() {
    return ActorTerm_EffectTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEffect = false;
    this._effect = null;
  }
  isEmpty() {
    if (this._hasEffect) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_EffectTerm) {
      return value;
    }
    return ActorTerm_EffectTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_EffectTerm();
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_EffectTerm(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new ActorTerm_EffectTerm(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_EffectTerm} other
   * @returns {ActorTerm_EffectTerm}
   */
  merge(other) {
    const copy = new ActorTerm_EffectTerm(this);
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    return copy;
  }
}
ActorTerm_EffectTerm.default = new ActorTerm_EffectTerm();
class ActorTerm_EffectTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_EffectTerm(value);
  }
  build() {
    return new ActorTerm_EffectTerm(this._value);
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
}
ActorTerm_EffectTerm.Builder = ActorTerm_EffectTerm_Builder;
class ActorTerm_EffectTerm_WithParent {
  /**
   * @param {ActorTerm_EffectTerm} value
   * @param {ActorTerm_EffectTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_EffectTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  update(current, parent) {
    const result = new ActorTerm_EffectTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_EffectTerm_WithParent.default = new ActorTerm_EffectTerm_WithParent(ActorTerm_EffectTerm.default, null);
ActorTerm_EffectTerm.WithParent = ActorTerm_EffectTerm_WithParent;
class ActorTerm_EffectTerm_Descriptor {
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 1,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The persistent effect that triggers this event.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.effect,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_EffectTerm.descriptor = new ActorTerm_EffectTerm_Descriptor();
class ActorTerm_AnimationTerm {
  get descriptor() {
    return ActorTerm_AnimationTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClip = false;
    this._clip = null;
  }
  isEmpty() {
    if (this._hasClip) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_AnimationTerm) {
      return value;
    }
    return ActorTerm_AnimationTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_AnimationTerm();
    if (json.clip != null) {
      result._hasClip = true;
      result._clip = JsonToInt32.fromJson(json.clip);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClip) {
      result.clip = JsonToInt32.toJson(this._clip);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get clip() {
    return this._hasClip ? this._clip : JsonToInt32.default;
  }
  get hasClip() {
    return this._hasClip;
  }
  setClip(path, value) {
    return {type: 'SET', path: path.concat(['clip']), value};
  }
  deleteClip(path) {
    return {type: 'DELETE', path: path.concat(['clip'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "clip": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_AnimationTerm(this);
              copy._hasClip = true;
              copy._clip = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClip) {
                return this;
              }
              const copy = new ActorTerm_AnimationTerm(this);
              copy._hasClip = false;
              copy._clip = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_AnimationTerm} other
   * @returns {ActorTerm_AnimationTerm}
   */
  merge(other) {
    const copy = new ActorTerm_AnimationTerm(this);
    if (other._hasClip) {
      copy._hasClip = true;
      copy._clip = other._clip;
    }
    return copy;
  }
}
ActorTerm_AnimationTerm.default = new ActorTerm_AnimationTerm();
class ActorTerm_AnimationTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_AnimationTerm(value);
  }
  build() {
    return new ActorTerm_AnimationTerm(this._value);
  }
  setClip(value) {
    this._value._hasClip = true;
    this._value._clip = value;
    return this;
  }
  deleteClip() {
    this._value._hasClip = false;
    this._value._clip = null;
    return this;
  }
}
ActorTerm_AnimationTerm.Builder = ActorTerm_AnimationTerm_Builder;
class ActorTerm_AnimationTerm_WithParent {
  /**
   * @param {ActorTerm_AnimationTerm} value
   * @param {ActorTerm_AnimationTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_AnimationTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClip() {
    if (this._cachedHasClip === undefined) {
      if (this._value.hasClip) {
        this._cachedHasClip = true;
      } else {
        this._cachedHasClip = this._parent ? this._parent.hasClip : false;
      }
    }
    return this._cachedHasClip;
  }
  get clip() {
    if (this._cachedClip === undefined) {
      if (this._value.hasClip) {
        this._cachedClip = this._value.clip;
      } else {
        this._cachedClip = this._parent ? this._parent.clip : this._value.clip;
      }
    }
    return this._cachedClip;
  }
  update(current, parent) {
    const result = new ActorTerm_AnimationTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_AnimationTerm_WithParent.default = new ActorTerm_AnimationTerm_WithParent(ActorTerm_AnimationTerm.default, null);
ActorTerm_AnimationTerm.WithParent = ActorTerm_AnimationTerm_WithParent;
class ActorTerm_AnimationTerm_Descriptor {
  get clip() {
    if (!this._clip) {
      this._clip = {
        name: "clip",
        Name: "Clip",
        number: 1,
        protoType: 5,
        protoName: "clip",
        type: JsonToInt32,
        options: {
          comments: "The animation that should trigger this event.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._clip;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.clip,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClip",
        Name: "DummyOneofForClip",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_AnimationTerm.descriptor = new ActorTerm_AnimationTerm_Descriptor();
class ActorTerm_TimerTerm {
  get descriptor() {
    return ActorTerm_TimerTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_TimerTerm) {
      return value;
    }
    return ActorTerm_TimerTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_TimerTerm();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_TimerTerm(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ActorTerm_TimerTerm(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_TimerTerm} other
   * @returns {ActorTerm_TimerTerm}
   */
  merge(other) {
    const copy = new ActorTerm_TimerTerm(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    return copy;
  }
}
ActorTerm_TimerTerm.default = new ActorTerm_TimerTerm();
class ActorTerm_TimerTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm_TimerTerm(value);
  }
  build() {
    return new ActorTerm_TimerTerm(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
}
ActorTerm_TimerTerm.Builder = ActorTerm_TimerTerm_Builder;
class ActorTerm_TimerTerm_WithParent {
  /**
   * @param {ActorTerm_TimerTerm} value
   * @param {ActorTerm_TimerTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_TimerTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  update(current, parent) {
    const result = new ActorTerm_TimerTerm_WithParent(current, parent);
    return result;
  }
}
ActorTerm_TimerTerm_WithParent.default = new ActorTerm_TimerTerm_WithParent(ActorTerm_TimerTerm.default, null);
ActorTerm_TimerTerm.WithParent = ActorTerm_TimerTerm_WithParent;
class ActorTerm_TimerTerm_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "The name of the timer that triggers this event.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_TimerTerm.descriptor = new ActorTerm_TimerTerm_Descriptor();
class ActorTerm_CustomEvent {
  get descriptor() {
    return ActorTerm_CustomEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedEventId = false;
    this._eventId = null;
    this._hasIdentifier = false;
    this._identifier = null;
  }
  isEmpty() {
    if (this._hasDeprecatedEventId) return false;
    if (this._hasIdentifier) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm_CustomEvent) {
      return value;
    }
    return ActorTerm_CustomEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm_CustomEvent();
    if (json.eventId != null) {
      result._hasDeprecatedEventId = true;
      result._eventId = JsonToInt32.fromJson(json.eventId);
    }
    if (json.identifier != null) {
      result._hasIdentifier = true;
      result._identifier = JsonToString.fromJson(json.identifier);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedEventId) {
      result.eventId = JsonToInt32.toJson(this._eventId);
    }
    if (this._hasIdentifier) {
      result.identifier = JsonToString.toJson(this._identifier);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get eventId() {
    return this._hasDeprecatedEventId ? this._eventId : JsonToInt32.default;
  }
  get hasDeprecatedEventId() {
    return this._hasDeprecatedEventId;
  }
  setDeprecatedEventId(path, value) {
    return {type: 'SET', path: path.concat(['eventId']), value};
  }
  deleteDeprecatedEventId(path) {
    return {type: 'DELETE', path: path.concat(['eventId'])};
  }
  /**
   * @returns {string}
   */
  get identifier() {
    return this._hasIdentifier ? this._identifier : JsonToString.default;
  }
  get hasIdentifier() {
    return this._hasIdentifier;
  }
  setIdentifier(path, value) {
    return {type: 'SET', path: path.concat(['identifier']), value};
  }
  deleteIdentifier(path) {
    return {type: 'DELETE', path: path.concat(['identifier'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "eventId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_CustomEvent(this);
              copy._hasDeprecatedEventId = true;
              copy._eventId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedEventId) {
                return this;
              }
              const copy = new ActorTerm_CustomEvent(this);
              copy._hasDeprecatedEventId = false;
              copy._eventId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "identifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm_CustomEvent(this);
              copy._hasIdentifier = true;
              copy._identifier = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIdentifier) {
                return this;
              }
              const copy = new ActorTerm_CustomEvent(this);
              copy._hasIdentifier = false;
              copy._identifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm_CustomEvent} other
   * @returns {ActorTerm_CustomEvent}
   */
  merge(other) {
    const copy = new ActorTerm_CustomEvent(this);
    if (other._hasDeprecatedEventId) {
      copy._hasDeprecatedEventId = true;
      copy._eventId = other._eventId;
    }
    if (other._hasIdentifier) {
      copy._hasIdentifier = true;
      copy._identifier = other._identifier;
    }
    return copy;
  }
}
ActorTerm_CustomEvent.default = new ActorTerm_CustomEvent();
class ActorTerm_CustomEvent_Builder {
  constructor(value) {
    this._value = new ActorTerm_CustomEvent(value);
  }
  build() {
    return new ActorTerm_CustomEvent(this._value);
  }
  setDeprecatedEventId(value) {
    this._value._hasDeprecatedEventId = true;
    this._value._eventId = value;
    return this;
  }
  deleteDeprecatedEventId() {
    this._value._hasDeprecatedEventId = false;
    this._value._eventId = null;
    return this;
  }
  setIdentifier(value) {
    this._value._hasIdentifier = true;
    this._value._identifier = value;
    return this;
  }
  deleteIdentifier() {
    this._value._hasIdentifier = false;
    this._value._identifier = null;
    return this;
  }
}
ActorTerm_CustomEvent.Builder = ActorTerm_CustomEvent_Builder;
class ActorTerm_CustomEvent_WithParent {
  /**
   * @param {ActorTerm_CustomEvent} value
   * @param {ActorTerm_CustomEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm_CustomEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedEventId() {
    if (this._cachedHasDeprecatedEventId === undefined) {
      if (this._value.hasDeprecatedEventId) {
        this._cachedHasDeprecatedEventId = true;
      } else {
        this._cachedHasDeprecatedEventId = this._parent ? this._parent.hasDeprecatedEventId : false;
      }
    }
    return this._cachedHasDeprecatedEventId;
  }
  get eventId() {
    if (this._cachedDeprecatedEventId === undefined) {
      if (this._value.hasDeprecatedEventId) {
        this._cachedDeprecatedEventId = this._value.eventId;
      } else {
        this._cachedDeprecatedEventId = this._parent ? this._parent.eventId : this._value.eventId;
      }
    }
    return this._cachedDeprecatedEventId;
  }
  get hasIdentifier() {
    if (this._cachedHasIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedHasIdentifier = true;
      } else {
        this._cachedHasIdentifier = this._parent ? this._parent.hasIdentifier : false;
      }
    }
    return this._cachedHasIdentifier;
  }
  get identifier() {
    if (this._cachedIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedIdentifier = this._value.identifier;
      } else {
        this._cachedIdentifier = this._parent ? this._parent.identifier : this._value.identifier;
      }
    }
    return this._cachedIdentifier;
  }
  update(current, parent) {
    const result = new ActorTerm_CustomEvent_WithParent(current, parent);
    return result;
  }
}
ActorTerm_CustomEvent_WithParent.default = new ActorTerm_CustomEvent_WithParent(ActorTerm_CustomEvent.default, null);
ActorTerm_CustomEvent.WithParent = ActorTerm_CustomEvent_WithParent;
class ActorTerm_CustomEvent_Descriptor {
  get eventId() {
    if (!this._eventId) {
      this._eventId = {
        name: "eventId",
        Name: "DeprecatedEventId",
        number: 1001,
        protoType: 5,
        protoName: "deprecated_event_id",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventId;
  }
  get identifier() {
    if (!this._identifier) {
      this._identifier = {
        name: "identifier",
        Name: "Identifier",
        number: 1,
        protoType: 9,
        protoName: "identifier",
        type: JsonToString,
        options: {
          comments: "The name of the custom event that triggers this event.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._identifier;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.eventId,
        this.identifier,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedEventId",
        Name: "DummyOneofForDeprecatedEventId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIdentifier",
        Name: "DummyOneofForIdentifier",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm_CustomEvent.descriptor = new ActorTerm_CustomEvent_Descriptor();
export class ActorTerm {
  get descriptor() {
    return ActorTerm.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTermTypeCase = 0;
    this._oneofTermTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTermTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorTerm) {
      return value;
    }
    return ActorTerm.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorTerm();
    if (json.unitSpawn != null) {
      result._oneofTermTypeCase = 1;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitSpawn);
    }
    if (json.unitMorph != null) {
      result._oneofTermTypeCase = 2;
      result._oneofTermTypeValue = ActorTerm_UnitTerm.fromJson(json.unitMorph);
    }
    if (json.unitRemove != null) {
      result._oneofTermTypeCase = 3;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitRemove);
    }
    if (json.unitStand != null) {
      result._oneofTermTypeCase = 4;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitStand);
    }
    if (json.unitWalk != null) {
      result._oneofTermTypeCase = 5;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitWalk);
    }
    if (json.unitDeath != null) {
      result._oneofTermTypeCase = 6;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitDeath);
    }
    if (json.unitWeaponStart != null) {
      result._oneofTermTypeCase = 7;
      result._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.fromJson(json.unitWeaponStart);
    }
    if (json.unitWeaponStop != null) {
      result._oneofTermTypeCase = 8;
      result._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.fromJson(json.unitWeaponStop);
    }
    if (json.unitAbilityStart != null) {
      result._oneofTermTypeCase = 9;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.unitAbilityStart);
    }
    if (json.unitAbilityStop != null) {
      result._oneofTermTypeCase = 10;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.unitAbilityStop);
    }
    if (json.unitAbilityTargetingOn != null) {
      result._oneofTermTypeCase = 11;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.unitAbilityTargetingOn);
    }
    if (json.unitAbilityTargetingOff != null) {
      result._oneofTermTypeCase = 12;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.unitAbilityTargetingOff);
    }
    if (json.unitChildrenSelectionOn != null) {
      result._oneofTermTypeCase = 13;
      result._oneofTermTypeValue = ActorTerm_UnitTerm.fromJson(json.unitChildrenSelectionOn);
    }
    if (json.unitChildrenSelectionOff != null) {
      result._oneofTermTypeCase = 14;
      result._oneofTermTypeValue = ActorTerm_UnitTerm.fromJson(json.unitChildrenSelectionOff);
    }
    if (json.unitMoveCommandReceived != null) {
      result._oneofTermTypeCase = 15;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitMoveCommandReceived);
    }
    if (json.unitAttackCommandReceived != null) {
      result._oneofTermTypeCase = 16;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.unitAttackCommandReceived);
    }
    if (json.unitWeaponDamagePoint != null) {
      result._oneofTermTypeCase = 17;
      result._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.fromJson(json.unitWeaponDamagePoint);
    }
    if (json.preAbilityTargetedOn != null) {
      result._oneofTermTypeCase = 18;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.preAbilityTargetedOn);
    }
    if (json.preAbilityTargetedOff != null) {
      result._oneofTermTypeCase = 19;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.preAbilityTargetedOff);
    }
    if (json.preAbilityCastTargeted != null) {
      result._oneofTermTypeCase = 20;
      result._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromJson(json.preAbilityCastTargeted);
    }
    if (json.selectionOn != null) {
      result._oneofTermTypeCase = 21;
      result._oneofTermTypeValue = ActorTerm_SelectionTerm.fromJson(json.selectionOn);
    }
    if (json.selectionOff != null) {
      result._oneofTermTypeCase = 22;
      result._oneofTermTypeValue = ActorTerm_SelectionTerm.fromJson(json.selectionOff);
    }
    if (json.behaviorOn != null) {
      result._oneofTermTypeCase = 31;
      result._oneofTermTypeValue = ActorTerm_BehaviorTerm.fromJson(json.behaviorOn);
    }
    if (json.behaviorOff != null) {
      result._oneofTermTypeCase = 32;
      result._oneofTermTypeValue = ActorTerm_BehaviorTerm.fromJson(json.behaviorOff);
    }
    if (json.persistentEffectOn != null) {
      result._oneofTermTypeCase = 41;
      result._oneofTermTypeValue = ActorTerm_EffectTerm.fromJson(json.persistentEffectOn);
    }
    if (json.persistentEffectOff != null) {
      result._oneofTermTypeCase = 42;
      result._oneofTermTypeValue = ActorTerm_EffectTerm.fromJson(json.persistentEffectOff);
    }
    if (json.actorCreate != null) {
      result._oneofTermTypeCase = 51;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.actorCreate);
    }
    if (json.actorDestroy != null) {
      result._oneofTermTypeCase = 52;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.actorDestroy);
    }
    if (json.actorOrphan != null) {
      result._oneofTermTypeCase = 53;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.actorOrphan);
    }
    if (json.animationFinish != null) {
      result._oneofTermTypeCase = 61;
      result._oneofTermTypeValue = ActorTerm_AnimationTerm.fromJson(json.animationFinish);
    }
    if (json.onTimer != null) {
      result._oneofTermTypeCase = 71;
      result._oneofTermTypeValue = ActorTerm_TimerTerm.fromJson(json.onTimer);
    }
    if (json.onCustomEvent != null) {
      result._oneofTermTypeCase = 81;
      result._oneofTermTypeValue = ActorTerm_CustomEvent.fromJson(json.onCustomEvent);
    }
    if (json.beamLostTarget != null) {
      result._oneofTermTypeCase = 91;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.beamLostTarget);
    }
    if (json.beamLostLaunch != null) {
      result._oneofTermTypeCase = 92;
      result._oneofTermTypeValue = ActorTerm_EmptyTerm.fromJson(json.beamLostLaunch);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTermTypeCase) {
      case 1:
        result.unitSpawn = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 2:
        result.unitMorph = ActorTerm_UnitTerm.toJson(this._oneofTermTypeValue);
        break;
      case 3:
        result.unitRemove = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 4:
        result.unitStand = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 5:
        result.unitWalk = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 6:
        result.unitDeath = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 7:
        result.unitWeaponStart = ActorTerm_UnitWeaponTerm.toJson(this._oneofTermTypeValue);
        break;
      case 8:
        result.unitWeaponStop = ActorTerm_UnitWeaponTerm.toJson(this._oneofTermTypeValue);
        break;
      case 9:
        result.unitAbilityStart = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 10:
        result.unitAbilityStop = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 11:
        result.unitAbilityTargetingOn = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 12:
        result.unitAbilityTargetingOff = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 13:
        result.unitChildrenSelectionOn = ActorTerm_UnitTerm.toJson(this._oneofTermTypeValue);
        break;
      case 14:
        result.unitChildrenSelectionOff = ActorTerm_UnitTerm.toJson(this._oneofTermTypeValue);
        break;
      case 15:
        result.unitMoveCommandReceived = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 16:
        result.unitAttackCommandReceived = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 17:
        result.unitWeaponDamagePoint = ActorTerm_UnitWeaponTerm.toJson(this._oneofTermTypeValue);
        break;
      case 18:
        result.preAbilityTargetedOn = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 19:
        result.preAbilityTargetedOff = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 20:
        result.preAbilityCastTargeted = ActorTerm_UnitAbilityTerm.toJson(this._oneofTermTypeValue);
        break;
      case 21:
        result.selectionOn = ActorTerm_SelectionTerm.toJson(this._oneofTermTypeValue);
        break;
      case 22:
        result.selectionOff = ActorTerm_SelectionTerm.toJson(this._oneofTermTypeValue);
        break;
      case 31:
        result.behaviorOn = ActorTerm_BehaviorTerm.toJson(this._oneofTermTypeValue);
        break;
      case 32:
        result.behaviorOff = ActorTerm_BehaviorTerm.toJson(this._oneofTermTypeValue);
        break;
      case 41:
        result.persistentEffectOn = ActorTerm_EffectTerm.toJson(this._oneofTermTypeValue);
        break;
      case 42:
        result.persistentEffectOff = ActorTerm_EffectTerm.toJson(this._oneofTermTypeValue);
        break;
      case 51:
        result.actorCreate = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 52:
        result.actorDestroy = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 53:
        result.actorOrphan = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 61:
        result.animationFinish = ActorTerm_AnimationTerm.toJson(this._oneofTermTypeValue);
        break;
      case 71:
        result.onTimer = ActorTerm_TimerTerm.toJson(this._oneofTermTypeValue);
        break;
      case 81:
        result.onCustomEvent = ActorTerm_CustomEvent.toJson(this._oneofTermTypeValue);
        break;
      case 91:
        result.beamLostTarget = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      case 92:
        result.beamLostLaunch = ActorTerm_EmptyTerm.toJson(this._oneofTermTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTermTypeCase() {
    return this._oneofTermTypeCase;
  }
  deleteOneofTermType(path) {
    switch (this._oneofTermTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['unitSpawn'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['unitMorph'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['unitRemove'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['unitStand'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['unitWalk'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['unitDeath'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['unitWeaponStart'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['unitWeaponStop'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['unitAbilityStart'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['unitAbilityStop'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['unitAbilityTargetingOn'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['unitAbilityTargetingOff'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['unitChildrenSelectionOn'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['unitChildrenSelectionOff'])};
      }
      case 15: {
        return {type: 'DELETE', path: path.concat(['unitMoveCommandReceived'])};
      }
      case 16: {
        return {type: 'DELETE', path: path.concat(['unitAttackCommandReceived'])};
      }
      case 17: {
        return {type: 'DELETE', path: path.concat(['unitWeaponDamagePoint'])};
      }
      case 18: {
        return {type: 'DELETE', path: path.concat(['preAbilityTargetedOn'])};
      }
      case 19: {
        return {type: 'DELETE', path: path.concat(['preAbilityTargetedOff'])};
      }
      case 20: {
        return {type: 'DELETE', path: path.concat(['preAbilityCastTargeted'])};
      }
      case 21: {
        return {type: 'DELETE', path: path.concat(['selectionOn'])};
      }
      case 22: {
        return {type: 'DELETE', path: path.concat(['selectionOff'])};
      }
      case 31: {
        return {type: 'DELETE', path: path.concat(['behaviorOn'])};
      }
      case 32: {
        return {type: 'DELETE', path: path.concat(['behaviorOff'])};
      }
      case 41: {
        return {type: 'DELETE', path: path.concat(['persistentEffectOn'])};
      }
      case 42: {
        return {type: 'DELETE', path: path.concat(['persistentEffectOff'])};
      }
      case 51: {
        return {type: 'DELETE', path: path.concat(['actorCreate'])};
      }
      case 52: {
        return {type: 'DELETE', path: path.concat(['actorDestroy'])};
      }
      case 53: {
        return {type: 'DELETE', path: path.concat(['actorOrphan'])};
      }
      case 61: {
        return {type: 'DELETE', path: path.concat(['animationFinish'])};
      }
      case 71: {
        return {type: 'DELETE', path: path.concat(['onTimer'])};
      }
      case 81: {
        return {type: 'DELETE', path: path.concat(['onCustomEvent'])};
      }
      case 91: {
        return {type: 'DELETE', path: path.concat(['beamLostTarget'])};
      }
      case 92: {
        return {type: 'DELETE', path: path.concat(['beamLostLaunch'])};
      }
    }
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitSpawn() {
    return this._oneofTermTypeCase === 1 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitSpawn(path, value) {
    return {type: 'SET', path: path.concat(['unitSpawn']), value: value.toJson()};
  }
  deleteUnitSpawn(path) {
    return {type: 'DELETE', path: path.concat(['unitSpawn'])};
  }
  /**
   * @returns {ActorTerm_UnitTerm}
   */
  get unitMorph() {
    return this._oneofTermTypeCase === 2 ? this._oneofTermTypeValue : ActorTerm_UnitTerm.default;
  }
  setUnitMorph(path, value) {
    return {type: 'SET', path: path.concat(['unitMorph']), value: value.toJson()};
  }
  deleteUnitMorph(path) {
    return {type: 'DELETE', path: path.concat(['unitMorph'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitRemove() {
    return this._oneofTermTypeCase === 3 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitRemove(path, value) {
    return {type: 'SET', path: path.concat(['unitRemove']), value: value.toJson()};
  }
  deleteUnitRemove(path) {
    return {type: 'DELETE', path: path.concat(['unitRemove'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitStand() {
    return this._oneofTermTypeCase === 4 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitStand(path, value) {
    return {type: 'SET', path: path.concat(['unitStand']), value: value.toJson()};
  }
  deleteUnitStand(path) {
    return {type: 'DELETE', path: path.concat(['unitStand'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitWalk() {
    return this._oneofTermTypeCase === 5 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitWalk(path, value) {
    return {type: 'SET', path: path.concat(['unitWalk']), value: value.toJson()};
  }
  deleteUnitWalk(path) {
    return {type: 'DELETE', path: path.concat(['unitWalk'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitDeath() {
    return this._oneofTermTypeCase === 6 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitDeath(path, value) {
    return {type: 'SET', path: path.concat(['unitDeath']), value: value.toJson()};
  }
  deleteUnitDeath(path) {
    return {type: 'DELETE', path: path.concat(['unitDeath'])};
  }
  /**
   * @returns {ActorTerm_UnitWeaponTerm}
   */
  get unitWeaponStart() {
    return this._oneofTermTypeCase === 7 ? this._oneofTermTypeValue : ActorTerm_UnitWeaponTerm.default;
  }
  setUnitWeaponStart(path, value) {
    return {type: 'SET', path: path.concat(['unitWeaponStart']), value: value.toJson()};
  }
  deleteUnitWeaponStart(path) {
    return {type: 'DELETE', path: path.concat(['unitWeaponStart'])};
  }
  /**
   * @returns {ActorTerm_UnitWeaponTerm}
   */
  get unitWeaponStop() {
    return this._oneofTermTypeCase === 8 ? this._oneofTermTypeValue : ActorTerm_UnitWeaponTerm.default;
  }
  setUnitWeaponStop(path, value) {
    return {type: 'SET', path: path.concat(['unitWeaponStop']), value: value.toJson()};
  }
  deleteUnitWeaponStop(path) {
    return {type: 'DELETE', path: path.concat(['unitWeaponStop'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get unitAbilityStart() {
    return this._oneofTermTypeCase === 9 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setUnitAbilityStart(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityStart']), value: value.toJson()};
  }
  deleteUnitAbilityStart(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityStart'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get unitAbilityStop() {
    return this._oneofTermTypeCase === 10 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setUnitAbilityStop(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityStop']), value: value.toJson()};
  }
  deleteUnitAbilityStop(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityStop'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get unitAbilityTargetingOn() {
    return this._oneofTermTypeCase === 11 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setUnitAbilityTargetingOn(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityTargetingOn']), value: value.toJson()};
  }
  deleteUnitAbilityTargetingOn(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityTargetingOn'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get unitAbilityTargetingOff() {
    return this._oneofTermTypeCase === 12 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setUnitAbilityTargetingOff(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityTargetingOff']), value: value.toJson()};
  }
  deleteUnitAbilityTargetingOff(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityTargetingOff'])};
  }
  /**
   * @returns {ActorTerm_UnitTerm}
   */
  get unitChildrenSelectionOn() {
    return this._oneofTermTypeCase === 13 ? this._oneofTermTypeValue : ActorTerm_UnitTerm.default;
  }
  setUnitChildrenSelectionOn(path, value) {
    return {type: 'SET', path: path.concat(['unitChildrenSelectionOn']), value: value.toJson()};
  }
  deleteUnitChildrenSelectionOn(path) {
    return {type: 'DELETE', path: path.concat(['unitChildrenSelectionOn'])};
  }
  /**
   * @returns {ActorTerm_UnitTerm}
   */
  get unitChildrenSelectionOff() {
    return this._oneofTermTypeCase === 14 ? this._oneofTermTypeValue : ActorTerm_UnitTerm.default;
  }
  setUnitChildrenSelectionOff(path, value) {
    return {type: 'SET', path: path.concat(['unitChildrenSelectionOff']), value: value.toJson()};
  }
  deleteUnitChildrenSelectionOff(path) {
    return {type: 'DELETE', path: path.concat(['unitChildrenSelectionOff'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitMoveCommandReceived() {
    return this._oneofTermTypeCase === 15 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitMoveCommandReceived(path, value) {
    return {type: 'SET', path: path.concat(['unitMoveCommandReceived']), value: value.toJson()};
  }
  deleteUnitMoveCommandReceived(path) {
    return {type: 'DELETE', path: path.concat(['unitMoveCommandReceived'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get unitAttackCommandReceived() {
    return this._oneofTermTypeCase === 16 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setUnitAttackCommandReceived(path, value) {
    return {type: 'SET', path: path.concat(['unitAttackCommandReceived']), value: value.toJson()};
  }
  deleteUnitAttackCommandReceived(path) {
    return {type: 'DELETE', path: path.concat(['unitAttackCommandReceived'])};
  }
  /**
   * @returns {ActorTerm_UnitWeaponTerm}
   */
  get unitWeaponDamagePoint() {
    return this._oneofTermTypeCase === 17 ? this._oneofTermTypeValue : ActorTerm_UnitWeaponTerm.default;
  }
  setUnitWeaponDamagePoint(path, value) {
    return {type: 'SET', path: path.concat(['unitWeaponDamagePoint']), value: value.toJson()};
  }
  deleteUnitWeaponDamagePoint(path) {
    return {type: 'DELETE', path: path.concat(['unitWeaponDamagePoint'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get preAbilityTargetedOn() {
    return this._oneofTermTypeCase === 18 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setPreAbilityTargetedOn(path, value) {
    return {type: 'SET', path: path.concat(['preAbilityTargetedOn']), value: value.toJson()};
  }
  deletePreAbilityTargetedOn(path) {
    return {type: 'DELETE', path: path.concat(['preAbilityTargetedOn'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get preAbilityTargetedOff() {
    return this._oneofTermTypeCase === 19 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setPreAbilityTargetedOff(path, value) {
    return {type: 'SET', path: path.concat(['preAbilityTargetedOff']), value: value.toJson()};
  }
  deletePreAbilityTargetedOff(path) {
    return {type: 'DELETE', path: path.concat(['preAbilityTargetedOff'])};
  }
  /**
   * @returns {ActorTerm_UnitAbilityTerm}
   */
  get preAbilityCastTargeted() {
    return this._oneofTermTypeCase === 20 ? this._oneofTermTypeValue : ActorTerm_UnitAbilityTerm.default;
  }
  setPreAbilityCastTargeted(path, value) {
    return {type: 'SET', path: path.concat(['preAbilityCastTargeted']), value: value.toJson()};
  }
  deletePreAbilityCastTargeted(path) {
    return {type: 'DELETE', path: path.concat(['preAbilityCastTargeted'])};
  }
  /**
   * @returns {ActorTerm_SelectionTerm}
   */
  get selectionOn() {
    return this._oneofTermTypeCase === 21 ? this._oneofTermTypeValue : ActorTerm_SelectionTerm.default;
  }
  setSelectionOn(path, value) {
    return {type: 'SET', path: path.concat(['selectionOn']), value: value.toJson()};
  }
  deleteSelectionOn(path) {
    return {type: 'DELETE', path: path.concat(['selectionOn'])};
  }
  /**
   * @returns {ActorTerm_SelectionTerm}
   */
  get selectionOff() {
    return this._oneofTermTypeCase === 22 ? this._oneofTermTypeValue : ActorTerm_SelectionTerm.default;
  }
  setSelectionOff(path, value) {
    return {type: 'SET', path: path.concat(['selectionOff']), value: value.toJson()};
  }
  deleteSelectionOff(path) {
    return {type: 'DELETE', path: path.concat(['selectionOff'])};
  }
  /**
   * @returns {ActorTerm_BehaviorTerm}
   */
  get behaviorOn() {
    return this._oneofTermTypeCase === 31 ? this._oneofTermTypeValue : ActorTerm_BehaviorTerm.default;
  }
  setBehaviorOn(path, value) {
    return {type: 'SET', path: path.concat(['behaviorOn']), value: value.toJson()};
  }
  deleteBehaviorOn(path) {
    return {type: 'DELETE', path: path.concat(['behaviorOn'])};
  }
  /**
   * @returns {ActorTerm_BehaviorTerm}
   */
  get behaviorOff() {
    return this._oneofTermTypeCase === 32 ? this._oneofTermTypeValue : ActorTerm_BehaviorTerm.default;
  }
  setBehaviorOff(path, value) {
    return {type: 'SET', path: path.concat(['behaviorOff']), value: value.toJson()};
  }
  deleteBehaviorOff(path) {
    return {type: 'DELETE', path: path.concat(['behaviorOff'])};
  }
  /**
   * @returns {ActorTerm_EffectTerm}
   */
  get persistentEffectOn() {
    return this._oneofTermTypeCase === 41 ? this._oneofTermTypeValue : ActorTerm_EffectTerm.default;
  }
  setPersistentEffectOn(path, value) {
    return {type: 'SET', path: path.concat(['persistentEffectOn']), value: value.toJson()};
  }
  deletePersistentEffectOn(path) {
    return {type: 'DELETE', path: path.concat(['persistentEffectOn'])};
  }
  /**
   * @returns {ActorTerm_EffectTerm}
   */
  get persistentEffectOff() {
    return this._oneofTermTypeCase === 42 ? this._oneofTermTypeValue : ActorTerm_EffectTerm.default;
  }
  setPersistentEffectOff(path, value) {
    return {type: 'SET', path: path.concat(['persistentEffectOff']), value: value.toJson()};
  }
  deletePersistentEffectOff(path) {
    return {type: 'DELETE', path: path.concat(['persistentEffectOff'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get actorCreate() {
    return this._oneofTermTypeCase === 51 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setActorCreate(path, value) {
    return {type: 'SET', path: path.concat(['actorCreate']), value: value.toJson()};
  }
  deleteActorCreate(path) {
    return {type: 'DELETE', path: path.concat(['actorCreate'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get actorDestroy() {
    return this._oneofTermTypeCase === 52 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setActorDestroy(path, value) {
    return {type: 'SET', path: path.concat(['actorDestroy']), value: value.toJson()};
  }
  deleteActorDestroy(path) {
    return {type: 'DELETE', path: path.concat(['actorDestroy'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get actorOrphan() {
    return this._oneofTermTypeCase === 53 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setActorOrphan(path, value) {
    return {type: 'SET', path: path.concat(['actorOrphan']), value: value.toJson()};
  }
  deleteActorOrphan(path) {
    return {type: 'DELETE', path: path.concat(['actorOrphan'])};
  }
  /**
   * @returns {ActorTerm_AnimationTerm}
   */
  get animationFinish() {
    return this._oneofTermTypeCase === 61 ? this._oneofTermTypeValue : ActorTerm_AnimationTerm.default;
  }
  setAnimationFinish(path, value) {
    return {type: 'SET', path: path.concat(['animationFinish']), value: value.toJson()};
  }
  deleteAnimationFinish(path) {
    return {type: 'DELETE', path: path.concat(['animationFinish'])};
  }
  /**
   * @returns {ActorTerm_TimerTerm}
   */
  get onTimer() {
    return this._oneofTermTypeCase === 71 ? this._oneofTermTypeValue : ActorTerm_TimerTerm.default;
  }
  setOnTimer(path, value) {
    return {type: 'SET', path: path.concat(['onTimer']), value: value.toJson()};
  }
  deleteOnTimer(path) {
    return {type: 'DELETE', path: path.concat(['onTimer'])};
  }
  /**
   * @returns {ActorTerm_CustomEvent}
   */
  get onCustomEvent() {
    return this._oneofTermTypeCase === 81 ? this._oneofTermTypeValue : ActorTerm_CustomEvent.default;
  }
  setOnCustomEvent(path, value) {
    return {type: 'SET', path: path.concat(['onCustomEvent']), value: value.toJson()};
  }
  deleteOnCustomEvent(path) {
    return {type: 'DELETE', path: path.concat(['onCustomEvent'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get beamLostTarget() {
    return this._oneofTermTypeCase === 91 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setBeamLostTarget(path, value) {
    return {type: 'SET', path: path.concat(['beamLostTarget']), value: value.toJson()};
  }
  deleteBeamLostTarget(path) {
    return {type: 'DELETE', path: path.concat(['beamLostTarget'])};
  }
  /**
   * @returns {ActorTerm_EmptyTerm}
   */
  get beamLostLaunch() {
    return this._oneofTermTypeCase === 92 ? this._oneofTermTypeValue : ActorTerm_EmptyTerm.default;
  }
  setBeamLostLaunch(path, value) {
    return {type: 'SET', path: path.concat(['beamLostLaunch']), value: value.toJson()};
  }
  deleteBeamLostLaunch(path) {
    return {type: 'DELETE', path: path.concat(['beamLostLaunch'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitSpawn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 1;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 1) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 1) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 1;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitSpawn.apply(type, path.slice(1), value);
          if (newValue === this.unitSpawn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 1;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitMorph": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 2;
              copy._oneofTermTypeValue = ActorTerm_UnitTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 2) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 2) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 2;
            copy._oneofTermTypeValue = ActorTerm_UnitTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitMorph.apply(type, path.slice(1), value);
          if (newValue === this.unitMorph) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 2;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitRemove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 3;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 3) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 3) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 3;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitRemove.apply(type, path.slice(1), value);
          if (newValue === this.unitRemove) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 3;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitStand": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 4;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 4) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 4) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 4;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitStand.apply(type, path.slice(1), value);
          if (newValue === this.unitStand) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 4;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitWalk": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 5;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 5) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 5) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 5;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWalk.apply(type, path.slice(1), value);
          if (newValue === this.unitWalk) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 5;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitDeath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 6;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 6) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 6) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 6;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitDeath.apply(type, path.slice(1), value);
          if (newValue === this.unitDeath) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 6;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitWeaponStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 7;
              copy._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 7) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 7) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 7;
            copy._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWeaponStart.apply(type, path.slice(1), value);
          if (newValue === this.unitWeaponStart) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 7;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitWeaponStop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 8;
              copy._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 8) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 8) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 8;
            copy._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWeaponStop.apply(type, path.slice(1), value);
          if (newValue === this.unitWeaponStop) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 8;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityStart": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 9;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 9) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 9) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 9;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityStart.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityStart) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 9;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityStop": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 10;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 10) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 10) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 10;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityStop.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityStop) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 10;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityTargetingOn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 11;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 11) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 11) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 11;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityTargetingOn.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityTargetingOn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 11;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityTargetingOff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 12;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 12) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 12) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 12;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityTargetingOff.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityTargetingOff) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 12;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitChildrenSelectionOn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 13;
              copy._oneofTermTypeValue = ActorTerm_UnitTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 13) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 13) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 13;
            copy._oneofTermTypeValue = ActorTerm_UnitTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitChildrenSelectionOn.apply(type, path.slice(1), value);
          if (newValue === this.unitChildrenSelectionOn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 13;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitChildrenSelectionOff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 14;
              copy._oneofTermTypeValue = ActorTerm_UnitTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 14) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 14) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 14;
            copy._oneofTermTypeValue = ActorTerm_UnitTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitChildrenSelectionOff.apply(type, path.slice(1), value);
          if (newValue === this.unitChildrenSelectionOff) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 14;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitMoveCommandReceived": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 15;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 15) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 15) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 15;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitMoveCommandReceived.apply(type, path.slice(1), value);
          if (newValue === this.unitMoveCommandReceived) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 15;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitAttackCommandReceived": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 16;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 16) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 16) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 16;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAttackCommandReceived.apply(type, path.slice(1), value);
          if (newValue === this.unitAttackCommandReceived) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 16;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "unitWeaponDamagePoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 17;
              copy._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 17) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 17) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 17;
            copy._oneofTermTypeValue = ActorTerm_UnitWeaponTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitWeaponDamagePoint.apply(type, path.slice(1), value);
          if (newValue === this.unitWeaponDamagePoint) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 17;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "preAbilityTargetedOn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 18;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 18) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 18) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 18;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.preAbilityTargetedOn.apply(type, path.slice(1), value);
          if (newValue === this.preAbilityTargetedOn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 18;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "preAbilityTargetedOff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 19;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 19) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 19) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 19;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.preAbilityTargetedOff.apply(type, path.slice(1), value);
          if (newValue === this.preAbilityTargetedOff) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 19;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "preAbilityCastTargeted": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 20;
              copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 20) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 20) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 20;
            copy._oneofTermTypeValue = ActorTerm_UnitAbilityTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.preAbilityCastTargeted.apply(type, path.slice(1), value);
          if (newValue === this.preAbilityCastTargeted) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 20;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "selectionOn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 21;
              copy._oneofTermTypeValue = ActorTerm_SelectionTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 21) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 21) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 21;
            copy._oneofTermTypeValue = ActorTerm_SelectionTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.selectionOn.apply(type, path.slice(1), value);
          if (newValue === this.selectionOn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 21;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "selectionOff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 22;
              copy._oneofTermTypeValue = ActorTerm_SelectionTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 22) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 22) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 22;
            copy._oneofTermTypeValue = ActorTerm_SelectionTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.selectionOff.apply(type, path.slice(1), value);
          if (newValue === this.selectionOff) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 22;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "behaviorOn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 31;
              copy._oneofTermTypeValue = ActorTerm_BehaviorTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 31) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 31) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 31;
            copy._oneofTermTypeValue = ActorTerm_BehaviorTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.behaviorOn.apply(type, path.slice(1), value);
          if (newValue === this.behaviorOn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 31;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "behaviorOff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 32;
              copy._oneofTermTypeValue = ActorTerm_BehaviorTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 32) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 32) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 32;
            copy._oneofTermTypeValue = ActorTerm_BehaviorTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.behaviorOff.apply(type, path.slice(1), value);
          if (newValue === this.behaviorOff) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 32;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "persistentEffectOn": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 41;
              copy._oneofTermTypeValue = ActorTerm_EffectTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 41) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 41) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 41;
            copy._oneofTermTypeValue = ActorTerm_EffectTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.persistentEffectOn.apply(type, path.slice(1), value);
          if (newValue === this.persistentEffectOn) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 41;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "persistentEffectOff": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 42;
              copy._oneofTermTypeValue = ActorTerm_EffectTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 42) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 42) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 42;
            copy._oneofTermTypeValue = ActorTerm_EffectTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.persistentEffectOff.apply(type, path.slice(1), value);
          if (newValue === this.persistentEffectOff) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 42;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "actorCreate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 51;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 51) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 51) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 51;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.actorCreate.apply(type, path.slice(1), value);
          if (newValue === this.actorCreate) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 51;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "actorDestroy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 52;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 52) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 52) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 52;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.actorDestroy.apply(type, path.slice(1), value);
          if (newValue === this.actorDestroy) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 52;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "actorOrphan": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 53;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 53) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 53) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 53;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.actorOrphan.apply(type, path.slice(1), value);
          if (newValue === this.actorOrphan) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 53;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "animationFinish": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 61;
              copy._oneofTermTypeValue = ActorTerm_AnimationTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 61) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 61) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 61;
            copy._oneofTermTypeValue = ActorTerm_AnimationTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.animationFinish.apply(type, path.slice(1), value);
          if (newValue === this.animationFinish) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 61;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "onTimer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 71;
              copy._oneofTermTypeValue = ActorTerm_TimerTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 71) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 71) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 71;
            copy._oneofTermTypeValue = ActorTerm_TimerTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.onTimer.apply(type, path.slice(1), value);
          if (newValue === this.onTimer) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 71;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "onCustomEvent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 81;
              copy._oneofTermTypeValue = ActorTerm_CustomEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 81) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 81) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 81;
            copy._oneofTermTypeValue = ActorTerm_CustomEvent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.onCustomEvent.apply(type, path.slice(1), value);
          if (newValue === this.onCustomEvent) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 81;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "beamLostTarget": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 91;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 91) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 91) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 91;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.beamLostTarget.apply(type, path.slice(1), value);
          if (newValue === this.beamLostTarget) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 91;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      case "beamLostLaunch": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 92;
              copy._oneofTermTypeValue = ActorTerm_EmptyTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTermTypeCase !== 92) {
                return this;
              }
              const copy = new ActorTerm(this);
              copy._oneofTermTypeCase = 0;
              copy._oneofTermTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTermTypeCase !== 92) {
            const copy = new ActorTerm(this);
            copy._oneofTermTypeCase = 92;
            copy._oneofTermTypeValue = ActorTerm_EmptyTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.beamLostLaunch.apply(type, path.slice(1), value);
          if (newValue === this.beamLostLaunch) {
            return this;
          }
          const copy = new ActorTerm(this);
          copy._oneofTermTypeCase = 92;
          copy._oneofTermTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorTerm} other
   * @returns {ActorTerm}
   */
  merge(other) {
    const copy = new ActorTerm(this);
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    if (other._oneofTermTypeCase === 1) {
      if (this._oneofTermTypeCase === 1) {
        copy._oneofTermTypeValue = copy._oneofTermTypeValue.merge(other._oneofTermTypeValue);
      } else {
        copy._oneofTermTypeValue = other._oneofTermTypeValue;
      }
      copy._oneofTermTypeCase = 1;
    }
    return copy;
  }
}
ActorTerm.default = new ActorTerm();
ActorTerm.EmptyTerm = ActorTerm_EmptyTerm;
ActorTerm.UnitTerm = ActorTerm_UnitTerm;
ActorTerm.UnitWeaponTerm = ActorTerm_UnitWeaponTerm;
ActorTerm.UnitAbilityTerm = ActorTerm_UnitAbilityTerm;
ActorTerm.SelectionTerm = ActorTerm_SelectionTerm;
ActorTerm.BehaviorTerm = ActorTerm_BehaviorTerm;
ActorTerm.EffectTerm = ActorTerm_EffectTerm;
ActorTerm.AnimationTerm = ActorTerm_AnimationTerm;
ActorTerm.TimerTerm = ActorTerm_TimerTerm;
ActorTerm.CustomEvent = ActorTerm_CustomEvent;
class ActorTerm_Builder {
  constructor(value) {
    this._value = new ActorTerm(value);
  }
  build() {
    return new ActorTerm(this._value);
  }
  clearoneofTermType() {
    this._value._oneofTermTypeCase = 0;
    this._value._oneofTermTypeValue = null;
    return this;
  }
  setUnitSpawn(value) {
    this._value._oneofTermTypeCase = 1;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitMorph(value) {
    this._value._oneofTermTypeCase = 2;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitRemove(value) {
    this._value._oneofTermTypeCase = 3;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitStand(value) {
    this._value._oneofTermTypeCase = 4;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitWalk(value) {
    this._value._oneofTermTypeCase = 5;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitDeath(value) {
    this._value._oneofTermTypeCase = 6;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitWeaponStart(value) {
    this._value._oneofTermTypeCase = 7;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitWeaponStop(value) {
    this._value._oneofTermTypeCase = 8;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitAbilityStart(value) {
    this._value._oneofTermTypeCase = 9;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitAbilityStop(value) {
    this._value._oneofTermTypeCase = 10;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitAbilityTargetingOn(value) {
    this._value._oneofTermTypeCase = 11;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitAbilityTargetingOff(value) {
    this._value._oneofTermTypeCase = 12;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitChildrenSelectionOn(value) {
    this._value._oneofTermTypeCase = 13;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitChildrenSelectionOff(value) {
    this._value._oneofTermTypeCase = 14;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitMoveCommandReceived(value) {
    this._value._oneofTermTypeCase = 15;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitAttackCommandReceived(value) {
    this._value._oneofTermTypeCase = 16;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setUnitWeaponDamagePoint(value) {
    this._value._oneofTermTypeCase = 17;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setPreAbilityTargetedOn(value) {
    this._value._oneofTermTypeCase = 18;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setPreAbilityTargetedOff(value) {
    this._value._oneofTermTypeCase = 19;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setPreAbilityCastTargeted(value) {
    this._value._oneofTermTypeCase = 20;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setSelectionOn(value) {
    this._value._oneofTermTypeCase = 21;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setSelectionOff(value) {
    this._value._oneofTermTypeCase = 22;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setBehaviorOn(value) {
    this._value._oneofTermTypeCase = 31;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setBehaviorOff(value) {
    this._value._oneofTermTypeCase = 32;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setPersistentEffectOn(value) {
    this._value._oneofTermTypeCase = 41;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setPersistentEffectOff(value) {
    this._value._oneofTermTypeCase = 42;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setActorCreate(value) {
    this._value._oneofTermTypeCase = 51;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setActorDestroy(value) {
    this._value._oneofTermTypeCase = 52;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setActorOrphan(value) {
    this._value._oneofTermTypeCase = 53;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setAnimationFinish(value) {
    this._value._oneofTermTypeCase = 61;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setOnTimer(value) {
    this._value._oneofTermTypeCase = 71;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setOnCustomEvent(value) {
    this._value._oneofTermTypeCase = 81;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setBeamLostTarget(value) {
    this._value._oneofTermTypeCase = 91;
    this._value._oneofTermTypeValue = value;
    return this;
  }
  setBeamLostLaunch(value) {
    this._value._oneofTermTypeCase = 92;
    this._value._oneofTermTypeValue = value;
    return this;
  }
}
ActorTerm.Builder = ActorTerm_Builder;
class ActorTerm_WithParent {
  /**
   * @param {ActorTerm} value
   * @param {ActorTerm_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorTerm.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTermTypeCase() {
    if (this._cachedoneofTermTypeCase === undefined) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedoneofTermTypeCase = this._parent ? this._parent.oneofTermTypeCase : 0;
      } else {
        this._cachedoneofTermTypeCase = this._value._oneofTermTypeCase;
      }
    }
    return this._cachedoneofTermTypeCase;
  }
  get unitSpawn() {
    if (!this._cachedUnitSpawn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitSpawn = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitSpawn) : this._value.unitSpawn;
      } else if (this._value._oneofTermTypeCase === 1) {
        this._cachedUnitSpawn = new ActorTerm_EmptyTerm.WithParent(this._value.unitSpawn, this._parent && this._parent.oneofTermTypeCase === 1 ? this._parent.unitSpawn : null);
      } else {
        this._cachedUnitSpawn = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitSpawn;
  }
  get unitMorph() {
    if (!this._cachedUnitMorph) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitMorph = this._parent ? new ActorTerm_UnitTerm.WithParent(ActorTerm_UnitTerm.default, this._parent.unitMorph) : this._value.unitMorph;
      } else if (this._value._oneofTermTypeCase === 2) {
        this._cachedUnitMorph = new ActorTerm_UnitTerm.WithParent(this._value.unitMorph, this._parent && this._parent.oneofTermTypeCase === 2 ? this._parent.unitMorph : null);
      } else {
        this._cachedUnitMorph = ActorTerm_UnitTerm.WithParent.default;
      }
    }
    return this._cachedUnitMorph;
  }
  get unitRemove() {
    if (!this._cachedUnitRemove) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitRemove = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitRemove) : this._value.unitRemove;
      } else if (this._value._oneofTermTypeCase === 3) {
        this._cachedUnitRemove = new ActorTerm_EmptyTerm.WithParent(this._value.unitRemove, this._parent && this._parent.oneofTermTypeCase === 3 ? this._parent.unitRemove : null);
      } else {
        this._cachedUnitRemove = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitRemove;
  }
  get unitStand() {
    if (!this._cachedUnitStand) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitStand = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitStand) : this._value.unitStand;
      } else if (this._value._oneofTermTypeCase === 4) {
        this._cachedUnitStand = new ActorTerm_EmptyTerm.WithParent(this._value.unitStand, this._parent && this._parent.oneofTermTypeCase === 4 ? this._parent.unitStand : null);
      } else {
        this._cachedUnitStand = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitStand;
  }
  get unitWalk() {
    if (!this._cachedUnitWalk) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitWalk = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitWalk) : this._value.unitWalk;
      } else if (this._value._oneofTermTypeCase === 5) {
        this._cachedUnitWalk = new ActorTerm_EmptyTerm.WithParent(this._value.unitWalk, this._parent && this._parent.oneofTermTypeCase === 5 ? this._parent.unitWalk : null);
      } else {
        this._cachedUnitWalk = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitWalk;
  }
  get unitDeath() {
    if (!this._cachedUnitDeath) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitDeath = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitDeath) : this._value.unitDeath;
      } else if (this._value._oneofTermTypeCase === 6) {
        this._cachedUnitDeath = new ActorTerm_EmptyTerm.WithParent(this._value.unitDeath, this._parent && this._parent.oneofTermTypeCase === 6 ? this._parent.unitDeath : null);
      } else {
        this._cachedUnitDeath = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitDeath;
  }
  get unitWeaponStart() {
    if (!this._cachedUnitWeaponStart) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitWeaponStart = this._parent ? new ActorTerm_UnitWeaponTerm.WithParent(ActorTerm_UnitWeaponTerm.default, this._parent.unitWeaponStart) : this._value.unitWeaponStart;
      } else if (this._value._oneofTermTypeCase === 7) {
        this._cachedUnitWeaponStart = new ActorTerm_UnitWeaponTerm.WithParent(this._value.unitWeaponStart, this._parent && this._parent.oneofTermTypeCase === 7 ? this._parent.unitWeaponStart : null);
      } else {
        this._cachedUnitWeaponStart = ActorTerm_UnitWeaponTerm.WithParent.default;
      }
    }
    return this._cachedUnitWeaponStart;
  }
  get unitWeaponStop() {
    if (!this._cachedUnitWeaponStop) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitWeaponStop = this._parent ? new ActorTerm_UnitWeaponTerm.WithParent(ActorTerm_UnitWeaponTerm.default, this._parent.unitWeaponStop) : this._value.unitWeaponStop;
      } else if (this._value._oneofTermTypeCase === 8) {
        this._cachedUnitWeaponStop = new ActorTerm_UnitWeaponTerm.WithParent(this._value.unitWeaponStop, this._parent && this._parent.oneofTermTypeCase === 8 ? this._parent.unitWeaponStop : null);
      } else {
        this._cachedUnitWeaponStop = ActorTerm_UnitWeaponTerm.WithParent.default;
      }
    }
    return this._cachedUnitWeaponStop;
  }
  get unitAbilityStart() {
    if (!this._cachedUnitAbilityStart) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitAbilityStart = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.unitAbilityStart) : this._value.unitAbilityStart;
      } else if (this._value._oneofTermTypeCase === 9) {
        this._cachedUnitAbilityStart = new ActorTerm_UnitAbilityTerm.WithParent(this._value.unitAbilityStart, this._parent && this._parent.oneofTermTypeCase === 9 ? this._parent.unitAbilityStart : null);
      } else {
        this._cachedUnitAbilityStart = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedUnitAbilityStart;
  }
  get unitAbilityStop() {
    if (!this._cachedUnitAbilityStop) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitAbilityStop = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.unitAbilityStop) : this._value.unitAbilityStop;
      } else if (this._value._oneofTermTypeCase === 10) {
        this._cachedUnitAbilityStop = new ActorTerm_UnitAbilityTerm.WithParent(this._value.unitAbilityStop, this._parent && this._parent.oneofTermTypeCase === 10 ? this._parent.unitAbilityStop : null);
      } else {
        this._cachedUnitAbilityStop = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedUnitAbilityStop;
  }
  get unitAbilityTargetingOn() {
    if (!this._cachedUnitAbilityTargetingOn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitAbilityTargetingOn = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.unitAbilityTargetingOn) : this._value.unitAbilityTargetingOn;
      } else if (this._value._oneofTermTypeCase === 11) {
        this._cachedUnitAbilityTargetingOn = new ActorTerm_UnitAbilityTerm.WithParent(this._value.unitAbilityTargetingOn, this._parent && this._parent.oneofTermTypeCase === 11 ? this._parent.unitAbilityTargetingOn : null);
      } else {
        this._cachedUnitAbilityTargetingOn = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedUnitAbilityTargetingOn;
  }
  get unitAbilityTargetingOff() {
    if (!this._cachedUnitAbilityTargetingOff) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitAbilityTargetingOff = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.unitAbilityTargetingOff) : this._value.unitAbilityTargetingOff;
      } else if (this._value._oneofTermTypeCase === 12) {
        this._cachedUnitAbilityTargetingOff = new ActorTerm_UnitAbilityTerm.WithParent(this._value.unitAbilityTargetingOff, this._parent && this._parent.oneofTermTypeCase === 12 ? this._parent.unitAbilityTargetingOff : null);
      } else {
        this._cachedUnitAbilityTargetingOff = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedUnitAbilityTargetingOff;
  }
  get unitChildrenSelectionOn() {
    if (!this._cachedUnitChildrenSelectionOn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitChildrenSelectionOn = this._parent ? new ActorTerm_UnitTerm.WithParent(ActorTerm_UnitTerm.default, this._parent.unitChildrenSelectionOn) : this._value.unitChildrenSelectionOn;
      } else if (this._value._oneofTermTypeCase === 13) {
        this._cachedUnitChildrenSelectionOn = new ActorTerm_UnitTerm.WithParent(this._value.unitChildrenSelectionOn, this._parent && this._parent.oneofTermTypeCase === 13 ? this._parent.unitChildrenSelectionOn : null);
      } else {
        this._cachedUnitChildrenSelectionOn = ActorTerm_UnitTerm.WithParent.default;
      }
    }
    return this._cachedUnitChildrenSelectionOn;
  }
  get unitChildrenSelectionOff() {
    if (!this._cachedUnitChildrenSelectionOff) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitChildrenSelectionOff = this._parent ? new ActorTerm_UnitTerm.WithParent(ActorTerm_UnitTerm.default, this._parent.unitChildrenSelectionOff) : this._value.unitChildrenSelectionOff;
      } else if (this._value._oneofTermTypeCase === 14) {
        this._cachedUnitChildrenSelectionOff = new ActorTerm_UnitTerm.WithParent(this._value.unitChildrenSelectionOff, this._parent && this._parent.oneofTermTypeCase === 14 ? this._parent.unitChildrenSelectionOff : null);
      } else {
        this._cachedUnitChildrenSelectionOff = ActorTerm_UnitTerm.WithParent.default;
      }
    }
    return this._cachedUnitChildrenSelectionOff;
  }
  get unitMoveCommandReceived() {
    if (!this._cachedUnitMoveCommandReceived) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitMoveCommandReceived = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitMoveCommandReceived) : this._value.unitMoveCommandReceived;
      } else if (this._value._oneofTermTypeCase === 15) {
        this._cachedUnitMoveCommandReceived = new ActorTerm_EmptyTerm.WithParent(this._value.unitMoveCommandReceived, this._parent && this._parent.oneofTermTypeCase === 15 ? this._parent.unitMoveCommandReceived : null);
      } else {
        this._cachedUnitMoveCommandReceived = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitMoveCommandReceived;
  }
  get unitAttackCommandReceived() {
    if (!this._cachedUnitAttackCommandReceived) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitAttackCommandReceived = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.unitAttackCommandReceived) : this._value.unitAttackCommandReceived;
      } else if (this._value._oneofTermTypeCase === 16) {
        this._cachedUnitAttackCommandReceived = new ActorTerm_EmptyTerm.WithParent(this._value.unitAttackCommandReceived, this._parent && this._parent.oneofTermTypeCase === 16 ? this._parent.unitAttackCommandReceived : null);
      } else {
        this._cachedUnitAttackCommandReceived = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedUnitAttackCommandReceived;
  }
  get unitWeaponDamagePoint() {
    if (!this._cachedUnitWeaponDamagePoint) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedUnitWeaponDamagePoint = this._parent ? new ActorTerm_UnitWeaponTerm.WithParent(ActorTerm_UnitWeaponTerm.default, this._parent.unitWeaponDamagePoint) : this._value.unitWeaponDamagePoint;
      } else if (this._value._oneofTermTypeCase === 17) {
        this._cachedUnitWeaponDamagePoint = new ActorTerm_UnitWeaponTerm.WithParent(this._value.unitWeaponDamagePoint, this._parent && this._parent.oneofTermTypeCase === 17 ? this._parent.unitWeaponDamagePoint : null);
      } else {
        this._cachedUnitWeaponDamagePoint = ActorTerm_UnitWeaponTerm.WithParent.default;
      }
    }
    return this._cachedUnitWeaponDamagePoint;
  }
  get preAbilityTargetedOn() {
    if (!this._cachedPreAbilityTargetedOn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedPreAbilityTargetedOn = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.preAbilityTargetedOn) : this._value.preAbilityTargetedOn;
      } else if (this._value._oneofTermTypeCase === 18) {
        this._cachedPreAbilityTargetedOn = new ActorTerm_UnitAbilityTerm.WithParent(this._value.preAbilityTargetedOn, this._parent && this._parent.oneofTermTypeCase === 18 ? this._parent.preAbilityTargetedOn : null);
      } else {
        this._cachedPreAbilityTargetedOn = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedPreAbilityTargetedOn;
  }
  get preAbilityTargetedOff() {
    if (!this._cachedPreAbilityTargetedOff) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedPreAbilityTargetedOff = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.preAbilityTargetedOff) : this._value.preAbilityTargetedOff;
      } else if (this._value._oneofTermTypeCase === 19) {
        this._cachedPreAbilityTargetedOff = new ActorTerm_UnitAbilityTerm.WithParent(this._value.preAbilityTargetedOff, this._parent && this._parent.oneofTermTypeCase === 19 ? this._parent.preAbilityTargetedOff : null);
      } else {
        this._cachedPreAbilityTargetedOff = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedPreAbilityTargetedOff;
  }
  get preAbilityCastTargeted() {
    if (!this._cachedPreAbilityCastTargeted) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedPreAbilityCastTargeted = this._parent ? new ActorTerm_UnitAbilityTerm.WithParent(ActorTerm_UnitAbilityTerm.default, this._parent.preAbilityCastTargeted) : this._value.preAbilityCastTargeted;
      } else if (this._value._oneofTermTypeCase === 20) {
        this._cachedPreAbilityCastTargeted = new ActorTerm_UnitAbilityTerm.WithParent(this._value.preAbilityCastTargeted, this._parent && this._parent.oneofTermTypeCase === 20 ? this._parent.preAbilityCastTargeted : null);
      } else {
        this._cachedPreAbilityCastTargeted = ActorTerm_UnitAbilityTerm.WithParent.default;
      }
    }
    return this._cachedPreAbilityCastTargeted;
  }
  get selectionOn() {
    if (!this._cachedSelectionOn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedSelectionOn = this._parent ? new ActorTerm_SelectionTerm.WithParent(ActorTerm_SelectionTerm.default, this._parent.selectionOn) : this._value.selectionOn;
      } else if (this._value._oneofTermTypeCase === 21) {
        this._cachedSelectionOn = new ActorTerm_SelectionTerm.WithParent(this._value.selectionOn, this._parent && this._parent.oneofTermTypeCase === 21 ? this._parent.selectionOn : null);
      } else {
        this._cachedSelectionOn = ActorTerm_SelectionTerm.WithParent.default;
      }
    }
    return this._cachedSelectionOn;
  }
  get selectionOff() {
    if (!this._cachedSelectionOff) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedSelectionOff = this._parent ? new ActorTerm_SelectionTerm.WithParent(ActorTerm_SelectionTerm.default, this._parent.selectionOff) : this._value.selectionOff;
      } else if (this._value._oneofTermTypeCase === 22) {
        this._cachedSelectionOff = new ActorTerm_SelectionTerm.WithParent(this._value.selectionOff, this._parent && this._parent.oneofTermTypeCase === 22 ? this._parent.selectionOff : null);
      } else {
        this._cachedSelectionOff = ActorTerm_SelectionTerm.WithParent.default;
      }
    }
    return this._cachedSelectionOff;
  }
  get behaviorOn() {
    if (!this._cachedBehaviorOn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedBehaviorOn = this._parent ? new ActorTerm_BehaviorTerm.WithParent(ActorTerm_BehaviorTerm.default, this._parent.behaviorOn) : this._value.behaviorOn;
      } else if (this._value._oneofTermTypeCase === 31) {
        this._cachedBehaviorOn = new ActorTerm_BehaviorTerm.WithParent(this._value.behaviorOn, this._parent && this._parent.oneofTermTypeCase === 31 ? this._parent.behaviorOn : null);
      } else {
        this._cachedBehaviorOn = ActorTerm_BehaviorTerm.WithParent.default;
      }
    }
    return this._cachedBehaviorOn;
  }
  get behaviorOff() {
    if (!this._cachedBehaviorOff) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedBehaviorOff = this._parent ? new ActorTerm_BehaviorTerm.WithParent(ActorTerm_BehaviorTerm.default, this._parent.behaviorOff) : this._value.behaviorOff;
      } else if (this._value._oneofTermTypeCase === 32) {
        this._cachedBehaviorOff = new ActorTerm_BehaviorTerm.WithParent(this._value.behaviorOff, this._parent && this._parent.oneofTermTypeCase === 32 ? this._parent.behaviorOff : null);
      } else {
        this._cachedBehaviorOff = ActorTerm_BehaviorTerm.WithParent.default;
      }
    }
    return this._cachedBehaviorOff;
  }
  get persistentEffectOn() {
    if (!this._cachedPersistentEffectOn) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedPersistentEffectOn = this._parent ? new ActorTerm_EffectTerm.WithParent(ActorTerm_EffectTerm.default, this._parent.persistentEffectOn) : this._value.persistentEffectOn;
      } else if (this._value._oneofTermTypeCase === 41) {
        this._cachedPersistentEffectOn = new ActorTerm_EffectTerm.WithParent(this._value.persistentEffectOn, this._parent && this._parent.oneofTermTypeCase === 41 ? this._parent.persistentEffectOn : null);
      } else {
        this._cachedPersistentEffectOn = ActorTerm_EffectTerm.WithParent.default;
      }
    }
    return this._cachedPersistentEffectOn;
  }
  get persistentEffectOff() {
    if (!this._cachedPersistentEffectOff) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedPersistentEffectOff = this._parent ? new ActorTerm_EffectTerm.WithParent(ActorTerm_EffectTerm.default, this._parent.persistentEffectOff) : this._value.persistentEffectOff;
      } else if (this._value._oneofTermTypeCase === 42) {
        this._cachedPersistentEffectOff = new ActorTerm_EffectTerm.WithParent(this._value.persistentEffectOff, this._parent && this._parent.oneofTermTypeCase === 42 ? this._parent.persistentEffectOff : null);
      } else {
        this._cachedPersistentEffectOff = ActorTerm_EffectTerm.WithParent.default;
      }
    }
    return this._cachedPersistentEffectOff;
  }
  get actorCreate() {
    if (!this._cachedActorCreate) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedActorCreate = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.actorCreate) : this._value.actorCreate;
      } else if (this._value._oneofTermTypeCase === 51) {
        this._cachedActorCreate = new ActorTerm_EmptyTerm.WithParent(this._value.actorCreate, this._parent && this._parent.oneofTermTypeCase === 51 ? this._parent.actorCreate : null);
      } else {
        this._cachedActorCreate = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedActorCreate;
  }
  get actorDestroy() {
    if (!this._cachedActorDestroy) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedActorDestroy = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.actorDestroy) : this._value.actorDestroy;
      } else if (this._value._oneofTermTypeCase === 52) {
        this._cachedActorDestroy = new ActorTerm_EmptyTerm.WithParent(this._value.actorDestroy, this._parent && this._parent.oneofTermTypeCase === 52 ? this._parent.actorDestroy : null);
      } else {
        this._cachedActorDestroy = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedActorDestroy;
  }
  get actorOrphan() {
    if (!this._cachedActorOrphan) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedActorOrphan = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.actorOrphan) : this._value.actorOrphan;
      } else if (this._value._oneofTermTypeCase === 53) {
        this._cachedActorOrphan = new ActorTerm_EmptyTerm.WithParent(this._value.actorOrphan, this._parent && this._parent.oneofTermTypeCase === 53 ? this._parent.actorOrphan : null);
      } else {
        this._cachedActorOrphan = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedActorOrphan;
  }
  get animationFinish() {
    if (!this._cachedAnimationFinish) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedAnimationFinish = this._parent ? new ActorTerm_AnimationTerm.WithParent(ActorTerm_AnimationTerm.default, this._parent.animationFinish) : this._value.animationFinish;
      } else if (this._value._oneofTermTypeCase === 61) {
        this._cachedAnimationFinish = new ActorTerm_AnimationTerm.WithParent(this._value.animationFinish, this._parent && this._parent.oneofTermTypeCase === 61 ? this._parent.animationFinish : null);
      } else {
        this._cachedAnimationFinish = ActorTerm_AnimationTerm.WithParent.default;
      }
    }
    return this._cachedAnimationFinish;
  }
  get onTimer() {
    if (!this._cachedOnTimer) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedOnTimer = this._parent ? new ActorTerm_TimerTerm.WithParent(ActorTerm_TimerTerm.default, this._parent.onTimer) : this._value.onTimer;
      } else if (this._value._oneofTermTypeCase === 71) {
        this._cachedOnTimer = new ActorTerm_TimerTerm.WithParent(this._value.onTimer, this._parent && this._parent.oneofTermTypeCase === 71 ? this._parent.onTimer : null);
      } else {
        this._cachedOnTimer = ActorTerm_TimerTerm.WithParent.default;
      }
    }
    return this._cachedOnTimer;
  }
  get onCustomEvent() {
    if (!this._cachedOnCustomEvent) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedOnCustomEvent = this._parent ? new ActorTerm_CustomEvent.WithParent(ActorTerm_CustomEvent.default, this._parent.onCustomEvent) : this._value.onCustomEvent;
      } else if (this._value._oneofTermTypeCase === 81) {
        this._cachedOnCustomEvent = new ActorTerm_CustomEvent.WithParent(this._value.onCustomEvent, this._parent && this._parent.oneofTermTypeCase === 81 ? this._parent.onCustomEvent : null);
      } else {
        this._cachedOnCustomEvent = ActorTerm_CustomEvent.WithParent.default;
      }
    }
    return this._cachedOnCustomEvent;
  }
  get beamLostTarget() {
    if (!this._cachedBeamLostTarget) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedBeamLostTarget = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.beamLostTarget) : this._value.beamLostTarget;
      } else if (this._value._oneofTermTypeCase === 91) {
        this._cachedBeamLostTarget = new ActorTerm_EmptyTerm.WithParent(this._value.beamLostTarget, this._parent && this._parent.oneofTermTypeCase === 91 ? this._parent.beamLostTarget : null);
      } else {
        this._cachedBeamLostTarget = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedBeamLostTarget;
  }
  get beamLostLaunch() {
    if (!this._cachedBeamLostLaunch) {
      if (this._value._oneofTermTypeCase === 0) {
        this._cachedBeamLostLaunch = this._parent ? new ActorTerm_EmptyTerm.WithParent(ActorTerm_EmptyTerm.default, this._parent.beamLostLaunch) : this._value.beamLostLaunch;
      } else if (this._value._oneofTermTypeCase === 92) {
        this._cachedBeamLostLaunch = new ActorTerm_EmptyTerm.WithParent(this._value.beamLostLaunch, this._parent && this._parent.oneofTermTypeCase === 92 ? this._parent.beamLostLaunch : null);
      } else {
        this._cachedBeamLostLaunch = ActorTerm_EmptyTerm.WithParent.default;
      }
    }
    return this._cachedBeamLostLaunch;
  }
  update(current, parent) {
    const result = new ActorTerm_WithParent(current, parent);
    if (this._cachedUnitSpawn && this._value._oneofTermTypeCase === 1 && current._oneofTermTypeCase === 1) {
      if (this._value.unitSpawn === current.unitSpawn && this._parent === parent) {
        result._cachedUnitSpawn = this._cachedUnitSpawn;
      } else {
        result._cachedUnitSpawn = this._cachedUnitSpawn.update(current.unitSpawn, parent && parent.oneofTermTypeCase === 1 ? parent.unitSpawn : null);
      }
    }
    if (this._cachedUnitMorph && this._value._oneofTermTypeCase === 2 && current._oneofTermTypeCase === 2) {
      if (this._value.unitMorph === current.unitMorph && this._parent === parent) {
        result._cachedUnitMorph = this._cachedUnitMorph;
      } else {
        result._cachedUnitMorph = this._cachedUnitMorph.update(current.unitMorph, parent && parent.oneofTermTypeCase === 2 ? parent.unitMorph : null);
      }
    }
    if (this._cachedUnitRemove && this._value._oneofTermTypeCase === 3 && current._oneofTermTypeCase === 3) {
      if (this._value.unitRemove === current.unitRemove && this._parent === parent) {
        result._cachedUnitRemove = this._cachedUnitRemove;
      } else {
        result._cachedUnitRemove = this._cachedUnitRemove.update(current.unitRemove, parent && parent.oneofTermTypeCase === 3 ? parent.unitRemove : null);
      }
    }
    if (this._cachedUnitStand && this._value._oneofTermTypeCase === 4 && current._oneofTermTypeCase === 4) {
      if (this._value.unitStand === current.unitStand && this._parent === parent) {
        result._cachedUnitStand = this._cachedUnitStand;
      } else {
        result._cachedUnitStand = this._cachedUnitStand.update(current.unitStand, parent && parent.oneofTermTypeCase === 4 ? parent.unitStand : null);
      }
    }
    if (this._cachedUnitWalk && this._value._oneofTermTypeCase === 5 && current._oneofTermTypeCase === 5) {
      if (this._value.unitWalk === current.unitWalk && this._parent === parent) {
        result._cachedUnitWalk = this._cachedUnitWalk;
      } else {
        result._cachedUnitWalk = this._cachedUnitWalk.update(current.unitWalk, parent && parent.oneofTermTypeCase === 5 ? parent.unitWalk : null);
      }
    }
    if (this._cachedUnitDeath && this._value._oneofTermTypeCase === 6 && current._oneofTermTypeCase === 6) {
      if (this._value.unitDeath === current.unitDeath && this._parent === parent) {
        result._cachedUnitDeath = this._cachedUnitDeath;
      } else {
        result._cachedUnitDeath = this._cachedUnitDeath.update(current.unitDeath, parent && parent.oneofTermTypeCase === 6 ? parent.unitDeath : null);
      }
    }
    if (this._cachedUnitWeaponStart && this._value._oneofTermTypeCase === 7 && current._oneofTermTypeCase === 7) {
      if (this._value.unitWeaponStart === current.unitWeaponStart && this._parent === parent) {
        result._cachedUnitWeaponStart = this._cachedUnitWeaponStart;
      } else {
        result._cachedUnitWeaponStart = this._cachedUnitWeaponStart.update(current.unitWeaponStart, parent && parent.oneofTermTypeCase === 7 ? parent.unitWeaponStart : null);
      }
    }
    if (this._cachedUnitWeaponStop && this._value._oneofTermTypeCase === 8 && current._oneofTermTypeCase === 8) {
      if (this._value.unitWeaponStop === current.unitWeaponStop && this._parent === parent) {
        result._cachedUnitWeaponStop = this._cachedUnitWeaponStop;
      } else {
        result._cachedUnitWeaponStop = this._cachedUnitWeaponStop.update(current.unitWeaponStop, parent && parent.oneofTermTypeCase === 8 ? parent.unitWeaponStop : null);
      }
    }
    if (this._cachedUnitAbilityStart && this._value._oneofTermTypeCase === 9 && current._oneofTermTypeCase === 9) {
      if (this._value.unitAbilityStart === current.unitAbilityStart && this._parent === parent) {
        result._cachedUnitAbilityStart = this._cachedUnitAbilityStart;
      } else {
        result._cachedUnitAbilityStart = this._cachedUnitAbilityStart.update(current.unitAbilityStart, parent && parent.oneofTermTypeCase === 9 ? parent.unitAbilityStart : null);
      }
    }
    if (this._cachedUnitAbilityStop && this._value._oneofTermTypeCase === 10 && current._oneofTermTypeCase === 10) {
      if (this._value.unitAbilityStop === current.unitAbilityStop && this._parent === parent) {
        result._cachedUnitAbilityStop = this._cachedUnitAbilityStop;
      } else {
        result._cachedUnitAbilityStop = this._cachedUnitAbilityStop.update(current.unitAbilityStop, parent && parent.oneofTermTypeCase === 10 ? parent.unitAbilityStop : null);
      }
    }
    if (this._cachedUnitAbilityTargetingOn && this._value._oneofTermTypeCase === 11 && current._oneofTermTypeCase === 11) {
      if (this._value.unitAbilityTargetingOn === current.unitAbilityTargetingOn && this._parent === parent) {
        result._cachedUnitAbilityTargetingOn = this._cachedUnitAbilityTargetingOn;
      } else {
        result._cachedUnitAbilityTargetingOn = this._cachedUnitAbilityTargetingOn.update(current.unitAbilityTargetingOn, parent && parent.oneofTermTypeCase === 11 ? parent.unitAbilityTargetingOn : null);
      }
    }
    if (this._cachedUnitAbilityTargetingOff && this._value._oneofTermTypeCase === 12 && current._oneofTermTypeCase === 12) {
      if (this._value.unitAbilityTargetingOff === current.unitAbilityTargetingOff && this._parent === parent) {
        result._cachedUnitAbilityTargetingOff = this._cachedUnitAbilityTargetingOff;
      } else {
        result._cachedUnitAbilityTargetingOff = this._cachedUnitAbilityTargetingOff.update(current.unitAbilityTargetingOff, parent && parent.oneofTermTypeCase === 12 ? parent.unitAbilityTargetingOff : null);
      }
    }
    if (this._cachedUnitChildrenSelectionOn && this._value._oneofTermTypeCase === 13 && current._oneofTermTypeCase === 13) {
      if (this._value.unitChildrenSelectionOn === current.unitChildrenSelectionOn && this._parent === parent) {
        result._cachedUnitChildrenSelectionOn = this._cachedUnitChildrenSelectionOn;
      } else {
        result._cachedUnitChildrenSelectionOn = this._cachedUnitChildrenSelectionOn.update(current.unitChildrenSelectionOn, parent && parent.oneofTermTypeCase === 13 ? parent.unitChildrenSelectionOn : null);
      }
    }
    if (this._cachedUnitChildrenSelectionOff && this._value._oneofTermTypeCase === 14 && current._oneofTermTypeCase === 14) {
      if (this._value.unitChildrenSelectionOff === current.unitChildrenSelectionOff && this._parent === parent) {
        result._cachedUnitChildrenSelectionOff = this._cachedUnitChildrenSelectionOff;
      } else {
        result._cachedUnitChildrenSelectionOff = this._cachedUnitChildrenSelectionOff.update(current.unitChildrenSelectionOff, parent && parent.oneofTermTypeCase === 14 ? parent.unitChildrenSelectionOff : null);
      }
    }
    if (this._cachedUnitMoveCommandReceived && this._value._oneofTermTypeCase === 15 && current._oneofTermTypeCase === 15) {
      if (this._value.unitMoveCommandReceived === current.unitMoveCommandReceived && this._parent === parent) {
        result._cachedUnitMoveCommandReceived = this._cachedUnitMoveCommandReceived;
      } else {
        result._cachedUnitMoveCommandReceived = this._cachedUnitMoveCommandReceived.update(current.unitMoveCommandReceived, parent && parent.oneofTermTypeCase === 15 ? parent.unitMoveCommandReceived : null);
      }
    }
    if (this._cachedUnitAttackCommandReceived && this._value._oneofTermTypeCase === 16 && current._oneofTermTypeCase === 16) {
      if (this._value.unitAttackCommandReceived === current.unitAttackCommandReceived && this._parent === parent) {
        result._cachedUnitAttackCommandReceived = this._cachedUnitAttackCommandReceived;
      } else {
        result._cachedUnitAttackCommandReceived = this._cachedUnitAttackCommandReceived.update(current.unitAttackCommandReceived, parent && parent.oneofTermTypeCase === 16 ? parent.unitAttackCommandReceived : null);
      }
    }
    if (this._cachedUnitWeaponDamagePoint && this._value._oneofTermTypeCase === 17 && current._oneofTermTypeCase === 17) {
      if (this._value.unitWeaponDamagePoint === current.unitWeaponDamagePoint && this._parent === parent) {
        result._cachedUnitWeaponDamagePoint = this._cachedUnitWeaponDamagePoint;
      } else {
        result._cachedUnitWeaponDamagePoint = this._cachedUnitWeaponDamagePoint.update(current.unitWeaponDamagePoint, parent && parent.oneofTermTypeCase === 17 ? parent.unitWeaponDamagePoint : null);
      }
    }
    if (this._cachedPreAbilityTargetedOn && this._value._oneofTermTypeCase === 18 && current._oneofTermTypeCase === 18) {
      if (this._value.preAbilityTargetedOn === current.preAbilityTargetedOn && this._parent === parent) {
        result._cachedPreAbilityTargetedOn = this._cachedPreAbilityTargetedOn;
      } else {
        result._cachedPreAbilityTargetedOn = this._cachedPreAbilityTargetedOn.update(current.preAbilityTargetedOn, parent && parent.oneofTermTypeCase === 18 ? parent.preAbilityTargetedOn : null);
      }
    }
    if (this._cachedPreAbilityTargetedOff && this._value._oneofTermTypeCase === 19 && current._oneofTermTypeCase === 19) {
      if (this._value.preAbilityTargetedOff === current.preAbilityTargetedOff && this._parent === parent) {
        result._cachedPreAbilityTargetedOff = this._cachedPreAbilityTargetedOff;
      } else {
        result._cachedPreAbilityTargetedOff = this._cachedPreAbilityTargetedOff.update(current.preAbilityTargetedOff, parent && parent.oneofTermTypeCase === 19 ? parent.preAbilityTargetedOff : null);
      }
    }
    if (this._cachedPreAbilityCastTargeted && this._value._oneofTermTypeCase === 20 && current._oneofTermTypeCase === 20) {
      if (this._value.preAbilityCastTargeted === current.preAbilityCastTargeted && this._parent === parent) {
        result._cachedPreAbilityCastTargeted = this._cachedPreAbilityCastTargeted;
      } else {
        result._cachedPreAbilityCastTargeted = this._cachedPreAbilityCastTargeted.update(current.preAbilityCastTargeted, parent && parent.oneofTermTypeCase === 20 ? parent.preAbilityCastTargeted : null);
      }
    }
    if (this._cachedSelectionOn && this._value._oneofTermTypeCase === 21 && current._oneofTermTypeCase === 21) {
      if (this._value.selectionOn === current.selectionOn && this._parent === parent) {
        result._cachedSelectionOn = this._cachedSelectionOn;
      } else {
        result._cachedSelectionOn = this._cachedSelectionOn.update(current.selectionOn, parent && parent.oneofTermTypeCase === 21 ? parent.selectionOn : null);
      }
    }
    if (this._cachedSelectionOff && this._value._oneofTermTypeCase === 22 && current._oneofTermTypeCase === 22) {
      if (this._value.selectionOff === current.selectionOff && this._parent === parent) {
        result._cachedSelectionOff = this._cachedSelectionOff;
      } else {
        result._cachedSelectionOff = this._cachedSelectionOff.update(current.selectionOff, parent && parent.oneofTermTypeCase === 22 ? parent.selectionOff : null);
      }
    }
    if (this._cachedBehaviorOn && this._value._oneofTermTypeCase === 31 && current._oneofTermTypeCase === 31) {
      if (this._value.behaviorOn === current.behaviorOn && this._parent === parent) {
        result._cachedBehaviorOn = this._cachedBehaviorOn;
      } else {
        result._cachedBehaviorOn = this._cachedBehaviorOn.update(current.behaviorOn, parent && parent.oneofTermTypeCase === 31 ? parent.behaviorOn : null);
      }
    }
    if (this._cachedBehaviorOff && this._value._oneofTermTypeCase === 32 && current._oneofTermTypeCase === 32) {
      if (this._value.behaviorOff === current.behaviorOff && this._parent === parent) {
        result._cachedBehaviorOff = this._cachedBehaviorOff;
      } else {
        result._cachedBehaviorOff = this._cachedBehaviorOff.update(current.behaviorOff, parent && parent.oneofTermTypeCase === 32 ? parent.behaviorOff : null);
      }
    }
    if (this._cachedPersistentEffectOn && this._value._oneofTermTypeCase === 41 && current._oneofTermTypeCase === 41) {
      if (this._value.persistentEffectOn === current.persistentEffectOn && this._parent === parent) {
        result._cachedPersistentEffectOn = this._cachedPersistentEffectOn;
      } else {
        result._cachedPersistentEffectOn = this._cachedPersistentEffectOn.update(current.persistentEffectOn, parent && parent.oneofTermTypeCase === 41 ? parent.persistentEffectOn : null);
      }
    }
    if (this._cachedPersistentEffectOff && this._value._oneofTermTypeCase === 42 && current._oneofTermTypeCase === 42) {
      if (this._value.persistentEffectOff === current.persistentEffectOff && this._parent === parent) {
        result._cachedPersistentEffectOff = this._cachedPersistentEffectOff;
      } else {
        result._cachedPersistentEffectOff = this._cachedPersistentEffectOff.update(current.persistentEffectOff, parent && parent.oneofTermTypeCase === 42 ? parent.persistentEffectOff : null);
      }
    }
    if (this._cachedActorCreate && this._value._oneofTermTypeCase === 51 && current._oneofTermTypeCase === 51) {
      if (this._value.actorCreate === current.actorCreate && this._parent === parent) {
        result._cachedActorCreate = this._cachedActorCreate;
      } else {
        result._cachedActorCreate = this._cachedActorCreate.update(current.actorCreate, parent && parent.oneofTermTypeCase === 51 ? parent.actorCreate : null);
      }
    }
    if (this._cachedActorDestroy && this._value._oneofTermTypeCase === 52 && current._oneofTermTypeCase === 52) {
      if (this._value.actorDestroy === current.actorDestroy && this._parent === parent) {
        result._cachedActorDestroy = this._cachedActorDestroy;
      } else {
        result._cachedActorDestroy = this._cachedActorDestroy.update(current.actorDestroy, parent && parent.oneofTermTypeCase === 52 ? parent.actorDestroy : null);
      }
    }
    if (this._cachedActorOrphan && this._value._oneofTermTypeCase === 53 && current._oneofTermTypeCase === 53) {
      if (this._value.actorOrphan === current.actorOrphan && this._parent === parent) {
        result._cachedActorOrphan = this._cachedActorOrphan;
      } else {
        result._cachedActorOrphan = this._cachedActorOrphan.update(current.actorOrphan, parent && parent.oneofTermTypeCase === 53 ? parent.actorOrphan : null);
      }
    }
    if (this._cachedAnimationFinish && this._value._oneofTermTypeCase === 61 && current._oneofTermTypeCase === 61) {
      if (this._value.animationFinish === current.animationFinish && this._parent === parent) {
        result._cachedAnimationFinish = this._cachedAnimationFinish;
      } else {
        result._cachedAnimationFinish = this._cachedAnimationFinish.update(current.animationFinish, parent && parent.oneofTermTypeCase === 61 ? parent.animationFinish : null);
      }
    }
    if (this._cachedOnTimer && this._value._oneofTermTypeCase === 71 && current._oneofTermTypeCase === 71) {
      if (this._value.onTimer === current.onTimer && this._parent === parent) {
        result._cachedOnTimer = this._cachedOnTimer;
      } else {
        result._cachedOnTimer = this._cachedOnTimer.update(current.onTimer, parent && parent.oneofTermTypeCase === 71 ? parent.onTimer : null);
      }
    }
    if (this._cachedOnCustomEvent && this._value._oneofTermTypeCase === 81 && current._oneofTermTypeCase === 81) {
      if (this._value.onCustomEvent === current.onCustomEvent && this._parent === parent) {
        result._cachedOnCustomEvent = this._cachedOnCustomEvent;
      } else {
        result._cachedOnCustomEvent = this._cachedOnCustomEvent.update(current.onCustomEvent, parent && parent.oneofTermTypeCase === 81 ? parent.onCustomEvent : null);
      }
    }
    if (this._cachedBeamLostTarget && this._value._oneofTermTypeCase === 91 && current._oneofTermTypeCase === 91) {
      if (this._value.beamLostTarget === current.beamLostTarget && this._parent === parent) {
        result._cachedBeamLostTarget = this._cachedBeamLostTarget;
      } else {
        result._cachedBeamLostTarget = this._cachedBeamLostTarget.update(current.beamLostTarget, parent && parent.oneofTermTypeCase === 91 ? parent.beamLostTarget : null);
      }
    }
    if (this._cachedBeamLostLaunch && this._value._oneofTermTypeCase === 92 && current._oneofTermTypeCase === 92) {
      if (this._value.beamLostLaunch === current.beamLostLaunch && this._parent === parent) {
        result._cachedBeamLostLaunch = this._cachedBeamLostLaunch;
      } else {
        result._cachedBeamLostLaunch = this._cachedBeamLostLaunch.update(current.beamLostLaunch, parent && parent.oneofTermTypeCase === 92 ? parent.beamLostLaunch : null);
      }
    }
    return result;
  }
}
ActorTerm_WithParent.default = new ActorTerm_WithParent(ActorTerm.default, null);
ActorTerm.WithParent = ActorTerm_WithParent;
class ActorTerm_Descriptor {
  get unitSpawn() {
    if (!this._unitSpawn) {
      this._unitSpawn = {
        name: "unitSpawn",
        Name: "UnitSpawn",
        number: 1,
        protoType: 11,
        protoName: "unit_spawn",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when the linked unit is spawned.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitSpawn;
  }
  get unitMorph() {
    if (!this._unitMorph) {
      this._unitMorph = {
        name: "unitMorph",
        Name: "UnitMorph",
        number: 2,
        protoType: 11,
        protoName: "unit_morph",
        oneofIndex: 0,
        type: ActorTerm_UnitTerm,
        options: {
          comments: "Triggers when a unit undergoes a **Morph** effect.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitMorph;
  }
  get unitRemove() {
    if (!this._unitRemove) {
      this._unitRemove = {
        name: "unitRemove",
        Name: "UnitRemove",
        number: 3,
        protoType: 11,
        protoName: "unit_remove",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when a unit is removed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitRemove;
  }
  get unitStand() {
    if (!this._unitStand) {
      this._unitStand = {
        name: "unitStand",
        Name: "UnitStand",
        number: 4,
        protoType: 11,
        protoName: "unit_stand",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when a unit leaves its movement state (ie, when it begins standing).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitStand;
  }
  get unitWalk() {
    if (!this._unitWalk) {
      this._unitWalk = {
        name: "unitWalk",
        Name: "UnitWalk",
        number: 5,
        protoType: 11,
        protoName: "unit_walk",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when a unit enters its movement state (ie, when it begins walking).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWalk;
  }
  get unitDeath() {
    if (!this._unitDeath) {
      this._unitDeath = {
        name: "unitDeath",
        Name: "UnitDeath",
        number: 6,
        protoType: 11,
        protoName: "unit_death",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when a unit dies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitDeath;
  }
  get unitWeaponStart() {
    if (!this._unitWeaponStart) {
      this._unitWeaponStart = {
        name: "unitWeaponStart",
        Name: "UnitWeaponStart",
        number: 7,
        protoType: 11,
        protoName: "unit_weapon_start",
        oneofIndex: 0,
        type: ActorTerm_UnitWeaponTerm,
        options: {
          comments: "Triggers when a unit begins attacking with a weapon.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWeaponStart;
  }
  get unitWeaponStop() {
    if (!this._unitWeaponStop) {
      this._unitWeaponStop = {
        name: "unitWeaponStop",
        Name: "UnitWeaponStop",
        number: 8,
        protoType: 11,
        protoName: "unit_weapon_stop",
        oneofIndex: 0,
        type: ActorTerm_UnitWeaponTerm,
        options: {
          comments: "Triggers when a unit stops attacking with a weapon.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWeaponStop;
  }
  get unitAbilityStart() {
    if (!this._unitAbilityStart) {
      this._unitAbilityStart = {
        name: "unitAbilityStart",
        Name: "UnitAbilityStart",
        number: 9,
        protoType: 11,
        protoName: "unit_ability_start",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Triggers when a unit starts casting an ability.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityStart;
  }
  get unitAbilityStop() {
    if (!this._unitAbilityStop) {
      this._unitAbilityStop = {
        name: "unitAbilityStop",
        Name: "UnitAbilityStop",
        number: 10,
        protoType: 11,
        protoName: "unit_ability_stop",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Triggers when a unit stops casting an ability.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityStop;
  }
  get unitAbilityTargetingOn() {
    if (!this._unitAbilityTargetingOn) {
      this._unitAbilityTargetingOn = {
        name: "unitAbilityTargetingOn",
        Name: "UnitAbilityTargetingOn",
        number: 11,
        protoType: 11,
        protoName: "unit_ability_targeting_on",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Triggers when an ability enters targeting mode.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityTargetingOn;
  }
  get unitAbilityTargetingOff() {
    if (!this._unitAbilityTargetingOff) {
      this._unitAbilityTargetingOff = {
        name: "unitAbilityTargetingOff",
        Name: "UnitAbilityTargetingOff",
        number: 12,
        protoType: 11,
        protoName: "unit_ability_targeting_off",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Triggers when an ability leaves targeting mode.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityTargetingOff;
  }
  get unitChildrenSelectionOn() {
    if (!this._unitChildrenSelectionOn) {
      this._unitChildrenSelectionOn = {
        name: "unitChildrenSelectionOn",
        Name: "UnitChildrenSelectionOn",
        number: 13,
        protoType: 11,
        protoName: "unit_children_selection_on",
        oneofIndex: 0,
        type: ActorTerm_UnitTerm,
        options: {
          comments: "Triggers when the children of this unit are selected.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitChildrenSelectionOn;
  }
  get unitChildrenSelectionOff() {
    if (!this._unitChildrenSelectionOff) {
      this._unitChildrenSelectionOff = {
        name: "unitChildrenSelectionOff",
        Name: "UnitChildrenSelectionOff",
        number: 14,
        protoType: 11,
        protoName: "unit_children_selection_off",
        oneofIndex: 0,
        type: ActorTerm_UnitTerm,
        options: {
          comments: "Triggers when the children of this unit are deselected.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitChildrenSelectionOff;
  }
  get unitMoveCommandReceived() {
    if (!this._unitMoveCommandReceived) {
      this._unitMoveCommandReceived = {
        name: "unitMoveCommandReceived",
        Name: "UnitMoveCommandReceived",
        number: 15,
        protoType: 11,
        protoName: "unit_move_command_received",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when a unit receives a movement command.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitMoveCommandReceived;
  }
  get unitAttackCommandReceived() {
    if (!this._unitAttackCommandReceived) {
      this._unitAttackCommandReceived = {
        name: "unitAttackCommandReceived",
        Name: "UnitAttackCommandReceived",
        number: 16,
        protoType: 11,
        protoName: "unit_attack_command_received",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when a unit receives an attack command.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAttackCommandReceived;
  }
  get unitWeaponDamagePoint() {
    if (!this._unitWeaponDamagePoint) {
      this._unitWeaponDamagePoint = {
        name: "unitWeaponDamagePoint",
        Name: "UnitWeaponDamagePoint",
        number: 17,
        protoType: 11,
        protoName: "unit_weapon_damage_point",
        oneofIndex: 0,
        type: ActorTerm_UnitWeaponTerm,
        options: {
          comments: "Triggers when a unit executes an attack with a weapon (occurs after preswing).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitWeaponDamagePoint;
  }
  get preAbilityTargetedOn() {
    if (!this._preAbilityTargetedOn) {
      this._preAbilityTargetedOn = {
        name: "preAbilityTargetedOn",
        Name: "PreAbilityTargetedOn",
        number: 18,
        protoType: 11,
        protoName: "pre_ability_targeted_on",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Triggers when a unit becomes highlighted by ability in targeting mode.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preAbilityTargetedOn;
  }
  get preAbilityTargetedOff() {
    if (!this._preAbilityTargetedOff) {
      this._preAbilityTargetedOff = {
        name: "preAbilityTargetedOff",
        Name: "PreAbilityTargetedOff",
        number: 19,
        protoType: 11,
        protoName: "pre_ability_targeted_off",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Triggers when a unit is unhighlighted by ability in targeting mode.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preAbilityTargetedOff;
  }
  get preAbilityCastTargeted() {
    if (!this._preAbilityCastTargeted) {
      this._preAbilityCastTargeted = {
        name: "preAbilityCastTargeted",
        Name: "PreAbilityCastTargeted",
        number: 20,
        protoType: 11,
        protoName: "pre_ability_cast_targeted",
        oneofIndex: 0,
        type: ActorTerm_UnitAbilityTerm,
        options: {
          comments: "Sent to the target unit\'s actor scope when a targeting ability is cast on the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preAbilityCastTargeted;
  }
  get selectionOn() {
    if (!this._selectionOn) {
      this._selectionOn = {
        name: "selectionOn",
        Name: "SelectionOn",
        number: 21,
        protoType: 11,
        protoName: "selection_on",
        oneofIndex: 0,
        type: ActorTerm_SelectionTerm,
        options: {
          comments: "Triggers when a unit is selected or on mouse hover.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionOn;
  }
  get selectionOff() {
    if (!this._selectionOff) {
      this._selectionOff = {
        name: "selectionOff",
        Name: "SelectionOff",
        number: 22,
        protoType: 11,
        protoName: "selection_off",
        oneofIndex: 0,
        type: ActorTerm_SelectionTerm,
        options: {
          comments: "Triggers when a unit is deselected or on mouse hover off.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionOff;
  }
  get behaviorOn() {
    if (!this._behaviorOn) {
      this._behaviorOn = {
        name: "behaviorOn",
        Name: "BehaviorOn",
        number: 31,
        protoType: 11,
        protoName: "behavior_on",
        oneofIndex: 0,
        type: ActorTerm_BehaviorTerm,
        options: {
          comments: "Triggers when a unit gains a behavior.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorOn;
  }
  get behaviorOff() {
    if (!this._behaviorOff) {
      this._behaviorOff = {
        name: "behaviorOff",
        Name: "BehaviorOff",
        number: 32,
        protoType: 11,
        protoName: "behavior_off",
        oneofIndex: 0,
        type: ActorTerm_BehaviorTerm,
        options: {
          comments: "Triggers when a unit loses a behavior (including if the behavior becomes disabled).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorOff;
  }
  get persistentEffectOn() {
    if (!this._persistentEffectOn) {
      this._persistentEffectOn = {
        name: "persistentEffectOn",
        Name: "PersistentEffectOn",
        number: 41,
        protoType: 11,
        protoName: "persistent_effect_on",
        oneofIndex: 0,
        type: ActorTerm_EffectTerm,
        options: {
          comments: "Triggers when a persistent effect is created.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._persistentEffectOn;
  }
  get persistentEffectOff() {
    if (!this._persistentEffectOff) {
      this._persistentEffectOff = {
        name: "persistentEffectOff",
        Name: "PersistentEffectOff",
        number: 42,
        protoType: 11,
        protoName: "persistent_effect_off",
        oneofIndex: 0,
        type: ActorTerm_EffectTerm,
        options: {
          comments: "Triggers when a persistent effect is destroyed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._persistentEffectOff;
  }
  get actorCreate() {
    if (!this._actorCreate) {
      this._actorCreate = {
        name: "actorCreate",
        Name: "ActorCreate",
        number: 51,
        protoType: 11,
        protoName: "actor_create",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when the actor is created.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actorCreate;
  }
  get actorDestroy() {
    if (!this._actorDestroy) {
      this._actorDestroy = {
        name: "actorDestroy",
        Name: "ActorDestroy",
        number: 52,
        protoType: 11,
        protoName: "actor_destroy",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when the actor is destroyed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actorDestroy;
  }
  get actorOrphan() {
    if (!this._actorOrphan) {
      this._actorOrphan = {
        name: "actorOrphan",
        Name: "ActorOrphan",
        number: 53,
        protoType: 11,
        protoName: "actor_orphan",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when the actor becomes orphaned. Actors become orphaned when their host actor is destroyed (an actor\'s host is typically the actor that created it).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actorOrphan;
  }
  get animationFinish() {
    if (!this._animationFinish) {
      this._animationFinish = {
        name: "animationFinish",
        Name: "AnimationFinish",
        number: 61,
        protoType: 11,
        protoName: "animation_finish",
        oneofIndex: 0,
        type: ActorTerm_AnimationTerm,
        options: {
          comments: "Triggers when an animation on the actor finishes.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._animationFinish;
  }
  get onTimer() {
    if (!this._onTimer) {
      this._onTimer = {
        name: "onTimer",
        Name: "OnTimer",
        number: 71,
        protoType: 11,
        protoName: "on_timer",
        oneofIndex: 0,
        type: ActorTerm_TimerTerm,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._onTimer;
  }
  get onCustomEvent() {
    if (!this._onCustomEvent) {
      this._onCustomEvent = {
        name: "onCustomEvent",
        Name: "OnCustomEvent",
        number: 81,
        protoType: 11,
        protoName: "on_custom_event",
        oneofIndex: 0,
        type: ActorTerm_CustomEvent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._onCustomEvent;
  }
  get beamLostTarget() {
    if (!this._beamLostTarget) {
      this._beamLostTarget = {
        name: "beamLostTarget",
        Name: "BeamLostTarget",
        number: 91,
        protoType: 11,
        protoName: "beam_lost_target",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when the target of beam model actor is destroyed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._beamLostTarget;
  }
  get beamLostLaunch() {
    if (!this._beamLostLaunch) {
      this._beamLostLaunch = {
        name: "beamLostLaunch",
        Name: "BeamLostLaunch",
        number: 92,
        protoType: 11,
        protoName: "beam_lost_launch",
        oneofIndex: 0,
        type: ActorTerm_EmptyTerm,
        options: {
          comments: "Triggers when the launch of beam model actor is destroyed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._beamLostLaunch;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitSpawn,
        this.unitMorph,
        this.unitRemove,
        this.unitStand,
        this.unitWalk,
        this.unitDeath,
        this.unitWeaponStart,
        this.unitWeaponStop,
        this.unitAbilityStart,
        this.unitAbilityStop,
        this.unitAbilityTargetingOn,
        this.unitAbilityTargetingOff,
        this.unitChildrenSelectionOn,
        this.unitChildrenSelectionOff,
        this.unitMoveCommandReceived,
        this.unitAttackCommandReceived,
        this.unitWeaponDamagePoint,
        this.preAbilityTargetedOn,
        this.preAbilityTargetedOff,
        this.preAbilityCastTargeted,
        this.selectionOn,
        this.selectionOff,
        this.behaviorOn,
        this.behaviorOff,
        this.persistentEffectOn,
        this.persistentEffectOff,
        this.actorCreate,
        this.actorDestroy,
        this.actorOrphan,
        this.animationFinish,
        this.onTimer,
        this.onCustomEvent,
        this.beamLostTarget,
        this.beamLostLaunch,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofTermType",
        Name: "OneofTermType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
          this.fields[13],
          this.fields[14],
          this.fields[15],
          this.fields[16],
          this.fields[17],
          this.fields[18],
          this.fields[19],
          this.fields[20],
          this.fields[21],
          this.fields[22],
          this.fields[23],
          this.fields[24],
          this.fields[25],
          this.fields[26],
          this.fields[27],
          this.fields[28],
          this.fields[29],
          this.fields[30],
          this.fields[31],
          this.fields[32],
          this.fields[33],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorTerm.descriptor = new ActorTerm_Descriptor();
export class ActorEvent {
  get descriptor() {
    return ActorEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIndex = false;
    this._index = null;
    this._hasDeprecatedTerm = false;
    this._term = null;
    this._hasActorTerm = false;
    this._actorTerm = null;
    this._conditions = [];
    this._actions = [];
  }
  isEmpty() {
    if (this._hasIndex) return false;
    if (this._hasDeprecatedTerm) return false;
    if (this._hasActorTerm && !this._actorTerm.isEmpty()) return false;
    if (this._conditions.length > 0) return false;
    if (this._actions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorEvent) {
      return value;
    }
    return ActorEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorEvent();
    if (json.index != null) {
      result._hasIndex = true;
      result._index = JsonToInt32.fromJson(json.index);
    }
    if (json.term != null) {
      result._hasDeprecatedTerm = true;
      result._term = JsonToString.fromJson(json.term);
    }
    if (json.actorTerm != null) {
      result._hasActorTerm = true;
      result._actorTerm = ActorTerm.fromJson(json.actorTerm);
    }
    result._conditions = JsonToList(json.conditions, ActorExpressions_Expression);
    result._actions = JsonToList(json.actions, ActorAction);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIndex) {
      result.index = JsonToInt32.toJson(this._index);
    }
    if (this._hasDeprecatedTerm) {
      result.term = JsonToString.toJson(this._term);
    }
    if (this._hasActorTerm && !this._actorTerm.isEmpty()) {
      result.actorTerm = ActorTerm.toJson(this._actorTerm);
    }
    if (this._conditions.length > 0) {
      result.conditions = ArrayToJson(this._conditions, ActorExpressions_Expression);
    }
    if (this._actions.length > 0) {
      result.actions = ArrayToJson(this._actions, ActorAction);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get index() {
    return this._hasIndex ? this._index : JsonToInt32.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  /**
   * @returns {string}
   */
  get term() {
    return this._hasDeprecatedTerm ? this._term : JsonToString.default;
  }
  get hasDeprecatedTerm() {
    return this._hasDeprecatedTerm;
  }
  setDeprecatedTerm(path, value) {
    return {type: 'SET', path: path.concat(['term']), value};
  }
  deleteDeprecatedTerm(path) {
    return {type: 'DELETE', path: path.concat(['term'])};
  }
  /**
   * @returns {ActorTerm}
   */
  get actorTerm() {
    return this._hasActorTerm ? this._actorTerm : ActorTerm.default;
  }
  get hasActorTerm() {
    return this._hasActorTerm;
  }
  setActorTerm(path, value) {
    return {type: 'SET', path: path.concat(['actorTerm']), value: value.toJson()};
  }
  deleteActorTerm(path) {
    return {type: 'DELETE', path: path.concat(['actorTerm'])};
  }
  /**
   * @returns {ActorExpressions_Expression[]}
   */
  get conditions() {
    return this._conditions;
  }
  addConditions(path, value) {
    return {type: 'ADD', path: path.concat(['conditions']), value: value.toJson()};
  }
  setConditions(path, value) {
    return {type: 'SET', path: path.concat(['conditions']), value: ArrayToJson(value, ActorExpressions_Expression)};
  }
  setConditionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['conditions', key]), value: value.toJson()};
  }
  deleteConditions(path) {
    return {type: 'DELETE', path: path.concat(['conditions'])};
  }
  deleteConditionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['conditions', key])};
  }
  /**
   * @returns {ActorAction[]}
   */
  get actions() {
    return this._actions;
  }
  addActions(path, value) {
    return {type: 'ADD', path: path.concat(['actions']), value: value.toJson()};
  }
  setActions(path, value) {
    return {type: 'SET', path: path.concat(['actions']), value: ArrayToJson(value, ActorAction)};
  }
  setActionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['actions', key]), value: value.toJson()};
  }
  deleteActions(path) {
    return {type: 'DELETE', path: path.concat(['actions'])};
  }
  deleteActionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['actions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._hasIndex = true;
              copy._index = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new ActorEvent(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "term": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._hasDeprecatedTerm = true;
              copy._term = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedTerm) {
                return this;
              }
              const copy = new ActorEvent(this);
              copy._hasDeprecatedTerm = false;
              copy._term = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "actorTerm": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._hasActorTerm = true;
              copy._actorTerm = ActorTerm.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActorTerm) {
                return this;
              }
              const copy = new ActorEvent(this);
              copy._hasActorTerm = false;
              copy._actorTerm = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasActorTerm) {
            const copy = new ActorEvent(this);
            copy._hasActorTerm = true;
            copy._actorTerm = ActorTerm.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._actorTerm.apply(type, path.slice(1), value);
          if (newValue === this._actorTerm) {
            return this;
          }
          const copy = new ActorEvent(this);
          copy._actorTerm = copy._actorTerm.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "conditions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._conditions = [];        for (let i of value) {
                copy._conditions.push(ActorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorEvent(this);
              copy._conditions = copy._conditions.concat([ActorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._conditions.length === 0) {
                return this;
              }
              const copy = new ActorEvent(this);
              copy._conditions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._conditions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._conditions = copy._conditions.slice();
              copy._conditions[path[1]] = ActorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorEvent(this);
              copy._conditions = copy._conditions.slice(0, path[1]).concat(copy._conditions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._conditions.length) {
            return this;
          }
          const oldValue = this._conditions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorEvent(this);
          copy._conditions = copy._conditions.slice();
          copy._conditions[key] = newValue;
          return copy;
        }
      }
      case "actions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._actions = [];        for (let i of value) {
                copy._actions.push(ActorAction.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorEvent(this);
              copy._actions = copy._actions.concat([ActorAction.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._actions.length === 0) {
                return this;
              }
              const copy = new ActorEvent(this);
              copy._actions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._actions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorEvent(this);
              copy._actions = copy._actions.slice();
              copy._actions[path[1]] = ActorAction.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorEvent(this);
              copy._actions = copy._actions.slice(0, path[1]).concat(copy._actions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._actions.length) {
            return this;
          }
          const oldValue = this._actions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorEvent(this);
          copy._actions = copy._actions.slice();
          copy._actions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorEvent} other
   * @returns {ActorEvent}
   */
  merge(other) {
    const copy = new ActorEvent(this);
    if (other._hasIndex) {
      copy._hasIndex = true;
      copy._index = other._index;
    }
    if (other._hasDeprecatedTerm) {
      copy._hasDeprecatedTerm = true;
      copy._term = other._term;
    }
    if (other._hasActorTerm) {
      if (copy._hasActorTerm) {
        copy._actorTerm = copy.actorTerm.merge(other.actorTerm);
      } else {
        copy._actorTerm = other._actorTerm;
      }
      copy._hasActorTerm = true;
    }
    copy._conditions = this._conditions.concat(other._conditions);
    copy._actions = this._actions.concat(other._actions);
    return copy;
  }
}
ActorEvent.default = new ActorEvent();
class ActorEvent_Builder {
  constructor(value) {
    this._value = new ActorEvent(value);
  }
  build() {
    return new ActorEvent(this._value);
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
  setDeprecatedTerm(value) {
    this._value._hasDeprecatedTerm = true;
    this._value._term = value;
    return this;
  }
  deleteDeprecatedTerm() {
    this._value._hasDeprecatedTerm = false;
    this._value._term = null;
    return this;
  }
  setActorTerm(value) {
    this._value._hasActorTerm = true;
    this._value._actorTerm = value;
    return this;
  }
  deleteActorTerm() {
    this._value._hasActorTerm = false;
    this._value._actorTerm = null;
    return this;
  }
  addAllConditions(values) {
    this._value._conditions = this._value._conditions.concat(values);
    return this;
  }
  addConditions(value) {
    this._value._conditions = this._value._conditions.concat([value]);
    return this;
  }
  setConditions(index, value) {
    this._value._conditions = this._value._conditions.concat();
    this._value._conditions[index] = value;
    return this;
  }
  clearConditions() {
    this._value._conditions = [];
    return this;
  }
  addAllActions(values) {
    this._value._actions = this._value._actions.concat(values);
    return this;
  }
  addActions(value) {
    this._value._actions = this._value._actions.concat([value]);
    return this;
  }
  setActions(index, value) {
    this._value._actions = this._value._actions.concat();
    this._value._actions[index] = value;
    return this;
  }
  clearActions() {
    this._value._actions = [];
    return this;
  }
}
ActorEvent.Builder = ActorEvent_Builder;
class ActorEvent_WithParent {
  /**
   * @param {ActorEvent} value
   * @param {ActorEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (this._cachedIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedIndex = this._value.index;
      } else {
        this._cachedIndex = this._parent ? this._parent.index : this._value.index;
      }
    }
    return this._cachedIndex;
  }
  get hasDeprecatedTerm() {
    if (this._cachedHasDeprecatedTerm === undefined) {
      if (this._value.hasDeprecatedTerm) {
        this._cachedHasDeprecatedTerm = true;
      } else {
        this._cachedHasDeprecatedTerm = this._parent ? this._parent.hasDeprecatedTerm : false;
      }
    }
    return this._cachedHasDeprecatedTerm;
  }
  get term() {
    if (this._cachedDeprecatedTerm === undefined) {
      if (this._value.hasDeprecatedTerm) {
        this._cachedDeprecatedTerm = this._value.term;
      } else {
        this._cachedDeprecatedTerm = this._parent ? this._parent.term : this._value.term;
      }
    }
    return this._cachedDeprecatedTerm;
  }
  get hasActorTerm() {
    if (this._cachedHasActorTerm === undefined) {
      if (this._value.hasActorTerm) {
        this._cachedHasActorTerm = true;
      } else {
        this._cachedHasActorTerm = this._parent ? this._parent.hasActorTerm : false;
      }
    }
    return this._cachedHasActorTerm;
  }
  get actorTerm() {
    if (!this._cachedActorTerm) {
      if (this._value.hasActorTerm) {
        this._cachedActorTerm = new ActorTerm.WithParent(this._value.actorTerm, this._parent && this._parent.hasActorTerm ? this._parent.actorTerm : null);
      } else {
        this._cachedActorTerm = this._parent ? new ActorTerm.WithParent(ActorTerm.default, this._parent.actorTerm) : ActorTerm.WithParent.default;
      }
    }
    return this._cachedActorTerm;
  }
  get selfConditions() {
    if (!this._selfConditions) {
      this._selfConditions = [];
      for (let i of this._value.conditions) {
        this._selfConditions.push(new ActorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfConditions;
  }
  get inherentConditions() {
    if (!this._inherentConditions) {
      this._inherentConditions = this._parent ? this._parent.conditions : [];
    }
    return this._inherentConditions;
  }
  get conditions() {
    if (!this._allConditions) {
      this._allConditions = this._parent ? this._parent.conditions.concat(this.selfConditions) : this.selfConditions;
    }
    return this._allConditions;
  }
  get selfActions() {
    if (!this._selfActions) {
      this._selfActions = [];
      for (let i of this._value.actions) {
        this._selfActions.push(new ActorAction.WithParent(i, null));
      }
    }
    return this._selfActions;
  }
  get inherentActions() {
    if (!this._inherentActions) {
      this._inherentActions = this._parent ? this._parent.actions : [];
    }
    return this._inherentActions;
  }
  get actions() {
    if (!this._allActions) {
      this._allActions = this._parent ? this._parent.actions.concat(this.selfActions) : this.selfActions;
    }
    return this._allActions;
  }
  update(current, parent) {
    const result = new ActorEvent_WithParent(current, parent);
    if (this._cachedActorTerm && this._value.hasActorTerm && current.hasActorTerm) {
      if (this._value.actorTerm === current.actorTerm && this._parent === parent) {
        result._cachedActorTerm = this._cachedActorTerm;
      } else {
        result._cachedActorTerm = this._cachedActorTerm.update(current.actorTerm, parent && parent.hasActorTerm ? parent.actorTerm : null);
      }
    }
    if (this._selfConditions) {
      if (this._value.conditions === current.conditions) {
        result._selfConditions = this._selfConditions;
      } else {
        result._selfConditions = [];
        for (let i = 0; i < current.conditions.length; i++) {
          const oldValue = this._value.conditions[i];
          if (oldValue) {
            const oldCache = this._selfConditions[i];
            if (oldValue === current.conditions[i]) {
              result._selfConditions[i] = oldCache;
            } else {
              result._selfConditions[i] = oldCache.update(current.conditions[i], null);
            }
          } else {
            result._selfConditions[i] = new ActorExpressions_Expression.WithParent(current.conditions[i], null);
          }
        }
      }
    }
    if (this._selfActions) {
      if (this._value.actions === current.actions) {
        result._selfActions = this._selfActions;
      } else {
        result._selfActions = [];
        for (let i = 0; i < current.actions.length; i++) {
          const oldValue = this._value.actions[i];
          if (oldValue) {
            const oldCache = this._selfActions[i];
            if (oldValue === current.actions[i]) {
              result._selfActions[i] = oldCache;
            } else {
              result._selfActions[i] = oldCache.update(current.actions[i], null);
            }
          } else {
            result._selfActions[i] = new ActorAction.WithParent(current.actions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorEvent_WithParent.default = new ActorEvent_WithParent(ActorEvent.default, null);
ActorEvent.WithParent = ActorEvent_WithParent;
class ActorEvent_Descriptor {
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 1,
        protoType: 5,
        protoName: "index",
        type: JsonToInt32,
        options: {
          hideInWiki: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get term() {
    if (!this._term) {
      this._term = {
        name: "term",
        Name: "DeprecatedTerm",
        number: 1002,
        protoType: 9,
        protoName: "deprecated_term",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._term;
  }
  get actorTerm() {
    if (!this._actorTerm) {
      this._actorTerm = {
        name: "actorTerm",
        Name: "ActorTerm",
        number: 2,
        protoType: 11,
        protoName: "actor_term",
        type: ActorTerm,
        options: {
          comments: "An actor event can be used multiple times on an actor. When the same event is used more than once, the events are checked in order from top to bottom.",
          wikiName: "Events",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actorTerm;
  }
  get conditions() {
    if (!this._conditions) {
      this._conditions = {
        name: "conditions",
        Name: "Conditions",
        number: 3,
        protoType: 11,
        protoName: "conditions",
        type: ActorExpressions_Expression,
        isRepeated: true,
        options: {
          comments: "Conditions to be met for the actions to be executed. If any of the condition evaulates to 0, the actions will not be executed. Note that the condition will be evaulated in the context of an existing actor. If this event is used to create a new actor (e.g., create a actor when a certain behavior is turned on), the evaulation context will be the root of the actor scope (e.g., the unit actor). If no actor can be found, the conditions are assumed to be met.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._conditions;
  }
  get actions() {
    if (!this._actions) {
      this._actions = {
        name: "actions",
        Name: "Actions",
        number: 4,
        protoType: 11,
        protoName: "actions",
        type: ActorAction,
        isRepeated: true,
        options: {
          comments: "Actions to run in response to an event, after conditions are checked. Actions that target other actors can only be sent to other actors of the same scope.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.index,
        this.term,
        this.actorTerm,
        this.conditions,
        this.actions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedTerm",
        Name: "DummyOneofForDeprecatedTerm",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForActorTerm",
        Name: "DummyOneofForActorTerm",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorEvent.descriptor = new ActorEvent_Descriptor();
export class ActorEventMacro {
  get descriptor() {
    return ActorEventMacro.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._events = [];
    this._hasComment = false;
    this._comment = null;
  }
  isEmpty() {
    if (this._events.length > 0) return false;
    if (this._hasComment) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActorEventMacro) {
      return value;
    }
    return ActorEventMacro.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActorEventMacro();
    result._events = JsonToList(json.events, ActorEvent);
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._events.length > 0) {
      result.events = ArrayToJson(this._events, ActorEvent);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    return result;
  }
  /**
   * @returns {ActorEvent[]}
   */
  get events() {
    return this._events;
  }
  addEvents(path, value) {
    return {type: 'ADD', path: path.concat(['events']), value: value.toJson()};
  }
  setEvents(path, value) {
    return {type: 'SET', path: path.concat(['events']), value: ArrayToJson(value, ActorEvent)};
  }
  setEventsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['events', key]), value: value.toJson()};
  }
  deleteEvents(path) {
    return {type: 'DELETE', path: path.concat(['events'])};
  }
  deleteEventsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['events', key])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "events": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEventMacro(this);
              copy._events = [];        for (let i of value) {
                copy._events.push(ActorEvent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActorEventMacro(this);
              copy._events = copy._events.concat([ActorEvent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._events.length === 0) {
                return this;
              }
              const copy = new ActorEventMacro(this);
              copy._events = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._events.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActorEventMacro(this);
              copy._events = copy._events.slice();
              copy._events[path[1]] = ActorEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActorEventMacro(this);
              copy._events = copy._events.slice(0, path[1]).concat(copy._events.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._events.length) {
            return this;
          }
          const oldValue = this._events[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActorEventMacro(this);
          copy._events = copy._events.slice();
          copy._events[key] = newValue;
          return copy;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActorEventMacro(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new ActorEventMacro(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActorEventMacro} other
   * @returns {ActorEventMacro}
   */
  merge(other) {
    const copy = new ActorEventMacro(this);
    copy._events = this._events.concat(other._events);
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    return copy;
  }
}
ActorEventMacro.default = new ActorEventMacro();
class ActorEventMacro_Builder {
  constructor(value) {
    this._value = new ActorEventMacro(value);
  }
  build() {
    return new ActorEventMacro(this._value);
  }
  addAllEvents(values) {
    this._value._events = this._value._events.concat(values);
    return this;
  }
  addEvents(value) {
    this._value._events = this._value._events.concat([value]);
    return this;
  }
  setEvents(index, value) {
    this._value._events = this._value._events.concat();
    this._value._events[index] = value;
    return this;
  }
  clearEvents() {
    this._value._events = [];
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
}
ActorEventMacro.Builder = ActorEventMacro_Builder;
class ActorEventMacro_WithParent {
  /**
   * @param {ActorEventMacro} value
   * @param {ActorEventMacro_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActorEventMacro.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfEvents() {
    if (!this._selfEvents) {
      this._selfEvents = [];
      for (let i of this._value.events) {
        this._selfEvents.push(new ActorEvent.WithParent(i, null));
      }
    }
    return this._selfEvents;
  }
  get inherentEvents() {
    if (!this._inherentEvents) {
      this._inherentEvents = this._parent ? this._parent.events : [];
    }
    return this._inherentEvents;
  }
  get events() {
    if (!this._allEvents) {
      this._allEvents = this._parent ? this._parent.events.concat(this.selfEvents) : this.selfEvents;
    }
    return this._allEvents;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  update(current, parent) {
    const result = new ActorEventMacro_WithParent(current, parent);
    if (this._selfEvents) {
      if (this._value.events === current.events) {
        result._selfEvents = this._selfEvents;
      } else {
        result._selfEvents = [];
        for (let i = 0; i < current.events.length; i++) {
          const oldValue = this._value.events[i];
          if (oldValue) {
            const oldCache = this._selfEvents[i];
            if (oldValue === current.events[i]) {
              result._selfEvents[i] = oldCache;
            } else {
              result._selfEvents[i] = oldCache.update(current.events[i], null);
            }
          } else {
            result._selfEvents[i] = new ActorEvent.WithParent(current.events[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActorEventMacro_WithParent.default = new ActorEventMacro_WithParent(ActorEventMacro.default, null);
ActorEventMacro.WithParent = ActorEventMacro_WithParent;
class ActorEventMacro_Descriptor {
  get events() {
    if (!this._events) {
      this._events = {
        name: "events",
        Name: "Events",
        number: 1,
        protoType: 11,
        protoName: "events",
        type: ActorEvent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._events;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 2,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.events,
        this.comment,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ActorEventMacro.descriptor = new ActorEventMacro_Descriptor();
class HostSite_Offset {
  get descriptor() {
    return HostSite_Offset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedX = false;
    this._x = null;
    this._hasDeprecatedY = false;
    this._y = null;
    this._hasDeprecatedZ = false;
    this._z = null;
    this._hasForward = false;
    this._forward = null;
    this._hasRight = false;
    this._right = null;
    this._hasUp = false;
    this._up = null;
  }
  isEmpty() {
    if (this._hasDeprecatedX) return false;
    if (this._hasDeprecatedY) return false;
    if (this._hasDeprecatedZ) return false;
    if (this._hasForward) return false;
    if (this._hasRight) return false;
    if (this._hasUp) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof HostSite_Offset) {
      return value;
    }
    return HostSite_Offset.fromJson(value);
  }
  static fromJson(json) {
    const result = new HostSite_Offset();
    if (json.x != null) {
      result._hasDeprecatedX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasDeprecatedY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasDeprecatedZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    if (json.forward != null) {
      result._hasForward = true;
      result._forward = JsonToDouble.fromJson(json.forward);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = JsonToDouble.fromJson(json.right);
    }
    if (json.up != null) {
      result._hasUp = true;
      result._up = JsonToDouble.fromJson(json.up);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasDeprecatedY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasDeprecatedZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    if (this._hasForward) {
      result.forward = JsonToDouble.toJson(this._forward);
    }
    if (this._hasRight) {
      result.right = JsonToDouble.toJson(this._right);
    }
    if (this._hasUp) {
      result.up = JsonToDouble.toJson(this._up);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasDeprecatedX ? this._x : JsonToDouble.default;
  }
  get hasDeprecatedX() {
    return this._hasDeprecatedX;
  }
  setDeprecatedX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteDeprecatedX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasDeprecatedY ? this._y : JsonToDouble.default;
  }
  get hasDeprecatedY() {
    return this._hasDeprecatedY;
  }
  setDeprecatedY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteDeprecatedY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasDeprecatedZ ? this._z : JsonToDouble.default;
  }
  get hasDeprecatedZ() {
    return this._hasDeprecatedZ;
  }
  setDeprecatedZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteDeprecatedZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  /**
   * @returns {number}
   */
  get forward() {
    return this._hasForward ? this._forward : JsonToDouble.default;
  }
  get hasForward() {
    return this._hasForward;
  }
  setForward(path, value) {
    return {type: 'SET', path: path.concat(['forward']), value};
  }
  deleteForward(path) {
    return {type: 'DELETE', path: path.concat(['forward'])};
  }
  /**
   * @returns {number}
   */
  get right() {
    return this._hasRight ? this._right : JsonToDouble.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  /**
   * @returns {number}
   */
  get up() {
    return this._hasUp ? this._up : JsonToDouble.default;
  }
  get hasUp() {
    return this._hasUp;
  }
  setUp(path, value) {
    return {type: 'SET', path: path.concat(['up']), value};
  }
  deleteUp(path) {
    return {type: 'DELETE', path: path.concat(['up'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite_Offset(this);
              copy._hasDeprecatedX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedX) {
                return this;
              }
              const copy = new HostSite_Offset(this);
              copy._hasDeprecatedX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite_Offset(this);
              copy._hasDeprecatedY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedY) {
                return this;
              }
              const copy = new HostSite_Offset(this);
              copy._hasDeprecatedY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite_Offset(this);
              copy._hasDeprecatedZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedZ) {
                return this;
              }
              const copy = new HostSite_Offset(this);
              copy._hasDeprecatedZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "forward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite_Offset(this);
              copy._hasForward = true;
              copy._forward = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForward) {
                return this;
              }
              const copy = new HostSite_Offset(this);
              copy._hasForward = false;
              copy._forward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite_Offset(this);
              copy._hasRight = true;
              copy._right = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new HostSite_Offset(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "up": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite_Offset(this);
              copy._hasUp = true;
              copy._up = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUp) {
                return this;
              }
              const copy = new HostSite_Offset(this);
              copy._hasUp = false;
              copy._up = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {HostSite_Offset} other
   * @returns {HostSite_Offset}
   */
  merge(other) {
    const copy = new HostSite_Offset(this);
    if (other._hasDeprecatedX) {
      copy._hasDeprecatedX = true;
      copy._x = other._x;
    }
    if (other._hasDeprecatedY) {
      copy._hasDeprecatedY = true;
      copy._y = other._y;
    }
    if (other._hasDeprecatedZ) {
      copy._hasDeprecatedZ = true;
      copy._z = other._z;
    }
    if (other._hasForward) {
      copy._hasForward = true;
      copy._forward = other._forward;
    }
    if (other._hasRight) {
      copy._hasRight = true;
      copy._right = other._right;
    }
    if (other._hasUp) {
      copy._hasUp = true;
      copy._up = other._up;
    }
    return copy;
  }
}
HostSite_Offset.default = new HostSite_Offset();
class HostSite_Offset_Builder {
  constructor(value) {
    this._value = new HostSite_Offset(value);
  }
  build() {
    return new HostSite_Offset(this._value);
  }
  setDeprecatedX(value) {
    this._value._hasDeprecatedX = true;
    this._value._x = value;
    return this;
  }
  deleteDeprecatedX() {
    this._value._hasDeprecatedX = false;
    this._value._x = null;
    return this;
  }
  setDeprecatedY(value) {
    this._value._hasDeprecatedY = true;
    this._value._y = value;
    return this;
  }
  deleteDeprecatedY() {
    this._value._hasDeprecatedY = false;
    this._value._y = null;
    return this;
  }
  setDeprecatedZ(value) {
    this._value._hasDeprecatedZ = true;
    this._value._z = value;
    return this;
  }
  deleteDeprecatedZ() {
    this._value._hasDeprecatedZ = false;
    this._value._z = null;
    return this;
  }
  setForward(value) {
    this._value._hasForward = true;
    this._value._forward = value;
    return this;
  }
  deleteForward() {
    this._value._hasForward = false;
    this._value._forward = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
  setUp(value) {
    this._value._hasUp = true;
    this._value._up = value;
    return this;
  }
  deleteUp() {
    this._value._hasUp = false;
    this._value._up = null;
    return this;
  }
}
HostSite_Offset.Builder = HostSite_Offset_Builder;
class HostSite_Offset_WithParent {
  /**
   * @param {HostSite_Offset} value
   * @param {HostSite_Offset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return HostSite_Offset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedX() {
    if (this._cachedHasDeprecatedX === undefined) {
      if (this._value.hasDeprecatedX) {
        this._cachedHasDeprecatedX = true;
      } else {
        this._cachedHasDeprecatedX = this._parent ? this._parent.hasDeprecatedX : false;
      }
    }
    return this._cachedHasDeprecatedX;
  }
  get x() {
    if (this._cachedDeprecatedX === undefined) {
      if (this._value.hasDeprecatedX) {
        this._cachedDeprecatedX = this._value.x;
      } else {
        this._cachedDeprecatedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedDeprecatedX;
  }
  get hasDeprecatedY() {
    if (this._cachedHasDeprecatedY === undefined) {
      if (this._value.hasDeprecatedY) {
        this._cachedHasDeprecatedY = true;
      } else {
        this._cachedHasDeprecatedY = this._parent ? this._parent.hasDeprecatedY : false;
      }
    }
    return this._cachedHasDeprecatedY;
  }
  get y() {
    if (this._cachedDeprecatedY === undefined) {
      if (this._value.hasDeprecatedY) {
        this._cachedDeprecatedY = this._value.y;
      } else {
        this._cachedDeprecatedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedDeprecatedY;
  }
  get hasDeprecatedZ() {
    if (this._cachedHasDeprecatedZ === undefined) {
      if (this._value.hasDeprecatedZ) {
        this._cachedHasDeprecatedZ = true;
      } else {
        this._cachedHasDeprecatedZ = this._parent ? this._parent.hasDeprecatedZ : false;
      }
    }
    return this._cachedHasDeprecatedZ;
  }
  get z() {
    if (this._cachedDeprecatedZ === undefined) {
      if (this._value.hasDeprecatedZ) {
        this._cachedDeprecatedZ = this._value.z;
      } else {
        this._cachedDeprecatedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedDeprecatedZ;
  }
  get hasForward() {
    if (this._cachedHasForward === undefined) {
      if (this._value.hasForward) {
        this._cachedHasForward = true;
      } else {
        this._cachedHasForward = this._parent ? this._parent.hasForward : false;
      }
    }
    return this._cachedHasForward;
  }
  get forward() {
    if (this._cachedForward === undefined) {
      if (this._value.hasForward) {
        this._cachedForward = this._value.forward;
      } else {
        this._cachedForward = this._parent ? this._parent.forward : this._value.forward;
      }
    }
    return this._cachedForward;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (this._cachedRight === undefined) {
      if (this._value.hasRight) {
        this._cachedRight = this._value.right;
      } else {
        this._cachedRight = this._parent ? this._parent.right : this._value.right;
      }
    }
    return this._cachedRight;
  }
  get hasUp() {
    if (this._cachedHasUp === undefined) {
      if (this._value.hasUp) {
        this._cachedHasUp = true;
      } else {
        this._cachedHasUp = this._parent ? this._parent.hasUp : false;
      }
    }
    return this._cachedHasUp;
  }
  get up() {
    if (this._cachedUp === undefined) {
      if (this._value.hasUp) {
        this._cachedUp = this._value.up;
      } else {
        this._cachedUp = this._parent ? this._parent.up : this._value.up;
      }
    }
    return this._cachedUp;
  }
  update(current, parent) {
    const result = new HostSite_Offset_WithParent(current, parent);
    return result;
  }
}
HostSite_Offset_WithParent.default = new HostSite_Offset_WithParent(HostSite_Offset.default, null);
HostSite_Offset.WithParent = HostSite_Offset_WithParent;
class HostSite_Offset_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "DeprecatedX",
        number: 1001,
        protoType: 1,
        protoName: "deprecated_x",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "DeprecatedY",
        number: 1002,
        protoType: 1,
        protoName: "deprecated_y",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "DeprecatedZ",
        number: 1003,
        protoType: 1,
        protoName: "deprecated_z",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get forward() {
    if (!this._forward) {
      this._forward = {
        name: "forward",
        Name: "Forward",
        number: 1,
        protoType: 1,
        protoName: "forward",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forward;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 1,
        protoName: "right",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get up() {
    if (!this._up) {
      this._up = {
        name: "up",
        Name: "Up",
        number: 3,
        protoType: 1,
        protoName: "up",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._up;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
        this.forward,
        this.right,
        this.up,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedX",
        Name: "DummyOneofForDeprecatedX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedY",
        Name: "DummyOneofForDeprecatedY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedZ",
        Name: "DummyOneofForDeprecatedZ",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForForward",
        Name: "DummyOneofForForward",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUp",
        Name: "DummyOneofForUp",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
HostSite_Offset.descriptor = new HostSite_Offset_Descriptor();
export class HostSite {
  get descriptor() {
    return HostSite.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOffset = false;
    this._offset = null;
  }
  isEmpty() {
    if (this._hasOffset && !this._offset.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof HostSite) {
      return value;
    }
    return HostSite.fromJson(value);
  }
  static fromJson(json) {
    const result = new HostSite();
    if (json.offset != null) {
      result._hasOffset = true;
      result._offset = HostSite_Offset.fromJson(json.offset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOffset && !this._offset.isEmpty()) {
      result.offset = HostSite_Offset.toJson(this._offset);
    }
    return result;
  }
  /**
   * @returns {HostSite_Offset}
   */
  get offset() {
    return this._hasOffset ? this._offset : HostSite_Offset.default;
  }
  get hasOffset() {
    return this._hasOffset;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HostSite(this);
              copy._hasOffset = true;
              copy._offset = HostSite_Offset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffset) {
                return this;
              }
              const copy = new HostSite(this);
              copy._hasOffset = false;
              copy._offset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOffset) {
            const copy = new HostSite(this);
            copy._hasOffset = true;
            copy._offset = HostSite_Offset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._offset.apply(type, path.slice(1), value);
          if (newValue === this._offset) {
            return this;
          }
          const copy = new HostSite(this);
          copy._offset = copy._offset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {HostSite} other
   * @returns {HostSite}
   */
  merge(other) {
    const copy = new HostSite(this);
    if (other._hasOffset) {
      if (copy._hasOffset) {
        copy._offset = copy.offset.merge(other.offset);
      } else {
        copy._offset = other._offset;
      }
      copy._hasOffset = true;
    }
    return copy;
  }
}
HostSite.default = new HostSite();
HostSite.Offset = HostSite_Offset;
class HostSite_Builder {
  constructor(value) {
    this._value = new HostSite(value);
  }
  build() {
    return new HostSite(this._value);
  }
  setOffset(value) {
    this._value._hasOffset = true;
    this._value._offset = value;
    return this;
  }
  deleteOffset() {
    this._value._hasOffset = false;
    this._value._offset = null;
    return this;
  }
}
HostSite.Builder = HostSite_Builder;
class HostSite_WithParent {
  /**
   * @param {HostSite} value
   * @param {HostSite_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return HostSite.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOffset() {
    if (this._cachedHasOffset === undefined) {
      if (this._value.hasOffset) {
        this._cachedHasOffset = true;
      } else {
        this._cachedHasOffset = this._parent ? this._parent.hasOffset : false;
      }
    }
    return this._cachedHasOffset;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value.hasOffset) {
        this._cachedOffset = new HostSite_Offset.WithParent(this._value.offset, this._parent && this._parent.hasOffset ? this._parent.offset : null);
      } else {
        this._cachedOffset = this._parent ? new HostSite_Offset.WithParent(HostSite_Offset.default, this._parent.offset) : HostSite_Offset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  update(current, parent) {
    const result = new HostSite_WithParent(current, parent);
    if (this._cachedOffset && this._value.hasOffset && current.hasOffset) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.hasOffset ? parent.offset : null);
      }
    }
    return result;
  }
}
HostSite_WithParent.default = new HostSite_WithParent(HostSite.default, null);
HostSite.WithParent = HostSite_WithParent;
class HostSite_Descriptor {
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 1,
        protoType: 11,
        protoName: "offset",
        type: HostSite_Offset,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.offset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofHostSiteType",
        Name: "OneofHostSiteType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
HostSite.descriptor = new HostSite_Descriptor();
export class SpriteOptions {
  get descriptor() {
    return SpriteOptions.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDisableCameraFacing = false;
    this._disableCameraFacing = null;
    this._hasCenterSpriteAnchor = false;
    this._centerSpriteAnchor = null;
    this._hasFlipX = false;
    this._flipX = null;
    this._hasFlipY = false;
    this._flipY = null;
    this._hasRenderingPriority = false;
    this._renderingPriority = null;
  }
  isEmpty() {
    if (this._hasDisableCameraFacing) return false;
    if (this._hasCenterSpriteAnchor) return false;
    if (this._hasFlipX) return false;
    if (this._hasFlipY) return false;
    if (this._hasRenderingPriority) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SpriteOptions) {
      return value;
    }
    return SpriteOptions.fromJson(value);
  }
  static fromJson(json) {
    const result = new SpriteOptions();
    if (json.disableCameraFacing != null) {
      result._hasDisableCameraFacing = true;
      result._disableCameraFacing = JsonToBoolean.fromJson(json.disableCameraFacing);
    }
    if (json.centerSpriteAnchor != null) {
      result._hasCenterSpriteAnchor = true;
      result._centerSpriteAnchor = JsonToBoolean.fromJson(json.centerSpriteAnchor);
    }
    if (json.flipX != null) {
      result._hasFlipX = true;
      result._flipX = JsonToBoolean.fromJson(json.flipX);
    }
    if (json.flipY != null) {
      result._hasFlipY = true;
      result._flipY = JsonToBoolean.fromJson(json.flipY);
    }
    if (json.renderingPriority != null) {
      result._hasRenderingPriority = true;
      result._renderingPriority = JsonToInt32.fromJson(json.renderingPriority);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDisableCameraFacing) {
      result.disableCameraFacing = JsonToBoolean.toJson(this._disableCameraFacing);
    }
    if (this._hasCenterSpriteAnchor) {
      result.centerSpriteAnchor = JsonToBoolean.toJson(this._centerSpriteAnchor);
    }
    if (this._hasFlipX) {
      result.flipX = JsonToBoolean.toJson(this._flipX);
    }
    if (this._hasFlipY) {
      result.flipY = JsonToBoolean.toJson(this._flipY);
    }
    if (this._hasRenderingPriority) {
      result.renderingPriority = JsonToInt32.toJson(this._renderingPriority);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get disableCameraFacing() {
    return this._hasDisableCameraFacing ? this._disableCameraFacing : JsonToBoolean.default;
  }
  get hasDisableCameraFacing() {
    return this._hasDisableCameraFacing;
  }
  setDisableCameraFacing(path, value) {
    return {type: 'SET', path: path.concat(['disableCameraFacing']), value};
  }
  deleteDisableCameraFacing(path) {
    return {type: 'DELETE', path: path.concat(['disableCameraFacing'])};
  }
  /**
   * @returns {boolean}
   */
  get centerSpriteAnchor() {
    return this._hasCenterSpriteAnchor ? this._centerSpriteAnchor : JsonToBoolean.default;
  }
  get hasCenterSpriteAnchor() {
    return this._hasCenterSpriteAnchor;
  }
  setCenterSpriteAnchor(path, value) {
    return {type: 'SET', path: path.concat(['centerSpriteAnchor']), value};
  }
  deleteCenterSpriteAnchor(path) {
    return {type: 'DELETE', path: path.concat(['centerSpriteAnchor'])};
  }
  /**
   * @returns {boolean}
   */
  get flipX() {
    return this._hasFlipX ? this._flipX : JsonToBoolean.default;
  }
  get hasFlipX() {
    return this._hasFlipX;
  }
  setFlipX(path, value) {
    return {type: 'SET', path: path.concat(['flipX']), value};
  }
  deleteFlipX(path) {
    return {type: 'DELETE', path: path.concat(['flipX'])};
  }
  /**
   * @returns {boolean}
   */
  get flipY() {
    return this._hasFlipY ? this._flipY : JsonToBoolean.default;
  }
  get hasFlipY() {
    return this._hasFlipY;
  }
  setFlipY(path, value) {
    return {type: 'SET', path: path.concat(['flipY']), value};
  }
  deleteFlipY(path) {
    return {type: 'DELETE', path: path.concat(['flipY'])};
  }
  /**
   * @returns {number}
   */
  get renderingPriority() {
    return this._hasRenderingPriority ? this._renderingPriority : JsonToInt32.default;
  }
  get hasRenderingPriority() {
    return this._hasRenderingPriority;
  }
  setRenderingPriority(path, value) {
    return {type: 'SET', path: path.concat(['renderingPriority']), value};
  }
  deleteRenderingPriority(path) {
    return {type: 'DELETE', path: path.concat(['renderingPriority'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "disableCameraFacing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpriteOptions(this);
              copy._hasDisableCameraFacing = true;
              copy._disableCameraFacing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableCameraFacing) {
                return this;
              }
              const copy = new SpriteOptions(this);
              copy._hasDisableCameraFacing = false;
              copy._disableCameraFacing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "centerSpriteAnchor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpriteOptions(this);
              copy._hasCenterSpriteAnchor = true;
              copy._centerSpriteAnchor = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCenterSpriteAnchor) {
                return this;
              }
              const copy = new SpriteOptions(this);
              copy._hasCenterSpriteAnchor = false;
              copy._centerSpriteAnchor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "flipX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpriteOptions(this);
              copy._hasFlipX = true;
              copy._flipX = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlipX) {
                return this;
              }
              const copy = new SpriteOptions(this);
              copy._hasFlipX = false;
              copy._flipX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "flipY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpriteOptions(this);
              copy._hasFlipY = true;
              copy._flipY = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlipY) {
                return this;
              }
              const copy = new SpriteOptions(this);
              copy._hasFlipY = false;
              copy._flipY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "renderingPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SpriteOptions(this);
              copy._hasRenderingPriority = true;
              copy._renderingPriority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRenderingPriority) {
                return this;
              }
              const copy = new SpriteOptions(this);
              copy._hasRenderingPriority = false;
              copy._renderingPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SpriteOptions} other
   * @returns {SpriteOptions}
   */
  merge(other) {
    const copy = new SpriteOptions(this);
    if (other._hasDisableCameraFacing) {
      copy._hasDisableCameraFacing = true;
      copy._disableCameraFacing = other._disableCameraFacing;
    }
    if (other._hasCenterSpriteAnchor) {
      copy._hasCenterSpriteAnchor = true;
      copy._centerSpriteAnchor = other._centerSpriteAnchor;
    }
    if (other._hasFlipX) {
      copy._hasFlipX = true;
      copy._flipX = other._flipX;
    }
    if (other._hasFlipY) {
      copy._hasFlipY = true;
      copy._flipY = other._flipY;
    }
    if (other._hasRenderingPriority) {
      copy._hasRenderingPriority = true;
      copy._renderingPriority = other._renderingPriority;
    }
    return copy;
  }
}
SpriteOptions.default = new SpriteOptions();
class SpriteOptions_Builder {
  constructor(value) {
    this._value = new SpriteOptions(value);
  }
  build() {
    return new SpriteOptions(this._value);
  }
  setDisableCameraFacing(value) {
    this._value._hasDisableCameraFacing = true;
    this._value._disableCameraFacing = value;
    return this;
  }
  deleteDisableCameraFacing() {
    this._value._hasDisableCameraFacing = false;
    this._value._disableCameraFacing = null;
    return this;
  }
  setCenterSpriteAnchor(value) {
    this._value._hasCenterSpriteAnchor = true;
    this._value._centerSpriteAnchor = value;
    return this;
  }
  deleteCenterSpriteAnchor() {
    this._value._hasCenterSpriteAnchor = false;
    this._value._centerSpriteAnchor = null;
    return this;
  }
  setFlipX(value) {
    this._value._hasFlipX = true;
    this._value._flipX = value;
    return this;
  }
  deleteFlipX() {
    this._value._hasFlipX = false;
    this._value._flipX = null;
    return this;
  }
  setFlipY(value) {
    this._value._hasFlipY = true;
    this._value._flipY = value;
    return this;
  }
  deleteFlipY() {
    this._value._hasFlipY = false;
    this._value._flipY = null;
    return this;
  }
  setRenderingPriority(value) {
    this._value._hasRenderingPriority = true;
    this._value._renderingPriority = value;
    return this;
  }
  deleteRenderingPriority() {
    this._value._hasRenderingPriority = false;
    this._value._renderingPriority = null;
    return this;
  }
}
SpriteOptions.Builder = SpriteOptions_Builder;
class SpriteOptions_WithParent {
  /**
   * @param {SpriteOptions} value
   * @param {SpriteOptions_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SpriteOptions.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDisableCameraFacing() {
    if (this._cachedHasDisableCameraFacing === undefined) {
      if (this._value.hasDisableCameraFacing) {
        this._cachedHasDisableCameraFacing = true;
      } else {
        this._cachedHasDisableCameraFacing = this._parent ? this._parent.hasDisableCameraFacing : false;
      }
    }
    return this._cachedHasDisableCameraFacing;
  }
  get disableCameraFacing() {
    if (this._cachedDisableCameraFacing === undefined) {
      if (this._value.hasDisableCameraFacing) {
        this._cachedDisableCameraFacing = this._value.disableCameraFacing;
      } else {
        this._cachedDisableCameraFacing = this._parent ? this._parent.disableCameraFacing : this._value.disableCameraFacing;
      }
    }
    return this._cachedDisableCameraFacing;
  }
  get hasCenterSpriteAnchor() {
    if (this._cachedHasCenterSpriteAnchor === undefined) {
      if (this._value.hasCenterSpriteAnchor) {
        this._cachedHasCenterSpriteAnchor = true;
      } else {
        this._cachedHasCenterSpriteAnchor = this._parent ? this._parent.hasCenterSpriteAnchor : false;
      }
    }
    return this._cachedHasCenterSpriteAnchor;
  }
  get centerSpriteAnchor() {
    if (this._cachedCenterSpriteAnchor === undefined) {
      if (this._value.hasCenterSpriteAnchor) {
        this._cachedCenterSpriteAnchor = this._value.centerSpriteAnchor;
      } else {
        this._cachedCenterSpriteAnchor = this._parent ? this._parent.centerSpriteAnchor : this._value.centerSpriteAnchor;
      }
    }
    return this._cachedCenterSpriteAnchor;
  }
  get hasFlipX() {
    if (this._cachedHasFlipX === undefined) {
      if (this._value.hasFlipX) {
        this._cachedHasFlipX = true;
      } else {
        this._cachedHasFlipX = this._parent ? this._parent.hasFlipX : false;
      }
    }
    return this._cachedHasFlipX;
  }
  get flipX() {
    if (this._cachedFlipX === undefined) {
      if (this._value.hasFlipX) {
        this._cachedFlipX = this._value.flipX;
      } else {
        this._cachedFlipX = this._parent ? this._parent.flipX : this._value.flipX;
      }
    }
    return this._cachedFlipX;
  }
  get hasFlipY() {
    if (this._cachedHasFlipY === undefined) {
      if (this._value.hasFlipY) {
        this._cachedHasFlipY = true;
      } else {
        this._cachedHasFlipY = this._parent ? this._parent.hasFlipY : false;
      }
    }
    return this._cachedHasFlipY;
  }
  get flipY() {
    if (this._cachedFlipY === undefined) {
      if (this._value.hasFlipY) {
        this._cachedFlipY = this._value.flipY;
      } else {
        this._cachedFlipY = this._parent ? this._parent.flipY : this._value.flipY;
      }
    }
    return this._cachedFlipY;
  }
  get hasRenderingPriority() {
    if (this._cachedHasRenderingPriority === undefined) {
      if (this._value.hasRenderingPriority) {
        this._cachedHasRenderingPriority = true;
      } else {
        this._cachedHasRenderingPriority = this._parent ? this._parent.hasRenderingPriority : false;
      }
    }
    return this._cachedHasRenderingPriority;
  }
  get renderingPriority() {
    if (this._cachedRenderingPriority === undefined) {
      if (this._value.hasRenderingPriority) {
        this._cachedRenderingPriority = this._value.renderingPriority;
      } else {
        this._cachedRenderingPriority = this._parent ? this._parent.renderingPriority : this._value.renderingPriority;
      }
    }
    return this._cachedRenderingPriority;
  }
  update(current, parent) {
    const result = new SpriteOptions_WithParent(current, parent);
    return result;
  }
}
SpriteOptions_WithParent.default = new SpriteOptions_WithParent(SpriteOptions.default, null);
SpriteOptions.WithParent = SpriteOptions_WithParent;
class SpriteOptions_Descriptor {
  get disableCameraFacing() {
    if (!this._disableCameraFacing) {
      this._disableCameraFacing = {
        name: "disableCameraFacing",
        Name: "DisableCameraFacing",
        number: 1,
        protoType: 8,
        protoName: "disable_camera_facing",
        type: JsonToBoolean,
        options: {
          comments: "Set actor with sprite asset not billboard facing camera, default sprite will keep facing camera",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableCameraFacing;
  }
  get centerSpriteAnchor() {
    if (!this._centerSpriteAnchor) {
      this._centerSpriteAnchor = {
        name: "centerSpriteAnchor",
        Name: "CenterSpriteAnchor",
        number: 2,
        protoType: 8,
        protoName: "center_sprite_anchor",
        type: JsonToBoolean,
        options: {
          comments: "Set actor with sprite asset anchor to center, default will be bottom of the sprite",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._centerSpriteAnchor;
  }
  get flipX() {
    if (!this._flipX) {
      this._flipX = {
        name: "flipX",
        Name: "FlipX",
        number: 3,
        protoType: 8,
        protoName: "flip_x",
        type: JsonToBoolean,
        options: {
          comments: "If checked, flips the sprite horizontally.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flipX;
  }
  get flipY() {
    if (!this._flipY) {
      this._flipY = {
        name: "flipY",
        Name: "FlipY",
        number: 4,
        protoType: 8,
        protoName: "flip_y",
        type: JsonToBoolean,
        options: {
          comments: "If checked, flips the sprite vertically.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flipY;
  }
  get renderingPriority() {
    if (!this._renderingPriority) {
      this._renderingPriority = {
        name: "renderingPriority",
        Name: "RenderingPriority",
        number: 5,
        protoType: 5,
        protoName: "rendering_priority",
        type: JsonToInt32,
        options: {
          comments: "Sets the sprite\'s rendering priority. Values greater than 50 will render above 3D models.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._renderingPriority;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.disableCameraFacing,
        this.centerSpriteAnchor,
        this.flipX,
        this.flipY,
        this.renderingPriority,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisableCameraFacing",
        Name: "DummyOneofForDisableCameraFacing",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCenterSpriteAnchor",
        Name: "DummyOneofForCenterSpriteAnchor",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFlipX",
        Name: "DummyOneofForFlipX",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFlipY",
        Name: "DummyOneofForFlipY",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRenderingPriority",
        Name: "DummyOneofForRenderingPriority",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
SpriteOptions.descriptor = new SpriteOptions_Descriptor();
class UnitActor_SelectionScale {
  get descriptor() {
    return UnitActor_SelectionScale.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitActor_SelectionScale) {
      return value;
    }
    return UnitActor_SelectionScale.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitActor_SelectionScale();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor_SelectionScale(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new UnitActor_SelectionScale(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor_SelectionScale(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new UnitActor_SelectionScale(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor_SelectionScale(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new UnitActor_SelectionScale(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitActor_SelectionScale} other
   * @returns {UnitActor_SelectionScale}
   */
  merge(other) {
    const copy = new UnitActor_SelectionScale(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    return copy;
  }
}
UnitActor_SelectionScale.default = new UnitActor_SelectionScale();
class UnitActor_SelectionScale_Builder {
  constructor(value) {
    this._value = new UnitActor_SelectionScale(value);
  }
  build() {
    return new UnitActor_SelectionScale(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
}
UnitActor_SelectionScale.Builder = UnitActor_SelectionScale_Builder;
class UnitActor_SelectionScale_WithParent {
  /**
   * @param {UnitActor_SelectionScale} value
   * @param {UnitActor_SelectionScale_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitActor_SelectionScale.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  update(current, parent) {
    const result = new UnitActor_SelectionScale_WithParent(current, parent);
    return result;
  }
}
UnitActor_SelectionScale_WithParent.default = new UnitActor_SelectionScale_WithParent(UnitActor_SelectionScale.default, null);
UnitActor_SelectionScale.WithParent = UnitActor_SelectionScale_WithParent;
class UnitActor_SelectionScale_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitActor_SelectionScale.descriptor = new UnitActor_SelectionScale_Descriptor();
class UnitActor_HostSitesEntry {
  get descriptor() {
    return UnitActor_HostSitesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitActor_HostSitesEntry) {
      return value;
    }
    return UnitActor_HostSitesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitActor_HostSitesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = HostSite.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = HostSite.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {HostSite}
   */
  get value() {
    return this._hasValue ? this._value : HostSite.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor_HostSitesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UnitActor_HostSitesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor_HostSitesEntry(this);
              copy._hasValue = true;
              copy._value = HostSite.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UnitActor_HostSitesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UnitActor_HostSitesEntry(this);
            copy._hasValue = true;
            copy._value = HostSite.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UnitActor_HostSitesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitActor_HostSitesEntry} other
   * @returns {UnitActor_HostSitesEntry}
   */
  merge(other) {
    const copy = new UnitActor_HostSitesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UnitActor_HostSitesEntry.default = new UnitActor_HostSitesEntry();
class UnitActor_HostSitesEntry_Builder {
  constructor(value) {
    this._value = new UnitActor_HostSitesEntry(value);
  }
  build() {
    return new UnitActor_HostSitesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UnitActor_HostSitesEntry.Builder = UnitActor_HostSitesEntry_Builder;
class UnitActor_HostSitesEntry_WithParent {
  /**
   * @param {UnitActor_HostSitesEntry} value
   * @param {UnitActor_HostSitesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitActor_HostSitesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new HostSite.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new HostSite.WithParent(HostSite.default, this._parent.value) : HostSite.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UnitActor_HostSitesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UnitActor_HostSitesEntry_WithParent.default = new UnitActor_HostSitesEntry_WithParent(UnitActor_HostSitesEntry.default, null);
UnitActor_HostSitesEntry.WithParent = UnitActor_HostSitesEntry_WithParent;
class UnitActor_HostSitesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: HostSite,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UnitActor_HostSitesEntry.descriptor = new UnitActor_HostSitesEntry_Descriptor();
class UnitActor_SelectionShape {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "SPHERE": return 0;
        case "CUBE": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return UnitActor_SelectionShape.fromJson(value);
  }
  static fromReact(e) {
    return UnitActor_SelectionShape.fromJson(e);
  }
}
UnitActor_SelectionShape.SPHERE = 0;
UnitActor_SelectionShape.CUBE = 1;
UnitActor_SelectionShape.default = 0;
UnitActor_SelectionShape.values = {
  SPHERE: 0,
  CUBE: 1,
};
UnitActor_SelectionShape.names = {
  0: "SPHERE",
  1: "CUBE",
};
export class UnitActor {
  get descriptor() {
    return UnitActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedUnit = false;
    this._unit = null;
    this._hasResource = false;
    this._resource = null;
    this._hasPreserveOnUnitRemove = false;
    this._preserveOnUnitRemove = null;
    this._events = [];
    this._eventMacros = [];
    this._hostSites = {};
    this._hasWalkAnimationSpeed = false;
    this._walkAnimationSpeed = null;
    this._hasModelScale = false;
    this._modelScale = null;
    this._hostSiteOperations = [];
    this._hasSelectionBonusRadius = false;
    this._selectionBonusRadius = null;
    this._hasExcludeFromUnitBody = false;
    this._unselectable = null;
    this._hasSelectionShape = false;
    this._selectionShape = null;
    this._hasSelectionScale = false;
    this._selectionScale = null;
    this._aliases = [];
    this._hasHideShadow = false;
    this._hideShadow = null;
    this._hasScaleMultiplier = false;
    this._scaleMultiplier = null;
    this._hasRenderingPriority = false;
    this._renderingPriority = null;
    this._hasSpriteOptions = false;
    this._spriteOptions = null;
  }
  isEmpty() {
    if (this._hasDeprecatedUnit) return false;
    if (this._hasResource && !this._resource.isEmpty()) return false;
    if (this._hasPreserveOnUnitRemove) return false;
    if (this._events.length > 0) return false;
    if (this._eventMacros.length > 0) return false;
    if (Object.keys(this._hostSites).length > 0) return false;
    if (this._hasWalkAnimationSpeed) return false;
    if (this._hasModelScale) return false;
    if (this._hostSiteOperations.length > 0) return false;
    if (this._hasSelectionBonusRadius) return false;
    if (this._hasExcludeFromUnitBody) return false;
    if (this._hasSelectionShape) return false;
    if (this._hasSelectionScale && !this._selectionScale.isEmpty()) return false;
    if (this._aliases.length > 0) return false;
    if (this._hasHideShadow) return false;
    if (this._hasScaleMultiplier && !this._scaleMultiplier.isEmpty()) return false;
    if (this._hasRenderingPriority) return false;
    if (this._hasSpriteOptions && !this._spriteOptions.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitActor) {
      return value;
    }
    return UnitActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitActor();
    if (json.unit != null) {
      result._hasDeprecatedUnit = true;
      result._unit = JsonToString.fromJson(json.unit);
    }
    if (json.resource != null) {
      result._hasResource = true;
      result._resource = ActorResource.fromJson(json.resource);
    }
    if (json.preserveOnUnitRemove != null) {
      result._hasPreserveOnUnitRemove = true;
      result._preserveOnUnitRemove = JsonToBoolean.fromJson(json.preserveOnUnitRemove);
    }
    result._events = JsonToList(json.events, ActorEvent);
    result._eventMacros = JsonToList(json.eventMacros, JsonToString);
    result._hostSites = JsonToMap(json.hostSites, JsonToString, HostSite);
    if (json.walkAnimationSpeed != null) {
      result._hasWalkAnimationSpeed = true;
      result._walkAnimationSpeed = JsonToDouble.fromJson(json.walkAnimationSpeed);
    }
    if (json.modelScale != null) {
      result._hasModelScale = true;
      result._modelScale = JsonToDouble.fromJson(json.modelScale);
    }
    result._hostSiteOperations = JsonToList(json.hostSiteOperations, JsonToString);
    if (json.selectionBonusRadius != null) {
      result._hasSelectionBonusRadius = true;
      result._selectionBonusRadius = JsonToDouble.fromJson(json.selectionBonusRadius);
    }
    if (json.unselectable != null) {
      result._hasExcludeFromUnitBody = true;
      result._unselectable = JsonToBoolean.fromJson(json.unselectable);
    }
    if (json.selectionShape != null) {
      result._hasSelectionShape = true;
      result._selectionShape = UnitActor_SelectionShape.fromJson(json.selectionShape);
    }
    if (json.selectionScale != null) {
      result._hasSelectionScale = true;
      result._selectionScale = UnitActor_SelectionScale.fromJson(json.selectionScale);
    }
    result._aliases = JsonToList(json.aliases, JsonToString);
    if (json.hideShadow != null) {
      result._hasHideShadow = true;
      result._hideShadow = JsonToBoolean.fromJson(json.hideShadow);
    }
    if (json.scaleMultiplier != null) {
      result._hasScaleMultiplier = true;
      result._scaleMultiplier = InitialScale.fromJson(json.scaleMultiplier);
    }
    if (json.renderingPriority != null) {
      result._hasRenderingPriority = true;
      result._renderingPriority = JsonToInt32.fromJson(json.renderingPriority);
    }
    if (json.spriteOptions != null) {
      result._hasSpriteOptions = true;
      result._spriteOptions = SpriteOptions.fromJson(json.spriteOptions);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedUnit) {
      result.unit = JsonToString.toJson(this._unit);
    }
    if (this._hasResource && !this._resource.isEmpty()) {
      result.resource = ActorResource.toJson(this._resource);
    }
    if (this._hasPreserveOnUnitRemove) {
      result.preserveOnUnitRemove = JsonToBoolean.toJson(this._preserveOnUnitRemove);
    }
    if (this._events.length > 0) {
      result.events = ArrayToJson(this._events, ActorEvent);
    }
    if (this._eventMacros.length > 0) {
      result.eventMacros = ArrayToJson(this._eventMacros, JsonToString);
    }
    if (Object.keys(this._hostSites).length > 0) {
      result.hostSites = MapToJson(this._hostSites, JsonToString, HostSite);
    }
    if (this._hasWalkAnimationSpeed) {
      result.walkAnimationSpeed = JsonToDouble.toJson(this._walkAnimationSpeed);
    }
    if (this._hasModelScale) {
      result.modelScale = JsonToDouble.toJson(this._modelScale);
    }
    if (this._hostSiteOperations.length > 0) {
      result.hostSiteOperations = ArrayToJson(this._hostSiteOperations, JsonToString);
    }
    if (this._hasSelectionBonusRadius) {
      result.selectionBonusRadius = JsonToDouble.toJson(this._selectionBonusRadius);
    }
    if (this._hasExcludeFromUnitBody) {
      result.unselectable = JsonToBoolean.toJson(this._unselectable);
    }
    if (this._hasSelectionShape) {
      result.selectionShape = UnitActor_SelectionShape.toJson(this._selectionShape);
    }
    if (this._hasSelectionScale && !this._selectionScale.isEmpty()) {
      result.selectionScale = UnitActor_SelectionScale.toJson(this._selectionScale);
    }
    if (this._aliases.length > 0) {
      result.aliases = ArrayToJson(this._aliases, JsonToString);
    }
    if (this._hasHideShadow) {
      result.hideShadow = JsonToBoolean.toJson(this._hideShadow);
    }
    if (this._hasScaleMultiplier && !this._scaleMultiplier.isEmpty()) {
      result.scaleMultiplier = InitialScale.toJson(this._scaleMultiplier);
    }
    if (this._hasRenderingPriority) {
      result.renderingPriority = JsonToInt32.toJson(this._renderingPriority);
    }
    if (this._hasSpriteOptions && !this._spriteOptions.isEmpty()) {
      result.spriteOptions = SpriteOptions.toJson(this._spriteOptions);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unit() {
    return this._hasDeprecatedUnit ? this._unit : JsonToString.default;
  }
  get hasDeprecatedUnit() {
    return this._hasDeprecatedUnit;
  }
  setDeprecatedUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteDeprecatedUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {ActorResource}
   */
  get resource() {
    return this._hasResource ? this._resource : ActorResource.default;
  }
  get hasResource() {
    return this._hasResource;
  }
  setResource(path, value) {
    return {type: 'SET', path: path.concat(['resource']), value: value.toJson()};
  }
  deleteResource(path) {
    return {type: 'DELETE', path: path.concat(['resource'])};
  }
  /**
   * @returns {boolean}
   */
  get preserveOnUnitRemove() {
    return this._hasPreserveOnUnitRemove ? this._preserveOnUnitRemove : JsonToBoolean.default;
  }
  get hasPreserveOnUnitRemove() {
    return this._hasPreserveOnUnitRemove;
  }
  setPreserveOnUnitRemove(path, value) {
    return {type: 'SET', path: path.concat(['preserveOnUnitRemove']), value};
  }
  deletePreserveOnUnitRemove(path) {
    return {type: 'DELETE', path: path.concat(['preserveOnUnitRemove'])};
  }
  /**
   * @returns {ActorEvent[]}
   */
  get events() {
    return this._events;
  }
  addEvents(path, value) {
    return {type: 'ADD', path: path.concat(['events']), value: value.toJson()};
  }
  setEvents(path, value) {
    return {type: 'SET', path: path.concat(['events']), value: ArrayToJson(value, ActorEvent)};
  }
  setEventsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['events', key]), value: value.toJson()};
  }
  deleteEvents(path) {
    return {type: 'DELETE', path: path.concat(['events'])};
  }
  deleteEventsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['events', key])};
  }
  /**
   * @returns {string[]}
   */
  get eventMacros() {
    return this._eventMacros;
  }
  addEventMacros(path, value) {
    return {type: 'ADD', path: path.concat(['eventMacros']), value};
  }
  setEventMacros(path, value) {
    return {type: 'SET', path: path.concat(['eventMacros']), value: ArrayToJson(value, JsonToString)};
  }
  setEventMacrosByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['eventMacros', key]), value};
  }
  deleteEventMacros(path) {
    return {type: 'DELETE', path: path.concat(['eventMacros'])};
  }
  deleteEventMacrosByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['eventMacros', key])};
  }
  /**
   * @returns {Object<string, HostSite>}
   */
  get hostSites() {
    return this._hostSites;
  }
  setHostSites(path, value) {
    return {type: 'SET', path: path.concat(['hostSites']), value: MapToJson(value, JsonToString, HostSite)};
  }
  setHostSitesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['hostSites', key]), value: value.toJson()};
  }
  deleteHostSites(path) {
    return {type: 'DELETE', path: path.concat(['hostSites'])};
  }
  deleteHostSitesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['hostSites', key])};
  }
  /**
   * @returns {number}
   */
  get walkAnimationSpeed() {
    return this._hasWalkAnimationSpeed ? this._walkAnimationSpeed : JsonToDouble.default;
  }
  get hasWalkAnimationSpeed() {
    return this._hasWalkAnimationSpeed;
  }
  setWalkAnimationSpeed(path, value) {
    return {type: 'SET', path: path.concat(['walkAnimationSpeed']), value};
  }
  deleteWalkAnimationSpeed(path) {
    return {type: 'DELETE', path: path.concat(['walkAnimationSpeed'])};
  }
  /**
   * @returns {number}
   */
  get modelScale() {
    return this._hasModelScale ? this._modelScale : JsonToDouble.default;
  }
  get hasModelScale() {
    return this._hasModelScale;
  }
  setModelScale(path, value) {
    return {type: 'SET', path: path.concat(['modelScale']), value};
  }
  deleteModelScale(path) {
    return {type: 'DELETE', path: path.concat(['modelScale'])};
  }
  /**
   * @returns {string[]}
   */
  get hostSiteOperations() {
    return this._hostSiteOperations;
  }
  addHostSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['hostSiteOperations']), value};
  }
  setHostSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setHostSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations', key]), value};
  }
  deleteHostSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations'])};
  }
  deleteHostSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations', key])};
  }
  /**
   * @returns {number}
   */
  get selectionBonusRadius() {
    return this._hasSelectionBonusRadius ? this._selectionBonusRadius : JsonToDouble.default;
  }
  get hasSelectionBonusRadius() {
    return this._hasSelectionBonusRadius;
  }
  setSelectionBonusRadius(path, value) {
    return {type: 'SET', path: path.concat(['selectionBonusRadius']), value};
  }
  deleteSelectionBonusRadius(path) {
    return {type: 'DELETE', path: path.concat(['selectionBonusRadius'])};
  }
  /**
   * @returns {boolean}
   */
  get unselectable() {
    return this._hasExcludeFromUnitBody ? this._unselectable : JsonToBoolean.default;
  }
  get hasExcludeFromUnitBody() {
    return this._hasExcludeFromUnitBody;
  }
  setExcludeFromUnitBody(path, value) {
    return {type: 'SET', path: path.concat(['unselectable']), value};
  }
  deleteExcludeFromUnitBody(path) {
    return {type: 'DELETE', path: path.concat(['unselectable'])};
  }
  /**
   * @returns {number}
   */
  get selectionShape() {
    return this._hasSelectionShape ? this._selectionShape : UnitActor_SelectionShape.default;
  }
  get hasSelectionShape() {
    return this._hasSelectionShape;
  }
  setSelectionShape(path, value) {
    return {type: 'SET', path: path.concat(['selectionShape']), value};
  }
  deleteSelectionShape(path) {
    return {type: 'DELETE', path: path.concat(['selectionShape'])};
  }
  /**
   * @returns {UnitActor_SelectionScale}
   */
  get selectionScale() {
    return this._hasSelectionScale ? this._selectionScale : UnitActor_SelectionScale.default;
  }
  get hasSelectionScale() {
    return this._hasSelectionScale;
  }
  setSelectionScale(path, value) {
    return {type: 'SET', path: path.concat(['selectionScale']), value: value.toJson()};
  }
  deleteSelectionScale(path) {
    return {type: 'DELETE', path: path.concat(['selectionScale'])};
  }
  /**
   * @returns {string[]}
   */
  get aliases() {
    return this._aliases;
  }
  addAliases(path, value) {
    return {type: 'ADD', path: path.concat(['aliases']), value};
  }
  setAliases(path, value) {
    return {type: 'SET', path: path.concat(['aliases']), value: ArrayToJson(value, JsonToString)};
  }
  setAliasesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['aliases', key]), value};
  }
  deleteAliases(path) {
    return {type: 'DELETE', path: path.concat(['aliases'])};
  }
  deleteAliasesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['aliases', key])};
  }
  /**
   * @returns {boolean}
   */
  get hideShadow() {
    return this._hasHideShadow ? this._hideShadow : JsonToBoolean.default;
  }
  get hasHideShadow() {
    return this._hasHideShadow;
  }
  setHideShadow(path, value) {
    return {type: 'SET', path: path.concat(['hideShadow']), value};
  }
  deleteHideShadow(path) {
    return {type: 'DELETE', path: path.concat(['hideShadow'])};
  }
  /**
   * @returns {InitialScale}
   */
  get scaleMultiplier() {
    return this._hasScaleMultiplier ? this._scaleMultiplier : InitialScale.default;
  }
  get hasScaleMultiplier() {
    return this._hasScaleMultiplier;
  }
  setScaleMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['scaleMultiplier']), value: value.toJson()};
  }
  deleteScaleMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['scaleMultiplier'])};
  }
  /**
   * @returns {number}
   */
  get renderingPriority() {
    return this._hasRenderingPriority ? this._renderingPriority : JsonToInt32.default;
  }
  get hasRenderingPriority() {
    return this._hasRenderingPriority;
  }
  setRenderingPriority(path, value) {
    return {type: 'SET', path: path.concat(['renderingPriority']), value};
  }
  deleteRenderingPriority(path) {
    return {type: 'DELETE', path: path.concat(['renderingPriority'])};
  }
  /**
   * @returns {SpriteOptions}
   */
  get spriteOptions() {
    return this._hasSpriteOptions ? this._spriteOptions : SpriteOptions.default;
  }
  get hasSpriteOptions() {
    return this._hasSpriteOptions;
  }
  setSpriteOptions(path, value) {
    return {type: 'SET', path: path.concat(['spriteOptions']), value: value.toJson()};
  }
  deleteSpriteOptions(path) {
    return {type: 'DELETE', path: path.concat(['spriteOptions'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasDeprecatedUnit = true;
              copy._unit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedUnit) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasDeprecatedUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resource": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasResource = true;
              copy._resource = ActorResource.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResource) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasResource = false;
              copy._resource = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasResource) {
            const copy = new UnitActor(this);
            copy._hasResource = true;
            copy._resource = ActorResource.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._resource.apply(type, path.slice(1), value);
          if (newValue === this._resource) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._resource = copy._resource.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "preserveOnUnitRemove": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasPreserveOnUnitRemove = true;
              copy._preserveOnUnitRemove = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPreserveOnUnitRemove) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasPreserveOnUnitRemove = false;
              copy._preserveOnUnitRemove = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "events": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._events = [];        for (let i of value) {
                copy._events.push(ActorEvent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitActor(this);
              copy._events = copy._events.concat([ActorEvent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._events.length === 0) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._events = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._events.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._events = copy._events.slice();
              copy._events[path[1]] = ActorEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitActor(this);
              copy._events = copy._events.slice(0, path[1]).concat(copy._events.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._events.length) {
            return this;
          }
          const oldValue = this._events[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._events = copy._events.slice();
          copy._events[key] = newValue;
          return copy;
        }
      }
      case "eventMacros": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._eventMacros = [];        for (let i of value) {
                copy._eventMacros.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitActor(this);
              copy._eventMacros = copy._eventMacros.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._eventMacros.length === 0) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._eventMacros = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._eventMacros.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._eventMacros = copy._eventMacros.slice();
              copy._eventMacros[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitActor(this);
              copy._eventMacros = copy._eventMacros.slice(0, path[1]).concat(copy._eventMacros.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._eventMacros.length) {
            return this;
          }
          const oldValue = this._eventMacros[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._eventMacros = copy._eventMacros.slice();
          copy._eventMacros[key] = newValue;
          return copy;
        }
      }
      case "hostSites": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._hostSites).length === 0) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hostSites = {};
              return copy;
            }
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hostSites = {};
              for (let key in value) {
                copy._hostSites[key] = HostSite.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hostSites = {...copy._hostSites};
              copy._hostSites[path[1]] = HostSite.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hostSites[path[1]]) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hostSites = {...copy._hostSites};
              delete copy._hostSites[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._hostSites[key] === undefined) {
            const copy = new UnitActor(this);
            copy._hostSites = {...copy._hostSites};
            copy._hostSites[key] = HostSite.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._hostSites[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._hostSites = {...copy._hostSites};
          copy._hostSites[key] = newValue;
          return copy;
        }
      }
      case "walkAnimationSpeed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasWalkAnimationSpeed = true;
              copy._walkAnimationSpeed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWalkAnimationSpeed) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasWalkAnimationSpeed = false;
              copy._walkAnimationSpeed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modelScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasModelScale = true;
              copy._modelScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModelScale) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasModelScale = false;
              copy._modelScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hostSiteOperations = [];        for (let i of value) {
                copy._hostSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._hostSiteOperations.length === 0) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hostSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice();
              copy._hostSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice(0, path[1]).concat(copy._hostSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          const oldValue = this._hostSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._hostSiteOperations = copy._hostSiteOperations.slice();
          copy._hostSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "selectionBonusRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasSelectionBonusRadius = true;
              copy._selectionBonusRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionBonusRadius) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasSelectionBonusRadius = false;
              copy._selectionBonusRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unselectable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasExcludeFromUnitBody = true;
              copy._unselectable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExcludeFromUnitBody) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasExcludeFromUnitBody = false;
              copy._unselectable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectionShape": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasSelectionShape = true;
              copy._selectionShape = UnitActor_SelectionShape.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionShape) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasSelectionShape = false;
              copy._selectionShape = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectionScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasSelectionScale = true;
              copy._selectionScale = UnitActor_SelectionScale.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionScale) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasSelectionScale = false;
              copy._selectionScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSelectionScale) {
            const copy = new UnitActor(this);
            copy._hasSelectionScale = true;
            copy._selectionScale = UnitActor_SelectionScale.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._selectionScale.apply(type, path.slice(1), value);
          if (newValue === this._selectionScale) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._selectionScale = copy._selectionScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "aliases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._aliases = [];        for (let i of value) {
                copy._aliases.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitActor(this);
              copy._aliases = copy._aliases.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._aliases.length === 0) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._aliases = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._aliases = copy._aliases.slice();
              copy._aliases[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitActor(this);
              copy._aliases = copy._aliases.slice(0, path[1]).concat(copy._aliases.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          const oldValue = this._aliases[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._aliases = copy._aliases.slice();
          copy._aliases[key] = newValue;
          return copy;
        }
      }
      case "hideShadow": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasHideShadow = true;
              copy._hideShadow = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideShadow) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasHideShadow = false;
              copy._hideShadow = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scaleMultiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasScaleMultiplier = true;
              copy._scaleMultiplier = InitialScale.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScaleMultiplier) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasScaleMultiplier = false;
              copy._scaleMultiplier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasScaleMultiplier) {
            const copy = new UnitActor(this);
            copy._hasScaleMultiplier = true;
            copy._scaleMultiplier = InitialScale.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._scaleMultiplier.apply(type, path.slice(1), value);
          if (newValue === this._scaleMultiplier) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._scaleMultiplier = copy._scaleMultiplier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "renderingPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasRenderingPriority = true;
              copy._renderingPriority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRenderingPriority) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasRenderingPriority = false;
              copy._renderingPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spriteOptions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitActor(this);
              copy._hasSpriteOptions = true;
              copy._spriteOptions = SpriteOptions.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpriteOptions) {
                return this;
              }
              const copy = new UnitActor(this);
              copy._hasSpriteOptions = false;
              copy._spriteOptions = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSpriteOptions) {
            const copy = new UnitActor(this);
            copy._hasSpriteOptions = true;
            copy._spriteOptions = SpriteOptions.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._spriteOptions.apply(type, path.slice(1), value);
          if (newValue === this._spriteOptions) {
            return this;
          }
          const copy = new UnitActor(this);
          copy._spriteOptions = copy._spriteOptions.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitActor} other
   * @returns {UnitActor}
   */
  merge(other) {
    const copy = new UnitActor(this);
    if (other._hasDeprecatedUnit) {
      copy._hasDeprecatedUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasResource) {
      if (copy._hasResource) {
        copy._resource = copy.resource.merge(other.resource);
      } else {
        copy._resource = other._resource;
      }
      copy._hasResource = true;
    }
    if (other._hasPreserveOnUnitRemove) {
      copy._hasPreserveOnUnitRemove = true;
      copy._preserveOnUnitRemove = other._preserveOnUnitRemove;
    }
    copy._events = this._events.concat(other._events);
    copy._eventMacros = this._eventMacros.concat(other._eventMacros);
    copy._hostSites = {...this._hostSites, ...other._hostSites};
    if (other._hasWalkAnimationSpeed) {
      copy._hasWalkAnimationSpeed = true;
      copy._walkAnimationSpeed = other._walkAnimationSpeed;
    }
    if (other._hasModelScale) {
      copy._hasModelScale = true;
      copy._modelScale = other._modelScale;
    }
    copy._hostSiteOperations = this._hostSiteOperations.concat(other._hostSiteOperations);
    if (other._hasSelectionBonusRadius) {
      copy._hasSelectionBonusRadius = true;
      copy._selectionBonusRadius = other._selectionBonusRadius;
    }
    if (other._hasExcludeFromUnitBody) {
      copy._hasExcludeFromUnitBody = true;
      copy._unselectable = other._unselectable;
    }
    if (other._hasSelectionShape) {
      copy._hasSelectionShape = true;
      copy._selectionShape = other._selectionShape;
    }
    if (other._hasSelectionScale) {
      if (copy._hasSelectionScale) {
        copy._selectionScale = copy.selectionScale.merge(other.selectionScale);
      } else {
        copy._selectionScale = other._selectionScale;
      }
      copy._hasSelectionScale = true;
    }
    copy._aliases = this._aliases.concat(other._aliases);
    if (other._hasHideShadow) {
      copy._hasHideShadow = true;
      copy._hideShadow = other._hideShadow;
    }
    if (other._hasScaleMultiplier) {
      if (copy._hasScaleMultiplier) {
        copy._scaleMultiplier = copy.scaleMultiplier.merge(other.scaleMultiplier);
      } else {
        copy._scaleMultiplier = other._scaleMultiplier;
      }
      copy._hasScaleMultiplier = true;
    }
    if (other._hasRenderingPriority) {
      copy._hasRenderingPriority = true;
      copy._renderingPriority = other._renderingPriority;
    }
    if (other._hasSpriteOptions) {
      if (copy._hasSpriteOptions) {
        copy._spriteOptions = copy.spriteOptions.merge(other.spriteOptions);
      } else {
        copy._spriteOptions = other._spriteOptions;
      }
      copy._hasSpriteOptions = true;
    }
    return copy;
  }
}
UnitActor.default = new UnitActor();
UnitActor.SelectionScale = UnitActor_SelectionScale;
UnitActor.HostSitesEntry = UnitActor_HostSitesEntry;
UnitActor.SelectionShape = UnitActor_SelectionShape;
class UnitActor_Builder {
  constructor(value) {
    this._value = new UnitActor(value);
  }
  build() {
    return new UnitActor(this._value);
  }
  setDeprecatedUnit(value) {
    this._value._hasDeprecatedUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteDeprecatedUnit() {
    this._value._hasDeprecatedUnit = false;
    this._value._unit = null;
    return this;
  }
  setResource(value) {
    this._value._hasResource = true;
    this._value._resource = value;
    return this;
  }
  deleteResource() {
    this._value._hasResource = false;
    this._value._resource = null;
    return this;
  }
  setPreserveOnUnitRemove(value) {
    this._value._hasPreserveOnUnitRemove = true;
    this._value._preserveOnUnitRemove = value;
    return this;
  }
  deletePreserveOnUnitRemove() {
    this._value._hasPreserveOnUnitRemove = false;
    this._value._preserveOnUnitRemove = null;
    return this;
  }
  addAllEvents(values) {
    this._value._events = this._value._events.concat(values);
    return this;
  }
  addEvents(value) {
    this._value._events = this._value._events.concat([value]);
    return this;
  }
  setEvents(index, value) {
    this._value._events = this._value._events.concat();
    this._value._events[index] = value;
    return this;
  }
  clearEvents() {
    this._value._events = [];
    return this;
  }
  addAllEventMacros(values) {
    this._value._eventMacros = this._value._eventMacros.concat(values);
    return this;
  }
  addEventMacros(value) {
    this._value._eventMacros = this._value._eventMacros.concat([value]);
    return this;
  }
  setEventMacros(index, value) {
    this._value._eventMacros = this._value._eventMacros.concat();
    this._value._eventMacros[index] = value;
    return this;
  }
  clearEventMacros() {
    this._value._eventMacros = [];
    return this;
  }
  setHostSites(key, value) {
    this._value._hostSites = {...this._value._hostSites, [key]: value};
    return this;
  }
  addAllHostSites(values) {
    this._value._hostSites = {...this._value._hostSites, ...values};
    return this;
  }
  deleteHostSites(key) {
    this._value._hostSites = {...this._value._hostSites};
    delete this._value._hostSites[key];
    return this;
  }
  clearHostSites() {
    this._value._hostSites = {};
    return this;
  }
  setWalkAnimationSpeed(value) {
    this._value._hasWalkAnimationSpeed = true;
    this._value._walkAnimationSpeed = value;
    return this;
  }
  deleteWalkAnimationSpeed() {
    this._value._hasWalkAnimationSpeed = false;
    this._value._walkAnimationSpeed = null;
    return this;
  }
  setModelScale(value) {
    this._value._hasModelScale = true;
    this._value._modelScale = value;
    return this;
  }
  deleteModelScale() {
    this._value._hasModelScale = false;
    this._value._modelScale = null;
    return this;
  }
  addAllHostSiteOperations(values) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat(values);
    return this;
  }
  addHostSiteOperations(value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat([value]);
    return this;
  }
  setHostSiteOperations(index, value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat();
    this._value._hostSiteOperations[index] = value;
    return this;
  }
  clearHostSiteOperations() {
    this._value._hostSiteOperations = [];
    return this;
  }
  setSelectionBonusRadius(value) {
    this._value._hasSelectionBonusRadius = true;
    this._value._selectionBonusRadius = value;
    return this;
  }
  deleteSelectionBonusRadius() {
    this._value._hasSelectionBonusRadius = false;
    this._value._selectionBonusRadius = null;
    return this;
  }
  setExcludeFromUnitBody(value) {
    this._value._hasExcludeFromUnitBody = true;
    this._value._unselectable = value;
    return this;
  }
  deleteExcludeFromUnitBody() {
    this._value._hasExcludeFromUnitBody = false;
    this._value._unselectable = null;
    return this;
  }
  setSelectionShape(value) {
    this._value._hasSelectionShape = true;
    this._value._selectionShape = value;
    return this;
  }
  deleteSelectionShape() {
    this._value._hasSelectionShape = false;
    this._value._selectionShape = null;
    return this;
  }
  setSelectionScale(value) {
    this._value._hasSelectionScale = true;
    this._value._selectionScale = value;
    return this;
  }
  deleteSelectionScale() {
    this._value._hasSelectionScale = false;
    this._value._selectionScale = null;
    return this;
  }
  addAllAliases(values) {
    this._value._aliases = this._value._aliases.concat(values);
    return this;
  }
  addAliases(value) {
    this._value._aliases = this._value._aliases.concat([value]);
    return this;
  }
  setAliases(index, value) {
    this._value._aliases = this._value._aliases.concat();
    this._value._aliases[index] = value;
    return this;
  }
  clearAliases() {
    this._value._aliases = [];
    return this;
  }
  setHideShadow(value) {
    this._value._hasHideShadow = true;
    this._value._hideShadow = value;
    return this;
  }
  deleteHideShadow() {
    this._value._hasHideShadow = false;
    this._value._hideShadow = null;
    return this;
  }
  setScaleMultiplier(value) {
    this._value._hasScaleMultiplier = true;
    this._value._scaleMultiplier = value;
    return this;
  }
  deleteScaleMultiplier() {
    this._value._hasScaleMultiplier = false;
    this._value._scaleMultiplier = null;
    return this;
  }
  setRenderingPriority(value) {
    this._value._hasRenderingPriority = true;
    this._value._renderingPriority = value;
    return this;
  }
  deleteRenderingPriority() {
    this._value._hasRenderingPriority = false;
    this._value._renderingPriority = null;
    return this;
  }
  setSpriteOptions(value) {
    this._value._hasSpriteOptions = true;
    this._value._spriteOptions = value;
    return this;
  }
  deleteSpriteOptions() {
    this._value._hasSpriteOptions = false;
    this._value._spriteOptions = null;
    return this;
  }
}
UnitActor.Builder = UnitActor_Builder;
class UnitActor_WithParent {
  /**
   * @param {UnitActor} value
   * @param {UnitActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedUnit() {
    if (this._cachedHasDeprecatedUnit === undefined) {
      if (this._value.hasDeprecatedUnit) {
        this._cachedHasDeprecatedUnit = true;
      } else {
        this._cachedHasDeprecatedUnit = this._parent ? this._parent.hasDeprecatedUnit : false;
      }
    }
    return this._cachedHasDeprecatedUnit;
  }
  get unit() {
    if (this._cachedDeprecatedUnit === undefined) {
      if (this._value.hasDeprecatedUnit) {
        this._cachedDeprecatedUnit = this._value.unit;
      } else {
        this._cachedDeprecatedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedDeprecatedUnit;
  }
  get hasResource() {
    if (this._cachedHasResource === undefined) {
      if (this._value.hasResource) {
        this._cachedHasResource = true;
      } else {
        this._cachedHasResource = this._parent ? this._parent.hasResource : false;
      }
    }
    return this._cachedHasResource;
  }
  get resource() {
    if (!this._cachedResource) {
      if (this._value.hasResource) {
        this._cachedResource = new ActorResource.WithParent(this._value.resource, this._parent && this._parent.hasResource ? this._parent.resource : null);
      } else {
        this._cachedResource = this._parent ? new ActorResource.WithParent(ActorResource.default, this._parent.resource) : ActorResource.WithParent.default;
      }
    }
    return this._cachedResource;
  }
  get hasPreserveOnUnitRemove() {
    if (this._cachedHasPreserveOnUnitRemove === undefined) {
      if (this._value.hasPreserveOnUnitRemove) {
        this._cachedHasPreserveOnUnitRemove = true;
      } else {
        this._cachedHasPreserveOnUnitRemove = this._parent ? this._parent.hasPreserveOnUnitRemove : false;
      }
    }
    return this._cachedHasPreserveOnUnitRemove;
  }
  get preserveOnUnitRemove() {
    if (this._cachedPreserveOnUnitRemove === undefined) {
      if (this._value.hasPreserveOnUnitRemove) {
        this._cachedPreserveOnUnitRemove = this._value.preserveOnUnitRemove;
      } else {
        this._cachedPreserveOnUnitRemove = this._parent ? this._parent.preserveOnUnitRemove : this._value.preserveOnUnitRemove;
      }
    }
    return this._cachedPreserveOnUnitRemove;
  }
  get selfEvents() {
    if (!this._selfEvents) {
      this._selfEvents = [];
      for (let i of this._value.events) {
        this._selfEvents.push(new ActorEvent.WithParent(i, null));
      }
    }
    return this._selfEvents;
  }
  get inherentEvents() {
    if (!this._inherentEvents) {
      this._inherentEvents = this._parent ? this._parent.events : [];
    }
    return this._inherentEvents;
  }
  get events() {
    if (!this._allEvents) {
      this._allEvents = this._parent ? this._parent.events.concat(this.selfEvents) : this.selfEvents;
    }
    return this._allEvents;
  }
  get selfEventMacros() {
    return this._value.eventMacros;
  }
  get inherentEventMacros() {
    if (!this._inherentEventMacros) {
      this._inherentEventMacros = this._parent ? this._parent.eventMacros : [];
    }
    return this._inherentEventMacros;
  }
  get eventMacros() {
    if (!this._allEventMacros) {
      this._allEventMacros = this._parent ? this._parent.eventMacros.concat(this.selfEventMacros) : this.selfEventMacros;
    }
    return this._allEventMacros;
  }
  get selfHostSites() {
    if (!this._selfHostSites) {
      this._selfHostSites = {};
      for (let i in this._value.hostSites) {
        this._selfHostSites[i] = new HostSite.WithParent(this._value.hostSites[i], null);
      }
    }
    return this._selfHostSites;
  }
  get inherentHostSites() {
    if (!this._inherentHostSites) {
      this._inherentHostSites = this._parent ? this._parent.hostSites : {};
    }
    return this._inherentHostSites;
  }
  get hostSites() {
    if (!this._allHostSites) {
      this._allHostSites = this._parent ? {...this._parent.hostSites, ...this.selfHostSites} : this.selfHostSites;
    }
    return this._allHostSites;
  }
  get hasWalkAnimationSpeed() {
    if (this._cachedHasWalkAnimationSpeed === undefined) {
      if (this._value.hasWalkAnimationSpeed) {
        this._cachedHasWalkAnimationSpeed = true;
      } else {
        this._cachedHasWalkAnimationSpeed = this._parent ? this._parent.hasWalkAnimationSpeed : false;
      }
    }
    return this._cachedHasWalkAnimationSpeed;
  }
  get walkAnimationSpeed() {
    if (this._cachedWalkAnimationSpeed === undefined) {
      if (this._value.hasWalkAnimationSpeed) {
        this._cachedWalkAnimationSpeed = this._value.walkAnimationSpeed;
      } else {
        this._cachedWalkAnimationSpeed = this._parent ? this._parent.walkAnimationSpeed : this._value.walkAnimationSpeed;
      }
    }
    return this._cachedWalkAnimationSpeed;
  }
  get hasModelScale() {
    if (this._cachedHasModelScale === undefined) {
      if (this._value.hasModelScale) {
        this._cachedHasModelScale = true;
      } else {
        this._cachedHasModelScale = this._parent ? this._parent.hasModelScale : false;
      }
    }
    return this._cachedHasModelScale;
  }
  get modelScale() {
    if (this._cachedModelScale === undefined) {
      if (this._value.hasModelScale) {
        this._cachedModelScale = this._value.modelScale;
      } else {
        this._cachedModelScale = this._parent ? this._parent.modelScale : this._value.modelScale;
      }
    }
    return this._cachedModelScale;
  }
  get selfHostSiteOperations() {
    return this._value.hostSiteOperations;
  }
  get inherentHostSiteOperations() {
    if (!this._inherentHostSiteOperations) {
      this._inherentHostSiteOperations = this._parent ? this._parent.hostSiteOperations : [];
    }
    return this._inherentHostSiteOperations;
  }
  get hostSiteOperations() {
    if (!this._allHostSiteOperations) {
      this._allHostSiteOperations = this._parent ? this._parent.hostSiteOperations.concat(this.selfHostSiteOperations) : this.selfHostSiteOperations;
    }
    return this._allHostSiteOperations;
  }
  get hasSelectionBonusRadius() {
    if (this._cachedHasSelectionBonusRadius === undefined) {
      if (this._value.hasSelectionBonusRadius) {
        this._cachedHasSelectionBonusRadius = true;
      } else {
        this._cachedHasSelectionBonusRadius = this._parent ? this._parent.hasSelectionBonusRadius : false;
      }
    }
    return this._cachedHasSelectionBonusRadius;
  }
  get selectionBonusRadius() {
    if (this._cachedSelectionBonusRadius === undefined) {
      if (this._value.hasSelectionBonusRadius) {
        this._cachedSelectionBonusRadius = this._value.selectionBonusRadius;
      } else {
        this._cachedSelectionBonusRadius = this._parent ? this._parent.selectionBonusRadius : this._value.selectionBonusRadius;
      }
    }
    return this._cachedSelectionBonusRadius;
  }
  get hasExcludeFromUnitBody() {
    if (this._cachedHasExcludeFromUnitBody === undefined) {
      if (this._value.hasExcludeFromUnitBody) {
        this._cachedHasExcludeFromUnitBody = true;
      } else {
        this._cachedHasExcludeFromUnitBody = this._parent ? this._parent.hasExcludeFromUnitBody : false;
      }
    }
    return this._cachedHasExcludeFromUnitBody;
  }
  get unselectable() {
    if (this._cachedExcludeFromUnitBody === undefined) {
      if (this._value.hasExcludeFromUnitBody) {
        this._cachedExcludeFromUnitBody = this._value.unselectable;
      } else {
        this._cachedExcludeFromUnitBody = this._parent ? this._parent.unselectable : this._value.unselectable;
      }
    }
    return this._cachedExcludeFromUnitBody;
  }
  get hasSelectionShape() {
    if (this._cachedHasSelectionShape === undefined) {
      if (this._value.hasSelectionShape) {
        this._cachedHasSelectionShape = true;
      } else {
        this._cachedHasSelectionShape = this._parent ? this._parent.hasSelectionShape : false;
      }
    }
    return this._cachedHasSelectionShape;
  }
  get selectionShape() {
    if (this._cachedSelectionShape === undefined) {
      if (this._value.hasSelectionShape) {
        this._cachedSelectionShape = this._value.selectionShape;
      } else {
        this._cachedSelectionShape = this._parent ? this._parent.selectionShape : this._value.selectionShape;
      }
    }
    return this._cachedSelectionShape;
  }
  get hasSelectionScale() {
    if (this._cachedHasSelectionScale === undefined) {
      if (this._value.hasSelectionScale) {
        this._cachedHasSelectionScale = true;
      } else {
        this._cachedHasSelectionScale = this._parent ? this._parent.hasSelectionScale : false;
      }
    }
    return this._cachedHasSelectionScale;
  }
  get selectionScale() {
    if (!this._cachedSelectionScale) {
      if (this._value.hasSelectionScale) {
        this._cachedSelectionScale = new UnitActor_SelectionScale.WithParent(this._value.selectionScale, this._parent && this._parent.hasSelectionScale ? this._parent.selectionScale : null);
      } else {
        this._cachedSelectionScale = this._parent ? new UnitActor_SelectionScale.WithParent(UnitActor_SelectionScale.default, this._parent.selectionScale) : UnitActor_SelectionScale.WithParent.default;
      }
    }
    return this._cachedSelectionScale;
  }
  get selfAliases() {
    return this._value.aliases;
  }
  get inherentAliases() {
    if (!this._inherentAliases) {
      this._inherentAliases = this._parent ? this._parent.aliases : [];
    }
    return this._inherentAliases;
  }
  get aliases() {
    if (!this._allAliases) {
      this._allAliases = this._parent ? this._parent.aliases.concat(this.selfAliases) : this.selfAliases;
    }
    return this._allAliases;
  }
  get hasHideShadow() {
    if (this._cachedHasHideShadow === undefined) {
      if (this._value.hasHideShadow) {
        this._cachedHasHideShadow = true;
      } else {
        this._cachedHasHideShadow = this._parent ? this._parent.hasHideShadow : false;
      }
    }
    return this._cachedHasHideShadow;
  }
  get hideShadow() {
    if (this._cachedHideShadow === undefined) {
      if (this._value.hasHideShadow) {
        this._cachedHideShadow = this._value.hideShadow;
      } else {
        this._cachedHideShadow = this._parent ? this._parent.hideShadow : this._value.hideShadow;
      }
    }
    return this._cachedHideShadow;
  }
  get hasScaleMultiplier() {
    if (this._cachedHasScaleMultiplier === undefined) {
      if (this._value.hasScaleMultiplier) {
        this._cachedHasScaleMultiplier = true;
      } else {
        this._cachedHasScaleMultiplier = this._parent ? this._parent.hasScaleMultiplier : false;
      }
    }
    return this._cachedHasScaleMultiplier;
  }
  get scaleMultiplier() {
    if (!this._cachedScaleMultiplier) {
      if (this._value.hasScaleMultiplier) {
        this._cachedScaleMultiplier = new InitialScale.WithParent(this._value.scaleMultiplier, this._parent && this._parent.hasScaleMultiplier ? this._parent.scaleMultiplier : null);
      } else {
        this._cachedScaleMultiplier = this._parent ? new InitialScale.WithParent(InitialScale.default, this._parent.scaleMultiplier) : InitialScale.WithParent.default;
      }
    }
    return this._cachedScaleMultiplier;
  }
  get hasRenderingPriority() {
    if (this._cachedHasRenderingPriority === undefined) {
      if (this._value.hasRenderingPriority) {
        this._cachedHasRenderingPriority = true;
      } else {
        this._cachedHasRenderingPriority = this._parent ? this._parent.hasRenderingPriority : false;
      }
    }
    return this._cachedHasRenderingPriority;
  }
  get renderingPriority() {
    if (this._cachedRenderingPriority === undefined) {
      if (this._value.hasRenderingPriority) {
        this._cachedRenderingPriority = this._value.renderingPriority;
      } else {
        this._cachedRenderingPriority = this._parent ? this._parent.renderingPriority : this._value.renderingPriority;
      }
    }
    return this._cachedRenderingPriority;
  }
  get hasSpriteOptions() {
    if (this._cachedHasSpriteOptions === undefined) {
      if (this._value.hasSpriteOptions) {
        this._cachedHasSpriteOptions = true;
      } else {
        this._cachedHasSpriteOptions = this._parent ? this._parent.hasSpriteOptions : false;
      }
    }
    return this._cachedHasSpriteOptions;
  }
  get spriteOptions() {
    if (!this._cachedSpriteOptions) {
      if (this._value.hasSpriteOptions) {
        this._cachedSpriteOptions = new SpriteOptions.WithParent(this._value.spriteOptions, this._parent && this._parent.hasSpriteOptions ? this._parent.spriteOptions : null);
      } else {
        this._cachedSpriteOptions = this._parent ? new SpriteOptions.WithParent(SpriteOptions.default, this._parent.spriteOptions) : SpriteOptions.WithParent.default;
      }
    }
    return this._cachedSpriteOptions;
  }
  update(current, parent) {
    const result = new UnitActor_WithParent(current, parent);
    if (this._cachedResource && this._value.hasResource && current.hasResource) {
      if (this._value.resource === current.resource && this._parent === parent) {
        result._cachedResource = this._cachedResource;
      } else {
        result._cachedResource = this._cachedResource.update(current.resource, parent && parent.hasResource ? parent.resource : null);
      }
    }
    if (this._selfEvents) {
      if (this._value.events === current.events) {
        result._selfEvents = this._selfEvents;
      } else {
        result._selfEvents = [];
        for (let i = 0; i < current.events.length; i++) {
          const oldValue = this._value.events[i];
          if (oldValue) {
            const oldCache = this._selfEvents[i];
            if (oldValue === current.events[i]) {
              result._selfEvents[i] = oldCache;
            } else {
              result._selfEvents[i] = oldCache.update(current.events[i], null);
            }
          } else {
            result._selfEvents[i] = new ActorEvent.WithParent(current.events[i], null);
          }
        }
      }
    }
    if (this._selfHostSites) {
      if (this._value.hostSites === current.hostSites) {
        result._selfHostSites = this._selfHostSites;
      } else {
        result._selfHostSites = {};
        for (let i in current.hostSites) {
          const oldValue = this._value.hostSites[i];
          if (oldValue) {
            const oldCache = this._selfHostSites[i];
            if (oldValue === current.hostSites[i]) {
              result._selfHostSites[i] = oldCache;
            } else {
              result._selfHostSites[i] = oldCache.update(current.hostSites[i], null);
            }
          } else {
            result._selfHostSites[i] = new HostSite.WithParent(current.hostSites[i], null);
          }
        }
      }
    }
    if (this._cachedSelectionScale && this._value.hasSelectionScale && current.hasSelectionScale) {
      if (this._value.selectionScale === current.selectionScale && this._parent === parent) {
        result._cachedSelectionScale = this._cachedSelectionScale;
      } else {
        result._cachedSelectionScale = this._cachedSelectionScale.update(current.selectionScale, parent && parent.hasSelectionScale ? parent.selectionScale : null);
      }
    }
    if (this._cachedScaleMultiplier && this._value.hasScaleMultiplier && current.hasScaleMultiplier) {
      if (this._value.scaleMultiplier === current.scaleMultiplier && this._parent === parent) {
        result._cachedScaleMultiplier = this._cachedScaleMultiplier;
      } else {
        result._cachedScaleMultiplier = this._cachedScaleMultiplier.update(current.scaleMultiplier, parent && parent.hasScaleMultiplier ? parent.scaleMultiplier : null);
      }
    }
    if (this._cachedSpriteOptions && this._value.hasSpriteOptions && current.hasSpriteOptions) {
      if (this._value.spriteOptions === current.spriteOptions && this._parent === parent) {
        result._cachedSpriteOptions = this._cachedSpriteOptions;
      } else {
        result._cachedSpriteOptions = this._cachedSpriteOptions.update(current.spriteOptions, parent && parent.hasSpriteOptions ? parent.spriteOptions : null);
      }
    }
    return result;
  }
}
UnitActor_WithParent.default = new UnitActor_WithParent(UnitActor.default, null);
UnitActor.WithParent = UnitActor_WithParent;
class UnitActor_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "DeprecatedUnit",
        number: 1002,
        protoType: 9,
        protoName: "deprecated_unit",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get resource() {
    if (!this._resource) {
      this._resource = {
        name: "resource",
        Name: "Resource",
        number: 1,
        protoType: 11,
        protoName: "resource",
        type: ActorResource,
        options: {
          comments: "The asset to use for the actor. This determines what the actor looks or sounds like.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resource;
  }
  get preserveOnUnitRemove() {
    if (!this._preserveOnUnitRemove) {
      this._preserveOnUnitRemove = {
        name: "preserveOnUnitRemove",
        Name: "PreserveOnUnitRemove",
        number: 2,
        protoType: 8,
        protoName: "preserve_on_unit_remove",
        type: JsonToBoolean,
        options: {
          comments: "By default, unit actor will be destroyed automatically when the unit is removed (on the UnitRemove event). When this flag is enabled enabled, the actor is not removed with the unit and must be destroyed with actor events. Enabling this flag is necessary for playing a death animations on the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preserveOnUnitRemove;
  }
  get events() {
    if (!this._events) {
      this._events = {
        name: "events",
        Name: "Events",
        number: 3,
        protoType: 11,
        protoName: "events",
        type: ActorEvent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._events;
  }
  get eventMacros() {
    if (!this._eventMacros) {
      this._eventMacros = {
        name: "eventMacros",
        Name: "EventMacros",
        number: 4,
        protoType: 9,
        protoName: "event_macros",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Event macros will be expanded after the events field.",
          valueDropdown: "SupportedActorEventMacroNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventMacros;
  }
  get hostSites() {
    if (!this._hostSites) {
      this._hostSites = {
        name: "hostSites",
        Name: "HostSites",
        number: 6,
        protoType: 11,
        protoName: "host_sites",
        isMap: true,
        keyType: JsonToString,
        valueType: HostSite,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
          comments: "Defines a list of named sites on this actor that other actors can be attached to (or reference).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSites;
  }
  get walkAnimationSpeed() {
    if (!this._walkAnimationSpeed) {
      this._walkAnimationSpeed = {
        name: "walkAnimationSpeed",
        Name: "WalkAnimationSpeed",
        number: 7,
        protoType: 1,
        protoName: "walk_animation_speed",
        type: JsonToDouble,
        options: {
          comments: "Adjusts the speed of the unit\'s walk animation. This can be used to correct \"slippery feet\" on certain models.",
          default: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._walkAnimationSpeed;
  }
  get modelScale() {
    if (!this._modelScale) {
      this._modelScale = {
        name: "modelScale",
        Name: "ModelScale",
        number: 12,
        protoType: 1,
        protoName: "model_scale",
        type: JsonToDouble,
        options: {
          comments: "Adjusts the size of the model. Using 0 defaults to 1.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modelScale;
  }
  get hostSiteOperations() {
    if (!this._hostSiteOperations) {
      this._hostSiteOperations = {
        name: "hostSiteOperations",
        Name: "HostSiteOperations",
        number: 13,
        protoType: 9,
        protoName: "host_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "A set of operations applied to the host site position/rotation to determine the final position/rotation for this actor.",
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSiteOperations;
  }
  get selectionBonusRadius() {
    if (!this._selectionBonusRadius) {
      this._selectionBonusRadius = {
        name: "selectionBonusRadius",
        Name: "SelectionBonusRadius",
        number: 14,
        protoType: 1,
        protoName: "selection_bonus_radius",
        type: JsonToDouble,
        options: {
          comments: "Adjusts the size of this actors\'s hit sphere for mouse selection and targeting if the model actor is within the scope of a unit actor. Useful for making small units more click-friendly.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionBonusRadius;
  }
  get unselectable() {
    if (!this._unselectable) {
      this._unselectable = {
        name: "unselectable",
        Name: "ExcludeFromUnitBody",
        number: 15,
        protoType: 8,
        protoName: "exclude_from_unit_body",
        type: JsonToBoolean,
        options: {
          comments: "If checked, this actor will not be considered as part of the unit when doing hit tests or calculating the bounds of the unit. If you use this flag, make sure there is at least one **Model Actor** on this unit that has the **Include In Unit Body** flag checked.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unselectable;
  }
  get selectionShape() {
    if (!this._selectionShape) {
      this._selectionShape = {
        name: "selectionShape",
        Name: "SelectionShape",
        number: 16,
        protoType: 14,
        protoName: "selection_shape",
        type: UnitActor_SelectionShape,
        options: {
          comments: "Used to change mouse selection collider from sphere (default) to a cube. Useful for games with grid-based selection.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionShape;
  }
  get selectionScale() {
    if (!this._selectionScale) {
      this._selectionScale = {
        name: "selectionScale",
        Name: "SelectionScale",
        number: 17,
        protoType: 11,
        protoName: "selection_scale",
        type: UnitActor_SelectionScale,
        options: {
          comments: "Adjusts the scale of the selection collider if **Selection Shape** is set to Cube.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionScale;
  }
  get aliases() {
    if (!this._aliases) {
      this._aliases = {
        name: "aliases",
        Name: "Aliases",
        number: 21,
        protoType: 9,
        protoName: "aliases",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "User defined name references that can be used to send messages to this actor from other actors in the same scope.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._aliases;
  }
  get hideShadow() {
    if (!this._hideShadow) {
      this._hideShadow = {
        name: "hideShadow",
        Name: "HideShadow",
        number: 41,
        protoType: 8,
        protoName: "hide_shadow",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the actor from casting a shadow.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideShadow;
  }
  get scaleMultiplier() {
    if (!this._scaleMultiplier) {
      this._scaleMultiplier = {
        name: "scaleMultiplier",
        Name: "ScaleMultiplier",
        number: 42,
        protoType: 11,
        protoName: "scale_multiplier",
        type: InitialScale,
        options: {
          comments: "Sets the scale of the actor across individual axes. The final scale will be these values multiplied by the **Model Scale**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scaleMultiplier;
  }
  get renderingPriority() {
    if (!this._renderingPriority) {
      this._renderingPriority = {
        name: "renderingPriority",
        Name: "RenderingPriority",
        number: 51,
        protoType: 5,
        protoName: "rendering_priority",
        type: JsonToInt32,
        options: {
          comments: "The rendering priority, for rendering performance optimization, in some situation(low end devices), the lower priority particle actors may not render or get hidden first",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._renderingPriority;
  }
  get spriteOptions() {
    if (!this._spriteOptions) {
      this._spriteOptions = {
        name: "spriteOptions",
        Name: "SpriteOptions",
        number: 52,
        protoType: 11,
        protoName: "sprite_options",
        type: SpriteOptions,
        options: {
          comments: "Sprite options are for actor using sprite as resource.",
          showIf: {'resource.type' : 'Sprite'},
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spriteOptions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.resource,
        this.preserveOnUnitRemove,
        this.events,
        this.eventMacros,
        this.hostSites,
        this.walkAnimationSpeed,
        this.modelScale,
        this.hostSiteOperations,
        this.selectionBonusRadius,
        this.unselectable,
        this.selectionShape,
        this.selectionScale,
        this.aliases,
        this.hideShadow,
        this.scaleMultiplier,
        this.renderingPriority,
        this.spriteOptions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedUnit",
        Name: "DummyOneofForDeprecatedUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResource",
        Name: "DummyOneofForResource",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPreserveOnUnitRemove",
        Name: "DummyOneofForPreserveOnUnitRemove",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWalkAnimationSpeed",
        Name: "DummyOneofForWalkAnimationSpeed",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModelScale",
        Name: "DummyOneofForModelScale",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionBonusRadius",
        Name: "DummyOneofForSelectionBonusRadius",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExcludeFromUnitBody",
        Name: "DummyOneofForExcludeFromUnitBody",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionShape",
        Name: "DummyOneofForSelectionShape",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionScale",
        Name: "DummyOneofForSelectionScale",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideShadow",
        Name: "DummyOneofForHideShadow",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScaleMultiplier",
        Name: "DummyOneofForScaleMultiplier",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRenderingPriority",
        Name: "DummyOneofForRenderingPriority",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpriteOptions",
        Name: "DummyOneofForSpriteOptions",
        fields: [
          this.fields[17],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitActor.descriptor = new UnitActor_Descriptor();
class ModelActor_HostSitesEntry {
  get descriptor() {
    return ModelActor_HostSitesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ModelActor_HostSitesEntry) {
      return value;
    }
    return ModelActor_HostSitesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new ModelActor_HostSitesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = HostSite.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = HostSite.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {HostSite}
   */
  get value() {
    return this._hasValue ? this._value : HostSite.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor_HostSitesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new ModelActor_HostSitesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor_HostSitesEntry(this);
              copy._hasValue = true;
              copy._value = HostSite.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new ModelActor_HostSitesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new ModelActor_HostSitesEntry(this);
            copy._hasValue = true;
            copy._value = HostSite.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new ModelActor_HostSitesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ModelActor_HostSitesEntry} other
   * @returns {ModelActor_HostSitesEntry}
   */
  merge(other) {
    const copy = new ModelActor_HostSitesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
ModelActor_HostSitesEntry.default = new ModelActor_HostSitesEntry();
class ModelActor_HostSitesEntry_Builder {
  constructor(value) {
    this._value = new ModelActor_HostSitesEntry(value);
  }
  build() {
    return new ModelActor_HostSitesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
ModelActor_HostSitesEntry.Builder = ModelActor_HostSitesEntry_Builder;
class ModelActor_HostSitesEntry_WithParent {
  /**
   * @param {ModelActor_HostSitesEntry} value
   * @param {ModelActor_HostSitesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ModelActor_HostSitesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new HostSite.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new HostSite.WithParent(HostSite.default, this._parent.value) : HostSite.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new ModelActor_HostSitesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
ModelActor_HostSitesEntry_WithParent.default = new ModelActor_HostSitesEntry_WithParent(ModelActor_HostSitesEntry.default, null);
ModelActor_HostSitesEntry.WithParent = ModelActor_HostSitesEntry_WithParent;
class ModelActor_HostSitesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: HostSite,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ModelActor_HostSitesEntry.descriptor = new ModelActor_HostSitesEntry_Descriptor();
export class ModelActor {
  get descriptor() {
    return ModelActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasResource = false;
    this._resource = null;
    this._events = [];
    this._eventMacros = [];
    this._hasHostSite = false;
    this._hostSite = null;
    this._hasDeprecatedHostSiteOperation = false;
    this._hostSiteOperation = null;
    this._hostSiteOperations = [];
    this._hostSites = {};
    this._additionalResources = [];
    this._hasModelScale = false;
    this._modelScale = null;
    this._hasSelectionBonusRadius = false;
    this._selectionBonusRadius = null;
    this._aliases = [];
    this._hasIncludeInUnitBody = false;
    this._selectable = null;
    this._hasSelectionShape = false;
    this._selectionShape = null;
    this._hasSelectionScale = false;
    this._selectionScale = null;
    this._hasHideShadow = false;
    this._hideShadow = null;
    this._hasScaleMultiplier = false;
    this._scaleMultiplier = null;
    this._hasRenderingPriority = false;
    this._renderingPriority = null;
    this._hasSpriteOptions = false;
    this._spriteOptions = null;
  }
  isEmpty() {
    if (this._hasResource && !this._resource.isEmpty()) return false;
    if (this._events.length > 0) return false;
    if (this._eventMacros.length > 0) return false;
    if (this._hasHostSite) return false;
    if (this._hasDeprecatedHostSiteOperation) return false;
    if (this._hostSiteOperations.length > 0) return false;
    if (Object.keys(this._hostSites).length > 0) return false;
    if (this._additionalResources.length > 0) return false;
    if (this._hasModelScale) return false;
    if (this._hasSelectionBonusRadius) return false;
    if (this._aliases.length > 0) return false;
    if (this._hasIncludeInUnitBody) return false;
    if (this._hasSelectionShape) return false;
    if (this._hasSelectionScale && !this._selectionScale.isEmpty()) return false;
    if (this._hasHideShadow) return false;
    if (this._hasScaleMultiplier && !this._scaleMultiplier.isEmpty()) return false;
    if (this._hasRenderingPriority) return false;
    if (this._hasSpriteOptions && !this._spriteOptions.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ModelActor) {
      return value;
    }
    return ModelActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ModelActor();
    if (json.resource != null) {
      result._hasResource = true;
      result._resource = ActorResource.fromJson(json.resource);
    }
    result._events = JsonToList(json.events, ActorEvent);
    result._eventMacros = JsonToList(json.eventMacros, JsonToString);
    if (json.hostSite != null) {
      result._hasHostSite = true;
      result._hostSite = JsonToString.fromJson(json.hostSite);
    }
    if (json.hostSiteOperation != null) {
      result._hasDeprecatedHostSiteOperation = true;
      result._hostSiteOperation = JsonToString.fromJson(json.hostSiteOperation);
    }
    result._hostSiteOperations = JsonToList(json.hostSiteOperations, JsonToString);
    result._hostSites = JsonToMap(json.hostSites, JsonToString, HostSite);
    result._additionalResources = JsonToList(json.additionalResources, ActorResource);
    if (json.modelScale != null) {
      result._hasModelScale = true;
      result._modelScale = JsonToDouble.fromJson(json.modelScale);
    }
    if (json.selectionBonusRadius != null) {
      result._hasSelectionBonusRadius = true;
      result._selectionBonusRadius = JsonToDouble.fromJson(json.selectionBonusRadius);
    }
    result._aliases = JsonToList(json.aliases, JsonToString);
    if (json.selectable != null) {
      result._hasIncludeInUnitBody = true;
      result._selectable = JsonToBoolean.fromJson(json.selectable);
    }
    if (json.selectionShape != null) {
      result._hasSelectionShape = true;
      result._selectionShape = UnitActor_SelectionShape.fromJson(json.selectionShape);
    }
    if (json.selectionScale != null) {
      result._hasSelectionScale = true;
      result._selectionScale = UnitActor_SelectionScale.fromJson(json.selectionScale);
    }
    if (json.hideShadow != null) {
      result._hasHideShadow = true;
      result._hideShadow = JsonToBoolean.fromJson(json.hideShadow);
    }
    if (json.scaleMultiplier != null) {
      result._hasScaleMultiplier = true;
      result._scaleMultiplier = InitialScale.fromJson(json.scaleMultiplier);
    }
    if (json.renderingPriority != null) {
      result._hasRenderingPriority = true;
      result._renderingPriority = JsonToInt32.fromJson(json.renderingPriority);
    }
    if (json.spriteOptions != null) {
      result._hasSpriteOptions = true;
      result._spriteOptions = SpriteOptions.fromJson(json.spriteOptions);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasResource && !this._resource.isEmpty()) {
      result.resource = ActorResource.toJson(this._resource);
    }
    if (this._events.length > 0) {
      result.events = ArrayToJson(this._events, ActorEvent);
    }
    if (this._eventMacros.length > 0) {
      result.eventMacros = ArrayToJson(this._eventMacros, JsonToString);
    }
    if (this._hasHostSite) {
      result.hostSite = JsonToString.toJson(this._hostSite);
    }
    if (this._hasDeprecatedHostSiteOperation) {
      result.hostSiteOperation = JsonToString.toJson(this._hostSiteOperation);
    }
    if (this._hostSiteOperations.length > 0) {
      result.hostSiteOperations = ArrayToJson(this._hostSiteOperations, JsonToString);
    }
    if (Object.keys(this._hostSites).length > 0) {
      result.hostSites = MapToJson(this._hostSites, JsonToString, HostSite);
    }
    if (this._additionalResources.length > 0) {
      result.additionalResources = ArrayToJson(this._additionalResources, ActorResource);
    }
    if (this._hasModelScale) {
      result.modelScale = JsonToDouble.toJson(this._modelScale);
    }
    if (this._hasSelectionBonusRadius) {
      result.selectionBonusRadius = JsonToDouble.toJson(this._selectionBonusRadius);
    }
    if (this._aliases.length > 0) {
      result.aliases = ArrayToJson(this._aliases, JsonToString);
    }
    if (this._hasIncludeInUnitBody) {
      result.selectable = JsonToBoolean.toJson(this._selectable);
    }
    if (this._hasSelectionShape) {
      result.selectionShape = UnitActor_SelectionShape.toJson(this._selectionShape);
    }
    if (this._hasSelectionScale && !this._selectionScale.isEmpty()) {
      result.selectionScale = UnitActor_SelectionScale.toJson(this._selectionScale);
    }
    if (this._hasHideShadow) {
      result.hideShadow = JsonToBoolean.toJson(this._hideShadow);
    }
    if (this._hasScaleMultiplier && !this._scaleMultiplier.isEmpty()) {
      result.scaleMultiplier = InitialScale.toJson(this._scaleMultiplier);
    }
    if (this._hasRenderingPriority) {
      result.renderingPriority = JsonToInt32.toJson(this._renderingPriority);
    }
    if (this._hasSpriteOptions && !this._spriteOptions.isEmpty()) {
      result.spriteOptions = SpriteOptions.toJson(this._spriteOptions);
    }
    return result;
  }
  /**
   * @returns {ActorResource}
   */
  get resource() {
    return this._hasResource ? this._resource : ActorResource.default;
  }
  get hasResource() {
    return this._hasResource;
  }
  setResource(path, value) {
    return {type: 'SET', path: path.concat(['resource']), value: value.toJson()};
  }
  deleteResource(path) {
    return {type: 'DELETE', path: path.concat(['resource'])};
  }
  /**
   * @returns {ActorEvent[]}
   */
  get events() {
    return this._events;
  }
  addEvents(path, value) {
    return {type: 'ADD', path: path.concat(['events']), value: value.toJson()};
  }
  setEvents(path, value) {
    return {type: 'SET', path: path.concat(['events']), value: ArrayToJson(value, ActorEvent)};
  }
  setEventsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['events', key]), value: value.toJson()};
  }
  deleteEvents(path) {
    return {type: 'DELETE', path: path.concat(['events'])};
  }
  deleteEventsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['events', key])};
  }
  /**
   * @returns {string[]}
   */
  get eventMacros() {
    return this._eventMacros;
  }
  addEventMacros(path, value) {
    return {type: 'ADD', path: path.concat(['eventMacros']), value};
  }
  setEventMacros(path, value) {
    return {type: 'SET', path: path.concat(['eventMacros']), value: ArrayToJson(value, JsonToString)};
  }
  setEventMacrosByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['eventMacros', key]), value};
  }
  deleteEventMacros(path) {
    return {type: 'DELETE', path: path.concat(['eventMacros'])};
  }
  deleteEventMacrosByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['eventMacros', key])};
  }
  /**
   * @returns {string}
   */
  get hostSite() {
    return this._hasHostSite ? this._hostSite : JsonToString.default;
  }
  get hasHostSite() {
    return this._hasHostSite;
  }
  setHostSite(path, value) {
    return {type: 'SET', path: path.concat(['hostSite']), value};
  }
  deleteHostSite(path) {
    return {type: 'DELETE', path: path.concat(['hostSite'])};
  }
  /**
   * @returns {string}
   */
  get hostSiteOperation() {
    return this._hasDeprecatedHostSiteOperation ? this._hostSiteOperation : JsonToString.default;
  }
  get hasDeprecatedHostSiteOperation() {
    return this._hasDeprecatedHostSiteOperation;
  }
  setDeprecatedHostSiteOperation(path, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperation']), value};
  }
  deleteDeprecatedHostSiteOperation(path) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperation'])};
  }
  /**
   * @returns {string[]}
   */
  get hostSiteOperations() {
    return this._hostSiteOperations;
  }
  addHostSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['hostSiteOperations']), value};
  }
  setHostSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setHostSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations', key]), value};
  }
  deleteHostSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations'])};
  }
  deleteHostSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations', key])};
  }
  /**
   * @returns {Object<string, HostSite>}
   */
  get hostSites() {
    return this._hostSites;
  }
  setHostSites(path, value) {
    return {type: 'SET', path: path.concat(['hostSites']), value: MapToJson(value, JsonToString, HostSite)};
  }
  setHostSitesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['hostSites', key]), value: value.toJson()};
  }
  deleteHostSites(path) {
    return {type: 'DELETE', path: path.concat(['hostSites'])};
  }
  deleteHostSitesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['hostSites', key])};
  }
  /**
   * @returns {ActorResource[]}
   */
  get additionalResources() {
    return this._additionalResources;
  }
  addAdditionalResources(path, value) {
    return {type: 'ADD', path: path.concat(['additionalResources']), value: value.toJson()};
  }
  setAdditionalResources(path, value) {
    return {type: 'SET', path: path.concat(['additionalResources']), value: ArrayToJson(value, ActorResource)};
  }
  setAdditionalResourcesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['additionalResources', key]), value: value.toJson()};
  }
  deleteAdditionalResources(path) {
    return {type: 'DELETE', path: path.concat(['additionalResources'])};
  }
  deleteAdditionalResourcesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['additionalResources', key])};
  }
  /**
   * @returns {number}
   */
  get modelScale() {
    return this._hasModelScale ? this._modelScale : JsonToDouble.default;
  }
  get hasModelScale() {
    return this._hasModelScale;
  }
  setModelScale(path, value) {
    return {type: 'SET', path: path.concat(['modelScale']), value};
  }
  deleteModelScale(path) {
    return {type: 'DELETE', path: path.concat(['modelScale'])};
  }
  /**
   * @returns {number}
   */
  get selectionBonusRadius() {
    return this._hasSelectionBonusRadius ? this._selectionBonusRadius : JsonToDouble.default;
  }
  get hasSelectionBonusRadius() {
    return this._hasSelectionBonusRadius;
  }
  setSelectionBonusRadius(path, value) {
    return {type: 'SET', path: path.concat(['selectionBonusRadius']), value};
  }
  deleteSelectionBonusRadius(path) {
    return {type: 'DELETE', path: path.concat(['selectionBonusRadius'])};
  }
  /**
   * @returns {string[]}
   */
  get aliases() {
    return this._aliases;
  }
  addAliases(path, value) {
    return {type: 'ADD', path: path.concat(['aliases']), value};
  }
  setAliases(path, value) {
    return {type: 'SET', path: path.concat(['aliases']), value: ArrayToJson(value, JsonToString)};
  }
  setAliasesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['aliases', key]), value};
  }
  deleteAliases(path) {
    return {type: 'DELETE', path: path.concat(['aliases'])};
  }
  deleteAliasesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['aliases', key])};
  }
  /**
   * @returns {boolean}
   */
  get selectable() {
    return this._hasIncludeInUnitBody ? this._selectable : JsonToBoolean.default;
  }
  get hasIncludeInUnitBody() {
    return this._hasIncludeInUnitBody;
  }
  setIncludeInUnitBody(path, value) {
    return {type: 'SET', path: path.concat(['selectable']), value};
  }
  deleteIncludeInUnitBody(path) {
    return {type: 'DELETE', path: path.concat(['selectable'])};
  }
  /**
   * @returns {number}
   */
  get selectionShape() {
    return this._hasSelectionShape ? this._selectionShape : UnitActor_SelectionShape.default;
  }
  get hasSelectionShape() {
    return this._hasSelectionShape;
  }
  setSelectionShape(path, value) {
    return {type: 'SET', path: path.concat(['selectionShape']), value};
  }
  deleteSelectionShape(path) {
    return {type: 'DELETE', path: path.concat(['selectionShape'])};
  }
  /**
   * @returns {UnitActor_SelectionScale}
   */
  get selectionScale() {
    return this._hasSelectionScale ? this._selectionScale : UnitActor_SelectionScale.default;
  }
  get hasSelectionScale() {
    return this._hasSelectionScale;
  }
  setSelectionScale(path, value) {
    return {type: 'SET', path: path.concat(['selectionScale']), value: value.toJson()};
  }
  deleteSelectionScale(path) {
    return {type: 'DELETE', path: path.concat(['selectionScale'])};
  }
  /**
   * @returns {boolean}
   */
  get hideShadow() {
    return this._hasHideShadow ? this._hideShadow : JsonToBoolean.default;
  }
  get hasHideShadow() {
    return this._hasHideShadow;
  }
  setHideShadow(path, value) {
    return {type: 'SET', path: path.concat(['hideShadow']), value};
  }
  deleteHideShadow(path) {
    return {type: 'DELETE', path: path.concat(['hideShadow'])};
  }
  /**
   * @returns {InitialScale}
   */
  get scaleMultiplier() {
    return this._hasScaleMultiplier ? this._scaleMultiplier : InitialScale.default;
  }
  get hasScaleMultiplier() {
    return this._hasScaleMultiplier;
  }
  setScaleMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['scaleMultiplier']), value: value.toJson()};
  }
  deleteScaleMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['scaleMultiplier'])};
  }
  /**
   * @returns {number}
   */
  get renderingPriority() {
    return this._hasRenderingPriority ? this._renderingPriority : JsonToInt32.default;
  }
  get hasRenderingPriority() {
    return this._hasRenderingPriority;
  }
  setRenderingPriority(path, value) {
    return {type: 'SET', path: path.concat(['renderingPriority']), value};
  }
  deleteRenderingPriority(path) {
    return {type: 'DELETE', path: path.concat(['renderingPriority'])};
  }
  /**
   * @returns {SpriteOptions}
   */
  get spriteOptions() {
    return this._hasSpriteOptions ? this._spriteOptions : SpriteOptions.default;
  }
  get hasSpriteOptions() {
    return this._hasSpriteOptions;
  }
  setSpriteOptions(path, value) {
    return {type: 'SET', path: path.concat(['spriteOptions']), value: value.toJson()};
  }
  deleteSpriteOptions(path) {
    return {type: 'DELETE', path: path.concat(['spriteOptions'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "resource": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasResource = true;
              copy._resource = ActorResource.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResource) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasResource = false;
              copy._resource = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasResource) {
            const copy = new ModelActor(this);
            copy._hasResource = true;
            copy._resource = ActorResource.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._resource.apply(type, path.slice(1), value);
          if (newValue === this._resource) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._resource = copy._resource.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "events": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._events = [];        for (let i of value) {
                copy._events.push(ActorEvent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ModelActor(this);
              copy._events = copy._events.concat([ActorEvent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._events.length === 0) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._events = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._events.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._events = copy._events.slice();
              copy._events[path[1]] = ActorEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ModelActor(this);
              copy._events = copy._events.slice(0, path[1]).concat(copy._events.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._events.length) {
            return this;
          }
          const oldValue = this._events[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._events = copy._events.slice();
          copy._events[key] = newValue;
          return copy;
        }
      }
      case "eventMacros": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._eventMacros = [];        for (let i of value) {
                copy._eventMacros.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ModelActor(this);
              copy._eventMacros = copy._eventMacros.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._eventMacros.length === 0) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._eventMacros = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._eventMacros.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._eventMacros = copy._eventMacros.slice();
              copy._eventMacros[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ModelActor(this);
              copy._eventMacros = copy._eventMacros.slice(0, path[1]).concat(copy._eventMacros.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._eventMacros.length) {
            return this;
          }
          const oldValue = this._eventMacros[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._eventMacros = copy._eventMacros.slice();
          copy._eventMacros[key] = newValue;
          return copy;
        }
      }
      case "hostSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasHostSite = true;
              copy._hostSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHostSite) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasHostSite = false;
              copy._hostSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSiteOperation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasDeprecatedHostSiteOperation = true;
              copy._hostSiteOperation = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedHostSiteOperation) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasDeprecatedHostSiteOperation = false;
              copy._hostSiteOperation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hostSiteOperations = [];        for (let i of value) {
                copy._hostSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ModelActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._hostSiteOperations.length === 0) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hostSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice();
              copy._hostSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ModelActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice(0, path[1]).concat(copy._hostSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          const oldValue = this._hostSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._hostSiteOperations = copy._hostSiteOperations.slice();
          copy._hostSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "hostSites": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._hostSites).length === 0) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hostSites = {};
              return copy;
            }
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hostSites = {};
              for (let key in value) {
                copy._hostSites[key] = HostSite.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hostSites = {...copy._hostSites};
              copy._hostSites[path[1]] = HostSite.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hostSites[path[1]]) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hostSites = {...copy._hostSites};
              delete copy._hostSites[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._hostSites[key] === undefined) {
            const copy = new ModelActor(this);
            copy._hostSites = {...copy._hostSites};
            copy._hostSites[key] = HostSite.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._hostSites[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._hostSites = {...copy._hostSites};
          copy._hostSites[key] = newValue;
          return copy;
        }
      }
      case "additionalResources": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._additionalResources = [];        for (let i of value) {
                copy._additionalResources.push(ActorResource.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ModelActor(this);
              copy._additionalResources = copy._additionalResources.concat([ActorResource.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._additionalResources.length === 0) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._additionalResources = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._additionalResources.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._additionalResources = copy._additionalResources.slice();
              copy._additionalResources[path[1]] = ActorResource.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ModelActor(this);
              copy._additionalResources = copy._additionalResources.slice(0, path[1]).concat(copy._additionalResources.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._additionalResources.length) {
            return this;
          }
          const oldValue = this._additionalResources[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._additionalResources = copy._additionalResources.slice();
          copy._additionalResources[key] = newValue;
          return copy;
        }
      }
      case "modelScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasModelScale = true;
              copy._modelScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModelScale) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasModelScale = false;
              copy._modelScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectionBonusRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasSelectionBonusRadius = true;
              copy._selectionBonusRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionBonusRadius) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasSelectionBonusRadius = false;
              copy._selectionBonusRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "aliases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._aliases = [];        for (let i of value) {
                copy._aliases.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ModelActor(this);
              copy._aliases = copy._aliases.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._aliases.length === 0) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._aliases = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._aliases = copy._aliases.slice();
              copy._aliases[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ModelActor(this);
              copy._aliases = copy._aliases.slice(0, path[1]).concat(copy._aliases.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._aliases.length) {
            return this;
          }
          const oldValue = this._aliases[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._aliases = copy._aliases.slice();
          copy._aliases[key] = newValue;
          return copy;
        }
      }
      case "selectable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasIncludeInUnitBody = true;
              copy._selectable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIncludeInUnitBody) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasIncludeInUnitBody = false;
              copy._selectable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectionShape": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasSelectionShape = true;
              copy._selectionShape = UnitActor_SelectionShape.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionShape) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasSelectionShape = false;
              copy._selectionShape = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectionScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasSelectionScale = true;
              copy._selectionScale = UnitActor_SelectionScale.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionScale) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasSelectionScale = false;
              copy._selectionScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSelectionScale) {
            const copy = new ModelActor(this);
            copy._hasSelectionScale = true;
            copy._selectionScale = UnitActor_SelectionScale.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._selectionScale.apply(type, path.slice(1), value);
          if (newValue === this._selectionScale) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._selectionScale = copy._selectionScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "hideShadow": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasHideShadow = true;
              copy._hideShadow = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideShadow) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasHideShadow = false;
              copy._hideShadow = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scaleMultiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasScaleMultiplier = true;
              copy._scaleMultiplier = InitialScale.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScaleMultiplier) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasScaleMultiplier = false;
              copy._scaleMultiplier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasScaleMultiplier) {
            const copy = new ModelActor(this);
            copy._hasScaleMultiplier = true;
            copy._scaleMultiplier = InitialScale.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._scaleMultiplier.apply(type, path.slice(1), value);
          if (newValue === this._scaleMultiplier) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._scaleMultiplier = copy._scaleMultiplier.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "renderingPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasRenderingPriority = true;
              copy._renderingPriority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRenderingPriority) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasRenderingPriority = false;
              copy._renderingPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spriteOptions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ModelActor(this);
              copy._hasSpriteOptions = true;
              copy._spriteOptions = SpriteOptions.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpriteOptions) {
                return this;
              }
              const copy = new ModelActor(this);
              copy._hasSpriteOptions = false;
              copy._spriteOptions = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSpriteOptions) {
            const copy = new ModelActor(this);
            copy._hasSpriteOptions = true;
            copy._spriteOptions = SpriteOptions.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._spriteOptions.apply(type, path.slice(1), value);
          if (newValue === this._spriteOptions) {
            return this;
          }
          const copy = new ModelActor(this);
          copy._spriteOptions = copy._spriteOptions.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ModelActor} other
   * @returns {ModelActor}
   */
  merge(other) {
    const copy = new ModelActor(this);
    if (other._hasResource) {
      if (copy._hasResource) {
        copy._resource = copy.resource.merge(other.resource);
      } else {
        copy._resource = other._resource;
      }
      copy._hasResource = true;
    }
    copy._events = this._events.concat(other._events);
    copy._eventMacros = this._eventMacros.concat(other._eventMacros);
    if (other._hasHostSite) {
      copy._hasHostSite = true;
      copy._hostSite = other._hostSite;
    }
    if (other._hasDeprecatedHostSiteOperation) {
      copy._hasDeprecatedHostSiteOperation = true;
      copy._hostSiteOperation = other._hostSiteOperation;
    }
    copy._hostSiteOperations = this._hostSiteOperations.concat(other._hostSiteOperations);
    copy._hostSites = {...this._hostSites, ...other._hostSites};
    copy._additionalResources = this._additionalResources.concat(other._additionalResources);
    if (other._hasModelScale) {
      copy._hasModelScale = true;
      copy._modelScale = other._modelScale;
    }
    if (other._hasSelectionBonusRadius) {
      copy._hasSelectionBonusRadius = true;
      copy._selectionBonusRadius = other._selectionBonusRadius;
    }
    copy._aliases = this._aliases.concat(other._aliases);
    if (other._hasIncludeInUnitBody) {
      copy._hasIncludeInUnitBody = true;
      copy._selectable = other._selectable;
    }
    if (other._hasSelectionShape) {
      copy._hasSelectionShape = true;
      copy._selectionShape = other._selectionShape;
    }
    if (other._hasSelectionScale) {
      if (copy._hasSelectionScale) {
        copy._selectionScale = copy.selectionScale.merge(other.selectionScale);
      } else {
        copy._selectionScale = other._selectionScale;
      }
      copy._hasSelectionScale = true;
    }
    if (other._hasHideShadow) {
      copy._hasHideShadow = true;
      copy._hideShadow = other._hideShadow;
    }
    if (other._hasScaleMultiplier) {
      if (copy._hasScaleMultiplier) {
        copy._scaleMultiplier = copy.scaleMultiplier.merge(other.scaleMultiplier);
      } else {
        copy._scaleMultiplier = other._scaleMultiplier;
      }
      copy._hasScaleMultiplier = true;
    }
    if (other._hasRenderingPriority) {
      copy._hasRenderingPriority = true;
      copy._renderingPriority = other._renderingPriority;
    }
    if (other._hasSpriteOptions) {
      if (copy._hasSpriteOptions) {
        copy._spriteOptions = copy.spriteOptions.merge(other.spriteOptions);
      } else {
        copy._spriteOptions = other._spriteOptions;
      }
      copy._hasSpriteOptions = true;
    }
    return copy;
  }
}
ModelActor.default = new ModelActor();
ModelActor.HostSitesEntry = ModelActor_HostSitesEntry;
class ModelActor_Builder {
  constructor(value) {
    this._value = new ModelActor(value);
  }
  build() {
    return new ModelActor(this._value);
  }
  setResource(value) {
    this._value._hasResource = true;
    this._value._resource = value;
    return this;
  }
  deleteResource() {
    this._value._hasResource = false;
    this._value._resource = null;
    return this;
  }
  addAllEvents(values) {
    this._value._events = this._value._events.concat(values);
    return this;
  }
  addEvents(value) {
    this._value._events = this._value._events.concat([value]);
    return this;
  }
  setEvents(index, value) {
    this._value._events = this._value._events.concat();
    this._value._events[index] = value;
    return this;
  }
  clearEvents() {
    this._value._events = [];
    return this;
  }
  addAllEventMacros(values) {
    this._value._eventMacros = this._value._eventMacros.concat(values);
    return this;
  }
  addEventMacros(value) {
    this._value._eventMacros = this._value._eventMacros.concat([value]);
    return this;
  }
  setEventMacros(index, value) {
    this._value._eventMacros = this._value._eventMacros.concat();
    this._value._eventMacros[index] = value;
    return this;
  }
  clearEventMacros() {
    this._value._eventMacros = [];
    return this;
  }
  setHostSite(value) {
    this._value._hasHostSite = true;
    this._value._hostSite = value;
    return this;
  }
  deleteHostSite() {
    this._value._hasHostSite = false;
    this._value._hostSite = null;
    return this;
  }
  setDeprecatedHostSiteOperation(value) {
    this._value._hasDeprecatedHostSiteOperation = true;
    this._value._hostSiteOperation = value;
    return this;
  }
  deleteDeprecatedHostSiteOperation() {
    this._value._hasDeprecatedHostSiteOperation = false;
    this._value._hostSiteOperation = null;
    return this;
  }
  addAllHostSiteOperations(values) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat(values);
    return this;
  }
  addHostSiteOperations(value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat([value]);
    return this;
  }
  setHostSiteOperations(index, value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat();
    this._value._hostSiteOperations[index] = value;
    return this;
  }
  clearHostSiteOperations() {
    this._value._hostSiteOperations = [];
    return this;
  }
  setHostSites(key, value) {
    this._value._hostSites = {...this._value._hostSites, [key]: value};
    return this;
  }
  addAllHostSites(values) {
    this._value._hostSites = {...this._value._hostSites, ...values};
    return this;
  }
  deleteHostSites(key) {
    this._value._hostSites = {...this._value._hostSites};
    delete this._value._hostSites[key];
    return this;
  }
  clearHostSites() {
    this._value._hostSites = {};
    return this;
  }
  addAllAdditionalResources(values) {
    this._value._additionalResources = this._value._additionalResources.concat(values);
    return this;
  }
  addAdditionalResources(value) {
    this._value._additionalResources = this._value._additionalResources.concat([value]);
    return this;
  }
  setAdditionalResources(index, value) {
    this._value._additionalResources = this._value._additionalResources.concat();
    this._value._additionalResources[index] = value;
    return this;
  }
  clearAdditionalResources() {
    this._value._additionalResources = [];
    return this;
  }
  setModelScale(value) {
    this._value._hasModelScale = true;
    this._value._modelScale = value;
    return this;
  }
  deleteModelScale() {
    this._value._hasModelScale = false;
    this._value._modelScale = null;
    return this;
  }
  setSelectionBonusRadius(value) {
    this._value._hasSelectionBonusRadius = true;
    this._value._selectionBonusRadius = value;
    return this;
  }
  deleteSelectionBonusRadius() {
    this._value._hasSelectionBonusRadius = false;
    this._value._selectionBonusRadius = null;
    return this;
  }
  addAllAliases(values) {
    this._value._aliases = this._value._aliases.concat(values);
    return this;
  }
  addAliases(value) {
    this._value._aliases = this._value._aliases.concat([value]);
    return this;
  }
  setAliases(index, value) {
    this._value._aliases = this._value._aliases.concat();
    this._value._aliases[index] = value;
    return this;
  }
  clearAliases() {
    this._value._aliases = [];
    return this;
  }
  setIncludeInUnitBody(value) {
    this._value._hasIncludeInUnitBody = true;
    this._value._selectable = value;
    return this;
  }
  deleteIncludeInUnitBody() {
    this._value._hasIncludeInUnitBody = false;
    this._value._selectable = null;
    return this;
  }
  setSelectionShape(value) {
    this._value._hasSelectionShape = true;
    this._value._selectionShape = value;
    return this;
  }
  deleteSelectionShape() {
    this._value._hasSelectionShape = false;
    this._value._selectionShape = null;
    return this;
  }
  setSelectionScale(value) {
    this._value._hasSelectionScale = true;
    this._value._selectionScale = value;
    return this;
  }
  deleteSelectionScale() {
    this._value._hasSelectionScale = false;
    this._value._selectionScale = null;
    return this;
  }
  setHideShadow(value) {
    this._value._hasHideShadow = true;
    this._value._hideShadow = value;
    return this;
  }
  deleteHideShadow() {
    this._value._hasHideShadow = false;
    this._value._hideShadow = null;
    return this;
  }
  setScaleMultiplier(value) {
    this._value._hasScaleMultiplier = true;
    this._value._scaleMultiplier = value;
    return this;
  }
  deleteScaleMultiplier() {
    this._value._hasScaleMultiplier = false;
    this._value._scaleMultiplier = null;
    return this;
  }
  setRenderingPriority(value) {
    this._value._hasRenderingPriority = true;
    this._value._renderingPriority = value;
    return this;
  }
  deleteRenderingPriority() {
    this._value._hasRenderingPriority = false;
    this._value._renderingPriority = null;
    return this;
  }
  setSpriteOptions(value) {
    this._value._hasSpriteOptions = true;
    this._value._spriteOptions = value;
    return this;
  }
  deleteSpriteOptions() {
    this._value._hasSpriteOptions = false;
    this._value._spriteOptions = null;
    return this;
  }
}
ModelActor.Builder = ModelActor_Builder;
class ModelActor_WithParent {
  /**
   * @param {ModelActor} value
   * @param {ModelActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ModelActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasResource() {
    if (this._cachedHasResource === undefined) {
      if (this._value.hasResource) {
        this._cachedHasResource = true;
      } else {
        this._cachedHasResource = this._parent ? this._parent.hasResource : false;
      }
    }
    return this._cachedHasResource;
  }
  get resource() {
    if (!this._cachedResource) {
      if (this._value.hasResource) {
        this._cachedResource = new ActorResource.WithParent(this._value.resource, this._parent && this._parent.hasResource ? this._parent.resource : null);
      } else {
        this._cachedResource = this._parent ? new ActorResource.WithParent(ActorResource.default, this._parent.resource) : ActorResource.WithParent.default;
      }
    }
    return this._cachedResource;
  }
  get selfEvents() {
    if (!this._selfEvents) {
      this._selfEvents = [];
      for (let i of this._value.events) {
        this._selfEvents.push(new ActorEvent.WithParent(i, null));
      }
    }
    return this._selfEvents;
  }
  get inherentEvents() {
    if (!this._inherentEvents) {
      this._inherentEvents = this._parent ? this._parent.events : [];
    }
    return this._inherentEvents;
  }
  get events() {
    if (!this._allEvents) {
      this._allEvents = this._parent ? this._parent.events.concat(this.selfEvents) : this.selfEvents;
    }
    return this._allEvents;
  }
  get selfEventMacros() {
    return this._value.eventMacros;
  }
  get inherentEventMacros() {
    if (!this._inherentEventMacros) {
      this._inherentEventMacros = this._parent ? this._parent.eventMacros : [];
    }
    return this._inherentEventMacros;
  }
  get eventMacros() {
    if (!this._allEventMacros) {
      this._allEventMacros = this._parent ? this._parent.eventMacros.concat(this.selfEventMacros) : this.selfEventMacros;
    }
    return this._allEventMacros;
  }
  get hasHostSite() {
    if (this._cachedHasHostSite === undefined) {
      if (this._value.hasHostSite) {
        this._cachedHasHostSite = true;
      } else {
        this._cachedHasHostSite = this._parent ? this._parent.hasHostSite : false;
      }
    }
    return this._cachedHasHostSite;
  }
  get hostSite() {
    if (this._cachedHostSite === undefined) {
      if (this._value.hasHostSite) {
        this._cachedHostSite = this._value.hostSite;
      } else {
        this._cachedHostSite = this._parent ? this._parent.hostSite : this._value.hostSite;
      }
    }
    return this._cachedHostSite;
  }
  get hasDeprecatedHostSiteOperation() {
    if (this._cachedHasDeprecatedHostSiteOperation === undefined) {
      if (this._value.hasDeprecatedHostSiteOperation) {
        this._cachedHasDeprecatedHostSiteOperation = true;
      } else {
        this._cachedHasDeprecatedHostSiteOperation = this._parent ? this._parent.hasDeprecatedHostSiteOperation : false;
      }
    }
    return this._cachedHasDeprecatedHostSiteOperation;
  }
  get hostSiteOperation() {
    if (this._cachedDeprecatedHostSiteOperation === undefined) {
      if (this._value.hasDeprecatedHostSiteOperation) {
        this._cachedDeprecatedHostSiteOperation = this._value.hostSiteOperation;
      } else {
        this._cachedDeprecatedHostSiteOperation = this._parent ? this._parent.hostSiteOperation : this._value.hostSiteOperation;
      }
    }
    return this._cachedDeprecatedHostSiteOperation;
  }
  get selfHostSiteOperations() {
    return this._value.hostSiteOperations;
  }
  get inherentHostSiteOperations() {
    if (!this._inherentHostSiteOperations) {
      this._inherentHostSiteOperations = this._parent ? this._parent.hostSiteOperations : [];
    }
    return this._inherentHostSiteOperations;
  }
  get hostSiteOperations() {
    if (!this._allHostSiteOperations) {
      this._allHostSiteOperations = this._parent ? this._parent.hostSiteOperations.concat(this.selfHostSiteOperations) : this.selfHostSiteOperations;
    }
    return this._allHostSiteOperations;
  }
  get selfHostSites() {
    if (!this._selfHostSites) {
      this._selfHostSites = {};
      for (let i in this._value.hostSites) {
        this._selfHostSites[i] = new HostSite.WithParent(this._value.hostSites[i], null);
      }
    }
    return this._selfHostSites;
  }
  get inherentHostSites() {
    if (!this._inherentHostSites) {
      this._inherentHostSites = this._parent ? this._parent.hostSites : {};
    }
    return this._inherentHostSites;
  }
  get hostSites() {
    if (!this._allHostSites) {
      this._allHostSites = this._parent ? {...this._parent.hostSites, ...this.selfHostSites} : this.selfHostSites;
    }
    return this._allHostSites;
  }
  get selfAdditionalResources() {
    if (!this._selfAdditionalResources) {
      this._selfAdditionalResources = [];
      for (let i of this._value.additionalResources) {
        this._selfAdditionalResources.push(new ActorResource.WithParent(i, null));
      }
    }
    return this._selfAdditionalResources;
  }
  get inherentAdditionalResources() {
    if (!this._inherentAdditionalResources) {
      this._inherentAdditionalResources = this._parent ? this._parent.additionalResources : [];
    }
    return this._inherentAdditionalResources;
  }
  get additionalResources() {
    if (!this._allAdditionalResources) {
      this._allAdditionalResources = this._parent ? this._parent.additionalResources.concat(this.selfAdditionalResources) : this.selfAdditionalResources;
    }
    return this._allAdditionalResources;
  }
  get hasModelScale() {
    if (this._cachedHasModelScale === undefined) {
      if (this._value.hasModelScale) {
        this._cachedHasModelScale = true;
      } else {
        this._cachedHasModelScale = this._parent ? this._parent.hasModelScale : false;
      }
    }
    return this._cachedHasModelScale;
  }
  get modelScale() {
    if (this._cachedModelScale === undefined) {
      if (this._value.hasModelScale) {
        this._cachedModelScale = this._value.modelScale;
      } else {
        this._cachedModelScale = this._parent ? this._parent.modelScale : this._value.modelScale;
      }
    }
    return this._cachedModelScale;
  }
  get hasSelectionBonusRadius() {
    if (this._cachedHasSelectionBonusRadius === undefined) {
      if (this._value.hasSelectionBonusRadius) {
        this._cachedHasSelectionBonusRadius = true;
      } else {
        this._cachedHasSelectionBonusRadius = this._parent ? this._parent.hasSelectionBonusRadius : false;
      }
    }
    return this._cachedHasSelectionBonusRadius;
  }
  get selectionBonusRadius() {
    if (this._cachedSelectionBonusRadius === undefined) {
      if (this._value.hasSelectionBonusRadius) {
        this._cachedSelectionBonusRadius = this._value.selectionBonusRadius;
      } else {
        this._cachedSelectionBonusRadius = this._parent ? this._parent.selectionBonusRadius : this._value.selectionBonusRadius;
      }
    }
    return this._cachedSelectionBonusRadius;
  }
  get selfAliases() {
    return this._value.aliases;
  }
  get inherentAliases() {
    if (!this._inherentAliases) {
      this._inherentAliases = this._parent ? this._parent.aliases : [];
    }
    return this._inherentAliases;
  }
  get aliases() {
    if (!this._allAliases) {
      this._allAliases = this._parent ? this._parent.aliases.concat(this.selfAliases) : this.selfAliases;
    }
    return this._allAliases;
  }
  get hasIncludeInUnitBody() {
    if (this._cachedHasIncludeInUnitBody === undefined) {
      if (this._value.hasIncludeInUnitBody) {
        this._cachedHasIncludeInUnitBody = true;
      } else {
        this._cachedHasIncludeInUnitBody = this._parent ? this._parent.hasIncludeInUnitBody : false;
      }
    }
    return this._cachedHasIncludeInUnitBody;
  }
  get selectable() {
    if (this._cachedIncludeInUnitBody === undefined) {
      if (this._value.hasIncludeInUnitBody) {
        this._cachedIncludeInUnitBody = this._value.selectable;
      } else {
        this._cachedIncludeInUnitBody = this._parent ? this._parent.selectable : this._value.selectable;
      }
    }
    return this._cachedIncludeInUnitBody;
  }
  get hasSelectionShape() {
    if (this._cachedHasSelectionShape === undefined) {
      if (this._value.hasSelectionShape) {
        this._cachedHasSelectionShape = true;
      } else {
        this._cachedHasSelectionShape = this._parent ? this._parent.hasSelectionShape : false;
      }
    }
    return this._cachedHasSelectionShape;
  }
  get selectionShape() {
    if (this._cachedSelectionShape === undefined) {
      if (this._value.hasSelectionShape) {
        this._cachedSelectionShape = this._value.selectionShape;
      } else {
        this._cachedSelectionShape = this._parent ? this._parent.selectionShape : this._value.selectionShape;
      }
    }
    return this._cachedSelectionShape;
  }
  get hasSelectionScale() {
    if (this._cachedHasSelectionScale === undefined) {
      if (this._value.hasSelectionScale) {
        this._cachedHasSelectionScale = true;
      } else {
        this._cachedHasSelectionScale = this._parent ? this._parent.hasSelectionScale : false;
      }
    }
    return this._cachedHasSelectionScale;
  }
  get selectionScale() {
    if (!this._cachedSelectionScale) {
      if (this._value.hasSelectionScale) {
        this._cachedSelectionScale = new UnitActor_SelectionScale.WithParent(this._value.selectionScale, this._parent && this._parent.hasSelectionScale ? this._parent.selectionScale : null);
      } else {
        this._cachedSelectionScale = this._parent ? new UnitActor_SelectionScale.WithParent(UnitActor_SelectionScale.default, this._parent.selectionScale) : UnitActor_SelectionScale.WithParent.default;
      }
    }
    return this._cachedSelectionScale;
  }
  get hasHideShadow() {
    if (this._cachedHasHideShadow === undefined) {
      if (this._value.hasHideShadow) {
        this._cachedHasHideShadow = true;
      } else {
        this._cachedHasHideShadow = this._parent ? this._parent.hasHideShadow : false;
      }
    }
    return this._cachedHasHideShadow;
  }
  get hideShadow() {
    if (this._cachedHideShadow === undefined) {
      if (this._value.hasHideShadow) {
        this._cachedHideShadow = this._value.hideShadow;
      } else {
        this._cachedHideShadow = this._parent ? this._parent.hideShadow : this._value.hideShadow;
      }
    }
    return this._cachedHideShadow;
  }
  get hasScaleMultiplier() {
    if (this._cachedHasScaleMultiplier === undefined) {
      if (this._value.hasScaleMultiplier) {
        this._cachedHasScaleMultiplier = true;
      } else {
        this._cachedHasScaleMultiplier = this._parent ? this._parent.hasScaleMultiplier : false;
      }
    }
    return this._cachedHasScaleMultiplier;
  }
  get scaleMultiplier() {
    if (!this._cachedScaleMultiplier) {
      if (this._value.hasScaleMultiplier) {
        this._cachedScaleMultiplier = new InitialScale.WithParent(this._value.scaleMultiplier, this._parent && this._parent.hasScaleMultiplier ? this._parent.scaleMultiplier : null);
      } else {
        this._cachedScaleMultiplier = this._parent ? new InitialScale.WithParent(InitialScale.default, this._parent.scaleMultiplier) : InitialScale.WithParent.default;
      }
    }
    return this._cachedScaleMultiplier;
  }
  get hasRenderingPriority() {
    if (this._cachedHasRenderingPriority === undefined) {
      if (this._value.hasRenderingPriority) {
        this._cachedHasRenderingPriority = true;
      } else {
        this._cachedHasRenderingPriority = this._parent ? this._parent.hasRenderingPriority : false;
      }
    }
    return this._cachedHasRenderingPriority;
  }
  get renderingPriority() {
    if (this._cachedRenderingPriority === undefined) {
      if (this._value.hasRenderingPriority) {
        this._cachedRenderingPriority = this._value.renderingPriority;
      } else {
        this._cachedRenderingPriority = this._parent ? this._parent.renderingPriority : this._value.renderingPriority;
      }
    }
    return this._cachedRenderingPriority;
  }
  get hasSpriteOptions() {
    if (this._cachedHasSpriteOptions === undefined) {
      if (this._value.hasSpriteOptions) {
        this._cachedHasSpriteOptions = true;
      } else {
        this._cachedHasSpriteOptions = this._parent ? this._parent.hasSpriteOptions : false;
      }
    }
    return this._cachedHasSpriteOptions;
  }
  get spriteOptions() {
    if (!this._cachedSpriteOptions) {
      if (this._value.hasSpriteOptions) {
        this._cachedSpriteOptions = new SpriteOptions.WithParent(this._value.spriteOptions, this._parent && this._parent.hasSpriteOptions ? this._parent.spriteOptions : null);
      } else {
        this._cachedSpriteOptions = this._parent ? new SpriteOptions.WithParent(SpriteOptions.default, this._parent.spriteOptions) : SpriteOptions.WithParent.default;
      }
    }
    return this._cachedSpriteOptions;
  }
  update(current, parent) {
    const result = new ModelActor_WithParent(current, parent);
    if (this._cachedResource && this._value.hasResource && current.hasResource) {
      if (this._value.resource === current.resource && this._parent === parent) {
        result._cachedResource = this._cachedResource;
      } else {
        result._cachedResource = this._cachedResource.update(current.resource, parent && parent.hasResource ? parent.resource : null);
      }
    }
    if (this._selfEvents) {
      if (this._value.events === current.events) {
        result._selfEvents = this._selfEvents;
      } else {
        result._selfEvents = [];
        for (let i = 0; i < current.events.length; i++) {
          const oldValue = this._value.events[i];
          if (oldValue) {
            const oldCache = this._selfEvents[i];
            if (oldValue === current.events[i]) {
              result._selfEvents[i] = oldCache;
            } else {
              result._selfEvents[i] = oldCache.update(current.events[i], null);
            }
          } else {
            result._selfEvents[i] = new ActorEvent.WithParent(current.events[i], null);
          }
        }
      }
    }
    if (this._selfHostSites) {
      if (this._value.hostSites === current.hostSites) {
        result._selfHostSites = this._selfHostSites;
      } else {
        result._selfHostSites = {};
        for (let i in current.hostSites) {
          const oldValue = this._value.hostSites[i];
          if (oldValue) {
            const oldCache = this._selfHostSites[i];
            if (oldValue === current.hostSites[i]) {
              result._selfHostSites[i] = oldCache;
            } else {
              result._selfHostSites[i] = oldCache.update(current.hostSites[i], null);
            }
          } else {
            result._selfHostSites[i] = new HostSite.WithParent(current.hostSites[i], null);
          }
        }
      }
    }
    if (this._selfAdditionalResources) {
      if (this._value.additionalResources === current.additionalResources) {
        result._selfAdditionalResources = this._selfAdditionalResources;
      } else {
        result._selfAdditionalResources = [];
        for (let i = 0; i < current.additionalResources.length; i++) {
          const oldValue = this._value.additionalResources[i];
          if (oldValue) {
            const oldCache = this._selfAdditionalResources[i];
            if (oldValue === current.additionalResources[i]) {
              result._selfAdditionalResources[i] = oldCache;
            } else {
              result._selfAdditionalResources[i] = oldCache.update(current.additionalResources[i], null);
            }
          } else {
            result._selfAdditionalResources[i] = new ActorResource.WithParent(current.additionalResources[i], null);
          }
        }
      }
    }
    if (this._cachedSelectionScale && this._value.hasSelectionScale && current.hasSelectionScale) {
      if (this._value.selectionScale === current.selectionScale && this._parent === parent) {
        result._cachedSelectionScale = this._cachedSelectionScale;
      } else {
        result._cachedSelectionScale = this._cachedSelectionScale.update(current.selectionScale, parent && parent.hasSelectionScale ? parent.selectionScale : null);
      }
    }
    if (this._cachedScaleMultiplier && this._value.hasScaleMultiplier && current.hasScaleMultiplier) {
      if (this._value.scaleMultiplier === current.scaleMultiplier && this._parent === parent) {
        result._cachedScaleMultiplier = this._cachedScaleMultiplier;
      } else {
        result._cachedScaleMultiplier = this._cachedScaleMultiplier.update(current.scaleMultiplier, parent && parent.hasScaleMultiplier ? parent.scaleMultiplier : null);
      }
    }
    if (this._cachedSpriteOptions && this._value.hasSpriteOptions && current.hasSpriteOptions) {
      if (this._value.spriteOptions === current.spriteOptions && this._parent === parent) {
        result._cachedSpriteOptions = this._cachedSpriteOptions;
      } else {
        result._cachedSpriteOptions = this._cachedSpriteOptions.update(current.spriteOptions, parent && parent.hasSpriteOptions ? parent.spriteOptions : null);
      }
    }
    return result;
  }
}
ModelActor_WithParent.default = new ModelActor_WithParent(ModelActor.default, null);
ModelActor.WithParent = ModelActor_WithParent;
class ModelActor_Descriptor {
  get resource() {
    if (!this._resource) {
      this._resource = {
        name: "resource",
        Name: "Resource",
        number: 1,
        protoType: 11,
        protoName: "resource",
        type: ActorResource,
        options: {
          comments: "The asset to use for the actor. This determines what the actor looks or sounds like.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resource;
  }
  get events() {
    if (!this._events) {
      this._events = {
        name: "events",
        Name: "Events",
        number: 2,
        protoType: 11,
        protoName: "events",
        type: ActorEvent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._events;
  }
  get eventMacros() {
    if (!this._eventMacros) {
      this._eventMacros = {
        name: "eventMacros",
        Name: "EventMacros",
        number: 3,
        protoType: 9,
        protoName: "event_macros",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Event macros will be expanded after the events field.",
          valueDropdown: "SupportedActorEventMacroNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventMacros;
  }
  get hostSite() {
    if (!this._hostSite) {
      this._hostSite = {
        name: "hostSite",
        Name: "HostSite",
        number: 4,
        protoType: 9,
        protoName: "host_site",
        type: JsonToString,
        options: {
          comments: "Where this actor will be attached to in the actor scope. It can be the name of an actor (that actor will be used as the parent and this actor will be attached to its origin point), or a host site defined in an actor (that actor will be used as the parent and the referenced site will be the attach point), or an attachment defined in the model of an actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSite;
  }
  get hostSiteOperation() {
    if (!this._hostSiteOperation) {
      this._hostSiteOperation = {
        name: "hostSiteOperation",
        Name: "DeprecatedHostSiteOperation",
        number: 1004,
        protoType: 9,
        protoName: "deprecated_host_site_operation",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSiteOperation;
  }
  get hostSiteOperations() {
    if (!this._hostSiteOperations) {
      this._hostSiteOperations = {
        name: "hostSiteOperations",
        Name: "HostSiteOperations",
        number: 5,
        protoType: 9,
        protoName: "host_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "A set of operations applied to the host site position/rotation to determine the final position/rotation for this actor.",
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSiteOperations;
  }
  get hostSites() {
    if (!this._hostSites) {
      this._hostSites = {
        name: "hostSites",
        Name: "HostSites",
        number: 6,
        protoType: 11,
        protoName: "host_sites",
        isMap: true,
        keyType: JsonToString,
        valueType: HostSite,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
          comments: "Define a list of named sites on this actor that other actors can be attached to (or reference).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSites;
  }
  get additionalResources() {
    if (!this._additionalResources) {
      this._additionalResources = {
        name: "additionalResources",
        Name: "AdditionalResources",
        number: 7,
        protoType: 11,
        protoName: "additional_resources",
        type: ActorResource,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._additionalResources;
  }
  get modelScale() {
    if (!this._modelScale) {
      this._modelScale = {
        name: "modelScale",
        Name: "ModelScale",
        number: 12,
        protoType: 1,
        protoName: "model_scale",
        type: JsonToDouble,
        options: {
          comments: "Adjusts the size of the model. Using 0 defaults to 1.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modelScale;
  }
  get selectionBonusRadius() {
    if (!this._selectionBonusRadius) {
      this._selectionBonusRadius = {
        name: "selectionBonusRadius",
        Name: "SelectionBonusRadius",
        number: 14,
        protoType: 1,
        protoName: "selection_bonus_radius",
        type: JsonToDouble,
        options: {
          comments: "Adjusts the size of this actors\'s hit sphere for mouse selection and targeting if the model actor is within the scope of a unit actor. Useful for making small units more click-friendly.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionBonusRadius;
  }
  get aliases() {
    if (!this._aliases) {
      this._aliases = {
        name: "aliases",
        Name: "Aliases",
        number: 21,
        protoType: 9,
        protoName: "aliases",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "User defined name references that can be used to send messages to this actor from other actors in the same scope.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._aliases;
  }
  get selectable() {
    if (!this._selectable) {
      this._selectable = {
        name: "selectable",
        Name: "IncludeInUnitBody",
        number: 31,
        protoType: 8,
        protoName: "include_in_unit_body",
        type: JsonToBoolean,
        options: {
          comments: "When enabled, the model actor counts as selectable when within the scope of a unit actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectable;
  }
  get selectionShape() {
    if (!this._selectionShape) {
      this._selectionShape = {
        name: "selectionShape",
        Name: "SelectionShape",
        number: 32,
        protoType: 14,
        protoName: "selection_shape",
        type: UnitActor_SelectionShape,
        options: {
          comments: "Used to change mouse selection collider from sphere (default) to a cube. Useful for games with grid-based selection.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionShape;
  }
  get selectionScale() {
    if (!this._selectionScale) {
      this._selectionScale = {
        name: "selectionScale",
        Name: "SelectionScale",
        number: 33,
        protoType: 11,
        protoName: "selection_scale",
        type: UnitActor_SelectionScale,
        options: {
          comments: "Adjusts the scale of the selection collider if **Selection Shape** is set to Cube.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionScale;
  }
  get hideShadow() {
    if (!this._hideShadow) {
      this._hideShadow = {
        name: "hideShadow",
        Name: "HideShadow",
        number: 41,
        protoType: 8,
        protoName: "hide_shadow",
        type: JsonToBoolean,
        options: {
          comments: "Prevents the actor from casting a shadow.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideShadow;
  }
  get scaleMultiplier() {
    if (!this._scaleMultiplier) {
      this._scaleMultiplier = {
        name: "scaleMultiplier",
        Name: "ScaleMultiplier",
        number: 42,
        protoType: 11,
        protoName: "scale_multiplier",
        type: InitialScale,
        options: {
          comments: "Sets the scale of the actor across individual axes. The final scale will be these values multiplied by the **Model Scale**.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scaleMultiplier;
  }
  get renderingPriority() {
    if (!this._renderingPriority) {
      this._renderingPriority = {
        name: "renderingPriority",
        Name: "RenderingPriority",
        number: 51,
        protoType: 5,
        protoName: "rendering_priority",
        type: JsonToInt32,
        options: {
          comments: "The rendering priority, for rendering performance optimization, in some situation(low end devices), the lower priority particle actors may not render or get hidden first",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._renderingPriority;
  }
  get spriteOptions() {
    if (!this._spriteOptions) {
      this._spriteOptions = {
        name: "spriteOptions",
        Name: "SpriteOptions",
        number: 52,
        protoType: 11,
        protoName: "sprite_options",
        type: SpriteOptions,
        options: {
          comments: "Sprite options are for actor using sprite as resource.",
          showIf: {'resource.type' : 'Sprite'},
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spriteOptions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.resource,
        this.events,
        this.eventMacros,
        this.hostSite,
        this.hostSiteOperation,
        this.hostSiteOperations,
        this.hostSites,
        this.additionalResources,
        this.modelScale,
        this.selectionBonusRadius,
        this.aliases,
        this.selectable,
        this.selectionShape,
        this.selectionScale,
        this.hideShadow,
        this.scaleMultiplier,
        this.renderingPriority,
        this.spriteOptions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForResource",
        Name: "DummyOneofForResource",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHostSite",
        Name: "DummyOneofForHostSite",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedHostSiteOperation",
        Name: "DummyOneofForDeprecatedHostSiteOperation",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModelScale",
        Name: "DummyOneofForModelScale",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionBonusRadius",
        Name: "DummyOneofForSelectionBonusRadius",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIncludeInUnitBody",
        Name: "DummyOneofForIncludeInUnitBody",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionShape",
        Name: "DummyOneofForSelectionShape",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionScale",
        Name: "DummyOneofForSelectionScale",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideShadow",
        Name: "DummyOneofForHideShadow",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScaleMultiplier",
        Name: "DummyOneofForScaleMultiplier",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRenderingPriority",
        Name: "DummyOneofForRenderingPriority",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpriteOptions",
        Name: "DummyOneofForSpriteOptions",
        fields: [
          this.fields[17],
        ],
      });
    }
    return this._oneofs;
  }
}
ModelActor.descriptor = new ModelActor_Descriptor();
class ActionActor_AdditionalModel {
  get descriptor() {
    return ActionActor_AdditionalModel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCriticalOnly = false;
    this._criticalOnly = null;
    this._hasNonCriticalOnly = false;
    this._nonCriticalOnly = null;
    this._hasLaunchModel = false;
    this._launchModel = null;
    this._hasLaunchModelDetached = false;
    this._launchModelDetached = null;
    this._hasImpactModel = false;
    this._impactModel = null;
    this._hasImpactModelDetached = false;
    this._impactModelDetached = null;
    this._hasBeamModel = false;
    this._beamModel = null;
    this._hasLaunchSite = false;
    this._launchSite = null;
    this._hasTargetSite = false;
    this._targetSite = null;
    this._launchSiteOperations = [];
    this._targetSiteOperations = [];
  }
  isEmpty() {
    if (this._hasCriticalOnly) return false;
    if (this._hasNonCriticalOnly) return false;
    if (this._hasLaunchModel) return false;
    if (this._hasLaunchModelDetached) return false;
    if (this._hasImpactModel) return false;
    if (this._hasImpactModelDetached) return false;
    if (this._hasBeamModel) return false;
    if (this._hasLaunchSite) return false;
    if (this._hasTargetSite) return false;
    if (this._launchSiteOperations.length > 0) return false;
    if (this._targetSiteOperations.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActionActor_AdditionalModel) {
      return value;
    }
    return ActionActor_AdditionalModel.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActionActor_AdditionalModel();
    if (json.criticalOnly != null) {
      result._hasCriticalOnly = true;
      result._criticalOnly = JsonToBoolean.fromJson(json.criticalOnly);
    }
    if (json.nonCriticalOnly != null) {
      result._hasNonCriticalOnly = true;
      result._nonCriticalOnly = JsonToBoolean.fromJson(json.nonCriticalOnly);
    }
    if (json.launchModel != null) {
      result._hasLaunchModel = true;
      result._launchModel = JsonToString.fromJson(json.launchModel);
    }
    if (json.launchModelDetached != null) {
      result._hasLaunchModelDetached = true;
      result._launchModelDetached = JsonToBoolean.fromJson(json.launchModelDetached);
    }
    if (json.impactModel != null) {
      result._hasImpactModel = true;
      result._impactModel = JsonToString.fromJson(json.impactModel);
    }
    if (json.impactModelDetached != null) {
      result._hasImpactModelDetached = true;
      result._impactModelDetached = JsonToBoolean.fromJson(json.impactModelDetached);
    }
    if (json.beamModel != null) {
      result._hasBeamModel = true;
      result._beamModel = JsonToString.fromJson(json.beamModel);
    }
    if (json.launchSite != null) {
      result._hasLaunchSite = true;
      result._launchSite = JsonToString.fromJson(json.launchSite);
    }
    if (json.targetSite != null) {
      result._hasTargetSite = true;
      result._targetSite = JsonToString.fromJson(json.targetSite);
    }
    result._launchSiteOperations = JsonToList(json.launchSiteOperations, JsonToString);
    result._targetSiteOperations = JsonToList(json.targetSiteOperations, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCriticalOnly) {
      result.criticalOnly = JsonToBoolean.toJson(this._criticalOnly);
    }
    if (this._hasNonCriticalOnly) {
      result.nonCriticalOnly = JsonToBoolean.toJson(this._nonCriticalOnly);
    }
    if (this._hasLaunchModel) {
      result.launchModel = JsonToString.toJson(this._launchModel);
    }
    if (this._hasLaunchModelDetached) {
      result.launchModelDetached = JsonToBoolean.toJson(this._launchModelDetached);
    }
    if (this._hasImpactModel) {
      result.impactModel = JsonToString.toJson(this._impactModel);
    }
    if (this._hasImpactModelDetached) {
      result.impactModelDetached = JsonToBoolean.toJson(this._impactModelDetached);
    }
    if (this._hasBeamModel) {
      result.beamModel = JsonToString.toJson(this._beamModel);
    }
    if (this._hasLaunchSite) {
      result.launchSite = JsonToString.toJson(this._launchSite);
    }
    if (this._hasTargetSite) {
      result.targetSite = JsonToString.toJson(this._targetSite);
    }
    if (this._launchSiteOperations.length > 0) {
      result.launchSiteOperations = ArrayToJson(this._launchSiteOperations, JsonToString);
    }
    if (this._targetSiteOperations.length > 0) {
      result.targetSiteOperations = ArrayToJson(this._targetSiteOperations, JsonToString);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get criticalOnly() {
    return this._hasCriticalOnly ? this._criticalOnly : JsonToBoolean.default;
  }
  get hasCriticalOnly() {
    return this._hasCriticalOnly;
  }
  setCriticalOnly(path, value) {
    return {type: 'SET', path: path.concat(['criticalOnly']), value};
  }
  deleteCriticalOnly(path) {
    return {type: 'DELETE', path: path.concat(['criticalOnly'])};
  }
  /**
   * @returns {boolean}
   */
  get nonCriticalOnly() {
    return this._hasNonCriticalOnly ? this._nonCriticalOnly : JsonToBoolean.default;
  }
  get hasNonCriticalOnly() {
    return this._hasNonCriticalOnly;
  }
  setNonCriticalOnly(path, value) {
    return {type: 'SET', path: path.concat(['nonCriticalOnly']), value};
  }
  deleteNonCriticalOnly(path) {
    return {type: 'DELETE', path: path.concat(['nonCriticalOnly'])};
  }
  /**
   * @returns {string}
   */
  get launchModel() {
    return this._hasLaunchModel ? this._launchModel : JsonToString.default;
  }
  get hasLaunchModel() {
    return this._hasLaunchModel;
  }
  setLaunchModel(path, value) {
    return {type: 'SET', path: path.concat(['launchModel']), value};
  }
  deleteLaunchModel(path) {
    return {type: 'DELETE', path: path.concat(['launchModel'])};
  }
  /**
   * @returns {boolean}
   */
  get launchModelDetached() {
    return this._hasLaunchModelDetached ? this._launchModelDetached : JsonToBoolean.default;
  }
  get hasLaunchModelDetached() {
    return this._hasLaunchModelDetached;
  }
  setLaunchModelDetached(path, value) {
    return {type: 'SET', path: path.concat(['launchModelDetached']), value};
  }
  deleteLaunchModelDetached(path) {
    return {type: 'DELETE', path: path.concat(['launchModelDetached'])};
  }
  /**
   * @returns {string}
   */
  get impactModel() {
    return this._hasImpactModel ? this._impactModel : JsonToString.default;
  }
  get hasImpactModel() {
    return this._hasImpactModel;
  }
  setImpactModel(path, value) {
    return {type: 'SET', path: path.concat(['impactModel']), value};
  }
  deleteImpactModel(path) {
    return {type: 'DELETE', path: path.concat(['impactModel'])};
  }
  /**
   * @returns {boolean}
   */
  get impactModelDetached() {
    return this._hasImpactModelDetached ? this._impactModelDetached : JsonToBoolean.default;
  }
  get hasImpactModelDetached() {
    return this._hasImpactModelDetached;
  }
  setImpactModelDetached(path, value) {
    return {type: 'SET', path: path.concat(['impactModelDetached']), value};
  }
  deleteImpactModelDetached(path) {
    return {type: 'DELETE', path: path.concat(['impactModelDetached'])};
  }
  /**
   * @returns {string}
   */
  get beamModel() {
    return this._hasBeamModel ? this._beamModel : JsonToString.default;
  }
  get hasBeamModel() {
    return this._hasBeamModel;
  }
  setBeamModel(path, value) {
    return {type: 'SET', path: path.concat(['beamModel']), value};
  }
  deleteBeamModel(path) {
    return {type: 'DELETE', path: path.concat(['beamModel'])};
  }
  /**
   * @returns {string}
   */
  get launchSite() {
    return this._hasLaunchSite ? this._launchSite : JsonToString.default;
  }
  get hasLaunchSite() {
    return this._hasLaunchSite;
  }
  setLaunchSite(path, value) {
    return {type: 'SET', path: path.concat(['launchSite']), value};
  }
  deleteLaunchSite(path) {
    return {type: 'DELETE', path: path.concat(['launchSite'])};
  }
  /**
   * @returns {string}
   */
  get targetSite() {
    return this._hasTargetSite ? this._targetSite : JsonToString.default;
  }
  get hasTargetSite() {
    return this._hasTargetSite;
  }
  setTargetSite(path, value) {
    return {type: 'SET', path: path.concat(['targetSite']), value};
  }
  deleteTargetSite(path) {
    return {type: 'DELETE', path: path.concat(['targetSite'])};
  }
  /**
   * @returns {string[]}
   */
  get launchSiteOperations() {
    return this._launchSiteOperations;
  }
  addLaunchSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['launchSiteOperations']), value};
  }
  setLaunchSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['launchSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setLaunchSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['launchSiteOperations', key]), value};
  }
  deleteLaunchSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['launchSiteOperations'])};
  }
  deleteLaunchSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['launchSiteOperations', key])};
  }
  /**
   * @returns {string[]}
   */
  get targetSiteOperations() {
    return this._targetSiteOperations;
  }
  addTargetSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['targetSiteOperations']), value};
  }
  setTargetSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['targetSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setTargetSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['targetSiteOperations', key]), value};
  }
  deleteTargetSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['targetSiteOperations'])};
  }
  deleteTargetSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['targetSiteOperations', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "criticalOnly": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasCriticalOnly = true;
              copy._criticalOnly = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCriticalOnly) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasCriticalOnly = false;
              copy._criticalOnly = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nonCriticalOnly": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasNonCriticalOnly = true;
              copy._nonCriticalOnly = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNonCriticalOnly) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasNonCriticalOnly = false;
              copy._nonCriticalOnly = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchModel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasLaunchModel = true;
              copy._launchModel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchModel) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasLaunchModel = false;
              copy._launchModel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchModelDetached": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasLaunchModelDetached = true;
              copy._launchModelDetached = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchModelDetached) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasLaunchModelDetached = false;
              copy._launchModelDetached = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactModel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasImpactModel = true;
              copy._impactModel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactModel) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasImpactModel = false;
              copy._impactModel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactModelDetached": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasImpactModelDetached = true;
              copy._impactModelDetached = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactModelDetached) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasImpactModelDetached = false;
              copy._impactModelDetached = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "beamModel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasBeamModel = true;
              copy._beamModel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBeamModel) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasBeamModel = false;
              copy._beamModel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasLaunchSite = true;
              copy._launchSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchSite) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasLaunchSite = false;
              copy._launchSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasTargetSite = true;
              copy._targetSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetSite) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._hasTargetSite = false;
              copy._targetSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._launchSiteOperations = [];        for (let i of value) {
                copy._launchSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._launchSiteOperations = copy._launchSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._launchSiteOperations.length === 0) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._launchSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._launchSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._launchSiteOperations = copy._launchSiteOperations.slice();
              copy._launchSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._launchSiteOperations = copy._launchSiteOperations.slice(0, path[1]).concat(copy._launchSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._launchSiteOperations.length) {
            return this;
          }
          const oldValue = this._launchSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActionActor_AdditionalModel(this);
          copy._launchSiteOperations = copy._launchSiteOperations.slice();
          copy._launchSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "targetSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._targetSiteOperations = [];        for (let i of value) {
                copy._targetSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._targetSiteOperations = copy._targetSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._targetSiteOperations.length === 0) {
                return this;
              }
              const copy = new ActionActor_AdditionalModel(this);
              copy._targetSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._targetSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._targetSiteOperations = copy._targetSiteOperations.slice();
              copy._targetSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActionActor_AdditionalModel(this);
              copy._targetSiteOperations = copy._targetSiteOperations.slice(0, path[1]).concat(copy._targetSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._targetSiteOperations.length) {
            return this;
          }
          const oldValue = this._targetSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActionActor_AdditionalModel(this);
          copy._targetSiteOperations = copy._targetSiteOperations.slice();
          copy._targetSiteOperations[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActionActor_AdditionalModel} other
   * @returns {ActionActor_AdditionalModel}
   */
  merge(other) {
    const copy = new ActionActor_AdditionalModel(this);
    if (other._hasCriticalOnly) {
      copy._hasCriticalOnly = true;
      copy._criticalOnly = other._criticalOnly;
    }
    if (other._hasNonCriticalOnly) {
      copy._hasNonCriticalOnly = true;
      copy._nonCriticalOnly = other._nonCriticalOnly;
    }
    if (other._hasLaunchModel) {
      copy._hasLaunchModel = true;
      copy._launchModel = other._launchModel;
    }
    if (other._hasLaunchModelDetached) {
      copy._hasLaunchModelDetached = true;
      copy._launchModelDetached = other._launchModelDetached;
    }
    if (other._hasImpactModel) {
      copy._hasImpactModel = true;
      copy._impactModel = other._impactModel;
    }
    if (other._hasImpactModelDetached) {
      copy._hasImpactModelDetached = true;
      copy._impactModelDetached = other._impactModelDetached;
    }
    if (other._hasBeamModel) {
      copy._hasBeamModel = true;
      copy._beamModel = other._beamModel;
    }
    if (other._hasLaunchSite) {
      copy._hasLaunchSite = true;
      copy._launchSite = other._launchSite;
    }
    if (other._hasTargetSite) {
      copy._hasTargetSite = true;
      copy._targetSite = other._targetSite;
    }
    copy._launchSiteOperations = this._launchSiteOperations.concat(other._launchSiteOperations);
    copy._targetSiteOperations = this._targetSiteOperations.concat(other._targetSiteOperations);
    return copy;
  }
}
ActionActor_AdditionalModel.default = new ActionActor_AdditionalModel();
class ActionActor_AdditionalModel_Builder {
  constructor(value) {
    this._value = new ActionActor_AdditionalModel(value);
  }
  build() {
    return new ActionActor_AdditionalModel(this._value);
  }
  setCriticalOnly(value) {
    this._value._hasCriticalOnly = true;
    this._value._criticalOnly = value;
    return this;
  }
  deleteCriticalOnly() {
    this._value._hasCriticalOnly = false;
    this._value._criticalOnly = null;
    return this;
  }
  setNonCriticalOnly(value) {
    this._value._hasNonCriticalOnly = true;
    this._value._nonCriticalOnly = value;
    return this;
  }
  deleteNonCriticalOnly() {
    this._value._hasNonCriticalOnly = false;
    this._value._nonCriticalOnly = null;
    return this;
  }
  setLaunchModel(value) {
    this._value._hasLaunchModel = true;
    this._value._launchModel = value;
    return this;
  }
  deleteLaunchModel() {
    this._value._hasLaunchModel = false;
    this._value._launchModel = null;
    return this;
  }
  setLaunchModelDetached(value) {
    this._value._hasLaunchModelDetached = true;
    this._value._launchModelDetached = value;
    return this;
  }
  deleteLaunchModelDetached() {
    this._value._hasLaunchModelDetached = false;
    this._value._launchModelDetached = null;
    return this;
  }
  setImpactModel(value) {
    this._value._hasImpactModel = true;
    this._value._impactModel = value;
    return this;
  }
  deleteImpactModel() {
    this._value._hasImpactModel = false;
    this._value._impactModel = null;
    return this;
  }
  setImpactModelDetached(value) {
    this._value._hasImpactModelDetached = true;
    this._value._impactModelDetached = value;
    return this;
  }
  deleteImpactModelDetached() {
    this._value._hasImpactModelDetached = false;
    this._value._impactModelDetached = null;
    return this;
  }
  setBeamModel(value) {
    this._value._hasBeamModel = true;
    this._value._beamModel = value;
    return this;
  }
  deleteBeamModel() {
    this._value._hasBeamModel = false;
    this._value._beamModel = null;
    return this;
  }
  setLaunchSite(value) {
    this._value._hasLaunchSite = true;
    this._value._launchSite = value;
    return this;
  }
  deleteLaunchSite() {
    this._value._hasLaunchSite = false;
    this._value._launchSite = null;
    return this;
  }
  setTargetSite(value) {
    this._value._hasTargetSite = true;
    this._value._targetSite = value;
    return this;
  }
  deleteTargetSite() {
    this._value._hasTargetSite = false;
    this._value._targetSite = null;
    return this;
  }
  addAllLaunchSiteOperations(values) {
    this._value._launchSiteOperations = this._value._launchSiteOperations.concat(values);
    return this;
  }
  addLaunchSiteOperations(value) {
    this._value._launchSiteOperations = this._value._launchSiteOperations.concat([value]);
    return this;
  }
  setLaunchSiteOperations(index, value) {
    this._value._launchSiteOperations = this._value._launchSiteOperations.concat();
    this._value._launchSiteOperations[index] = value;
    return this;
  }
  clearLaunchSiteOperations() {
    this._value._launchSiteOperations = [];
    return this;
  }
  addAllTargetSiteOperations(values) {
    this._value._targetSiteOperations = this._value._targetSiteOperations.concat(values);
    return this;
  }
  addTargetSiteOperations(value) {
    this._value._targetSiteOperations = this._value._targetSiteOperations.concat([value]);
    return this;
  }
  setTargetSiteOperations(index, value) {
    this._value._targetSiteOperations = this._value._targetSiteOperations.concat();
    this._value._targetSiteOperations[index] = value;
    return this;
  }
  clearTargetSiteOperations() {
    this._value._targetSiteOperations = [];
    return this;
  }
}
ActionActor_AdditionalModel.Builder = ActionActor_AdditionalModel_Builder;
class ActionActor_AdditionalModel_WithParent {
  /**
   * @param {ActionActor_AdditionalModel} value
   * @param {ActionActor_AdditionalModel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActionActor_AdditionalModel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCriticalOnly() {
    if (this._cachedHasCriticalOnly === undefined) {
      if (this._value.hasCriticalOnly) {
        this._cachedHasCriticalOnly = true;
      } else {
        this._cachedHasCriticalOnly = this._parent ? this._parent.hasCriticalOnly : false;
      }
    }
    return this._cachedHasCriticalOnly;
  }
  get criticalOnly() {
    if (this._cachedCriticalOnly === undefined) {
      if (this._value.hasCriticalOnly) {
        this._cachedCriticalOnly = this._value.criticalOnly;
      } else {
        this._cachedCriticalOnly = this._parent ? this._parent.criticalOnly : this._value.criticalOnly;
      }
    }
    return this._cachedCriticalOnly;
  }
  get hasNonCriticalOnly() {
    if (this._cachedHasNonCriticalOnly === undefined) {
      if (this._value.hasNonCriticalOnly) {
        this._cachedHasNonCriticalOnly = true;
      } else {
        this._cachedHasNonCriticalOnly = this._parent ? this._parent.hasNonCriticalOnly : false;
      }
    }
    return this._cachedHasNonCriticalOnly;
  }
  get nonCriticalOnly() {
    if (this._cachedNonCriticalOnly === undefined) {
      if (this._value.hasNonCriticalOnly) {
        this._cachedNonCriticalOnly = this._value.nonCriticalOnly;
      } else {
        this._cachedNonCriticalOnly = this._parent ? this._parent.nonCriticalOnly : this._value.nonCriticalOnly;
      }
    }
    return this._cachedNonCriticalOnly;
  }
  get hasLaunchModel() {
    if (this._cachedHasLaunchModel === undefined) {
      if (this._value.hasLaunchModel) {
        this._cachedHasLaunchModel = true;
      } else {
        this._cachedHasLaunchModel = this._parent ? this._parent.hasLaunchModel : false;
      }
    }
    return this._cachedHasLaunchModel;
  }
  get launchModel() {
    if (this._cachedLaunchModel === undefined) {
      if (this._value.hasLaunchModel) {
        this._cachedLaunchModel = this._value.launchModel;
      } else {
        this._cachedLaunchModel = this._parent ? this._parent.launchModel : this._value.launchModel;
      }
    }
    return this._cachedLaunchModel;
  }
  get hasLaunchModelDetached() {
    if (this._cachedHasLaunchModelDetached === undefined) {
      if (this._value.hasLaunchModelDetached) {
        this._cachedHasLaunchModelDetached = true;
      } else {
        this._cachedHasLaunchModelDetached = this._parent ? this._parent.hasLaunchModelDetached : false;
      }
    }
    return this._cachedHasLaunchModelDetached;
  }
  get launchModelDetached() {
    if (this._cachedLaunchModelDetached === undefined) {
      if (this._value.hasLaunchModelDetached) {
        this._cachedLaunchModelDetached = this._value.launchModelDetached;
      } else {
        this._cachedLaunchModelDetached = this._parent ? this._parent.launchModelDetached : this._value.launchModelDetached;
      }
    }
    return this._cachedLaunchModelDetached;
  }
  get hasImpactModel() {
    if (this._cachedHasImpactModel === undefined) {
      if (this._value.hasImpactModel) {
        this._cachedHasImpactModel = true;
      } else {
        this._cachedHasImpactModel = this._parent ? this._parent.hasImpactModel : false;
      }
    }
    return this._cachedHasImpactModel;
  }
  get impactModel() {
    if (this._cachedImpactModel === undefined) {
      if (this._value.hasImpactModel) {
        this._cachedImpactModel = this._value.impactModel;
      } else {
        this._cachedImpactModel = this._parent ? this._parent.impactModel : this._value.impactModel;
      }
    }
    return this._cachedImpactModel;
  }
  get hasImpactModelDetached() {
    if (this._cachedHasImpactModelDetached === undefined) {
      if (this._value.hasImpactModelDetached) {
        this._cachedHasImpactModelDetached = true;
      } else {
        this._cachedHasImpactModelDetached = this._parent ? this._parent.hasImpactModelDetached : false;
      }
    }
    return this._cachedHasImpactModelDetached;
  }
  get impactModelDetached() {
    if (this._cachedImpactModelDetached === undefined) {
      if (this._value.hasImpactModelDetached) {
        this._cachedImpactModelDetached = this._value.impactModelDetached;
      } else {
        this._cachedImpactModelDetached = this._parent ? this._parent.impactModelDetached : this._value.impactModelDetached;
      }
    }
    return this._cachedImpactModelDetached;
  }
  get hasBeamModel() {
    if (this._cachedHasBeamModel === undefined) {
      if (this._value.hasBeamModel) {
        this._cachedHasBeamModel = true;
      } else {
        this._cachedHasBeamModel = this._parent ? this._parent.hasBeamModel : false;
      }
    }
    return this._cachedHasBeamModel;
  }
  get beamModel() {
    if (this._cachedBeamModel === undefined) {
      if (this._value.hasBeamModel) {
        this._cachedBeamModel = this._value.beamModel;
      } else {
        this._cachedBeamModel = this._parent ? this._parent.beamModel : this._value.beamModel;
      }
    }
    return this._cachedBeamModel;
  }
  get hasLaunchSite() {
    if (this._cachedHasLaunchSite === undefined) {
      if (this._value.hasLaunchSite) {
        this._cachedHasLaunchSite = true;
      } else {
        this._cachedHasLaunchSite = this._parent ? this._parent.hasLaunchSite : false;
      }
    }
    return this._cachedHasLaunchSite;
  }
  get launchSite() {
    if (this._cachedLaunchSite === undefined) {
      if (this._value.hasLaunchSite) {
        this._cachedLaunchSite = this._value.launchSite;
      } else {
        this._cachedLaunchSite = this._parent ? this._parent.launchSite : this._value.launchSite;
      }
    }
    return this._cachedLaunchSite;
  }
  get hasTargetSite() {
    if (this._cachedHasTargetSite === undefined) {
      if (this._value.hasTargetSite) {
        this._cachedHasTargetSite = true;
      } else {
        this._cachedHasTargetSite = this._parent ? this._parent.hasTargetSite : false;
      }
    }
    return this._cachedHasTargetSite;
  }
  get targetSite() {
    if (this._cachedTargetSite === undefined) {
      if (this._value.hasTargetSite) {
        this._cachedTargetSite = this._value.targetSite;
      } else {
        this._cachedTargetSite = this._parent ? this._parent.targetSite : this._value.targetSite;
      }
    }
    return this._cachedTargetSite;
  }
  get selfLaunchSiteOperations() {
    return this._value.launchSiteOperations;
  }
  get inherentLaunchSiteOperations() {
    if (!this._inherentLaunchSiteOperations) {
      this._inherentLaunchSiteOperations = this._parent ? this._parent.launchSiteOperations : [];
    }
    return this._inherentLaunchSiteOperations;
  }
  get launchSiteOperations() {
    if (!this._allLaunchSiteOperations) {
      this._allLaunchSiteOperations = this._parent ? this._parent.launchSiteOperations.concat(this.selfLaunchSiteOperations) : this.selfLaunchSiteOperations;
    }
    return this._allLaunchSiteOperations;
  }
  get selfTargetSiteOperations() {
    return this._value.targetSiteOperations;
  }
  get inherentTargetSiteOperations() {
    if (!this._inherentTargetSiteOperations) {
      this._inherentTargetSiteOperations = this._parent ? this._parent.targetSiteOperations : [];
    }
    return this._inherentTargetSiteOperations;
  }
  get targetSiteOperations() {
    if (!this._allTargetSiteOperations) {
      this._allTargetSiteOperations = this._parent ? this._parent.targetSiteOperations.concat(this.selfTargetSiteOperations) : this.selfTargetSiteOperations;
    }
    return this._allTargetSiteOperations;
  }
  update(current, parent) {
    const result = new ActionActor_AdditionalModel_WithParent(current, parent);
    return result;
  }
}
ActionActor_AdditionalModel_WithParent.default = new ActionActor_AdditionalModel_WithParent(ActionActor_AdditionalModel.default, null);
ActionActor_AdditionalModel.WithParent = ActionActor_AdditionalModel_WithParent;
class ActionActor_AdditionalModel_Descriptor {
  get criticalOnly() {
    if (!this._criticalOnly) {
      this._criticalOnly = {
        name: "criticalOnly",
        Name: "CriticalOnly",
        number: 6,
        protoType: 8,
        protoName: "critical_only",
        type: JsonToBoolean,
        options: {
          comments: "When checked, create actors only if the effect is from a critical hit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._criticalOnly;
  }
  get nonCriticalOnly() {
    if (!this._nonCriticalOnly) {
      this._nonCriticalOnly = {
        name: "nonCriticalOnly",
        Name: "NonCriticalOnly",
        number: 7,
        protoType: 8,
        protoName: "non_critical_only",
        type: JsonToBoolean,
        options: {
          comments: "When checked, create actors only if the effect is not from a critical hit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nonCriticalOnly;
  }
  get launchModel() {
    if (!this._launchModel) {
      this._launchModel = {
        name: "launchModel",
        Name: "LaunchModel",
        number: 1,
        protoType: 9,
        protoName: "launch_model",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchModel;
  }
  get launchModelDetached() {
    if (!this._launchModelDetached) {
      this._launchModelDetached = {
        name: "launchModelDetached",
        Name: "LaunchModelDetached",
        number: 2,
        protoType: 8,
        protoName: "launch_model_detached",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchModelDetached;
  }
  get impactModel() {
    if (!this._impactModel) {
      this._impactModel = {
        name: "impactModel",
        Name: "ImpactModel",
        number: 3,
        protoType: 9,
        protoName: "impact_model",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactModel;
  }
  get impactModelDetached() {
    if (!this._impactModelDetached) {
      this._impactModelDetached = {
        name: "impactModelDetached",
        Name: "ImpactModelDetached",
        number: 4,
        protoType: 8,
        protoName: "impact_model_detached",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactModelDetached;
  }
  get beamModel() {
    if (!this._beamModel) {
      this._beamModel = {
        name: "beamModel",
        Name: "BeamModel",
        number: 5,
        protoType: 9,
        protoName: "beam_model",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._beamModel;
  }
  get launchSite() {
    if (!this._launchSite) {
      this._launchSite = {
        name: "launchSite",
        Name: "LaunchSite",
        number: 11,
        protoType: 9,
        protoName: "launch_site",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchSite;
  }
  get targetSite() {
    if (!this._targetSite) {
      this._targetSite = {
        name: "targetSite",
        Name: "TargetSite",
        number: 12,
        protoType: 9,
        protoName: "target_site",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetSite;
  }
  get launchSiteOperations() {
    if (!this._launchSiteOperations) {
      this._launchSiteOperations = {
        name: "launchSiteOperations",
        Name: "LaunchSiteOperations",
        number: 13,
        protoType: 9,
        protoName: "launch_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchSiteOperations;
  }
  get targetSiteOperations() {
    if (!this._targetSiteOperations) {
      this._targetSiteOperations = {
        name: "targetSiteOperations",
        Name: "TargetSiteOperations",
        number: 14,
        protoType: 9,
        protoName: "target_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetSiteOperations;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.criticalOnly,
        this.nonCriticalOnly,
        this.launchModel,
        this.launchModelDetached,
        this.impactModel,
        this.impactModelDetached,
        this.beamModel,
        this.launchSite,
        this.targetSite,
        this.launchSiteOperations,
        this.targetSiteOperations,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCriticalOnly",
        Name: "DummyOneofForCriticalOnly",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNonCriticalOnly",
        Name: "DummyOneofForNonCriticalOnly",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchModel",
        Name: "DummyOneofForLaunchModel",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchModelDetached",
        Name: "DummyOneofForLaunchModelDetached",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactModel",
        Name: "DummyOneofForImpactModel",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactModelDetached",
        Name: "DummyOneofForImpactModelDetached",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBeamModel",
        Name: "DummyOneofForBeamModel",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchSite",
        Name: "DummyOneofForLaunchSite",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetSite",
        Name: "DummyOneofForTargetSite",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
ActionActor_AdditionalModel.descriptor = new ActionActor_AdditionalModel_Descriptor();
export class ActionActor {
  get descriptor() {
    return ActionActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEffect = false;
    this._effect = null;
    this._hasLaunchModel = false;
    this._launchModel = null;
    this._hasLaunchModelDetached = false;
    this._launchModelDetached = null;
    this._hasImpactModel = false;
    this._impactModel = null;
    this._hasImpactModelDetached = false;
    this._impactModelDetached = null;
    this._hasBeamModel = false;
    this._beamModel = null;
    this._hasLaunchSite = false;
    this._launchSite = null;
    this._hasTargetSite = false;
    this._targetSite = null;
    this._hasDeprecatedLaunchSiteOperation = false;
    this._launchSiteOperation = null;
    this._launchSiteOperations = [];
    this._hasDeprecatedTargetSiteOperation = false;
    this._targetSiteOperation = null;
    this._targetSiteOperations = [];
    this._hasHostSite = false;
    this._hostSite = null;
    this._hasDeprecatedHostSiteOperation = false;
    this._hostSiteOperation = null;
    this._hostSiteOperations = [];
    this._additionalModels = [];
  }
  isEmpty() {
    if (this._hasEffect) return false;
    if (this._hasLaunchModel) return false;
    if (this._hasLaunchModelDetached) return false;
    if (this._hasImpactModel) return false;
    if (this._hasImpactModelDetached) return false;
    if (this._hasBeamModel) return false;
    if (this._hasLaunchSite) return false;
    if (this._hasTargetSite) return false;
    if (this._hasDeprecatedLaunchSiteOperation) return false;
    if (this._launchSiteOperations.length > 0) return false;
    if (this._hasDeprecatedTargetSiteOperation) return false;
    if (this._targetSiteOperations.length > 0) return false;
    if (this._hasHostSite) return false;
    if (this._hasDeprecatedHostSiteOperation) return false;
    if (this._hostSiteOperations.length > 0) return false;
    if (this._additionalModels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ActionActor) {
      return value;
    }
    return ActionActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new ActionActor();
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.launchModel != null) {
      result._hasLaunchModel = true;
      result._launchModel = JsonToString.fromJson(json.launchModel);
    }
    if (json.launchModelDetached != null) {
      result._hasLaunchModelDetached = true;
      result._launchModelDetached = JsonToBoolean.fromJson(json.launchModelDetached);
    }
    if (json.impactModel != null) {
      result._hasImpactModel = true;
      result._impactModel = JsonToString.fromJson(json.impactModel);
    }
    if (json.impactModelDetached != null) {
      result._hasImpactModelDetached = true;
      result._impactModelDetached = JsonToBoolean.fromJson(json.impactModelDetached);
    }
    if (json.beamModel != null) {
      result._hasBeamModel = true;
      result._beamModel = JsonToString.fromJson(json.beamModel);
    }
    if (json.launchSite != null) {
      result._hasLaunchSite = true;
      result._launchSite = JsonToString.fromJson(json.launchSite);
    }
    if (json.targetSite != null) {
      result._hasTargetSite = true;
      result._targetSite = JsonToString.fromJson(json.targetSite);
    }
    if (json.launchSiteOperation != null) {
      result._hasDeprecatedLaunchSiteOperation = true;
      result._launchSiteOperation = JsonToString.fromJson(json.launchSiteOperation);
    }
    result._launchSiteOperations = JsonToList(json.launchSiteOperations, JsonToString);
    if (json.targetSiteOperation != null) {
      result._hasDeprecatedTargetSiteOperation = true;
      result._targetSiteOperation = JsonToString.fromJson(json.targetSiteOperation);
    }
    result._targetSiteOperations = JsonToList(json.targetSiteOperations, JsonToString);
    if (json.hostSite != null) {
      result._hasHostSite = true;
      result._hostSite = JsonToString.fromJson(json.hostSite);
    }
    if (json.hostSiteOperation != null) {
      result._hasDeprecatedHostSiteOperation = true;
      result._hostSiteOperation = JsonToString.fromJson(json.hostSiteOperation);
    }
    result._hostSiteOperations = JsonToList(json.hostSiteOperations, JsonToString);
    result._additionalModels = JsonToList(json.additionalModels, ActionActor_AdditionalModel);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasLaunchModel) {
      result.launchModel = JsonToString.toJson(this._launchModel);
    }
    if (this._hasLaunchModelDetached) {
      result.launchModelDetached = JsonToBoolean.toJson(this._launchModelDetached);
    }
    if (this._hasImpactModel) {
      result.impactModel = JsonToString.toJson(this._impactModel);
    }
    if (this._hasImpactModelDetached) {
      result.impactModelDetached = JsonToBoolean.toJson(this._impactModelDetached);
    }
    if (this._hasBeamModel) {
      result.beamModel = JsonToString.toJson(this._beamModel);
    }
    if (this._hasLaunchSite) {
      result.launchSite = JsonToString.toJson(this._launchSite);
    }
    if (this._hasTargetSite) {
      result.targetSite = JsonToString.toJson(this._targetSite);
    }
    if (this._hasDeprecatedLaunchSiteOperation) {
      result.launchSiteOperation = JsonToString.toJson(this._launchSiteOperation);
    }
    if (this._launchSiteOperations.length > 0) {
      result.launchSiteOperations = ArrayToJson(this._launchSiteOperations, JsonToString);
    }
    if (this._hasDeprecatedTargetSiteOperation) {
      result.targetSiteOperation = JsonToString.toJson(this._targetSiteOperation);
    }
    if (this._targetSiteOperations.length > 0) {
      result.targetSiteOperations = ArrayToJson(this._targetSiteOperations, JsonToString);
    }
    if (this._hasHostSite) {
      result.hostSite = JsonToString.toJson(this._hostSite);
    }
    if (this._hasDeprecatedHostSiteOperation) {
      result.hostSiteOperation = JsonToString.toJson(this._hostSiteOperation);
    }
    if (this._hostSiteOperations.length > 0) {
      result.hostSiteOperations = ArrayToJson(this._hostSiteOperations, JsonToString);
    }
    if (this._additionalModels.length > 0) {
      result.additionalModels = ArrayToJson(this._additionalModels, ActionActor_AdditionalModel);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {string}
   */
  get launchModel() {
    return this._hasLaunchModel ? this._launchModel : JsonToString.default;
  }
  get hasLaunchModel() {
    return this._hasLaunchModel;
  }
  setLaunchModel(path, value) {
    return {type: 'SET', path: path.concat(['launchModel']), value};
  }
  deleteLaunchModel(path) {
    return {type: 'DELETE', path: path.concat(['launchModel'])};
  }
  /**
   * @returns {boolean}
   */
  get launchModelDetached() {
    return this._hasLaunchModelDetached ? this._launchModelDetached : JsonToBoolean.default;
  }
  get hasLaunchModelDetached() {
    return this._hasLaunchModelDetached;
  }
  setLaunchModelDetached(path, value) {
    return {type: 'SET', path: path.concat(['launchModelDetached']), value};
  }
  deleteLaunchModelDetached(path) {
    return {type: 'DELETE', path: path.concat(['launchModelDetached'])};
  }
  /**
   * @returns {string}
   */
  get impactModel() {
    return this._hasImpactModel ? this._impactModel : JsonToString.default;
  }
  get hasImpactModel() {
    return this._hasImpactModel;
  }
  setImpactModel(path, value) {
    return {type: 'SET', path: path.concat(['impactModel']), value};
  }
  deleteImpactModel(path) {
    return {type: 'DELETE', path: path.concat(['impactModel'])};
  }
  /**
   * @returns {boolean}
   */
  get impactModelDetached() {
    return this._hasImpactModelDetached ? this._impactModelDetached : JsonToBoolean.default;
  }
  get hasImpactModelDetached() {
    return this._hasImpactModelDetached;
  }
  setImpactModelDetached(path, value) {
    return {type: 'SET', path: path.concat(['impactModelDetached']), value};
  }
  deleteImpactModelDetached(path) {
    return {type: 'DELETE', path: path.concat(['impactModelDetached'])};
  }
  /**
   * @returns {string}
   */
  get beamModel() {
    return this._hasBeamModel ? this._beamModel : JsonToString.default;
  }
  get hasBeamModel() {
    return this._hasBeamModel;
  }
  setBeamModel(path, value) {
    return {type: 'SET', path: path.concat(['beamModel']), value};
  }
  deleteBeamModel(path) {
    return {type: 'DELETE', path: path.concat(['beamModel'])};
  }
  /**
   * @returns {string}
   */
  get launchSite() {
    return this._hasLaunchSite ? this._launchSite : JsonToString.default;
  }
  get hasLaunchSite() {
    return this._hasLaunchSite;
  }
  setLaunchSite(path, value) {
    return {type: 'SET', path: path.concat(['launchSite']), value};
  }
  deleteLaunchSite(path) {
    return {type: 'DELETE', path: path.concat(['launchSite'])};
  }
  /**
   * @returns {string}
   */
  get targetSite() {
    return this._hasTargetSite ? this._targetSite : JsonToString.default;
  }
  get hasTargetSite() {
    return this._hasTargetSite;
  }
  setTargetSite(path, value) {
    return {type: 'SET', path: path.concat(['targetSite']), value};
  }
  deleteTargetSite(path) {
    return {type: 'DELETE', path: path.concat(['targetSite'])};
  }
  /**
   * @returns {string}
   */
  get launchSiteOperation() {
    return this._hasDeprecatedLaunchSiteOperation ? this._launchSiteOperation : JsonToString.default;
  }
  get hasDeprecatedLaunchSiteOperation() {
    return this._hasDeprecatedLaunchSiteOperation;
  }
  setDeprecatedLaunchSiteOperation(path, value) {
    return {type: 'SET', path: path.concat(['launchSiteOperation']), value};
  }
  deleteDeprecatedLaunchSiteOperation(path) {
    return {type: 'DELETE', path: path.concat(['launchSiteOperation'])};
  }
  /**
   * @returns {string[]}
   */
  get launchSiteOperations() {
    return this._launchSiteOperations;
  }
  addLaunchSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['launchSiteOperations']), value};
  }
  setLaunchSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['launchSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setLaunchSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['launchSiteOperations', key]), value};
  }
  deleteLaunchSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['launchSiteOperations'])};
  }
  deleteLaunchSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['launchSiteOperations', key])};
  }
  /**
   * @returns {string}
   */
  get targetSiteOperation() {
    return this._hasDeprecatedTargetSiteOperation ? this._targetSiteOperation : JsonToString.default;
  }
  get hasDeprecatedTargetSiteOperation() {
    return this._hasDeprecatedTargetSiteOperation;
  }
  setDeprecatedTargetSiteOperation(path, value) {
    return {type: 'SET', path: path.concat(['targetSiteOperation']), value};
  }
  deleteDeprecatedTargetSiteOperation(path) {
    return {type: 'DELETE', path: path.concat(['targetSiteOperation'])};
  }
  /**
   * @returns {string[]}
   */
  get targetSiteOperations() {
    return this._targetSiteOperations;
  }
  addTargetSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['targetSiteOperations']), value};
  }
  setTargetSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['targetSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setTargetSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['targetSiteOperations', key]), value};
  }
  deleteTargetSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['targetSiteOperations'])};
  }
  deleteTargetSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['targetSiteOperations', key])};
  }
  /**
   * @returns {string}
   */
  get hostSite() {
    return this._hasHostSite ? this._hostSite : JsonToString.default;
  }
  get hasHostSite() {
    return this._hasHostSite;
  }
  setHostSite(path, value) {
    return {type: 'SET', path: path.concat(['hostSite']), value};
  }
  deleteHostSite(path) {
    return {type: 'DELETE', path: path.concat(['hostSite'])};
  }
  /**
   * @returns {string}
   */
  get hostSiteOperation() {
    return this._hasDeprecatedHostSiteOperation ? this._hostSiteOperation : JsonToString.default;
  }
  get hasDeprecatedHostSiteOperation() {
    return this._hasDeprecatedHostSiteOperation;
  }
  setDeprecatedHostSiteOperation(path, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperation']), value};
  }
  deleteDeprecatedHostSiteOperation(path) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperation'])};
  }
  /**
   * @returns {string[]}
   */
  get hostSiteOperations() {
    return this._hostSiteOperations;
  }
  addHostSiteOperations(path, value) {
    return {type: 'ADD', path: path.concat(['hostSiteOperations']), value};
  }
  setHostSiteOperations(path, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations']), value: ArrayToJson(value, JsonToString)};
  }
  setHostSiteOperationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['hostSiteOperations', key]), value};
  }
  deleteHostSiteOperations(path) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations'])};
  }
  deleteHostSiteOperationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['hostSiteOperations', key])};
  }
  /**
   * @returns {ActionActor_AdditionalModel[]}
   */
  get additionalModels() {
    return this._additionalModels;
  }
  addAdditionalModels(path, value) {
    return {type: 'ADD', path: path.concat(['additionalModels']), value: value.toJson()};
  }
  setAdditionalModels(path, value) {
    return {type: 'SET', path: path.concat(['additionalModels']), value: ArrayToJson(value, ActionActor_AdditionalModel)};
  }
  setAdditionalModelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['additionalModels', key]), value: value.toJson()};
  }
  deleteAdditionalModels(path) {
    return {type: 'DELETE', path: path.concat(['additionalModels'])};
  }
  deleteAdditionalModelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['additionalModels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchModel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasLaunchModel = true;
              copy._launchModel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchModel) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasLaunchModel = false;
              copy._launchModel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchModelDetached": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasLaunchModelDetached = true;
              copy._launchModelDetached = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchModelDetached) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasLaunchModelDetached = false;
              copy._launchModelDetached = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactModel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasImpactModel = true;
              copy._impactModel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactModel) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasImpactModel = false;
              copy._impactModel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "impactModelDetached": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasImpactModelDetached = true;
              copy._impactModelDetached = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImpactModelDetached) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasImpactModelDetached = false;
              copy._impactModelDetached = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "beamModel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasBeamModel = true;
              copy._beamModel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBeamModel) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasBeamModel = false;
              copy._beamModel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasLaunchSite = true;
              copy._launchSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLaunchSite) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasLaunchSite = false;
              copy._launchSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasTargetSite = true;
              copy._targetSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetSite) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasTargetSite = false;
              copy._targetSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchSiteOperation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasDeprecatedLaunchSiteOperation = true;
              copy._launchSiteOperation = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedLaunchSiteOperation) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasDeprecatedLaunchSiteOperation = false;
              copy._launchSiteOperation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "launchSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._launchSiteOperations = [];        for (let i of value) {
                copy._launchSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActionActor(this);
              copy._launchSiteOperations = copy._launchSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._launchSiteOperations.length === 0) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._launchSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._launchSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._launchSiteOperations = copy._launchSiteOperations.slice();
              copy._launchSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActionActor(this);
              copy._launchSiteOperations = copy._launchSiteOperations.slice(0, path[1]).concat(copy._launchSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._launchSiteOperations.length) {
            return this;
          }
          const oldValue = this._launchSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActionActor(this);
          copy._launchSiteOperations = copy._launchSiteOperations.slice();
          copy._launchSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "targetSiteOperation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasDeprecatedTargetSiteOperation = true;
              copy._targetSiteOperation = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedTargetSiteOperation) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasDeprecatedTargetSiteOperation = false;
              copy._targetSiteOperation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._targetSiteOperations = [];        for (let i of value) {
                copy._targetSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActionActor(this);
              copy._targetSiteOperations = copy._targetSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._targetSiteOperations.length === 0) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._targetSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._targetSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._targetSiteOperations = copy._targetSiteOperations.slice();
              copy._targetSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActionActor(this);
              copy._targetSiteOperations = copy._targetSiteOperations.slice(0, path[1]).concat(copy._targetSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._targetSiteOperations.length) {
            return this;
          }
          const oldValue = this._targetSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActionActor(this);
          copy._targetSiteOperations = copy._targetSiteOperations.slice();
          copy._targetSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "hostSite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasHostSite = true;
              copy._hostSite = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHostSite) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasHostSite = false;
              copy._hostSite = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSiteOperation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hasDeprecatedHostSiteOperation = true;
              copy._hostSiteOperation = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedHostSiteOperation) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hasDeprecatedHostSiteOperation = false;
              copy._hostSiteOperation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hostSiteOperations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hostSiteOperations = [];        for (let i of value) {
                copy._hostSiteOperations.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActionActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._hostSiteOperations.length === 0) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._hostSiteOperations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice();
              copy._hostSiteOperations[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActionActor(this);
              copy._hostSiteOperations = copy._hostSiteOperations.slice(0, path[1]).concat(copy._hostSiteOperations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._hostSiteOperations.length) {
            return this;
          }
          const oldValue = this._hostSiteOperations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActionActor(this);
          copy._hostSiteOperations = copy._hostSiteOperations.slice();
          copy._hostSiteOperations[key] = newValue;
          return copy;
        }
      }
      case "additionalModels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._additionalModels = [];        for (let i of value) {
                copy._additionalModels.push(ActionActor_AdditionalModel.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ActionActor(this);
              copy._additionalModels = copy._additionalModels.concat([ActionActor_AdditionalModel.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._additionalModels.length === 0) {
                return this;
              }
              const copy = new ActionActor(this);
              copy._additionalModels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._additionalModels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ActionActor(this);
              copy._additionalModels = copy._additionalModels.slice();
              copy._additionalModels[path[1]] = ActionActor_AdditionalModel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ActionActor(this);
              copy._additionalModels = copy._additionalModels.slice(0, path[1]).concat(copy._additionalModels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._additionalModels.length) {
            return this;
          }
          const oldValue = this._additionalModels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ActionActor(this);
          copy._additionalModels = copy._additionalModels.slice();
          copy._additionalModels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ActionActor} other
   * @returns {ActionActor}
   */
  merge(other) {
    const copy = new ActionActor(this);
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasLaunchModel) {
      copy._hasLaunchModel = true;
      copy._launchModel = other._launchModel;
    }
    if (other._hasLaunchModelDetached) {
      copy._hasLaunchModelDetached = true;
      copy._launchModelDetached = other._launchModelDetached;
    }
    if (other._hasImpactModel) {
      copy._hasImpactModel = true;
      copy._impactModel = other._impactModel;
    }
    if (other._hasImpactModelDetached) {
      copy._hasImpactModelDetached = true;
      copy._impactModelDetached = other._impactModelDetached;
    }
    if (other._hasBeamModel) {
      copy._hasBeamModel = true;
      copy._beamModel = other._beamModel;
    }
    if (other._hasLaunchSite) {
      copy._hasLaunchSite = true;
      copy._launchSite = other._launchSite;
    }
    if (other._hasTargetSite) {
      copy._hasTargetSite = true;
      copy._targetSite = other._targetSite;
    }
    if (other._hasDeprecatedLaunchSiteOperation) {
      copy._hasDeprecatedLaunchSiteOperation = true;
      copy._launchSiteOperation = other._launchSiteOperation;
    }
    copy._launchSiteOperations = this._launchSiteOperations.concat(other._launchSiteOperations);
    if (other._hasDeprecatedTargetSiteOperation) {
      copy._hasDeprecatedTargetSiteOperation = true;
      copy._targetSiteOperation = other._targetSiteOperation;
    }
    copy._targetSiteOperations = this._targetSiteOperations.concat(other._targetSiteOperations);
    if (other._hasHostSite) {
      copy._hasHostSite = true;
      copy._hostSite = other._hostSite;
    }
    if (other._hasDeprecatedHostSiteOperation) {
      copy._hasDeprecatedHostSiteOperation = true;
      copy._hostSiteOperation = other._hostSiteOperation;
    }
    copy._hostSiteOperations = this._hostSiteOperations.concat(other._hostSiteOperations);
    copy._additionalModels = this._additionalModels.concat(other._additionalModels);
    return copy;
  }
}
ActionActor.default = new ActionActor();
ActionActor.AdditionalModel = ActionActor_AdditionalModel;
class ActionActor_Builder {
  constructor(value) {
    this._value = new ActionActor(value);
  }
  build() {
    return new ActionActor(this._value);
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setLaunchModel(value) {
    this._value._hasLaunchModel = true;
    this._value._launchModel = value;
    return this;
  }
  deleteLaunchModel() {
    this._value._hasLaunchModel = false;
    this._value._launchModel = null;
    return this;
  }
  setLaunchModelDetached(value) {
    this._value._hasLaunchModelDetached = true;
    this._value._launchModelDetached = value;
    return this;
  }
  deleteLaunchModelDetached() {
    this._value._hasLaunchModelDetached = false;
    this._value._launchModelDetached = null;
    return this;
  }
  setImpactModel(value) {
    this._value._hasImpactModel = true;
    this._value._impactModel = value;
    return this;
  }
  deleteImpactModel() {
    this._value._hasImpactModel = false;
    this._value._impactModel = null;
    return this;
  }
  setImpactModelDetached(value) {
    this._value._hasImpactModelDetached = true;
    this._value._impactModelDetached = value;
    return this;
  }
  deleteImpactModelDetached() {
    this._value._hasImpactModelDetached = false;
    this._value._impactModelDetached = null;
    return this;
  }
  setBeamModel(value) {
    this._value._hasBeamModel = true;
    this._value._beamModel = value;
    return this;
  }
  deleteBeamModel() {
    this._value._hasBeamModel = false;
    this._value._beamModel = null;
    return this;
  }
  setLaunchSite(value) {
    this._value._hasLaunchSite = true;
    this._value._launchSite = value;
    return this;
  }
  deleteLaunchSite() {
    this._value._hasLaunchSite = false;
    this._value._launchSite = null;
    return this;
  }
  setTargetSite(value) {
    this._value._hasTargetSite = true;
    this._value._targetSite = value;
    return this;
  }
  deleteTargetSite() {
    this._value._hasTargetSite = false;
    this._value._targetSite = null;
    return this;
  }
  setDeprecatedLaunchSiteOperation(value) {
    this._value._hasDeprecatedLaunchSiteOperation = true;
    this._value._launchSiteOperation = value;
    return this;
  }
  deleteDeprecatedLaunchSiteOperation() {
    this._value._hasDeprecatedLaunchSiteOperation = false;
    this._value._launchSiteOperation = null;
    return this;
  }
  addAllLaunchSiteOperations(values) {
    this._value._launchSiteOperations = this._value._launchSiteOperations.concat(values);
    return this;
  }
  addLaunchSiteOperations(value) {
    this._value._launchSiteOperations = this._value._launchSiteOperations.concat([value]);
    return this;
  }
  setLaunchSiteOperations(index, value) {
    this._value._launchSiteOperations = this._value._launchSiteOperations.concat();
    this._value._launchSiteOperations[index] = value;
    return this;
  }
  clearLaunchSiteOperations() {
    this._value._launchSiteOperations = [];
    return this;
  }
  setDeprecatedTargetSiteOperation(value) {
    this._value._hasDeprecatedTargetSiteOperation = true;
    this._value._targetSiteOperation = value;
    return this;
  }
  deleteDeprecatedTargetSiteOperation() {
    this._value._hasDeprecatedTargetSiteOperation = false;
    this._value._targetSiteOperation = null;
    return this;
  }
  addAllTargetSiteOperations(values) {
    this._value._targetSiteOperations = this._value._targetSiteOperations.concat(values);
    return this;
  }
  addTargetSiteOperations(value) {
    this._value._targetSiteOperations = this._value._targetSiteOperations.concat([value]);
    return this;
  }
  setTargetSiteOperations(index, value) {
    this._value._targetSiteOperations = this._value._targetSiteOperations.concat();
    this._value._targetSiteOperations[index] = value;
    return this;
  }
  clearTargetSiteOperations() {
    this._value._targetSiteOperations = [];
    return this;
  }
  setHostSite(value) {
    this._value._hasHostSite = true;
    this._value._hostSite = value;
    return this;
  }
  deleteHostSite() {
    this._value._hasHostSite = false;
    this._value._hostSite = null;
    return this;
  }
  setDeprecatedHostSiteOperation(value) {
    this._value._hasDeprecatedHostSiteOperation = true;
    this._value._hostSiteOperation = value;
    return this;
  }
  deleteDeprecatedHostSiteOperation() {
    this._value._hasDeprecatedHostSiteOperation = false;
    this._value._hostSiteOperation = null;
    return this;
  }
  addAllHostSiteOperations(values) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat(values);
    return this;
  }
  addHostSiteOperations(value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat([value]);
    return this;
  }
  setHostSiteOperations(index, value) {
    this._value._hostSiteOperations = this._value._hostSiteOperations.concat();
    this._value._hostSiteOperations[index] = value;
    return this;
  }
  clearHostSiteOperations() {
    this._value._hostSiteOperations = [];
    return this;
  }
  addAllAdditionalModels(values) {
    this._value._additionalModels = this._value._additionalModels.concat(values);
    return this;
  }
  addAdditionalModels(value) {
    this._value._additionalModels = this._value._additionalModels.concat([value]);
    return this;
  }
  setAdditionalModels(index, value) {
    this._value._additionalModels = this._value._additionalModels.concat();
    this._value._additionalModels[index] = value;
    return this;
  }
  clearAdditionalModels() {
    this._value._additionalModels = [];
    return this;
  }
}
ActionActor.Builder = ActionActor_Builder;
class ActionActor_WithParent {
  /**
   * @param {ActionActor} value
   * @param {ActionActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ActionActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasLaunchModel() {
    if (this._cachedHasLaunchModel === undefined) {
      if (this._value.hasLaunchModel) {
        this._cachedHasLaunchModel = true;
      } else {
        this._cachedHasLaunchModel = this._parent ? this._parent.hasLaunchModel : false;
      }
    }
    return this._cachedHasLaunchModel;
  }
  get launchModel() {
    if (this._cachedLaunchModel === undefined) {
      if (this._value.hasLaunchModel) {
        this._cachedLaunchModel = this._value.launchModel;
      } else {
        this._cachedLaunchModel = this._parent ? this._parent.launchModel : this._value.launchModel;
      }
    }
    return this._cachedLaunchModel;
  }
  get hasLaunchModelDetached() {
    if (this._cachedHasLaunchModelDetached === undefined) {
      if (this._value.hasLaunchModelDetached) {
        this._cachedHasLaunchModelDetached = true;
      } else {
        this._cachedHasLaunchModelDetached = this._parent ? this._parent.hasLaunchModelDetached : false;
      }
    }
    return this._cachedHasLaunchModelDetached;
  }
  get launchModelDetached() {
    if (this._cachedLaunchModelDetached === undefined) {
      if (this._value.hasLaunchModelDetached) {
        this._cachedLaunchModelDetached = this._value.launchModelDetached;
      } else {
        this._cachedLaunchModelDetached = this._parent ? this._parent.launchModelDetached : this._value.launchModelDetached;
      }
    }
    return this._cachedLaunchModelDetached;
  }
  get hasImpactModel() {
    if (this._cachedHasImpactModel === undefined) {
      if (this._value.hasImpactModel) {
        this._cachedHasImpactModel = true;
      } else {
        this._cachedHasImpactModel = this._parent ? this._parent.hasImpactModel : false;
      }
    }
    return this._cachedHasImpactModel;
  }
  get impactModel() {
    if (this._cachedImpactModel === undefined) {
      if (this._value.hasImpactModel) {
        this._cachedImpactModel = this._value.impactModel;
      } else {
        this._cachedImpactModel = this._parent ? this._parent.impactModel : this._value.impactModel;
      }
    }
    return this._cachedImpactModel;
  }
  get hasImpactModelDetached() {
    if (this._cachedHasImpactModelDetached === undefined) {
      if (this._value.hasImpactModelDetached) {
        this._cachedHasImpactModelDetached = true;
      } else {
        this._cachedHasImpactModelDetached = this._parent ? this._parent.hasImpactModelDetached : false;
      }
    }
    return this._cachedHasImpactModelDetached;
  }
  get impactModelDetached() {
    if (this._cachedImpactModelDetached === undefined) {
      if (this._value.hasImpactModelDetached) {
        this._cachedImpactModelDetached = this._value.impactModelDetached;
      } else {
        this._cachedImpactModelDetached = this._parent ? this._parent.impactModelDetached : this._value.impactModelDetached;
      }
    }
    return this._cachedImpactModelDetached;
  }
  get hasBeamModel() {
    if (this._cachedHasBeamModel === undefined) {
      if (this._value.hasBeamModel) {
        this._cachedHasBeamModel = true;
      } else {
        this._cachedHasBeamModel = this._parent ? this._parent.hasBeamModel : false;
      }
    }
    return this._cachedHasBeamModel;
  }
  get beamModel() {
    if (this._cachedBeamModel === undefined) {
      if (this._value.hasBeamModel) {
        this._cachedBeamModel = this._value.beamModel;
      } else {
        this._cachedBeamModel = this._parent ? this._parent.beamModel : this._value.beamModel;
      }
    }
    return this._cachedBeamModel;
  }
  get hasLaunchSite() {
    if (this._cachedHasLaunchSite === undefined) {
      if (this._value.hasLaunchSite) {
        this._cachedHasLaunchSite = true;
      } else {
        this._cachedHasLaunchSite = this._parent ? this._parent.hasLaunchSite : false;
      }
    }
    return this._cachedHasLaunchSite;
  }
  get launchSite() {
    if (this._cachedLaunchSite === undefined) {
      if (this._value.hasLaunchSite) {
        this._cachedLaunchSite = this._value.launchSite;
      } else {
        this._cachedLaunchSite = this._parent ? this._parent.launchSite : this._value.launchSite;
      }
    }
    return this._cachedLaunchSite;
  }
  get hasTargetSite() {
    if (this._cachedHasTargetSite === undefined) {
      if (this._value.hasTargetSite) {
        this._cachedHasTargetSite = true;
      } else {
        this._cachedHasTargetSite = this._parent ? this._parent.hasTargetSite : false;
      }
    }
    return this._cachedHasTargetSite;
  }
  get targetSite() {
    if (this._cachedTargetSite === undefined) {
      if (this._value.hasTargetSite) {
        this._cachedTargetSite = this._value.targetSite;
      } else {
        this._cachedTargetSite = this._parent ? this._parent.targetSite : this._value.targetSite;
      }
    }
    return this._cachedTargetSite;
  }
  get hasDeprecatedLaunchSiteOperation() {
    if (this._cachedHasDeprecatedLaunchSiteOperation === undefined) {
      if (this._value.hasDeprecatedLaunchSiteOperation) {
        this._cachedHasDeprecatedLaunchSiteOperation = true;
      } else {
        this._cachedHasDeprecatedLaunchSiteOperation = this._parent ? this._parent.hasDeprecatedLaunchSiteOperation : false;
      }
    }
    return this._cachedHasDeprecatedLaunchSiteOperation;
  }
  get launchSiteOperation() {
    if (this._cachedDeprecatedLaunchSiteOperation === undefined) {
      if (this._value.hasDeprecatedLaunchSiteOperation) {
        this._cachedDeprecatedLaunchSiteOperation = this._value.launchSiteOperation;
      } else {
        this._cachedDeprecatedLaunchSiteOperation = this._parent ? this._parent.launchSiteOperation : this._value.launchSiteOperation;
      }
    }
    return this._cachedDeprecatedLaunchSiteOperation;
  }
  get selfLaunchSiteOperations() {
    return this._value.launchSiteOperations;
  }
  get inherentLaunchSiteOperations() {
    if (!this._inherentLaunchSiteOperations) {
      this._inherentLaunchSiteOperations = this._parent ? this._parent.launchSiteOperations : [];
    }
    return this._inherentLaunchSiteOperations;
  }
  get launchSiteOperations() {
    if (!this._allLaunchSiteOperations) {
      this._allLaunchSiteOperations = this._parent ? this._parent.launchSiteOperations.concat(this.selfLaunchSiteOperations) : this.selfLaunchSiteOperations;
    }
    return this._allLaunchSiteOperations;
  }
  get hasDeprecatedTargetSiteOperation() {
    if (this._cachedHasDeprecatedTargetSiteOperation === undefined) {
      if (this._value.hasDeprecatedTargetSiteOperation) {
        this._cachedHasDeprecatedTargetSiteOperation = true;
      } else {
        this._cachedHasDeprecatedTargetSiteOperation = this._parent ? this._parent.hasDeprecatedTargetSiteOperation : false;
      }
    }
    return this._cachedHasDeprecatedTargetSiteOperation;
  }
  get targetSiteOperation() {
    if (this._cachedDeprecatedTargetSiteOperation === undefined) {
      if (this._value.hasDeprecatedTargetSiteOperation) {
        this._cachedDeprecatedTargetSiteOperation = this._value.targetSiteOperation;
      } else {
        this._cachedDeprecatedTargetSiteOperation = this._parent ? this._parent.targetSiteOperation : this._value.targetSiteOperation;
      }
    }
    return this._cachedDeprecatedTargetSiteOperation;
  }
  get selfTargetSiteOperations() {
    return this._value.targetSiteOperations;
  }
  get inherentTargetSiteOperations() {
    if (!this._inherentTargetSiteOperations) {
      this._inherentTargetSiteOperations = this._parent ? this._parent.targetSiteOperations : [];
    }
    return this._inherentTargetSiteOperations;
  }
  get targetSiteOperations() {
    if (!this._allTargetSiteOperations) {
      this._allTargetSiteOperations = this._parent ? this._parent.targetSiteOperations.concat(this.selfTargetSiteOperations) : this.selfTargetSiteOperations;
    }
    return this._allTargetSiteOperations;
  }
  get hasHostSite() {
    if (this._cachedHasHostSite === undefined) {
      if (this._value.hasHostSite) {
        this._cachedHasHostSite = true;
      } else {
        this._cachedHasHostSite = this._parent ? this._parent.hasHostSite : false;
      }
    }
    return this._cachedHasHostSite;
  }
  get hostSite() {
    if (this._cachedHostSite === undefined) {
      if (this._value.hasHostSite) {
        this._cachedHostSite = this._value.hostSite;
      } else {
        this._cachedHostSite = this._parent ? this._parent.hostSite : this._value.hostSite;
      }
    }
    return this._cachedHostSite;
  }
  get hasDeprecatedHostSiteOperation() {
    if (this._cachedHasDeprecatedHostSiteOperation === undefined) {
      if (this._value.hasDeprecatedHostSiteOperation) {
        this._cachedHasDeprecatedHostSiteOperation = true;
      } else {
        this._cachedHasDeprecatedHostSiteOperation = this._parent ? this._parent.hasDeprecatedHostSiteOperation : false;
      }
    }
    return this._cachedHasDeprecatedHostSiteOperation;
  }
  get hostSiteOperation() {
    if (this._cachedDeprecatedHostSiteOperation === undefined) {
      if (this._value.hasDeprecatedHostSiteOperation) {
        this._cachedDeprecatedHostSiteOperation = this._value.hostSiteOperation;
      } else {
        this._cachedDeprecatedHostSiteOperation = this._parent ? this._parent.hostSiteOperation : this._value.hostSiteOperation;
      }
    }
    return this._cachedDeprecatedHostSiteOperation;
  }
  get selfHostSiteOperations() {
    return this._value.hostSiteOperations;
  }
  get inherentHostSiteOperations() {
    if (!this._inherentHostSiteOperations) {
      this._inherentHostSiteOperations = this._parent ? this._parent.hostSiteOperations : [];
    }
    return this._inherentHostSiteOperations;
  }
  get hostSiteOperations() {
    if (!this._allHostSiteOperations) {
      this._allHostSiteOperations = this._parent ? this._parent.hostSiteOperations.concat(this.selfHostSiteOperations) : this.selfHostSiteOperations;
    }
    return this._allHostSiteOperations;
  }
  get selfAdditionalModels() {
    if (!this._selfAdditionalModels) {
      this._selfAdditionalModels = [];
      for (let i of this._value.additionalModels) {
        this._selfAdditionalModels.push(new ActionActor_AdditionalModel.WithParent(i, null));
      }
    }
    return this._selfAdditionalModels;
  }
  get inherentAdditionalModels() {
    if (!this._inherentAdditionalModels) {
      this._inherentAdditionalModels = this._parent ? this._parent.additionalModels : [];
    }
    return this._inherentAdditionalModels;
  }
  get additionalModels() {
    if (!this._allAdditionalModels) {
      this._allAdditionalModels = this._parent ? this._parent.additionalModels.concat(this.selfAdditionalModels) : this.selfAdditionalModels;
    }
    return this._allAdditionalModels;
  }
  update(current, parent) {
    const result = new ActionActor_WithParent(current, parent);
    if (this._selfAdditionalModels) {
      if (this._value.additionalModels === current.additionalModels) {
        result._selfAdditionalModels = this._selfAdditionalModels;
      } else {
        result._selfAdditionalModels = [];
        for (let i = 0; i < current.additionalModels.length; i++) {
          const oldValue = this._value.additionalModels[i];
          if (oldValue) {
            const oldCache = this._selfAdditionalModels[i];
            if (oldValue === current.additionalModels[i]) {
              result._selfAdditionalModels[i] = oldCache;
            } else {
              result._selfAdditionalModels[i] = oldCache.update(current.additionalModels[i], null);
            }
          } else {
            result._selfAdditionalModels[i] = new ActionActor_AdditionalModel.WithParent(current.additionalModels[i], null);
          }
        }
      }
    }
    return result;
  }
}
ActionActor_WithParent.default = new ActionActor_WithParent(ActionActor.default, null);
ActionActor.WithParent = ActionActor_WithParent;
class ActionActor_Descriptor {
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 1,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The effect that triggers the action.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get launchModel() {
    if (!this._launchModel) {
      this._launchModel = {
        name: "launchModel",
        Name: "LaunchModel",
        number: 2,
        protoType: 9,
        protoName: "launch_model",
        type: JsonToString,
        options: {
          comments: "The actor that\'s created when the action actor\'s effect starts. Uses the start location of the **effect**",
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchModel;
  }
  get launchModelDetached() {
    if (!this._launchModelDetached) {
      this._launchModelDetached = {
        name: "launchModelDetached",
        Name: "LaunchModelDetached",
        number: 3,
        protoType: 8,
        protoName: "launch_model_detached",
        type: JsonToBoolean,
        options: {
          comments: "When checked, prevents the launch model from following a unit if the **effect** target is a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchModelDetached;
  }
  get impactModel() {
    if (!this._impactModel) {
      this._impactModel = {
        name: "impactModel",
        Name: "ImpactModel",
        number: 4,
        protoType: 9,
        protoName: "impact_model",
        type: JsonToString,
        options: {
          comments: "The actor that\'s created when the action actor\'s **effect** ends. Uses the end location of the effect.",
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactModel;
  }
  get impactModelDetached() {
    if (!this._impactModelDetached) {
      this._impactModelDetached = {
        name: "impactModelDetached",
        Name: "ImpactModelDetached",
        number: 5,
        protoType: 8,
        protoName: "impact_model_detached",
        type: JsonToBoolean,
        options: {
          comments: "When checked, prevents the impact model from following a unit if the **effect** target is a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._impactModelDetached;
  }
  get beamModel() {
    if (!this._beamModel) {
      this._beamModel = {
        name: "beamModel",
        Name: "BeamModel",
        number: 6,
        protoType: 9,
        protoName: "beam_model",
        type: JsonToString,
        options: {
          comments: "Creates a beam between the action\'s **launch site** and **target site**.",
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._beamModel;
  }
  get launchSite() {
    if (!this._launchSite) {
      this._launchSite = {
        name: "launchSite",
        Name: "LaunchSite",
        number: 11,
        protoType: 9,
        protoName: "launch_site",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchSite;
  }
  get targetSite() {
    if (!this._targetSite) {
      this._targetSite = {
        name: "targetSite",
        Name: "TargetSite",
        number: 12,
        protoType: 9,
        protoName: "target_site",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetSite;
  }
  get launchSiteOperation() {
    if (!this._launchSiteOperation) {
      this._launchSiteOperation = {
        name: "launchSiteOperation",
        Name: "DeprecatedLaunchSiteOperation",
        number: 1013,
        protoType: 9,
        protoName: "deprecated_launch_site_operation",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchSiteOperation;
  }
  get launchSiteOperations() {
    if (!this._launchSiteOperations) {
      this._launchSiteOperations = {
        name: "launchSiteOperations",
        Name: "LaunchSiteOperations",
        number: 13,
        protoType: 9,
        protoName: "launch_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Site operations applied to the **launch model**.",
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._launchSiteOperations;
  }
  get targetSiteOperation() {
    if (!this._targetSiteOperation) {
      this._targetSiteOperation = {
        name: "targetSiteOperation",
        Name: "DeprecatedTargetSiteOperation",
        number: 1014,
        protoType: 9,
        protoName: "deprecated_target_site_operation",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetSiteOperation;
  }
  get targetSiteOperations() {
    if (!this._targetSiteOperations) {
      this._targetSiteOperations = {
        name: "targetSiteOperations",
        Name: "TargetSiteOperations",
        number: 14,
        protoType: 9,
        protoName: "target_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Site operations applied to the **impact model**.",
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetSiteOperations;
  }
  get hostSite() {
    if (!this._hostSite) {
      this._hostSite = {
        name: "hostSite",
        Name: "HostSite",
        number: 31,
        protoType: 9,
        protoName: "host_site",
        type: JsonToString,
        options: {
          deprecated: {date: '2021-03-26', reason: 'Not used.'},
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSite;
  }
  get hostSiteOperation() {
    if (!this._hostSiteOperation) {
      this._hostSiteOperation = {
        name: "hostSiteOperation",
        Name: "DeprecatedHostSiteOperation",
        number: 1032,
        protoType: 9,
        protoName: "deprecated_host_site_operation",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSiteOperation;
  }
  get hostSiteOperations() {
    if (!this._hostSiteOperations) {
      this._hostSiteOperations = {
        name: "hostSiteOperations",
        Name: "HostSiteOperations",
        number: 32,
        protoType: 9,
        protoName: "host_site_operations",
        type: JsonToString,
        isRepeated: true,
        options: {
          deprecated: {date: '2021-03-26', reason: 'Not used.'},
          valueDropdown: "SupportedSiteOperationNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hostSiteOperations;
  }
  get additionalModels() {
    if (!this._additionalModels) {
      this._additionalModels = {
        name: "additionalModels",
        Name: "AdditionalModels",
        number: 41,
        protoType: 11,
        protoName: "additional_models",
        type: ActionActor_AdditionalModel,
        isRepeated: true,
        options: {
          comments: "Used to add additional launch and impact models to the action.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._additionalModels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.effect,
        this.launchModel,
        this.launchModelDetached,
        this.impactModel,
        this.impactModelDetached,
        this.beamModel,
        this.launchSite,
        this.targetSite,
        this.launchSiteOperation,
        this.launchSiteOperations,
        this.targetSiteOperation,
        this.targetSiteOperations,
        this.hostSite,
        this.hostSiteOperation,
        this.hostSiteOperations,
        this.additionalModels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchModel",
        Name: "DummyOneofForLaunchModel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchModelDetached",
        Name: "DummyOneofForLaunchModelDetached",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactModel",
        Name: "DummyOneofForImpactModel",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForImpactModelDetached",
        Name: "DummyOneofForImpactModelDetached",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBeamModel",
        Name: "DummyOneofForBeamModel",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLaunchSite",
        Name: "DummyOneofForLaunchSite",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetSite",
        Name: "DummyOneofForTargetSite",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedLaunchSiteOperation",
        Name: "DummyOneofForDeprecatedLaunchSiteOperation",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedTargetSiteOperation",
        Name: "DummyOneofForDeprecatedTargetSiteOperation",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHostSite",
        Name: "DummyOneofForHostSite",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedHostSiteOperation",
        Name: "DummyOneofForDeprecatedHostSiteOperation",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
ActionActor.descriptor = new ActionActor_Descriptor();
class SiteOperation_Offset {
  get descriptor() {
    return SiteOperation_Offset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
    this._hasXRange = false;
    this._xRange = null;
    this._hasYRange = false;
    this._yRange = null;
    this._hasZRange = false;
    this._zRange = null;
    this._hasOrientation = false;
    this._orientation = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    if (this._hasXRange) return false;
    if (this._hasYRange) return false;
    if (this._hasZRange) return false;
    if (this._hasOrientation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_Offset) {
      return value;
    }
    return SiteOperation_Offset.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_Offset();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    if (json.xRange != null) {
      result._hasXRange = true;
      result._xRange = JsonToDouble.fromJson(json.xRange);
    }
    if (json.yRange != null) {
      result._hasYRange = true;
      result._yRange = JsonToDouble.fromJson(json.yRange);
    }
    if (json.zRange != null) {
      result._hasZRange = true;
      result._zRange = JsonToDouble.fromJson(json.zRange);
    }
    if (json.orientation != null) {
      result._hasOrientation = true;
      result._orientation = SiteOperation_OrientationType.fromJson(json.orientation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    if (this._hasXRange) {
      result.xRange = JsonToDouble.toJson(this._xRange);
    }
    if (this._hasYRange) {
      result.yRange = JsonToDouble.toJson(this._yRange);
    }
    if (this._hasZRange) {
      result.zRange = JsonToDouble.toJson(this._zRange);
    }
    if (this._hasOrientation) {
      result.orientation = SiteOperation_OrientationType.toJson(this._orientation);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  /**
   * @returns {number}
   */
  get xRange() {
    return this._hasXRange ? this._xRange : JsonToDouble.default;
  }
  get hasXRange() {
    return this._hasXRange;
  }
  setXRange(path, value) {
    return {type: 'SET', path: path.concat(['xRange']), value};
  }
  deleteXRange(path) {
    return {type: 'DELETE', path: path.concat(['xRange'])};
  }
  /**
   * @returns {number}
   */
  get yRange() {
    return this._hasYRange ? this._yRange : JsonToDouble.default;
  }
  get hasYRange() {
    return this._hasYRange;
  }
  setYRange(path, value) {
    return {type: 'SET', path: path.concat(['yRange']), value};
  }
  deleteYRange(path) {
    return {type: 'DELETE', path: path.concat(['yRange'])};
  }
  /**
   * @returns {number}
   */
  get zRange() {
    return this._hasZRange ? this._zRange : JsonToDouble.default;
  }
  get hasZRange() {
    return this._hasZRange;
  }
  setZRange(path, value) {
    return {type: 'SET', path: path.concat(['zRange']), value};
  }
  deleteZRange(path) {
    return {type: 'DELETE', path: path.concat(['zRange'])};
  }
  /**
   * @returns {number}
   */
  get orientation() {
    return this._hasOrientation ? this._orientation : SiteOperation_OrientationType.default;
  }
  get hasOrientation() {
    return this._hasOrientation;
  }
  setOrientation(path, value) {
    return {type: 'SET', path: path.concat(['orientation']), value};
  }
  deleteOrientation(path) {
    return {type: 'DELETE', path: path.concat(['orientation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasXRange = true;
              copy._xRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXRange) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasXRange = false;
              copy._xRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "yRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasYRange = true;
              copy._yRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasYRange) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasYRange = false;
              copy._yRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "zRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasZRange = true;
              copy._zRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZRange) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasZRange = false;
              copy._zRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "orientation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Offset(this);
              copy._hasOrientation = true;
              copy._orientation = SiteOperation_OrientationType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOrientation) {
                return this;
              }
              const copy = new SiteOperation_Offset(this);
              copy._hasOrientation = false;
              copy._orientation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_Offset} other
   * @returns {SiteOperation_Offset}
   */
  merge(other) {
    const copy = new SiteOperation_Offset(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    if (other._hasXRange) {
      copy._hasXRange = true;
      copy._xRange = other._xRange;
    }
    if (other._hasYRange) {
      copy._hasYRange = true;
      copy._yRange = other._yRange;
    }
    if (other._hasZRange) {
      copy._hasZRange = true;
      copy._zRange = other._zRange;
    }
    if (other._hasOrientation) {
      copy._hasOrientation = true;
      copy._orientation = other._orientation;
    }
    return copy;
  }
}
SiteOperation_Offset.default = new SiteOperation_Offset();
class SiteOperation_Offset_Builder {
  constructor(value) {
    this._value = new SiteOperation_Offset(value);
  }
  build() {
    return new SiteOperation_Offset(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
  setXRange(value) {
    this._value._hasXRange = true;
    this._value._xRange = value;
    return this;
  }
  deleteXRange() {
    this._value._hasXRange = false;
    this._value._xRange = null;
    return this;
  }
  setYRange(value) {
    this._value._hasYRange = true;
    this._value._yRange = value;
    return this;
  }
  deleteYRange() {
    this._value._hasYRange = false;
    this._value._yRange = null;
    return this;
  }
  setZRange(value) {
    this._value._hasZRange = true;
    this._value._zRange = value;
    return this;
  }
  deleteZRange() {
    this._value._hasZRange = false;
    this._value._zRange = null;
    return this;
  }
  setOrientation(value) {
    this._value._hasOrientation = true;
    this._value._orientation = value;
    return this;
  }
  deleteOrientation() {
    this._value._hasOrientation = false;
    this._value._orientation = null;
    return this;
  }
}
SiteOperation_Offset.Builder = SiteOperation_Offset_Builder;
class SiteOperation_Offset_WithParent {
  /**
   * @param {SiteOperation_Offset} value
   * @param {SiteOperation_Offset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_Offset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  get hasXRange() {
    if (this._cachedHasXRange === undefined) {
      if (this._value.hasXRange) {
        this._cachedHasXRange = true;
      } else {
        this._cachedHasXRange = this._parent ? this._parent.hasXRange : false;
      }
    }
    return this._cachedHasXRange;
  }
  get xRange() {
    if (this._cachedXRange === undefined) {
      if (this._value.hasXRange) {
        this._cachedXRange = this._value.xRange;
      } else {
        this._cachedXRange = this._parent ? this._parent.xRange : this._value.xRange;
      }
    }
    return this._cachedXRange;
  }
  get hasYRange() {
    if (this._cachedHasYRange === undefined) {
      if (this._value.hasYRange) {
        this._cachedHasYRange = true;
      } else {
        this._cachedHasYRange = this._parent ? this._parent.hasYRange : false;
      }
    }
    return this._cachedHasYRange;
  }
  get yRange() {
    if (this._cachedYRange === undefined) {
      if (this._value.hasYRange) {
        this._cachedYRange = this._value.yRange;
      } else {
        this._cachedYRange = this._parent ? this._parent.yRange : this._value.yRange;
      }
    }
    return this._cachedYRange;
  }
  get hasZRange() {
    if (this._cachedHasZRange === undefined) {
      if (this._value.hasZRange) {
        this._cachedHasZRange = true;
      } else {
        this._cachedHasZRange = this._parent ? this._parent.hasZRange : false;
      }
    }
    return this._cachedHasZRange;
  }
  get zRange() {
    if (this._cachedZRange === undefined) {
      if (this._value.hasZRange) {
        this._cachedZRange = this._value.zRange;
      } else {
        this._cachedZRange = this._parent ? this._parent.zRange : this._value.zRange;
      }
    }
    return this._cachedZRange;
  }
  get hasOrientation() {
    if (this._cachedHasOrientation === undefined) {
      if (this._value.hasOrientation) {
        this._cachedHasOrientation = true;
      } else {
        this._cachedHasOrientation = this._parent ? this._parent.hasOrientation : false;
      }
    }
    return this._cachedHasOrientation;
  }
  get orientation() {
    if (this._cachedOrientation === undefined) {
      if (this._value.hasOrientation) {
        this._cachedOrientation = this._value.orientation;
      } else {
        this._cachedOrientation = this._parent ? this._parent.orientation : this._value.orientation;
      }
    }
    return this._cachedOrientation;
  }
  update(current, parent) {
    const result = new SiteOperation_Offset_WithParent(current, parent);
    return result;
  }
}
SiteOperation_Offset_WithParent.default = new SiteOperation_Offset_WithParent(SiteOperation_Offset.default, null);
SiteOperation_Offset.WithParent = SiteOperation_Offset_WithParent;
class SiteOperation_Offset_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
          comments: "Left/Right offset. Positive values are offset right, negative values are offset left.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
          comments: "Up/Down offset. Positive values are up, negative values are down.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
          comments: "Forward/Back offset. Positive values are forward, negative values are back.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get xRange() {
    if (!this._xRange) {
      this._xRange = {
        name: "xRange",
        Name: "XRange",
        number: 11,
        protoType: 1,
        protoName: "x_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the X Range will be applied to the X offset when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xRange;
  }
  get yRange() {
    if (!this._yRange) {
      this._yRange = {
        name: "yRange",
        Name: "YRange",
        number: 12,
        protoType: 1,
        protoName: "y_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the Y Range will be applied to the Y offset when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._yRange;
  }
  get zRange() {
    if (!this._zRange) {
      this._zRange = {
        name: "zRange",
        Name: "ZRange",
        number: 13,
        protoType: 1,
        protoName: "z_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the Z Range will be applied to the Z offset when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._zRange;
  }
  get orientation() {
    if (!this._orientation) {
      this._orientation = {
        name: "orientation",
        Name: "Orientation",
        number: 4,
        protoType: 14,
        protoName: "orientation",
        type: SiteOperation_OrientationType,
        options: {
          comments: "Determines relative direction of the offset.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._orientation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
        this.xRange,
        this.yRange,
        this.zRange,
        this.orientation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXRange",
        Name: "DummyOneofForXRange",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForYRange",
        Name: "DummyOneofForYRange",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZRange",
        Name: "DummyOneofForZRange",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOrientation",
        Name: "DummyOneofForOrientation",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_Offset.descriptor = new SiteOperation_Offset_Descriptor();
class SiteOperation_AbsoluteHeight {
  get descriptor() {
    return SiteOperation_AbsoluteHeight.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHeight = false;
    this._height = null;
  }
  isEmpty() {
    if (this._hasHeight) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_AbsoluteHeight) {
      return value;
    }
    return SiteOperation_AbsoluteHeight.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_AbsoluteHeight();
    if (json.height != null) {
      result._hasHeight = true;
      result._height = JsonToDouble.fromJson(json.height);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHeight) {
      result.height = JsonToDouble.toJson(this._height);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get height() {
    return this._hasHeight ? this._height : JsonToDouble.default;
  }
  get hasHeight() {
    return this._hasHeight;
  }
  setHeight(path, value) {
    return {type: 'SET', path: path.concat(['height']), value};
  }
  deleteHeight(path) {
    return {type: 'DELETE', path: path.concat(['height'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "height": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteHeight(this);
              copy._hasHeight = true;
              copy._height = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHeight) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteHeight(this);
              copy._hasHeight = false;
              copy._height = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_AbsoluteHeight} other
   * @returns {SiteOperation_AbsoluteHeight}
   */
  merge(other) {
    const copy = new SiteOperation_AbsoluteHeight(this);
    if (other._hasHeight) {
      copy._hasHeight = true;
      copy._height = other._height;
    }
    return copy;
  }
}
SiteOperation_AbsoluteHeight.default = new SiteOperation_AbsoluteHeight();
class SiteOperation_AbsoluteHeight_Builder {
  constructor(value) {
    this._value = new SiteOperation_AbsoluteHeight(value);
  }
  build() {
    return new SiteOperation_AbsoluteHeight(this._value);
  }
  setHeight(value) {
    this._value._hasHeight = true;
    this._value._height = value;
    return this;
  }
  deleteHeight() {
    this._value._hasHeight = false;
    this._value._height = null;
    return this;
  }
}
SiteOperation_AbsoluteHeight.Builder = SiteOperation_AbsoluteHeight_Builder;
class SiteOperation_AbsoluteHeight_WithParent {
  /**
   * @param {SiteOperation_AbsoluteHeight} value
   * @param {SiteOperation_AbsoluteHeight_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_AbsoluteHeight.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHeight() {
    if (this._cachedHasHeight === undefined) {
      if (this._value.hasHeight) {
        this._cachedHasHeight = true;
      } else {
        this._cachedHasHeight = this._parent ? this._parent.hasHeight : false;
      }
    }
    return this._cachedHasHeight;
  }
  get height() {
    if (this._cachedHeight === undefined) {
      if (this._value.hasHeight) {
        this._cachedHeight = this._value.height;
      } else {
        this._cachedHeight = this._parent ? this._parent.height : this._value.height;
      }
    }
    return this._cachedHeight;
  }
  update(current, parent) {
    const result = new SiteOperation_AbsoluteHeight_WithParent(current, parent);
    return result;
  }
}
SiteOperation_AbsoluteHeight_WithParent.default = new SiteOperation_AbsoluteHeight_WithParent(SiteOperation_AbsoluteHeight.default, null);
SiteOperation_AbsoluteHeight.WithParent = SiteOperation_AbsoluteHeight_WithParent;
class SiteOperation_AbsoluteHeight_Descriptor {
  get height() {
    if (!this._height) {
      this._height = {
        name: "height",
        Name: "Height",
        number: 1,
        protoType: 1,
        protoName: "height",
        type: JsonToDouble,
        options: {
          comments: "Sets the absolute height of the actor.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._height;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.height,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHeight",
        Name: "DummyOneofForHeight",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_AbsoluteHeight.descriptor = new SiteOperation_AbsoluteHeight_Descriptor();
class SiteOperation_AbsoluteOffset {
  get descriptor() {
    return SiteOperation_AbsoluteOffset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
    this._hasXRange = false;
    this._xRange = null;
    this._hasYRange = false;
    this._yRange = null;
    this._hasZRange = false;
    this._zRange = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    if (this._hasXRange) return false;
    if (this._hasYRange) return false;
    if (this._hasZRange) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_AbsoluteOffset) {
      return value;
    }
    return SiteOperation_AbsoluteOffset.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_AbsoluteOffset();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    if (json.xRange != null) {
      result._hasXRange = true;
      result._xRange = JsonToDouble.fromJson(json.xRange);
    }
    if (json.yRange != null) {
      result._hasYRange = true;
      result._yRange = JsonToDouble.fromJson(json.yRange);
    }
    if (json.zRange != null) {
      result._hasZRange = true;
      result._zRange = JsonToDouble.fromJson(json.zRange);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    if (this._hasXRange) {
      result.xRange = JsonToDouble.toJson(this._xRange);
    }
    if (this._hasYRange) {
      result.yRange = JsonToDouble.toJson(this._yRange);
    }
    if (this._hasZRange) {
      result.zRange = JsonToDouble.toJson(this._zRange);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  /**
   * @returns {number}
   */
  get xRange() {
    return this._hasXRange ? this._xRange : JsonToDouble.default;
  }
  get hasXRange() {
    return this._hasXRange;
  }
  setXRange(path, value) {
    return {type: 'SET', path: path.concat(['xRange']), value};
  }
  deleteXRange(path) {
    return {type: 'DELETE', path: path.concat(['xRange'])};
  }
  /**
   * @returns {number}
   */
  get yRange() {
    return this._hasYRange ? this._yRange : JsonToDouble.default;
  }
  get hasYRange() {
    return this._hasYRange;
  }
  setYRange(path, value) {
    return {type: 'SET', path: path.concat(['yRange']), value};
  }
  deleteYRange(path) {
    return {type: 'DELETE', path: path.concat(['yRange'])};
  }
  /**
   * @returns {number}
   */
  get zRange() {
    return this._hasZRange ? this._zRange : JsonToDouble.default;
  }
  get hasZRange() {
    return this._hasZRange;
  }
  setZRange(path, value) {
    return {type: 'SET', path: path.concat(['zRange']), value};
  }
  deleteZRange(path) {
    return {type: 'DELETE', path: path.concat(['zRange'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasXRange = true;
              copy._xRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXRange) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasXRange = false;
              copy._xRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "yRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasYRange = true;
              copy._yRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasYRange) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasYRange = false;
              copy._yRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "zRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasZRange = true;
              copy._zRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZRange) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteOffset(this);
              copy._hasZRange = false;
              copy._zRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_AbsoluteOffset} other
   * @returns {SiteOperation_AbsoluteOffset}
   */
  merge(other) {
    const copy = new SiteOperation_AbsoluteOffset(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    if (other._hasXRange) {
      copy._hasXRange = true;
      copy._xRange = other._xRange;
    }
    if (other._hasYRange) {
      copy._hasYRange = true;
      copy._yRange = other._yRange;
    }
    if (other._hasZRange) {
      copy._hasZRange = true;
      copy._zRange = other._zRange;
    }
    return copy;
  }
}
SiteOperation_AbsoluteOffset.default = new SiteOperation_AbsoluteOffset();
class SiteOperation_AbsoluteOffset_Builder {
  constructor(value) {
    this._value = new SiteOperation_AbsoluteOffset(value);
  }
  build() {
    return new SiteOperation_AbsoluteOffset(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
  setXRange(value) {
    this._value._hasXRange = true;
    this._value._xRange = value;
    return this;
  }
  deleteXRange() {
    this._value._hasXRange = false;
    this._value._xRange = null;
    return this;
  }
  setYRange(value) {
    this._value._hasYRange = true;
    this._value._yRange = value;
    return this;
  }
  deleteYRange() {
    this._value._hasYRange = false;
    this._value._yRange = null;
    return this;
  }
  setZRange(value) {
    this._value._hasZRange = true;
    this._value._zRange = value;
    return this;
  }
  deleteZRange() {
    this._value._hasZRange = false;
    this._value._zRange = null;
    return this;
  }
}
SiteOperation_AbsoluteOffset.Builder = SiteOperation_AbsoluteOffset_Builder;
class SiteOperation_AbsoluteOffset_WithParent {
  /**
   * @param {SiteOperation_AbsoluteOffset} value
   * @param {SiteOperation_AbsoluteOffset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_AbsoluteOffset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  get hasXRange() {
    if (this._cachedHasXRange === undefined) {
      if (this._value.hasXRange) {
        this._cachedHasXRange = true;
      } else {
        this._cachedHasXRange = this._parent ? this._parent.hasXRange : false;
      }
    }
    return this._cachedHasXRange;
  }
  get xRange() {
    if (this._cachedXRange === undefined) {
      if (this._value.hasXRange) {
        this._cachedXRange = this._value.xRange;
      } else {
        this._cachedXRange = this._parent ? this._parent.xRange : this._value.xRange;
      }
    }
    return this._cachedXRange;
  }
  get hasYRange() {
    if (this._cachedHasYRange === undefined) {
      if (this._value.hasYRange) {
        this._cachedHasYRange = true;
      } else {
        this._cachedHasYRange = this._parent ? this._parent.hasYRange : false;
      }
    }
    return this._cachedHasYRange;
  }
  get yRange() {
    if (this._cachedYRange === undefined) {
      if (this._value.hasYRange) {
        this._cachedYRange = this._value.yRange;
      } else {
        this._cachedYRange = this._parent ? this._parent.yRange : this._value.yRange;
      }
    }
    return this._cachedYRange;
  }
  get hasZRange() {
    if (this._cachedHasZRange === undefined) {
      if (this._value.hasZRange) {
        this._cachedHasZRange = true;
      } else {
        this._cachedHasZRange = this._parent ? this._parent.hasZRange : false;
      }
    }
    return this._cachedHasZRange;
  }
  get zRange() {
    if (this._cachedZRange === undefined) {
      if (this._value.hasZRange) {
        this._cachedZRange = this._value.zRange;
      } else {
        this._cachedZRange = this._parent ? this._parent.zRange : this._value.zRange;
      }
    }
    return this._cachedZRange;
  }
  update(current, parent) {
    const result = new SiteOperation_AbsoluteOffset_WithParent(current, parent);
    return result;
  }
}
SiteOperation_AbsoluteOffset_WithParent.default = new SiteOperation_AbsoluteOffset_WithParent(SiteOperation_AbsoluteOffset.default, null);
SiteOperation_AbsoluteOffset.WithParent = SiteOperation_AbsoluteOffset_WithParent;
class SiteOperation_AbsoluteOffset_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
          comments: "Horizontal position on the world grid. A value of 0 is the map\'s left edge.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
          comments: "Height position on the world grid. A value of 0 is the map\'s base height.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
          comments: "Vertical position on the world grid. A value of 0 is the map\'s bottom edge.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get xRange() {
    if (!this._xRange) {
      this._xRange = {
        name: "xRange",
        Name: "XRange",
        number: 11,
        protoType: 1,
        protoName: "x_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the X Range will be applied to the X position when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xRange;
  }
  get yRange() {
    if (!this._yRange) {
      this._yRange = {
        name: "yRange",
        Name: "YRange",
        number: 12,
        protoType: 1,
        protoName: "y_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the Y Range will be applied to the Y position when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._yRange;
  }
  get zRange() {
    if (!this._zRange) {
      this._zRange = {
        name: "zRange",
        Name: "ZRange",
        number: 13,
        protoType: 1,
        protoName: "z_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the Z Range will be applied to the Z position when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._zRange;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
        this.xRange,
        this.yRange,
        this.zRange,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXRange",
        Name: "DummyOneofForXRange",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForYRange",
        Name: "DummyOneofForYRange",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZRange",
        Name: "DummyOneofForZRange",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_AbsoluteOffset.descriptor = new SiteOperation_AbsoluteOffset_Descriptor();
class SiteOperation_AbsoluteX {
  get descriptor() {
    return SiteOperation_AbsoluteX.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasXRange = false;
    this._xRange = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasXRange) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_AbsoluteX) {
      return value;
    }
    return SiteOperation_AbsoluteX.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_AbsoluteX();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.xRange != null) {
      result._hasXRange = true;
      result._xRange = JsonToDouble.fromJson(json.xRange);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasXRange) {
      result.xRange = JsonToDouble.toJson(this._xRange);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get xRange() {
    return this._hasXRange ? this._xRange : JsonToDouble.default;
  }
  get hasXRange() {
    return this._hasXRange;
  }
  setXRange(path, value) {
    return {type: 'SET', path: path.concat(['xRange']), value};
  }
  deleteXRange(path) {
    return {type: 'DELETE', path: path.concat(['xRange'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteX(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteX(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteX(this);
              copy._hasXRange = true;
              copy._xRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXRange) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteX(this);
              copy._hasXRange = false;
              copy._xRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_AbsoluteX} other
   * @returns {SiteOperation_AbsoluteX}
   */
  merge(other) {
    const copy = new SiteOperation_AbsoluteX(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasXRange) {
      copy._hasXRange = true;
      copy._xRange = other._xRange;
    }
    return copy;
  }
}
SiteOperation_AbsoluteX.default = new SiteOperation_AbsoluteX();
class SiteOperation_AbsoluteX_Builder {
  constructor(value) {
    this._value = new SiteOperation_AbsoluteX(value);
  }
  build() {
    return new SiteOperation_AbsoluteX(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setXRange(value) {
    this._value._hasXRange = true;
    this._value._xRange = value;
    return this;
  }
  deleteXRange() {
    this._value._hasXRange = false;
    this._value._xRange = null;
    return this;
  }
}
SiteOperation_AbsoluteX.Builder = SiteOperation_AbsoluteX_Builder;
class SiteOperation_AbsoluteX_WithParent {
  /**
   * @param {SiteOperation_AbsoluteX} value
   * @param {SiteOperation_AbsoluteX_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_AbsoluteX.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasXRange() {
    if (this._cachedHasXRange === undefined) {
      if (this._value.hasXRange) {
        this._cachedHasXRange = true;
      } else {
        this._cachedHasXRange = this._parent ? this._parent.hasXRange : false;
      }
    }
    return this._cachedHasXRange;
  }
  get xRange() {
    if (this._cachedXRange === undefined) {
      if (this._value.hasXRange) {
        this._cachedXRange = this._value.xRange;
      } else {
        this._cachedXRange = this._parent ? this._parent.xRange : this._value.xRange;
      }
    }
    return this._cachedXRange;
  }
  update(current, parent) {
    const result = new SiteOperation_AbsoluteX_WithParent(current, parent);
    return result;
  }
}
SiteOperation_AbsoluteX_WithParent.default = new SiteOperation_AbsoluteX_WithParent(SiteOperation_AbsoluteX.default, null);
SiteOperation_AbsoluteX.WithParent = SiteOperation_AbsoluteX_WithParent;
class SiteOperation_AbsoluteX_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
          comments: "Horizontal position on the world grid. A value of 0 is the map\'s left edge.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get xRange() {
    if (!this._xRange) {
      this._xRange = {
        name: "xRange",
        Name: "XRange",
        number: 11,
        protoType: 1,
        protoName: "x_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the X Range will be applied to the X position when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xRange;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.xRange,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXRange",
        Name: "DummyOneofForXRange",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_AbsoluteX.descriptor = new SiteOperation_AbsoluteX_Descriptor();
class SiteOperation_AbsoluteY {
  get descriptor() {
    return SiteOperation_AbsoluteY.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasY = false;
    this._y = null;
    this._hasYRange = false;
    this._yRange = null;
  }
  isEmpty() {
    if (this._hasY) return false;
    if (this._hasYRange) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_AbsoluteY) {
      return value;
    }
    return SiteOperation_AbsoluteY.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_AbsoluteY();
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.yRange != null) {
      result._hasYRange = true;
      result._yRange = JsonToDouble.fromJson(json.yRange);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasYRange) {
      result.yRange = JsonToDouble.toJson(this._yRange);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get yRange() {
    return this._hasYRange ? this._yRange : JsonToDouble.default;
  }
  get hasYRange() {
    return this._hasYRange;
  }
  setYRange(path, value) {
    return {type: 'SET', path: path.concat(['yRange']), value};
  }
  deleteYRange(path) {
    return {type: 'DELETE', path: path.concat(['yRange'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteY(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteY(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "yRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteY(this);
              copy._hasYRange = true;
              copy._yRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasYRange) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteY(this);
              copy._hasYRange = false;
              copy._yRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_AbsoluteY} other
   * @returns {SiteOperation_AbsoluteY}
   */
  merge(other) {
    const copy = new SiteOperation_AbsoluteY(this);
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasYRange) {
      copy._hasYRange = true;
      copy._yRange = other._yRange;
    }
    return copy;
  }
}
SiteOperation_AbsoluteY.default = new SiteOperation_AbsoluteY();
class SiteOperation_AbsoluteY_Builder {
  constructor(value) {
    this._value = new SiteOperation_AbsoluteY(value);
  }
  build() {
    return new SiteOperation_AbsoluteY(this._value);
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setYRange(value) {
    this._value._hasYRange = true;
    this._value._yRange = value;
    return this;
  }
  deleteYRange() {
    this._value._hasYRange = false;
    this._value._yRange = null;
    return this;
  }
}
SiteOperation_AbsoluteY.Builder = SiteOperation_AbsoluteY_Builder;
class SiteOperation_AbsoluteY_WithParent {
  /**
   * @param {SiteOperation_AbsoluteY} value
   * @param {SiteOperation_AbsoluteY_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_AbsoluteY.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasYRange() {
    if (this._cachedHasYRange === undefined) {
      if (this._value.hasYRange) {
        this._cachedHasYRange = true;
      } else {
        this._cachedHasYRange = this._parent ? this._parent.hasYRange : false;
      }
    }
    return this._cachedHasYRange;
  }
  get yRange() {
    if (this._cachedYRange === undefined) {
      if (this._value.hasYRange) {
        this._cachedYRange = this._value.yRange;
      } else {
        this._cachedYRange = this._parent ? this._parent.yRange : this._value.yRange;
      }
    }
    return this._cachedYRange;
  }
  update(current, parent) {
    const result = new SiteOperation_AbsoluteY_WithParent(current, parent);
    return result;
  }
}
SiteOperation_AbsoluteY_WithParent.default = new SiteOperation_AbsoluteY_WithParent(SiteOperation_AbsoluteY.default, null);
SiteOperation_AbsoluteY.WithParent = SiteOperation_AbsoluteY_WithParent;
class SiteOperation_AbsoluteY_Descriptor {
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 1,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
          comments: "Height position on the world grid. A value of 0 is the map\'s base height.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get yRange() {
    if (!this._yRange) {
      this._yRange = {
        name: "yRange",
        Name: "YRange",
        number: 11,
        protoType: 1,
        protoName: "y_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the Y Range will be applied to the Y position when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._yRange;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.y,
        this.yRange,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForYRange",
        Name: "DummyOneofForYRange",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_AbsoluteY.descriptor = new SiteOperation_AbsoluteY_Descriptor();
class SiteOperation_AbsoluteZ {
  get descriptor() {
    return SiteOperation_AbsoluteZ.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasZ = false;
    this._z = null;
    this._hasZRange = false;
    this._zRange = null;
  }
  isEmpty() {
    if (this._hasZ) return false;
    if (this._hasZRange) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_AbsoluteZ) {
      return value;
    }
    return SiteOperation_AbsoluteZ.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_AbsoluteZ();
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    if (json.zRange != null) {
      result._hasZRange = true;
      result._zRange = JsonToDouble.fromJson(json.zRange);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    if (this._hasZRange) {
      result.zRange = JsonToDouble.toJson(this._zRange);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  /**
   * @returns {number}
   */
  get zRange() {
    return this._hasZRange ? this._zRange : JsonToDouble.default;
  }
  get hasZRange() {
    return this._hasZRange;
  }
  setZRange(path, value) {
    return {type: 'SET', path: path.concat(['zRange']), value};
  }
  deleteZRange(path) {
    return {type: 'DELETE', path: path.concat(['zRange'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteZ(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteZ(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "zRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_AbsoluteZ(this);
              copy._hasZRange = true;
              copy._zRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZRange) {
                return this;
              }
              const copy = new SiteOperation_AbsoluteZ(this);
              copy._hasZRange = false;
              copy._zRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_AbsoluteZ} other
   * @returns {SiteOperation_AbsoluteZ}
   */
  merge(other) {
    const copy = new SiteOperation_AbsoluteZ(this);
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    if (other._hasZRange) {
      copy._hasZRange = true;
      copy._zRange = other._zRange;
    }
    return copy;
  }
}
SiteOperation_AbsoluteZ.default = new SiteOperation_AbsoluteZ();
class SiteOperation_AbsoluteZ_Builder {
  constructor(value) {
    this._value = new SiteOperation_AbsoluteZ(value);
  }
  build() {
    return new SiteOperation_AbsoluteZ(this._value);
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
  setZRange(value) {
    this._value._hasZRange = true;
    this._value._zRange = value;
    return this;
  }
  deleteZRange() {
    this._value._hasZRange = false;
    this._value._zRange = null;
    return this;
  }
}
SiteOperation_AbsoluteZ.Builder = SiteOperation_AbsoluteZ_Builder;
class SiteOperation_AbsoluteZ_WithParent {
  /**
   * @param {SiteOperation_AbsoluteZ} value
   * @param {SiteOperation_AbsoluteZ_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_AbsoluteZ.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  get hasZRange() {
    if (this._cachedHasZRange === undefined) {
      if (this._value.hasZRange) {
        this._cachedHasZRange = true;
      } else {
        this._cachedHasZRange = this._parent ? this._parent.hasZRange : false;
      }
    }
    return this._cachedHasZRange;
  }
  get zRange() {
    if (this._cachedZRange === undefined) {
      if (this._value.hasZRange) {
        this._cachedZRange = this._value.zRange;
      } else {
        this._cachedZRange = this._parent ? this._parent.zRange : this._value.zRange;
      }
    }
    return this._cachedZRange;
  }
  update(current, parent) {
    const result = new SiteOperation_AbsoluteZ_WithParent(current, parent);
    return result;
  }
}
SiteOperation_AbsoluteZ_WithParent.default = new SiteOperation_AbsoluteZ_WithParent(SiteOperation_AbsoluteZ.default, null);
SiteOperation_AbsoluteZ.WithParent = SiteOperation_AbsoluteZ_WithParent;
class SiteOperation_AbsoluteZ_Descriptor {
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 1,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
          comments: "Vertical position on the world grid. A value of 0 is the map\'s bottom edge.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get zRange() {
    if (!this._zRange) {
      this._zRange = {
        name: "zRange",
        Name: "ZRange",
        number: 11,
        protoType: 1,
        protoName: "z_range",
        type: JsonToDouble,
        options: {
          comments: "If set, a random value between 0 and the Z Range will be applied to the Z position when this site operation is applied. Only accepts positive values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._zRange;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.z,
        this.zRange,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZRange",
        Name: "DummyOneofForZRange",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_AbsoluteZ.descriptor = new SiteOperation_AbsoluteZ_Descriptor();
class SiteOperation_Rotate {
  get descriptor() {
    return SiteOperation_Rotate.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
    this._hasDx = false;
    this._dx = null;
    this._hasDy = false;
    this._dy = null;
    this._hasDz = false;
    this._dz = null;
    this._hasOrientation = false;
    this._orientation = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    if (this._hasDx) return false;
    if (this._hasDy) return false;
    if (this._hasDz) return false;
    if (this._hasOrientation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_Rotate) {
      return value;
    }
    return SiteOperation_Rotate.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_Rotate();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    if (json.dx != null) {
      result._hasDx = true;
      result._dx = JsonToDouble.fromJson(json.dx);
    }
    if (json.dy != null) {
      result._hasDy = true;
      result._dy = JsonToDouble.fromJson(json.dy);
    }
    if (json.dz != null) {
      result._hasDz = true;
      result._dz = JsonToDouble.fromJson(json.dz);
    }
    if (json.orientation != null) {
      result._hasOrientation = true;
      result._orientation = SiteOperation_OrientationType.fromJson(json.orientation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    if (this._hasDx) {
      result.dx = JsonToDouble.toJson(this._dx);
    }
    if (this._hasDy) {
      result.dy = JsonToDouble.toJson(this._dy);
    }
    if (this._hasDz) {
      result.dz = JsonToDouble.toJson(this._dz);
    }
    if (this._hasOrientation) {
      result.orientation = SiteOperation_OrientationType.toJson(this._orientation);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  /**
   * @returns {number}
   */
  get dx() {
    return this._hasDx ? this._dx : JsonToDouble.default;
  }
  get hasDx() {
    return this._hasDx;
  }
  setDx(path, value) {
    return {type: 'SET', path: path.concat(['dx']), value};
  }
  deleteDx(path) {
    return {type: 'DELETE', path: path.concat(['dx'])};
  }
  /**
   * @returns {number}
   */
  get dy() {
    return this._hasDy ? this._dy : JsonToDouble.default;
  }
  get hasDy() {
    return this._hasDy;
  }
  setDy(path, value) {
    return {type: 'SET', path: path.concat(['dy']), value};
  }
  deleteDy(path) {
    return {type: 'DELETE', path: path.concat(['dy'])};
  }
  /**
   * @returns {number}
   */
  get dz() {
    return this._hasDz ? this._dz : JsonToDouble.default;
  }
  get hasDz() {
    return this._hasDz;
  }
  setDz(path, value) {
    return {type: 'SET', path: path.concat(['dz']), value};
  }
  deleteDz(path) {
    return {type: 'DELETE', path: path.concat(['dz'])};
  }
  /**
   * @returns {number}
   */
  get orientation() {
    return this._hasOrientation ? this._orientation : SiteOperation_OrientationType.default;
  }
  get hasOrientation() {
    return this._hasOrientation;
  }
  setOrientation(path, value) {
    return {type: 'SET', path: path.concat(['orientation']), value};
  }
  deleteOrientation(path) {
    return {type: 'DELETE', path: path.concat(['orientation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dx": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasDx = true;
              copy._dx = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDx) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasDx = false;
              copy._dx = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasDy = true;
              copy._dy = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDy) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasDy = false;
              copy._dy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dz": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasDz = true;
              copy._dz = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDz) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasDz = false;
              copy._dz = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "orientation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Rotate(this);
              copy._hasOrientation = true;
              copy._orientation = SiteOperation_OrientationType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOrientation) {
                return this;
              }
              const copy = new SiteOperation_Rotate(this);
              copy._hasOrientation = false;
              copy._orientation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_Rotate} other
   * @returns {SiteOperation_Rotate}
   */
  merge(other) {
    const copy = new SiteOperation_Rotate(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    if (other._hasDx) {
      copy._hasDx = true;
      copy._dx = other._dx;
    }
    if (other._hasDy) {
      copy._hasDy = true;
      copy._dy = other._dy;
    }
    if (other._hasDz) {
      copy._hasDz = true;
      copy._dz = other._dz;
    }
    if (other._hasOrientation) {
      copy._hasOrientation = true;
      copy._orientation = other._orientation;
    }
    return copy;
  }
}
SiteOperation_Rotate.default = new SiteOperation_Rotate();
class SiteOperation_Rotate_Builder {
  constructor(value) {
    this._value = new SiteOperation_Rotate(value);
  }
  build() {
    return new SiteOperation_Rotate(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
  setDx(value) {
    this._value._hasDx = true;
    this._value._dx = value;
    return this;
  }
  deleteDx() {
    this._value._hasDx = false;
    this._value._dx = null;
    return this;
  }
  setDy(value) {
    this._value._hasDy = true;
    this._value._dy = value;
    return this;
  }
  deleteDy() {
    this._value._hasDy = false;
    this._value._dy = null;
    return this;
  }
  setDz(value) {
    this._value._hasDz = true;
    this._value._dz = value;
    return this;
  }
  deleteDz() {
    this._value._hasDz = false;
    this._value._dz = null;
    return this;
  }
  setOrientation(value) {
    this._value._hasOrientation = true;
    this._value._orientation = value;
    return this;
  }
  deleteOrientation() {
    this._value._hasOrientation = false;
    this._value._orientation = null;
    return this;
  }
}
SiteOperation_Rotate.Builder = SiteOperation_Rotate_Builder;
class SiteOperation_Rotate_WithParent {
  /**
   * @param {SiteOperation_Rotate} value
   * @param {SiteOperation_Rotate_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_Rotate.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  get hasDx() {
    if (this._cachedHasDx === undefined) {
      if (this._value.hasDx) {
        this._cachedHasDx = true;
      } else {
        this._cachedHasDx = this._parent ? this._parent.hasDx : false;
      }
    }
    return this._cachedHasDx;
  }
  get dx() {
    if (this._cachedDx === undefined) {
      if (this._value.hasDx) {
        this._cachedDx = this._value.dx;
      } else {
        this._cachedDx = this._parent ? this._parent.dx : this._value.dx;
      }
    }
    return this._cachedDx;
  }
  get hasDy() {
    if (this._cachedHasDy === undefined) {
      if (this._value.hasDy) {
        this._cachedHasDy = true;
      } else {
        this._cachedHasDy = this._parent ? this._parent.hasDy : false;
      }
    }
    return this._cachedHasDy;
  }
  get dy() {
    if (this._cachedDy === undefined) {
      if (this._value.hasDy) {
        this._cachedDy = this._value.dy;
      } else {
        this._cachedDy = this._parent ? this._parent.dy : this._value.dy;
      }
    }
    return this._cachedDy;
  }
  get hasDz() {
    if (this._cachedHasDz === undefined) {
      if (this._value.hasDz) {
        this._cachedHasDz = true;
      } else {
        this._cachedHasDz = this._parent ? this._parent.hasDz : false;
      }
    }
    return this._cachedHasDz;
  }
  get dz() {
    if (this._cachedDz === undefined) {
      if (this._value.hasDz) {
        this._cachedDz = this._value.dz;
      } else {
        this._cachedDz = this._parent ? this._parent.dz : this._value.dz;
      }
    }
    return this._cachedDz;
  }
  get hasOrientation() {
    if (this._cachedHasOrientation === undefined) {
      if (this._value.hasOrientation) {
        this._cachedHasOrientation = true;
      } else {
        this._cachedHasOrientation = this._parent ? this._parent.hasOrientation : false;
      }
    }
    return this._cachedHasOrientation;
  }
  get orientation() {
    if (this._cachedOrientation === undefined) {
      if (this._value.hasOrientation) {
        this._cachedOrientation = this._value.orientation;
      } else {
        this._cachedOrientation = this._parent ? this._parent.orientation : this._value.orientation;
      }
    }
    return this._cachedOrientation;
  }
  update(current, parent) {
    const result = new SiteOperation_Rotate_WithParent(current, parent);
    return result;
  }
}
SiteOperation_Rotate_WithParent.default = new SiteOperation_Rotate_WithParent(SiteOperation_Rotate.default, null);
SiteOperation_Rotate.WithParent = SiteOperation_Rotate_WithParent;
class SiteOperation_Rotate_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
          comments: "The rotation in degrees around the X axis (aka Pitch).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
          comments: "The rotation in degrees around the Y axis (aka Yaw).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
          comments: "The rotation in degrees around the Z axis (aka Roll).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get dx() {
    if (!this._dx) {
      this._dx = {
        name: "dx",
        Name: "Dx",
        number: 4,
        protoType: 1,
        protoName: "dx",
        type: JsonToDouble,
        options: {
          comments: "The rotation in degrees per second around the X axis.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dx;
  }
  get dy() {
    if (!this._dy) {
      this._dy = {
        name: "dy",
        Name: "Dy",
        number: 5,
        protoType: 1,
        protoName: "dy",
        type: JsonToDouble,
        options: {
          comments: "The rotation in degrees per second around the Y axis.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dy;
  }
  get dz() {
    if (!this._dz) {
      this._dz = {
        name: "dz",
        Name: "Dz",
        number: 6,
        protoType: 1,
        protoName: "dz",
        type: JsonToDouble,
        options: {
          comments: "The rotation in degrees per second around the Z axis.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dz;
  }
  get orientation() {
    if (!this._orientation) {
      this._orientation = {
        name: "orientation",
        Name: "Orientation",
        number: 7,
        protoType: 14,
        protoName: "orientation",
        type: SiteOperation_OrientationType,
        options: {
          comments: "Determines relative orientation of the rotation.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._orientation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
        this.dx,
        this.dy,
        this.dz,
        this.orientation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDx",
        Name: "DummyOneofForDx",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDy",
        Name: "DummyOneofForDy",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDz",
        Name: "DummyOneofForDz",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOrientation",
        Name: "DummyOneofForOrientation",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_Rotate.descriptor = new SiteOperation_Rotate_Descriptor();
class SiteOperation_Orbit {
  get descriptor() {
    return SiteOperation_Orbit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRadius = false;
    this._radius = null;
    this._hasSpeed = false;
    this._speed = null;
  }
  isEmpty() {
    if (this._hasRadius) return false;
    if (this._hasSpeed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_Orbit) {
      return value;
    }
    return SiteOperation_Orbit.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_Orbit();
    if (json.radius != null) {
      result._hasRadius = true;
      result._radius = JsonToDouble.fromJson(json.radius);
    }
    if (json.speed != null) {
      result._hasSpeed = true;
      result._speed = JsonToDouble.fromJson(json.speed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRadius) {
      result.radius = JsonToDouble.toJson(this._radius);
    }
    if (this._hasSpeed) {
      result.speed = JsonToDouble.toJson(this._speed);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get radius() {
    return this._hasRadius ? this._radius : JsonToDouble.default;
  }
  get hasRadius() {
    return this._hasRadius;
  }
  setRadius(path, value) {
    return {type: 'SET', path: path.concat(['radius']), value};
  }
  deleteRadius(path) {
    return {type: 'DELETE', path: path.concat(['radius'])};
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._hasSpeed ? this._speed : JsonToDouble.default;
  }
  get hasSpeed() {
    return this._hasSpeed;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "radius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Orbit(this);
              copy._hasRadius = true;
              copy._radius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRadius) {
                return this;
              }
              const copy = new SiteOperation_Orbit(this);
              copy._hasRadius = false;
              copy._radius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation_Orbit(this);
              copy._hasSpeed = true;
              copy._speed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeed) {
                return this;
              }
              const copy = new SiteOperation_Orbit(this);
              copy._hasSpeed = false;
              copy._speed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_Orbit} other
   * @returns {SiteOperation_Orbit}
   */
  merge(other) {
    const copy = new SiteOperation_Orbit(this);
    if (other._hasRadius) {
      copy._hasRadius = true;
      copy._radius = other._radius;
    }
    if (other._hasSpeed) {
      copy._hasSpeed = true;
      copy._speed = other._speed;
    }
    return copy;
  }
}
SiteOperation_Orbit.default = new SiteOperation_Orbit();
class SiteOperation_Orbit_Builder {
  constructor(value) {
    this._value = new SiteOperation_Orbit(value);
  }
  build() {
    return new SiteOperation_Orbit(this._value);
  }
  setRadius(value) {
    this._value._hasRadius = true;
    this._value._radius = value;
    return this;
  }
  deleteRadius() {
    this._value._hasRadius = false;
    this._value._radius = null;
    return this;
  }
  setSpeed(value) {
    this._value._hasSpeed = true;
    this._value._speed = value;
    return this;
  }
  deleteSpeed() {
    this._value._hasSpeed = false;
    this._value._speed = null;
    return this;
  }
}
SiteOperation_Orbit.Builder = SiteOperation_Orbit_Builder;
class SiteOperation_Orbit_WithParent {
  /**
   * @param {SiteOperation_Orbit} value
   * @param {SiteOperation_Orbit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_Orbit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRadius() {
    if (this._cachedHasRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedHasRadius = true;
      } else {
        this._cachedHasRadius = this._parent ? this._parent.hasRadius : false;
      }
    }
    return this._cachedHasRadius;
  }
  get radius() {
    if (this._cachedRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedRadius = this._value.radius;
      } else {
        this._cachedRadius = this._parent ? this._parent.radius : this._value.radius;
      }
    }
    return this._cachedRadius;
  }
  get hasSpeed() {
    if (this._cachedHasSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedHasSpeed = true;
      } else {
        this._cachedHasSpeed = this._parent ? this._parent.hasSpeed : false;
      }
    }
    return this._cachedHasSpeed;
  }
  get speed() {
    if (this._cachedSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedSpeed = this._value.speed;
      } else {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  update(current, parent) {
    const result = new SiteOperation_Orbit_WithParent(current, parent);
    return result;
  }
}
SiteOperation_Orbit_WithParent.default = new SiteOperation_Orbit_WithParent(SiteOperation_Orbit.default, null);
SiteOperation_Orbit.WithParent = SiteOperation_Orbit_WithParent;
class SiteOperation_Orbit_Descriptor {
  get radius() {
    if (!this._radius) {
      this._radius = {
        name: "radius",
        Name: "Radius",
        number: 1,
        protoType: 1,
        protoName: "radius",
        type: JsonToDouble,
        options: {
          comments: "Sets the offset radius that the actor will orbit round its host.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radius;
  }
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 2,
        protoType: 1,
        protoName: "speed",
        type: JsonToDouble,
        options: {
          comments: "Sets the speed of the orbit in degrees per second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.radius,
        this.speed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRadius",
        Name: "DummyOneofForRadius",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeed",
        Name: "DummyOneofForSpeed",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation_Orbit.descriptor = new SiteOperation_Orbit_Descriptor();
class SiteOperation_HoldPosition {
  get descriptor() {
    return SiteOperation_HoldPosition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation_HoldPosition) {
      return value;
    }
    return SiteOperation_HoldPosition.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation_HoldPosition();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation_HoldPosition} other
   * @returns {SiteOperation_HoldPosition}
   */
  merge(other) {
    const copy = new SiteOperation_HoldPosition(this);
    return copy;
  }
}
SiteOperation_HoldPosition.default = new SiteOperation_HoldPosition();
class SiteOperation_HoldPosition_Builder {
  constructor(value) {
    this._value = new SiteOperation_HoldPosition(value);
  }
  build() {
    return new SiteOperation_HoldPosition(this._value);
  }
}
SiteOperation_HoldPosition.Builder = SiteOperation_HoldPosition_Builder;
class SiteOperation_HoldPosition_WithParent {
  /**
   * @param {SiteOperation_HoldPosition} value
   * @param {SiteOperation_HoldPosition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation_HoldPosition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new SiteOperation_HoldPosition_WithParent(current, parent);
    return result;
  }
}
SiteOperation_HoldPosition_WithParent.default = new SiteOperation_HoldPosition_WithParent(SiteOperation_HoldPosition.default, null);
SiteOperation_HoldPosition.WithParent = SiteOperation_HoldPosition_WithParent;
class SiteOperation_HoldPosition_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
SiteOperation_HoldPosition.descriptor = new SiteOperation_HoldPosition_Descriptor();
class SiteOperation_OrientationType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "WORLD_ORIENTATION": return 0;
        case "ACTOR_ORIENTATION": return 1;
        case "ACTOR_ORIENTATION_IGNORING_OTHER_SITE_OPERATIONS": return 2;
        case "EVENT_ORIENTATION": return 3;
        case "MOVE_ORIENTATION": return 4;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return SiteOperation_OrientationType.fromJson(value);
  }
  static fromReact(e) {
    return SiteOperation_OrientationType.fromJson(e);
  }
}
SiteOperation_OrientationType.WORLD_ORIENTATION = 0;
SiteOperation_OrientationType.ACTOR_ORIENTATION = 1;
SiteOperation_OrientationType.ACTOR_ORIENTATION_IGNORING_OTHER_SITE_OPERATIONS = 2;
SiteOperation_OrientationType.EVENT_ORIENTATION = 3;
SiteOperation_OrientationType.MOVE_ORIENTATION = 4;
SiteOperation_OrientationType.default = 0;
SiteOperation_OrientationType.values = {
  WORLD_ORIENTATION: 0,
  ACTOR_ORIENTATION: 1,
  ACTOR_ORIENTATION_IGNORING_OTHER_SITE_OPERATIONS: 2,
  EVENT_ORIENTATION: 3,
  MOVE_ORIENTATION: 4,
};
SiteOperation_OrientationType.names = {
  0: "WORLD_ORIENTATION",
  1: "ACTOR_ORIENTATION",
  2: "ACTOR_ORIENTATION_IGNORING_OTHER_SITE_OPERATIONS",
  3: "EVENT_ORIENTATION",
  4: "MOVE_ORIENTATION",
};
export class SiteOperation {
  get descriptor() {
    return SiteOperation.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofSiteOperationTypeCase = 0;
    this._oneofSiteOperationTypeValue = null;
  }
  isEmpty() {
    if (this._oneofSiteOperationTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SiteOperation) {
      return value;
    }
    return SiteOperation.fromJson(value);
  }
  static fromJson(json) {
    const result = new SiteOperation();
    if (json.offset != null) {
      result._oneofSiteOperationTypeCase = 2;
      result._oneofSiteOperationTypeValue = SiteOperation_Offset.fromJson(json.offset);
    }
    if (json.rotate != null) {
      result._oneofSiteOperationTypeCase = 3;
      result._oneofSiteOperationTypeValue = SiteOperation_Rotate.fromJson(json.rotate);
    }
    if (json.absoluteHeight != null) {
      result._oneofSiteOperationTypeCase = 4;
      result._oneofSiteOperationTypeValue = SiteOperation_AbsoluteHeight.fromJson(json.absoluteHeight);
    }
    if (json.holdPosition != null) {
      result._oneofSiteOperationTypeCase = 5;
      result._oneofSiteOperationTypeValue = SiteOperation_HoldPosition.fromJson(json.holdPosition);
    }
    if (json.absoluteOffset != null) {
      result._oneofSiteOperationTypeCase = 6;
      result._oneofSiteOperationTypeValue = SiteOperation_AbsoluteOffset.fromJson(json.absoluteOffset);
    }
    if (json.absoluteX != null) {
      result._oneofSiteOperationTypeCase = 7;
      result._oneofSiteOperationTypeValue = SiteOperation_AbsoluteX.fromJson(json.absoluteX);
    }
    if (json.absoluteY != null) {
      result._oneofSiteOperationTypeCase = 8;
      result._oneofSiteOperationTypeValue = SiteOperation_AbsoluteY.fromJson(json.absoluteY);
    }
    if (json.absoluteZ != null) {
      result._oneofSiteOperationTypeCase = 9;
      result._oneofSiteOperationTypeValue = SiteOperation_AbsoluteZ.fromJson(json.absoluteZ);
    }
    if (json.rotation != null) {
      result._oneofSiteOperationTypeCase = 102;
      result._oneofSiteOperationTypeValue = SiteOperation_Orbit.fromJson(json.rotation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofSiteOperationTypeCase) {
      case 2:
        result.offset = SiteOperation_Offset.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 3:
        result.rotate = SiteOperation_Rotate.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 4:
        result.absoluteHeight = SiteOperation_AbsoluteHeight.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 5:
        result.holdPosition = SiteOperation_HoldPosition.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 6:
        result.absoluteOffset = SiteOperation_AbsoluteOffset.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 7:
        result.absoluteX = SiteOperation_AbsoluteX.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 8:
        result.absoluteY = SiteOperation_AbsoluteY.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 9:
        result.absoluteZ = SiteOperation_AbsoluteZ.toJson(this._oneofSiteOperationTypeValue);
        break;
      case 102:
        result.rotation = SiteOperation_Orbit.toJson(this._oneofSiteOperationTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofSiteOperationTypeCase() {
    return this._oneofSiteOperationTypeCase;
  }
  deleteOneofSiteOperationType(path) {
    switch (this._oneofSiteOperationTypeCase) {
      default:
      case 2: {
        return {type: 'DELETE', path: path.concat(['offset'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['rotate'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['absoluteHeight'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['holdPosition'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['absoluteOffset'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['absoluteX'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['absoluteY'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['absoluteZ'])};
      }
      case 102: {
        return {type: 'DELETE', path: path.concat(['rotation'])};
      }
    }
  }
  /**
   * @returns {SiteOperation_Offset}
   */
  get offset() {
    return this._oneofSiteOperationTypeCase === 2 ? this._oneofSiteOperationTypeValue : SiteOperation_Offset.default;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  /**
   * @returns {SiteOperation_Rotate}
   */
  get rotate() {
    return this._oneofSiteOperationTypeCase === 3 ? this._oneofSiteOperationTypeValue : SiteOperation_Rotate.default;
  }
  setRotate(path, value) {
    return {type: 'SET', path: path.concat(['rotate']), value: value.toJson()};
  }
  deleteRotate(path) {
    return {type: 'DELETE', path: path.concat(['rotate'])};
  }
  /**
   * @returns {SiteOperation_AbsoluteHeight}
   */
  get absoluteHeight() {
    return this._oneofSiteOperationTypeCase === 4 ? this._oneofSiteOperationTypeValue : SiteOperation_AbsoluteHeight.default;
  }
  setAbsoluteHeight(path, value) {
    return {type: 'SET', path: path.concat(['absoluteHeight']), value: value.toJson()};
  }
  deleteAbsoluteHeight(path) {
    return {type: 'DELETE', path: path.concat(['absoluteHeight'])};
  }
  /**
   * @returns {SiteOperation_HoldPosition}
   */
  get holdPosition() {
    return this._oneofSiteOperationTypeCase === 5 ? this._oneofSiteOperationTypeValue : SiteOperation_HoldPosition.default;
  }
  setHoldPosition(path, value) {
    return {type: 'SET', path: path.concat(['holdPosition']), value: value.toJson()};
  }
  deleteHoldPosition(path) {
    return {type: 'DELETE', path: path.concat(['holdPosition'])};
  }
  /**
   * @returns {SiteOperation_AbsoluteOffset}
   */
  get absoluteOffset() {
    return this._oneofSiteOperationTypeCase === 6 ? this._oneofSiteOperationTypeValue : SiteOperation_AbsoluteOffset.default;
  }
  setAbsoluteOffset(path, value) {
    return {type: 'SET', path: path.concat(['absoluteOffset']), value: value.toJson()};
  }
  deleteAbsoluteOffset(path) {
    return {type: 'DELETE', path: path.concat(['absoluteOffset'])};
  }
  /**
   * @returns {SiteOperation_AbsoluteX}
   */
  get absoluteX() {
    return this._oneofSiteOperationTypeCase === 7 ? this._oneofSiteOperationTypeValue : SiteOperation_AbsoluteX.default;
  }
  setAbsoluteX(path, value) {
    return {type: 'SET', path: path.concat(['absoluteX']), value: value.toJson()};
  }
  deleteAbsoluteX(path) {
    return {type: 'DELETE', path: path.concat(['absoluteX'])};
  }
  /**
   * @returns {SiteOperation_AbsoluteY}
   */
  get absoluteY() {
    return this._oneofSiteOperationTypeCase === 8 ? this._oneofSiteOperationTypeValue : SiteOperation_AbsoluteY.default;
  }
  setAbsoluteY(path, value) {
    return {type: 'SET', path: path.concat(['absoluteY']), value: value.toJson()};
  }
  deleteAbsoluteY(path) {
    return {type: 'DELETE', path: path.concat(['absoluteY'])};
  }
  /**
   * @returns {SiteOperation_AbsoluteZ}
   */
  get absoluteZ() {
    return this._oneofSiteOperationTypeCase === 9 ? this._oneofSiteOperationTypeValue : SiteOperation_AbsoluteZ.default;
  }
  setAbsoluteZ(path, value) {
    return {type: 'SET', path: path.concat(['absoluteZ']), value: value.toJson()};
  }
  deleteAbsoluteZ(path) {
    return {type: 'DELETE', path: path.concat(['absoluteZ'])};
  }
  /**
   * @returns {SiteOperation_Orbit}
   */
  get rotation() {
    return this._oneofSiteOperationTypeCase === 102 ? this._oneofSiteOperationTypeValue : SiteOperation_Orbit.default;
  }
  setOrbit(path, value) {
    return {type: 'SET', path: path.concat(['rotation']), value: value.toJson()};
  }
  deleteOrbit(path) {
    return {type: 'DELETE', path: path.concat(['rotation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 2;
              copy._oneofSiteOperationTypeValue = SiteOperation_Offset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 2) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 2) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 2;
            copy._oneofSiteOperationTypeValue = SiteOperation_Offset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.offset.apply(type, path.slice(1), value);
          if (newValue === this.offset) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 2;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "rotate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 3;
              copy._oneofSiteOperationTypeValue = SiteOperation_Rotate.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 3) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 3) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 3;
            copy._oneofSiteOperationTypeValue = SiteOperation_Rotate.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.rotate.apply(type, path.slice(1), value);
          if (newValue === this.rotate) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 3;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "absoluteHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 4;
              copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteHeight.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 4) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 4) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 4;
            copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteHeight.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.absoluteHeight.apply(type, path.slice(1), value);
          if (newValue === this.absoluteHeight) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 4;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "holdPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 5;
              copy._oneofSiteOperationTypeValue = SiteOperation_HoldPosition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 5) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 5) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 5;
            copy._oneofSiteOperationTypeValue = SiteOperation_HoldPosition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.holdPosition.apply(type, path.slice(1), value);
          if (newValue === this.holdPosition) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 5;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "absoluteOffset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 6;
              copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 6) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 6) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 6;
            copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.absoluteOffset.apply(type, path.slice(1), value);
          if (newValue === this.absoluteOffset) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 6;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "absoluteX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 7;
              copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteX.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 7) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 7) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 7;
            copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteX.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.absoluteX.apply(type, path.slice(1), value);
          if (newValue === this.absoluteX) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 7;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "absoluteY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 8;
              copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteY.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 8) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 8) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 8;
            copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteY.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.absoluteY.apply(type, path.slice(1), value);
          if (newValue === this.absoluteY) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 8;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "absoluteZ": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 9;
              copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteZ.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 9) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 9) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 9;
            copy._oneofSiteOperationTypeValue = SiteOperation_AbsoluteZ.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.absoluteZ.apply(type, path.slice(1), value);
          if (newValue === this.absoluteZ) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 9;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      case "rotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 102;
              copy._oneofSiteOperationTypeValue = SiteOperation_Orbit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofSiteOperationTypeCase !== 102) {
                return this;
              }
              const copy = new SiteOperation(this);
              copy._oneofSiteOperationTypeCase = 0;
              copy._oneofSiteOperationTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofSiteOperationTypeCase !== 102) {
            const copy = new SiteOperation(this);
            copy._oneofSiteOperationTypeCase = 102;
            copy._oneofSiteOperationTypeValue = SiteOperation_Orbit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.rotation.apply(type, path.slice(1), value);
          if (newValue === this.rotation) {
            return this;
          }
          const copy = new SiteOperation(this);
          copy._oneofSiteOperationTypeCase = 102;
          copy._oneofSiteOperationTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SiteOperation} other
   * @returns {SiteOperation}
   */
  merge(other) {
    const copy = new SiteOperation(this);
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    if (other._oneofSiteOperationTypeCase === 2) {
      if (this._oneofSiteOperationTypeCase === 2) {
        copy._oneofSiteOperationTypeValue = copy._oneofSiteOperationTypeValue.merge(other._oneofSiteOperationTypeValue);
      } else {
        copy._oneofSiteOperationTypeValue = other._oneofSiteOperationTypeValue;
      }
      copy._oneofSiteOperationTypeCase = 2;
    }
    return copy;
  }
}
SiteOperation.default = new SiteOperation();
SiteOperation.Offset = SiteOperation_Offset;
SiteOperation.AbsoluteHeight = SiteOperation_AbsoluteHeight;
SiteOperation.AbsoluteOffset = SiteOperation_AbsoluteOffset;
SiteOperation.AbsoluteX = SiteOperation_AbsoluteX;
SiteOperation.AbsoluteY = SiteOperation_AbsoluteY;
SiteOperation.AbsoluteZ = SiteOperation_AbsoluteZ;
SiteOperation.Rotate = SiteOperation_Rotate;
SiteOperation.Orbit = SiteOperation_Orbit;
SiteOperation.HoldPosition = SiteOperation_HoldPosition;
SiteOperation.OrientationType = SiteOperation_OrientationType;
class SiteOperation_Builder {
  constructor(value) {
    this._value = new SiteOperation(value);
  }
  build() {
    return new SiteOperation(this._value);
  }
  clearoneofSiteOperationType() {
    this._value._oneofSiteOperationTypeCase = 0;
    this._value._oneofSiteOperationTypeValue = null;
    return this;
  }
  setOffset(value) {
    this._value._oneofSiteOperationTypeCase = 2;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setRotate(value) {
    this._value._oneofSiteOperationTypeCase = 3;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setAbsoluteHeight(value) {
    this._value._oneofSiteOperationTypeCase = 4;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setHoldPosition(value) {
    this._value._oneofSiteOperationTypeCase = 5;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setAbsoluteOffset(value) {
    this._value._oneofSiteOperationTypeCase = 6;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setAbsoluteX(value) {
    this._value._oneofSiteOperationTypeCase = 7;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setAbsoluteY(value) {
    this._value._oneofSiteOperationTypeCase = 8;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setAbsoluteZ(value) {
    this._value._oneofSiteOperationTypeCase = 9;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
  setOrbit(value) {
    this._value._oneofSiteOperationTypeCase = 102;
    this._value._oneofSiteOperationTypeValue = value;
    return this;
  }
}
SiteOperation.Builder = SiteOperation_Builder;
class SiteOperation_WithParent {
  /**
   * @param {SiteOperation} value
   * @param {SiteOperation_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SiteOperation.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofSiteOperationTypeCase() {
    if (this._cachedoneofSiteOperationTypeCase === undefined) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedoneofSiteOperationTypeCase = this._parent ? this._parent.oneofSiteOperationTypeCase : 0;
      } else {
        this._cachedoneofSiteOperationTypeCase = this._value._oneofSiteOperationTypeCase;
      }
    }
    return this._cachedoneofSiteOperationTypeCase;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedOffset = this._parent ? new SiteOperation_Offset.WithParent(SiteOperation_Offset.default, this._parent.offset) : this._value.offset;
      } else if (this._value._oneofSiteOperationTypeCase === 2) {
        this._cachedOffset = new SiteOperation_Offset.WithParent(this._value.offset, this._parent && this._parent.oneofSiteOperationTypeCase === 2 ? this._parent.offset : null);
      } else {
        this._cachedOffset = SiteOperation_Offset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  get rotate() {
    if (!this._cachedRotate) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedRotate = this._parent ? new SiteOperation_Rotate.WithParent(SiteOperation_Rotate.default, this._parent.rotate) : this._value.rotate;
      } else if (this._value._oneofSiteOperationTypeCase === 3) {
        this._cachedRotate = new SiteOperation_Rotate.WithParent(this._value.rotate, this._parent && this._parent.oneofSiteOperationTypeCase === 3 ? this._parent.rotate : null);
      } else {
        this._cachedRotate = SiteOperation_Rotate.WithParent.default;
      }
    }
    return this._cachedRotate;
  }
  get absoluteHeight() {
    if (!this._cachedAbsoluteHeight) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedAbsoluteHeight = this._parent ? new SiteOperation_AbsoluteHeight.WithParent(SiteOperation_AbsoluteHeight.default, this._parent.absoluteHeight) : this._value.absoluteHeight;
      } else if (this._value._oneofSiteOperationTypeCase === 4) {
        this._cachedAbsoluteHeight = new SiteOperation_AbsoluteHeight.WithParent(this._value.absoluteHeight, this._parent && this._parent.oneofSiteOperationTypeCase === 4 ? this._parent.absoluteHeight : null);
      } else {
        this._cachedAbsoluteHeight = SiteOperation_AbsoluteHeight.WithParent.default;
      }
    }
    return this._cachedAbsoluteHeight;
  }
  get holdPosition() {
    if (!this._cachedHoldPosition) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedHoldPosition = this._parent ? new SiteOperation_HoldPosition.WithParent(SiteOperation_HoldPosition.default, this._parent.holdPosition) : this._value.holdPosition;
      } else if (this._value._oneofSiteOperationTypeCase === 5) {
        this._cachedHoldPosition = new SiteOperation_HoldPosition.WithParent(this._value.holdPosition, this._parent && this._parent.oneofSiteOperationTypeCase === 5 ? this._parent.holdPosition : null);
      } else {
        this._cachedHoldPosition = SiteOperation_HoldPosition.WithParent.default;
      }
    }
    return this._cachedHoldPosition;
  }
  get absoluteOffset() {
    if (!this._cachedAbsoluteOffset) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedAbsoluteOffset = this._parent ? new SiteOperation_AbsoluteOffset.WithParent(SiteOperation_AbsoluteOffset.default, this._parent.absoluteOffset) : this._value.absoluteOffset;
      } else if (this._value._oneofSiteOperationTypeCase === 6) {
        this._cachedAbsoluteOffset = new SiteOperation_AbsoluteOffset.WithParent(this._value.absoluteOffset, this._parent && this._parent.oneofSiteOperationTypeCase === 6 ? this._parent.absoluteOffset : null);
      } else {
        this._cachedAbsoluteOffset = SiteOperation_AbsoluteOffset.WithParent.default;
      }
    }
    return this._cachedAbsoluteOffset;
  }
  get absoluteX() {
    if (!this._cachedAbsoluteX) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedAbsoluteX = this._parent ? new SiteOperation_AbsoluteX.WithParent(SiteOperation_AbsoluteX.default, this._parent.absoluteX) : this._value.absoluteX;
      } else if (this._value._oneofSiteOperationTypeCase === 7) {
        this._cachedAbsoluteX = new SiteOperation_AbsoluteX.WithParent(this._value.absoluteX, this._parent && this._parent.oneofSiteOperationTypeCase === 7 ? this._parent.absoluteX : null);
      } else {
        this._cachedAbsoluteX = SiteOperation_AbsoluteX.WithParent.default;
      }
    }
    return this._cachedAbsoluteX;
  }
  get absoluteY() {
    if (!this._cachedAbsoluteY) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedAbsoluteY = this._parent ? new SiteOperation_AbsoluteY.WithParent(SiteOperation_AbsoluteY.default, this._parent.absoluteY) : this._value.absoluteY;
      } else if (this._value._oneofSiteOperationTypeCase === 8) {
        this._cachedAbsoluteY = new SiteOperation_AbsoluteY.WithParent(this._value.absoluteY, this._parent && this._parent.oneofSiteOperationTypeCase === 8 ? this._parent.absoluteY : null);
      } else {
        this._cachedAbsoluteY = SiteOperation_AbsoluteY.WithParent.default;
      }
    }
    return this._cachedAbsoluteY;
  }
  get absoluteZ() {
    if (!this._cachedAbsoluteZ) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedAbsoluteZ = this._parent ? new SiteOperation_AbsoluteZ.WithParent(SiteOperation_AbsoluteZ.default, this._parent.absoluteZ) : this._value.absoluteZ;
      } else if (this._value._oneofSiteOperationTypeCase === 9) {
        this._cachedAbsoluteZ = new SiteOperation_AbsoluteZ.WithParent(this._value.absoluteZ, this._parent && this._parent.oneofSiteOperationTypeCase === 9 ? this._parent.absoluteZ : null);
      } else {
        this._cachedAbsoluteZ = SiteOperation_AbsoluteZ.WithParent.default;
      }
    }
    return this._cachedAbsoluteZ;
  }
  get rotation() {
    if (!this._cachedOrbit) {
      if (this._value._oneofSiteOperationTypeCase === 0) {
        this._cachedOrbit = this._parent ? new SiteOperation_Orbit.WithParent(SiteOperation_Orbit.default, this._parent.rotation) : this._value.rotation;
      } else if (this._value._oneofSiteOperationTypeCase === 102) {
        this._cachedOrbit = new SiteOperation_Orbit.WithParent(this._value.rotation, this._parent && this._parent.oneofSiteOperationTypeCase === 102 ? this._parent.rotation : null);
      } else {
        this._cachedOrbit = SiteOperation_Orbit.WithParent.default;
      }
    }
    return this._cachedOrbit;
  }
  update(current, parent) {
    const result = new SiteOperation_WithParent(current, parent);
    if (this._cachedOffset && this._value._oneofSiteOperationTypeCase === 2 && current._oneofSiteOperationTypeCase === 2) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.oneofSiteOperationTypeCase === 2 ? parent.offset : null);
      }
    }
    if (this._cachedRotate && this._value._oneofSiteOperationTypeCase === 3 && current._oneofSiteOperationTypeCase === 3) {
      if (this._value.rotate === current.rotate && this._parent === parent) {
        result._cachedRotate = this._cachedRotate;
      } else {
        result._cachedRotate = this._cachedRotate.update(current.rotate, parent && parent.oneofSiteOperationTypeCase === 3 ? parent.rotate : null);
      }
    }
    if (this._cachedAbsoluteHeight && this._value._oneofSiteOperationTypeCase === 4 && current._oneofSiteOperationTypeCase === 4) {
      if (this._value.absoluteHeight === current.absoluteHeight && this._parent === parent) {
        result._cachedAbsoluteHeight = this._cachedAbsoluteHeight;
      } else {
        result._cachedAbsoluteHeight = this._cachedAbsoluteHeight.update(current.absoluteHeight, parent && parent.oneofSiteOperationTypeCase === 4 ? parent.absoluteHeight : null);
      }
    }
    if (this._cachedHoldPosition && this._value._oneofSiteOperationTypeCase === 5 && current._oneofSiteOperationTypeCase === 5) {
      if (this._value.holdPosition === current.holdPosition && this._parent === parent) {
        result._cachedHoldPosition = this._cachedHoldPosition;
      } else {
        result._cachedHoldPosition = this._cachedHoldPosition.update(current.holdPosition, parent && parent.oneofSiteOperationTypeCase === 5 ? parent.holdPosition : null);
      }
    }
    if (this._cachedAbsoluteOffset && this._value._oneofSiteOperationTypeCase === 6 && current._oneofSiteOperationTypeCase === 6) {
      if (this._value.absoluteOffset === current.absoluteOffset && this._parent === parent) {
        result._cachedAbsoluteOffset = this._cachedAbsoluteOffset;
      } else {
        result._cachedAbsoluteOffset = this._cachedAbsoluteOffset.update(current.absoluteOffset, parent && parent.oneofSiteOperationTypeCase === 6 ? parent.absoluteOffset : null);
      }
    }
    if (this._cachedAbsoluteX && this._value._oneofSiteOperationTypeCase === 7 && current._oneofSiteOperationTypeCase === 7) {
      if (this._value.absoluteX === current.absoluteX && this._parent === parent) {
        result._cachedAbsoluteX = this._cachedAbsoluteX;
      } else {
        result._cachedAbsoluteX = this._cachedAbsoluteX.update(current.absoluteX, parent && parent.oneofSiteOperationTypeCase === 7 ? parent.absoluteX : null);
      }
    }
    if (this._cachedAbsoluteY && this._value._oneofSiteOperationTypeCase === 8 && current._oneofSiteOperationTypeCase === 8) {
      if (this._value.absoluteY === current.absoluteY && this._parent === parent) {
        result._cachedAbsoluteY = this._cachedAbsoluteY;
      } else {
        result._cachedAbsoluteY = this._cachedAbsoluteY.update(current.absoluteY, parent && parent.oneofSiteOperationTypeCase === 8 ? parent.absoluteY : null);
      }
    }
    if (this._cachedAbsoluteZ && this._value._oneofSiteOperationTypeCase === 9 && current._oneofSiteOperationTypeCase === 9) {
      if (this._value.absoluteZ === current.absoluteZ && this._parent === parent) {
        result._cachedAbsoluteZ = this._cachedAbsoluteZ;
      } else {
        result._cachedAbsoluteZ = this._cachedAbsoluteZ.update(current.absoluteZ, parent && parent.oneofSiteOperationTypeCase === 9 ? parent.absoluteZ : null);
      }
    }
    if (this._cachedOrbit && this._value._oneofSiteOperationTypeCase === 102 && current._oneofSiteOperationTypeCase === 102) {
      if (this._value.rotation === current.rotation && this._parent === parent) {
        result._cachedOrbit = this._cachedOrbit;
      } else {
        result._cachedOrbit = this._cachedOrbit.update(current.rotation, parent && parent.oneofSiteOperationTypeCase === 102 ? parent.rotation : null);
      }
    }
    return result;
  }
}
SiteOperation_WithParent.default = new SiteOperation_WithParent(SiteOperation.default, null);
SiteOperation.WithParent = SiteOperation_WithParent;
class SiteOperation_Descriptor {
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 2,
        protoType: 11,
        protoName: "offset",
        oneofIndex: 0,
        type: SiteOperation_Offset,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get rotate() {
    if (!this._rotate) {
      this._rotate = {
        name: "rotate",
        Name: "Rotate",
        number: 3,
        protoType: 11,
        protoName: "rotate",
        oneofIndex: 0,
        type: SiteOperation_Rotate,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rotate;
  }
  get absoluteHeight() {
    if (!this._absoluteHeight) {
      this._absoluteHeight = {
        name: "absoluteHeight",
        Name: "AbsoluteHeight",
        number: 4,
        protoType: 11,
        protoName: "absolute_height",
        oneofIndex: 0,
        type: SiteOperation_AbsoluteHeight,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._absoluteHeight;
  }
  get holdPosition() {
    if (!this._holdPosition) {
      this._holdPosition = {
        name: "holdPosition",
        Name: "HoldPosition",
        number: 5,
        protoType: 11,
        protoName: "hold_position",
        oneofIndex: 0,
        type: SiteOperation_HoldPosition,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._holdPosition;
  }
  get absoluteOffset() {
    if (!this._absoluteOffset) {
      this._absoluteOffset = {
        name: "absoluteOffset",
        Name: "AbsoluteOffset",
        number: 6,
        protoType: 11,
        protoName: "absolute_offset",
        oneofIndex: 0,
        type: SiteOperation_AbsoluteOffset,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._absoluteOffset;
  }
  get absoluteX() {
    if (!this._absoluteX) {
      this._absoluteX = {
        name: "absoluteX",
        Name: "AbsoluteX",
        number: 7,
        protoType: 11,
        protoName: "absolute_x",
        oneofIndex: 0,
        type: SiteOperation_AbsoluteX,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._absoluteX;
  }
  get absoluteY() {
    if (!this._absoluteY) {
      this._absoluteY = {
        name: "absoluteY",
        Name: "AbsoluteY",
        number: 8,
        protoType: 11,
        protoName: "absolute_y",
        oneofIndex: 0,
        type: SiteOperation_AbsoluteY,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._absoluteY;
  }
  get absoluteZ() {
    if (!this._absoluteZ) {
      this._absoluteZ = {
        name: "absoluteZ",
        Name: "AbsoluteZ",
        number: 9,
        protoType: 11,
        protoName: "absolute_z",
        oneofIndex: 0,
        type: SiteOperation_AbsoluteZ,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._absoluteZ;
  }
  get rotation() {
    if (!this._rotation) {
      this._rotation = {
        name: "rotation",
        Name: "Orbit",
        number: 102,
        protoType: 11,
        protoName: "orbit",
        oneofIndex: 0,
        type: SiteOperation_Orbit,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rotation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.offset,
        this.rotate,
        this.absoluteHeight,
        this.holdPosition,
        this.absoluteOffset,
        this.absoluteX,
        this.absoluteY,
        this.absoluteZ,
        this.rotation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofSiteOperationType",
        Name: "OneofSiteOperationType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
SiteOperation.descriptor = new SiteOperation_Descriptor();
